export const phoneCodes = {
	'Алтайский край': {
		regionCode: '385',
		cities: {
			'Белый Ануй': '38847',
			'Беш-Озек': '38849',
			'Быстрый Исток': '38571',
			'Верх-Апшуяхта': '38849',
			'Верх-Бийск': '38843',
			'Верх-Карагуж': '38844',
			'Веселая Сейка': '38840',
			'Горно-Алтайск': '38822',
			'Камень-на-Оби': '38584',
			'Кош-Агач': '38842',
			'Курмач-Байгол': '38843',
			'Кызыл-Озек': '38844',
			'Малая-Черга': '38849',
			'Мендур-Саккон': '38847',
			'Мухор-Тархата': '38842',
			'Озеро-Куреево': '38843',
			'Турочак РУПС': '38843',
			'Улус-Черга': '38849',
			'Урлу-Аспак': '38844',
			'Усть-Калманка': '38599',
			'Усть-Кан': '38847',
			'Усть-Кокса': '38848',
			'Усть-Кумир': '38847',
			'Усть-Муны': '38844',
			'Усть-Мута': '38847',
			'Усть-Пыжа': '38843',
			'Усть-Сема': '38841',
			'Усть-Чарышская Пристань': '38554',
			'Чаган-Узун': '38842',
			'Черный Ануй': '38847',
			'с. Краснощеково': '38575',
			'с. Топчиха': '38552',
			'село Косиха': '38531',
			'село Курья': '38576',
			'село Полковниково': '38531',
			'село Ребриха': '38582',
			Абай: '38848',
			Актал: '38842',
			Акташ: '38846',
			Алейск: '38553',
			Александровка: '38844',
			Алтайский: '38537',
			Алтайское: '38537',
			Амур: '38848',
			Анос: '38841',
			Баево: '38585',
			Балыктуюль: '38846',
			Балыкча: '38846',
			Барагаш: '38849',
			Барнаул: '3852',
			Белокуриха: '38577',
			Бельтир: '38842',
			Беляши: '38842',
			Бешпельтир: '38841',
			Бийка: '38843',
			Бийск: '3854',
			Бирюля: '38844',
			Благовещенка: '38564',
			Бурла: '38572',
			Волчиха: '38565',
			Гальбштадт: '38539',
			Горбуново: '38848',
			Горняк: '38586',
			Дмитриевка: '38843',
			Дьектиек: '38849',
			Ело: '38845',
			Ельцовка: '38593',
			Завьялово: '38562',
			Залесово: '38592',
			Заринск: '38595',
			Змеиногорск: '38587',
			Зональное: '38530',
			Иогач: '38843',
			Кайтанак: '38848',
			Калманка: '38551',
			Камлак: '38849',
			Карагай: '38848',
			Каракокша: '38840',
			Карасук: '38844',
			Каргон: '38847',
			Катанда: '38848',
			Каяшкан: '38843',
			Кебезень: '38843',
			Киска: '38840',
			Ключи: '38578',
			Козуль: '38847',
			Кокоря: '38842',
			Косиха: '38531',
			Красногорское: '38535',
			Краснощеково: '38575',
			Крутиха: '38589',
			Кулада: '38845',
			Кулунда: '38566',
			Купчегень: '38845',
			Курай: '38842',
			Курунда: '38848',
			Курья: '38576',
			Куюс: '38841',
			Кырлык: '38847',
			Кытманово: '38590',
			Майма: '38844',
			Майский: '38843',
			Мамонтово: '38583',
			Манжерок: '38844',
			Михайловский: '38570',
			Михайловское: '38570',
			Мульта: '38848',
			Мыюта: '38849',
			Новичиха: '38555',
			Новоалтайск: '38532',
			Новоегорьевское: '38560',
			Огневка: '38848',
			Онгудай: '38845',
			Ороктой: '38841',
			Ортолык: '38842',
			Павловск: '38581',
			Панкрушиха: '38580',
			Паспаул: '38840',
			Петропавловское: '38573',
			Поспелиха: '38556',
			Ребриха: '38582',
			Родино: '38563',
			Романово: '38561',
			Рубцовск: '38557',
			Саратан: '38846',
			Сибирский: '38532',
			Славгород: '38568',
			Смоленское: '38536',
			Советское: '38598',
			Солонешное: '38594',
			Солтон: '38533',
			Соузга: '38844',
			Староалейское: '38559',
			Сугаш: '38848',
			Суранаш: '38843',
			Табуны: '38567',
			Талда: '38848',
			Талон: '38843',
			Тальменка: '38591',
			Ташанта: '38842',
			Тебелер: '38842',
			Теньга: '38845',
			Тогул: '38597',
			Тондошка: '38843',
			Топчиха: '38552',
			Троицкое: '38534',
			Туньжа: '38840',
			Туэкта: '38845',
			Тюдрала: '38847',
			Тюменцево: '38588',
			Тюнгур: '38848',
			Угловское: '38579',
			Удаловка: '38843',
			Узнезя: '38841',
			Уймень: '38840',
			Улаган: '38846',
			Ускуч: '38840',
			Хабаровка: '38845',
			Хабары: '38569',
			Целинное: '38596',
			Чарышское: '38574',
			Чемал: '38841',
			Чендек: '38848',
			Чепош: '38841',
			Черга: '38849',
			Чибиля: '38846',
			Чибит: '38846',
			Чоя: '38840',
			Чуйка: '38843',
			Шашикман: '38845',
			Шебалино: '38849',
			Шелаболиха: '38558',
			Шипуново: '38550',
			Ынырга: '38840',
			Эдиган: '38841',
			Элекмонар: '38841',
			Южный: '3852',
			Ябоган: '38847',
			Яконур: '38847',
			Яровое: '38568'
		}
	},
	'Амурская область': {
		regionCode: '416',
		cities: {
			'Белый Яр': '41636',
			'Большая Сазанка': '41642',
			'Верхний Уртуй': '41639',
			'Верхняя Полтавка': '41639',
			'Ерофей Павлович': '41654',
			'Загорная Селитьба': '41643',
			'Заречная Слобода': '41658',
			'Зеленый Бор': '41637',
			'Золотая Гора': '41658',
			'Нижние Бузули': '41643',
			'Нижняя Ильиновка': '41637',
			'Нижняя Полтавка': '41639',
			'Николо-Александровка': '41652',
			'Новокиевский Увал': '41644',
			'Сосновый Бор': '41658',
			'Среднебелое Второе': '41649',
			'Средняя Полтавка': '41639',
			'Старая Райчиха': '41634',
			'Усть-Ивановка': '4162',
			'Усть-Кивда': '41634',
			'Усть-Нюкжа': '41656',
			'Усть-Пера': '41643',
			'Усть-Уркима': '41656',
			'Червонная Армия': '41636',
			'Широкий Лог': '41642',
			'с. Ивановка': '41649',
			'село Поярково': '41637',
			'село Ромны': '41645',
			Автономовка: '41642',
			Албазинка: '41636',
			Албазино: '41654',
			Алгач: '41658',
			Алексеевка: '41634',
			Амаранка: '41645',
			Амурское: '41641',
			Анновка: '41649',
			Аносовский: '41656',
			Антоновка: '41648',
			Апрельский: '41653',
			Арга: '41642',
			Аркадьевка: '41648',
			Арсентьевка: '41637',
			Архара: '41648',
			БАМ: '41654',
			Безозерное: '41634',
			Беленький: '41656',
			Белогорск: '41641',
			Белогорье: '4162',
			Белоногово: '41642',
			Белоярово: '41644',
			Береговой: '41658',
			Березовка: '41649',
			Благовещенск: '4162',
			Богородское: '41649',
			Богословка: '41644',
			Болдыревка: '41636',
			Бомнак: '41658',
			Бузули: '41643',
			Бурея: '41634',
			Буссе: '41643',
			Варваровка: '41652',
			Васильевка: '41641',
			Великокнязевка: '41641',
			Верное: '41642',
			Верхнебелое: '41645',
			Верхнезейск: '41658',
			Верхнеильиновка: '41636',
			Винниково: '41637',
			Виноградовка: '41634',
			Водораздельное: '41642',
			Возжаевка: '41641',
			Волково: '4162',
			Воскресеновка: '41637',
			Восточный: '41652',
			Гильчин: '41638',
			Глухари: '41643',
			Голубая: '41643',
			Гонжа: '41653',
			Горный: '41658',
			Грибовка: '41648',
			Грибское: '4162',
			Григорьевка: '41645',
			Грязнушка: '4162',
			Гудачи: '41653',
			Гулик: '41658',
			Гуран: '41643',
			Дактуй: '41653',
			Дальневосточное: '41645',
			Джалинда: '41654',
			Дипкун: '41656',
			Дмитриевка: '41649',
			Долдыкан: '41634',
			Дубовое: '41637',
			Дугда: '41658',
			Екатеринославка: '41652',
			Ерковцы: '41649',
			Жариково: '41638',
			Желтоярово: '41643',
			Завитинск: '41636',
			Заречное: '41641',
			Зеньковка: '41639',
			Зея: '41658',
			Златоустовск: '41646',
			Знаменка: '41645',
			Золотоножка: '41639',
			Ивановка: '41649',
			Ивановский: '41644',
			Игнашино: '41654',
			Ильиновка: '41652',
			Иннокентьевка: '41648',
			Иса: '41646',
			Казанка: '41642',
			Калинино: '41637',
			Каникурган: '4162',
			Касаткино: '41648',
			Каховка: '41645',
			Климоуцы: '41643',
			Ключи: '41639',
			Коболдо: '41646',
			Коврижка: '41639',
			Козьмодемьяновка: '41638',
			Константиновка: '41639',
			Константиноградовка: '41649',
			Коршуновка: '41637',
			Костюковка: '41643',
			Красноярово: '41644',
			Крестовоздвиженка: '41639',
			Кувыкта: '41656',
			Кузнецово: '41653',
			Кундур: '41648',
			Куприяновка: '41636',
			Куприяново: '41637',
			Куропатино: '41638',
			Кустанаевка: '41641',
			Ларба: '41656',
			Лебяжье: '41642',
			Ленинское: '41648',
			Лермонтовка: '41638',
			Лермонтово: '41642',
			Лесной: '41654',
			Лиманное: '41642',
			Лозовое: '41638',
			Лопча: '41656',
			Лохвицы: '41641',
			Магдагачи: '41653',
			Мадалан: '41654',
			Мазаново: '41644',
			Малиновка: '41634',
			Маргаритовка: '41644',
			Маревый: '41656',
			Марково: '4162',
			Маркучи: '41643',
			Михайловка: '41637',
			Могот: '41656',
			Молчаново: '41644',
			Москвитино: '41643',
			Муравьевка: '41638',
			Муртыгит: '41656',
			Мухино: '41651',
			Мухинский: '41652',
			Натальино: '4162',
			Невер: '41654',
			Некрасовка: '41641',
			Низинное: '41641',
			Николаевка: '41658',
			Никольское: '41641',
			Новгородка: '41643',
			Новоалександровка: '41638',
			Новоалексеевка: '41649',
			Новобурейск: '41634',
			Новобурейский: '41634',
			Нововоскресеновка: '41651',
			Новогеоргиевка: '41651',
			Новое: '41641',
			Новоивановка: '41643',
			Новомихайловка: '41652',
			Новопетровка: '4162',
			Новорайчихинск: '41647',
			Новороссийка: '41644',
			Новосергеевка: '41642',
			Новоспасск: '41648',
			Новостепановка: '41643',
			Новотроицкое: '4162',
			Новочесноково: '41637',
			Норск: '41646',
			Овсянка: '41658',
			Огоджа: '41646',
			Огорон: '41658',
			Озерное: '41642',
			Октябрьский: '41658',
			Олекма: '41656',
			Ольгинск: '41646',
			Ольдой: '41654',
			Орловка: '41639',
			Осежено: '41654',
			Отважное: '41648',
			Павловка: '41641',
			Паруновка: '41642',
			Первомайское: '41656',
			Песчаноозерка: '41652',
			Петровка: '41644',
			Петропавловка: '41649',
			Петруши: '41651',
			Пионер: '41653',
			Плодопитомник: '4162',
			Подгорный: '41643',
			Подоловка: '41636',
			Поздеевка: '41645',
			Поляковский: '41658',
			Поляна: '41642',
			Поляное: '41641',
			Поярково: '41637',
			Правовосточный: '41649',
			Практичи: '41644',
			Пригородное: '41641',
			Придорожное: '41638',
			Прогресс: '41647',
			Путятино: '41644',
			Раздольное: '41644',
			Райчихинск: '41647',
			Рогозовка: '41645',
			Родионовка: '41634',
			Романовка: '41652',
			Ромны: '41645',
			Садовое: '41638',
			Саскаль: '41651',
			Светиловка: '41641',
			Свободный: '41643',
			Святоруссовка: '41645',
			Северное: '41648',
			Семеновка: '41643',
			Семидомка: '41639',
			Семиозерка: '41649',
			Сергеевка: '4162',
			Серышево: '41642',
			Сиан: '41658',
			Сиваки: '41653',
			Симоново: '41651',
			Сковородино: '41654',
			Смелое: '41652',
			Снежногорский: '41658',
			Солнечное: '41649',
			Солнечный: '41654',
			Соловьевск: '41656',
			Сосновка: '41642',
			Среднебелая: '41649',
			Среднебелое: '41649',
			Среднерейновский: '41654',
			Сукромли: '41643',
			Сычевка: '41643',
			Тавричанка: '41642',
			Таежный: '41654',
			Талакан: '41634',
			Талали: '41643',
			Талдан: '41654',
			Тамбовка: '41638',
			Тахтамыгда: '41654',
			Токур: '41646',
			Толбузино: '41653',
			Толстовка: '41638',
			Томичи: '41641',
			Томское: '41642',
			Троицкое: '41649',
			Тунгала: '41658',
			Тутаул: '41656',
			Тыгда: '41653',
			Тында: '41656',
			Углегорск: '41643',
			Угловое: '41644',
			Украинка: '41642',
			Умлекан: '41658',
			Ураловка: '41651',
			Уркан: '41656',
			Уруша: '41654',
			Успеновка: '41641',
			Ушаково: '41651',
			Ушумун: '41653',
			Февральск: '41655',
			Февральское: '41646',
			Фроловка: '41642',
			Хвойный: '41658',
			Хорогочи: '41656',
			Чалбочи: '41658',
			Чалганы: '41653',
			Чергали: '41645',
			Черемхово: '41649',
			Черниговка: '41643',
			Черновка: '41643',
			Черняево: '41653',
			Чесноково: '41637',
			Чигири: '4162',
			Чильчи: '41656',
			Шимановск: '41651',
			Широкий: '41647',
			Экимчан: '41646',
			Юбилейный: '41658',
			Юктали: '41656',
			Юхта: '41643',
			Ядрино: '41648'
		}
	},
	'Архангельская область': {
		regionCode: '818',
		cities: {
			'Анцифировский Бор': '81839',
			'Белое Озеро': '8184',
			'Большая Нисогора': '81833',
			'Большая Слудка': '81840',
			'Большая Товра': '81830',
			'Большая Щелья': '81833',
			'Большой Бор': '81839',
			'Большой Двор': '81838',
			'Верхнее Шилово': '81840',
			'Верхняя Золотица': '8182',
			'Верхняя Кица': '81831',
			'Верхняя Тойма': '81854',
			'Верхняя Уфтюга': '81840',
			'Горка-Муравьевская': '81836',
			'Евда Санаторий': '81840',
			'Запань Яреньга': '81859',
			'Ильинско-Подомское': '81843',
			'Красная Горка': '81851',
			'Красный Бор': '81855',
			'Кривые Озера': '81856',
			'Лайский Док': '8182',
			'Лево-Плосская': '81855',
			'Ленино-Ульяновская': '81836',
			'Летняя Золотица': '8182',
			'Малая Липовка': '81836',
			'Монастырская Пашня': '81840',
			'Нарьян-Мар': '81853',
			'Нижнее Рыболово': '8182',
			'Нижнее Устье': '81832',
			'Нижняя Золотица': '8182',
			'Новый Куваш': '81836',
			'Санаторий им.Тимме': '81832',
			'Семеновская-Первая': '81854',
			'Сергиевская Верхняя': '81840',
			'Степановская Большая': '81837',
			'Сухая Вычера': '81839',
			'Усть-Вага': '81831',
			'Усть-Ваеньга': '81831',
			'Усть-Ерга': '81854',
			'Усть-Заруба': '81854',
			'Усть-Кыма': '81833',
			'Усть-Очея': '81859',
			'Усть-Паденьга': '81851',
			'Усть-Пинега': '81830',
			'Усть-Поча': '81832',
			'Усть-Чуласы': '81833',
			'Усть-Шоноша': '81836',
			'Черный Ручей': '81854',
			'Чубола-Наволок': '8182',
			'Широкий Прилук': '81843',
			'деревня Норинская': '81858',
			'поселок Коноша': '81858',
			'село Ломоносово': '81830',
			Абакумово: '81841',
			Абрамково: '81854',
			Абрамовская: '81839',
			Авнюгский: '81854',
			Азополье: '81848',
			Аксеновская: '81851',
			Алешковская: '81851',
			Алферовская: '81855',
			Анашкино: '81830',
			Андреевская: '81838',
			Андриановская: '81830',
			Аргуновский: '81836',
			Артемьевская: '81851',
			Артюшинская: '81831',
			Архангельск: '8182',
			Белогорский: '81830',
			Беломорье: '81852',
			Белощелье: '81833',
			Березник: '81831',
			Березовка: '81840',
			Березонаволок: '81840',
			Бестужево: '81855',
			Благовещенское: '81836',
			Боброво: '8182',
			Богдановский: '81855',
			Большая: '81840',
			Борки: '81837',
			Боровое: '81836',
			Бронево: '81841',
			Булатово: '81832',
			Бурачиха: '81838',
			Бурцевская: '81854',
			Быково: '81843',
			Бычье: '81848',
			Важский: '81831',
			Ваймуша: '81856',
			Вайново: '8182',
			Вальтево: '81856',
			Вандыш: '81858',
			Васьково: '8182',
			Ватамановская: '81841',
			Веегора: '81856',
			Вежа: '81855',
			Великое: '81836',
			Вельск: '81836',
			Вельцы: '81858',
			Веркола: '81856',
			Верхнеозерский: '81839',
			Верховский: '81832',
			Верхопуйский: '81836',
			Вершина: '81840',
			Вершинино: '81832',
			Вилегодск: '81843',
			Витюнино: '81859',
			Вожгора: '81833',
			Вознесенская: '81832',
			Вознесенское: '81854',
			Вознесенье: '8182',
			Волость: '8184',
			Волочек: '81830',
			Волошка: '81858',
			Вонга: '81856',
			Вонгуда: '81839',
			Вонжуга: '81855',
			Воробьевская: '81841',
			Воронцы: '81831',
			Вотложма: '81837',
			Выставка: '81837',
			Вычегодский: '81837',
			Гавриловская: '81841',
			Георгиевская: '81836',
			Глазаниха: '81839',
			Глубокий: '81855',
			Горка: '81830',
			Городецк: '81856',
			Городище: '81837',
			Горский: '81855',
			Григорово: '81837',
			Григоровская: '81830',
			Григорьево: '81841',
			Грунцовская: '81855',
			Гыжег: '81859',
			Данилово: '81830',
			Двинской: '81854',
			Долгощелье: '81848',
			Долматово: '81836',
			Дорогорское: '81848',
			Дубровская: '81855',
			Дывлевская: '81851',
			Дябрино: '81840',
			Евдокимовская: '81854',
			Еменьга: '81836',
			Емецк: '81830',
			Емца: '81832',
			Ерга: '81837',
			Еркино: '81856',
			Ерцево: '81858',
			Ефремковская: '81836',
			Жердь: '81848',
			Заакакурье: '81848',
			Задовая: '81837',
			Заречный: '81858',
			Заручей: '81833',
			Засулье: '81833',
			Зачачье: '81830',
			Зеленник: '81854',
			Зеленый: '81838',
			Золотуха: '81839',
			Зубово: '81833',
			Ивакша: '81838',
			Ивановское: '81851',
			Игнатовка: '81836',
			Игнатьевская: '81831',
			Игумновская: '81854',
			Илеза: '81855',
			Ирта: '81859',
			Исаковская: '81854',
			Исполиновка: '81836',
			Кадыевская: '81855',
			Казаково: '81841',
			Казенщина: '81830',
			Казово: '81855',
			Калитинка: '81841',
			Каменка: '81848',
			Каменное: '81854',
			Каргополь: '81841',
			Карпогоры: '81856',
			Карьеполье: '81848',
			Каска: '81839',
			Катунино: '8182',
			Квазеньга: '81855',
			Кварзангский: '81858',
			Кеба: '81833',
			Кеврола: '81856',
			Керзеньга: '81851',
			Кидюга: '81855',
			Кизема: '81855',
			Кимжа: '81848',
			Клемушино: '81851',
			Клещево: '81839',
			Климовская: '81858',
			Клишовщина: '81830',
			Кобелево: '81856',
			Ковкула: '81839',
			Кодима: '81854',
			Кодино: '81839',
			Козловская: '81836',
			Козловское: '81836',
			Козьмино: '81859',
			Козьмогородское: '81848',
			Койда: '81848',
			Койнас: '81833',
			Коковка: '81832',
			Комарово: '81840',
			Комсомольский: '81836',
			Кондратовская: '81855',
			Конево: '81832',
			Конецдворье: '8182',
			Кононово: '81841',
			Коноша: '81858',
			Копачево: '81830',
			Коровино: '81832',
			Коряжма: '81850',
			Корякино: '81832',
			Костылево: '81855',
			Котлас: '81837',
			Красная: '81854',
			Красноборск: '81840',
			Кремлево: '81858',
			Кречетово: '81841',
			Кузомень: '81830',
			Кузьмино: '8182',
			Куликово: '81840',
			Куликовская: '81851',
			Кулой: '81836',
			Кулосега: '81856',
			Курниково: '81838',
			Куша: '81839',
			Кушкопала: '81856',
			Кянда: '81839',
			Лавела: '81856',
			Лазаревская: '81841',
			Ламбас: '81854',
			Лампожня: '81848',
			Лапоминка: '8182',
			Ластола: '8182',
			Лахома: '81854',
			Лебское: '81833',
			Лельма: '81838',
			Лена: '81859',
			Лепша: '81838',
			Летнеозерский: '81832',
			Лешуконское: '81833',
			Липаково: '81832',
			Литвино: '81859',
			Лиходиевский: '81836',
			Лодейное: '81836',
			Лойга: '81855',
			Ломовое: '81832',
			Ломоносово: '81830',
			Лопшеньга: '8182',
			Лужма: '81832',
			Луковецкий: '81830',
			Лупья: '81859',
			Лысимо: '81859',
			Лямца: '81839',
			Ляховская: '81840',
			Майда: '81848',
			Макаровская: '81838',
			Маложма: '81839',
			Малошуйка: '81839',
			Мальшинская: '81838',
			Матвера: '81856',
			Медведево: '81841',
			Междуреченский: '81856',
			Мезень: '81848',
			Мелединская: '81836',
			Мелентьевский: '81858',
			Мирный: '81834',
			Михалево: '81855',
			Можуга: '81858',
			Молодиловская: '81837',
			Монастырь: '81832',
			Моржегоры: '81831',
			Морщихинская: '81841',
			Мосеево: '81848',
			Мотьма: '81837',
			Мудьюга: '81839',
			Нагорская: '81855',
			Ненокса: '8184',
			Нестюковская: '81836',
			Нечаевская: '81858',
			Нечаиха: '81837',
			Никифорово: '81836',
			Никифоровская: '81851',
			Никольское: '81843',
			Нименьга: '81839',
			Новиково: '81837',
			Новинки: '81836',
			Новодвинск: '81852',
			Новолавела: '81856',
			Норминга: '81858',
			Нюхча: '81856',
			Няндома: '81838',
			Обозерский: '81832',
			Одиночка: '81830',
			Одинцовская: '81851',
			Оксовский: '81832',
			Октябрьский: '81855',
			Окулово: '8182',
			Окуловская: '81854',
			Олема: '81833',
			Онега: '81839',
			Орлецы: '81830',
			Осередок: '81830',
			Осиново: '81831',
			Осташевская: '81841',
			Осяткино: '81854',
			Ошлапье: '81859',
			Павловское: '81836',
			Палащелье: '81833',
			Палова: '81854',
			Палово: '81830',
			Палуга: '81833',
			Папинская: '81858',
			Пасьва: '81836',
			Патракеевка: '8182',
			Патровская: '81841',
			Пачиха: '81856',
			Пежма: '81836',
			Первомайский: '81855',
			Пертоминск: '8182',
			Першинская: '81858',
			Песок: '81841',
			Петрова: '81856',
			Петровская: '81851',
			Пинега: '81856',
			Пиньгиша: '81830',
			Пиринемь: '81856',
			Плесецк: '81832',
			Плесо: '81851',
			Площадь: '81858',
			Погост: '81830',
			Подволочье: '81832',
			Подюга: '81858',
			Покровское: '81839',
			Пономаревская: '81858',
			Поньга: '81839',
			Поперечка: '81854',
			Порог: '81839',
			Посад: '81839',
			Поча: '81832',
			Почтовое: '81830',
			Прела: '81837',
			Приводино: '81837',
			Прилуки: '81839',
			Прошково: '81839',
			Пукса: '81832',
			Пуксоозеро: '81832',
			Пурнема: '81839',
			Пустарево: '81838',
			Пустошь: '8182',
			Пустынька: '81832',
			Пушлахта: '8182',
			Пылема: '81833',
			Пянда: '81831',
			Раковская: '81851',
			Ракула: '81830',
			Реваж: '81837',
			Рембуево: '81830',
			Рикасиха: '8182',
			Рикасово: '8182',
			Ровдино: '81851',
			Родома: '81833',
			Россохи: '81851',
			Ростовское: '81831',
			Рочегда: '81831',
			Русковера: '81856',
			Ручьи: '81848',
			Рыбогорская: '81851',
			Рязаново: '81831',
			Савватия: '81837',
			Савинская: '81840',
			Савинский: '81832',
			Самино: '81843',
			Самково: '81832',
			Самодед: '81832',
			Саргино: '81836',
			Сафоново: '81848',
			Светлый: '81830',
			Северный: '81854',
			Северодвинск: '8184',
			Североонежск: '81832',
			Селище: '81833',
			Сельменьга: '81831',
			Семеновская: '81841',
			Сенгосс: '81855',
			Синега: '81836',
			Сия: '81856',
			Скарлахта: '81832',
			Скрипово: '81832',
			Слобода: '81843',
			Слободчиково: '81859',
			Смоленец: '81833',
			Смольянская: '81836',
			Совза: '81858',
			Совполье: '81848',
			Согра: '81854',
			Сойга: '81859',
			Солгинский: '81836',
			Солза: '81841',
			Соловецкий: '8183590',
			Сольвычегодск: '81837',
			Сорово: '81843',
			Сосновка: '81856',
			Сосновый: '81854',
			Сояла: '81856',
			Сояна: '81848',
			Спасская: '81855',
			Степановская: '8182',
			Строевское: '81855',
			Студенец: '81855',
			Ступинская: '81838',
			Сулонда: '81855',
			Сульца: '81856',
			Сура: '81856',
			Сурдомский: '81836',
			Сылога: '81856',
			Тайга: '81856',
			Талаги: '8182',
			Тамица: '81839',
			Тарза: '81838',
			Тегрозеро: '81836',
			Теребино: '81836',
			Тимонино: '81836',
			Тимошинская: '81841',
			Топоровская: '81858',
			Топса: '81831',
			Тронинская: '81851',
			Трофимовская: '81841',
			Труфанова: '81856',
			Тулубьево: '81837',
			Тундра: '8182',
			Туровец: '81837',
			Тыва: '81859',
			Удимский: '81837',
			Уемский: '8182',
			Уйма: '8182',
			Уйта: '81831',
			Уколок: '81851',
			Уксора: '81851',
			Улитино: '81832',
			Ульюха: '81855',
			Уна: '8182',
			Унежма: '81839',
			Урдома: '81859',
			Устье: '81859',
			Устькожа: '81839',
			Ухменьга: '81854',
			Ушаковская: '81851',
			Федово: '81832',
			Федосеевская: '81838',
			Федотовская: '81837',
			Филинская: '81855',
			Филипповская: '81840',
			Фоминская: '81858',
			Фоминский: '81843',
			Хаврогоры: '81830',
			Хаминово: '81837',
			Харитоново: '81837',
			Харламовская: '81858',
			Хачела: '81839',
			Холмогоры: '81830',
			Хорьково: '8182',
			Целегора: '81848',
			Ценогора: '81833',
			Чадрома: '81855',
			Чакола: '81856',
			Часовенская: '8182',
			Черевково: '81840',
			Черемушский: '81837',
			Чуласа: '81833',
			Чушевская: '81851',
			Шалакуша: '81838',
			Шалимово: '81843',
			Шангалы: '81855',
			Шардонемь: '81856',
			Шахановка: '81851',
			Швакино: '81832',
			Шеговары: '81851',
			Шелаша: '81851',
			Шелоховская: '81841',
			Шенкурск: '81851',
			Шестиозерский: '81838',
			Шидрово: '81831',
			Шипицино: '81837',
			Шипуновская: '81851',
			Широкое: '81856',
			Ширша: '8182',
			Ширяиха: '81841',
			Шожма: '81838',
			Шокша: '81836',
			Шомокша: '81839',
			Шотова: '81856',
			Шотогорка: '81856',
			Шошельцы: '81831',
			Шуйга: '81856',
			Шунема: '81836',
			Шурай: '81855',
			Юра: '81836',
			Юрома: '81833',
			Юрятинская: '81855',
			Ядриха: '81837',
			Яковлевское: '81831',
			Яренск: '81859',
			Яреньга: '8182',
			Ясный: '81856'
		}
	},
	'Астраханская область': {
		regionCode: '851',
		cities: {
			'Анатолия Зверева им.': '85144',
			'Бирючья Коса': '85147',
			'Большой Могой': '85142',
			'Верхний Баскунчак': '85141',
			'Верхний Бузан': '85146',
			'Волго-Каспийский': '85145',
			'Жан-Аул': '85145',
			'Каменный Яр': '85149',
			'Капустин Яр': '85141',
			'Кирпичный завод': '85172',
			'Красные Баррикады': '85144',
			'Красный Яр': '85146',
			'Кривой Бузан': '85146',
			'Нижне-Никольский': '85145',
			'Нижний Баскунчак': '85141',
			'Новый Рычан': '85142',
			'Образцово-Травино': '85145',
			'Осыпной Бугор': '85172',
			'Пологое Займище': '85141',
			'Посёлок Лиман': '85147',
			'Сизый Бугор': '85142',
			'Соленое Займище': '85149',
			'Средний Баскунчак': '85141',
			'Старая Кучергановка': '85171',
			'Татарская Башмаковка': '85172',
			'Три Протока': '85172',
			'Труд-Фронт': '85144',
			'Чёрный Яр': '85149',
			'Яр Базар': '85147',
			'Ясын-Сокан': '85146',
			'село Селитренное': '85148',
			Аксарайская: '85146',
			Алексеевка: '85145',
			Алтынжар: '85142',
			Алча: '85146',
			Ассадулаево: '85172',
			Астрахань: '8512',
			Ахтубинск: '85141',
			Байбек: '85146',
			Барановка: '85171',
			Басы: '85147',
			Батаевка: '85141',
			Бахтемир: '85144',
			Белячье: '85146',
			Бирюковка: '85172',
			Болхуны: '85141',
			Бударино: '85147',
			Бузан: '85146',
			Буруны: '85171',
			Ватажное: '85146',
			Верблюжий: '85141',
			Верхнекалиновский: '85145',
			Верхнелебяжье: '85171',
			Ветлянка: '85143',
			Винный: '85142',
			Владимировка: '85143',
			Водяновка: '85172',
			Волжский: '85143',
			Волжское: '85171',
			Володарский: '85142',
			Вольное: '85148',
			Воскресеновка: '85147',
			Восток: '85143',
			Восточное: '85144',
			Вышка: '85147',
			Вязовка: '85149',
			Гандурино: '85145',
			Грачи: '85143',
			Грушево: '85145',
			Джанай: '85146',
			Досанг: '85146',
			Евпраксино: '85172',
			Енотаевка: '85143',
			Житное: '85144',
			Забузан: '85146',
			Заволжское: '85148',
			Замьяны: '85143',
			Заречное: '85147',
			Затон: '85145',
			Зеленга: '85142',
			Зензели: '85147',
			Знаменск: '85140',
			Золотуха: '85141',
			Зубовка: '85149',
			Зюзино: '85144',
			Ивановка: '85143',
			Иванчуг: '85145',
			Икряное: '85144',
			Ильинка: '85144',
			Калинино: '85142',
			Камызяк: '85145',
			Камышово: '85147',
			Караванное: '85147',
			Карагали: '85172',
			Каралат: '85145',
			Караульное: '85145',
			Каспий: '85145',
			Килинчи: '85172',
			Кировский: '85145',
			Козлово: '85142',
			Комсомольский: '85146',
			Копановка: '85143',
			Косика: '85143',
			Кочковатка: '85148',
			Крутое: '85142',
			Кряжевое: '85147',
			Курченко: '85171',
			Лебяжье: '85145',
			Ленино: '85143',
			Лесное: '85147',
			Лиман: '85147',
			Линейное: '85171',
			Маково: '85142',
			Марфино: '85142',
			Маячное: '85144',
			Михайловка: '85147',
			Мултаново: '85142',
			Мумра: '85144',
			Нариманов: '85171',
			Начало: '85172',
			Началово: '85172',
			Николаевка: '85171',
			Никольское: '85143',
			Новинка: '85142',
			Новокрасное: '85142',
			Новониколаевка: '85141',
			Новоурусовка: '85146',
			Оля: '85147',
			Оранжереи: '85144',
			Песчаное: '85147',
			Петропавловка: '85171',
			Пироговка: '85141',
			Поды: '85149',
			Пойменный: '85172',
			Покровка: '85141',
			Полдневое: '85145',
			Прикаспийский: '85171',
			Пришиб: '85143',
			Промысловка: '85147',
			Проточное: '85147',
			Раздор: '85145',
			Разночиновка: '85171',
			Рассвет: '85171',
			Растопуловка: '85172',
			Речное: '85148',
			Самосделка: '85145',
			Сасыколи: '85148',
			Седлистое: '85144',
			Сеитовка: '85146',
			Селитреное: '85148',
			Сергиевка: '85144',
			Сероглазка: '85143',
			Сокрутовка: '85141',
			Солодники: '85149',
			Солянка: '85171',
			Старица: '85149',
			Староволжское: '85144',
			Старокучергановка: '85171',
			Стеклозавод: '85172',
			Степной: '85146',
			Ступино: '85149',
			Судачье: '85147',
			Тамбовка: '85148',
			Тинаки: '85171',
			Тишково: '85142',
			Товарное: '85144',
			Трубный: '85142',
			Трусово: '85171',
			Тузуклей: '85145',
			Тулугановка: '85171',
			Тумак: '85142',
			Тюрино: '85142',
			Увары: '85145',
			Удачное: '85141',
			Успенка: '85141',
			Ушаковка: '85149',
			Федоровка: '85144',
			Фунтово: '85172',
			Харабали: '85148',
			Хмелевка: '85145',
			Хошеутово: '85148',
			Цветное: '85142',
			Чаган: '85145',
			Чапаево: '85145',
			Черемуха: '85146',
			Чулпан: '85144',
			Яблонка: '85142',
			Яксатово: '85172',
			Ямное: '85144',
			Яндыки: '85147'
		}
	},
	Байконур: {
		regionCode: '336',
		cities: {
			Байконур: '33622'
		}
	},
	'Белгородская область': {
		regionCode: '472',
		cities: {
			'Батрацкая Дача': '47248',
			'Белый Колодезь': '47237',
			'Белый Плес': '47237',
			'Береговое-Второе': '47242',
			'Береговое-Первое': '47242',
			'Ближняя Игуменка': '4722',
			'Бобровы Дворы': '47241',
			'Большая Халань': '47231',
			'Большие Липяги': '47237',
			'Большое Городище': '47248',
			'Введенская Готня': '47245',
			'Велико-Михайловка': '47233',
			'Верхнее Кузькино': '47232',
			'Верхние Лубянки': '47235',
			'Верхний Ольшанец': '47244',
			'Верхняя Покровка': '47247',
			'Верхняя Серебрянка': '47238',
			'Веселая Лопань': '4722',
			'Вислая Дубрава': '47241',
			'Волчья Александровка': '47235',
			'Вышние Пены': '47245',
			'Головчино Первое': '47261',
			'Гора-Подол': '47261',
			'Долгая Поляна': '4725',
			'Журавка-Первая': '47242',
			'Зеленая Поляна': '4722',
			'Ивановская Лисица': '47261',
			'Илек-Кошары': '47245',
			'Илек-Пеньковка': '47263',
			'Казачья Лисица': '47261',
			'Красная Поляна': '47248',
			'Красная Яруга': '47263',
			'Красный Куток': '47246',
			'Красный Хутор': '4722',
			'Кривые Балки': '47242',
			'Крутой Лог': '4722',
			'Лесное Уколово': '47262',
			'Лубяное Первое': '47232',
			'Маслова Пристань': '47248',
			'Матрено-Гезово': '47234',
			'Мокрая Орловка': '47261',
			'Нижние Пены': '47245',
			'Нижняя Серебрянка': '47238',
			'Новая Безгинка': '47233',
			'Новая Глинка': '47244',
			'Новая Масловка': '47232',
			'Новая Нелидовка': '4722',
			'Новая Слободка': '47231',
			'Новая Таволжанка': '47248',
			'Новый Оскол': '47233',
			'Октябрьская Готня': '47246',
			'Первое Цепляево': '47248',
			'Русская Березовка': '47245',
			'Русская Халань': '47232',
			'Солонец-Поляна': '47233',
			'Старая Безгинка': '47233',
			'Старый Оскол': '4725',
			'Стрелица Вторая': '47248',
			'Теплый Колодезь': '47241',
			'Червона Дибровка': '47248',
			'Ясные Зори': '4722',
			'с. Мандрово': '47236',
			'село Мухоудеровка': '47234',
			Айдар: '47238',
			Акулиновка: '47246',
			Алейниково: '47234',
			Александровка: '47248',
			Алексеевка: '47234',
			Андреевка: '47232',
			Анновка: '47231',
			Арнаутово: '47247',
			Архангельское: '47248',
			Афанасьевка: '47234',
			Байцуры: '47246',
			Барсучье: '47238',
			Безымено: '47261',
			Белгород: '4722',
			Беленихино: '47242',
			Беленькое: '47246',
			Беловское: '4722',
			Беломестное: '4722',
			Белянка: '47248',
			Березовка: '47246',
			Бершаково: '47248',
			Бессоновка: '4722',
			Бехтеевка: '47231',
			Бирюч: '47247',
			Бобрава: '47245',
			Богатое: '47243',
			Богдановка: '47233',
			Богородское: '47233',
			Богословка: '47241',
			Божково: '47234',
			Большебыково: '47247',
			Большетроицкое: '47248',
			Борисовка: '47246',
			Борисполье: '47245',
			Борки: '47236',
			Боровки: '47233',
			Боровое: '47233',
			Бородин: '47232',
			Борсук: '47233',
			Бочковка: '4722',
			Бубново: '47231',
			Булановка: '47248',
			Бутово: '47244',
			Бутырки: '47236',
			Быковка: '47244',
			Валуйки: '47236',
			Валуйчик: '47247',
			Варваровка: '4722',
			Васильдол: '47233',
			Васильевка: '47245',
			Вейделевка: '47237',
			Великомихайловка: '47233',
			Венгеровка: '47245',
			Вергелевка: '4722',
			Верхнеберезово: '47248',
			Верхнечуфичево: '4725',
			Верхопенье: '47243',
			Верхососна: '47247',
			Веселое: '47247',
			Веселый: '47242',
			Викторополь: '47237',
			Владимировка: '4725',
			Вознесеновка: '47248',
			Волково: '47232',
			Волоконовка: '47235',
			Волотово: '47232',
			Всесвятка: '47238',
			Вязовое: '47242',
			Вязовское: '47263',
			Гарбузово: '47234',
			Герасимовка: '47236',
			Глинное: '47233',
			Глотово: '47261',
			Глуховка: '47234',
			Гнездиловка: '47242',
			Головчино: '47261',
			Голофеевка: '47235',
			Голубино: '47233',
			Городище: '4725',
			Горьковский: '47261',
			Гостищево: '47244',
			Готовье: '47262',
			Грайворон: '47261',
			Графовка: '47248',
			Грузское: '47246',
			Грушевка: '47235',
			Грязное: '47242',
			Губкин: '47241',
			Гущино: '47241',
			Дальний: '47236',
			Двулучное: '47236',
			Дегтярное: '47237',
			Демидовка: '47263',
			Дмитриевка: '47244',
			Доброивановка: '47261',
			Долгое: '47241',
			Донец: '47242',
			Дорогощь: '47261',
			Драгунка: '47243',
			Драгунское: '47244',
			Дроновка: '47261',
			Дубовое: '4722',
			Дунайка: '47261',
			Ездочное: '47232',
			Еремовка: '47238',
			Ерик: '4722',
			Жабское: '47238',
			Жигайловка: '47231',
			Жуково: '47234',
			Журавлевка: '4722',
			Завидовка: '47244',
			Задельное: '47244',
			Закутское: '47237',
			Заповедный: '47241',
			Запольное: '47234',
			Засосна: '47247',
			Заячье: '47231',
			Зенино: '47237',
			Зиборовка: '47248',
			Зимовное: '47248',
			Зинаидино: '47245',
			Знаменка: '4725',
			Зыбино: '47246',
			Ивановка: '4725',
			Иващенково: '47234',
			Ивня: '47243',
			Иловка: '47234',
			Ильинка: '47234',
			Истобное: '47241',
			Казанка: '47231',
			Казацкое: '47244',
			Казачок: '4725',
			Казинка: '47236',
			Казначеевка: '47236',
			Калинино: '47244',
			Калиново: '47247',
			Калитва: '47234',
			Камызино: '47262',
			Камышеватое: '47234',
			Каплино: '4725',
			Караичное: '47248',
			Карташевка: '47242',
			Киселевка: '47233',
			Кладовое: '47241',
			Клименки: '47237',
			Клименково: '47238',
			Клиновец: '47231',
			Ковалево: '47234',
			Козинка: '47261',
			Козьмодемьяновка: '47248',
			Колесники: '47237',
			Коломыцево: '47242',
			Колтуновка: '47234',
			Комсомольский: '4722',
			Коновалово: '47235',
			Конопляновка: '47236',
			Коньшино: '47241',
			Копанки: '47238',
			Короткое: '47231',
			Короча: '47231',
			Корочка: '47241',
			Косилово: '47261',
			Котово: '4725',
			Кочегуры: '47232',
			Кочетовка: '47243',
			Кошлаково: '47248',
			Кощеево: '47231',
			Крапивное: '47248',
			Красногвардейское: '47247',
			Красное: '47262',
			Кривошеевка: '47242',
			Кривцово: '47244',
			Круглое: '47262',
			Крутое: '4725',
			Крюк: '47233',
			Крюково: '47246',
			Кубраки: '47237',
			Кукуевка: '47236',
			Купино: '47248',
			Курасовка: '47243',
			Кустовое: '47244',
			Лавы: '47236',
			Ладомировка: '47238',
			Лазареново: '47247',
			Лапыгино: '4725',
			Ларисовка: '47232',
			Ливенка: '47247',
			Лихолобов: '47238',
			Логачевка: '47236',
			Лозная: '47238',
			Лозное: '47232',
			Лозовое: '47238',
			Локня: '47244',
			Ломное: '47261',
			Ломово: '47231',
			Луценково: '47234',
			Мазикино: '47231',
			Майский: '4722',
			Макешкино: '47233',
			Максимовка: '47248',
			Малакеево: '47237',
			Маломихайловка: '47248',
			Малотроицкое: '47232',
			Мальцевка: '47231',
			Мандрово: '47236',
			Марьевка: '47247',
			Масловка: '47238',
			Мелавое: '47241',
			Мелихово: '47231',
			Меловое: '47245',
			Меняйлово: '47234',
			Мешковое: '47248',
			Мощеное: '47244',
			Мухоудеровка: '47234',
			Мясоедово: '4722',
			Нагольное: '47238',
			Нагорье: '47238',
			Насоново: '47236',
			Незнамово: '4725',
			Немцово: '47233',
			Нечаево: '47231',
			Нижнечуфичево: '4725',
			Никаноровка: '47241',
			Никитовка: '47247',
			Никитское: '47246',
			Николаевка: '47237',
			Никольское: '47248',
			Ниновка: '47233',
			Новенькое: '47243',
			Новоалександровка: '47246',
			Новопетровка: '47236',
			Новоречье: '47232',
			Новосадовый: '4722',
			Новостроевка: '47261',
			Новоуколово: '47262',
			Новохуторное: '47247',
			Обуховка: '4725',
			Огибное: '47232',
			Озерки: '4725',
			Октябрьский: '4722',
			Окуни: '47232',
			Олейники: '47237',
			Ольховатка: '47233',
			Ольшанка: '47232',
			Орлик: '47232',
			Орловка: '4722',
			Осколец: '47241',
			Оскольское: '47233',
			Отрадное: '4722',
			Палатово: '47247',
			Пестуново: '47231',
			Песчанка: '4725',
			Песчаное: '47243',
			Петровка: '47242',
			Петровский: '4725',
			Петропавловка: '4722',
			Пирогово: '47234',
			Плоское: '47231',
			Плота: '47242',
			Плотавец: '47231',
			Погореловка: '47231',
			Погромец: '47235',
			Подгорное: '47236',
			Подольхи: '47242',
			Подсереднее: '47234',
			Покровка: '47243',
			Политотдел: '4722',
			Поповка: '47231',
			Пороз: '47261',
			Потудань: '4725',
			Почаево: '47261',
			Прелестное: '47242',
			Преображенка: '4725',
			Прибрежный: '47233',
			Призначное: '47242',
			Прилепы: '47232',
			Принцевка: '47236',
			Пристень: '47238',
			Пролетарский: '47245',
			Проходное: '47231',
			Прохоровка: '47242',
			Пушкарное: '4722',
			Пятницкое: '47235',
			Радьковка: '47242',
			Раздорное: '47247',
			Разумное: '4722',
			Раисовка: '47242',
			Ракитное: '47245',
			Расховец: '47262',
			Репенка: '47234',
			Репьевка: '47235',
			Репяховка: '47263',
			Ржавец: '47242',
			Ржевка: '47248',
			Ровеньки: '47238',
			Ровны: '47237',
			Роговатое: '4725',
			Ромахово: '47237',
			Сагайдачное: '47242',
			Сажное: '47244',
			Самарино: '47247',
			Самойловка: '47231',
			Сапрыкино: '47241',
			Сафоновка: '47243',
			Свистовка: '47238',
			Святославка: '47245',
			Севальный: '47233',
			Северный: '4722',
			Сеймица: '47242',
			Селиваново: '47236',
			Сергиевка: '47263',
			Серебрянка: '47233',
			Середа: '47248',
			Серетено: '47244',
			Сетище: '47262',
			Сидоровка: '47231',
			Скородное: '47241',
			Скрынников: '47233',
			Слоновка: '47233',
			Смородино: '47244',
			Советское: '47234',
			Соколовка: '47231',
			Солдатское: '4725',
			Солонцы: '47237',
			Солоти: '47236',
			Солохи: '4722',
			Сорокино: '47247',
			Стариково: '47248',
			Староивановка: '47235',
			Стрелецкое: '4722',
			Стригуны: '47246',
			Строитель: '47244',
			Сухосолотино: '47243',
			Сырцево: '47243',
			Таврово: '4722',
			Теребрено: '47263',
			Терехово: '4725',
			Терновка: '47244',
			Тетеревино: '47242',
			Тимоново: '47236',
			Тишанка: '47235',
			Толстое: '47241',
			Томаровка: '47244',
			Трефиловка: '47245',
			Триречное: '47244',
			Троицкий: '47241',
			Тростенец: '47233',
			Тютюниково: '47234',
			Уколово: '47241',
			Ураево: '47236',
			Уразово: '47236',
			Ураково: '47262',
			Успенка: '47235',
			Устянка: '4722',
			Уточка: '47247',
			Ушаковка: '47231',
			Федоренков: '47244',
			Федосеевка: '4725',
			Федчевка: '47243',
			Флюговка: '47262',
			Фощеватово: '47235',
			Фощеватое: '47231',
			Харьковское: '47238',
			Хлевище: '47234',
			Хмелевец: '47236',
			Хмелевое: '47262',
			Холки: '47232',
			Холодное: '47242',
			Хомутцы: '47243',
			Хотмыжск: '47261',
			Хохлово: '4722',
			Храпово: '47236',
			Хрещатый: '47234',
			Хуторцы: '47247',
			Чапкино: '47241',
			Черемошное: '4722',
			Черкасское: '47244',
			Чернянка: '47232',
			Чуево: '47241',
			Чуланово: '47246',
			Чураево: '47248',
			Шараповка: '47233',
			Шаталовка: '4725',
			Шахово: '47242',
			Шебекино: '47248',
			Шеино: '47231',
			Шелаево: '47236',
			Шидловка: '47235',
			Широкое: '47262',
			Шляхово: '47231',
			Щербаково: '47234',
			Щетиновка: '4722',
			Юрьевка: '47241',
			Ютановка: '47235',
			Яблоново: '47236',
			Яковлевка: '47233',
			Яковлево: '47244',
			Ярское: '47233'
		}
	},
	'Брянская область': {
		regionCode: '483',
		cities: {
			'Белая Берёзка': '48352',
			'Белые Берега': '4832',
			'Большая Жукова': '48333',
			'Большие Щербиничи': '48358',
			'Большое Полпино': '4832',
			'Великая Дуброва': '48339',
			'Великая Топаль': '48336',
			'Великий Бор': '48340',
			'Верхняя Злобинка': '48345',
			'Воронов Лог': '48354',
			'Гетманская Буда': '48347',
			'Городище-Второе': '48354',
			'Гришина Слобода': '48334',
			'Гуто-Корецкая': '48336',
			'Добрая Корна': '48338',
			'Заводо-Корецкий': '48340',
			'Запольские Халеевичи': '48348',
			'Каменский Хутор': '48347',
			'Коржово-Голубовка': '48336',
			'Красная Гора': '48346',
			'Красная Слобода': '48345',
			'Красные Косары': '48339',
			'Красный Колодец': '48354',
			'Красный Рог': '48345',
			'Лакомая Буда': '48347',
			'Малая Топаль': '48336',
			'Малое Полпино': '4832',
			'Малые Щербиничи': '48358',
			'Марицкий Хутор': '48356',
			'Никольская Слобода': '48334',
			'Новая Погощь': '48353',
			'Новая Романовка': '48339',
			'Новая Салынь': '48332',
			'Новое Место': '48343',
			'Новое Село': '48348',
			'Новые Бобовичи': '48343',
			'Новые Ивайтенки': '48351',
			'Новые Юрковичи': '48347',
			'Новый Дроков': '48330',
			'Новый Ропск': '48347',
			'Палужская Рудня': '48346',
			'Первое Мая': '48336',
			'Петрова Буда': '48340',
			'Подлесные Новоселки': '48356',
			'Полевые Новоселки': '48353',
			'Радица-Крыловка': '4832',
			'Рудня-Воробьевский': '48340',
			'Синий Колодец': '48343',
			'Смотрова Буда': '48336',
			'Сосновое Болото': '48341',
			'Спиридонова Буда': '48358',
			'Старая Гута': '48351',
			'Старая Красная Слобода': '48345',
			'Старая Мармазовка': '48338',
			'Старая Полона': '48340',
			'Старая Романовка': '48339',
			'Старое Хотьмирово': '48331',
			'Старые Бобовичи': '48343',
			'Старые Чешуйки': '48339',
			'Старые Юрковичи': '48347',
			'Старый Вышков': '48343',
			'Старый Кривец': '48343',
			'Старый Ропск': '48347',
			'Стеклянная Радица': '4832',
			'Струговская Буда': '48340',
			'Сытая Буда': '48347',
			'Удельные Уты': '48341',
			'Черный Ручей': '48340',
			'Юрасов Хутор': '48356',
			'село Красный Рог': '48345',
			'село Овстуг': '48334',
			Азаровка: '48348',
			Акуличи: '48338',
			Аладьино: '48352',
			Алейниково: '48348',
			Алексеева: '48335',
			Алексеевка: '48338',
			Алешенка: '48352',
			Алешковичи: '48353',
			Алтухово: '48342',
			Алымово: '48335',
			Андреевка: '48330',
			Андрейковичи: '48349',
			Антоновка: '48340',
			Ардонь: '48336',
			Аркино: '48355',
			Асовицы: '48355',
			Афонино: '48332',
			Баклань: '48345',
			Балыки: '48345',
			Батуровка: '48346',
			Бацкино: '48333',
			Беловодка: '48339',
			Белоглавая: '48334',
			Бельково: '48345',
			Березино: '48351',
			Березовка: '48335',
			Бересток: '48356',
			Бобовня: '48352',
			Бобрик: '48349',
			Болотня: '48338',
			Борщево: '48349',
			Ботогово: '4832',
			Бошино: '48335',
			Брасово: '48354',
			Брахлов: '48347',
			Бровничи: '48347',
			Брянкустичи: '48351',
			Брянск: '4832',
			Буда: '48331',
			Будочки: '48333',
			Бурчак: '48339',
			Бутрь: '48342',
			Быковичи: '48334',
			Бытошь: '48333',
			Быхово: '48355',
			Бяково: '48342',
			Вадьковка: '48349',
			Валуец: '48345',
			Василевка: '48349',
			Вельжичи: '48339',
			Вельяминово: '48335',
			Веприно: '48336',
			Веребское: '48354',
			Верещаки: '48343',
			Верхи: '48333',
			Верхличи: '48346',
			Верхополье: '48335',
			Ветлевка: '48339',
			Вздружное: '48342',
			Витемля: '48349',
			Витовка: '48345',
			Вишневский: '48347',
			Влазовичи: '48330',
			Внуковичи: '48343',
			Воробейня: '48344',
			Воробьевка: '48347',
			Вороново: '48331',
			Воронок: '48348',
			Выгоничи: '48341',
			Высокое: '48344',
			Вышков: '48358',
			Вьюково: '48330',
			Вьюнка: '48336',
			Галенск: '48348',
			Гапоново: '48356',
			Гарцево: '48348',
			Герасимовка: '48332',
			Гетуновка: '48349',
			Глинищево: '4832',
			Глинное: '48342',
			Глоднево: '48354',
			Глыбочка: '48352',
			Глядино: '48355',
			Гнилево: '48352',
			Гобики: '48331',
			Голышино: '48356',
			Гордеевка: '48340',
			Горицы: '48349',
			Городец: '48341',
			Городище: '48349',
			Городцы: '48352',
			Гостиловка: '48334',
			Гремячее: '48342',
			Гринево: '48349',
			Громыки: '48345',
			Гудовка: '48349',
			Гулевка: '48336',
			Гущино: '48345',
			Давыдчичи: '48332',
			Далисичи: '48330',
			Дареевск: '48349',
			Дарковичи: '4832',
			Дегтяревка: '48330',
			Деменка: '48343',
			Демьянки: '48348',
			Денисковичи: '48358',
			Деньгубовка: '48332',
			Деремна: '48339',
			Десятуха: '48348',
			Дивовка: '48339',
			Дмитрово: '48345',
			Добрик: '48354',
			Доброводье: '48356',
			Добродеевка: '48358',
			Добрунь: '4832',
			Долботово: '48349',
			Доманичи: '48345',
			Домашово: '4832',
			Дохновичи: '48348',
			Дроново: '48335',
			Дружба: '48333',
			Дубровка: '48332',
			Дунаевский: '48335',
			Душатино: '48330',
			Душкино: '48336',
			Дятьково: '48333',
			Евдокимовка: '48355',
			Елионка: '48348',
			Жастково: '48330',
			Жигалки: '48349',
			Жирятино: '48344',
			Жудилово: '48351',
			Жуковка: '48334',
			Журиничи: '4832',
			Заборье: '48346',
			Забрама: '48347',
			Задубравье: '48334',
			Займище: '48336',
			Залядка: '48341',
			Замишево: '48343',
			Затишье: '48336',
			Заулье: '48356',
			Зерново: '48353',
			Злынка: '48358',
			Ивот: '48333',
			Истопки: '48347',
			Каменка: '48331',
			Каменск: '48330',
			Камень: '48348',
			Карачев: '48335',
			Карпиловка: '48358',
			Карповка: '48341',
			Картушино: '48348',
			Касилово: '48334',
			Каташин: '48343',
			Катичи: '48343',
			Католино: '48339',
			Кветунь: '48352',
			Кибирщина: '48346',
			Киваи: '48336',
			Кирилловка: '48347',
			Кистер: '48349',
			Клетня: '48338',
			Климово: '48347',
			Клинцы: '48336',
			Клюковники: '48342',
			Княвичи: '48344',
			Княгинино: '48356',
			Ковалево: '48348',
			Кожановка: '48358',
			Кожаны: '48340',
			Кокино: '48341',
			Кокоревка: '48353',
			Колодня: '48344',
			Колюды: '48346',
			Комаричи: '48355',
			Коршево: '48338',
			Костеничи: '48330',
			Котляково: '48345',
			Красновичи: '48351',
			Красное: '48352',
			Кубань: '48355',
			Кулаги: '48330',
			Кульнево: '48344',
			Куприно: '48335',
			Кургановка: '48346',
			Курковичи: '48348',
			Курово: '48349',
			Куршановичи: '48347',
			Ларневск: '48346',
			Левенки: '48348',
			Леденево: '48334',
			Лемяшовка: '48356',
			Лески: '48342',
			Лесное: '48330',
			Летошники: '48334',
			Летяхи: '48346',
			Лизогубовка: '48351',
			Литиж: '48355',
			Лобановка: '48347',
			Логоватое: '48348',
			Локоть: '48354',
			Лопазна: '48330',
			Лопандино: '48355',
			Лопатня: '48336',
			Лопушь: '48341',
			Лотаки: '48346',
			Лубошево: '48355',
			Лугань: '48355',
			Луговец: '48339',
			Лужецкая: '48335',
			Лужки: '48348',
			Лукин: '48349',
			Лукинка: '48355',
			Лутна: '48338',
			Лутовиновка: '48331',
			Лысые: '48358',
			Лыщичи: '48351',
			Любегощь: '48333',
			Любечане: '48347',
			Любовша: '48346',
			Любожичи: '48352',
			Любохна: '48333',
			Ляличи: '48330',
			Макаричи: '48346',
			Малфа: '48341',
			Манюки: '48343',
			Мареевка: '48332',
			Мартьяновка: '48336',
			Масловка: '48335',
			Мглин: '48339',
			Медведи: '48346',
			Медведово: '48336',
			Меленск: '48348',
			Меркульево: '4832',
			Милечь: '48345',
			Мирный: '4832',
			Митьковка: '48347',
			Мичуринский: '4832',
			Мишковка: '48348',
			Молчаново: '48352',
			Морачево: '48344',
			Московский: '48345',
			Мохоновка: '48348',
			Мужиново: '48338',
			Навля: '48342',
			Найтоповичи: '48351',
			Невдольск: '48353',
			Негино: '48353',
			Неделька: '48338',
			Немеричи: '48333',
			Нетьинка: '4832',
			Нивное: '48330',
			Нижнее: '48348',
			Новгородский: '48335',
			Новенькое: '48353',
			Новозыбков: '48343',
			Новомлынка: '48348',
			Новоселки: '4832',
			Новотроицкое: '48338',
			Новямское: '48356',
			Норино: '48344',
			Оболешево: '48336',
			Овстуг: '48334',
			Овчинец: '48330',
			Одрино: '48335',
			Октябрьское: '4832',
			Олсуфьево: '48334',
			Ольховка: '48336',
			Орменка: '48341',
			Осколково: '48339',
			Осовик: '48331',
			Осотское: '48354',
			Отрадное: '4832',
			Павлинка: '48338',
			Павличи: '48336',
			Павловка: '48351',
			Партизанское: '48342',
			Пацинь: '48331',
			Пеклино: '48332',
			Первомайское: '48345',
			Перелазы: '48346',
			Переторги: '48341',
			Перятин: '48340',
			Пестриково: '48348',
			Песчанка: '48336',
			Петрятинка: '48358',
			Пильшино: '48341',
			Писаревка: '48351',
			Плавна: '48347',
			Плюсково: '48352',
			Погар: '48349',
			Погребы: '48354',
			Подбелово: '48345',
			Подывотье: '48356',
			Поздняшовка: '48356',
			Полужье: '48341',
			Польники: '48345',
			Понуровка: '48348',
			Посудичи: '48349',
			Почеп: '48345',
			Прирубки: '48349',
			Пролетарское: '48348',
			Пролысово: '48342',
			Пупково: '48333',
			Путёвка: '4832',
			Пушкино: '48356',
			Пятовск: '48348',
			Радогощь: '48355',
			Радутино: '48352',
			Радчино: '48352',
			Рамасуха: '48345',
			Рассуха: '48351',
			Ревны: '48342',
			Рековичи: '48332',
			Речица: '48345',
			Ржаница: '48334',
			Рогнедино: '48331',
			Рогов: '48358',
			Рогово: '48345',
			Рожны: '48336',
			Рубежное: '48347',
			Рубча: '48344',
			Рудня: '48347',
			Ружное: '48335',
			Рюхов: '48351',
			Рябчевск: '48352',
			Рябчичи: '48332',
			Савлуково: '48344',
			Савостьяны: '48349',
			Савчино: '48333',
			Сагутьево: '48352',
			Саково: '48334',
			Салтановка: '48342',
			Сачковичи: '48347',
			Свень: '4832',
			Севск: '48356',
			Селец: '48352',
			Селечня: '48353',
			Селище: '48348',
			Сельцо: '48333',
			Семеновск: '48353',
			Семиричи: '48338',
			Семки: '48339',
			Семцы: '48345',
			Семячки: '48352',
			Сенное: '48356',
			Серпеевский: '48332',
			Сетолово: '48345',
			Сеща: '48332',
			Симонтовка: '48339',
			Синезерки: '48342',
			Синицкое: '48338',
			Скуратово: '48341',
			Слище: '48330',
			Слободище: '48333',
			Случевск: '48349',
			Смолевичи: '48336',
			Смяльч: '48340',
			Сновское: '48343',
			Снопоть: '48331',
			Сныткино: '48354',
			Согласие: '48335',
			Соколовка: '48339',
			Соколово: '48342',
			Соловьевка: '48347',
			Сосновка: '48352',
			Софиевка: '48358',
			Стародуб: '48348',
			Старь: '48333',
			Стечна: '48349',
			Столбово: '48354',
			Страчево: '48353',
			Страшевичи: '48344',
			Струженка: '48330',
			Суземка: '48353',
			Супонево: '4832',
			Супрягино: '48345',
			Сураж: '48330',
			Сушаны: '48347',
			Тарасовка: '48348',
			Творишино: '48340',
			Теменичи: '4832',
			Теплое: '48335',
			Титовка: '48345',
			Третьяки: '48345',
			Троебортное: '48356',
			Тросна: '48334',
			Трубчевск: '48352',
			Трыковка: '48335',
			Тубольцы: '48345',
			Туросна: '48336',
			Тюнино: '48331',
			Увелье: '48346',
			Угревище: '48355',
			Ужа: '48352',
			Унеча: '48351',
			Уношево: '48340',
			Уручье: '48341',
			Усожа: '48355',
			Усох: '48352',
			Ущерпье: '48336',
			Филипповичи: '48352',
			Фоевичи: '48347',
			Фокино: '48333',
			Фошное: '48346',
			Халеевичи: '48343',
			Хариново: '48331',
			Харитоновка: '48338',
			Хинель: '48356',
			Хмелево: '48341',
			Ходиловичи: '48334',
			Холмечи: '48353',
			Хоромное: '48347',
			Хотеево: '48354',
			Хотылево: '4832',
			Хохловка: '48347',
			Цветники: '48334',
			Цинка: '48339',
			Чайкино: '48349',
			Челхов: '48347',
			Чемлыж: '48356',
			Чернево: '48355',
			Чернетово: '4832',
			Черновица: '48339',
			Чернооково: '48347',
			Чернятичи: '48333',
			Чеховка: '48349',
			Чопово: '48345',
			Чубковичи: '48348',
			Чуровичи: '48347',
			Шаровичи: '48331',
			Шарово: '48355',
			Шведчики: '48356',
			Шеломы: '48343',
			Ширковка: '48338',
			Ширяевка: '48340',
			Шкрябино: '48348',
			Шумарово: '48339',
			Шумиловка: '48347',
			Шуморово: '48345',
			Щегловка: '48342',
			Юдиново: '48349',
			Юрасово: '48335',
			Юрово: '48352',
			Юшино: '48356',
			Яловка: '48346'
		}
	},
	'Владимирская область': {
		regionCode: '492',
		cities: {
			'Абельмана им.Санаторий': '49232',
			'Артема им.': '49248',
			'Белая Речка': '49245',
			'Большая Пекша': '49243',
			'Большое Каринское': '49244',
			'Большое Кузьминское': '49245',
			'Большой Приклон': '49247',
			'Вольная Артемовка': '49235',
			'Воровского им.': '49235',
			'Гусь-Хрустальный': '49241',
			'Дмитриевская Слобода': '49234',
			'Дмитриевы Горы': '49247',
			'Карла Маркса пос.им.': '49248',
			'Кирова им.': '49248',
			'Клязьменский Городок': '49232',
			'Красная Горбатка': '49236',
			'Красная Ушна': '49236',
			'Красное Заречье': '49246',
			'Красное Пламя': '49244',
			'Красное Эхо': '49241',
			'Красный Богатырь': '49235',
			'Красный Бор': '49234',
			'Красный Куст': '49235',
			'Красный Маяк': '49232',
			'Красный Октябрь': '49241',
			'Максима Горького им.': '49248',
			'Малые Удолы': '49233',
			'Новая Заря': '49248',
			'Новое Аннино': '49243',
			'Новое Перепечино': '49243',
			'Новый Быт': '49236',
			'Пировы Городищи': '49233',
			'Сергиевы Горки': '49233',
			'Сосновый Бор': '49246',
			'Спасское Городище': '49231',
			'Старые Омутищи': '49243',
			'Старый Двор': '49231',
			'Тасинский Бор': '49241',
			Эрлекс: '49241',
			'Юрьев-Польский': '49246',
			'Якиманская Слобода': '49234',
			'деревня Орехово': '49242',
			'им. Ленина': '49244',
			'поселок Мстера': '49233',
			'поселок им. Ленина': '49244',
			Аббакумово: '49241',
			Авдотьино: '49246',
			Аксеново: '49241',
			Александров: '49244',
			Андреево: '49235',
			Андреевское: '49244',
			Анкудиново: '49243',
			Анопино: '49241',
			Арефино: '49238',
			Арсаки: '49244',
			Архангел: '49247',
			Асерхово: '49242',
			Афанасово: '49237',
			Бабаево: '49242',
			Бавлены: '49245',
			Бакино: '49244',
			Бакшеево: '49244',
			Балакирево: '49244',
			Бараки: '49235',
			Барсово: '49237',
			Безлесная: '49234',
			Беляницыно: '49246',
			Березники: '49242',
			Благовещенское: '49234',
			Боголюбово: '49231',
			Болдино: '49243',
			Большевысоково: '49233',
			Большое: '49238',
			Борисово: '49234',
			Борисовское: '49231',
			Борисоглеб: '49234',
			Булатниково: '49234',
			Буторлино: '49233',
			Бутылицы: '49247',
			Быкасово: '49238',
			Ваулово: '49245',
			Вашутино: '49241',
			Вековка: '49241',
			Великово: '49232',
			Великодворский: '49241',
			Вербовский: '49234',
			Веска: '49246',
			Весь: '49231',
			Вешки: '49241',
			Вишневый: '49245',
			Вишняково: '49244',
			Владимир: '4922',
			Войново: '49247',
			Волковойно: '49248',
			Волосово: '49242',
			Вольгинский: '49243',
			Ворша: '49242',
			Воспушка: '49243',
			Восход: '49232',
			Вощиха: '49236',
			Воютино: '49247',
			Второво: '49248',
			Вышманово: '49242',
			Вязники: '49233',
			Вяткино: '49235',
			Гавриловское: '49231',
			Галицы: '49238',
			Галкино: '49233',
			Гатиха: '49248',
			Гигант: '49232',
			Глухово: '49242',
			Годуново: '49244',
			Головино: '49235',
			Гонобилово: '49235',
			Горка: '49237',
			Горки: '49246',
			Городищи: '49243',
			Гороховец: '49238',
			Гришино: '49238',
			Губино: '49236',
			Гусевский: '49241',
			Давыдово: '49248',
			Данилово: '49247',
			Демидово: '49241',
			Денятино: '49247',
			Дмитриево: '49232',
			Добрынское: '49231',
			Добрятино: '49241',
			Долбино: '49241',
			Долгополье: '49244',
			Дорофеево: '49235',
			Достижение: '49232',
			Драчево: '49236',
			Дубки: '49237',
			Ельтесуново: '49242',
			Ельцино: '49245',
			Ельцы: '49237',
			Есиплево: '49245',
			Жердеево: '49237',
			Жерехово: '49242',
			Заклязьменский: '49231',
			Заколпье: '49241',
			Заречное: '49242',
			Заречье: '49237',
			Заря: '49232',
			Зименки: '49234',
			Зиновьево: '49245',
			Злобино: '49247',
			Золотково: '49241',
			Золотуха: '49245',
			Иванищи: '49241',
			Ильино: '49241',
			Ильинское: '49245',
			Илькино: '49247',
			Искра: '49244',
			Каменка: '49247',
			Камешково: '49248',
			Карабаново: '49244',
			Караваево: '49243',
			Кашино: '49237',
			Кибирево: '49243',
			Кидекша: '49231',
			Кипрево: '49237',
			Киржач: '49237',
			Кишлеево: '49242',
			Клементьево: '49231',
			Ковардицы: '49234',
			Ковров: '49232',
			Козлово: '49233',
			Колокша: '49242',
			Колпь: '49241',
			Кольчугино: '49245',
			Коммунар: '49231',
			Кондраково: '49234',
			Кондряево: '49235',
			Копнино: '49242',
			Коробовщинский: '49245',
			Косинское: '49246',
			Костенец: '49236',
			Костерево: '49243',
			Костино: '49243',
			Красногвардейский: '49231',
			Крестниково: '49232',
			Кривицы: '49234',
			Круглово: '49248',
			Крутово: '49243',
			Кудрино: '49247',
			Купреево: '49241',
			Курилово: '49242',
			Курловский: '49241',
			Кутуково: '49231',
			Кучки: '49246',
			Лакинск: '49242',
			Ларионово: '49243',
			Левино: '49247',
			Лесниково: '49241',
			Лесной: '4922',
			Лизуново: '49244',
			Ликино: '49235',
			Липна: '49243',
			Литвиново: '49245',
			Лобково: '49244',
			Лукново: '49233',
			Лучки: '49246',
			Лычево: '49245',
			Ляхи: '49247',
			Майский: '49244',
			Максимово: '49247',
			Малыгино: '49232',
			Малышево: '49236',
			Маринино: '49232',
			Марково: '49243',
			Матвейщево: '49246',
			Махра: '49244',
			Межищи: '49234',
			Мезиновский: '49241',
			Меленки: '49247',
			Мелехово: '49232',
			Металлист: '49245',
			Мирный: '49248',
			Мичурино: '49235',
			Мокрое: '49241',
			Молотицы: '49234',
			Мордыш: '49231',
			Мошок: '49235',
			Мстера: '49233',
			Муром: '49234',
			Муромский: '49234',
			Муромцево: '49235',
			Мячково: '49244',
			Надеждино: '49236',
			Небылое: '49246',
			Неклюдово: '49241',
			Нерехта: '49232',
			Нестерково: '49248',
			Нестерово: '49246',
			Нечаевская: '49241',
			Никологоры: '49233',
			Новки: '49248',
			Новлянка: '49236',
			Новоалександрово: '49235',
			Новобусино: '49245',
			Нововязники: '49233',
			Новое: '49231',
			Новоселово: '49237',
			Новый: '49232',
			Обашево: '49244',
			Ожигово: '49234',
			Октябрьская: '49233',
			Октябрьский: '49233',
			Ополье: '49246',
			Оргтруд: '49248',
			Осинки: '49233',
			Павловка: '49245',
			Павловское: '49231',
			Пакино: '49232',
			Палищи: '49241',
			Паново: '49247',
			Пантелеево: '49232',
			Панфилово: '49243',
			Панфиловский: '49241',
			Папулино: '49247',
			Парахино: '49241',
			Патакино: '49248',
			Паустово: '49233',
			Пенкино: '49248',
			Первомайский: '49236',
			Переложниково: '49236',
			Перово: '49233',
			Першино: '49237',
			Пески: '49233',
			Пестенькино: '49234',
			Петушки: '49243',
			Плеханы: '49244',
			Площево: '49244',
			Подолец: '49246',
			Покров: '49243',
			Польцо: '49243',
			Порецкое: '49231',
			Поречье: '49244',
			Пролетарий: '49233',
			Пролетарский: '49238',
			Прудищи: '49234',
			Прудня: '49247',
			Радужный: '49254',
			Рождествено: '49242',
			Рукав: '49242',
			Ручей: '49232',
			Савино: '49237',
			Савково: '49247',
			Садовый: '49231',
			Саксино: '49234',
			Санино: '49243',
			Санниково: '49232',
			Санхар: '49233',
			Сарыево: '49233',
			Сельцо: '49231',
			Семеновка: '49241',
			Семьинское: '49246',
			Сергеиха: '49248',
			Серково: '49233',
			Сима: '49246',
			Скрипино: '49247',
			Следнево: '49244',
			Смолино: '49232',
			Сновицы: '49231',
			Собинка: '49242',
			Сойма: '49235',
			Сокол: '49231',
			Соколье: '49247',
			Спасское: '49246',
			Ставрово: '49242',
			Станки: '49233',
			Степанцево: '49233',
			Стригино: '49234',
			Струнино: '49244',
			Судогда: '49235',
			Суздаль: '49231',
			Талызино: '49234',
			Татарово: '49234',
			Тириброво: '49244',
			Тихоново: '49241',
			Толпухово: '49242',
			Толстиково: '49247',
			Торчино: '49231',
			Тургенево: '49247',
			Туртино: '49231',
			Тынцы: '49248',
			Улыбышево: '49235',
			Уршельский: '49241',
			Усад: '49247',
			Усолье: '49248',
			Федоровское: '49246',
			Фетинино: '49242',
			Филипповское: '49237',
			Финеево: '49237',
			Флорищи: '49245',
			Фоминки: '49238',
			Хмелево: '49237',
			Цибеево: '49231',
			Чаадаево: '49234',
			Чамерево: '49235',
			Чеково: '49246',
			Черкутино: '49242',
			Черсево: '49241',
			Чертково: '49236',
			Чкалово: '49232',
			Чудиново: '49233',
			Чулково: '49238',
			Шатнево: '49233',
			Шевинская: '49232',
			Шипилово: '49246',
			Шихобалово: '49246',
			Эдон: '49233',
			Энергетик: '4922',
			Энтузиаст: '49246',
			Эсино: '49232',
			Южный: '49247',
			Юрьевец: '4922'
		}
	},
	'Волгоградская область': {
		regionCode: '844',
		cities: {
			'Абганерово Вокзал': '84477',
			'Амо Совхоз': '84447',
			'Арчедино-Чернушенский': '84465',
			'Арчединский Совхоз': '84465',
			'Белые Пруды': '84461',
			'Березовка Первая': '84447',
			'Бобровский Второй': '84464',
			'Бобровский Первый': '84464',
			'Большая Ивановка': '84467',
			'Большая Князевка': '84454',
			'Большие Чапурники': '84477',
			'Большое Судачье': '84453',
			'Большой Бабинский': '84446',
			'Большой Головский': '84447',
			'Большой Лычак': '84465',
			'Большой Морец': '84452',
			'Буерак-Поповский': '84464',
			'Великий Октябрь': '84479',
			'Верхние Липки': '84465',
			'Верхний Балыклей': '84495',
			'Верхний Еруслан': '84493',
			'Верхняя Бузиновка': '84466',
			'Верхняя Водянка': '84493',
			'Верхняя Грязнуха': '84457',
			'Верхняя Добринка': '84457',
			'Верхняя Кулаинка': '84457',
			'Верхняя Липовка': '84457',
			'Горная Пролейка': '84458',
			'Горный Балыклей': '84458',
			'Дом Отдыха': '84472',
			'Дубовый Овраг': '84477',
			'Жутово Второе': '84475',
			'Жутово Первое': '84475',
			'Зеленовский Cовхоз': '84465',
			'Ильменский Второй': '84463',
			'Ильменский Первый': '84463',
			'Ильмень-Суворовский': '84475',
			'Калач-на-Дону': '84472',
			'Каменный Брод': '84456',
			'Кирова им.': '84477',
			'Клетско-Почтовский': '84464',
			'Красные Липки': '84465',
			'Красный Буксир': '84479',
			'Красный Мелиоратор': '84494',
			'Красный Октябрь': '84446',
			'Красный Пахарь': '84468',
			'Красный Сад': '84479',
			'Красный Яр': '84454',
			'Лебяжья Поляна': '84479',
			'Ленина им.': '84476',
			'Луговая Пролейка': '84495',
			'Максима Горького им.': '84479',
			'Малая Ивановка': '84458',
			'Малые Чапурники': '84477',
			'Маяк Октября': '84478',
			'Мокрая Ольховка': '84455',
			'Нижние Коробки': '84455',
			'Нижние Черни': '84476',
			'Нижний Балыклей': '84495',
			'Нижний Чир': '84473',
			'Нижняя Добринка': '84454',
			'Новая Иванцовка': '84492',
			'Новая Квасниковка': '84493',
			'Новая Надежда': '84468',
			'Новая Паника': '84465',
			'Новая Полтавка': '84493',
			'Новый Быт': '84494',
			'Новый Рогачик': '84468',
			'Новый Тихонов': '84493',
			'Парижская Коммуна': '84465',
			'Петров Вал': '84457',
			'Пимено-Черни': '84476',
			'Плотников Второй': '84463',
			'Плотников Первый': '84461',
			'Погожья Балка': '84456',
			'Попов Второй': '84473',
			'Прямая Балка': '84458',
			'Путь Ильича': '84478',
			'Рог-Измайловский': '84447',
			'Русская Бундиевка': '84453',
			'Рюмино-Красноярский': '84472',
			'Светлый Лог': '84472',
			'Светлый Яр': '84477',
			'Серп и Молот': '84444',
			'Солдатско-Степное': '84495',
			'Средняя Ахтуба': '84479',
			'Старая Иванцовка': '84492',
			'Старая Полтавка': '84493',
			'Степана Разина им.': '84478',
			'Степано-Разинская': '84495',
			'Сухов Второй': '84463',
			'Третий Решающий': '84479',
			'Усть-Бузулукская': '84446',
			'Усть-Грязнуха': '84457',
			'Усть-Погожье': '84458',
			'Усть-Хоперская': '84464',
			'Чиганаки 2-е': '84462',
			'Ярской Первый': '84462',
			'станица Тепикинская': '84442',
			'хутор Петровский': '84442',
			Абганерово: '84475',
			Абрамов: '84463',
			Авилов: '84467',
			Ададурово: '84454',
			Аксай: '84475',
			Акчернский: '84442',
			Александровка: '84495',
			Алексеевская: '84446',
			Алексиковский: '84444',
			Алешкин: '84474',
			Алешники: '84454',
			Алонцево: '84445',
			Алявы: '84452',
			Амелино: '84465',
			Андреевка: '84454',
			Антиповка: '84457',
			Антонов: '84475',
			Аржановская: '84446',
			Арчединская: '84463',
			Атамановка: '84461',
			Бабинкино: '84452',
			Базки: '84464',
			Барановка: '84457',
			Басакин: '84474',
			Бахтияровка: '84478',
			Безымянка: '84463',
			Белокаменка: '84493',
			Беляевка: '84493',
			Бережновка: '84494',
			Березовка: '84452',
			Березовская: '84461',
			Береславка: '84472',
			Беспаловский: '84442',
			Бесплемяновский: '84442',
			Ближнеосиновский: '84473',
			Ближнеподгорский: '84473',
			Большевик: '84452',
			Большетерновой: '84474',
			Большой: '84463',
			Бородачи: '84454',
			Бочаровский: '84447',
			Бубновский: '84442',
			Бугровский: '84442',
			Бузиновка: '84472',
			Букановская: '84462',
			Булгурино: '84452',
			Булековский: '84442',
			Бурацкий: '84473',
			Бурковский: '84479',
			Бурлук: '84455',
			Бутырка: '84454',
			Быково: '84495',
			Валуевка: '84493',
			Васильевка: '84475',
			Венгеловский: '84492',
			Вербный: '84493',
			Вербовский: '84472',
			Вертячий: '84468',
			Верхнеаксеновский: '84473',
			Верхнебезымянский: '84442',
			Верхнегнутовский: '84474',
			Верхнекардаильский: '84444',
			Верхнеосиновский: '84473',
			Верхнепогромное: '84479',
			Верхнереченский: '84443',
			Верхнерубежный: '84475',
			Верхнесоинский: '84442',
			Верхнесолоновский: '84473',
			Верхнечеренский: '84466',
			Верхнечирский: '84473',
			Верхнеяблочный: '84476',
			Веселый: '84476',
			Ветютнев: '84465',
			Вилтов: '84467',
			Вихлянцево: '84457',
			Вихлянцевский: '84442',
			Вишневка: '84492',
			Вишневое: '84454',
			Вишняковский: '84442',
			Воднобуерачное: '84457',
			Водопьяново: '84452',
			Водянский: '84475',
			Волгоград: '8442',
			Волгодонской: '84472',
			Волжский: '8443',
			Волково: '84452',
			Волоцкий: '84474',
			Выпасной: '84476',
			Вязовка: '84452',
			Галка: '84457',
			Галкин: '84457',
			Галушкинский: '84447',
			Генераловский: '84476',
			Глазуновская: '84462',
			Гмелинка: '84493',
			Голубинский: '84472',
			Гончары: '84461',
			Горбатовский: '84464',
			Горин: '84461',
			Горноводяное: '84458',
			Городище: '84468',
			Горский: '84442',
			Госпитомник: '84479',
			Госселекстанция: '84457',
			Грачи: '84444',
			Гришин: '84445',
			Гришинский: '84462',
			Громки: '84453',
			Громославка: '84475',
			Грязнуха: '84461',
			Гуляевка: '84465',
			Гурово: '84456',
			Гусевка: '84456',
			Гуселка: '84457',
			Давыдовка: '84458',
			Даниловка: '84461',
			Дарганов: '84476',
			Двойновский: '84444',
			Дворянское: '84457',
			Демидов: '84495',
			Деминский: '84447',
			Денисовский: '84443',
			Динамо: '84443',
			Добринка: '84442',
			Долговский: '84442',
			Донской: '84472',
			Дорожкин: '84461',
			Дорофеевский: '84476',
			Дубовка: '84458',
			Дубовое: '84452',
			Дубовский: '84442',
			Дубровский: '84445',
			Дудаченский: '84465',
			Дуплятский: '84444',
			Дурновский: '84447',
			Дьяконовский: '84442',
			Ежовка: '84445',
			Еланский: '84462',
			Елань: '84452',
			Елкино: '84474',
			Ендовский: '84464',
			Ерзовка: '84468',
			Ершовка: '84454',
			Етеревская: '84463',
			Ефимовка: '84455',
			Жирковский: '84466',
			Жирновск: '844542',
			Жуковский: '84462',
			Журавка: '84452',
			Забурдяевский: '84442',
			Завязка: '84445',
			Закутский: '84479',
			Заливский: '84475',
			Заплавка: '84461',
			Заплавное: '84478',
			Заполянский: '84461',
			Заря: '84472',
			Затонский: '84464',
			Захаров: '84474',
			Захаровка: '84456',
			Захоперский: '84443',
			Зеленый: '84495',
			Зензеватка: '84456',
			Зимняцкий: '84464',
			Зимовский: '84465',
			Золотари: '84492',
			Ивановка: '84452',
			Ивановский: '84447',
			Иванушенский: '84466',
			Иловатка: '84493',
			Иловля: '84467',
			Ильевка: '84472',
			Ильмень: '84453',
			Исакиевский: '84446',
			Искра: '84442',
			Казарино: '84445',
			Кайсацкое: '84492',
			Калачевский: '84445',
			Калинино: '84493',
			Калиновский: '84445',
			Калмыковский: '84466',
			Каменка: '84444',
			Каменный: '84468',
			Каменский: '84443',
			Камыши: '84472',
			Камышин: '84457',
			Камышинский: '84467',
			Кано: '84493',
			Караваинка: '84458',
			Карагический: '84463',
			Караичевский: '84443',
			Карповка: '84468',
			Каршевитое: '84478',
			Катасонов: '84463',
			Катричев: '84495',
			Качалин: '84473',
			Качалино: '84467',
			Качалинская: '84467',
			Кепинский: '84464',
			Киквидзе: '84444',
			Киреево: '84456',
			Кислово: '84495',
			Кленовка: '84454',
			Клетская: '84466',
			Клетский: '84466',
			Ковалевка: '84475',
			Козловка: '84453',
			Колобовка: '84478',
			Колпачки: '84472',
			Колышкино: '84493',
			Коммунар: '84478',
			Комсомолец: '84494',
			Комсомольский: '84444',
			Кондраши: '84467',
			Коростино: '84455',
			Костарево: '84457',
			Котельников: '84476',
			Котельниково: '84476',
			Котлубань: '84468',
			Котово: '84455',
			Котовский: '84442',
			Краишево: '84452',
			Красноармейский: '84444',
			Красновский: '84443',
			Краснокоротковский: '84447',
			Краснопартизанский: '84477',
			Краснополов: '84462',
			Краснополье: '84443',
			Красноселец: '84495',
			Краснослободск: '84479',
			Красноталовский: '84452',
			Краснофлотский: '84477',
			Красноярский: '84474',
			Красный: '84442',
			Краснянский: '84442',
			Кременская: '84466',
			Крепинский: '84472',
			Креповский: '84442',
			Криушинский: '84442',
			Кругловка: '84443',
			Крутовский: '84464',
			Крячки: '84455',
			Кувшинов: '84461',
			Кузнецов: '84467',
			Кузнечинский: '84462',
			Кузьмичи: '84468',
			Куйбышев: '84479',
			Куликовский: '84444',
			Кулички: '84443',
			Кумылженская: '84462',
			Кумысолечебница: '84492',
			Купава: '84447',
			Купцово: '84455',
			Курнаевка: '84493',
			Лапшинская: '84455',
			Ларинский: '84446',
			Лебяжье: '84457',
			Левчуновка: '84494',
			Лемешкино: '84453',
			Ленинск: '84478',
			Ленинское: '84494',
			Лещев: '84478',
			Лиманный: '84492',
			Линево: '84454',
			Липовка: '84456',
			Лобакин: '84473',
			Лобачевский: '84443',
			Лобойково: '84461',
			Ловягин: '84461',
			Лог: '84467',
			Логовский: '84466',
			Лозное: '84458',
			Лопуховка: '84453',
			Лощиновский: '84442',
			Луговой: '84477',
			Луковская: '84443',
			Лысов: '84473',
			Лычак: '84465',
			Любишенский: '84462',
			Ляпичев: '84472',
			Лятошинка: '84493',
			Мазинский: '84443',
			Майоровский: '84476',
			Малодельская: '84465',
			Маляевка: '84478',
			Манойлин: '84466',
			Мариновка: '84472',
			Мартыновский: '84447',
			Матышево: '84453',
			Мачеха: '84445',
			Медведев: '84467',
			Медведица: '84454',
			Медведицкий: '84454',
			Меловатка: '84454',
			Мелоклетский: '84466',
			Мирный: '84454',
			Мирошники: '84455',
			Митькин: '84462',
			Миусово: '84461',
			Михайловка: '84463',
			Михайловская: '84442',
			Моисеево: '84455',
			Мордвинцево: '84445',
			Морец: '84452',
			Морозово: '84454',
			Морской: '84474',
			Мостовский: '84464',
			Моховский: '84463',
			Моховской: '84442',
			Нагавская: '84476',
			Нагольный: '84476',
			Нариман: '84477',
			Небыков: '84476',
			Недоступов: '84454',
			Нежинский: '84456',
			Нехаевский: '84443',
			Нижнеантошинский: '84442',
			Нижнегнутов: '84474',
			Нижнедолговский: '84443',
			Нижнекумский: '84475',
			Нижнеосиновский: '84473',
			Нижнеяблочный: '84476',
			Никитинский: '84462',
			Николаевка: '84452',
			Николаевск: '84494',
			Николаевский: '84444',
			Новинка: '84454',
			Новоаксайский: '84475',
			Новоалександровский: '84464',
			Новоаннинский: '84447',
			Новогригорьевская: '84467',
			Новодербеновский: '84473',
			Новокардаильский: '84444',
			Новокиевка: '84447',
			Новоляпичев: '84472',
			Новомаксимовский: '84473',
			Новониколаевка: '84455',
			Новониколаевский: '84444',
			Новоникольское: '84495',
			Новоромашкин: '84475',
			Новосельский: '84447',
			Новостройка: '84492',
			Новоцарицынский: '84466',
			Образцы: '84465',
			Озерки: '84445',
			Окладненский: '84442',
			Октябрьский: '84475',
			Оленье: '84458',
			Ольховка: '84456',
			Ольховский: '84442',
			Ольшанка: '84442',
			Орехово: '84461',
			Орловка: '84468',
			Орловский: '84444',
			Орлы: '84463',
			Орошаемый: '84494',
			Осички: '84453',
			Островская: '84461',
			Островский: '84473',
			Остроухов: '84462',
			Отрадное: '84463',
			Отрожки: '84464',
			Отруба: '84463',
			Очкуровка: '84494',
			Павловский: '84446',
			Палласовка: '84492',
			Панфилово: '84447',
			Паньшино: '84468',
			Пархоменко: '84472',
			Первомайский: '84442',
			Перегрузное: '84475',
			Перекопка: '84466',
			Перекопская: '84466',
			Перелазовский: '84466',
			Перещепное: '84455',
			Перфиловский: '84465',
			Песковатка: '84458',
			Песковка: '84454',
			Песчанка: '84467',
			Песчаный: '84464',
			Петровский: '84442',
			Петропавловка: '84458',
			Петрунино: '84457',
			Пионер: '84494',
			Писаревка: '84465',
			Пичуга: '84458',
			Племхоз: '84455',
			Победа: '84495',
			Подкуйково: '84453',
			Подольховский: '84464',
			Подчинный: '84454',
			Поклоновский: '84446',
			Покровка: '84478',
			Покручинский: '84462',
			Полевой: '84447',
			Политотдельское: '84494',
			Поперечный: '84476',
			Попов: '84474',
			Посевной: '84493',
			Посельский: '84464',
			Похлебин: '84476',
			Преображенская: '84445',
			Приволжский: '84477',
			Привольный: '84477',
			Приморск: '84495',
			Приморский: '84472',
			Пристеновский: '84474',
			Провоторовский: '84442',
			Пронин: '84464',
			Профсоюзник: '84461',
			Прудбой: '84472',
			Прудентов: '84492',
			Прудовый: '84477',
			Пугачевская: '84476',
			Пятиизбянский: '84472',
			Пятиморский: '84472',
			Равнинный: '84476',
			Раздольное: '84494',
			Раздоры: '84463',
			Райгород: '84477',
			Распопинская: '84466',
			Рассвет: '84478',
			Расстригин: '84445',
			Рахинка: '84479',
			Реконструкция: '84463',
			Реченский: '84446',
			Рогачев: '84447',
			Рогожин: '84463',
			Родинское: '84452',
			Родионовский: '84462',
			Роднички: '84443',
			Розовский: '84442',
			Романов: '84455',
			Романовка: '84456',
			Ромашки: '84492',
			Россошинский: '84442',
			Рубежный: '84465',
			Рудня: '84453',
			Рыбинка: '84456',
			Рыбный: '84464',
			Рябовский: '84446',
			Савинка: '84492',
			Савинский: '84473',
			Садки: '84458',
			Садовое: '84495',
			Садовый: '84453',
			Саломатин: '84447',
			Саломатино: '84462',
			Салтово: '84493',
			Салтынский: '84442',
			Самолшинский: '84446',
			Самофаловка: '84468',
			Самохино: '84475',
			Сарычевский: '84462',
			Себрово: '84463',
			Северный: '84477',
			Седов: '84462',
			Секачи: '84463',
			Селиванов: '84466',
			Семеновка: '84457',
			Семичный: '84476',
			Сенной: '84463',
			Серафимович: '84464',
			Сергиевская: '84461',
			Серогодский: '84492',
			Сидоры: '84463',
			Сизов: '84474',
			Синяпкинский: '84473',
			Сиротинская: '84467',
			Скулябинский: '84446',
			Скуришенская: '84462',
			Слащевская: '84462',
			Слюсарево: '84455',
			Смородино: '84455',
			Советский: '84475',
			Соколовский: '84443',
			Солодовка: '84478',
			Солодушино: '84494',
			Солодча: '84456',
			Солонка: '84443',
			Солонцовский: '84446',
			Солянка: '84477',
			Сосновка: '84453',
			Среднецарицынский: '84464',
			Староаннинская: '84447',
			Старогригорьевская: '84467',
			Староселье: '84463',
			Старосенюткин: '84464',
			Стеженский: '84446',
			Степаневка: '84472',
			Степновский: '84494',
			Степной: '84478',
			Столяров: '84495',
			Страхов: '84445',
			Стрельноширокое: '84458',
			Субботин: '84463',
			Суводская: '84458',
			Суворовская: '84473',
			Суляевский: '84462',
			Суровикино: '84473',
			Суровкино: '84473',
			Суходол: '84479',
			Сысоевский: '84473',
			Сычевский: '84442',
			Таловка: '84452',
			Тарапатино: '84454',
			Тарасово: '84455',
			Тепикинская: '84442',
			Теркин: '84464',
			Терновка: '84465',
			Терновое: '84452',
			Терса: '84452',
			Тетеревятка: '84454',
			Титовский: '84446',
			Тихий: '84475',
			Тихоновка: '84472',
			Тишанская: '84443',
			Торгунский: '84494',
			Тормосин: '84474',
			Торяное: '84452',
			Тракторострой: '84478',
			Трехложинский: '84446',
			Трехостровская: '84467',
			Троецкий: '84447',
			Троицкий: '84463',
			Тростянка: '84452',
			Тростянский: '84447',
			Трудолюбие: '84477',
			Трясиновский: '84464',
			Тушкановский: '84443',
			Умет: '84457',
			Упорниковский: '84443',
			Урюпинск: '84442',
			Успенка: '84443',
			Ушинка: '84453',
			Фастов: '84467',
			Федосеевская: '84462',
			Филин: '84462',
			Филоновская: '84447',
			Фоминский: '84444',
			Фомихинский: '84464',
			Фролов: '84463',
			Фролово: '84465',
			Харьковка: '84493',
			Хвощинка: '84452',
			Хмелевской: '84467',
			Хованский: '84464',
			Хоперский: '84444',
			Хорошенский: '84443',
			Хохлачев: '84464',
			Царев: '84478',
			Цаца: '84477',
			Чапурники: '84477',
			Чеботаревский: '84464',
			Червленое: '84477',
			Черебаево: '84493',
			Черкесовский: '84447',
			Чернозубовка: '84467',
			Чернолагутинский: '84445',
			Черноморовский: '84475',
			Чернышковский: '84474',
			Чиганаки: '84476',
			Чулинский: '84444',
			Чухонастовка: '84457',
			Шакин: '84462',
			Шарашенский: '84446',
			Шебалино: '84475',
			Шелестово: '84475',
			Ширяевская: '84467',
			Шохинский: '84467',
			Шуруповский: '84465',
			Щучий: '84479',
			Эльтон: '84492',
			Ягодное: '84456',
			Яминский: '84446',
			Ярыженская: '84447'
		}
	},
	'Вологодская область': {
		regionCode: ['817', '820'],
		cities: {
			'Андомский Погост': '81746',
			'Анненский Мост': '81746',
			'Б.Гора': '81740',
			'Бабушкина им.': '81745',
			'Бекетово-Лесоучасток': '81744',
			'Белый Ручей': '81756',
			'Березовая Гора': '81740',
			'Большая Слободка': '81754',
			'Большая Ягница': '8202',
			'Большие Новишки': '81756',
			'Большое Сверчково': '81754',
			'Борисово-Судское': '81743',
			'Великий Двор': '81739',
			'Великий Устюг': '81738',
			'Верхнее Анисимово': '81738',
			'Верхний Енангск': '81740',
			'Верхняя Ентала': '81740',
			'Волоков Мост': '81746',
			'Воскресенское-на-Мусоре': '8202',
			'Данилов Починок': '81739',
			'Даньшин Ручей': '81758',
			'Желябова им.': '81737',
			'Иванов Бор': '81757',
			'Карл Либкнехт': '81756',
			'Кичменгский Городок': '81740',
			'Климшин Бор': '81756',
			'Красавино-деревня': '81738',
			'Красный Бор': '81739',
			'Крутая Осыпь': '81739',
			'Крутой Ручей': '81752',
			'Липин Бор': '81758',
			'Малая Рукавицкая': '81742',
			'Малое Борисово': '81743',
			'Нижний Енангск': '81740',
			'Нижняя Ентала': '81740',
			'Нижняя Мондома': '81756',
			'Нижняя Ножема': '81743',
			'Никола-Корень': '81753',
			'Николо-Раменье': '8202',
			'Никольский Торжок': '81757',
			'Новое Лукино': '81743',
			'Новый Источник': '8172',
			'Погост-Никольский': '81753',
			'Северная Ферма': '8172',
			'Село им. Бабушкина': '81745',
			'Спасс-Ямщики': '81749',
			'Старое Село': '81756',
			'Судническая Гора': '81740',
			'Тарногский Городок': '81748',
			'Тиманова Гора': '81745',
			'Усть-Алексеево': '81738',
			'Усть-Кубенское': '81753',
			'Усть-Печенегское': '81739',
			'Усть-Река': '81752',
			'Усть-Харюзово': '81740',
			'Фан-Завод': '81742',
			'Чистый Дор': '81757',
			'Ясная Поляна': '8202',
			'м. Пустынь': '81747',
			'о. Каменный': '81754',
			'село Ферапонтово': '81757',
			Абаканово: '8202',
			Аббакумовская: '81748',
			Айга: '81748',
			Акишево: '81743',
			Аксеново: '8202',
			Аксентьево: '81754',
			Александровская: '81743',
			Алферово: '81740',
			Андогский: '8202',
			Андроново: '81742',
			Аниково: '81745',
			Анисимово: '81741',
			Анохино: '81755',
			Антоново: '8172',
			Антушево: '81756',
			Аргуново: '81754',
			Арзубиха: '81732',
			Аристово: '81738',
			Артюшино: '81756',
			Архангельское: '8202',
			Асташкино: '81737',
			Афанасьевская: '81748',
			Бабаево: '81743',
			Байдарово: '81754',
			Барановская: '81742',
			Батран: '8202',
			Башевская: '81748',
			Бекетовская: '81744',
			Белозерск: '81756',
			Белоусово: '81746',
			Бережное: '81753',
			Березник: '8172',
			Берсенево: '81740',
			Беседное: '8172',
			Бечевинка: '81756',
			Биряково: '81733',
			Благовещенье: '81757',
			Бобровниково: '81738',
			Бобровское: '81747',
			Богородское: '81753',
			Бойлово: '81742',
			Большедворское: '8202',
			Бонга: '81758',
			Борбушино: '81757',
			Борисово: '81741',
			Борок: '81754',
			Ботово: '8202',
			Брилино: '81737',
			Брусенец: '81747',
			Брусная: '81747',
			Будрино: '81738',
			Бураково: '81757',
			Бурцево: '8202',
			Бушуиха: '81755',
			Ванское: '81737',
			Вараксино: '81755',
			Васильево: '81745',
			Васильевское: '8172',
			Вахнево: '81754',
			Вахонькино: '81742',
			Великодворская: '81759',
			Великое: '81742',
			Веницы: '81737',
			Вертягино: '81742',
			Верхневольский: '81743',
			Верховажье: '81759',
			Верховино: '81754',
			Верховье: '81748',
			Визьма: '81756',
			Вогнема: '81757',
			Вожега: '81744',
			Вологда: '8172',
			Володино: '81743',
			Володинская: '81748',
			Воробьево: '81733',
			Воскресенское: '8202',
			Вострое: '81747',
			Вотча: '8172',
			Вохтога: '81755',
			Вощар: '81748',
			Врагово: '81749',
			Высокинский: '81754',
			Высокое: '81753',
			Вытегра: '81746',
			Гаврилково: '81749',
			Георгиевское: '81756',
			Глухарево: '81757',
			Глушково: '81756',
			Голузино: '81752',
			Гончарка: '8172',
			Гора: '81757',
			Горбачево: '81738',
			Горицы: '81757',
			Горка: '81751',
			Городишна: '81747',
			Гремячий: '81752',
			Грибково: '8172',
			Грибцово: '81733',
			Григорьевская: '81743',
			Гридино: '81744',
			Грязовец: '81755',
			Данилово: '81740',
			Даниловское: '81737',
			Девятины: '81746',
			Демьяново: '81755',
			Депо: '81746',
			Деревенька: '81744',
			Дермянинское: '8202',
			Дикая: '8172',
			Дмитриево: '8202',
			Долоцкое: '81737',
			Дора: '8202',
			Дубровка: '81743',
			Дуброво: '8202',
			Дубровское: '8172',
			Дуниловский: '81754',
			Елисеевская: '81759',
			Еловино: '81740',
			Емельяновская: '81756',
			Енино: '81756',
			Еремеево: '81751',
			Ереминское: '81759',
			Ермаково: '8172',
			Ершово: '81751',
			Жерноково: '81755',
			Житьево: '81752',
			Жубрино: '81745',
			Заводское: '81753',
			Завражье: '81754',
			Заемье: '81755',
			Займище: '81754',
			Зайчики: '81745',
			Залесье: '81737',
			Замошье: '81756',
			Заречье: '81748',
			Захарово: '81740',
			Захарьино: '81746',
			Заэрап: '81742',
			Зеленцово: '81754',
			Золотава: '81732',
			Зубово: '81756',
			Ивановское: '8202',
			Ивачино: '81732',
			Игмас: '81747',
			Игнатово: '81746',
			Игумницево: '81749',
			Ида: '81755',
			Избоищи: '81741',
			Ильинское: '81738',
			Ирдоматка: '8202',
			Исады: '81740',
			Исаково: '81744',
			Истоминская: '81752',
			Истопный: '81755',
			Кадников: '81733',
			Кадниковский: '81744',
			Кадуй: '81742',
			Калинино: '81754',
			Каменка: '81755',
			Камешник: '81751',
			Камчуга: '81739',
			Карасово: '81738',
			Карица: '81755',
			Карпово: '81756',
			Карюг: '81740',
			Кипелово: '8172',
			Кириллов: '81757',
			Климовское: '8202',
			Климушино: '81759',
			Кобыльск: '81740',
			Коварзино: '81757',
			Кожаево: '81754',
			Кожухово: '81749',
			Козлово: '81744',
			Кокшарка: '81745',
			Колкач: '81757',
			Колошма: '81743',
			Комсомольский: '81745',
			Кондуши: '81746',
			Кононово: '81758',
			Кононовская: '81752',
			Конторка: '81748',
			Копосово: '81742',
			Копылово: '81752',
			Коробицыно: '81752',
			Коровино: '81756',
			Королиха: '81753',
			Коростелево: '81752',
			Коротецкая: '81757',
			Коротковская: '81744',
			Коротово: '8202',
			Косиково: '81745',
			Косково: '81740',
			Костеньково: '81743',
			Костино: '81756',
			Коштуги: '81746',
			Красавино: '81747',
			Красное: '81739',
			Красота: '81745',
			Крестцы: '81737',
			Кривец: '8202',
			Круглицы: '81737',
			Крутец: '81745',
			Кубенское: '8172',
			Кувшиново: '81733',
			Куданга: '81754',
			Кудринская: '81739',
			Кузино: '81738',
			Куколовская: '81759',
			Кукшево: '81756',
			Кулибарово: '81745',
			Куляшиха: '81732',
			Кумзеро: '81732',
			Кунож: '81745',
			Куность: '81756',
			Курилово: '8202',
			Куркино: '8172',
			Лаптюг: '81740',
			Леваш: '81747',
			Лежа: '81755',
			Лентьево: '81737',
			Леоново: '81751',
			Лесково: '8172',
			Лесютино: '81747',
			Леушинская: '81759',
			Литега: '81733',
			Логдуз: '81745',
			Лодейка: '81738',
			Ломоватка: '81738',
			Лоста: '8172',
			Лукинское: '81741',
			Лукьяновская: '81744',
			Любомирово: '81751',
			Маза: '81742',
			Майский: '8172',
			Макарово: '8172',
			Макарцево: '81759',
			Макачево: '81746',
			Малеево: '81758',
			Малечкино: '8202',
			Марково: '81754',
			Марковская: '81753',
			Марковское: '81733',
			Марыгино: '81742',
			Марьинская: '81744',
			Матвеево: '81739',
			Маэкса: '81756',
			Мегра: '81746',
			Мегрино: '81741',
			Мегринский: '81756',
			Медведево: '81739',
			Межозерье: '81746',
			Мережа: '81737',
			Минькино: '81755',
			Миньково: '81745',
			Мирный: '81746',
			Митенское: '81753',
			Митино: '81746',
			Михайловка: '81739',
			Михайловская: '81744',
			Михайловское: '81732',
			Мишутинская: '81744',
			Модно: '81737',
			Можайское: '8172',
			Молодежный: '81754',
			Молочное: '8172',
			Морино: '8172',
			Морозовица: '81738',
			Морозово: '81759',
			Мосеево: '81739',
			Мочала: '81737',
			Мынчаково: '8172',
			Мякиницыно: '81738',
			Мякса: '8202',
			Надеево: '8172',
			Надпорожье: '8202',
			Наумовская: '81748',
			Нелазское: '8202',
			Непотягово: '8172',
			Нестерово: '81733',
			Нестеровское: '8202',
			Нефедово: '8172',
			Нефедьево: '81757',
			Нигино: '81754',
			Нижнекубенский: '81732',
			Нижние: '81742',
			Низ: '81741',
			Никола: '81737',
			Никольск: '81754',
			Никольское: '81732',
			Нифантово: '81751',
			Новатор: '81738',
			Новая: '81749',
			Новленское: '8172',
			Новое: '81753',
			Новокемский: '81758',
			Новоселово: '81738',
			Новостройка: '81757',
			Ногинская: '81759',
			Норобово: '8172',
			Нюксеница: '81747',
			Обросово: '81733',
			Огарково: '8172',
			Огибалово: '81744',
			Озеро: '81746',
			Октябрьский: '81746',
			Окуловская: '81748',
			Оларево: '81733',
			Олеховская: '81744',
			Омогаево: '8172',
			Орлово: '81756',
			Осиново: '81754',
			Останинская: '81758',
			Остахово: '8172',
			Осташево: '81759',
			Ошта: '81746',
			Павшозеро: '81746',
			Палема: '81738',
			Палтога: '81746',
			Панинская: '81756',
			Панкратово: '81746',
			Парфеново: '81758',
			Паунинское: '81748',
			Пача: '81751',
			Пеганово: '81738',
			Пежма: '81759',
			Пеньково: '81757',
			Первомайский: '81739',
			Первомайское: '81738',
			Пермас: '81754',
			Перьево: '8172',
			Песье: '8202',
			Петровское: '81757',
			Петряево: '8202',
			Петухово: '81745',
			Пигилинская: '81752',
			Пиксимово: '81758',
			Пионерский: '81749',
			Пихтово: '81738',
			Пленишник: '8202',
			Плесо: '81743',
			Плосково: '8202',
			Плоское: '81755',
			Погорелово: '8172',
			Подволочье: '81740',
			Подгородье: '81740',
			Пожара: '81743',
			Пожарово: '81738',
			Покровское: '81755',
			Полдарса: '81738',
			Полежаево: '81754',
			Половина: '81754',
			Полутово: '81738',
			Понизовье: '81737',
			Поповка: '8202',
			Порохово: '81753',
			Постниково: '81742',
			Потуловская: '81759',
			Починок: '8202',
			Прилуки: '8172',
			Прокунино: '8172',
			Пундуга: '81732',
			Пяжелка: '81743',
			Раменье: '81748',
			Рандач: '81757',
			Расторопово: '81737',
			Ратновская: '81732',
			Рогна: '81759',
			Романово: '8202',
			Ромашево: '81748',
			Рослятино: '81745',
			Ростилово: '81755',
			Русино: '81757',
			Сазоново: '81741',
			Самино: '81746',
			Санинская: '81743',
			Сараево: '81740',
			Светица: '81740',
			Святогорье: '81749',
			Северный: '81746',
			Селище: '81742',
			Семениха: '81732',
			Семенково: '8172',
			Семигородняя: '81732',
			Сергиевская: '81748',
			Середская: '81739',
			Сигово: '81757',
			Сидорово: '81755',
			Сизьма: '81751',
			Сиуч: '81743',
			Скородумка: '81755',
			Славынево: '81737',
			Слизово: '81751',
			Слобода: '81759',
			Слободка: '81740',
			Слудно: '81743',
			Смердомский: '81741',
			Сметанино: '81759',
			Смородинка: '81743',
			Соболево: '8202',
			Советский: '81739',
			Согорки: '81732',
			Сокол: '81733',
			Сорожино: '81732',
			Сорокополье: '81746',
			Сосновица: '81744',
			Сосновка: '8172',
			Спасское: '81737',
			Средняя: '81759',
			Стан: '81742',
			Старое: '81749',
			Степачево: '81737',
			Степурино: '81755',
			Столбиха: '81744',
			Стрига: '81738',
			Суда: '8202',
			Сурково: '8202',
			Сусоловка: '81738',
			Суховерково: '81757',
			Сычево: '8172',
			Сямжа: '81752',
			Талица: '81745',
			Талицы: '81757',
			Теплогорье: '81738',
			Теребаево: '81754',
			Тимошино: '81743',
			Тимошкино: '81743',
			Томашево: '81738',
			Томашка: '81732',
			Тоншалово: '8202',
			Топорня: '81757',
			Тотьма: '81739',
			Троицкое: '81758',
			Туровец: '81749',
			Тюприха: '81748',
			Угрюмово: '8202',
			Ужла: '81746',
			Уйта: '81742',
			Урусовская: '81759',
			Успенское: '81742',
			Устье: '81753',
			Устюжна: '81737',
			Уткино: '8172',
			Ухтанга: '81739',
			Ухтома: '81758',
			Федоровская: '81756',
			Федотово: '8172',
			Феклуха: '81759',
			Ферапонтово: '81757',
			Филинская: '81752',
			Фоминское: '81751',
			Фофанцево: '8172',
			Фрол: '81755',
			Харламовская: '8202',
			Харовск: '81732',
			Хмелевое: '8202',
			Хорошево: '81755',
			Хохлово: '81742',
			Царева: '81739',
			Ципелево: '81742',
			Чагода: '81741',
			Чаево: '8202',
			Чарозеро: '81757',
			Чаромское: '81751',
			Чебсара: '81751',
			Чекшино: '81733',
			Череповец: '8202',
			Чернево: '81738',
			Чернеево: '81751',
			Чертеж: '81758',
			Чистиково: '81743',
			Чубрино: '81743',
			Чуровское: '81751',
			Чучково: '81733',
			Чушевицы: '81759',
			Шайма: '8202',
			Шалимово: '8202',
			Шапша: '81732',
			Шарженга: '81754',
			Шатенево: '81740',
			Шебеньга: '81748',
			Шейбухта: '81749',
			Шексна: '81751',
			Шелота: '81759',
			Шера: '81733',
			Шестаково: '81740',
			Шигоево: '81751',
			Ширега: '81752',
			Шиченга: '81749',
			Шишовка: '8202',
			Шолохово: '8172',
			Шонга: '81740',
			Шуйское: '81749',
			Шулма: '8202',
			Шухободь: '8202',
			Шухтово: '8202',
			Щекино: '81738',
			Щетинское: '8202',
			Юбилейный: '81739',
			Югский: '81740',
			Юношеское: '81755',
			Юрино: '81756',
			Юрово: '81755',
			Юрочкино: '81751',
			Ючка: '81744',
			Юшково: '81747',
			Явенга: '81744',
			Яганово: '8202',
			Яковлевское: '81737',
			Якшино: '81746',
			Янгосарь: '8172',
			Янишево: '81746',
			Ярцево: '81737',
			Яхренга: '81744'
		}
	},
	'Воронежская область': {
		regionCode: '473',
		cities: {
			'Александровка-Донская': '47362',
			'Алое Поле': '47344',
			'Байчуровский Совхоз': '47376',
			'Битюг-Матреновка': '47345',
			'Ближняя Полубянка': '47375',
			'Большая Алексеевка': '47346',
			'Большая Верейка': '47340',
			'Большая Дмитриевка': '47394',
			'Большая Добринка': '47345',
			'Большая Казинка': '47362',
			'Большая Приваловка': '47343',
			'Большая Хвощеватка': '47394',
			'Большие Алабухи': '47348',
			'Большие Базы': '47395',
			'Большие Ясырки': '47344',
			'Большой Мартын': '47344',
			'Большой Самовец': '47345',
			'Большой Скорорыб': '47394',
			'Борщевские Пески': '47345',
			'Бугаевка-Вторая': '47367',
			'Васильевка-Вторая': '47343',
			'Васильевка-Первая': '47343',
			'Верхнее Турово': '47370',
			'Верхние Марки': '47357',
			'Верхний Бык': '47356',
			'Верхний Икорец': '47350',
			'Верхний Карабут': '47394',
			'Верхний Карачан': '47348',
			'Верхний Мамон': '47355',
			'Верхняя Байгора': '47343',
			'Верхняя Катуховка': '47344',
			'Верхняя Луговатка': '47343',
			'Верхняя Маза': '47343',
			'Верхняя Плавица': '47343',
			'Верхняя Тишанка': '47352',
			'Верхняя Тойда': '47346',
			'Верхняя Хава': '47343',
			'Голубая Криница': '47396',
			'Горенские Выселки': '47341',
			'Гремячий Колодезь': '47372',
			'Дальняя Полубянка': '47375',
			'Дивногорье-Санаторий': '47391',
			'Елань-Колено': '47353',
			'Елань-Коленовский': '47353',
			'Еманча-Вторая': '47371',
			'Емача-Первая': '47371',
			'Ивановка-Первая': '47344',
			'Казанская Хава': '47341',
			'Каменка-Садовка': '47353',
			'Каменно-Верховка': '47342',
			'Колос Совхоз': '47363',
			'Копаная-Вторая': '47395',
			'Костино-Отделец': '47347',
			'Красные Холмы': '47344',
			'Красный Лиман': '47344',
			'Кривая Поляна': '47375',
			'Кучугуровский Совхоз': '47370',
			'Лебедь-Сергеевка': '47396',
			'Левая Россошь': '47342',
			'Малая Верейка': '47372',
			'Малая Грибановка': '47348',
			'Малая Покровка': '47372',
			'Малая Приваловка': '47343',
			'Малые Алабухи-Вторые': '47348',
			'Малые Алабухи-Первые': '47348',
			'Малый Самовец': '47343',
			'Масловский-Совхоз': '47341',
			'Маяк Совхоз': '47365',
			'Михайловка-Вторая': '47344',
			'Михайловка-Первая': '47344',
			'Михайловский-Совхоз': '47344',
			'Нижнее Турово': '47370',
			'Нижний Бык': '47356',
			'Нижний Икорец': '47391',
			'Нижний Карабут': '47396',
			'Нижний Карачан': '47348',
			'Нижний Кисляй': '47361',
			'Нижний Мамон': '47355',
			'Нижний Ольшан': '47375',
			'Нижняя Байгора': '47343',
			'Нижняя Ведуга': '47372',
			'Нижняя Каменка': '47352',
			'Нижняя Катуховка': '47341',
			'Нижняя Маза': '47343',
			'Николо-Варваринка': '47350',
			'Никольское-Второе': '47350',
			'Никольское-на-Еманче': '47371',
			'Новая Жизнь': '47346',
			'Новая Калитва': '47396',
			'Новая Криуша': '47363',
			'Новая Мельница': '47375',
			'Новая Ольшанка': '47370',
			'Новая Осиновка': '47375',
			'Новая Усмань': '47341',
			'Новая Чигла': '47352',
			'Новоусманский Совхоз': '47341',
			'Новый Буравль': '47350',
			'Новый Курлак': '47346',
			'Новый Лиман': '47365',
			'Олень-Колодезь': '47342',
			'Ольхов Лог': '47357',
			'Опыт Совхоз': '47394',
			'Опытная Станция': '47371',
			'Орлов Лог': '47372',
			'Парижская Коммуна': '47343',
			'Перво-Эртиль': '47345',
			'Правая Хава': '47343',
			'Пробуждение-Совхоз': '47394',
			'Родина Героя': '47395',
			'Рождественская Хава': '47341',
			'Русская Буйловка': '47362',
			'Русская Гвоздевка': '47340',
			'Русская Журавка': '47355',
			'Русская Тростянка': '47375',
			'Селявное Второе': '47391',
			'Семено-Александровка': '47350',
			'Синие Липяги': '47370',
			'Скупая Потудань': '47370',
			'Средний Икорец': '47391',
			'Средний Карачан': '47348',
			'Старая Ведуга': '47372',
			'Старая Калитва': '47396',
			'Старая Криуша': '47365',
			'Старая Ольшанка': '47372',
			'Старая Тойда': '47346',
			'Старая Хворостань': '47391',
			'Старая Чигла': '47346',
			'Старокриушанский Совхоз': '47365',
			'Старый Курлак': '47346',
			'Степной Совхоз': '47342',
			'Сторожевое-Второе': '47391',
			'Сторожевое-Первое': '47375',
			'Суд-Николаевка': '47394',
			'Сухая Березовка': '47350',
			'Сухая Россошь': '47394',
			'Сухие Гаи': '47343',
			'Сухой Донец': '47366',
			'Тихая Сосна': '47375',
			'Труд Совхоз': '47365',
			'Ударник Совхоз': '47361',
			'Урыв-Покровка': '47375',
			'Усманские Выселки': '47344',
			'Усть-Муравлянка': '47374',
			'Хохол-Тростянка': '47375',
			'Черноземный Совхоз': '47363',
			'Чистая Поляна': '47340',
			'Шанино-Второе': '47352',
			'Шанино-Первое': '47352',
			'Шкурлат Третий': '47362',
			'Щучинские Пески': '47345',
			'Южный Совхоз': '47366',
			'село Россошь': '47396',
			Абрамовка: '47352',
			Абросимово: '47366',
			Айдарово: '47340',
			Алейниково: '47396',
			Александровка: '47362',
			Алексеевка: '47348',
			Алешки: '47347',
			Алферовка: '47353',
			Андриановка: '47395',
			Андрюшевка: '47367',
			Анна: '47346',
			Анновка: '47350',
			Анохинка: '47352',
			Аношкино: '47391',
			Артюшкино: '47346',
			Архиповка: '47396',
			Бабино: '47347',
			Бабка: '47362',
			Бабяково: '47341',
			Байчурово: '47376',
			Банное: '47356',
			Басовка: '47394',
			Белогорье: '47394',
			Березки: '47362',
			Березняги: '47365',
			Березовка: '47346',
			Бирюч: '47352',
			Бобров: '47350',
			Богана: '47354',
			Богословка: '47343',
			Богучар: '47366',
			Бодеевка: '47391',
			Боево: '47342',
			Болдыревка: '47375',
			Бондарево: '47367',
			Бор: '47340',
			Борисоглебск: '47354',
			Бороздиновский: '47353',
			Борщево: '47344',
			Борщово: '47371',
			Братки: '47347',
			Бродовое: '47346',
			Буравлянка: '47340',
			Буравцовка: '47345',
			Бурляевка: '47353',
			Бутурлиновка: '47361',
			Бутырки: '47374',
			Бычок: '47365',
			Вакуловка: '47396',
			Валентиновка: '47367',
			Варварино: '47353',
			Варваровка: '47366',
			Васильевка: '47346',
			Великоархангельское: '47361',
			Веретье: '47375',
			Верхненикольское: '47371',
			Верхнеозерский: '47352',
			Верхнетолучеево: '47356',
			Витебск: '47394',
			Вихляевка: '47376',
			Владимировка: '47391',
			Власовка: '47348',
			Вознесенка: '47372',
			Вознесеновка: '47352',
			Вознесенский: '47352',
			Возрождение: '47345',
			Волоконовка: '47367',
			Волошино: '47375',
			Волчанское: '47357',
			Воля: '47341',
			Воробьевка: '47356',
			Воронеж: '4732',
			Воронцовка: '47362',
			Восход: '47345',
			Вязковка: '47345',
			Вязноватовка: '47370',
			Вязовка: '47352',
			Гаврильск: '47362',
			Галиевка: '47366',
			Гвазда: '47361',
			Георгиевка: '47344',
			Глазово: '47370',
			Глубокое: '47365',
			Гнилое: '47375',
			Гнилуша: '47372',
			Голосновка: '47372',
			Гончаровка: '47394',
			Горелка: '47354',
			Горки: '47341',
			Горожанка: '47340',
			Гороховка: '47355',
			Грань: '47362',
			Гремячье: '47371',
			Грибановский: '47348',
			Григорьевка: '47394',
			Грушовое: '47366',
			Губарево: '47372',
			Губари: '47354',
			Гусевка: '47346',
			Давыдовка: '47391',
			Данило: '47362',
			Данково: '47342',
			Данцевка: '47366',
			Девица: '47372',
			Дегтярное: '47357',
			Дерезовка: '47355',
			Дерябкино: '47346',
			Дивногорье: '47391',
			Дмитриевка: '47361',
			Дмитриевский: '47370',
			Добрино: '47391',
			Долгое: '47372',
			Должик: '47375',
			Долина: '47347',
			Дракино: '47391',
			Дроздово: '47395',
			Дружба: '47370',
			Дубовиково: '47366',
			Дубровка: '47347',
			Дьяченково: '47366',
			Евдаково: '47357',
			Евдокиевка: '47367',
			Евстратовка: '47396',
			Еланка: '47352',
			Еланский: '47353',
			Еленовка: '47396',
			Елизаветино: '47361',
			Елизаветовка: '47362',
			Ендовище: '47372',
			Ермоловка: '47391',
			Ерышевка: '47362',
			Есипово: '47347',
			Желанное: '47346',
			Жилино: '47396',
			Журавка: '47367',
			Заболотовка: '47395',
			Зайцевка: '47367',
			Залесный: '47363',
			Залиман: '47366',
			Залужное: '47391',
			Замельничный: '47353',
			Замостье: '47365',
			Запрудское: '47342',
			Заречное: '47361',
			Заречье: '47347',
			Затон: '47356',
			Зеленый: '47361',
			Землянск: '47372',
			Избище: '47372',
			Ильинка: '47363',
			Ильмень: '47376',
			Индычий: '47365',
			Истобное: '47374',
			Каверье: '47340',
			Казанка: '47352',
			Казинка: '47372',
			Калач: '47363',
			Калиново: '47348',
			Калмычек: '47344',
			Каменка: '47357',
			Каменск: '47362',
			Кантемировка: '47367',
			Каразеево: '47366',
			Карайчевка: '47361',
			Карачун: '47340',
			Караяшник: '47395',
			Кардаиловка: '47376',
			Карпенково: '47357',
			Касьяновка: '47367',
			Каширское: '47342',
			Квашино: '47356',
			Кирсановка: '47348',
			Кисельное: '47347',
			Клеповка: '47361',
			Князево: '47340',
			Ковалево: '47391',
			Коваленковский: '47367',
			Коденцово: '47357',
			Козловский: '47352',
			Кокаревка: '47396',
			Колбино: '47374',
			Колбинское: '47396',
			Колещатовка: '47367',
			Колодежное: '47394',
			Колодезный: '47342',
			Коломыцево: '47391',
			Колыбелка: '47391',
			Коминтерн: '47352',
			Кондрашевка: '47372',
			Кондрашкино: '47342',
			Копанище: '47391',
			Копанки: '47396',
			Копыл: '47345',
			Коренное: '47363',
			Корнеевка: '47374',
			Коротояк: '47375',
			Коршево: '47350',
			Костенки: '47371',
			Костово: '47395',
			Костомарово: '47394',
			Кочетовка: '47371',
			Кравцово: '47366',
			Красноармейский: '47345',
			Красногоровка: '47366',
			Краснолипье: '47374',
			Краснополье: '47356',
			Краснореченка: '47348',
			Красноселовка: '47365',
			Краснофлотское: '47365',
			Красный: '47350',
			Красовка: '47348',
			Кривоборье: '47340',
			Кривоносово: '47396',
			Криничное: '47396',
			Криуша: '47344',
			Круглое: '47342',
			Круглоподпольное: '47346',
			Крыловка: '47341',
			Кузнецовский: '47367',
			Купянка: '47366',
			Курбатово: '47370',
			Кутки: '47348',
			Кучеряевка: '47361',
			Кучугуры: '47370',
			Лавровка: '47348',
			Латная: '47372',
			Латное: '47372',
			Лебединка: '47366',
			Лебяжье: '47340',
			Левашовка: '47346',
			Ленинский: '47353',
			Лесково: '47363',
			Лещаное: '47356',
			Ливенка: '47362',
			Лизиновка: '47396',
			Лимарев: '47395',
			Липовка: '47350',
			Липчанка: '47366',
			Липяги: '47347',
			Лиски: '47391',
			Листопадовка: '47348',
			Лозовое: '47355',
			Ломово: '47340',
			Лопатки: '47340',
			Лофицкое: '47366',
			Лощина: '47396',
			Луговое: '47366',
			Луки: '47375',
			Луначаровка: '47347',
			Лыково: '47394',
			Мазурка: '47376',
			Макарье: '47341',
			Макашевка: '47354',
			Мамоновка: '47355',
			Манино: '47363',
			Марки: '47357',
			Марченковка: '47395',
			Масловка: '47391',
			Мастюгино: '47375',
			Махровка: '47354',
			Медвежье: '47372',
			Медово: '47366',
			Меловатка: '47372',
			Мечетка: '47350',
			Миролюбие: '47354',
			Митрофановка: '47367',
			Михайловский: '47353',
			Михинский: '47352',
			Михнево: '47370',
			Можайское: '47342',
			Монастырщина: '47366',
			Мосальское: '47342',
			Мосоловка: '47346',
			Моховое: '47346',
			Мужичье: '47356',
			Назаровка: '47395',
			Народное: '47347',
			Начало: '47396',
			Нащекино: '47346',
			Некрылово: '47353',
			Нелжа: '47340',
			Неровновка: '47395',
			Нескучный: '47350',
			Нижнедевицк: '47370',
			Нижнемарьино: '47391',
			Никитская: '47347',
			Никольский: '47345',
			Никоново: '47343',
			Новенький: '47352',
			Новобелая: '47367',
			Новобогородицкое: '47365',
			Нововоронеж: '47364',
			Нововоронежский: '47364',
			Нововоскресеновка: '47354',
			Новогольелань: '47348',
			Новогольское: '47348',
			Новогремяченское: '47371',
			Новоживотинное: '47340',
			Новоильменский: '47353',
			Новокараяшник: '47395',
			Новокирсановка: '47347',
			Новомакарово: '47348',
			Новомарковка: '47367',
			Новомеловатка: '47363',
			Новонадеждинский: '47346',
			Новоникольск: '47366',
			Новопавловка: '47367',
			Новопокровский: '47353',
			Новопостояловка: '47396',
			Новосильское: '47372',
			Новосолдатка: '47374',
			Новоспасовка: '47348',
			Новотолучеево: '47356',
			Новотроицкий: '47352',
			Новоуспенка: '47375',
			Новохарьковка: '47395',
			Новохоперск: '47353',
			Новохоперский: '47353',
			Новохреновое: '47344',
			Одинцовка: '47374',
			Озерки: '47361',
			Октябрьский: '47344',
			Ольховатка: '47395',
			Орлово: '47341',
			Осадчее: '47374',
			Осетровка: '47355',
			Осиковка: '47367',
			Островки: '47346',
			Острогожск: '47375',
			Острянка: '47370',
			Оськино: '47371',
			Откормсовхоз: '47391',
			Павловск: '47362',
			Пады: '47344',
			Панино: '47344',
			Парусное: '47341',
			Патокино: '47361',
			Первомайское: '47396',
			Перевальное: '47394',
			Переволочное: '47363',
			Переездной: '47362',
			Перекоповка: '47372',
			Перелешино: '47344',
			Перелешинский: '47344',
			Перлевка: '47372',
			Першино: '47370',
			Песковатка: '47350',
			Петренково: '47375',
			Петровка: '47362',
			Петропавловка: '47365',
			Пилипы: '47357',
			Пирогово: '47363',
			Писаревка: '47367',
			Платава: '47374',
			Плесновка: '47366',
			Плясоватка: '47343',
			Побединщина: '47394',
			Поворино: '47376',
			Подгоренский: '47394',
			Подгорная: '47363',
			Поддубное: '47396',
			Подколодновка: '47366',
			Подосиновка: '47353',
			Полежаевское: '47353',
			Половцево: '47353',
			Полтавка: '47366',
			Попасное: '47363',
			Посевкино: '47348',
			Постоялый: '47395',
			Почепское: '47391',
			Приволье: '47372',
			Пригородный: '47363',
			Прилепы: '47374',
			Прилужный: '47374',
			Приречное: '47355',
			Пришиб: '47363',
			Прияр: '47391',
			Пугачевский: '47346',
			Пузево: '47361',
			Пухово: '47391',
			Пчелиновка: '47350',
			Пчельники: '47340',
			Пыховка: '47353',
			Радченское: '47366',
			Раздолье: '47372',
			Рамонь: '47340',
			Рамонье: '47346',
			Репьевка: '47374',
			Ржавец: '47347',
			Рождественское: '47376',
			Романовка: '47346',
			Россошь: '47396',
			Россыпное: '47363',
			Ростоши: '47345',
			Рубашевка: '47346',
			Рудаевка: '47367',
			Рудкино: '47371',
			Рудня: '47356',
			Русаново: '47347',
			Рыбальчино: '47357',
			Рыбное: '47375',
			Рыкань: '47341',
			Сабуровка: '47346',
			Сагуны: '47394',
			Садовое: '47346',
			Самодуровка: '47376',
			Саприно: '47394',
			Селявное: '47391',
			Семейка: '47394',
			Семеновка: '47363',
			Семеновский: '47345',
			Семилуки: '47372',
			Серебрянка: '47372',
			Сериково: '47361',
			Серяково: '47363',
			Синявка: '47352',
			Скляево: '47340',
			Скнаровка: '47367',
			Скорицкое: '47374',
			Скрипниково: '47363',
			Сластенка: '47345',
			Смаглеевка: '47367',
			Советское: '47363',
			Соколовский: '47350',
			Солдатское: '47375',
			Соленый: '47367',
			Сомово: '47340',
			Сончино: '47357',
			Софиевка: '47367',
			Софьинка: '47346',
			Спасское: '47343',
			Стадница: '47372',
			Старина: '47342',
			Старогольское: '47348',
			Старомеловая: '47365',
			Староникольское: '47371',
			Старотолучеево: '47366',
			Стеценково: '47396',
			Стрелица: '47372',
			Студеное: '47346',
			Ступино: '47340',
			Таволжанка: '47348',
			Таловая: '47352',
			Талы: '47367',
			Тамбовка: '47347',
			Танцирей: '47354',
			Татарино: '47357',
			Твердохлебовка: '47366',
			Теллермановский: '47348',
			Терехово: '47352',
			Терешково: '47366',
			Терновка: '47347',
			Терновое: '47394',
			Терновский: '47353',
			Тимирязево: '47357',
			Титаревка: '47367',
			Тихвинка: '47348',
			Тойда: '47344',
			Тресоруково: '47391',
			Третьяки: '47354',
			Трехстенки: '47357',
			Трещевка: '47340',
			Тройня: '47350',
			Трудовое: '47341',
			Тхоревка: '47357',
			Тюковка: '47354',
			Углянец: '47343',
			Украинский: '47396',
			Ульяновка: '47354',
			Устье: '47371',
			Утиновка: '47352',
			Фабрицкое: '47374',
			Филиппенково: '47361',
			Филоново: '47366',
			Фисенково: '47367',
			Фоменково: '47365',
			Хвощеватка: '47340',
			Хвощеватое: '47363',
			Хлебное: '47341',
			Хлебородное: '47346',
			Хорольский: '47352',
			Хохольский: '47371',
			Хрещатое: '47363',
			Цапково: '47396',
			Централь: '47353',
			Чагары: '47396',
			Черкасское: '47362',
			Чертовицы: '47340',
			Чесменка: '47350',
			Четвериково: '47363',
			Чигорак: '47354',
			Чичерино: '47348',
			Чулок: '47361',
			Шапошниковка: '47395',
			Шевченково: '47367',
			Шекаловка: '47396',
			Шестаково: '47350',
			Ширяево: '47363',
			Шишовка: '47350',
			Шрамовка: '47396',
			Шуберское: '47341',
			Шубное: '47375',
			Шувалов: '47362',
			Шуриновка: '47366',
			Щербаково: '47357',
			Щербачевка: '47344',
			Эртиль: '47345',
			Юдановка: '47350',
			Юдино: '47394',
			Южное: '47341',
			Юнаково: '47363',
			Юрасовка: '47395',
			Яблочное: '47371',
			Ямное: '47340',
			Ясенки: '47350',
			Ясеновка: '47363',
			Ячейка: '47345'
		}
	},
	'Еврейская автономная область': {
		regionCode: '426',
		cities: {
			'Волочаевка 1': '42632',
			'Волочаевка-1': '42632',
			'Екатерино-Никольское': '42665',
			'Желтый Яр': '42622',
			'Лондоко Поселок': '42666',
			'Лондоко-Завод': '42666',
			'Нижне-Ленинское': '42663',
			'Опытное Поле': '42622',
			'ст. Волочаевка': '42632',
			Амурзет: '42665',
			Аур: '42632',
			Бабстово: '42663',
			Башмак: '42663',
			Башурово: '42666',
			Белгородское: '42632',
			Биджан: '42663',
			Бира: '42666',
			Биракан: '42666',
			Биробиджан: '42622',
			Бирофельд: '42622',
			Благословенное: '42665',
			Будукан: '42666',
			Валдгейм: '42622',
			Венцелево: '42663',
			Воскресеновка: '42663',
			Головино: '42622',
			Горное: '42663',
			Даниловка: '42632',
			Двуречье: '42666',
			Дежнево: '42663',
			Доброе: '42665',
			Дубовое: '42622',
			Заречное: '42666',
			Известковый: '42666',
			Калинино: '42663',
			Камышовка: '42632',
			Квашнино: '42663',
			Кирга: '42622',
			Кирово: '42663',
			Ключевое: '42632',
			Красивое: '42622',
			Кукелево: '42663',
			Кульдур: '42666',
			Лазарево: '42663',
			Ленинское: '42663',
			Луговое: '42665',
			Нагибово: '42665',
			Надеждинское: '42622',
			Найфельд: '42622',
			Николаевка: '42632',
			Новое: '42663',
			Новотроицкое: '42663',
			Облучье: '42666',
			Озерное: '42665',
			Октябрьское: '42663',
			Партизанское: '42632',
			Пашково: '42666',
			Песчаное: '42632',
			Полевое: '42665',
			Преображеновка: '42663',
			Приамурская: '42632',
			Приамурский: '42632',
			Пронькино: '42622',
			Птичник: '42622',
			Пузино: '42665',
			Радде: '42666',
			Ручейки: '42665',
			Садовое: '42665',
			Самара: '42665',
			Семисточный: '42666',
			Смидович: '42632',
			Смидовичи: '42632',
			Степное: '42663',
			Столбовое: '42665',
			Тельман: '42632',
			Теплоозёрск: '42666',
			Унгун: '42663',
			Хинганск: '42666',
			Целинное: '42663',
			Чурки: '42663'
		}
	},
	'Забайкальский край': {
		regionCode: '302',
		cities: {
			Амитхаша: '30229',
			'Верх-Усугли': '30264',
			'Вершино-Дарасунский': '30264',
			'Забайкальск ': '30251',
			'Красный Чикой': '30230',
			'Нерчинский Завод': '30248',
			'Нижний Цасучей': '30252',
			'Петровск-Забайкальский': '30236',
			Цугол: '30255',
			'Шерловая Гора': '30233',
			'с. Акша': '30231',
			Агинское: '30239',
			Акша: '30231',
			Атамановка: '3022',
			Балей: '30232',
			Борзя: '30233',
			Горный: '30257',
			Дарасун: '30234',
			Домна: '3022',
			Дульдурга: '30256',
			Забайкальск: '30251',
			Калга: '30249',
			Карымское: '30234',
			Кокуй: '30246',
			Краснокаменск: '30245',
			Кыра: '30235',
			Могойтуй: '30255',
			Моготуй: '30255',
			Могоча: '30241',
			Нерчинск: '30242',
			Новокручининский: '3022',
			Оловянная: '30253',
			Приаргунск: '30243',
			Сретенск: '30246',
			Улёты: '30238',
			Хилок: '30237',
			Чара: '30261',
			Чернышевск: '30265',
			Чита: '3022',
			Шелопугино: '30266',
			Шилка: '30244',
			Ясная: '30253'
		}
	},
	'Ивановская область': {
		regionCode: '493',
		cities: {
			'Верхний Ландех': '49349',
			'Воскресенское-Новое': '49344',
			'Гаврилов Посад ': '49355',
			'Гаврилов Посад': '49355',
			'Горки-Чириковы': '49339',
			'Ильинское-Хованск': '49353',
			'Ильинское-Хованское': '49353',
			'Илья-Высоково': '49345',
			'Лазарцево-Фомино': '49353',
			'Липовая Роща': '49355',
			'Мугреево-Никольское': '49347',
			'Неверово-Слобода': '49346',
			'Нижний Ландех': '49346',
			'Ново-Талицы': '4932',
			'Новое Леушино': '49343',
			'Новые Горки': '49357',
			'Рстилково-Малое': '49357',
			'Синяя Осока': '49343',
			'Старая Вичуга': '49354',
			'Тихон-Воля': '49337',
			'Утес Совхоз': '49339',
			Алехино: '49346',
			Антилохово: '49356',
			Антушково: '49353',
			Аньково: '49353',
			Архиповка: '49356',
			Балахонки: '4932',
			Бараново: '49349',
			Батманы: '49331',
			Беклемищи: '49346',
			Белоногово: '49333',
			Бердюково: '49336',
			Бережок: '49355',
			Благовещенье: '49344',
			Богданиха: '4932',
			Богородское: '4932',
			Болотново: '49336',
			Боровое: '49343',
			Бородино: '49355',
			Буньково: '4932',
			Бутово: '49352',
			Быково: '49344',
			Вандышки: '49331',
			Ваньково: '49337',
			Васильевское: '49351',
			Вахутки: '49331',
			Введенье: '49351',
			Вербино: '49346',
			Вичуга: '49354',
			Воздвиженье: '49333',
			Вознесенье: '49356',
			Воронино: '49333',
			Вьюшково: '49333',
			Гаврилково: '49354',
			Гари: '49353',
			Гарь: '49337',
			Гольцовка: '49333',
			Горкино: '49336',
			Горячево: '49356',
			Груздево: '49347',
			Данилово: '49352',
			Демидово: '49346',
			Дмитриево: '49345',
			Доброхотово: '49331',
			Долматовский: '49333',
			Дорожаево: '49351',
			Дубново: '49345',
			Дуляпино: '49341',
			Дунилово: '49351',
			Дягилево: '49334',
			Елнать: '49337',
			Ермолино: '4932',
			Есиплево: '49333',
			Жажлево: '49333',
			Железнодорожный: '4932',
			Жирятино: '49354',
			Журихино: '49331',
			Заволжск: '49333',
			Загорье: '49355',
			Закусихино: '49331',
			Зарайское: '49345',
			Заречный: '49333',
			Зарубино: '49354',
			Засека: '49349',
			Затеиха: '49345',
			Захарьино: '4932',
			Зернилово: '49343',
			Зиново: '49343',
			Зобнино: '49331',
			Золотилово: '49354',
			Иваново: '4932',
			Иванцево: '4932',
			Иваньково: '49352',
			Иваньковский: '49355',
			Ивашево: '49353',
			Игнатовское: '49341',
			Игрищи: '49353',
			Изотино: '49347',
			Ильинское: '49331',
			Ингарь: '49339',
			Исаевское: '49353',
			Каблуково: '49353',
			Калачево: '4932',
			Каликино: '49341',
			Каменка: '49354',
			Каминский: '49336',
			Кандаурово: '49345',
			Качалово: '49351',
			Кинешма: '49331',
			Кирикино: '49354',
			Китово: '49351',
			Клетино: '49334',
			Клочково: '49351',
			Князьково: '49349',
			Коварчино: '49353',
			Колбацкое: '4932',
			Колобово: '49351',
			Колшево: '49333',
			Комсомольск: '49352',
			Корзино: '49356',
			Коротиха: '49333',
			Косачево: '49354',
			Костяево: '49337',
			Котово: '49344',
			Кохма: '4932',
			Крапивново: '49343',
			Красинское: '49339',
			Красногорский: '49331',
			Красное: '49336',
			Кромы: '49349',
			Кукарино: '49357',
			Кулачево: '49353',
			Кулеберьево: '49352',
			Куликово: '4932',
			Кунестино: '49339',
			Курень: '49333',
			Ласкариха: '49331',
			Лежнево: '49357',
			Летнево: '49345',
			Лобаны: '49337',
			Лобцово: '49355',
			Ломы: '4932',
			Луговое: '49331',
			Лужинки: '49345',
			Лужки: '49334',
			Лух: '49344',
			Лычево: '49355',
			Майдаково: '49334',
			Макатово: '49354',
			Малышево: '49336',
			Мальчиха: '49336',
			Марищи: '49345',
			Марково: '49352',
			Марьино: '49341',
			Меховицы: '49356',
			Мирславль: '49355',
			Михеево: '49352',
			Мордвиново: '49346',
			Морозово: '49343',
			Мортки: '49345',
			Москвино: '49343',
			Моста: '49347',
			Мугреевский: '49347',
			Мыт: '49349',
			Мытищи: '49352',
			Наволоки: '49331',
			Нажерово: '49353',
			Насакино: '49354',
			Непотягово: '49355',
			Нерль: '49343',
			Никольское: '49352',
			Новлянское: '49333',
			Новое: '49339',
			Новоклязьминское: '49347',
			Новописцово: '49354',
			Новоселка: '49355',
			Обжериха: '49337',
			Оболсуново: '49343',
			Озёрный: '4932',
			Октябрьский: '49352',
			Оношково: '49344',
			Осановец: '49355',
			Острецово: '49336',
			Палех: '49334',
			Панеево: '4932',
			Панино: '49341',
			Паново: '49334',
			Панфилово: '49356',
			Парское: '49336',
			Пелевино: '49337',
			Пеньки: '49334',
			Перемилово: '49351',
			Пестяки: '49346',
			Петрово: '49345',
			Петровский: '49355',
			Писцово: '49352',
			Плес: '49339',
			Плёс: '49339',
			Погост: '49341',
			Подвязновский: '4932',
			Подозерский: '49352',
			Подолино: '49334',
			Покровское: '49356',
			Польки: '49356',
			Порздни: '49344',
			Постнинский: '49336',
			Преображенское: '49347',
			Приволжск: '49339',
			Пустошь: '49351',
			Пучеж: '49345',
			Ратницкое: '49355',
			Решма: '49331',
			Родники: '49336',
			Рождествено: '49339',
			Рябово: '49344',
			Савино: '49356',
			Сакулино: '49334',
			Сахтыш: '49343',
			Светиково: '49352',
			Сеготь: '49345',
			Седельницы: '49352',
			Сезух: '49346',
			Семеновское: '49354',
			Сербилово: '49355',
			Сергеево: '49351',
			Симаково: '49349',
			Слободки: '49344',
			Снетиново: '49341',
			Соболево: '49337',
			Сокатово: '49343',
			Сорохта: '49352',
			Сосновец: '49336',
			Сошники: '49354',
			Спирки: '49353',
			Станко: '49331',
			Старилово: '49349',
			Стромихино: '4932',
			Тайманиха: '49336',
			Талица: '49337',
			Талицы: '49347',
			Тейково: '49343',
			Телегино: '49357',
			Тименка: '49334',
			Тимирязево: '49344',
			Толпыгино: '49339',
			Торопиха: '49333',
			Троица: '49354',
			Тюгаево: '49352',
			Филисово: '49336',
			Фурманов: '49341',
			Харитоново: '49351',
			Хлебницы: '49353',
			Хозниково: '49357',
			Холуй: '49347',
			Хотимль: '49347',
			Хромцово: '49341',
			Центральный: '49351',
			Чернореченский: '4932',
			Чернцы: '49357',
			Чертовищи: '49354',
			Шалаево: '49346',
			Шекшово: '49355',
			Шилекша: '49331',
			Шилыково: '49357',
			Широково: '49341',
			Шуя: '49351',
			Щапово: '49357',
			Щениково: '49353',
			Южа: '49347',
			Юрьевец: '49337',
			Юрьевское: '49341'
		}
	},
	'Иркутская область': {
		regionCode: '395',
		cities: {
			'Большая Елань': '39543',
			'Большая Речка': '3952',
			'Большое Голоустное': '3952',
			'Большой Кашелак': '39536',
			'Большой Луг': '39550',
			'Верхний Булай': '39546',
			'Верхняя Гутара': '39557',
			'Верхняя Иреть': '39546',
			'Вершина Тутуры': '39540',
			'Горно-Чуйский': '39569',
			'Горячий Ключ': '3952',
			'Дальняя Закора': '39551',
			'Железногорск-Илимск': '39566',
			'Железногорск-Илимский': '39566',
			'Зорино-Быково': '3952',
			'Каменно-Ангарск': '39546',
			'Ключи-Булак': '3953',
			'Кривая Лука': '39568',
			'Крутой Ключ': '39530',
			'Малое Голоустное': '3952',
			'Нижний Бурбук': '39530',
			'Нижняя Иреть': '39546',
			'Новая Игирма': '39566',
			'Новая Тельба': '39536',
			'Новая Уда': '39545',
			'Новое Приречье': '3953',
			'Октябрьский-Второй': '39530',
			'Половино-Черемхово': '39563',
			'Поселок Листвянка': '3952',
			'Северный Кадуй': '39530',
			'Сосновый Бор': '3952',
			'Средняя Муя': '39545',
			'Старый Акульшет': '39563',
			'Тыреть Первая': '39552',
			'Усолье-Сибирское': '39543',
			'Усть-Илга': '39551',
			'Усть-Илимск': '39535',
			'Усть-Када': '39536',
			'Усть-Кульск': '39530',
			'Усть-Кут': '39565',
			'Усть-Ордынский': '39541',
			'Усть-Уда': '39545',
			'Харик Село': '39536',
			'Хор-Тагна': '39552',
			'Целинные Земли': '39530',
			'Центральный Хазан': '39554',
			'Чистые Ключи': '39550',
			'Шеберта поселок': '39557',
			'п. Залари': '39552',
			'поселок Усть-Ордынский': '39541',
			Алгатуй: '39530',
			Александровка: '3953',
			Алексеевск: '39568',
			Алехино: '39546',
			Алзамай: '39557',
			Алкин: '39536',
			Алыгджер: '39557',
			Алымовка: '39568',
			Амур: '39536',
			Анга: '39540',
			Ангарск: '3955',
			Ангасолка: '39544',
			Ангуй: '39530',
			Андреевск: '39561',
			Андрюшино: '39536',
			Аносово: '39545',
			Апрельск: '39561',
			Артемовский: '39561',
			Аршан: '39530',
			Атагай: '39557',
			Аталанка: '39545',
			Ацикяк: '39540',
			Бабагай: '39552',
			Бада: '3953',
			Бадарма: '39535',
			Бадарминск: '39535',
			Байкал: '39544',
			Байкальск: '39542',
			Баклаши: '39550',
			Балаганка: '39545',
			Балаганск: '39548',
			Балахнинский: '39561',
			Банщиково: '39568',
			Баргадай: '39554',
			Барлук: '39536',
			Басалаевка: '39554',
			Батама: '39554',
			Белореченский: '39543',
			Белоусово: '39540',
			Бельск: '39546',
			Березняки: '39566',
			Березовка: '39563',
			Бидога: '39567',
			Бикей: '3953',
			Биликтуй: '39543',
			Бирит: '39548',
			Бирюлька: '39540',
			Бирюса: '39563',
			Бирюсинск: '39563',
			Бобровка: '39565',
			Бодайбо: '39561',
			Большеокинское: '3953',
			Борисово: '39563',
			Боровое: '39554',
			Боровской: '3953',
			Братск: '3953',
			Брусничный: '39566',
			Бубновка: '39568',
			Бугульдейка: '39558',
			Будагово: '39530',
			Бузыканово: '39563',
			Булюшкина: '39530',
			Бунбуй: '39567',
			Бур: '39553',
			Буреть: '39543',
			Бурук: '39536',
			Бурхун: '39530',
			Бутаково: '39540',
			Быстрая: '39544',
			Венгерка: '39563',
			Веренка: '39552',
			Верхнемарково: '39565',
			Верхнемартыново: '39562',
			Верхнеокинский: '39554',
			Верхоленск: '39540',
			Вершина: '39557',
			Веселый: '39567',
			Видим: '39566',
			Визирный: '39568',
			Витимский: '39569',
			Вихоревка: '3953',
			Владимир: '39552',
			Владимировка: '39530',
			Вознесенский: '39557',
			Воронежский: '39568',
			Гадалей: '39530',
			Галдун: '39530',
			Гарбич: '39562',
			Голуметь: '39546',
			Горевая: '39563',
			Горохово: '3952',
			Гуран: '39530',
			Дальний: '39566',
			Джогино: '39563',
			Дзержинск: '3952',
			Дмитриевка: '39552',
			Добчур: '3953',
			Дубынино: '3953',
			Евдокимово: '39530',
			Едогон: '39530',
			Еланцы: '39558',
			Ербогачен: '39553',
			Ерема: '39553',
			Ермаки: '39562',
			Ершово: '39535',
			Железнодорожный: '39535',
			Жигалово: '39551',
			Заблагар: '39552',
			Заводской: '39567',
			Залари: '39552',
			Залог: '39540',
			Замзор: '39557',
			Заморский: '39566',
			Зарбь: '3953',
			Заречье: '39557',
			Заславская: '39548',
			Заярск: '39566',
			Звездный: '39565',
			Зерновое: '39546',
			Зима: '39554',
			Знаменка: '39551',
			Зулумай: '39554',
			Игжей: '39545',
			Игирма: '39566',
			Игнино: '39536',
			Ика: '39553',
			Икей: '39530',
			Или: '39536',
			Илир: '3953',
			Иркутск: '3952',
			Ишидей: '39530',
			Казачинское: '39562',
			Каймоново: '39565',
			Калтук: '3953',
			Каменка: '39557',
			Каменск: '39567',
			Камышет: '39557',
			Каразей: '39536',
			Карам: '39562',
			Каранцай: '39536',
			Карахун: '3953',
			Карда: '39545',
			Кардой: '3953',
			Карлук: '3952',
			Карымск: '39536',
			Катарбей: '39557',
			Качуг: '39540',
			Квиток: '39563',
			Кежемский: '3953',
			Кеуль: '39535',
			Кижа: '39545',
			Кимильтей: '39554',
			Киренск: '39568',
			Кобляково: '3953',
			Коновалово: '39548',
			Коношаново: '39551',
			Коршуновский: '39566',
			Костино: '39557',
			Котик: '39530',
			Красноярово: '39568',
			Кропоткин: '39561',
			Куватка: '3953',
			Кузнецовка: '3953',
			Куйтун: '39536',
			Култук: '39544',
			Кумарейка: '39548',
			Кумейка: '3953',
			Кундуй: '39536',
			Кундулун: '39554',
			Кунерма: '39562',
			Куреть: '39558',
			Кутима: '39562',
			Кутулик: '39564',
			Кяхтинский: '39561',
			Леонова: '3953',
			Лермонтовский: '39536',
			Лесогорск: '39567',
			Листвянка: '3952',
			Лохово: '39546',
			Луговский: '39569',
			Лукиново: '39551',
			Магистральный: '39562',
			Майский: '39536',
			Малиновка: '39546',
			Малышевка: '39545',
			Мальта: '39543',
			Мама: '39569',
			Мамакан: '39561',
			Мамоны: '3952',
			Мамырь: '3953',
			Манзурка: '39540',
			Маракан: '39561',
			Маритуй: '39544',
			Маркова: '3952',
			Марково: '39565',
			Масляногорск: '39554',
			Мельница: '39557',
			Мингатуй: '39536',
			Мирный: '39563',
			Мироново: '39568',
			Михайловка: '39546',
			Михайловщина: '39545',
			Мишелевка: '39543',
			Моисеевка: '39552',
			Мойган: '39552',
			Молька: '39545',
			Мусковит: '39569',
			Мухино: '39567',
			Надеждинск: '39553',
			Наканно: '39553',
			Небель: '39562',
			Невельская: '39563',
			Невон: '39535',
			Непа: '39553',
			Нерпо: '39561',
			Нижнеудинск: '39557',
			Никилей: '39540',
			Никитаево: '39530',
			Николаевка: '39563',
			Никольск: '3952',
			Ния: '39565',
			Новобалтурина: '39567',
			Новобирюсинский: '39563',
			Новогромово: '39546',
			Новодолоново: '3953',
			Новожилкино: '39543',
			Новоилимск: '39566',
			Новокиевск: '39557',
			Новолетники: '39554',
			Новомальтинск: '39543',
			Новонукутский: '39549',
			Новостройка: '39546',
			Новотроицк: '39530',
			Новочеремхово: '39552',
			Новочунка: '39567',
			Облепиха: '39563',
			Оек: '3952',
			Озерный: '3953',
			Окунайский: '39562',
			Олха: '39550',
			Омолой: '39565',
			Онгурен: '39558',
			Онот: '39546',
			Орлинга: '39565',
			Осиновка: '3953',
			Оськино: '39553',
			Панагино: '39536',
			Парчум: '39567',
			Патриха: '39563',
			Пафеново: '39546',
			Первомайский: '39557',
			Перевоз: '39561',
			Перфилово: '39530',
			Петрово: '39551',
			Петропавловское: '39568',
			Пивовариха: '3952',
			Пионерский: '39567',
			Подволочное: '39545',
			Подволошино: '39553',
			Подгорный: '39557',
			Подкаменная: '39550',
			Подъеланка: '39535',
			Подымахино: '39565',
			Покосное: '3953',
			Покровка: '39554',
			Полинчет: '39563',
			Порожский: '3953',
			Преображенка: '39553',
			Прибойный: '3953',
			Прибрежный: '3953',
			Приудинск: '39567',
			Радищев: '39566',
			Раздолье: '39543',
			Ревякина: '3952',
			Речушка: '39566',
			Рождественка: '39563',
			Рудногорск: '39566',
			Рудовка: '39551',
			Ручей: '39565',
			Рысево: '39546',
			Савватеевка: '3955',
			Самара: '39554',
			Саянск: '39553',
			Саянское: '39546',
			Светлолобово: '39545',
			Светлый: '39561',
			Свирск: '39573',
			Седаново: '39535',
			Семеновское: '39552',
			Семигорск: '39566',
			Сереброво: '39563',
			Сибиряк: '39530',
			Слюдянка: '39544',
			Смоленщина: '3952',
			Согдиондон: '39569',
			Солонцы: '39557',
			Соляная: '39563',
			Сорты: '39552',
			Сосновый: '3953',
			Соцгородок: '39566',
			Сполошино: '39568',
			Средний: '39543',
			Суворовский: '39566',
			Сухой: '3953',
			Тагна: '39552',
			Таежный: '39557',
			Тайтурка: '39543',
			Тайшет: '39563',
			Тальники: '39546',
			Тальцы: '3952',
			Тальяны: '39543',
			Тамтачет: '39563',
			Тангуй: '3953',
			Таргиз: '39567',
			Тарма: '3953',
			Тарнополь: '39548',
			Тельма: '39543',
			Тимошино: '39551',
			Троицк: '39552',
			Тубинский: '39535',
			Туковский: '3953',
			Тулун: '39530',
			Тулюшка: '39536',
			Тунгуска: '39546',
			Турма: '3953',
			Тутура: '39551',
			Тынкобь: '3953',
			Тэмь: '3953',
			Ук: '39557',
			Улькан: '39562',
			Урик: '3952',
			Урункуй: '39554',
			Услон: '39554',
			Утай: '39530',
			Утулик: '39544',
			Уховский: '39536',
			Ухтуй: '39554',
			Уян: '39536',
			Филипповск: '39554',
			Хаихта: '39536',
			Хамакар: '39553',
			Ханжиново: '39552',
			Харайгун: '39554',
			Харанжино: '3953',
			Харбатово: '39540',
			Харгажин: '39530',
			Харик: '39536',
			Хингуй: '39557',
			Холмогой: '39552',
			Хомутово: '3952',
			Хребтовая: '39566',
			Худобок: '3953',
			Худоеланское: '39557',
			Хужир: '39558',
			Целоты: '39543',
			Чеботариха: '39536',
			Червянка: '39567',
			Черемхово: '39546',
			Черноруд: '39558',
			Чехово: '39557',
			Чикан: '39551',
			Чистый: '3953',
			Чичкова: '39545',
			Чунский: '39567',
			Шаманка: '39550',
			Шарагай: '39548',
			Шелаево: '39563',
			Шелехов: '39550',
			Шелехово: '39563',
			Шерагул: '39530',
			Шестаково: '39566',
			Широково: '39557',
			Ширяева: '3952',
			Шиткино: '39563',
			Шумилово: '3953',
			Шумский: '39557',
			Эдучанка: '39535',
			Юбилейный: '39568',
			Юголок: '39545',
			Южный: '3953',
			Юрты: '39563',
			Якурим: '39565',
			Янгель: '39566',
			Янталь: '39565'
		}
	},
	'Кабардино-Балкарская Республика': {
		regionCode: '866',
		cities: {
			'Верхний Акбаш': '86632',
			'Верхний Баксан': '86638',
			'Верхний Куркужин': '86634',
			'Верхний Лескен': '86635',
			'Верхний Чегем': '86630',
			'Верхняя Балкария': '86636',
			'Верхняя Жемтала': '86636',
			'Куба-Таба': '86634',
			'Кызбурун Первый': '86634',
			'Кызбурун Третий': '86634',
			'Лескен Второй': '86635',
			'Нижний Куркужин': '86634',
			'Нижний Курп': '86632',
			'Нижний Чегем': '86630',
			'Нижний Черек': '86635',
			'Новая Балкария': '86632',
			'Новое Хамидие': '86632',
			'Станица Солдатская': '86631',
			'Старый Лескен': '86635',
			'Старый Урух': '86635',
			'Старый Черек': '86635',
			'Ташлы-Тала': '86635',
			'Чегем Второй': '86630',
			'Чегем Первый': '86630',
			'поселок Терскол': '86639',
			'село Дугулыбгей': '86631',
			Александровская: '86633',
			Алтуд: '86631',
			Аргудан: '86635',
			Арик: '86632',
			Аушигер: '86636',
			Бабугент: '86636',
			Баксан: '86634',
			Баксаненок: '86634',
			Бедык: '86638',
			Безенги: '86636',
			Белокаменское: '86637',
			Былым: '86638',
			Гвардейское: '86631',
			Герменчик: '86635',
			Герпегеж: '86636',
			Дальное: '86631',
			Дейское: '86632',
			Дыгулыбгей: '86634',
			Екатериноградская: '86631',
			Ерокко: '86635',
			Жанхотеко: '86634',
			Жемтала: '86636',
			Заводской: '86632',
			Залукодес: '86637',
			Залукокоаже: '86637',
			Зарагиж: '86636',
			Заречное: '86631',
			Заюково: '86634',
			Зольское: '86637',
			Исламей: '86634',
			Каменномостское: '86637',
			Камлюко: '86637',
			Карагач: '86631',
			Кахун: '86635',
			Кашхатау: '86636',
			Кенделен: '86638',
			Кичмалка: '86637',
			Кишпек: '86634',
			Колдрасинский: '86633',
			Комсомольское: '86631',
			Котляревская: '86633',
			Красносельское: '86631',
			Куба: '86634',
			Куян: '86632',
			Лашкута: '86638',
			Лесное: '86631',
			Лечинкай: '86630',
			Майский: '86633',
			Малка: '86637',
			Малокановский: '86631',
			Морзох: '86635',
			Нальчик: '8662',
			Нартан: '86630',
			Нарткала: '86635',
			Нейтрино: '86638',
			Новоивановское: '86633',
			Новопокровский: '86631',
			Новополтавское: '86631',
			Озрек: '86635',
			Октябрьское: '86633',
			Плановское: '86632',
			Приближная: '86631',
			Прималкинское: '86631',
			Приречное: '86637',
			Пролетарское: '86631',
			Прохладный: '86631',
			Псыгансу: '86635',
			Псыкод: '86635',
			Псынабо: '86635',
			Псынадаха: '86637',
			Псыншоко: '86631',
			Псыхурей: '86634',
			Псычох: '86634',
			Саратовский: '86631',
			Сармаково: '86637',
			Светловодское: '86637',
			Советский: '86631',
			Совхозное: '86637',
			Солдатская: '86631',
			Тамбовское: '86632',
			Терек: '86632',
			Терекское: '86632',
			Терскол: '86638',
			Тырныауз: '86638',
			Урвань: '86635',
			Урожайное: '86632',
			Урух: '86635',
			Учебный: '86631',
			Хабаз: '86637',
			Хамидие: '86632',
			Хасанья: '8662',
			Хуштосырт: '86630',
			Чегем: '86630',
			Черниговское: '86631',
			Шалушка: '86630',
			Шардаково: '86637',
			Шитхала: '86635',
			Эльбрус: '86638',
			Этоко: '86637',
			Яникой: '86630',
			Янтарное: '86631'
		}
	},
	'Калининградская область': {
		regionCode: '401',
		cities: {
			'Большое Село': '40162',
			'Красный Яр': '40159',
			'Новая Деревня': '40158',
			'Чистые Пруды': '40144',
			'Чистые пруды': '40144',
			Бабушкино: '40144',
			Багратионово: '40142',
			Багратионовск: '40156',
			Балтийск: '40145',
			Большаково: '40163',
			Борское: '40159',
			Васильково: '40151',
			Весново: '40164',
			Взморье: '40152',
			Вишневка: '40163',
			Владимирово: '40156',
			Володаровка: '40141',
			Высокое: '40163',
			Гаврилово: '40142',
			Гастеллово: '40163',
			Гвардейск: '40159',
			Гвардейское: '40156',
			Головкино: '40158',
			Грачевка: '40150',
			Громово: '40163',
			Гурьевск: '40151',
			Гурьевское: '40142',
			Гусев: '40143',
			Дальнее: '40158',
			Добровольск: '40164',
			Доваторовка: '40141',
			Долгоруково: '40156',
			Домново: '40157',
			Донское: '40153',
			Дружба: '40157',
			Дубовское: '40143',
			Ермаково: '40157',
			Железнодорожный: '40157',
			Жилино: '40162',
			Заветы: '40144',
			Загорское: '40141',
			Залесье: '40158',
			Заливино: '40158',
			Заовражное: '40141',
			Заповедное: '40163',
			Зеленоградск: '40150',
			Зеленое: '40158',
			Знаменка: '40157',
			Знаменск: '40159',
			Зорино: '40159',
			Ильинское: '40144',
			Ильичево: '40158',
			Илюшино: '40144',
			Исаково: '40151',
			Истровка: '40159',
			Калининград: '4012',
			Калинино: '40144',
			Калиновка: '40141',
			Калужское: '40141',
			Каменское: '40141',
			Канаш: '40162',
			Карамышево: '40142',
			Коврово: '40150',
			Колосовка: '40150',
			Комсомольск: '40159',
			Константиновка: '40151',
			Корнево: '40156',
			Кострово: '40150',
			Красное: '40163',
			Краснознаменск: '40164',
			Краснолесье: '40144',
			Краснополянское: '40141',
			Красноторовка: '40150',
			Красноярское: '40142',
			Крылово: '40157',
			Кубановка: '40143',
			Ладушкин: '40156',
			Левобережное: '40163',
			Лесное: '40162',
			Липняки: '40157',
			Липово: '40143',
			Ломово: '40143',
			Лужки: '40142',
			Лунино: '40162',
			Львовское: '40142',
			Люблино: '40152',
			Маевка: '40141',
			Майское: '40143',
			Малиновка: '40159',
			Маломожайское: '40162',
			Мальцево: '40142',
			Мамоново: '40156',
			Маршальское: '40151',
			Марьино: '40151',
			Матросово: '40151',
			Маяковское: '40143',
			Междуречье: '40141',
			Мельниково: '40150',
			Михайлово: '40143',
			Мозырь: '40157',
			Моргуново: '40151',
			Мысовка: '40163',
			Надеждино: '40156',
			Невское: '40144',
			Некрасово: '40151',
			Неман: '40162',
			Неманское: '40164',
			Нестеров: '40144',
			Нивенское: '40156',
			Низовье: '40151',
			Нилово: '40142',
			Новобобруйск: '40157',
			Новоколхозное: '40162',
			Новоселово: '40156',
			Новостроево: '40142',
			Новоуральское: '40164',
			Озерки: '40159',
			Озёрск: '40142',
			Олехово: '40142',
			Охотное: '40163',
			Партизанское: '40156',
			Переславское: '40150',
			Петрово: '40151',
			Петропавловское: '40164',
			Пионерский: '40155',
			Победино: '40164',
			Поваровка: '40150',
			Поддубы: '40143',
			Подлипово: '40157',
			Покрышкино: '40144',
			Полесск: '40158',
			Правдино: '40164',
			Правдинск: '40157',
			Прибрежное: '4012',
			Привольное: '40141',
			Придорожное: '40163',
			Приморск: '40145',
			Приморье: '40153',
			Причалы: '40163',
			Прохладное: '40163',
			Пятидорожное: '40156',
			Ракитино: '40162',
			Ржевское: '40163',
			Романово: '40150',
			Рыбачий: '40150',
			Саранское: '40158',
			Светлогорск: '40153',
			Светлый: '40152',
			Свобода: '40141',
			Севское: '40157',
			Славинск: '40159',
			Славск: '40163',
			Славянское: '40158',
			Советск: '40161',
			Советское: '40163',
			Сосновка: '40158',
			Суворовка: '40142',
			Тимирязево: '40163',
			Тимофеево: '40164',
			Тишино: '40156',
			Толпаки: '40159',
			Толстово: '40164',
			Тургенево: '40158',
			Узловое: '40164',
			Ульяново: '40162',
			Ушаково: '40151',
			Фрунзенское: '40157',
			Фурманово: '40143',
			Холмогоровка: '40150',
			Храброво: '40151',
			Черепаново: '40152',
			Чернышевское: '40144',
			Черняховск: '40141',
			Чехово: '40156',
			Чкалово: '40144',
			Южный: '40156',
			Яблоневка: '40151',
			Яблоновка: '40142',
			Янтарный: '40153',
			Ясное: '40163'
		}
	},
	'Калужская область': {
		regionCode: '484',
		cities: {
			'Березичский стеклозавод': '48442',
			'Богдановы Колодези': '48451',
			'Большие Желтоухи': '48456',
			'Большие Козлы': '48441',
			'Большие Савки': '48456',
			'Большое Алешино': '48446',
			'Буда-Вторая': '48455',
			'Верхнее Гульцово': '48447',
			'Верхнее Сяглово': '48447',
			'Верхняя Акимовка': '48445',
			'Верхняя Песочня': '48456',
			'Восход Санаторий': '48432',
			'Думиничи Вокзал': '48447',
			'Киреевское-Первое': '48442',
			'Климов Завод': '48436',
			'Коллективизатор Совхоз': '48445',
			'Красный Городок': '48437',
			'Крисаново-Пятница': '48454',
			'Ленина им.Cовхоз': '48434',
			'Льва Толстого им.': '48434',
			'Малая Песочня': '48456',
			'Малые Зимницы': '48456',
			'Муратовский Щебзавод': '4842',
			'Нагорное Санаторий': '48456',
			'Нижние Прыски': '48442',
			'Опытная с/х станция': '48441',
			'Полотняный Завод': '48434',
			'Поповские Хутора': '48448',
			'Раменский Совхоз': '48452',
			'Сенино-Первое': '48442',
			'Спас-Деменск': '48455',
			'Сухиничи Главные': '48451',
			'Сухиничи Узловые': '48451',
			'Тихонова Пустынь': '4842',
			'Черная Грязь': '48448',
			'Чкаловский Совхоз': '48434',
			'Шанский Завод': '48449',
			'Шаховский Совхоз': '48452',
			'п/о Цветовка': '48454',
			'село Льва Толстого': '48434',
			Абрамовское: '48438',
			Авдеевка: '48453',
			Авчурино: '48437',
			Адуево: '48433',
			Акулово: '48448',
			Алекино: '48435',
			Алексеевка: '48449',
			Алешково: '48431',
			Алнеры: '48451',
			Андреевское: '4842',
			Аристово: '48437',
			Асеньевское: '48438',
			Асмолово: '48454',
			Афанасово: '48443',
			Ахлебинино: '48441',
			Бабаево: '48431',
			Бабынино: '48448',
			Балабаново: '48438',
			Барсуки: '48434',
			Барятино: '48454',
			Бахмутово: '48454',
			Бебелево: '48437',
			Безвель: '48448',
			Белоусово: '48432',
			Беляево: '48436',
			Бережки: '48456',
			Березовка: '48431',
			Березовский: '48445',
			Бетлица: '48457',
			Богдановка: '48442',
			Борисово: '48438',
			Борищево: '48441',
			Боровенск: '48452',
			Боровск: '48438',
			Бояновичи: '48453',
			Брежнево: '48443',
			Бронцы: '48437',
			Брынь: '48447',
			Брюхово: '48433',
			Буда: '48456',
			Букань: '48444',
			Бутчино: '48457',
			Бухловка: '48432',
			Варваровка: '48433',
			Василенки: '48441',
			Вертное: '48447',
			Верховая: '48451',
			Ветьмица: '48457',
			Вознесенье: '48435',
			Волковское: '48435',
			Волконское: '48442',
			Володино: '48451',
			Воротынск: '48448',
			Ворсино: '48438',
			Ворсобино: '48449',
			Воткино: '48453',
			Выползово: '48456',
			Высокиничи: '48432',
			Высокое: '48447',
			Вязовна: '48443',
			Гаврики: '48446',
			Гавриловка: '48456',
			Галкино: '48434',
			Глазково: '48451',
			Глухово: '48433',
			Головнино: '48441',
			Головтеево: '48431',
			Голосиловка: '48444',
			Горбачи: '48452',
			Горбенки: '48434',
			Горки: '48441',
			Городня: '48438',
			Грабцево: '4842',
			Грачевка: '48432',
			Гремячево: '48441',
			Гришинск: '48442',
			Гусево: '48433',
			Дабужа: '48451',
			Дашино: '48452',
			Дегонка: '48454',
			Детчино: '48431',
			Дешовки: '48442',
			Добрая: '48454',
			Добрино: '48438',
			Долгое: '48452',
			Дороховая: '48449',
			Дуброво: '48456',
			Дугна: '48437',
			Дудоровский: '48443',
			Думиничи: '48447',
			Дурнево: '48434',
			Еленский: '48453',
			Ерденево: '48431',
			Ермолино: '48438',
			Ефимцево: '48443',
			Жданово: '48455',
			Желтыкино: '48434',
			Желябужский: '48437',
			Жерелево: '48457',
			Жиздра: '48445',
			Жилетово: '48434',
			Жильково: '48443',
			Жуков: '48432',
			Заболотье: '48444',
			Закрутое: '48457',
			Заречье: '48443',
			Захарово: '48431',
			Звизжи: '48434',
			Зикеево: '48445',
			Ивановское: '48449',
			Игнатовка: '48444',
			Игнатьевское: '48431',
			Извольск: '48449',
			Износки: '48449',
			Истье: '48432',
			Калинино: '48442',
			Калуга: '4842',
			Калуговский: '48452',
			Каляево: '48433',
			Каменка: '48442',
			Караулово: '48432',
			Картышово: '48446',
			Карцево: '48446',
			Карцово: '48434',
			Касьяново: '48443',
			Кирейково: '48443',
			Киров: '48456',
			Клен: '48453',
			Клетино: '48446',
			Козельск: '48442',
			Коллонтай: '48431',
			Колодяссы: '48453',
			Колосово: '48443',
			Колчино: '48444',
			Кольцово: '48437',
			Колюпаново: '4842',
			Кондрово: '48434',
			Конецполье: '48454',
			Корекозево: '48441',
			Коренево: '48445',
			Коростелево: '48438',
			Корсаково: '48432',
			Космачево: '48444',
			Которь: '48447',
			Кошняки: '48449',
			Крапивна: '48443',
			Красное: '48453',
			Кременское: '48433',
			Кремёнки: '48432',
			Кривское: '48438',
			Крюково: '48436',
			Кудиново: '48431',
			Кудринская: '48446',
			Кудрявец: '48453',
			Кузьминичи: '48457',
			Курганы: '48449',
			Курилово: '48432',
			Куркино: '48436',
			Куровской: '48434',
			Кцынь: '48443',
			Лавровск: '48442',
			Лазинки: '48455',
			Лаптево: '48446',
			Лесной: '48446',
			Ловать: '48453',
			Лопатино: '48435',
			Любунь: '48455',
			Людиново: '48444',
			Людково: '48452',
			Макарово: '48441',
			Маклаки: '48447',
			Маклино: '48431',
			Маковцы: '48434',
			Максимовка: '48431',
			Малоярославец: '48431',
			Мамоновка: '48457',
			Манино: '48444',
			Мармыжи: '48446',
			Матчино: '48442',
			Медынцево: '48443',
			Медынь: '48433',
			Мелихово: '48443',
			Меховое: '48451',
			Мещовск: '48446',
			Милотичи: '48454',
			Милятино: '48454',
			Митинка: '48431',
			Митяево: '48438',
			Михали: '48449',
			Михеево: '48433',
			Мокрое: '48457',
			Мосальск: '48452',
			Мосур: '48454',
			Мошонки: '48446',
			Мужитино: '48445',
			Муромцево: '48448',
			Мятлево: '48449',
			Наумово: '48455',
			Недельное: '48431',
			Некрасово: '48435',
			Нестеровка: '48446',
			Нестеры: '48455',
			Никиткино: '48452',
			Никитское: '48433',
			Новоалександровский: '48455',
			Новослободск: '48447',
			Обнинск: '48439',
			Оболенское: '48431',
			Овсорок: '48445',
			Овчинино: '48432',
			Огорь: '48445',
			Озерна: '48443',
			Озеро: '48436',
			Октябрьский: '48437',
			Ореховня: '48449',
			Ослинка: '48445',
			Острожное: '48434',
			Охотное: '48451',
			Павлиново: '48455',
			Палики: '48447',
			Палькевичи: '48453',
			Пеневичи: '48453',
			Передел: '48433',
			Перемышль: '48441',
			Песочня: '48441',
			Петрищево: '48435',
			Печки: '48444',
			Плетни: '48454',
			Плоское: '48436',
			Победа: '48432',
			Подборки: '48442',
			Подбужье: '48453',
			Подкопаево: '48446',
			Поздняково: '48443',
			Покров: '48446',
			Покровск: '48442',
			Покровское: '48441',
			Полошково: '48442',
			Полюдово: '48445',
			Поляна: '48445',
			Понизовье: '48455',
			Попелево: '48442',
			Поречье: '48431',
			Посконь: '48452',
			Прудки: '48431',
			Пыренка: '48447',
			Пятовский: '48434',
			Радождево: '48451',
			Радюкино: '48433',
			Редькино: '48434',
			Резвань: '4842',
			Романово: '48433',
			Росва: '4842',
			Роща: '48435',
			Рудня: '48434',
			Рыляки: '48436',
			Рябцево: '48431',
			Сабуровщино: '48448',
			Сашкино: '48437',
			Семеновское: '48449',
			Сени: '48434',
			Середейский: '48451',
			Серпейск: '48446',
			Сильковичи: '48454',
			Сильково: '48441',
			Слаговищи: '48442',
			Слобода: '48453',
			Снопоть: '48455',
			Соболевка: '48451',
			Совьяки: '48438',
			Сосенский: '48442',
			Спас: '4842',
			Спасское: '48454',
			Староселиваново: '48437',
			Стрельна: '48451',
			Стрельня: '48448',
			Студенец: '48445',
			Субботники: '48451',
			Суборово: '48457',
			Сугоново: '48437',
			Судимир: '48445',
			Сухиничи: '48451',
			Таруса: '48435',
			Тарутино: '48432',
			Татаринцы: '48451',
			Теребень: '48453',
			Терпилово: '48446',
			Тишнево: '48438',
			Товарково: '48434',
			Торбеево: '48431',
			Торкотино: '48446',
			Троицкое: '48457',
			Тростье: '48432',
			Трубино: '48432',
			Тырново: '48448',
			Тягаево: '48456',
			Уколица: '48443',
			Улемец: '48445',
			Улемль: '48445',
			Ульяново: '48443',
			Упрямово: '48436',
			Уруга: '48451',
			Утешево: '48448',
			Ферзиково: '48437',
			Фокино: '48449',
			Фоминичи: '48456',
			Фролово: '48451',
			Фроловское: '48442',
			Хвастовичи: '48453',
			Хвощи: '48449',
			Хотень: '48451',
			Хотисино: '48441',
			Хотьково: '48447',
			Цветовка: '48454',
			Чаусово: '48432',
			Чемоданово: '48436',
			Чертень: '48452',
			Чипляево: '48455',
			Чужбиновка: '48456',
			Шайковка: '48456',
			Шамординский: '48442',
			Шемелинки: '48454',
			Шлиппово: '48451',
			Шопино: '4842',
			Шумятино: '48431',
			Щелканово: '48436',
			Щигры: '48445',
			Юбилейный: '48431',
			Юрьево: '48451',
			Юхнов: '48436',
			Якимово: '48456',
			Якшуново: '48434',
			Яровщина: '48445',
			Ястребовка: '4842'
		}
	},
	'Камчатский край': {
		regionCode: '415',
		cities: {
			'Петропавловск-Камчат': '41522',
			'Петропавловск-Камчатский': '4152',
			'Усть-Большерецк': '41532',
			'Усть-Камчатск': '41534',
			'Усть-Хайрюзово': '41539',
			'Южные Коряки': '41531',
			Авача: '4152',
			Анавгай: '41542',
			Апача: '41532',
			Атласово: '41533',
			Березняки: '41531',
			Вилючинск: '41535',
			Вулканный: '41531',
			Долиновка: '41533',
			Елизово: '41531',
			Запорожье: '41532',
			Зеленый: '41531',
			Ичинский: '41536',
			Кавалерское: '41532',
			Каменское: '41546',
			Ключи: '41532',
			Козыревск: '41532',
			Коряки: '41531',
			Крутогоровский: '41536',
			Лазо: '41533',
			Лесной: '41531',
			Майское: '41532',
			Мильково: '41533',
			Моховая: '4152',
			Нагорный: '41531',
			Начики: '41531',
			Николаевка: '41531',
			Никольское: '41547',
			Новый: '41531',
			Озерновский: '41532',
			Октябрьский: '41532',
			Оссора: '41545',
			Палана: '41543',
			Паратунка: '41531',
			Пионерский: '41531',
			Пущино: '41533',
			Раздольный: '41531',
			Сероглазка: '4152',
			Соболево: '41536',
			Сокоч: '41531',
			Сосновка: '41531',
			Таежный: '41533',
			Термальный: '41531',
			Тигиль: '41537',
			Тиличики: '41544',
			Устьевое: '41536',
			Шаромы: '41533',
			Эссо: '41542'
		}
	},
	'Карачаево-Черкесская Республика': {
		regionCode: '878',
		cities: {
			'Адиль-Халк': '87870',
			'Адыге-Хабль': '87870',
			'Али-Бердуковский': '87873',
			'Вако-Жиле': '87870',
			'Верхняя Мара': '87879',
			'Верхняя Теберда': '87879',
			'Икон-Халк': '87870',
			'Инжи-Чишхо': '87873',
			'Инжич-Чукун': '87873',
			'Кара-Паго': '87874',
			'Карт-Джурт': '87879',
			'Кичи-Балык': '87877',
			'Коста Хетагурова им.': '87879',
			'Кош-Хабль': '87873',
			'Красный Курган': '87877',
			'Кызыл-Кала': '87875',
			'Кызыл-Октябрьский': '87878',
			'Кызыл-Покун': '87877',
			'Кызыл-Уруп': '87876',
			'Лесо-Кефарь': '87878',
			'Малый Зеленчук': '87873',
			'Нижний Архыз': '87878',
			'Нижняя Ермоловка': '87878',
			'Нижняя Мара': '87879',
			'Нижняя Теберда': '87879',
			'Новая Джегута': '87875',
			'Новая Теберда': '87879',
			'Новый Карачай': '87879',
			'Псаучье-Дахе': '87873',
			'Сары-Тюз': '87875',
			'Усть-Джегута': '87875',
			'Хасаут-Греческое': '87878',
			'Эркен-Халк': '87870',
			'Эркен-Шахар': '87870',
			'Эркен-Юрт': '87870',
			Апсуа: '87870',
			Архыз: '87878',
			Бавуко: '87873',
			Бесленей: '87873',
			Важное: '87875',
			Грушка: '87870',
			Гюрюльдеук: '87875',
			Даусуз: '87878',
			Джага: '87877',
			Джегута: '87875',
			Джингирик: '87879',
			Домбай: '87879',
			Дружба: '87874',
			Жако: '87873',
			Зеленчукская: '87878',
			Зеюко: '87873',
			Знаменка: '87874',
			Ильич: '87878',
			Ильичевское: '87874',
			Исправная: '87878',
			Кавказский: '87874',
			Каменномостский: '87879',
			Карачаевск: '87879',
			Кардоникская: '87878',
			Красновосточный: '87877',
			Красногорская: '87875',
			Кубина: '87875',
			Кубрань: '87879',
			Кумыш: '87879',
			Курджиново: '87876',
			Майский: '87874',
			Малокурганный: '87879',
			Маруха: '87878',
			Медногорский: '87876',
			Мичуринский: '87874',
			Николаевское: '87874',
			Новоисправненское: '87878',
			Новокувинский: '87870',
			Октябрьский: '87874',
			Орджоникидзевский: '87879',
			Первомайское: '87877',
			Правокубанский: '87879',
			Преградная: '87876',
			Предгорное: '87876',
			Пристань: '87874',
			Псемен: '87876',
			Псыж: '87874',
			Пхия: '87876',
			Римгорское: '87877',
			Рожкао: '87876',
			Садовое: '87870',
			Светлое: '87874',
			Спарта: '87870',
			Старокувинский: '87870',
			Сторожевая: '87878',
			Счастливое: '87874',
			Таллык: '87874',
			Теберда: '87879',
			Терезе: '87877',
			Ударный: '87874',
			Уруп: '87876',
			Учкекен: '87877',
			Учкулан: '87879',
			Фроловский: '87878',
			Хабез: '87873',
			Хумара: '87879',
			Хурзук: '87879',
			Чапаевское: '87874',
			Черкесск: '8782',
			Эльбрусский: '87879',
			Эльбурган: '87873',
			Эльтаркач: '87875',
			Эрсакон: '87870'
		}
	},
	'Кемеровская область': {
		regionCode: '384',
		cities: {
			'Акимо-Анненка': '38449',
			'Анжеро-Судженск': '38453',
			'Большая Натальевка': '38447',
			'Большая Покровка': '38449',
			'Большая Талда': '3846',
			'Большой Барандат': '38447',
			'Большой Берчикуль': '38447',
			'Большой Керлегеш': '3846',
			'Большой Корчуган': '38454',
			'Верх-Егос': '3846',
			'Верх-Падунский': '38454',
			'Верх-Тайменка': '38451',
			'Верх-Чебула': '38444',
			'Верх-Чумыш': '3846',
			'Верхняя-Чебула': '38444',
			'Каз (посёлок)': '38473',
			'Каменный Ключ': '3846',
			'Красные Ключи': '38446',
			'Красные Орлы': '38443',
			'Красный Яр': '38459',
			'Курск-Смоленка': '38444',
			'Лебяжье-Асаново': '38451',
			'Ленинск-Кузнецкий': '38456',
			'Малая Салаирка': '38463',
			'Малый Антибесс': '38443',
			'Малый Корчуган': '38454',
			'Нижняя Суета': '38445',
			'Ново-Казанка': '38444',
			'Новый Берикуль': '38447',
			'Новый Городок': '38452',
			'Новый Каракан': '38452',
			'Новый Свет': '38459',
			'Орлово-Розово': '38444',
			'Осиновое-Плесо': '3843',
			'Падунская Станция': '38442',
			'Пор-Искитим': '38442',
			'Сары-Чумыш': '3843',
			'Старый Тяжин': '38449',
			'Старый Урюп': '38449',
			'Судженка Село': '38441',
			'Сухая Речка': '3842',
			'Таежно-Александровка': '38443',
			'Таежно-Михайловка': '38443',
			'Теплая Речка': '38459',
			'Теплая речка': '38459',
			'Ур-Бедари': '38463',
			'Усть-Анзас': '38473',
			'Усть-Кабырза': '38473',
			'Усть-Колба': '38447',
			'Усть-Нарык': '3843',
			'Усть-Серта': '38444',
			'Усть-Сосново': '38454',
			'Усть-Тарсьма': '38442',
			'Усть-Хмелевка': '3842',
			'Усть-Чебула': '38444',
			'Яя-Борик': '38441',
			'деревня Старочервово': '3842',
			'поселок Усть-Анзас': '38473',
			Абагур: '3843',
			Абышево: '38442',
			Азаново: '38459',
			Акация: '38455',
			Алтамаш: '38473',
			Алчедат: '38444',
			Амзас: '38473',
			Андреевка: '3842',
			Антибесская: '38443',
			Апанас: '3843',
			Ариничево: '38456',
			Арлюк: '38451',
			Арсеново: '38446',
			Арсентьевка: '38445',
			Артышта: '38452',
			Атаманово: '3843',
			Ашмариново: '3843',
			Базанча: '38473',
			Байла: '38447',
			Банново: '38446',
			Барановка: '3842',
			Барачаты: '38446',
			Барзас: '38445',
			Бархатово: '38454',
			Бачатский: '38452',
			Безлесное: '38441',
			Безруково: '3843',
			Беково: '38452',
			Белово: '38452',
			Белогородка: '38443',
			Белогорск: '38447',
			Белянино: '38451',
			Бенжереп: '3843',
			Береговая: '3842',
			Березовка: '38446',
			Берензас: '38474',
			Берикуль: '38459',
			Берикульский: '38447',
			Берёзовский: '38445',
			Благовещенка: '38443',
			Большеямное: '38451',
			Борисово: '38446',
			Борисоглебское: '38449',
			Бормотово: '38442',
			Боровой: '3842',
			Ботьево: '38455',
			Бурлаки: '3846',
			Ваганово: '38442',
			Валерьяновка: '38449',
			Варюхино: '38451',
			Васьково: '38442',
			Верхотомское: '3842',
			Вишневка: '38452',
			Вознесенка: '38441',
			Воскресенка: '3842',
			Восходящий: '38456',
			Глубокая: '38454',
			Голубево: '38442',
			Горскино: '38463',
			Грамотеино: '38452',
			Гурьевск: '38463',
			Даниловка: '38449',
			Дворниково: '38447',
			Демьяновка: '38456',
			Драченино: '38456',
			Дубровка: '38455',
			Евтино: '38452',
			Елань: '3843',
			Елгино: '38451',
			Елыкаево: '3842',
			Журавлево: '38442',
			Загорский: '3843',
			Задубровский: '38452',
			Заозерный: '38451',
			Заринское: '38452',
			Зарубино: '38454',
			Звездный: '3842',
			Зеледеево: '38451',
			Зеленовский: '38446',
			Зеленогорский: '38446',
			Зимник: '38451',
			Знаменка: '38443',
			Знаменский: '38454',
			Зырянка: '38455',
			Иверка: '38459',
			Ижморка: '38459',
			Ижморский: '38459',
			Ильинка: '3843',
			Индустрия: '3846',
			Инской: '38452',
			Инюшка: '38452',
			Итатский: '38449',
			Ишим: '38441',
			Казанка: '38444',
			Казанково: '3843',
			Кайла: '38441',
			Калачево: '3846',
			Калининский: '38443',
			Калинкино: '38442',
			Калтан: '38471',
			Каменка: '38442',
			Каменный: '38446',
			Камышено: '38456',
			Кандалеп: '3843',
			Карагайла: '3846',
			Карагайлинский: '38464',
			Каракан: '38452',
			Каралда: '38452',
			Карачарово: '38444',
			Катково: '38454',
			Кедровка: '3842',
			Кемерово: '3842',
			Киселёвск: '38464',
			Ключи: '38446',
			Кожевниково: '38451',
			Козлово: '38454',
			Колба: '38447',
			Колеул: '38443',
			Колмогорово: '38455',
			Колыон: '38459',
			Колычево: '38442',
			Комиссарово: '3842',
			Комсомольск: '38447',
			Кондома: '38473',
			Конево: '38452',
			Коновалово: '38452',
			Костенково: '3843',
			Котино: '3846',
			Кочкуровка: '38463',
			Крапивинский: '38446',
			Краснинское: '38442',
			Краснобродский: '38452',
			Красное: '38456',
			Красноселка: '38455',
			Красноярка: '38456',
			Красулино: '3843',
			Кубитет: '38449',
			Кузбасский: '3842',
			Кузедеево: '3843',
			Кузель: '38455',
			Кулебакино: '38463',
			Куликовка: '38447',
			Куртуково: '3843',
			Лебеди: '38442',
			Лебяжий: '38443',
			Ленинский: '38455',
			Летяжка: '38459',
			Листвяги: '3843',
			Листвянка: '38449',
			Литвиново: '38455',
			Лукошкино: '38454',
			Лучшево: '3846',
			Лыс: '3843',
			Магистральный: '38454',
			Майзас: '38475',
			Макаракский: '38447',
			Малиновка: '38471',
			Малопесчанка: '38443',
			Мальцево: '38451',
			Мариинск: '38443',
			Марьевка: '38441',
			Медвежка: '38446',
			Медынино: '38454',
			Междугорное: '38446',
			Междуреченск: '38475',
			Менчереп: '38452',
			Металлплощадка: '3842',
			Металлургов: '3843',
			Мирный: '38456',
			Мозжуха: '3842',
			Мокроусово: '38454',
			Московка: '38447',
			Мохово: '38452',
			Мрассу: '38473',
			Мундыбаш: '38473',
			Мусохраново: '38456',
			Мыски: '38474',
			Нижнеяшкино: '38455',
			Новобачаты: '38452',
			Новогеоргиевка: '38456',
			Новогородец: '38456',
			Новое: '38456',
			Новоивановский: '38444',
			Новокузнецк: '3843',
			Новониколаевка: '38441',
			Новопестерево: '38463',
			Новоподзорново: '38449',
			Новопокасьма: '38456',
			Новопокровка: '38449',
			Новороманово: '38451',
			Новосафоновский: '3846',
			Новославянка: '38459',
			Новостройка: '3842',
			Обояновка: '38443',
			Озерки: '38442',
			Опарино: '38454',
			Ортон: '38475',
			Осинники: '38471',
			Осиновка: '3842',
			Островка: '38459',
			Панфилово: '38456',
			Пача: '38455',
			Пашково: '38455',
			Первомайский: '38443',
			Перехляи: '38446',
			Пермяки: '38452',
			Петровский: '3842',
			Пинигино: '38454',
			Пионер: '3842',
			Пихтовка: '38443',
			Плодопитомник: '3846',
			Плотниково: '38442',
			Подгорное: '38456',
			Подобас: '38474',
			Поломошное: '38455',
			Полуторник: '38447',
			Полысаево: '38456',
			Постниково: '38459',
			Почитанка: '38459',
			Преображенка: '38449',
			Пригородный: '3842',
			Пристань: '38443',
			Притомский: '3843',
			Прогресс: '38442',
			Прокопьевск: '3846',
			Промышленная: '38442',
			Промышленновский: '3842',
			Проскоково: '38451',
			Пьяново: '38442',
			Пятково: '38451',
			Раздолье: '38454',
			Раздольный: '38463',
			Речной: '38451',
			Ржавчик: '38447',
			Рубино: '38443',
			Рудничный: '38453',
			Салаир: '38463',
			Салтымаково: '38446',
			Сандайка: '38449',
			Сарбала: '38471',
			Свердловский: '38456',
			Святославка: '38459',
			Севск: '3846',
			Серебряково: '38447',
			Сидоренково: '38452',
			Сидорово: '3843',
			Силино: '3842',
			Симбирка: '38459',
			Смышляево: '3846',
			Соколово: '3846',
			Солдаткино: '38447',
			Соломатово: '38455',
			Соломино: '38454',
			Спасск: '38473',
			Станционный: '38454',
			Старобачаты: '38452',
			Старопестерево: '38452',
			Старочервово: '3842',
			Степной: '3843',
			Ступишино: '38449',
			Суслово: '38443',
			Тайга: '38448',
			Тайжина: '38471',
			Талая: '38451',
			Таловка: '38455',
			Тальжино: '3843',
			Тамбар: '38447',
			Тарабарино: '38442',
			Тараданово: '38446',
			Тарасово: '38442',
			Таскаево: '38451',
			Таштагол: '38473',
			Теба: '38475',
			Темиртау: '38473',
			Терентьевское: '3846',
			Тисуль: '38447',
			Титово: '38442',
			Топки: '38454',
			Трещевский: '38454',
			Троицкое: '38459',
			Трудармейский: '3846',
			Туйла: '38443',
			Тутальская: '38455',
			Тутуяс: '38474',
			Тыхта: '38454',
			Тюменево: '38443',
			Тяжинский: '38449',
			Убинский: '38452',
			Улановка: '38441',
			Уроп: '38452',
			Урск: '38463',
			Усманка: '38444',
			Утинка: '38447',
			Хмелево: '38456',
			Хорошеборка: '38454',
			Хрестиновский: '38456',
			Худяшово: '38456',
			Центральный: '38454',
			Цыпино: '38454',
			Черемичкино: '38454',
			Чистогорский: '3843',
			Чкаловский: '38456',
			Чуазас: '38474',
			Чувашка: '38474',
			Чугунаш: '38473',
			Чулым: '38449',
			Чумай: '38444',
			Чусовитино: '38456',
			Шабаново: '38456',
			Шарап: '3846',
			Шахтер: '38455',
			Шевели: '38446',
			Шерегеш: '38473',
			Шестаково: '38444',
			Школьный: '3846',
			Шуринка: '38442',
			Щебзавод: '38452',
			Щегловский: '3842',
			Юрга: '38451',
			Ягуново: '3842',
			Ягуновский: '3842',
			Яшкино: '38455',
			Яя: '38441'
		}
	},
	'Кировская область': {
		regionCode: '833',
		cities: {
			'Андреева Гора': '83346',
			'Белая Холуница': '83364',
			'Большая Козловка': '83345',
			'Большая Лукинская': '83336',
			'Большая Субботиха': '8332',
			'Большая Шишовка': '83357',
			'Большие Кулики': '83335',
			'Большие Пасынки': '83337',
			'Большие Туры': '83357',
			'Большой Ихтиал': '83357',
			'Большой Китяк': '83347',
			'Большой Кугунур': '83330',
			'Большой Перелаз': '83343',
			'Большой Порек': '83338',
			'Большой Рой': '83363',
			'Быстрицкий Тубсанаторий': '83361',
			'Верхнее Камье': '83331',
			'Верхняя Волманга': '83353',
			'Верхняя Тимофеевская': '83331',
			'Воробьева Гора': '83375',
			'Второй Ластик': '83355',
			'Вятские Поляны': '83334',
			'Дым-Дым-Омгам': '83334',
			'Каменный Перебор': '83338',
			'Кирово-Чепецк': '83361',
			'Красная Поляна': '83334',
			'Красный Яр': '83368',
			'Крутой Лог': '83349',
			'Ленинская Искра': '83342',
			'Лесные Поляны': '83352',
			'Летский Рейд': '83362',
			'Лудяна-Ясашинская': '83368',
			'Малый Конып': '83361',
			'Малый Полом': '83359',
			'Малый Сатнур': '83347',
			'Мари-Малмыж': '83347',
			'Мари-Ошаево': '83355',
			'Мари-Ушем': '83367',
			'Марийская Лиса': '83357',
			'Нижняя Паломица': '83353',
			'Новая Малиновка': '83334',
			'Новая Смаиль': '83347',
			'Новая Указна': '83345',
			'Новый Бурец': '83334',
			'Новый Кокуй': '83347',
			'Опытное Поле ': '83367',
			'Опытное Поле': '83367',
			'Разбойный Бор': '83354',
			'Русская Биляморь': '83363',
			'Русская Шуйма': '83355',
			'Русские Краи': '83341',
			'Русский Турек': '83363',
			'Русское Тимкино': '83363',
			'Рыбная Ватага': '83338',
			'Рябово ': '83337',
			'Средние Шуни': '83334',
			'Средняя Тойма': '83334',
			'Старая Тушка': '83347',
			'Старый Бурец': '83347',
			'Старый Буртек': '83347',
			'Старый Ирюк': '83347',
			'Старый Пинигерь': '83334',
			'Тат-Верх-Гоньба': '83347',
			'Удмуртский Сурвай': '83359',
			'Усть-Люга': '83334',
			'Фаленки ': '83332',
			'Черная Холуница': '83352',
			'Чистые Пруды': '8332',
			'п.г.т. Лальск': '83346',
			'пгт Подосиновец': '83351',
			'пгт. Пижанка': '83355',
			'пгт. Санчурск': '83357',
			Абрамово: '83341',
			Аджим: '83347',
			Адово: '83363',
			Адышево: '83354',
			Алексеиха: '83357',
			Альмеж: '83353',
			Андреевский: '83363',
			Арбаж: '83330',
			Ардаши: '83337',
			Аркуль: '83368',
			Арское: '83350',
			Архипята: '83331',
			Арык: '83347',
			Астрахань: '83359',
			Афанасьево: '83331',
			Ахманово: '83355',
			Ацвеж: '83358',
			Бадья: '83339',
			Бажелка: '83349',
			Бажино: '83341',
			Байса: '83363',
			Бакули: '83362',
			Баланды: '83330',
			Барановка: '83339',
			Барашки: '83359',
			Басманы: '83330',
			Бахта: '8332',
			Безбожник: '83348',
			Безводное: '83355',
			Безденежные: '83335',
			Белорецк: '83352',
			Белореченск: '83352',
			Бельтюги: '83343',
			Беляево: '83341',
			Березник: '83343',
			Березовка: '83341',
			Березово: '83366',
			Бечева: '83336',
			Бисерово: '83331',
			Благовещенское: '83358',
			Бобино: '83362',
			Бобровы: '83336',
			Богородское: '83333',
			Большероманово: '83351',
			Бор: '83331',
			Боровково: '83344',
			Боровой: '83339',
			Ботыли: '83368',
			Буйское: '83363',
			Булатовцы: '83359',
			Бураши: '83338',
			Бурденок: '83336',
			Бурмакино: '83361',
			Буторинская: '83345',
			Быданово: '83364',
			Быково: '83343',
			Быстрица: '83354',
			Быстряги: '83354',
			Вазюк: '83353',
			Ванино: '83331',
			Варнаки: '83368',
			Васильевский: '83352',
			Васильевское: '83350',
			Васильково: '83375',
			Васичи: '83375',
			Васькино: '83340',
			Вахруши: '83362',
			Ваштранга: '83341',
			Великая: '83366',
			Великорецкое: '83366',
			Верхнелалье: '83346',
			Верхнемалье: '83351',
			Верхобыстрица: '83343',
			Верховино: '83366',
			Верховойское: '83333',
			Верховонданка: '83336',
			Верхоишеть: '83368',
			Верхолемье: '83359',
			Верхолипово: '83335',
			Верхораменье: '83348',
			Верхорубы: '83350',
			Верхотулье: '83330',
			Верхоуслино: '83367',
			Верхошижемье: '83335',
			Ветошкино: '83344',
			Вихарево: '83338',
			Вичевщина: '83343',
			Вишкиль: '83342',
			Вогульцы: '83332',
			Вожгалы: '83343',
			Волково: '83362',
			Волосница: '83348',
			Вонданка: '83336',
			Воронье: '83335',
			Восточный: '83352',
			Вотское: '83344',
			Вотчина: '83357',
			Воя: '83355',
			Всехсвятское: '83364',
			Вынур: '83340',
			Высокогорье: '83345',
			Высокораменское: '83345',
			Гаврюшата: '83344',
			Галицкое: '83357',
			Георгиево: '83331',
			Гидаево: '83339',
			Гирсово: '83366',
			Гоньба: '83347',
			Гордино: '83331',
			Городище: '83357',
			Гостовский: '83345',
			Греково: '83340',
			Грехово: '83375',
			Гулины: '83330',
			Гуренки: '83364',
			Дамаскино: '83338',
			Даниловка: '83348',
			Даровской: '83336',
			Дворища: '83369',
			Демьяново: '83351',
			Денисовы: '83362',
			Донаурово: '83363',
			Дороничи: '8332',
			Дорошата: '83338',
			Дресвяново: '83361',
			Дуброва: '83375',
			Дубровка: '83364',
			Дуванное: '83353',
			Ежиха: '83342',
			Езжа: '83331',
			Екатерина: '83342',
			Елгань: '83359',
			Елизарово: '83344',
			Елькино: '83344',
			Еремино: '83368',
			Ершовка: '83334',
			Ефремята: '83331',
			Ешпаево: '83363',
			Желны: '83343',
			Животово: '83346',
			Журавли: '83375',
			Заево: '83349',
			Зайцевы: '83342',
			Закаринье: '83362',
			Залазна: '83352',
			Заречный: '83342',
			Заречье: '83351',
			Заря: '83353',
			Захватаево: '83347',
			Зашижемье: '83375',
			Зенгино: '83354',
			Зимино: '83352',
			Зимник: '83338',
			Зуевка: '83337',
			Зуи: '83337',
			Зыково: '83368',
			Ивановка: '83336',
			Ивановское: '83358',
			Иванцево: '83364',
			Изиморка: '83344',
			Ильинск: '83375',
			Истобенск: '83354',
			Ичетовкины: '83331',
			Кабачки: '83338',
			Казаково: '83355',
			Казаковщина: '83348',
			Кай: '83339',
			Каксинвай: '83347',
			Калачиги: '83335',
			Калинино: '83347',
			Каменное: '83364',
			Камский: '83339',
			Канахинцы: '83359',
			Каравайково: '83346',
			Караванное: '83340',
			Каракша: '83367',
			Караул: '83333',
			Карачи: '83368',
			Каринка: '83361',
			Карино: '83362',
			Карпушино: '83342',
			Катни: '83342',
			Качонки: '83349',
			Кашнур: '83355',
			Кикнур: '83341',
			Кильмезь: '83338',
			Киров: '8332',
			Кирс: '83339',
			Кичма: '83375',
			Кленовица: '83365',
			Климковка: '83364',
			Князево: '83359',
			Коврижата: '83340',
			Кожа: '83375',
			Козловаж: '83342',
			Козьмино: '83357',
			Кокино: '8332',
			Кокорево: '83344',
			Кокшага: '83341',
			Колково: '83365',
			Колобово: '83350',
			Колосово: '83345',
			Колотово: '83357',
			Колянур: '83375',
			Комарово: '83359',
			Комлево: '83344',
			Комсомольский: '83342',
			Коноваловы: '83336',
			Константиновка: '83347',
			Копылы: '83342',
			Кордяга: '83337',
			Корляки: '83357',
			Кормино: '83330',
			Коробовщина: '83365',
			Коршик: '83354',
			Коса: '83337',
			Косино: '83337',
			Костино: '8332',
			Котельнич: '83342',
			Котчиха: '83352',
			Кочкино: '83339',
			Кошулино: '83349',
			Красногорье: '83342',
			Краснополье: '83369',
			Краснореченское: '83349',
			Кресты: '83341',
			Кривецкая: '83336',
			Круглыжи: '83358',
			Кстинино: '83361',
			Кувакуш: '83331',
			Кувшинское: '83357',
			Кугалки: '83367',
			Кугушерга: '83367',
			Кузнецово: '83344',
			Кузнецы: '83365',
			Куликово: '83346',
			Кулыги: '83334',
			Кумёны: '83343',
			Курень: '83336',
			Курино: '83342',
			Курчум: '83369',
			Кучелапы: '83354',
			Кырчаны: '83368',
			Лаж: '83344',
			Лазарево: '83363',
			Лальск: '83346',
			Латышский: '83353',
			Лебедевский: '83363',
			Лебяжье: '83344',
			Леваны: '83332',
			Лекма: '83362',
			Лемам: '83337',
			Ленинское: '83345',
			Лесниково: '83375',
			Лесной: '83339',
			Липовка: '83349',
			Липовое: '83349',
			Лобань: '83333',
			Лодейно: '83351',
			Ложкари: '83366',
			Лойно: '83339',
			Лом: '83367',
			Лопьял: '83363',
			Лошкари: '83375',
			Лудяна: '83368',
			Луза: '83346',
			Лум: '83367',
			Лунданка: '83351',
			Луни: '83345',
			Лупья: '83352',
			Лутошкино: '83343',
			Люй: '83357',
			Люмпанур: '83357',
			Лянгасово: '8332',
			Максаки: '83361',
			Малиновка: '83336',
			Малмыж: '83347',
			Мамаевщина: '83365',
			Марково: '83350',
			Марковцы: '83361',
			Маромица: '83353',
			Матвинур: '83357',
			Машкино: '83340',
			Медведок: '83368',
			Медяны: '83366',
			Мелеть: '83347',
			Мелянда: '83344',
			Михайловское: '83340',
			Мокино: '83375',
			Молома: '83353',
			Молотниково: '83342',
			Монастырское: '83366',
			Монастырщина: '83354',
			Моряны: '83343',
			Мосинский: '83366',
			Московская: '83331',
			Мосуны: '83330',
			Мотоус: '83337',
			Мулино: '83349',
			Мураши: '83348',
			Мурино: '83369',
			Мурыгино: '83366',
			Мухино: '83337',
			Муша: '83375',
			Мысы: '83344',
			Мытьец: '83349',
			Мякиши: '83335',
			Нагорск: '83349',
			Нагорское: '83332',
			Нема: '83350',
			Нестино: '83369',
			Нижнеивкино: '8332',
			Низево: '83332',
			Никишичи: '83348',
			Никола: '83367',
			Никулята: '83367',
			Новотроицкое: '83345',
			Новый: '83348',
			Нолинск: '83368',
			Ныр: '83340',
			Обухово: '83355',
			Овсянниково: '83363',
			Ожегины: '83331',
			Ожмегово: '83339',
			Озерница: '83362',
			Окатьево: '83336',
			Октябрь: '83351',
			Окунево: '83344',
			Омутнинск: '83352',
			Опарино: '83353',
			Оричи: '83354',
			Орлецы: '83349',
			Орлов: '83365',
			Оса: '83342',
			Осиновка: '83338',
			Ошлань: '83333',
			Павлово: '83355',
			Падерино: '83341',
			Паломохино: '83348',
			Паньшонки: '83332',
			Папулово: '83346',
			Парюг: '83342',
			Пасегово: '83361',
			Паска: '83338',
			Пачи: '83340',
			Пашино: '83331',
			Первомайск: '83349',
			Первомайское: '83367',
			Перевоз: '83368',
			Пермята: '83348',
			Песковка: '83352',
			Пестерево: '83338',
			Петровское: '83363',
			Петруненки: '83332',
			Петухи: '83357',
			Петуховы: '83342',
			Пещера: '83339',
			Пижанка: '83355',
			Пиксур: '83336',
			Пиляндыш: '83363',
			Пинюг: '83351',
			Пишнур: '83330',
			Пиштань: '83367',
			Пиштенур: '83340',
			Пищалье: '83354',
			Плелое: '83369',
			Плотбище: '83347',
			Плотники: '83343',
			Пограничный: '83331',
			Подгорцы: '83366',
			Подосиновец: '83351',
			Подрезчиха: '83364',
			Покровское: '83342',
			Покста: '83340',
			Полушнур: '83340',
			Поляки: '83365',
			Порошино: '8332',
			Порубово: '83331',
			Потняк: '83341',
			Преображенка: '83347',
			Прозорово: '83375',
			Прокопье: '83364',
			Прокопьевское: '83345',
			Просница: '83361',
			Пунгино: '83335',
			Пура: '83331',
			Пустоши: '83354',
			Пушкино: '83367',
			Пушма: '83351',
			Пушья: '83339',
			Пышак: '83366',
			Радужный: '83361',
			Разлив: '83342',
			Ракалово: '83364',
			Ральники: '83347',
			Рассвет: '83357',
			Рига: '83358',
			Ровдино: '83351',
			Роговое: '83362',
			Родино: '83375',
			Родичи: '83342',
			Родыгино: '83375',
			Рожки: '83347',
			Рои: '83330',
			Ромаши: '83331',
			Рудничный: '83339',
			Русаново: '83365',
			Русское: '8332',
			Рябиново: '83343',
			Рябово: '83337',
			Савали: '83347',
			Савиново: '83363',
			Савинцы: '83331',
			Савичи: '83367',
			Садаковское: '8332',
			Салобеляк: '83367',
			Салтыки: '83362',
			Санчурск: '83357',
			Сардык: '83359',
			Саринка: '83338',
			Светлополянск: '83339',
			Светлый: '83342',
			Светозарево: '83362',
			Свеча: '83358',
			Святица: '83332',
			Сева: '83331',
			Северный: '83352',
			Сезенево: '83337',
			Селезениха: '83361',
			Селенур: '83363',
			Селино: '83338',
			Семеновское: '83345',
			Семушино: '83337',
			Сердеж: '83367',
			Сибирь: '83359',
			Симахино: '83368',
			Симоновка: '83349',
			Синегорье: '83349',
			Синцово: '83344',
			Ситемка: '83375',
			Скрябино: '83351',
			Слободской: '83362',
			Слудка: '83350',
			Сметанино: '83357',
			Смыки: '83369',
			Советск: '83375',
			Совье: '83362',
			Содом: '83345',
			Созимский: '83339',
			Соколовка: '83337',
			Соколово: '83350',
			Солдари: '83332',
			Сорвижи: '83330',
			Среднеивкино: '83335',
			Сретенское: '83355',
			Сретенье: '83342',
			Старица: '83358',
			Староверческая: '83348',
			Старчевская: '83346',
			Стеклофилины: '83362',
			Степановщина: '83365',
			Столбовы: '83336',
			Стрельская: '83353',
			Стрижи: '83354',
			Струговский: '83352',
			Стулово: '83362',
			Суборь: '83336',
			Суводи: '83354',
			Суводь: '83375',
			Сумчино: '83364',
			Суна: '83369',
			Сусловы: '83366',
			Сухоборка: '83362',
			Сырда: '83335',
			Сырчаны: '83368',
			Сырьяны: '83364',
			Сюзьва: '83331',
			Таврический: '83346',
			Такашур: '83338',
			Талица: '83332',
			Таранки: '83333',
			Татаурово: '83368',
			Томызь: '83331',
			Тонкино: '83352',
			Торопово: '83336',
			Торфяной: '83354',
			Тохтино: '83365',
			Троица: '83364',
			Тужа: '83340',
			Туманы: '83333',
			Тупрунка: '83339',
			Турусиново: '83341',
			Тылай: '83348',
			Тырышкино: '83341',
			Уга: '83346',
			Угор: '83335',
			Улеш: '83341',
			Уни: '83359',
			Уржум: '83363',
			Уртма: '83367',
			Усовы: '83354',
			Успенское: '83358',
			Утманово: '83351',
			Уть: '83359',
			Ухтым: '83333',
			Учка: '83346',
			Фабричное: '83346',
			Фалёнки: '83332',
			Фатеево: '83361',
			Федосята: '83364',
			Федяково: '83361',
			Филейка: '83332',
			Филиппово: '83361',
			Фокино: '83375',
			Фроловская: '83331',
			Холмы: '83358',
			Хороши: '83333',
			Хохловщина: '83336',
			Христофорово: '83346',
			Цекеево: '83341',
			Цепели: '83365',
			Цепочкино: '83363',
			Чахловка: '83345',
			Чаща: '83341',
			Чекашево: '83334',
			Чекоты: '83343',
			Челка: '83375',
			Чепецкий: '83337',
			Черная: '83342',
			Черниговский: '83339',
			Черновское: '83345',
			Чернорецкий: '83336',
			Чернореченский: '83339',
			Чернушка: '83338',
			Чистополье: '83342',
			Чуваши: '83361',
			Чудиново: '83365',
			Чурсья: '83353',
			Чус: '83339',
			Шабуры: '83353',
			Шаваржаки: '83375',
			Шадрино: '83353',
			Шадричи: '83365',
			Шалегово: '83354',
			Шалеевщина: '83342',
			Шапта: '83341',
			Шараница: '83330',
			Шахровка: '83352',
			Швариха: '83368',
			Швецово: '83343',
			Шевнино: '83363',
			Шевырталово: '83349',
			Шембеть: '83330',
			Шестаково: '83362',
			Шешурга: '83340',
			Шихово: '83362',
			Шкаланка: '83367',
			Шленники: '83348',
			Шмелево: '83358',
			Шолга: '83351',
			Шохорда: '83345',
			Шубяны: '83366',
			Шурма: '83363',
			Щеткино: '83351',
			Энгенер: '83367',
			Юдино: '83364',
			Южаки: '83339',
			Юма: '83358',
			Юртик: '83368',
			Юрьево: '83342',
			Юрья: '83366',
			Юсово: '83332',
			Яранск: '83367',
			Яхреньга: '83351'
		}
	},
	'Костромская область': {
		regionCode: '494',
		cities: {
			'Верхне-Спасское': '49452',
			'Красная Осыпь': '49444',
			'Красная Поляна': '49438',
			'Красное-на-Волге': '49432',
			'Красный Бор': '49443',
			'Малая Торзать': '49445',
			'Малое Раменье': '49450',
			'Николо-Макарово': '49445',
			'Николо-Полома': '49440',
			'Николо-Шанга': '49449',
			'Николо-Ширь': '49440',
			'Новая Чудь': '49442',
			'Новое Самылово': '49436',
			'Новый Березовец': '49442',
			'Новый Курдюм': '49442',
			'Серебряный Брод': '49441',
			'Средняя Вохма': '49450',
			'Успенская Слобода': '49437',
			'Чистые Боры': '49435',
			'п/о Щелыково': '49435',
			'с. Павино': '49439',
			'с. Парфеньево': '49440',
			'село Щелыково': '49438',
			Абросимово: '49444',
			Адищево: '49438',
			Александровка: '49431',
			Александрово: '49433',
			Александровское: '49438',
			Алексеевское: '49444',
			Алешково: '49447',
			Андреевское: '49434',
			Аносово: '49440',
			Антропово: '49430',
			Апраксино: '4942',
			Арменки: '49431',
			Ассорино: '49441',
			Афонино: '49435',
			Бараново: '49431',
			Бедрино: '49430',
			Белово: '49441',
			Березники: '49445',
			Березовец: '49437',
			Берзиха: '49449',
			Боговарово: '49451',
			Богослов: '49430',
			Боково: '49435',
			Бор: '49440',
			Боровиково: '49432',
			Боровской: '49452',
			Борок: '49435',
			Борщино: '4942',
			Буй: '49435',
			Бурундучиха: '49448',
			Буяково: '49434',
			Бычиха: '4942',
			Варакинский: '49449',
			Варзенга: '49443',
			Василево: '4942',
			Васильево: '49436',
			Ведрово: '49442',
			Векса: '49437',
			Ветлужский: '49449',
			Вешка: '49442',
			Вига: '49441',
			Владычное: '49431',
			Власиха: '49451',
			Вожерово: '49444',
			Воймас: '49443',
			Волгореченск: '49453',
			Ворваж: '49441',
			Воробьевица: '49450',
			Воронье: '49433',
			Воскресенское: '49431',
			Воскресенье: '49435',
			Вохма: '49450',
			Вохтома: '49440',
			Гавриловское: '49435',
			Гаврино: '49444',
			Гагарино: '49435',
			Галич: '49437',
			Гармониха: '49438',
			Георгиевское: '49447',
			Георгий: '49441',
			Головино: '49449',
			Головинское: '49434',
			Горбачево: '49436',
			Горка: '49441',
			Горчуха: '49445',
			Григорово: '49434',
			Григорцово: '49431',
			Гридино: '49432',
			Грудки: '49433',
			Гуляевка: '49438',
			Гусево: '49446',
			Густомесово: '49432',
			Даравка: '49443',
			Добрецово: '49435',
			Доброумово: '49439',
			Дор: '49435',
			Дорогиня: '49445',
			Дубяны: '49438',
			Дымница: '49438',
			Екатеринкино: '49442',
			Елегино: '49435',
			Елизарово: '49446',
			Елкино: '49444',
			Емсна: '49431',
			Ефино: '49445',
			Жвалово: '49433',
			Жилино: '49436',
			Забегаево: '49451',
			Заболотье: '49449',
			Заборье: '49438',
			Заветлужье: '49450',
			Завражье: '49442',
			Задорино: '49440',
			Залужье: '49433',
			Зарубино: '4942',
			Захарово: '49432',
			Зашугомье: '49436',
			Зебляки: '49449',
			Знаменка: '49446',
			Ивановское: '49432',
			Иваньково: '49442',
			Ивашево: '49438',
			Игодово: '49438',
			Кабаново: '49437',
			Кадый: '49442',
			Кажирово: '49450',
			Калинино: '49436',
			Калинки: '49433',
			Калиново: '49452',
			Каплино: '49435',
			Караваево: '4942',
			Карпово: '49439',
			Карьково: '49446',
			Катунино: '49449',
			Клеванцово: '49438',
			Клементьево: '49431',
			Климово: '49438',
			Кобякино: '49433',
			Козлиха: '49447',
			Кологрив: '49443',
			Колос: '4942',
			Колохта: '49443',
			Колпашница: '49452',
			Конево: '49449',
			Конница: '49450',
			Контеево: '49435',
			Корега: '49435',
			Коровново: '49436',
			Коровье: '49441',
			Корцово: '49436',
			Коряково: '4942',
			Косевское: '49432',
			Космынино: '49431',
			Костома: '49437',
			Кострома: '4942',
			Котельниково: '49430',
			Коткишево: '49444',
			Котлово: '49442',
			Красильниково: '49437',
			Кренево: '49435',
			Кривячка: '49449',
			Крутая: '49452',
			Крутогорское: '49439',
			Кужбал: '49444',
			Куземино: '49436',
			Кузнецово: '4942',
			Кузьмищи: '4942',
			Курьяново: '49437',
			Лаврово: '49431',
			Ладыгино: '49437',
			Лажборовица: '49450',
			Лапшино: '49450',
			Лебеди: '49451',
			Левково: '49437',
			Легитово: '49430',
			Леденгск: '49439',
			Ликурга: '49435',
			Лисицыно: '49443',
			Ломышки: '49434',
			Лопарево: '49437',
			Лубяны: '49442',
			Лужки: '49431',
			Лужок: '49435',
			Мазалово: '49441',
			Майтиха: '49449',
			Макарий: '49435',
			Макарьев: '49445',
			Макарята: '49450',
			Малышево: '49437',
			Мантурово: '49446',
			Маракино: '49443',
			Марково: '49450',
			Марьино: '49442',
			Матвеево: '49440',
			Матвеевское: '49449',
			Маяк: '49450',
			Медведица: '49439',
			Медведки: '49434',
			Меленки: '49434',
			Минское: '4942',
			Мисково: '4942',
			Митино: '49437',
			Михайловица: '49452',
			Михайловское: '49433',
			Михали: '49444',
			Муравьище: '49437',
			Нагатино: '49437',
			Неверово: '49430',
			Нерехта: '49431',
			Нея: '49444',
			Низкусь: '49442',
			Никольское: '4942',
			Новопанкратово: '49441',
			Новый: '49448',
			Ножкино: '49441',
			Номжа: '49444',
			Носково: '49452',
			Нюрюг: '49449',
			Обломихино: '4942',
			Оглоблино: '49436',
			Одоевское: '49449',
			Октябрьский: '49446',
			Олешь: '49437',
			Орехово: '49437',
			Островское: '49438',
			Павино: '49439',
			Палкино: '49430',
			Панино: '49448',
			Панкратово: '49441',
			Паньково: '49442',
			Парфеньево: '49440',
			Пеньки: '49430',
			Первомайка: '49445',
			Первомайский: '49447',
			Первушино: '49433',
			Петрилово: '4942',
			Петровка: '49447',
			Петровское: '49441',
			Петропавловское: '49439',
			Петушиха: '49447',
			Печенкино: '49449',
			Пилятино: '49435',
			Питер: '49450',
			Пищевка: '49449',
			Повалихино: '49441',
			Подвигалиха: '49446',
			Подольское: '49432',
			Полдневица: '49448',
			Поляшово: '49449',
			Помчище: '49430',
			Поназырево: '49448',
			Понизье: '49430',
			Попадьино: '49434',
			Потрусово: '49440',
			Починок: '49436',
			Прибрежный: '4942',
			Прискоково: '49432',
			Пронино: '49437',
			Просек: '49430',
			Пыщуг: '49452',
			Раслово: '49433',
			Ратчина: '49451',
			Рогово: '49446',
			Рождественское: '49449',
			Россолово: '49437',
			Савино: '49440',
			Саметь: '4942',
			Самылово: '49446',
			Сандгора: '4942',
			Северное: '49434',
			Селехово: '49437',
			Селище: '49442',
			Семениха: '49449',
			Серапиха: '49441',
			Сергеевица: '49452',
			Сергеево: '49449',
			Серково: '49432',
			Сивково: '49445',
			Сидоровское: '49432',
			Словинка: '49430',
			Советский: '49447',
			Согра: '49450',
			Соколовский: '49449',
			Солигалич: '49436',
			Соловатово: '49445',
			Соловецкое: '49451',
			Солтаново: '49444',
			Сосновка: '49448',
			Спас: '49450',
			Стариково: '49445',
			Степаново: '49437',
			Столпино: '49442',
			Стрелица: '49436',
			Судай: '49441',
			Судиславль: '49433',
			Сумароково: '49434',
			Сусанино: '49434',
			Суховерхово: '49443',
			Сухоногово: '4942',
			Сущево: '4942',
			Татарское: '49431',
			Текотово: '49433',
			Текун: '49442',
			Тетеринское: '49431',
			Тимошино: '49445',
			Тихон: '49450',
			Толтуново: '49437',
			Торманово: '49441',
			Тотомица: '49444',
			Трифон: '49430',
			Троица: '49450',
			Троицкое: '49449',
			Углево: '49437',
			Угоры: '49446',
			Ужуга: '49443',
			Унжа: '49445',
			Унорож: '49437',
			Фадеево: '49433',
			Фанерник: '4942',
			Федоровское: '49431',
			Фоминское: '4942',
			Фуфайки: '49444',
			Харитоново: '49432',
			Хмелевка: '49448',
			Хомутово: '49438',
			Хорошая: '49450',
			Центральный: '49447',
			Чебаново: '49430',
			Челсма: '49437',
			Ченцово: '49434',
			Ченцы: '49432',
			Черменино: '49443',
			Чернышево: '49442',
			Чухлома: '49441',
			Шайма: '49439',
			Шартаново: '49441',
			Шарья: '49449',
			Шахово: '49433',
			Шекшема: '49449',
			Шемятино: '49445',
			Шепилово: '49434',
			Шолохово: '49432',
			Шувалово: '4942',
			Шунга: '4942',
			Шушкодом: '49435',
			Щелыково: '49438',
			Юркино: '49445',
			Юрово: '49445',
			Юрьево: '49438',
			Якимово: '49445',
			Яковлевское: '4942',
			Якшанга: '49448'
		}
	},
	'Краснодарский край': {
		regionCode: ['862', '861'],
		cities: {
			'Абрау-Дюрсо': '8617',
			'Агуй-Шапсуг': '86167',
			'Алексее-Тенгинская': '86158',
			'Андрее-Дмитриевский': '86147',
			'Архипо-Осиповка': '86141',
			'Асфальтовая Гора': '86152',
			'Бабиче-Кореновский': '86142',
			'Балка Грузская': '86149',
			'Бейсужск Второй': '86157',
			'Белая Глина': '86154',
			'Большая Лопатина': '86168',
			'Большие Челбасы': '86164',
			'Большой Бейсуг': '86156',
			'Большой Разнокол': '86133',
			'Веселая Жизнь': '86191',
			'Волна Революции': '86148',
			'Восточный Сосык': '86153',
			'Гай-Кодзор': '86133',
			'Гарбузова Балка': '86156',
			'Голубая Нива': '86146',
			'Горькая Балка': '86149',
			'Горячий Ключ': '86159',
			'Гречаная Балка': '86163',
			'Гунайка Четвертая': '86167',
			'Ейское Укрепление': '86151',
			'Еремизино-Борисовский': '86196',
			'Желтые Копани': '86153',
			'Зеленчук-Мостовой': '86144',
			'Ивано-Слюсаревское': '86168',
			'Иногородне-Малеваный': '86157',
			'Казаче-Малеваный': '86142',
			'Красная Нива': '86156',
			'Красное Знамя': '86147',
			'Красное Поле': '86147',
			'Красный Дар': '86151',
			'Красный Зеленчук': '86158',
			'Красный Курган': '86133',
			'Красный Лес': '86165',
			'Красный Октябрь': '86148',
			'Кубанская Степь': '86164',
			'Лабинск ': '86169',
			'Лебяжий Остров': '86156',
			'Ленинский Путь': '8617',
			'Марьина Роща': '86141',
			'Михайловский Перевал': '86141',
			'Нижняя Гостагайка': '86133',
			'Новое Село': '86156',
			'Отрадно-Кубанское': '86160',
			'Отрадно-Ольгинское': '86160',
			'Отрадно-Тенгинский': '86144',
			'Память Ленина': '86157',
			'Первая Синюха': '86169',
			'Подгорная Синюха': '86144',
			'Приморско-Ахтарск': '86143',
			'Роте-Фане': '86195',
			'Светлая Заря': '86147',
			'Свободный Мир': '86192',
			'Славянск-на-Кубани': '86146',
			'Сладкий Лиман': '86164',
			'Совет-Квадже': '8622',
			'Солдатская Балка': '86144',
			'Сопова Балка': '86156',
			'Спокойная Синюха': '86144',
			'Средние Чебурки': '86168',
			'Средние Челбасы': '86164',
			'Средний Челбас': '86191',
			'Суворов-Черкесский': '86133',
			'Сухие Челбасы': '86164',
			'Сухой Кут': '86147',
			'Терско-Каламбетский': '86158',
			'Усатова Балка': '86133',
			'Усть-Лабинск': '86135',
			'Фокин Первый': '86155',
			'Цукерова Балка': '86168',
			'Черный Ерик': '86146',
			'Широкая Балка': '86159',
			'Юго-Северная': '86196',
			'Южная Озереевка': '8617',
			'Ясенская Переправа': '86132',
			'ст. Попутная': '86144',
			'станица Новопокровская': '86149',
			'станица Октябрьская': '86161',
			Абинск: '86150',
			Агой: '86167',
			Агрия: '86167',
			Агроном: '86162',
			Адагум: '86131',
			Адербиевка: '86141',
			Адлер: '8622',
			Азовская: '86166',
			Александровка: '86132',
			Александровская: '86164',
			Александровский: '86135',
			Александроневская: '86157',
			Алексеевская: '86196',
			Алексеевский: '86160',
			Алексеевское: '86168',
			Анапа: '86133',
			Анапская: '86133',
			Анапский: '86142',
			Анастасиевская: '86146',
			Ангелинский: '86163',
			Андреевская: '86163',
			Андрющенко: '86145',
			Апшеронск: '86152',
			Армавир: '86137',
			Артющенко: '86148',
			Архангельская: '86196',
			Архиповское: '86155',
			Атаманская: '86191',
			Афипский: '86166',
			Ахметовская: '86169',
			Ахтанизовская: '86148',
			Ахтарский: '86143',
			Ахтырский: '86150',
			Ачуево: '86146',
			Аше: '8622',
			Баговская: '86192',
			Бакинская: '86159',
			Балковская: '86157',
			Бальчанский: '86191',
			Баракаевская: '86192',
			Бараниковский: '86146',
			Батарейка: '86148',
			Батуринская: '86156',
			Беднягина: '86130',
			Безлесный: '86135',
			Безымянное: '86159',
			Бейсуг: '86157',
			Бейсугское: '86156',
			Бейсужек: '86191',
			Беликов: '86146',
			Белозерный: '861',
			Белореченск: '86155',
			Беноково: '86192',
			Береговое: '86141',
			Березанская: '86157',
			Бесленевская: '86192',
			Бесскорбная: '86195',
			Бесстрашная: '86144',
			Бетта: '86141',
			Бжедуховская: '86155',
			Бичевой: '86145',
			Благовещенская: '86133',
			Благодарное: '86144',
			Бойкопонура: '86163',
			Болгов: '86135',
			Большевик: '86130',
			Бородинская: '86143',
			Ботаника: '86160',
			Братковское: '86142',
			Бриньковская: '86143',
			Брюховецкая: '86156',
			Бузиновская: '86157',
			Бураковский: '86142',
			Ванновское: '86158',
			Варваровка: '86133',
			Вардане: '8622',
			Варениковская: '86131',
			Варнавинское: '86150',
			Васюринская: '86162',
			Великовечное: '86155',
			Венцы: '86160',
			Веревкин: '86158',
			Верхнебаканский: '8617',
			Верхневеденеевский: '86155',
			Веселая: '86191',
			Веселовка: '86148',
			Весна: '86167',
			Вестник: '86133',
			Вимовец: '86135',
			Витязево: '86133',
			Владимировка: '8617',
			Владимирская: '86169',
			Водный: '86165',
			Воздвиженская: '86147',
			Вознесенская: '86169',
			Возрождение: '86141',
			Волна: '86148',
			Вольное: '86140',
			Воронежская: '86135',
			Воронцовка: '86132',
			Воронцовская: '86162',
			Воскресенский: '86133',
			Вперед: '86152',
			Выселки: '86157',
			Высокий: '86147',
			Вышестеблиевская: '86148',
			Газырь: '86157',
			Гайдук: '8617',
			Галицын: '86146',
			Гаркуша: '86148',
			Гвардейское: '86131',
			Геймановская: '86158',
			Геленджик: '86141',
			Георгиевское: '86167',
			Гизельдере: '86167',
			Гирей: '86160',
			Гладковская: '86131',
			Глафировка: '86151',
			Глебовка: '86168',
			Глебовское: '8617',
			Глубокий: '86195',
			Гойтх: '86167',
			Головинка: '8622',
			Голубицкая: '86148',
			Горный: '8617',
			Гостагаевская: '86133',
			Гофицкое: '86169',
			Гражданский: '86157',
			Греки: '86163',
			Гривенская: '86163',
			Григорьевская: '86166',
			Гришковское: '86163',
			Грушевый: '86155',
			Гуамка: '86152',
			Губская: '86192',
			Гулькевичи: '86160',
			Гурийская: '86155',
			Гусаровское: '86144',
			Дагомыс: '8622',
			Даманка: '86131',
			Двубратский: '86135',
			Дербентская: '86166',
			Державный: '86140',
			Дефановка: '86167',
			Джанхот: '86141',
			Джигинка: '86133',
			Джубга: '86167',
			Джумайловка: '86163',
			Дивноморское: '86141',
			Динская: '86162',
			Дмитриевская: '86193',
			Днепровская: '86130',
			Долгогусевский: '86155',
			Должанская: '86132',
			Дружный: '86155',
			Духовский: '86160',
			Дятьковская: '86164',
			Ейск: '86132',
			Ейский: '86153',
			Екатериновка: '86151',
			Елизаветинская: '861',
			Еремин: '86158',
			Ереминская: '86169',
			Ерик: '86152',
			Железный: '86135',
			Журавлевка: '86163',
			Журавская: '86142',
			Журавский: '86142',
			Забойский: '86146',
			Заветный: '86137',
			Западный: '86145',
			Запорожская: '86148',
			Засовская: '86169',
			Звезда: '86145',
			Зеленый: '86196',
			Зубов: '86158',
			Иванов: '86133',
			Ивановская: '86165',
			Изобильное: '86144',
			Ильинская: '86149',
			Ильинское: '86168',
			Ильский: '86166',
			Имеретинская: '86159',
			Индюк: '86167',
			Ириновка: '86161',
			Ирклиевская: '86157',
			Кабардинка: '86141',
			Кабардинская: '86152',
			Кавказская: '86193',
			Кадухин: '86135',
			Казанская: '86193',
			Каладжинская: '86169',
			Калинино: '861',
			Калининская: '86163',
			Калининский: '86135',
			Калниболотская: '86149',
			Калужская: '86166',
			Камышеватская: '86132',
			Камышеваха: '86195',
			Каневская: '86164',
			Канеловская: '86153',
			Кеслерово: '86131',
			Киевское: '86131',
			Киновия: '86156',
			Кирпильская: '86135',
			Кирпичное: '86167',
			Кисляковская: '86168',
			Ковалевское: '86195',
			Коваленко: '86166',
			Колос: '86165',
			Комсомолец: '86132',
			Коноково: '86140',
			Константиновская: '86147',
			Копанская: '86132',
			Копанской: '861',
			Кореновск: '86142',
			Коржевский: '86146',
			Коржи: '86145',
			Костромская: '86192',
			Косякинская: '86195',
			Кочергин: '86147',
			Красногвардеец: '86164',
			Краснодар: '861',
			Краснодарский: '86165',
			Красное: '86168',
			Краснолит: '861',
			Краснооктябрьский: '86150',
			Краснопартизанское: '86191',
			Красносельский: '86160',
			Красносельское: '86162',
			Краснофлотский: '86132',
			Крепостная: '86166',
			Кривенковское: '86167',
			Кропоткин: '86138',
			Круглик: '86165',
			Крупская: '86157',
			Крутой: '86196',
			Крыловская: '86161',
			Крымск: '86131',
			Кубанская: '86152',
			Кубань: '86160',
			Кугоейская: '86161',
			Кудепста: '8622',
			Кулешовка: '86155',
			Куликовский: '86145',
			Курганинск: '86147',
			Куринская: '86152',
			Курчанская: '86148',
			Курчанский: '86143',
			Кутаис: '86159',
			Кухаривка: '86132',
			Кучугуры: '86148',
			Кущёвская: '86168',
			Лабинск: '86169',
			Ладожская: '86135',
			Лазаревское: '8622',
			Лебеди: '86163',
			Ленинградская: '86145',
			Ленинодар: '86191',
			Лермонтово: '86167',
			Лесогорская: '86152',
			Лесодача: '86160',
			Лиманский: '86156',
			Линейная: '86152',
			Ловлинская: '86158',
			Лоо: '8622',
			Лосево: '86193',
			Лучезарный: '86147',
			Львовское: '86166',
			Любимов: '86151',
			Ляпино: '86195',
			Маевский: '86146',
			Майкопское: '86160',
			Маламино: '86140',
			Малокубанский: '86149',
			Малороссийский: '86196',
			Малотенгинская: '86144',
			Мартанская: '86159',
			Марьино: '86140',
			Марьинская: '86158',
			Марьинский: '86195',
			Марьянская: '86165',
			Махошевская: '86192',
			Маяк: '86144',
			Медведовская: '86130',
			Междуреченский: '86191',
			Мезмай: '86152',
			Меклета: '86154',
			Мерчанское: '86131',
			Мессажай: '86167',
			Мигуты: '86164',
			Мингрельская: '86150',
			Мирской: '86193',
			Михайловская: '86147',
			Михайловское: '86166',
			Мичуринский: '86140',
			Могукоровка: '86163',
			Могукоровский: '86131',
			Молдовановка: '86167',
			Молдованское: '86131',
			Молодежный: '86155',
			Молькин: '86159',
			Моревка: '86132',
			Морозовский: '86143',
			Мостовское: '86192',
			Мостовской: '86192',
			Набережный: '86191',
			Навагинское: '86167',
			Надежная: '86144',
			Найдорф: '86162',
			Натухаевская: '8617',
			Неберджаевская: '86131',
			Небуг: '86167',
			Незаймановский: '86130',
			Незамаевская: '86191',
			Незамаевский: '86149',
			Некрасовская: '86135',
			Нефтегорск: '86152',
			Нефтяная: '86152',
			Нижегородская: '86152',
			Нижнебаканский: '86131',
			Нижневеденеевский: '86155',
			Нижний: '86142',
			Никитино: '86192',
			Николаевка: '86151',
			Николаевский: '86140',
			Николаенко: '86152',
			Николенское: '86160',
			Новоалексеевская: '86147',
			Новоалексеевское: '86155',
			Новобейсугская: '86157',
			Новоберезанский: '86142',
			Нововеличковская: '86162',
			Нововладимировская: '86158',
			Нововысоченский: '86168',
			Новогражданская: '86157',
			Новодеревянковская: '86164',
			Новоджерелиевская: '86156',
			Новодмитриевская: '86166',
			Новодонецкая: '86157',
			Новоивановская: '86149',
			Новоивановский: '86166',
			Новоивановское: '86168',
			Новокорсунская: '86130',
			Новокубанск: '86195',
			Новолабинская: '86135',
			Новоленинский: '86130',
			Новолеушкоевская: '86191',
			Новолокинская: '86154',
			Новомалороссийская: '86157',
			Новоминская: '86164',
			Новомихайловский: '86167',
			Новомышастовская: '86165',
			Новонекрасовский: '86143',
			Новониколаевская: '86163',
			Новопавловка: '86154',
			Новопашковская: '86161',
			Новопетровская: '86191',
			Новопластуновская: '86191',
			Новоплатнировская: '86145',
			Новопокровская: '86149',
			Новопокровский: '86149',
			Новорождественская: '86196',
			Новороссийск: '8617',
			Новосельское: '86195',
			Новосергиевская: '86161',
			Новотитаровская: '86162',
			Новотроицкий: '86131',
			Новоукраинский: '86131',
			Новоукраинское: '86160',
			Новоурупское: '86140',
			Новощербиновская: '86151',
			Новоясенская: '86153',
			Образцовый: '86145',
			Ольгинка: '86167',
			Ольгинская: '86143',
			Ольгинский: '86150',
			Ольховский: '86130',
			Орленок: '86167',
			Отважная: '86169',
			Отдаленный: '86152',
			Отрадная: '86144',
			Павловская: '86191',
			Павловский: '86131',
			Парковый: '86196',
			Пашковский: '861',
			Пенькозавод: '86144',
			Первомайское: '86157',
			Первореченское: '86162',
			Перевалка: '86192',
			Передовая: '86144',
			Передовой: '86195',
			Переправная: '86192',
			Пересыпь: '86148',
			Переясловская: '86156',
			Песчаный: '86158',
			Петровская: '86146',
			Петровское: '86144',
			Петропавловская: '86147',
			Пискуновское: '86144',
			Плавненский: '86131',
			Пластуновская: '86162',
			Платнировская: '86142',
			Плоская: '86149',
			Подгорная: '86144',
			Подлесный: '86165',
			Поды: '86156',
			Полтавская: '86165',
			Полтавский: '86156',
			Полтавченское: '86168',
			Попутная: '86144',
			Прасковеевка: '86141',
			Приазовская: '86143',
			Привольная: '86164',
			Привольный: '86193',
			Пригибский: '86163',
			Придорожная: '86164',
			Приморский: '86148',
			Приморье: '8622',
			Приреченский: '86159',
			Пролетарий: '86150',
			Протичка: '86165',
			Протоцкие: '86165',
			Прохладный: '86169',
			Прочноокопская: '86195',
			Псебай: '86192',
			Пушкинское: '86160',
			Пшада: '86141',
			Пшехская: '86155',
			Пятихатки: '86133',
			Радищево: '86195',
			Раевская: '8617',
			Раздольная: '86142',
			Раздольное: '86168',
			Редант: '86163',
			Режет: '86152',
			Рисовый: '86146',
			Рисоопытный: '86165',
			Роговская: '86130',
			Родники: '86155',
			Родниковская: '86147',
			Родниковский: '86195',
			Розовый: '86169',
			Романчуков: '86144',
			Рудь: '86144',
			Рязанская: '86155',
			Садки: '86143',
			Садовое: '86167',
			Самурская: '86152',
			Саратовская: '86159',
			Саукдере: '86131',
			Свердловский: '86150',
			Свобода: '86147',
			Свободное: '86156',
			Северин: '86158',
			Северокавказский: '86195',
			Северская: '86166',
			Селекционный: '86154',
			Семеновка: '86135',
			Сенной: '86148',
			Сергиевская: '86142',
			Синегорск: '86150',
			Скобелевская: '86160',
			Славянский: '86192',
			Сладкий: '86169',
			Смоленская: '86166',
			Советская: '86195',
			Советский: '86132',
			Соколихин: '86169',
			Соколовское: '86160',
			Соленое: '86192',
			Соленый: '86148',
			Сочи: '8622',
			Спасов: '86152',
			Спокойная: '86144',
			Спокойный: '86130',
			Ставропольская: '86166',
			Станционный: '86152',
			Старовеличковская: '86163',
			Стародеревянковская: '86164',
			Староджерелиевская: '86165',
			Старокорсунская: '861',
			Старолеушкоевская: '86191',
			Староминская: '86153',
			Старомышастовская: '86162',
			Старонижестеблиевская: '86165',
			Старотитаровская: '86148',
			Старощербиновская: '86151',
			Стеблицкий: '86195',
			Стефановский: '86166',
			Стринский: '86130',
			Суворовское: '86135',
			Суздальская: '86159',
			Сукко: '86133',
			Супсех: '86133',
			Тамань: '86148',
			Тбилисская: '86158',
			Тверская: '86152',
			Тверской: '86161',
			Текос: '86141',
			Темижбекская: '86193',
			Темиргоевская: '86147',
			Темрюк: '86148',
			Тенгинка: '86167',
			Тенгинская: '86135',
			Терновская: '86196',
			Тешебс: '86141',
			Тимашевский: '86130',
			Тимашёвск: '86130',
			Тиховский: '86165',
			Тихорецк: '86196',
			Тополи: '86130',
			Трактовый: '86144',
			Трехсельское: '86140',
			Троицкая: '86131',
			Трудобеликовский: '86165',
			Туапсе: '86167',
			Туркинский: '86154',
			Тхамаха: '86166',
			Тысячный: '86160',
			Тюменский: '86167',
			Убеженская: '86140',
			Убинская: '86166',
			Удобная: '86144',
			Узловой: '86192',
			Украинская: '86191',
			Украинский: '86162',
			Уманский: '86145',
			Унароково: '86192',
			Упорная: '86169',
			Упорный: '86191',
			Урмия: '86147',
			Урожайный: '86160',
			Успенская: '86140',
			Успенское: '86140',
			Усташ: '86133',
			Фадеево: '86131',
			Фадеевский: '86155',
			Фанагорийское: '86159',
			Фастовецкая: '86196',
			Федоровская: '86150',
			Фонталовская: '86148',
			Хадыженск: '86152',
			Хамкетинская: '86192',
			Ханьков: '86146',
			Харьковский: '86169',
			Хлебороб: '86149',
			Холмская: '86150',
			Хоперская: '86196',
			Хоста: '8622',
			Целинный: '86146',
			Цемдолина: '8617',
			Центральный: '86154',
			Цибанобалка: '86133',
			Цыпка: '86167',
			Чайкин: '86144',
			Чамлыкская: '86169',
			Чаплыгин: '86160',
			Чебурголь: '86165',
			Чекон: '86133',
			Челбасская: '86164',
			Челюскинец: '86156',
			Чепигинская: '86156',
			Черниговская: '86155',
			Черниговское: '86152',
			Черноерковская: '86146',
			Черноморская: '86159',
			Черноморский: '86166',
			Черномуровский: '86164',
			Чернореченская: '86169',
			Черный: '86133',
			Чехрак: '86144',
			Чигрина: '86165',
			Чушка: '86148',
			Шабановское: '86166',
			Шабельское: '86151',
			Шапсугская: '86150',
			Шаумян: '86167',
			Шевченковское: '86161',
			Шедок: '86192',
			Шепси: '86167',
			Шептальский: '86131',
			Ширванская: '86152',
			Широчанка: '86132',
			Школьное: '86155',
			Школьный: '86131',
			Шкуринская: '86168',
			Щербиновский: '86151',
			Экономическое: '86131',
			Элитный: '86165',
			Эриванская: '86150',
			Юбилейный: '86148',
			Юровка: '86133',
			Ярославская: '86192',
			Ясенская: '86132'
		}
	},
	'Красноярский край': {
		regionCode: '391',
		cities: {
			'Александро-Ерша': '39167',
			'Апано-Ключи': '39163',
			'Большая Иня': '39132',
			'Большая Ирба': '39136',
			'Большая Косуль': '39157',
			'Большая Мурта': '39198',
			'Большая Ничка': '39132',
			'Большая Речка': '39138',
			'Большая Салба': '39135',
			'Большая Уря': '39161',
			'Большие Кныши': '39135',
			'Большие Пруды': '39119',
			'Большие Сыры': '39148',
			'Большое Озеро': '39153',
			'Большой Арбай': '39142',
			'Большой Телек': '39135',
			'Большой Улуй': '39159',
			'Большой Унгут': '39149',
			'Большой Хабык': '39135',
			'Верх-Амонаш': '39161',
			'Верх-Казанка': '39118',
			'Верхний Кужебар': '39137',
			'Верхняя Уря': '39174',
			'Вершино-Рыбное': '39140',
			'Выезжий Лог': '39149',
			'Долгий Мост': '39163',
			'Запасный Имбеж': '39140',
			'Зеленый Бор': '39132',
			'Красная Поляна': '39155',
			'Красный Завод': '39157',
			'Красный Курыш': '39161',
			'Красный Маяк': '39161',
			'Малая Камала': '39165',
			'Малая Кеть Станция': '39150',
			'Малая Минуса': '39132',
			'Малый Имыш': '39156',
			'Малый Хабык': '39135',
			'Нижний Ингаш': '39171',
			'Нижний Тонай': '39167',
			'Нижняя Есауловка': '39149',
			'Нижняя Пойма': '39171',
			'Николо-Петровка': '39132',
			'Новая Еловка': '39159',
			'Новая Калами': '39114',
			'Новая Кежма': '39143',
			'Новая Солянка': '39165',
			'Новая Сыда': '39134',
			'Новый Городок': '39195',
			'Озеро Тагарское': '39132',
			'Озеро Учум': '39156',
			'Осиновый Мыс': '39162',
			'Памяти 13 Борцов': '39133',
			'Пит Городок': '39114',
			'Поймо-Тины': '39171',
			'Покровка Первая': '39163',
			'Северо-Енисейский': '39160',
			'Советская Речка': '39190',
			'Солонечно-Талое': '39140',
			'Средняя Шушь': '39139',
			'Степной Баджей': '39149',
			'Тиличеть Второй': '39171',
			'Толстый Мыс': '39147',
			'Тунгусско-Чунский': '39177',
			'Усть-Кемь': '39195',
			'Усть-Мана': '39144',
			'Усть-Пит': '39195',
			'Усть-Яруль': '39174',
			'Черная Кома': '39147',
			'Чистое Поле': '39148',
			'Южная Тунгуска': '39171',
			'Южно-Александровка': '39173',
			'Южно-Енисейский': '39141',
			'с. Хатанга': '39191',
			Абакумовка: '39173',
			Абалаково: '39195',
			Абан: '39163',
			Авда: '39146',
			Агинское: '39142',
			Алексеевка: '39136',
			Амонаш: '39161',
			Анаш: '39147',
			Ангарский: '39162',
			Андроново: '39156',
			Анцирь: '39161',
			Арабкаево: '39156',
			Арадан: '39138',
			Арефьево: '39150',
			Артемовск: '39136',
			Артюгино: '39162',
			Архангельское: '39161',
			Астафьевка: '39161',
			Атаманово: '39119',
			Ачинск: '39151',
			Ашкаул: '39161',
			Ашпан: '39156',
			Байкитский: '39178',
			Бакланиха: '39190',
			Балай: '39146',
			Балахта: '39148',
			Балахтон: '39154',
			Бараит: '39147',
			Бартат: '39118',
			Бархатово: '39175',
			Батов: '39167',
			Бахта: '39190',
			Бедоба: '39162',
			Беллык: '39134',
			Беляки: '39162',
			Березовский: '39175',
			Берёзовка: '39175',
			Бидея: '663498',
			Бирилюссы: '39150',
			Благовещенка: '39174',
			Боготол: '39157',
			Богучанский: '39162',
			Богучаны: '39162',
			Болтурино: '663498',
			Бор: '39190',
			Бородино: '39168',
			Борск: '39119',
			Бошняково: '39161',
			Брагино: '39136',
			Бражное: '39161',
			Брянка: '39114',
			Буровой: '39164',
			Быстрая: '39132',
			Бычки: '39159',
			Вагино: '39157',
			Вангаш: '39114',
			Вахрушево: '39164',
			Вельмо: '39114',
			Верещагино: '39190',
			Верхнеимбатск: '39190',
			Верхнепашино: '39195',
			Верхнеусинское: '39138',
			Веселое: '39164',
			Владимировка: '39157',
			Ворогово: '39190',
			Вороковка: '39196',
			Высокогорский: '39195',
			Высотино: '39119',
			Галанино: '39196',
			Гаревое: '39133',
			Георгиевка: '39161',
			Гладково: '39142',
			Глядень: '39155',
			Говорково: '39162',
			Горный: '39151',
			Городище: '39195',
			Городок: '39132',
			Горошиха: '39190',
			Горячегорск: '39153',
			Гремучий: '39162',
			Григорьевка: '39138',
			Громадск: '39146',
			Грузенка: '39148',
			Далай: '39173',
			Двинка: '39158',
			Двуречная: '39165',
			Денисовка: '39163',
			Денисово: '39167',
			Детлово: '39136',
			Дзержинское: '39167',
			Дивногорск: '39144',
			Диксонский: '39152',
			Добромысловский: '39135',
			Дорохово: '39155',
			Дубенское: '39139',
			Дубинино: '39153',
			Дудинка: '39191',
			Дудовка: '39196',
			Екатериновка: '39135',
			Ельники: '39173',
			Емельяново: '39133',
			Енашино: '39114',
			Енисейск: '39195',
			Енисейский: '39195',
			Ентауль: '39118',
			Епишино: '39195',
			Ермаковское: '39138',
			Ермолаево: '39175',
			Еруда: '39114',
			Есаулово: '39175',
			Жайма: '39149',
			Жеблахты: '39138',
			Железногорск: '39197',
			Жерлык: '39132',
			Журавлево: '39136',
			Заледеево: '663498',
			Залипье: '39163',
			Замятино: '39133',
			Заозерный: '39165',
			Зареченка: '39158',
			Зарничный: '39139',
			Зачулымка: '39150',
			Зеледеево: '39133',
			Зеленогорск: '39169',
			Златоруновск: '39156',
			Знаменка: '39132',
			Зотино: '39190',
			Зыково: '39175',
			Игарка: '39172',
			Игнатово: '39166',
			Иджа: '39139',
			Идринское: '39135',
			Икшурма: '39166',
			Иланский: '39173',
			Ильичево: '39139',
			Имба: '39143',
			Имисское: '39136',
			Инголь: '39153',
			Иннокентьевка: '39140',
			Ирба: '39143',
			Ирбейское: '39174',
			Ирша: '39165',
			Исток: '39119',
			Кавказское: '39132',
			Казанка: '39118',
			Казанцево: '39139',
			Казачинский: '39196',
			Казачинское: '39196',
			Кайеркан: '3919',
			Камарчага: '39149',
			Каменка: '39162',
			Канарай: '39167',
			Канск: '39161',
			Каптырево: '39139',
			Карабула: '39162',
			Карапсель: '39173',
			Каратузское: '39137',
			Каргино: '39195',
			Касьяново: '39171',
			Качулька: '39137',
			Кедровый: '39133',
			Кежек: '39162',
			Кежемский: '39143',
			Кежма: '39143',
			Келлог: '39190',
			Кемское: '39196',
			Кемчуг: '39154',
			Кетский: '39166',
			Кирсантьево: '39141',
			Кирчиж: '39150',
			Кияй: '39149',
			Ключи: '39151',
			Кодинск: '39143',
			Кожаны: '39148',
			Козулька: '39154',
			Колбинский: '39149',
			Колмогорово: '39195',
			Колон: '39167',
			Кома: '39147',
			Кононово: '39119',
			Кордово: '39136',
			Коростелево: '39174',
			Кортуз: '39134',
			Костино: '39190',
			Кочергино: '39136',
			Кошурниково: '39136',
			Красная: '39148',
			Красногорьевский: '39162',
			Краснокаменск: '39136',
			Краснотуранск: '39134',
			Красноярск: '391',
			Кривляк: '39195',
			Критово: '39157',
			Кулаково: '39141',
			Кулижниково: '39142',
			Кулун: '39156',
			Курагино: '39136',
			Курай: '39167',
			Курейка: '39172',
			Курское: '39136',
			Курыш: '39167',
			Кучердаевка: '39173',
			Кучерово: '39171',
			Кытат: '39159',
			Лазарево: '39158',
			Лазурный: '39154',
			Лакино: '39118',
			Лапшиха: '39151',
			Лебяжье: '39134',
			Легостаево: '39147',
			Леонтьевка: '39158',
			Лесосибирск: '39145',
			Локшино: '39156',
			Лугавское: '39132',
			Луговское: '39118',
			Лужки: '39164',
			Маганск: '39175',
			Мазульский: '39151',
			Майский: '39139',
			Майское: '39195',
			Малиновка: '39151',
			Мана: '39140',
			Манзя: '39162',
			Маринино: '39136',
			Марьевка: '39146',
			Маталассы: '39150',
			Машуковка: '39141',
			Межево: '39142',
			Межово: '39118',
			Мельничное: '39174',
			Мигна: '39138',
			Мина: '39140',
			Миндерла: '39119',
			Минино: '39133',
			Минусинск: '39132',
			Можарка: '39136',
			Мокруша: '39161',
			Мокрушинское: '39196',
			Момотово: '39196',
			Мостовское: '39118',
			Моторское: '39137',
			Мотыгино: '39141',
			Мотыгинский: '39141',
			Нагорное: '39142',
			Назарово: '39155',
			Назимово: '39195',
			Нарва: '39149',
			Нахвальское: '39119',
			Невонка: '39162',
			Недокура: '663498',
			Нижнесуэтук: '39138',
			Нижнетерянск: '39162',
			Николаевка: '39134',
			Новгородка: '39173',
			Новоалександровка: '39171',
			Новоалтатка: '39153',
			Новоангарск: '39141',
			Новоберезовка: '39135',
			Новобирилюссы: '39150',
			Новокамала: '39165',
			Новомитрополька: '39158',
			Новоназимово: '39195',
			Новопетровка: '39157',
			Новопокровка: '39173',
			Новополтавка: '39138',
			Новопятницкое: '39146',
			Новоселово: '39147',
			Новоуспенка: '39163',
			Новохайский: '39162',
			Новочернореченский: '39154',
			Новый: '39167',
			Норильск: '3919',
			Овсянка: '39144',
			Огур: '39148',
			Ойский: '39138',
			Ойха: '39136',
			Октябрьский: '39162',
			Ораки: '39153',
			Орджоникидзе: '39141',
			Орешное: '39149',
			Орье: '39142',
			Отрок: '39135',
			Ошарово: '39171',
			Павловка: '39171',
			Павловщина: '39119',
			Пакатеево: '39163',
			Паново: '39143',
			Парная: '39153',
			Партизанск: '39141',
			Партизанское: '39140',
			Первомайск: '39141',
			Первомайский: '39133',
			Первоманск: '39149',
			Переясловка: '39165',
			Петропавловка: '39148',
			Пинчуга: '39162',
			Пировское: '39166',
			Пискуновка: '39196',
			Поваренкино: '39158',
			Погодаево: '39195',
			Подгорный: '39197',
			Подсопки: '39119',
			Подтесово: '39195',
			Пойлово: '39136',
			Поканаевка: '39171',
			Полевое: '39150',
			Поначево: '39136',
			Потапово: '39195',
			Почет: '39163',
			Предивинск: '39118',
			Преображенский: '39155',
			Приморск: '39148',
			Приозерный: '39155',
			Приреченск: '39156',
			Прихолмье: '39132',
			Причулымский: '39151',
			Проспихино: '663498',
			Проточный: '39150',
			Пятково: '39196',
			Раздолинск: '39141',
			Раздольное: '39118',
			Разъезжее: '39138',
			Рассвет: '39150',
			Ровное: '39148',
			Родники: '39153',
			Романовка: '39135',
			Российка: '39118',
			Роща: '39146',
			Рощинский: '39136',
			Рудяное: '39161',
			Сагайское: '39137',
			Самойловка: '39163',
			Сахапта: '39155',
			Саянск: '39134',
			Саянский: '39165',
			Светлогорск: '39172',
			Светлолобово: '39147',
			Селиваниха: '39132',
			Семенниково: '39138',
			Семеновка: '39146',
			Сивохино: '39164',
			Сизая: '39139',
			Синеборск: '39139',
			Слизнево: '39144',
			Снежногорск: '39193',
			Солнечный: '39156',
			Солоуха: '39166',
			Сосновоборск: '39131',
			Сотниково: '39161',
			Сплавной: '39158',
			Степановка: '39174',
			Степной: '39155',
			Степняки: '39161',
			Стойба: '39140',
			Стрелка: '39145',
			Стретенка: '39171',
			Субботино: '39139',
			Сургутиха: '39190',
			Сурикова: '39150',
			Сухобузимское: '39199',
			Сухово: '39164',
			Сухоной: '39146',
			Сучково: '39159',
			Сушиновка: '39146',
			Тагара: '39143',
			Таежка: '39159',
			Тайна: '39161',
			Талая: '39133',
			Талнах: '3919',
			Таловка: '39118',
			Талое: '39174',
			Танзыбей: '39138',
			Тарутино: '39151',
			Тасеево: '39164',
			Таскино: '39137',
			Терское: '39161',
			Тертеж: '39149',
			Тесь: '39132',
			Тея: '39114',
			Тигрицкое: '39132',
			Тинской: '39171',
			Тины: '39171',
			Токучет: '39162',
			Толстихино: '39146',
			Топол: '39167',
			Троица: '39166',
			Троицк: '39164',
			Тубинск: '39134',
			Тугач: '39142',
			Тумаково: '39174',
			Тура: '39170',
			Туруханск: '39190',
			Туруханский: '39190',
			Тюльково: '39148',
			Тюхтет: '39158',
			Удачное: '39159',
			Ужур: '39156',
			Улюколь: '39167',
			Унер: '39142',
			Урал: '39165',
			Уральская: '39136',
			Усолка: '39167',
			Усольцева: '663498',
			Успенка: '39165',
			Устьянск: '39163',
			Устюг: '39133',
			Уяр: '39146',
			Фаначет: '39164',
			Фарково: '39190',
			Филимоново: '39161',
			Хаерино: '39161',
			Хайрюзовка: '39173',
			Хандала: '39164',
			Хандальск: '39163',
			Хатангский: '39176',
			Хлоптуново: '39119',
			Холмогорское: '39153',
			Хребтовый: '39162',
			Центральный: '39135',
			Чайковский: '39157',
			Частоостровское: '39133',
			Черемушка: '39137',
			Черемушки: '39148',
			Черемшанка: '39136',
			Чечеул: '39161',
			Чибижек: '39136',
			Чиндат: '39158',
			Чулым: '39147',
			Чунояр: '39162',
			Шадрино: '39154',
			Шалаболино: '39136',
			Шалинское: '39149',
			Шапкино: '39195',
			Шарыпово: '39153',
			Шиверский: '39162',
			Шила: '39119',
			Шилинка: '39119',
			Шириштык: '39137',
			Шошино: '39132',
			Шунеры: '39139',
			Шушенское: '39139',
			Шушь: '39153',
			Элита: '39133',
			Юксеево: '39118',
			Юрьевка: '39157',
			Ярки: '39162',
			Яркино: '663498',
			Ярцево: '39195',
			Ястребово: '39151'
		}
	},
	'Курганская область': {
		regionCode: '352',
		cities: {
			'Белоярка-первая': '35252',
			'Большая Рига': '35245',
			'Большое Банниково': '35256',
			'Большое Гусиное': '35235',
			'Большое Дубровное': '35241',
			'Большое Зарослое': '35232',
			'Большое Кабанье': '35253',
			'Большое Каменное': '35235',
			'Большое Касаргульское': '35251',
			'Большое Курейное': '35236',
			'Большое Моховое': '35237',
			'Большое Приютное': '35235',
			'Большое Просеково': '35233',
			'Большое Раково': '35231',
			'Большое Султаново': '35243',
			'Большое Чаусово': '35231',
			'Большой Камаган': '35232',
			'Верхние Пески': '35251',
			'Верхняя Алабуга': '35240',
			'Верхняя Полевая': '35253',
			'Верхняя Теча': '35251',
			'Дальняя Кубасова': '35257',
			'Казак-Кочердык': '35241',
			'Костыгин Лог': '35241',
			'Красная Звезда': '35253',
			'Красная Нива': '35253',
			'Красный Октябрь': '35256',
			'Красный Уралец': '35248',
			'Крутая Горка': '35245',
			'Малое Белое': '35248',
			'Малое Дюрягино': '35245',
			'Малое Мостовское': '35234',
			'Малое Окунево': '35247',
			'Нижний Яр': '35252',
			'Новая Сидоровка': '35231',
			'Новогеоргиевка-вторая': '35235',
			'Новое Ильинское': '35235',
			'Новые Байдары': '35238',
			'Новые Пески': '35247',
			'Новый Мир': '35248',
			'Отряд Алабуга': '35240',
			'Сарт-Абдрашево': '35243',
			'Светлые Поляны': '35231',
			'Светлый Дол': '35232',
			'Старый Просвет': '35231',
			'Труд и Знание': '35240',
			'Усть-Миасское': '35256',
			'Усть-Уйское': '35241',
			'Ясная Поляна': '35252',
			Агапино: '35253',
			Аджитарово: '35243',
			Актабан: '35235',
			Альменево: '35242',
			Арлагуль: '35237',
			Байдары: '35238',
			Байрак: '35253',
			Бакланское: '35256',
			Балакуль: '35237',
			Барашково: '35233',
			Барино: '35257',
			Басказык: '35251',
			Басковское: '35236',
			Батурино: '35253',
			Бахарево: '35256',
			Башкирское: '35238',
			Баярак: '35232',
			Белозерское: '35232',
			Белоногово: '35249',
			Белоусова: '35256',
			Белоярское: '35244',
			Беляковское: '35230',
			Белянино: '35237',
			Благовещенское: '35245',
			Богданы: '35235',
			Боровичи: '35243',
			Бороздинка: '35242',
			Борчаниново: '35253',
			Брылино: '35256',
			Бугаево: '35251',
			Бугровое: '35240',
			Булдак: '35238',
			Бутырино: '35230',
			Бутырское: '35247',
			Вагино: '35232',
			Варгановское: '35244',
			Варгаши: '35233',
			Варлаково: '35247',
			Введенское: '35231',
			Верхнеберезово: '35239',
			Верхнее: '35249',
			Верхнеключевское: '35251',
			Верхнесуерское: '35233',
			Верхозино: '35253',
			Вилкино: '35248',
			Воздвиженка: '35241',
			Вознесенское: '35252',
			Волчье: '35230',
			Воробьи: '35235',
			Воскресенское: '35238',
			Восточное: '35230',
			Восход: '35247',
			Вохменка: '35248',
			Вяткино: '35256',
			Гаганово: '35247',
			Гагарье: '35248',
			Галкино: '35245',
			Ганино: '35253',
			Гладковское: '35239',
			Гладышево: '35247',
			Глубокое: '35253',
			Глядянское: '35239',
			Головное: '35237',
			Горбунешное: '35235',
			Горохово: '35248',
			Давыдовка: '35239',
			Далматово: '35252',
			Даньково: '35244',
			Демино: '35253',
			Денисово: '35230',
			Дмитриевка: '35234',
			Долгие: '35230',
			Долговка: '35249',
			Долговское: '35256',
			Дрянново: '35253',
			Дулино: '35241',
			Дундино: '35233',
			Елошное: '35237',
			Жидки: '35235',
			Житниковское: '35256',
			Жуково: '35249',
			Журавлево: '35256',
			Зайково: '35244',
			Закомалдино: '35249',
			Закоулово: '35249',
			Заманилки: '35241',
			Затеченское: '35252',
			Зауральская: '35256',
			Звериноголовское: '35240',
			Зеленоборское: '35253',
			Золотое: '35236',
			Зотино: '35235',
			Зубаревка: '35240',
			Зырянка: '35251',
			Зюзино: '35232',
			Иванково: '35242',
			Иванковское: '35247',
			Изъедугино: '35257',
			Иковка: '35231',
			Ильино: '35257',
			Ильинское: '35251',
			Ильтяково: '35253',
			Искра: '35240',
			Ичкино: '35253',
			Казанцева: '35251',
			Казаркино: '35236',
			Казенное: '35242',
			Калашное: '35237',
			Камаган: '35249',
			Каменное: '35245',
			Каминское: '35249',
			Камышевка: '35257',
			Камыши: '35249',
			Канаши: '35253',
			Карасево: '35243',
			Караси: '35248',
			Карачельское: '35245',
			Каргаполье: '35256',
			Карпунино: '35234',
			Катайск: '35251',
			Каширино: '35231',
			Каясан: '35244',
			Кетово: '35231',
			Кирово: '35247',
			Кислянка: '35241',
			Кислянское: '35248',
			Клюквенное: '35236',
			Ключевское: '35252',
			Ключики: '35249',
			Коврига: '35253',
			Кодское: '35257',
			Кокорина: '35253',
			Колесниково: '35253',
			Колташево: '35231',
			Кондинское: '35257',
			Коновалова: '35249',
			Коновалово: '35236',
			Коровье: '35247',
			Корюково: '35251',
			Косолапово: '35241',
			Костылево: '35249',
			Косулино: '35249',
			Красногорка: '35240',
			Краснознаменское: '35247',
			Красноисетское: '35252',
			Красномыльское: '35253',
			Красноярское: '35244',
			Крепость: '35234',
			Крестовка: '35252',
			Кривское: '35252',
			Круглое: '35240',
			Крутиха: '35252',
			Кулаш: '35248',
			Купай: '35247',
			Курган: '3522',
			Куртамыш: '35249',
			Куртан: '35234',
			Кушма: '35245',
			Кызылбай: '35257',
			Лапушки: '35234',
			Лебяжье: '35237',
			Лесниково: '35231',
			Лисье: '35237',
			Лиханово: '35230',
			Лихачи: '35233',
			Лобаново: '35251',
			Лопарево: '35234',
			Лопатки: '35237',
			Майка: '35244',
			Майлык: '35242',
			Майский: '35256',
			Макарово: '35253',
			Макушино: '35236',
			Малышево: '35242',
			Мальцево: '35253',
			Мансурово: '35243',
			Марково: '35231',
			Мартино: '35236',
			Мартыновка: '35243',
			Масли: '35247',
			Маслянское: '35253',
			Матасы: '35235',
			Матвеевка: '35241',
			Медведское: '35244',
			Медвежье: '35233',
			Межборное: '35239',
			Мехонское: '35257',
			Мингали: '35253',
			Мир: '35242',
			Митино: '35231',
			Михайловка: '35234',
			Михалево: '35241',
			Мишкино: '35247',
			Мокроусово: '35234',
			Мокрушино: '35247',
			Моршиха: '35236',
			Моховое: '35236',
			Мыльниково: '35253',
			Мыркайское: '35247',
			Мясниково: '35252',
			Нагорское: '35239',
			Надеждинка: '35243',
			Налимово: '35237',
			Неверовское: '35236',
			Неонилинское: '35253',
			Нечунаево: '35256',
			Нижетобольное: '35232',
			Нижнеглубокое: '35237',
			Нижнее: '35249',
			Нижнеполевское: '35253',
			Никитинское: '35251',
			Николаевка: '35244',
			Новоберезово: '35235',
			Новодостовалово: '35232',
			Новоиковское: '35256',
			Новопетропавловское: '35252',
			Новотроицкое: '35230',
			Обанино: '35249',
			Обутковское: '35236',
			Обухово: '35239',
			Одино: '35234',
			Ожогино: '35257',
			Озерное: '35240',
			Октябрь: '35253',
			Октябрьское: '35235',
			Окуневское: '35256',
			Ольховка: '35253',
			Осиновское: '35256',
			Ошурково: '35233',
			Падеринское: '35231',
			Памятное: '35232',
			Парамоново: '35242',
			Параткуль: '35252',
			Пашково: '35235',
			Пепелино: '35249',
			Первомайское: '35247',
			Перевалово: '35249',
			Першино: '35232',
			Першинское: '35252',
			Песчаноколедино: '35252',
			Песчанотаволжанское: '35253',
			Песчанское: '35244',
			Петропавловское: '35251',
			Петухи: '35245',
			Петухово: '35235',
			Пивкино: '35244',
			Пименовка: '35231',
			Пионерское: '35236',
			Пичугино: '35233',
			Пищальное: '35238',
			Плановый: '35244',
			Плоское: '35237',
			Плотниково: '35239',
			Погорелка: '35253',
			Половинное: '35238',
			Полой: '35234',
			Понькино: '35253',
			Попово: '35233',
			Привольное: '35238',
			Прилогино: '35237',
			Притобольное: '35239',
			Прогресс: '35253',
			Прорывное: '35240',
			Прошкино: '35245',
			Птичье: '35245',
			Пуктыш: '35244',
			Пушкино: '35249',
			Пьянково: '35232',
			Раскатиха: '35239',
			Рассвет: '35234',
			Рачеевка: '35241',
			Редуть: '35240',
			Редькино: '35232',
			Речное: '35237',
			Рынки: '35235',
			Рычково: '35232',
			Садовое: '35231',
			Сажино: '35245',
			Самохвалово: '35257',
			Сафакулево: '35243',
			Сетовное: '35236',
			Сетово: '35241',
			Сивково: '35230',
			Скаты: '35232',
			Скоблино: '35248',
			Скопино: '35232',
			Слевное: '35236',
			Смирново: '35252',
			Советское: '35249',
			Соколовка: '35251',
			Соколово: '35256',
			Соровское: '35253',
			Сосновка: '35256',
			Сосновское: '35253',
			Спицыно: '35257',
			Спорное: '35233',
			Становая: '35231',
			Становое: '35241',
			Стариково: '35245',
			Старопершино: '35234',
			Стеклозавод: '35232',
			Степное: '35236',
			Стрельцы: '35235',
			Строево: '35233',
			Субботино: '35243',
			Сулейманово: '35243',
			Сулюклино: '35243',
			Сумки: '35238',
			Сунгурова: '35234',
			Сухмень: '35238',
			Сухоборское: '35244',
			Сухринское: '35253',
			Тагильское: '35256',
			Таловка: '35248',
			Тамакульское: '35252',
			Танрыкулово: '35242',
			Твердыш: '35256',
			Терсюкское: '35257',
			Топорищево: '35253',
			Травное: '35234',
			Травяное: '35245',
			Требушинное: '35236',
			Трехозерки: '35241',
			Троицкое: '35235',
			Трусилово: '35245',
			Трюхино: '35236',
			Уварово: '35234',
			Уксянское: '35252',
			Улугушское: '35251',
			Уральцевское: '35252',
			Утчанское: '35235',
			Ушаковское: '35251',
			Фадюшино: '35248',
			Фрунзе: '35253',
			Хлупово: '35238',
			Хохлы: '35245',
			Хутора: '35237',
			Целинное: '35241',
			Центральное: '35237',
			Частоозерье: '35230',
			Чаши: '35256',
			Чашинский: '35231',
			Чебаки: '35236',
			Чемякина: '35256',
			Чердынцево: '35230',
			Черемисское: '35253',
			Черемушки: '35237',
			Чернавское: '35239',
			Черноборье: '35249',
			Чесноки: '35231',
			Чимеево: '35232',
			Чинеево: '35248',
			Чистопрудное: '35253',
			Чулошное: '35238',
			Чумляк: '35244',
			Шадринск: '35253',
			Шаламово: '35247',
			Шарипово: '35242',
			Шастово: '35233',
			Шатрово: '35257',
			Шахматово: '35253',
			Шелепово: '35234',
			Широково: '35257',
			Широковское: '35252',
			Шкодинское: '35231',
			Шумиха: '35245',
			Шутино: '35251',
			Шутихинское: '35251',
			Шуткино: '35256',
			Щигры: '35234',
			Щучье: '35244',
			Юламаново: '35242',
			Юлдус: '35253',
			Юргамыш: '35248',
			Яблочное: '35233',
			Ягодное: '35242',
			Язовка: '35252',
			Яланское: '35243',
			Ялым: '35239',
			Ярки: '35249',
			Яровое: '35238',
			Ярославское: '35239',
			Яутла: '35257'
		}
	},
	'Курская область': {
		regionCode: '471',
		cities: {
			'Анпилогово-Первое': '4712',
			'Банино-Первое': '47144',
			'Безлесное-Второе': '4712',
			'Белая Слобода': '47149',
			'Белый Колодезь': '47151',
			'Большая Алешня': '47137',
			'Большие Бутырки': '47155',
			'Большие Крюки': '47134',
			'Большие Сети': '47134',
			'Большие Угоны': '47140',
			'Большое Анненково': '47144',
			'Большое Долженково': '47142',
			'Большое Жирово': '47144',
			'Большое Солдатское': '47136',
			'Большое Шумаково': '4712',
			'Большой Змеинец': '47145',
			'Вереитиново-Первое': '47151',
			'Верхние Апочки': '47145',
			'Верхний Любаж': '47144',
			'Верхний Реутец': '47146',
			'Верхний Хотемль': '47144',
			'Верхняя Грайворонка': '47157',
			'Верхняя Гремячка': '47145',
			'Верхняя Груня': '47147',
			'Верхняя Медведица': '4712',
			'Верхняя Ольшанка': '47134',
			'Верхняя Соковнинка': '47156',
			'Воробьевка-Вторая': '47151',
			'Воробьевка-Первая': '47151',
			'Вышние Деревеньки': '47140',
			'Вышний Дубовец': '47146',
			'Гостомля-Первая': '47146',
			'Дмитриев-Льговский': '47150',
			'Долгие Буды': '47149',
			'Дорохо-Доренское': '47154',
			'Засеймье-Второе': '47155',
			'Засеймье-Первое': '47155',
			'Зеленая Роща': '47145',
			'Казанка-Вторая': '47151',
			'Казачья Локня': '47143',
			'Китаевка-Первая': '47146',
			'Конево-Первое': '47151',
			'Кривицкие Буды': '47149',
			'Кромские Быки': '47140',
			'Липовец-Первый': '47146',
			'Макаро-Петровское': '47156',
			'Малая Локня': '47143',
			'Малое Городьково': '47156',
			'Малое Солдатское': '47149',
			'Малые Крюки': '47141',
			'Малый Каменец': '47136',
			'Маршала Жукова': '4712',
			'Махов Колодезь': '47136',
			'Мелехино-Второе': '47145',
			'Моква-Первая': '4712',
			'Нижнее Бабино': '47141',
			'Нижнее Гридино': '47136',
			'Нижнее Гурово': '47145',
			'Нижнее Жданово': '47148',
			'Нижнее Песочное': '47156',
			'Нижнее Солотино': '47141',
			'Нижнее Чупахино': '47137',
			'Нижние Борки': '47133',
			'Нижние Деревеньки': '47140',
			'Нижние Халчи': '47144',
			'Нижний Мордок': '47132',
			'Нижний Реут': '47144',
			'Нижний Реутец': '47146',
			'Нижний Теребуж': '47145',
			'Нижняя Грайворонка': '47145',
			'Нижняя Груня': '47147',
			'Новая Першина': '47150',
			'Новоспасское-Первое': '47151',
			'Новые Савины': '47159',
			'Панино-Первое': '47146',
			'Петрово-Карцево': '47145',
			'Поныри-Вторые': '47135',
			'Поныри-Первые': '47135',
			'Попово-Лежачи': '47132',
			'Посёлок имени Карла Либкнехта': '47131',
			'Пригородная слободка': '47140',
			'Репецкая Плата': '47155',
			'Рогозецкий Колодезь': '47153',
			'Русское Поречное': '47143',
			'Рыбинские Буды': '47141',
			'Сельский Рогачик': '47159',
			'Семеновка-Первая': '47145',
			'Средние Апочки': '47133',
			'Средний Расховец': '47145',
			'Средняя Ольшанка': '47134',
			'Старая Белица': '47156',
			'Старое Роговое': '47133',
			'Старые Савины': '47159',
			'Старый Бузец': '47148',
			'Старый Лещин': '47154',
			'Стремоухово-Бобрик': '47140',
			'Толстый Колодезь': '47159',
			'Цуканово-Бобрик': '47140',
			'Черкасское Поречное': '47143',
			'Черный Олех': '47143',
			'Яньково-Первое': '47152',
			'поселок Большой Дуб': '47148',
			'поселок Касторное': '47157',
			'село 1-е Винниково': '4712',
			'слобода Белая': '47149',
			Ажово: '47148',
			Акимовка: '47152',
			Александровский: '47157',
			Алексеевка: '47132',
			Алисово: '47144',
			Алябьева: '47142',
			Амонь: '47137',
			Амосовка: '47146',
			Анастасьевка: '47140',
			Анахино: '4712',
			Андреевка: '47157',
			Апанасовка: '47147',
			Арбузово: '47156',
			Артюховка: '47142',
			Артюшково: '47152',
			Асмолово: '47152',
			Афанасьево: '47141',
			Банищи: '47140',
			Бараново: '47133',
			Барковка: '47153',
			Басовка: '47144',
			Башкатово: '47141',
			Бегичево: '47141',
			Бегоща: '47152',
			Безлепкино: '47155',
			Бекетовский: '47133',
			Белая: '47149',
			Белгородка: '47133',
			Белица: '47149',
			Белогорье: '47157',
			Беляево: '47156',
			Береза: '47150',
			Березники: '47152',
			Березовец: '47135',
			Березово: '47133',
			Беседино: '4712',
			Бирюковка: '47136',
			Благодатное: '47147',
			Бобрава: '47149',
			Бобровка: '47135',
			Бобрышево: '47134',
			Богатырево: '47133',
			Богородицкое: '47133',
			Болото: '47133',
			Большегнеушево: '47152',
			Большенизовцево: '47152',
			Борисовка: '47140',
			Борки: '47143',
			Боровка: '47133',
			Борщень: '47136',
			Брусовое: '47135',
			Будановка: '47151',
			Бунино: '47154',
			Бупел: '47137',
			Бурцевка: '47155',
			Бушмено: '47141',
			Быканово: '47141',
			Быки: '47131',
			Быково: '47133',
			Быстрецы: '47153',
			Бычок: '47157',
			Вабля: '47156',
			Введенка: '47153',
			Веретенино: '47148',
			Верхнеплоское: '47134',
			Верхотопье: '47157',
			Веселое: '47132',
			Веть: '47137',
			Виногробль: '4712',
			Вислое: '47133',
			Вихровка: '47134',
			Вишневка: '47145',
			Вишнево: '47149',
			Владимировка: '47134',
			Внезапное: '47147',
			Вознесеновка: '47157',
			Возы: '47135',
			Волково: '47148',
			Волобуевка: '47153',
			Волоконск: '47136',
			Волфино: '47132',
			Воробжа: '47143',
			Воробьевка: '47154',
			Воронок: '47152',
			Воскресеновка: '47153',
			Выползово: '47154',
			Вышнеольховатое: '47145',
			Вязовое: '47145',
			Гахово: '47146',
			Генеральшино: '47150',
			Глазово: '47156',
			Гламаздино: '47137',
			Глебовщина: '47144',
			Глушково: '47132',
			Гнилое: '47153',
			Гнилуши: '47153',
			Гоголевка: '47143',
			Головище: '47133',
			Гололобовка: '47154',
			Голощаповка: '47145',
			Голубовка: '47137',
			Горки: '47144',
			Горналь: '47143',
			Городенск: '47140',
			Городище: '47145',
			Городное: '47148',
			Горшечное: '47133',
			Горяиново: '47157',
			Горяйново: '47135',
			Гочево: '47149',
			Гремячка: '47151',
			Гридасово: '47141',
			Гряды: '47156',
			Грязное: '47145',
			Губановка: '47146',
			Гуево: '47143',
			Густомой: '47140',
			Гущино: '47155',
			Дарьино: '47143',
			Дежевка: '47154',
			Деменино: '47137',
			Демякино: '47151',
			Деревеньки: '47140',
			Дерлово: '47151',
			Дерюгино: '47150',
			Дичня: '47131',
			Длинная: '47145',
			Дмитриев: '47150',
			Дмитриевка: '47151',
			Доброе: '47154',
			Долгий: '47136',
			Долженково: '47141',
			Донское: '47151',
			Дроновка: '47132',
			Дубовица: '47137',
			Дурово: '47152',
			Дьяконово: '47142',
			Евгеньевка: '47157',
			Егорьевка: '47157',
			Еринка: '47134',
			Ефремовка: '47159',
			Ефросимово: '47137',
			Жеденовка: '47137',
			Железногорск: '47148',
			Жигаево: '47156',
			Забужевка: '47149',
			Замостье: '47143',
			Заолещенка: '47143',
			Заповедный: '4712',
			Заречье: '47155',
			Захарково: '47156',
			Защитное: '47145',
			Званное: '47132',
			Звенячка: '47137',
			Зиборово: '47151',
			Знаменка: '47133',
			Золотухино: '47151',
			Зорино: '47141',
			Зуевка: '47154',
			Иванино: '47131',
			Ивановка: '47133',
			Ивановское: '47152',
			Иванчиково: '47140',
			Ивница: '47143',
			Игино: '47144',
			Игишево: '47135',
			Износково: '47140',
			Илек: '47149',
			Ильинка: '47134',
			Исаково: '47159',
			Искра: '47137',
			Калиновка: '47137',
			Каменка: '47141',
			Каменогорка: '47145',
			Камынино: '47141',
			Камыши: '4712',
			Камышное: '47149',
			Канищево: '47153',
			Капыстичи: '47152',
			Карманово: '47148',
			Карыж: '47132',
			Касимовка: '47145',
			Касиновский: '4712',
			Касторное: '47157',
			Кашара: '47156',
			Киреевка: '47143',
			Кирилловка: '47145',
			Кировка: '47153',
			Кировский: '47134',
			Клевень: '47137',
			Клишино: '47148',
			Клюква: '4712',
			Ключ: '47133',
			Кобылки: '47132',
			Кожля: '47131',
			Козино: '47152',
			Колбасовка: '47134',
			Колонтаевка: '47140',
			Колычево: '47144',
			Комаровка: '47147',
			Коммунар: '47149',
			Кондратовка: '47149',
			Конышевка: '47156',
			Копенки: '47148',
			Коренево: '47147',
			Коробкино: '47150',
			Коровяковка: '47132',
			Корочка: '47149',
			Косиново: '47141',
			Косоржа: '47145',
			Костельцево: '47131',
			Кострова: '47152',
			Котельниково: '47141',
			Котлево: '47156',
			Котовка: '47157',
			Котово: '47134',
			Кочановка: '47140',
			Кошкино: '47150',
			Красниково: '47134',
			Краснооктябрьское: '47147',
			Кремяное: '47147',
			Крестище: '47145',
			Кривец: '47155',
			Кривцовка: '47145',
			Кромская: '47144',
			Крупец: '47152',
			Крутое: '47145',
			Кудинцево: '47140',
			Кулевка: '47133',
			Кулига: '47152',
			Куликовка: '47145',
			Кульбаки: '47132',
			Кунье: '47133',
			Курица: '4712',
			Куркино: '4712',
			Курносовка: '47145',
			Курск: '4712',
			Курчатов: '47131',
			Куськино: '47155',
			Кучеровка: '47149',
			Кшенский: '47158',
			Кшень: '47145',
			Лачиново: '47157',
			Лебедевка: '47143',
			Лебяжье: '4712',
			Левшинка: '47140',
			Ледовское: '47145',
			Леженьки: '47153',
			Ленинский: '47135',
			Леоновка: '47136',
			Лещиновка: '47132',
			Линец: '47148',
			Лобазовка: '47142',
			Локоть: '47152',
			Ломакино: '47152',
			Луговое: '47137',
			Льгов: '47140',
			Любостань: '47136',
			Магнитный: '47148',
			Мазеповка: '47152',
			Макаровка: '47131',
			Макеево: '47152',
			Малеевка: '47137',
			Малиновый: '4712',
			Малогнеушево: '47152',
			Мансурово: '47145',
			Мантурово: '47155',
			Марица: '47140',
			Марково: '47132',
			Мартыновка: '47143',
			Марьино: '47152',
			Махновка: '47143',
			Машкино: '47156',
			Медвенка: '47146',
			Мелавка: '47157',
			Мелавский: '47133',
			Меловое: '47150',
			Меньшиково: '47137',
			Мерцаловка: '47146',
			Миленино: '47144',
			Миролюбово: '47144',
			Мокрушино: '47149',
			Молотычи: '47144',
			Моршнево: '47150',
			Мосолово: '47131',
			Муравлево: '4712',
			Мухино: '47137',
			Мяснянка: '47155',
			Мяснянкино: '47159',
			Нагольное: '47134',
			Надеждовка: '47140',
			Надейка: '47137',
			Натальино: '47145',
			Наумовка: '47156',
			Неварь: '47150',
			Некрасово: '47152',
			Нехаевка: '47152',
			Ниженка: '47159',
			Нижнемахово: '47143',
			Нижнеольховатое: '47159',
			Нижнесмородино: '47135',
			Никитское: '47159',
			Никольниково: '47152',
			Никольский: '47131',
			Новоандросово: '47148',
			Новодворский: '47157',
			Новоивановка: '47143',
			Новокасторное: '47157',
			Новомеловое: '47133',
			Новопоселеновка: '4712',
			Новоселки: '47144',
			Новосергеевка: '47131',
			Ноздрачево: '4712',
			Обеста: '47152',
			Обоянь: '47141',
			Обуховка: '47147',
			Огневка: '47159',
			Олым: '47157',
			Олымский: '47157',
			Ольговка: '47147',
			Ольховатка: '47135',
			Ольховка: '47137',
			Ольшанка: '47140',
			Орехово: '47157',
			Орлянка: '47154',
			Останино: '47155',
			Отрадное: '47154',
			Отрешково: '4712',
			Охочевка: '47145',
			Павловка: '47141',
			Пальцево: '47150',
			Паники: '47146',
			Пенский: '47149',
			Первоавгустовский: '47150',
			Первомайское: '47135',
			Переволочное: '47145',
			Переступлено: '47137',
			Песчаное: '47149',
			Петраковка: '47150',
			Платава: '47156',
			Плехово: '47143',
			Плоское: '47154',
			Плотава: '47142',
			Погодино: '47150',
			Погожее: '47153',
			Погребки: '47143',
			Поды: '47137',
			Пойменово: '47151',
			Полевая: '4712',
			Поныри: '47135',
			Поповка: '47152',
			Поповкино: '47150',
			Почепное: '47150',
			Пригородный: '47141',
			Пристенное: '47134',
			Пристень: '47134',
			Приходьково: '47137',
			Пронское: '4712',
			Прямицыно: '47142',
			Пселец: '47134',
			Пузачи: '47155',
			Разветье: '47148',
			Разгребли: '47136',
			Раздолье: '47157',
			Ракитинка: '47134',
			Расховец: '47145',
			Репец: '47155',
			Речица: '47140',
			Ржавец: '47133',
			Роговое: '47155',
			Рогозцы: '47153',
			Родительское: '47151',
			Рождественка: '47153',
			Рудавец: '47141',
			Рудавский: '47141',
			Русаново: '47159',
			Рыльск: '47152',
			Садовый: '47145',
			Сазановка: '47134',
			Сальное: '47137',
			Саморядово: '47136',
			Сапогово: '4712',
			Сараевка: '47154',
			Сафоновка: '47147',
			Свердликово: '47143',
			Свинец: '47155',
			Свобода: '47151',
			Седмиховка: '47151',
			Сейм: '47155',
			Селекционный: '47140',
			Семеновка: '47157',
			Сергиевское: '47151',
			Сидоровка: '47145',
			Сковороднево: '47137',
			Скородное: '47136',
			Снагость: '47147',
			Снецкое: '47148',
			Снижа: '47150',
			Соколье: '47153',
			Солдатское: '47144',
			Солдаты: '47148',
			Солнечный: '47151',
			Солнцево: '47154',
			Сомовка: '47133',
			Сопеловка: '47131',
			Сосновка: '47133',
			Сотниково: '47144',
			Спасское: '47146',
			Среднедорожное: '47133',
			Стаканово: '47159',
			Старково: '47142',
			Старомеловое: '47133',
			Старшее: '47137',
			Степановка: '47152',
			Сторожевое: '47136',
			Стоянова: '47142',
			Стрекалово: '47137',
			Стрелецкое: '47141',
			Струковка: '47145',
			Стужень: '47155',
			Субботино: '47154',
			Сугрово: '47140',
			Суджа: '47143',
			Суковкино: '47157',
			Сула: '47136',
			Сухая: '47152',
			Сухиновка: '47132',
			Тазово: '47151',
			Тарасово: '47146',
			Теплое: '47159',
			Тестово: '47145',
			Теткино: '47132',
			Тим: '47153',
			Толпино: '47147',
			Трояново: '47148',
			Трубеж: '47141',
			Удерево: '47159',
			Удобное: '47133',
			Уланок: '47143',
			Усланка: '47141',
			Ушаково: '47144',
			Фатеевка: '47150',
			Фатеж: '47144',
			Фентисово: '47151',
			Фитиж: '47140',
			Харасея: '47150',
			Хмелевое: '47144',
			Хомутовка: '47137',
			Цветочный: '47157',
			Чапли: '47131',
			Чаплыгина: '4712',
			Чекмаревка: '47141',
			Черемисиново: '47159',
			Черемошки: '47140',
			Черемушки: '4712',
			Черневка: '47150',
			Черницыно: '47142',
			Черничено: '47156',
			Черновец: '47134',
			Шевелево: '47141',
			Шептуховка: '47147',
			Шерекино: '47140',
			Шипы: '47141',
			Ширково: '47156',
			Шлях: '47154',
			Шмырево: '47141',
			Шуклино: '47144',
			Шумаково: '47154',
			Шустово: '47156',
			Щеголек: '47149',
			Щекино: '47152',
			Щетинка: '4712',
			Щигры: '47145',
			Эммануиловка: '47140',
			Юдинка: '47159',
			Юрьевка: '47156',
			Яндовище: '47156',
			Ясенки: '47133',
			Ясенок: '47144',
			Ястребовка: '47155',
			Яцено: '47156'
		}
	},
	'Ленинградская область': {
		regionCode: '813',
		cities: {
			'Апраксин Бор': '81361',
			'Большая Вруда': '81363',
			'Большая Ижора': '81376',
			'Большая Пустомержа': '81375',
			'Большие Коковичи': '81364',
			'Большие Колпаны': '81371',
			'Большие Сабицы': '81372',
			'Большие Шатновичи': '81372',
			'Большое Жабино': '81371',
			'Большое Куземкино': '81375',
			'Большое Ондорово': '81371',
			'Большое Поле': '81378',
			'Большой Двор': '81366',
			'Борисова Грива': '81370',
			'Великий Двор': '81366',
			'Дружная Горка': '81371',
			'Живой Ручей': '81372',
			'Зеленый Холм': '81378',
			'Красная Долина': '81378',
			'Красные Горы': '81372',
			'Красный Броневик': '81366',
			'Красный Вал': '81372',
			'Красный Маяк': '81372',
			'Красный Сокол': '81378',
			'Ладожское Озеро': '81370',
			'Липная Горка': '81367',
			'Лисино-Корпус': '81361',
			'Лодейное Поле': '81364',
			'Ломоносовский район': '81376',
			'Малое Карлино': '81376',
			'Мелегежская Горка': '81367',
			'Мошковые Поляны': '81372',
			'Нижние Осельки': '81370',
			'Новая Ладога': '81363',
			'Новое Девяткино': '81370',
			'Новый Свет': '81371',
			Петрово: '81371',
			'Попкова Гора': '81374',
			'Посёлок имени Морозова': '81370',
			'Русско-Высоцкое': '81376',
			'Санкт-Петербург': '812',
			'Сосновый Бор': '81369',
			'Среднее Село': '81368',
			'Старая Ладога': '81363',
			'Старая Малукса': '81362',
			'Старая Слобода': '81364',
			'Усть-Луга': '81375',
			'Хаппо-Ое': '81370',
			'Черная Речка': '81370',
			'Щеглово-Совхоз': '81370',
			'Ям-Тесово': '81372',
			'станция «Ладожское Озеро»': '81370',
			'станция «Петрокрепость»': '81362',
			Аврово: '81363',
			Агалатово: '81370',
			Алексеевка: '81375',
			Алексино: '81363',
			Алеховщина: '81364',
			Андреево: '81368',
			Андреевщина: '81364',
			Андрианово: '81361',
			Андронниково: '81367',
			Анино: '81376',
			Анисимово: '81366',
			Аннино: '81376',
			Астрача: '81366',
			Бабино: '81361',
			Батово: '81371',
			Бегуницы: '81363',
			Белогорка: '81371',
			Белое: '81372',
			Бережки: '81363',
			Березовик: '81367',
			Беседа: '81363',
			Бокситогорск: '81366',
			Боровое: '81372',
			Бугры: '81370',
			Будогощь: '81368',
			Ваганово: '81370',
			Важины: '81365',
			Васкелово: '81370',
			Васьково: '81366',
			Веймарн: '81375',
			Верево: '81371',
			Вещево: '81378',
			Виллози: '81376',
			Винницы: '81365',
			Вистино: '81375',
			Владимировка: '81379',
			Воейково: '81370',
			Вознесенье: '81365',
			Возрождение: '81378',
			Войсковицы: '81371',
			Войскорово: '81361',
			Володарское: '81372',
			Волосово: '81373',
			Волочаевка: '81378',
			Волошово: '81372',
			Волхов: '81363',
			Вруда: '81373',
			Всеволожск: '81370',
			Выборг: '81378',
			Выра: '81371',
			Вырица: '81371',
			Выскатка: '81374',
			Высоцк: '81378',
			Гаврилово: '81378',
			Ганьково: '81367',
			Гарболово: '81370',
			Гатчина: '81371',
			Гвардейское: '81378',
			Гимрека: '81365',
			Гладкое: '81361',
			Глажево: '81368',
			Глебычево: '81378',
			Глобицы: '81376',
			Голубково: '81372',
			Гончарово: '81378',
			Горбунки: '81376',
			Горка: '81367',
			Городец: '81372',
			Городище: '81368',
			Городок: '81372',
			Горьковское: '81378',
			Гостилицы: '81376',
			Гостинополье: '81363',
			Гремячево: '81368',
			Григино: '81367',
			Громово: '81379',
			Дивенская: '81371',
			Доможирово: '81364',
			Дубровка: '81370',
			Дятлово: '81378',
			Елизаветино: '81371',
			Ермилово: '81378',
			Ефимовский: '81366',
			Ефремково: '81364',
			Жемчужина: '81372',
			Житково: '81378',
			Журавлево: '81366',
			Забелино: '81366',
			Заборье: '81366',
			Заголодно: '81366',
			Загривье: '81374',
			Загубье: '81363',
			Зайцево: '81378',
			Заклинье: '81372',
			Запорожское: '81379',
			Заручье: '81374',
			Захонье: '81372',
			Зеленец: '81363',
			Зимитицы: '81373',
			Ивангород: '81375',
			Ивановское: '81375',
			Игнатовское: '81365',
			Извара: '81373',
			Ильжо: '81372',
			Ильичево: '81378',
			Имоченицы: '81364',
			Исаково: '81367',
			Иссад: '81363',
			Казыченская: '81365',
			Калитино: '81373',
			Каменногорск: '81378',
			Камышевка: '81378',
			Кармановская: '81365',
			Карташевская: '81371',
			Касколовка: '81375',
			Керстово: '81375',
			Кикерино: '81373',
			Кингисепп: '81375',
			Кингисеппский: '81375',
			Кипень: '81376',
			Кипрушино: '81365',
			Кирилловское: '81378',
			Кириши: '81368',
			Кировск: '81362',
			Кирпичное: '81378',
			Кирьямо: '81375',
			Кисельня: '81363',
			Климово: '81366',
			Клопицы: '81373',
			Кобона: '81362',
			Кобралово: '81371',
			Кобрино: '81371',
			Кобринское: '81371',
			Коваши: '81376',
			Колбеки: '81366',
			Коли: '81366',
			Колтуши: '81370',
			Колчаново: '81363',
			Коммунар: '81371',
			Коммунары: '81379',
			Комсомолец: '81371',
			Кондратьево: '81378',
			Копорье: '81376',
			Корбеничи: '81367',
			Коркино: '81361',
			Коробицыно: '81378',
			Коськово: '81367',
			Котельский: '81375',
			Котлы: '81375',
			Кошкино: '81375',
			Краколье: '81375',
			Красава: '81367',
			Красноармейское: '81379',
			Красноозерное: '81379',
			Красносельское: '81378',
			Кривко: '81379',
			Кузнечное: '81379',
			Кузра: '81365',
			Кузьмоловский: '81370',
			Куйвози: '81370',
			Кукуй: '81368',
			Курба: '81365',
			Курковицы: '81373',
			Куровицы: '81375',
			Кусино: '81368',
			Лаврово: '81362',
			Лаголово: '81376',
			Лампово: '81371',
			Ларионово: '81379',
			Ларьян: '81366',
			Лебяжье: '81376',
			Ленинское: '81378',
			Лесколово: '81370',
			Лесной: '81366',
			Лесобиржа: '81375',
			Лесогорский: '81378',
			Лесозавод: '81363',
			Логи: '81375',
			Ложголово: '81374',
			Ломоносов: '81376',
			Лопухинка: '81376',
			Лосево: '81378',
			Луга: '81372',
			Лукаши: '81371',
			Лукинская: '81365',
			Любань: '81361',
			Манихино: '81363',
			Матокса: '81370',
			Мга: '81362',
			Межозерный: '81372',
			Мельниково: '81379',
			Мехбаза: '81367',
			Миницкая: '81365',
			Михалево: '81378',
			Мичуринское: '81379',
			Мозолево: '81366',
			Молодцово: '81362',
			Молосковицы: '81373',
			Монастырек: '81374',
			Мотохово: '81368',
			Мурино: '81370',
			Мшинская: '81372',
			Наволок: '81372',
			Надкопанье: '81363',
			Надпорожье: '81364',
			Назия: '81362',
			Нежново: '81375',
			Низино: '81376',
			Низовская: '81372',
			Николаевское: '81372',
			Николаевщина: '81363',
			Никольский: '81365',
			Новая: '81366',
			Новинка: '81371',
			Новолисино: '81361',
			Нурма: '81361',
			Овсище: '81374',
			Овцино: '81370',
			Озерево: '81366',
			Озерное: '81376',
			Окулово: '81366',
			Оломна: '81368',
			Ольеши: '81366',
			Ополье: '81375',
			Оредеж: '81372',
			Оржицы: '81376',
			Островно: '81372',
			Осьмино: '81372',
			Отрадное: '81362',
			Павлово: '81362',
			Паша: '81363',
			Пашозеро: '81367',
			Пелдуши: '81365',
			Пельгора: '81361',
			Пельгорторф: '81361',
			Пеники: '81376',
			Первомайское: '81378',
			Перечицы: '81372',
			Перово: '81378',
			Пески: '81378',
			Песочное: '81378',
			Петровское: '81379',
			Пехенец: '81372',
			Печково: '81372',
			Пикалёво: '81366',
			Пирозеро: '81364',
			Плодовое: '81379',
			Плоское: '81372',
			Победа: '81378',
			Подборовье: '81366',
			Подвязье: '81363',
			Поддубье: '81372',
			Подпорожье: '81365',
			Поляны: '81378',
			Померанье: '81361',
			Поречье: '81374',
			Потанино: '81363',
			Поток: '81366',
			Починок: '81379',
			Прибытково: '81371',
			Приветнинское: '81378',
			Приладожский: '81362',
			Приморск: '81378',
			Приозерск: '81379',
			Пруды: '81378',
			Пудомяги: '81371',
			Пудость: '81371',
			Путилово: '81362',
			Пушное: '81378',
			Пчева: '81368',
			Пчевжа: '81368',
			Пяхта: '81367',
			Рабитицы: '81373',
			Радогощь: '81366',
			Радофинниково: '81361',
			Разбегаево: '81376',
			Раздолье: '81379',
			Разметелево: '81370',
			Раковно: '81372',
			Рапполово: '81370',
			Рассвет: '81364',
			Ратница: '81362',
			Рахья: '81370',
			Ребовичи: '81364',
			Рель: '81372',
			Реполка: '81373',
			Ретюнь: '81372',
			Решетниково: '81378',
			Рождествено: '81371',
			Романовка: '81371',
			Ромашки: '81379',
			Ропша: '81376',
			Рощино: '81378',
			Рыбежно: '81363',
			Рябово: '81361',
			Сабск: '81373',
			Саперное: '81379',
			Сарка: '81367',
			Сарожа: '81367',
			Светогорск: '81378',
			Свирица: '81363',
			Свирьстрой: '81364',
			Свободное: '81378',
			Севостьяново: '81379',
			Сегла: '81366',
			Селезнево: '81378',
			Селиваново: '81363',
			Сельхозтехника: '81374',
			Сельцо: '81373',
			Семиозерье: '81378',
			Семрино: '81371',
			Серебрянка: '81372',
			Сертолово: '81370',
			Сиверский: '81371',
			Сидорово: '81366',
			Синявино: '81362',
			Скреблово: '81372',
			Сланцы: '81374',
			Слудицы: '81371',
			Соболевщина: '81365',
			Советский: '81378',
			Совхозный: '81366',
			Соколинское: '81378',
			Сологубовка: '81362',
			Сомино: '81366',
			Сорзуй: '81363',
			Сосново: '81379',
			Спирово: '81366',
			Спутник: '81370',
			Старополье: '81374',
			Старосиверская: '81371',
			Стеклянный: '81370',
			Суйда: '81371',
			Сумино: '81373',
			Сусанино: '81371',
			Суходолье: '81379',
			Сухое: '81362',
			Сяськелево: '81371',
			Сясьстрой: '81363',
			Тайцы: '81371',
			Тарасово: '81378',
			Тельман: '81361',
			Тервеничи: '81364',
			Терволово: '81371',
			Терпилицы: '81373',
			Тесово: '81372',
			Тихвин: '81367',
			Тихорицы: '81368',
			Токарево: '81378',
			Токари: '81365',
			Токсово: '81370',
			Толмачево: '81372',
			Торковичи: '81372',
			Торосово: '81373',
			Торошковичи: '81372',
			Тосно: '81361',
			Труфаново: '81366',
			Тургошь: '81366',
			Тушемля: '81366',
			Ульяновка: '81361',
			Усадище: '81363',
			Утишье: '81366',
			Ушаки: '81361',
			Ущевицы: '81373',
			Фалилеево: '81375',
			Федоровское: '81361',
			Форносово: '81361',
			Фосфорит: '81375',
			Хвалово: '81363',
			Хотнежа: '81373',
			Цвелодубово: '81378',
			Цвылево: '81367',
			Часовенское: '81363',
			Чаща: '81371',
			Чемихино: '81367',
			Черкасово: '81378',
			Черновское: '81374',
			Чолово: '81372',
			Шалово: '81372',
			Шамокша: '81364',
			Шапки: '81361',
			Шапша: '81364',
			Шархиничи: '81364',
			Шеменичи: '81365',
			Шепелево: '81376',
			Шлиссельбург: '81362',
			Шпаньково: '81371',
			Шум: '81362',
			Щугозеро: '81367',
			Юкки: '81370',
			Яблоницы: '81373',
			Яльгелево: '81376',
			Янега: '81364',
			Яровщина: '81364',
			Ярославичи: '81365'
		}
	},
	'Липецкая область': {
		regionCode: '474',
		cities: {
			'Агроном Совхоз': '47466',
			'Аргамач-Пальна': '47467',
			'Большая Боевка': '47468',
			'Большая Ивановка': '47473',
			'Большая Отрада': '47462',
			'Большая Поляна': '47474',
			'Большие Избищи': '47466',
			'Большие Извалы': '47467',
			'Большие Хомяки': '47463',
			'Большой Верх': '47466',
			'Большой Самовец': '47461',
			'Большой Снежеток': '47475',
			'Большой Хомутец': '47463',
			'Верхнее Казачье': '47471',
			'Верхнее Чесночное': '47473',
			'Верхний Ломовец': '47468',
			'Верхний Студенец': '47471',
			'Верхний Телелюй': '47461',
			'Верхняя Колыбелька': '47477',
			'Верхняя Матренка': '47462',
			'Верхняя Мосоловка': '47472',
			'Вислая Поляна': '47474',
			'Войсковая Казинка': '47468',
			'Воронежская Лозовка': '47477',
			'Вторые Тербуны': '47474',
			'Грунин Воргол': '47476',
			'Донская Негачевка': '47477',
			'Донские Избищи': '47466',
			'Донской Рудник': '47471',
			'Елецкая Лозовка': '47477',
			'Елецкое Маланино': '47477',
			'Желтые Пески': '4742',
			'Каменная Лубна': '47466',
			'Ключ Жизни Совхоз': '47467',
			'Княжая Байгора': '47461',
			'Конь-Колодезь': '47477',
			'Красная Пальна': '47476',
			'Красное Колычево': '47464',
			'Крутченская Байгора': '47472',
			'Крутые Хутора': '4742',
			'Кузьминские Отвержки': '4742',
			'Лев Толстой': '47464',
			'Малая Боевка': '47467',
			'Малый Мечек': '47477',
			'Марьино-Николаевка': '47474',
			'Маяк Совхоз': '47467',
			'Меньшой Колодезь': '47468',
			'Нижнее Большое': '47473',
			'Нижний Воргол': '47467',
			'Нижняя Колыбелька': '47477',
			'Нижняя Матренка': '47462',
			'Новая Деревня': '4742',
			'Новое Дубовое': '47477',
			'Новое Петелино': '47475',
			'Ольшанка-Вторая': '47474',
			'Осиновские Прудки': '47465',
			'Пальна-Михайловка': '47476',
			'Песковатка-Казачья': '47472',
			'Песковатский Совхоз': '47461',
			'Петровский Совхоз': '47462',
			'Полевые Локотцы': '47478',
			'Решетово-Дуброво': '47469',
			'Сахарный завод': '47466',
			'Солидарность Совхоз': '47467',
			'Спешнево-Ивановское': '47465',
			'Средняя Матренка': '47462',
			'Старое Ракитино': '47466',
			'Сторожевские Хутора': '47472',
			'Студенские Выселки': '47472',
			'Студеные Выселки': '4742',
			'Сухая Лубна': '4742',
			'Сухой Семенек': '47478',
			'Талицкий Чамлык': '47462',
			'Тепленькая-Вторая': '47468',
			'Товаро-Никольское': '4742',
			'Толстая Дубрава': '47476',
			'Фомина Негачевка': '47477',
			'Хворостянка-Село': '47462',
			'Хорошие Воды': '47465',
			'Хрущево-Подлесное': '47465',
			'Частая Дубрава': '4742',
			'деревня Рязанка': '47475',
			'с. Двуречки': '47461',
			Авдулово: '47465',
			Александровка: '47462',
			Алексеевка: '47471',
			Афанасьево: '47478',
			Бабарыкино: '47476',
			Балахна: '47471',
			Баловнево: '47465',
			Барятино: '47465',
			Беляево: '47472',
			Березнеговатка: '47462',
			Березняговка: '47472',
			Бигильдино: '47465',
			Болховское: '47471',
			Боринское: '4742',
			Борисовка: '47463',
			Боровое: '47472',
			Братовка: '47475',
			Братовщина: '47468',
			Бредихино: '47469',
			Бреславка: '47472',
			Бродки: '47476',
			Бруслановка: '4742',
			Бурдино: '47474',
			Буховое: '47475',
			Ведное: '47475',
			Вербилово: '4742',
			Верхнедрезгалово: '47469',
			Веселая: '47468',
			Вешаловка: '4742',
			Волово: '47473',
			Воловчик: '47473',
			Волотово: '47466',
			Воробьевка: '47477',
			Воронец: '47467',
			Воскресенское: '47475',
			Выселки: '47475',
			Вязово: '47466',
			Вязовое: '47468',
			Гатище: '47473',
			Георгиевка: '47462',
			Глотово: '47478',
			Гниловоды: '47478',
			Гнилуша: '47471',
			Голиково: '47467',
			Головщино: '47461',
			Грачевка: '47472',
			Гребенкино: '47469',
			Грызлово: '47468',
			Грязи: '47461',
			Грязновка: '47466',
			Грязное: '4742',
			Гудово: '47463',
			Данков: '47465',
			Двуречки: '47461',
			Девица: '47472',
			Дегтевая: '47469',
			Демкино: '47475',
			Демшинка: '47462',
			Денисово: '47478',
			Дмитриевка: '47472',
			Дмитряшевка: '47477',
			Добринка: '47462',
			Доброе: '47463',
			Докторово: '47466',
			Долгое: '47465',
			Долгоруково: '47468',
			Долгуша: '47468',
			Домачи: '47464',
			Донское: '47471',
			Дрязги: '47472',
			Дубовец: '47468',
			Дуброво: '47474',
			Дурово: '47462',
			Дуровщино: '47475',
			Елец: '47467',
			Елизаветовка: '47468',
			Епанчино: '47469',
			Жабино: '47475',
			Жерновное: '47468',
			Завальное: '47472',
			Загрядчино: '47464',
			Задонск: '47471',
			Замарайка: '47473',
			Замартынье: '47463',
			Заречное: '47474',
			Заря: '47462',
			Захаровка: '47473',
			Зенкино: '47475',
			Злобино: '47476',
			Знаменка: '47469',
			Знаменское: '47464',
			Золотуха: '47464',
			Ивово: '4742',
			Излегоще: '47472',
			Измайловка: '47465',
			Измалково: '47478',
			Ильинка: '47464',
			Инихово: '47465',
			Истобное: '47475',
			Ищеино: '47469',
			Казаки: '47467',
			Казаково: '47473',
			Казино: '47471',
			Калабино: '47471',
			Каликино: '47463',
			Камышевка: '47471',
			Карамышево: '47461',
			Кашары: '47471',
			Квитки: '47478',
			Кириллово: '47476',
			Колодези: '47465',
			Колыбельское: '47475',
			Конюшки: '47475',
			Кореневщино: '47463',
			Коробовка: '47461',
			Косыревка: '4742',
			Котовка: '47464',
			Красное: '47469',
			Красотыновка: '47468',
			Крещенка: '47477',
			Кривец: '47463',
			Кривка: '47472',
			Кривополянье: '47475',
			Круглое: '47464',
			Крутогорье: '4742',
			Крутчик: '47472',
			Ксизово: '47471',
			Кубань: '47461',
			Кудрявщино: '47465',
			Кузовлево: '47464',
			Куймань: '47466',
			Куликово: '47472',
			Культура: '47466',
			Курганка: '47474',
			Курино: '47477',
			Ламское: '47476',
			Лаухино: '47469',
			Лебедянка: '47462',
			Лебедянь: '47466',
			Лебяжье: '47478',
			Ленино: '4742',
			Лески: '47469',
			Липецк: '4742',
			Липовец: '47473',
			Липовка: '47471',
			Лозовка: '47475',
			Ломигоры: '47473',
			Ломовое: '47475',
			Лутошкино: '47469',
			Мазейка: '47462',
			Малинино: '47477',
			Малинки: '47465',
			Матырский: '4742',
			Маховище: '4742',
			Махоново: '47463',
			Мелеховое: '47475',
			Мещерка: '47476',
			Митягино: '47464',
			Морево: '47469',
			Московка: '47472',
			Муравьевка: '47477',
			Мягкое: '47478',
			Набережное: '47473',
			Нагорное: '47474',
			Недоходовка: '47478',
			Нижнебрусланово: '47466',
			Новоникольское: '47465',
			Новопетровка: '47462',
			Новополянье: '47475',
			Новосильское: '47474',
			Новоуглянка: '47472',
			Новочемоданово: '47464',
			Новочеркутино: '47462',
			Оберец: '47478',
			Одоевщино: '47465',
			Ожога: '47473',
			Ольховка: '47462',
			Ольшанец: '47471',
			Орловка: '47464',
			Павелка: '47466',
			Павловка: '47462',
			Павловское: '47466',
			Падворки: '47461',
			Паленка: '47476',
			Панино: '47463',
			Панкратовка: '47478',
			Паршиновка: '47462',
			Пашково: '47472',
			Первомайское: '47464',
			Перехваль: '47465',
			Петрищево: '47476',
			Петровка: '47461',
			Петровское: '47478',
			Пиково: '47475',
			Плавица: '47462',
			Пластинка: '47472',
			Плахово: '47465',
			Плеханово: '47461',
			Плоты: '47476',
			Подгорное: '4742',
			Поддубровка: '47472',
			Покровское: '47474',
			Полибино: '47465',
			Политово: '47465',
			Половнево: '47469',
			Порой: '47463',
			Предтечево: '47478',
			Преображение: '47478',
			Преображеновка: '47463',
			Пречистенское: '47478',
			Прибытково: '47461',
			Приозерное: '47462',
			Пружинки: '4742',
			Путятино: '47463',
			Пушкари: '47472',
			Пушкино: '47462',
			Пятницкая: '47478',
			Ратчино: '47463',
			Ржавец: '47471',
			Ровенка: '47478',
			Романово: '47466',
			Рощинский: '47475',
			Рябинки: '47467',
			Савицкое: '47472',
			Сафоново: '47462',
			Свишни: '47468',
			Свищевка: '47464',
			Сезеново: '47466',
			Семенек: '47476',
			Семеновка: '47473',
			Сенцово: '4742',
			Синдякино: '47477',
			Синявка: '47461',
			Ситовка: '4742',
			Скорняково: '47471',
			Сланское: '47464',
			Слепуха: '47468',
			Слободка: '47466',
			Солдатское: '47474',
			Солнцево: '47475',
			Соловое: '47475',
			Соловьево: '47476',
			Сотниково: '47469',
			Сошки: '47461',
			Среднее: '47462',
			Сселки: '4742',
			Становая: '47476',
			Становое: '47476',
			Стебаево: '4742',
			Стегаловка: '47468',
			Сторожевое: '47472',
			Стрелец: '47468',
			Студенки: '47472',
			Суходол: '47469',
			Сцепное: '47471',
			Сырский: '4742',
			Сырское: '4742',
			Талица: '47467',
			Телегино: '47476',
			Тележенка: '4742',
			Телелюй: '47461',
			Телепнево: '47465',
			Теплое: '47466',
			Тербуны: '47474',
			Тимирязев: '47471',
			Тихвинка: '47462',
			Топки: '47464',
			Топтыково: '47475',
			Требунки: '47465',
			Троекурово: '47475',
			Тростяное: '47471',
			Трубетчино: '47463',
			Тульское: '47474',
			Урицкое: '47474',
			Урусово: '47475',
			Усмань: '47472',
			Успенское: '47476',
			Уткино: '47471',
			Фащевка: '47461',
			Хворостянка: '47462',
			Хитрово: '47467',
			Хлевное: '47477',
			Хмелинец: '47471',
			Хорошовка: '47466',
			Чаплыгин: '47475',
			Чемоданово: '47476',
			Черкассы: '47467',
			Чермошное: '47478',
			Чернава: '47478',
			Черниговка: '47471',
			Черник: '47478',
			Чернолес: '47476',
			Чернышевка: '47467',
			Чибисовка: '47467',
			Чириково: '4742',
			Шишкино: '47475',
			Шовское: '47466',
			Щербаково: '47469',
			Юрское: '47473',
			Ягодное: '47465',
			Яковлево: '47474',
			Яркино: '47476',
			Ярлуково: '47461'
		}
	},
	'Магаданская область': {
		regionCode: '413',
		cities: {
			'Верхний Балыгычан': '41346',
			'Верхний Парень': '41348',
			'Верхний Сеймчан': '41347',
			'Магадан ': '4132',
			'Усть Омчуг': '41344',
			'Усть-Омчуг': '41344',
			'Усть-Среднекан': '41347',
			'Усть-Хакчан': '41345',
			'Эвенск ': '41348',
			Армань: '41341',
			Атка: '41322',
			Балаганное: '41341',
			Беличан: '41345',
			Большевик: '41345',
			Бурхала: '41343',
			Галимый: '41346',
			Гарманда: '41348',
			Гижига: '41348',
			Дебин: '41343',
			Дукат: '41346',
			Кадыкчан: '41345',
			Карамкен: '41322',
			Клепка: '41341',
			Колымское: '41347',
			Магадан: '4132',
			Мадаун: '41344',
			Мальдяк: '41345',
			Мылга: '41343',
			Мяунджа: '41345',
			Ола: '41341',
			Омсукчан: '41346',
			Омчак: '41344',
			Оротукан: '41343',
			Палатка: '41342',
			Сеймчан: '41347',
			Синегорье: '41343',
			Сокол: '4132',
			Спорное: '41343',
			Стекольный: '41322',
			Сусуман: '41345',
			Талая: '41322',
			Талон: '41341',
			Тауйск: '41341',
			Тахтоямск: '41341',
			Транспортный: '41344',
			Уптар: '4132',
			Хасын: '41322',
			Холодный: '41345',
			Чайбуха: '41348',
			Широкий: '41345',
			Эвенск: '41348',
			Эльген: '41343',
			Ягодное: '41343'
		}
	},
	Москва: {
		regionCode: ['495', '499'],
		cities: {
			Зеленоград: '49653',
			Котельники: '495',
			Красково: '495',
			Лобня: '495',
			Лыткарино: '495',
			Люберцы: '495',
			Москва: ['495', '499'],
			Мытищи: '495',
			Нахабино: '495',
			Одинцово: '495',
			Остафьево: '495',
			Томилино: '495',
			Хамовники: '495',
			Химки: '495',
			Щербинка: '49585'
		}
	},
	'Московская область': {
		regionCode: ['495', '496', '498'],
		cities: {
			'Алексино-Шатур': '49640',
			'Архангельское ': '498',
			'Барвиха Санаторий': '49633',
			'Бекасово-2': '49634',
			'Белые Колодези': '49670',
			'Белые Столбы': '49679',
			'Белый Раст': '49622',
			'Беляная Гора': '49627',
			'Березка Дом отдыха': '49627',
			'Большие Вязёмы': '49633',
			'Большие Дворы': '49643',
			'Большое Алексеевское': '4967',
			'Большое Гридино': '49640',
			'Большое Грызлово': '4967',
			'Великий Двор': '49620',
			'Вишняковские Дачи': '49651',
			'Вождь Пролетариата': '49640',
			'Волоколамский Совхоз': '49636',
			'Гарь-Покровское': '49633',
			'Гидроузла Поселок': '49631',
			'Горбово Фабрика': '49627',
			'Горки-Коломенские': '49661',
			'Дубовая Роща': '49646',
			'Евсеево ': '49643',
			'Заветы Ильича': '49653',
			'Загорские Дали': '49654',
			'Заря Коммунизма': '49679',
			'Зеленая Роща': '49679',
			'Знамя Октября': '49675',
			'Ильинский Погост': '4964',
			'Ильинское-Теряевское': '49636',
			'Ильинское-Усово': '49634',
			'Ильинское-Ярополецкое': '49636',
			'Клемово Совхоз': '49667',
			'Кр.Электрик': '49651',
			'Красная Гора': '49636',
			'Красная Дубрава': '4964',
			'Красная Заря': '4967',
			'Красная Пахра': '4967',
			'Красная Пойма': '49663',
			'Красный Ткач': '49640',
			'Красный Холм': '49644',
			'Лесное Озеро': '49626',
			'Летний отдых': '49633',
			'Ликино-Дулево': '4964',
			'Ликино-Дулёво': '496424',
			'Лосино-Петровский': '49656',
			'Луговой Поселок': '49622',
			'Малая Дубна': '4964',
			'Марфин Брод': '49638',
			'Маслово Совхоз': '49666',
			'Мир Совхоз': '49645',
			'Мисцево-Куровское': '4964',
			'Н.Поселок': '49640',
			'Наро-Фоминск': '49634',
			'Нижнее Хорошево': '49661',
			'Николо-Кропотки': '49620',
			'Никольское-Гагарино': '49627',
			'Новая Деревня': '49638',
			'Новая Ольховка ': '49634',
			'Новая Ольховка': '49634',
			'Ново-Синьково': '49622',
			'Новый Быт': '49672',
			'Одинцово-Вахромеево': '49679',
			'Озеро Белое Санаторий': '49645',
			'Орехово-Зуево': '4964',
			'Осаново-Дубовое': '49645',
			'Павловская Слобода': '49631',
			'Павловский Посад': '49643',
			'Подмосковье Санаторий': '49679',
			'Покровское-Шереметьево': '49627',
			'Поречье Санаторий': '49633',
			'Пос.Биокомбинат': '496',
			'Посёлок зверосовхоза': '49653',
			'Рахмановский Комбинат': '49643',
			'Русское Поле': '49672',
			'Сав.Слобода ': '49632',
			'Саввинская Слобода': '49633',
			'Сергиев Посад': '49654',
			'Серебряные Пруды': '49667',
			'Ситне-Щелканово': '49664',
			'Соколова Пустынь': '4967',
			'Спас-Заулок': '49624',
			'Спасс-Заулок': '49624',
			'Старая Купавна': '49651',
			'Старая Руза': '49627',
			'Старая Ситня': '49664',
			'Старый Городок': '49633',
			'Т.Болото ': '49640',
			'Туголесский Бор': '49645',
			'Цветковский Совхоз': '49638',
			'Шишкин Лес': '4967',
			'Щапово ': '4967',
			Абрамовка: '4964',
			Абрамцево: '49654',
			Авдеево: '49666',
			Авдотьино: '49651',
			Авсюнино: '4964',
			Акатьево: '49661',
			Алабино: '49634',
			Алабушево: '49626',
			Александрово: '49638',
			Алексино: '49631',
			Алпатьево: '49663',
			Алферово: '49643',
			Алферьево: '49666',
			Андреевка: '49626',
			Апрелевка: '49634',
			Архангельское: '498',
			Астапово: '49663',
			Атепцево: '49634',
			Афанасовка: '49634',
			Ашитково: '49644',
			Ашукино: '49653',
			Бабенки: '49675',
			Бакшеево: '49645',
			Балашиха: '49621',
			Барабаново: '49669',
			Барановское: '49644',
			Барвиха: '49633',
			Барыбино: '49679',
			Барынино: '49627',
			Беззубово: '4964',
			Бекасово: '49634',
			Белавино: '4964',
			Белозерск: '49644',
			Белоозёрский: '49644',
			Белоомут: '49663',
			Бережки: '49640',
			Березняки: '49654',
			Бесово: '49669',
			Биорки: '49661',
			Бирево: '49624',
			Бисерово: '49651',
			Бобково: '49640',
			Богатищево: '49669',
			Болычево: '49636',
			Большевик: '4967',
			Борисово: '49638',
			Боровково: '49651',
			Бородино: '49638',
			Бортниково: '4967',
			Ботово: '49636',
			Бояркино: '49670',
			Братовщина: '49653',
			Бронницы: '49646',
			Буденовец: '49622',
			Бужаниново: '49654',
			Бужарово: '49631',
			Буньково: '49651',
			Бунятино: '49622',
			Бурцево: '49669',
			Быково: '4967',
			Васильевское: '4967',
			Васькино: '49672',
			Введенское: '49632',
			Вельяминово: '49679',
			Вербилки: '49620',
			Верея: '49634',
			Веселево: '49634',
			Видное: '498',
			Виноградово: '49644',
			Воздвиженское: '49624',
			Волково: '49627',
			Волоколамск: '49636',
			Волченки: '49634',
			Воробьево: '49679',
			Вороново: '4967',
			Воскресенск: '49644',
			Востряково: '49679',
			Высоковск: '49624',
			Вышегород: '49634',
			Ганусово: '49646',
			Гидроузел: '49631',
			Глубокое: '49654',
			Голицыно: '49633',
			Головково: '49634',
			Гора: '4964',
			Горетово: '49638',
			Горловка: '49633',
			Городище: '4967',
			Городищи: '4966',
			Горшково: '49622',
			Гранит: '49620',
			Григорково: '49654',
			Григорьевское: '49663',
			Гридино: '49640',
			Гришино: '49626',
			Губино: '4964',
			Давыдково: '49624',
			Давыдово: '4964',
			Дарищи: '49661',
			Дашковка: '4967',
			Дворики: '49661',
			Деденево: '49622',
			Дединово: '49663',
			Дедовск: '49631',
			Демихово: '4964',
			Денежниково: '49646',
			Деньково: '49631',
			Дзержинский: '49654',
			Дмитров: '49622',
			Дмитрово: '49675',
			Долгопрудный: '49622',
			Домодедово: '49679',
			Донино: '49646',
			Дорохово: '49627',
			Дрезна: '4964',
			Дубки: '49633',
			Дубна: '49621',
			Дубнево: '4967',
			Дубровицы: '49675',
			Дурыкино: '49626',
			Духанино: '49631',
			Дютьково: '49633',
			Евсеево: '49643',
			Егорьевск: '49640',
			Елгозино: '49624',
			Елизарово: '49626',
			Ельдигино: '49653',
			Ерново: '49666',
			Ершово: '49632',
			Ефимово: '49643',
			Ефремовская: '49640',
			Жаворонки: '49633',
			Железнодорожный: '49631',
			Жилево: '49664',
			Житнево: '49679',
			Жуковский: '49648',
			Журавна: '49666',
			Заворово: '49646',
			Загарье: '49643',
			Загорянский: '496',
			Закубежье: '49654',
			Заовражье: '49626',
			Запрудня: '49620',
			Запутное: '4964',
			Зарайск: '49666',
			Захарово: '49624',
			Звенигород: '49632',
			Зверосовхоз: '49653',
			Зеленоградский: '49653',
			Зеленый: '49651',
			Зендиково: '49669',
			Зыково: '49631',
			Ивакино: '49638',
			Ивановка: '49646',
			Ивантеевка: '49653',
			Игумново: '49646',
			Икша: '49622',
			Ильинка: '4964',
			Ильинский: '49646',
			Ильинское: '49679',
			Индустрия: '49661',
			Истра: '49631',
			Кабаново: '4964',
			Калининец: '49634',
			Калистово: '49636',
			Каменское: '49634',
			Каренское: '49632',
			Каринское: '49633',
			Кашино: '49636',
			Кашира: '49669',
			Клеменово: '49640',
			Клементьево: '49638',
			Кленово: '49675',
			Климовск: '4967',
			Клин: '49624',
			Клязьма: '49653',
			Княжево: '49636',
			Кокино: '49669',
			Кокошкино: '49634',
			Коломна: '4966',
			Колычево: '4966',
			Колюбакино: '49627',
			Конобеево: '49644',
			Константиново: '49679',
			Королёв: '49636',
			Корыстово: '49669',
			Костомарово: '4967',
			Кострово: '49631',
			Косяево: '49667',
			Котельники: '495',
			Кошелево: '49620',
			Красково: '495',
			Красноармейск: '49653',
			Красновидово: '49638',
			Красногорск: '49653',
			Краснозаводск: '49654',
			Краснознаменск: '49633',
			Кратово: '49646',
			Крекшино: '49634',
			Кривандино: '49645',
			Крупино: '49643',
			Крутое: '49667',
			Кубинка: '49633',
			Кузнецово: '49646',
			Кузнецы: '49643',
			Кузьмино: '49654',
			Купавна: '49651',
			Куровское: '4964',
			Куртино: '4967',
			Курьяново: '49636',
			Ладыгино: '49627',
			Ледово: '49669',
			Леньково: '49627',
			Леонтьево: '4967',
			Лесной: '4966',
			Летуново: '49666',
			Лиаз: '4964',
			Липино: '49622',
			Липицы: '4967',
			Литвиново: '49626',
			Лобня: '495',
			Логиново: '49643',
			Лоза: '49654',
			Лопатинский: '49644',
			Лотошино: '49628',
			Лужники: '4967',
			Лукерьино: '49661',
			Лукино: '49679',
			Лукошкино: '49675',
			Лукьяново: '4967',
			Лунев: '49626',
			Луховицы: '49663',
			Луцино: '49632',
			Лыткарино: '495',
			Лыткино: '49626',
			Лыщиково: '49627',
			Львовский: '4967',
			Люберцы: '495',
			Любучаны: '49672',
			Майдарово: '4962',
			Макеево: '49666',
			Макшеево: '49661',
			Малаховка: '495',
			Маливо: '49661',
			Малино: '49664',
			Малышево: '49646',
			Мамонтовка: '49653',
			Мамонтово: '49651',
			Манихино: '49631',
			Мансурово: '49631',
			Марушкино: '49634',
			Маяк: '49663',
			Менделеево: '49626',
			Мендюкино: '49666',
			Мещерино: '4967',
			Мещерское: '49672',
			Минино: '4964',
			Мисцево: '4964',
			Митякино: '49667',
			Михайловское: '4967',
			Михали: '49640',
			Мишеронский: '49645',
			Мишеронь: '49645',
			Мишутино: '49654',
			Можайск: '49638',
			Молодежный: '49634',
			Монино: '49656',
			Москвич: '49679',
			Мостовик: '49654',
			Мураново: '49653',
			Муханово: '49654',
			Мытищи: '495',
			Назарьево: '49633',
			Нарский: '49633',
			Нарынка: '49624',
			Нахабино: '495',
			Некрасовский: '49622',
			Нелидово: '49644',
			Непецино: '49661',
			Нерастанное: '49672',
			Никитское: '49646',
			Никоновское: '49646',
			Новобратцевский: '49634',
			Новое: '4964',
			Новоегорий: '49640',
			Новозагарье: '49643',
			Новопетровск: '49631',
			Новопетровское: '49631',
			Новоселки: '49669',
			Новостройка: '49654',
			Новохаритоново: '49646',
			Новый: '49654',
			Ногинск: '49651',
			Носово: '49663',
			Нудоль: '49624',
			Оборино: '49651',
			Обухово: '49651',
			Одинцово: '495',
			Ожерелье: '49669',
			Озерецкое: '49622',
			Озёры: '49670',
			Ольгово: '49622',
			Ольявидово: '49622',
			Онуфриево: '49631',
			Опалиха: '49634',
			Орево: '49622',
			Орудьево: '49622',
			Осташево: '49636',
			Осташово: '49636',
			Павловское: '49679',
			Первомайское: '49661',
			Пересвет: '49654',
			Перхушково: '49633',
			Петрово: '49667',
			Печерники: '49666',
			Пешки: '4962',
			Пирочи: '49661',
			Повадино: '49679',
			Поварово: '4962',
			Подмосковный: '49646',
			Подмосковье: '49679',
			Подольск: '4967',
			Подосинки: '49622',
			Подрядниково: '49640',
			Подхожее: '49667',
			Подъячево: '49622',
			Покровка: '49624',
			Полбино: '49640',
			Полуряденки: '49670',
			Полушкино: '49627',
			Поминово: '49638',
			Поповская: '49640',
			Поречье: '49638',
			Починки: '49640',
			Правдинский: '49653',
			Привокзальный: '49636',
			Приволье: '49675',
			Приокск: '4967',
			Пролетарий: '4967',
			Пролетарский: '4967',
			Протвино: '49677',
			Протекино: '49666',
			Псарьки: '49651',
			Птицеград: '49654',
			Птичное: '49634',
			Пустоша: '49645',
			Пушкино: '49653',
			Пущино: '49677',
			Пышелицы: '49645',
			Радовицкий: '49645',
			Радужный: '4966',
			Раменки: '49640',
			Раменское: '49646',
			Рассудово: '49634',
			Рахманово: '49643',
			Редькино: '49670',
			Реутов: '49679',
			Речицы: '49646',
			Решетниково: '49624',
			Решоткино: '49624',
			Ржавки: '49626',
			Рогачево: '49622',
			Рогово: '4967',
			Родники: '49646',
			Рошаль: '49645',
			Руза: '49627',
			Румянцево: '49631',
			Рыбное: '49622',
			Рязаново: '49675',
			Савино: '4964',
			Сватково: '49654',
			Свердловский: '496',
			Северный: '49620',
			Селиваниха: '49640',
			Селково: '49654',
			Селятино: '49634',
			Семеново: '49643',
			Семхоз: '49654',
			Сенеж: '49626',
			Сенницы: '49670',
			Середа: '49637',
			Середниково: '49645',
			Серпухов: '4967',
			Симбухово: '49634',
			Синичино: '49638',
			Скоропусковский: '49654',
			Слобода: '49624',
			Сменки: '49620',
			Снегири: '49631',
			Соболево: '4964',
			Сокольниково: '49638',
			Солнечногорск: '4962',
			Сосновка: '49670',
			Софрино: '49653',
			Спасс: '49636',
			Спутник: '49638',
			Стариково: '49620',
			Стегачево: '49626',
			Стенино: '4964',
			Степановское: '49634',
			Степанцево: '49624',
			Степанщино: '49644',
			Столбовая: '49672',
			Стремилово: '49672',
			Струпна: '49666',
			Ступино: '49664',
			Судниково: '49636',
			Сысоево: '49622',
			Сычево: '49636',
			Талдом: '49620',
			Тарасково: '49669',
			Тарбушево: '49670',
			Татариново: '4967',
			Таширово: '49634',
			Темпы: '49620',
			Теряево: '49636',
			Тимонино: '49636',
			Тимоново: '4962',
			Тишково: '49653',
			Толстяково: '49626',
			Томилино: '495',
			Топканово: '49669',
			Торгашино: '49654',
			Троицк: '49675',
			Троицкое: '49672',
			Тропарево: '49638',
			Трудовая: '49622',
			Туменское: '49661',
			Тучково: '49627',
			Тютьково: '49667',
			Уваровка: '49638',
			Ударный: '49626',
			Удельная: '49646',
			Узуново: '49667',
			Ульянино: '49646',
			Усово: '49633',
			Успенское: '49633',
			Фаустово: '49646',
			Федорцово: '49654',
			Федосьино: '49661',
			Федоскино: '495',
			Федюково: '49675',
			Фруктовая: '49663',
			Фрязево: '49651',
			Фрязино: '49656',
			Фряново: '496',
			Харлампеево: '49645',
			Хатунь: '4967',
			Химки: '495',
			Холодово: '49646',
			Холщевики: '49631',
			Хотьково: '49654',
			Хрипань: '49646',
			Чемодурово: '49644',
			Черкизово: '49653',
			Чернево: '49636',
			Черноголовка: '49652',
			Черусти: '49645',
			Чехов: '496',
			Чисмена: '49636',
			Чулково: '49646',
			Чурилкино: '49679',
			Чурилково: '49679',
			Шаликово: '49638',
			Шарапово: '49632',
			Шатура: '49645',
			Шатурторф: '49645',
			Шаховская: '49637',
			Шебляково: '49624',
			Шеино: '49645',
			Шестаково: '49636',
			Шубино: '49679',
			Шувое: '49640',
			Шугарово: '49664',
			Шустиково: '49634',
			Щёлково: '496',
			Щербинка: '4967',
			Щурово: '4966',
			Электрогорск: '49643',
			Электросталь: '49657',
			Электроугли: '49651',
			Юбилейный: '49636',
			Юрлово: '49626',
			Юрцово: '49640',
			Якимовка: '49667',
			Яковлево: '4964',
			Яковское: '49669',
			Якоть: '49622',
			Ям: '49679',
			Ямкино: '49651',
			Ярополец: '49636',
			Яхрома: '49622'
		}
	},
	'Мурманская область': {
		regionCode: '815',
		cities: {
			'Белое Море': '81533',
			'Ковда-Станция': '81533',
			'Полярные Зори': '81532',
			'Ура-Губа': '81553',
			'Щук-Озеро': '81537',
			Алакуртти: '81533',
			Апатиты: '81555',
			Африканда: '81555',
			Белокаменка: '81530',
			Варзуга: '81559',
			Верхнетуломский: '81553',
			Видяево: '81553',
			Гаджиево: '81539',
			Енский: '81535',
			Заозёрск: '81556',
			Заполярный: '81554',
			Зареченск: '81533',
			Зашеек: '81555',
			Зверосовхоз: '81553',
			Зеленоборский: '81533',
			Кандалакша: '81533',
			Каневка: '81538',
			Кашкаранцы: '81559',
			Килпъявр: '81553',
			Кильдинстрой: '81553',
			Кировск: '81531',
			Коашва: '81555',
			Ковдозеро: '81533',
			Ковдор: '81535',
			Кола: '81553',
			Корзуново: '81554',
			Краснощелье: '81538',
			Кузомень: '81559',
			Куропта: '81535',
			Лапландия: '81536',
			Лейпи: '81535',
			Лесозаводский: '81533',
			Лиинахамари: '81554',
			Ловозеро: '81538',
			Лопарская: '81553',
			Лувеньга: '81533',
			Луостари: '81554',
			Магнетиты: '81553',
			Междуречье: '81553',
			Минькино: '81553',
			Мишуково: '81553',
			Молочный: '81553',
			Мончегорск: '81536',
			Мурманск: '8152',
			Мурмаши: '81553',
			Нивский: '81533',
			Никель: '81554',
			Октябрьский: '81531',
			Оленегорск: '81552',
			Оленица: '81559',
			Островной: '81558',
			Песчаный: '81553',
			Печенга: '81554',
			Полярный: '81551',
			Пояконда: '81533',
			Приречный: '81554',
			Пушной: '81553',
			Пяйве: '81553',
			Раякоски: '81554',
			Ревда: '81538',
			Риколатва: '81535',
			Росляково: '81537',
			Сафоново: '81537',
			Североморск: '81537',
			Снежногорск: '81530',
			Сосновка: '81538',
			Териберка: '81537',
			Тетрино: '81559',
			Титан: '81531',
			Тулома: '81553',
			Туманный: '81553',
			Умба: '81559',
			Чаваньга: '81559',
			Чапома: '81559',
			Шонгуй: '81553'
		}
	},
	'Нижегородская область': {
		regionCode: '831',
		cities: {
			'Березовая Пойма': '831',
			'Ближне-Песочное': '83177',
			'Ближнее Борисово': '83145',
			'Большая Арать': '83195',
			'Большая Аря': '83196',
			'Большая Елховка': '83154',
			'Большая Музя': '83152',
			'Большая Рудка': '83155',
			'Большая Свеча': '83152',
			'Большая Якшень': '83172',
			'Большие Бакалды': '83172',
			'Большие Кемары': '83148',
			'Большие Круты': '83157',
			'Большие Печерки': '83142',
			'Большие Поляны': '83138',
			'Большие Селки': '83151',
			'Большое Болдино': '83138',
			'Большое Горево': '83154',
			'Большое Давыдово': '83171',
			'Большое Загарино': '83173',
			'Большое Иевлево': '83178',
			'Большое Казариново': '83138',
			'Большое Карпово': '83154',
			'Большое Козино': '83144',
			'Большое Мамлеево': '83196',
			'Большое Маресьево': '83196',
			'Большое Мокрое': '83145',
			'Большое Мурашкино': '83167',
			'Большое Непряхино': '83154',
			'Большое Никитино': '83154',
			'Большое Окулово': '83175',
			'Большое Пикино': '83159',
			'Большое Поле': '83163',
			'Большое Рыбушкино': '83194',
			'Большое Содомово': '83153',
			'Большое Туманово': '83147',
			'Большое Устинское': '83155',
			'Большое Череватово': '83134',
			'Большое Широкое': '83152',
			'Большой Красногор': '83154',
			'Большой Макателем': '83139',
			'Большой Терсень': '83154',
			'Бронский Ватрас': '83165',
			'Васильев Враг': '83147',
			'Васильев Майдан': '83197',
			'Верхнее Талызино': '83193',
			'Верхняя Верея': '83177',
			'Дальнее Константиново': '83168',
			'Дивеев Усад': '83197',
			'Зеленые Горы': '83140',
			'Зеленый Город': '831',
			'Ильино-Заборское': '83162',
			'Кочко-Пожарки': '83191',
			'Красная Поляна': '83196',
			'Красные Баки': '83156',
			'Красные Усады': '83162',
			'Красный Бор': '83142',
			'Красный Ватрас': '83165',
			'Красный Луч': '83158',
			'Красный Оселок': '83149',
			'Красный Остров': '83193',
			'Красный Яр': '83178',
			'Круглые Паны': '83134',
			'Крутой Майдан': '83140',
			'Лесной Курорт': '83156',
			'Летняя База': '83137',
			'Лысая Гора': '83164',
			'Малая Пица': '83168',
			'Малая Пуза': '83197',
			'Малое Андосово': '83192',
			'Малое Зиновьево': '83162',
			'Малое Мамлеево': '83196',
			'Малое Окулово': '83175',
			'Малое Содомово': '83178',
			'Малый Макателем': '83139',
			'Михалко-Майдан': '83138',
			'Можаров Майдан': '83192',
			'Нижний Красный Яр': '83149',
			'Нижний Новгород': '831',
			'Нижняя Верея': '83177',
			'Новая Деревня': '83177',
			'Новая Слобода': '83138',
			'Новый Майдан': '83196',
			'Новый Усад': '83147',
			'Овечий Овраг': '83194',
			'Пеля-Казенная': '83197',
			'Пеля-Хованская': '83197',
			'Покров Майдан': '83164',
			'Полховский Майдан': '83178',
			'Пузская Слобода': '83197',
			'Русское Маклаково': '83165',
			'Салдаманов Майдан': '83196',
			'Сарминский Майдан': '83178',
			'Сельская Маза': '83149',
			'Софрониева Пустынь': '83147',
			'Старая Березовка': '83191',
			'Старая Рудка': '83155',
			'Старое Ахматово': '83138',
			'Старое Иванцево': '83142',
			'Татарское Маклаково': '83165',
			'Теплый Стан': '83193',
			'Тольский Майдан': '83196',
			'Торговое Талызино': '83193',
			'Учуево-Майдан': '83197',
			'Черная Маза': '83149',
			'Чернолесская Пустынь': '83159',
			'Чистое Поле': '83159',
			'Чистое-Борское': '83159',
			'Чуварлей-Майдан': '83179',
			'Ягодно-Лесное': '83161',
			'р. п. Тоншаево': '83151',
			Абабково: '83171',
			Абрамово: '83147',
			Азрапино: '83197',
			Аксентис: '83161',
			Актуково: '83194',
			Акузово: '83191',
			Аламасово: '83178',
			Александрово: '83194',
			Алешково: '83170',
			Алтунино: '83173',
			Алферьево: '83193',
			Ананье: '83166',
			Андреевка: '83191',
			Анисимово: '83157',
			Анненково: '83140',
			Аносово: '83138',
			Антониха: '83158',
			Апраксино: '83138',
			Арапово: '83170',
			Ардатов: '83179',
			Арефино: '83173',
			Арзамас: '83147',
			Арзинка: '83197',
			Арманиха: '83168',
			Арьевка: '83192',
			Арья: '83154',
			Асташиха: '83178',
			Атемасово: '83179',
			Атингеево: '83196',
			Афанасьево: '83170',
			Афонино: '83145',
			Ачка: '83191',
			Бабино: '8313',
			Базлово: '83165',
			Байково: '83197',
			Балахна: '83144',
			Балахониха: '83147',
			Балеевка: '83192',
			Бармино: '83149',
			Бахтызино: '83178',
			Бебяево: '83147',
			Беговатово: '83147',
			Безводное: '83145',
			Белавка: '83164',
			Беласовка: '83162',
			Белбаж: '83157',
			Белое: '83160',
			Белозериха: '83149',
			Белозерово: '83168',
			Беляйково: '83173',
			Бердники: '83153',
			Березники: '83195',
			Березовка: '83147',
			Березово: '83137',
			Берендеевка: '83149',
			Берещино: '83139',
			Бетино: '83157',
			Благодатовка: '83178',
			Богатиловка: '83193',
			Богородск: '83170',
			Болтинка: '83193',
			Болховское: '83193',
			Большеорловский: '83159',
			Бор: '83159',
			Борковка: '83177',
			Борнуково: '83172',
			Бортсурманы: '83192',
			Бочиха: '83174',
			Бриляково: '83161',
			Буревестник: '83170',
			Буреполом: '83151',
			Бутаково: '83178',
			Бутурлино: '83172',
			Быструха: '83156',
			Ваганьково: '83159',
			Вад: '83140',
			Вазьянка: '83165',
			Валава: '83149',
			Валгусы: '83172',
			Валки: '83149',
			Валтово: '83175',
			Варганы: '83149',
			Вареж: '83171',
			Варнавино: '83158',
			Варнаево: '83178',
			Васильсурск: '83164',
			Вахтан: '83152',
			Вача: '83173',
			Велетьма: '83176',
			Великовское: '83149',
			Вельдеманово: '83148',
			Верховское: '83152',
			Вершилово: '83160',
			Верякуши: '83134',
			Ветлуга: '83150',
			Ветлужский: '83156',
			Виля: '83177',
			Виткулово: '83174',
			Владимировка: '83196',
			Владимирское: '83178',
			Водоватово: '83147',
			Воздвиженское: '83178',
			Вознесенское: '83178',
			Волжский: '83145',
			Володарск: '83136',
			Волчиха: '83147',
			Воронино: '83161',
			Воротынец: '83164',
			Ворсма: '83171',
			Воскресенское: '83163',
			Восход: '83158',
			Вторусское: '83147',
			Выездное: '83147',
			Выкса: '83177',
			Вякшенер: '83151',
			Гавриловка: '83157',
			Гагаринское: '83151',
			Гагино: '83195',
			Галибиха: '83178',
			Георгиевское: '83137',
			Гидроторф: '83144',
			Глазково: '83159',
			Глухово: '83134',
			Глухое: '83158',
			Голяткино: '83179',
			Горбатов: '83171',
			Горбатовка: '8313',
			Горево: '83157',
			Горки: '83158',
			Городец: '83161',
			Городищи: '83159',
			Гремячево: '83176',
			Григорово: '83167',
			Грудцино: '83171',
			Гугино: '83149',
			Давыдково: '83174',
			Давыдово: '83173',
			Демино: '83157',
			Деяново: '83192',
			Дзержинск: '8313',
			Дивеево: '83143',
			Димара: '83177',
			Докукино: '83178',
			Дорофеево: '83137',
			Досчатое: '83177',
			Дресвищи: '83137',
			Дружба: '83177',
			Дружный: '83145',
			Дрюково: '83159',
			Дубенское: '83140',
			Дубрава: '83168',
			Дуброво: '83197',
			Дубское: '83148',
			Дуденево: '83170',
			Егорово: '83178',
			Елдеж: '83178',
			Елизарово: '83174',
			Елизарьево: '83134',
			Ендовищи: '83194',
			Епифаново: '83173',
			Ерпелево: '83194',
			Ефаново: '83175',
			Жайск: '83173',
			Жданово: '83192',
			Ждановский: '83145',
			Железнодорожный: '83159',
			Желнино: '8313',
			Журавлиха: '83197',
			Журалейка: '83179',
			Заболотное: '83137',
			Заволжье: '83161',
			Завражное: '83159',
			Заево: '83162',
			Замятино: '83144',
			Запрудное: '83145',
			Зарубино: '83161',
			Зверево: '83195',
			Зверниха: '83158',
			Звягино: '83173',
			Зеленцово: '83173',
			Зименки: '83162',
			Зиняки: '83161',
			Золино: '83136',
			Зубилиха: '83156',
			Зубово: '83162',
			Иванцево: '83196',
			Ивково: '83195',
			Идеал: '83179',
			Илев: '83178',
			Илларионово: '83138',
			Ильинка: '83193',
			Ильино: '83136',
			Ильиногорск: '8313',
			Ильинский: '83161',
			Ильинское: '83197',
			Инкино: '83172',
			Инютино: '83170',
			Истомино: '83144',
			Исупово: '83195',
			Итманово: '83195',
			Ичалким: '83148',
			Ичалово: '83134',
			Какино: '83195',
			Калапино: '83142',
			Каликино: '83159',
			Калиниха: '83178',
			Каменищи: '83172',
			Каменки: '83170',
			Камкино: '83191',
			Кантаурово: '83159',
			Карабатово: '83167',
			Карга: '83194',
			Карпуниха: '83154',
			Кекино: '83164',
			Кельдюшево: '83196',
			Кержемок: '83142',
			Кетрось: '83172',
			Кечасово: '83194',
			Кириково: '83149',
			Кирилловка: '83147',
			Кириллово: '83156',
			Кисленка: '83192',
			Кишкино: '83167',
			Климово: '83154',
			Клин: '83173',
			Княгинино: '83166',
			Ковакса: '83147',
			Ковернино: '83157',
			Ковригино: '83161',
			Коврово: '83159',
			Козлово: '83156',
			Комарово: '83171',
			Кондратьево: '83162',
			Кондрыкино: '83138',
			Конево: '83144',
			Конново: '83134',
			Коренево: '83137',
			Коробково: '83175',
			Костянка: '83142',
			Котиха: '83147',
			Котовка: '83179',
			Кочетовка: '83193',
			Кочкурово: '83197',
			Кочуново: '83172',
			Кошелиха: '83139',
			Кремницкое: '83172',
			Кресты: '83158',
			Круглово: '83179',
			Крутец: '83172',
			Крутые: '83174',
			Крюковка: '83196',
			Кстово: '83145',
			Кугланур: '83155',
			Кудеярово: '83196',
			Кудьма: '83170',
			Кужутки: '83168',
			Кузьмияр: '83164',
			Кузятово: '83179',
			Кулагино: '83162',
			Кулебаки: '83176',
			Куриха: '83178',
			Курлаково: '83167',
			Курмыш: '83192',
			Кучиново: '83178',
			Кушнур: '83155',
			Лакша: '83170',
			Лаптево: '83171',
			Ленинское: '83147',
			Леньково: '83149',
			Лесогорск: '83142',
			Лесуново: '83174',
			Летнево: '83149',
			Лещево: '83162',
			Линда: '83159',
			Личадеево: '83179',
			Ломакино: '83195',
			Лукино: '83144',
			Лукоянов: '83196',
			Лукояновка: '83194',
			Лыково: '83162',
			Лысиица: '83194',
			Лысково: '83149',
			Ляпня: '83195',
			Мадаево: '83197',
			Макарий: '83158',
			Макарьево: '83149',
			Малахово: '83174',
			Мальцево: '83192',
			Мамлейка: '83193',
			Мамонтово: '83137',
			Маргуша: '83168',
			Матызлей: '83178',
			Медведево: '83162',
			Медоварцево: '83173',
			Мерлиновка: '83196',
			Мигалиха: '83168',
			Минеевка: '83154',
			Мирный: '83158',
			Митрополье: '83193',
			Михайловское: '83164',
			Михаленино: '83158',
			Михеевка: '83179',
			Моисеевка: '83195',
			Молчаново: '83138',
			Монаково: '83175',
			Морозовка: '83147',
			Мотмос: '83177',
			Мотовилово: '83147',
			Мулино: '83136',
			Мурзино: '83137',
			Мурзицы: '83193',
			Мухтолово: '83179',
			Мячково: '83136',
			Наваты: '83192',
			Навашино: '83175',
			Надежино: '83179',
			Наруксово: '83197',
			Нарышкино: '83178',
			Натальино: '83175',
			Наумовка: '83147',
			Наумово: '83157',
			Неверово: '83196',
			Неклюдово: '83159',
			Нелей: '83139',
			Нелюбово: '83167',
			Нестиары: '83178',
			Нива: '83149',
			Нижегородец: '83168',
			Никитино: '83197',
			Никитиха: '83152',
			Никольское: '83149',
			Никулино: '83196',
			Новоблаговещенское: '83195',
			Новодмитриевка: '83177',
			Новоликеево: '83145',
			Новомихайловка: '83196',
			Новомочалей: '83192',
			Новоникольское: '83158',
			Новопокровское: '83150',
			Новосмолинский: '83136',
			Новоспасское: '83197',
			Новотроицкое: '83197',
			Новошино: '83175',
			Носовая: '83156',
			Обухово: '83139',
			Обход: '83154',
			Овсянка: '83162',
			Огибное: '83162',
			Озерки: '83192',
			Окский: '83170',
			Октябрьский: '83159',
			Онучино: '83134',
			Опониха: '83162',
			Оранки: '83170',
			Ореховец: '83134',
			Останкино: '83159',
			Отары: '83164',
			Ошминское: '83151',
			Павлово: '83171',
			Пакали: '83153',
			Палец: '83148',
			Панино: '83174',
			Панкратово: '83197',
			Паново: '83142',
			Пасьяново: '83142',
			Пафнутово: '83162',
			Пахутино: '83153',
			Пелегово: '83137',
			Первомайск: '83139',
			Первомайский: '83161',
			Пергалей: '83172',
			Перевоз: '83148',
			Перелаз: '83162',
			Пермеево: '83138',
			Перчваж: '83155',
			Пестово: '83155',
			Петлино: '83140',
			Петряксы: '83192',
			Печи: '83196',
			Пижма: '83151',
			Пикшень: '83138',
			Пильна: '83192',
			Пичингуши: '83196',
			Плотинка: '83159',
			Плюхино: '83162',
			Погатиха: '83178',
			Подлесово: '83145',
			Подъяблонное: '83170',
			Поздеево: '83155',
			Поздняково: '83175',
			Покровка: '83196',
			Полом: '83162',
			Польцо: '83173',
			Поляна: '83148',
			Понетаевка: '83142',
			Понурово: '83157',
			Починки: '83197',
			Поя: '83196',
			Проволочное: '83177',
			Прокошево: '83145',
			Просек: '83149',
			Прудищи: '83165',
			Пруды: '83156',
			Пурех: '83160',
			Пустынь: '83147',
			Пушкарево: '83137',
			Пыдрей: '83162',
			Пыра: '8313',
			Работки: '83145',
			Развилье: '83159',
			Размазлей: '83179',
			Разнежье: '83164',
			Рамешки: '83157',
			Раскаты: '83178',
			Ратово: '83193',
			Ревезень: '83148',
			Редькино: '83159',
			Решетиха: '83136',
			Ризоватово: '83197',
			Рогово: '83175',
			Рогожка: '83193',
			Рождествено: '83167',
			Роженцово: '83155',
			Рожок: '83174',
			Румянцево: '83168',
			Рустай: '83159',
			Рыжково: '83162',
			Саваслейка: '83176',
			Саврасово: '83196',
			Саконы: '83179',
			Салавирь: '83175',
			Салган: '83194',
			Саломаты: '83160',
			Санки: '83196',
			Сарга: '83194',
			Сарлей: '83168',
			Саров: '83130',
			Светлогорск: '83142',
			Светлое: '83162',
			Северный: '83158',
			Селема: '83147',
			Селитьба: '83174',
			Семенов: '83162',
			Семеновка: '83194',
			Семино: '83157',
			Семьяны: '83164',
			Семёнов: '83162',
			Сергач: '83191',
			Сергеевка: '83138',
			Серебрянка: '83176',
			Серково: '83161',
			Сеченево: '83193',
			Сеченово: '83193',
			Силино: '83142',
			Симбухово: '83197',
			Ситники: '83159',
			Сицкое: '83160',
			Скорятино: '83147',
			Слизнево: '83147',
			Смагино: '83172',
			Смиркино: '83161',
			Смирново: '83142',
			Смолино: '83136',
			Смольки: '83161',
			Сноведь: '83177',
			Соболево: '83195',
			Советский: '83167',
			Совхозный: '83144',
			Сокольское: '83137',
			Соловьево: '83166',
			Солонское: '83170',
			Сомовка: '83164',
			Сонино: '83175',
			Сосновка: '83165',
			Сосновское: '83174',
			Спасское: '83165',
			Староустье: '83178',
			Стексово: '83179',
			Степурино: '83175',
			Столбищи: '83192',
			Стрелка: '83140',
			Строчково: '83161',
			Стуклово: '83134',
			Ступино: '83160',
			Суворово: '83134',
			Суморьево: '83178',
			Сунеево: '83148',
			Сурадеево: '83172',
			Суроватиха: '83168',
			Сурулово: '83174',
			Сухобезводное: '83162',
			Сухоноска: '83157',
			Сырятино: '83197',
			Сява: '83152',
			Тагаево: '83197',
			Таможниково: '83168',
			Танайково: '83148',
			Тарасиха: '83162',
			Тарасово: '83157',
			Таремское: '83171',
			Тарталей: '83172',
			Тарханово: '83195',
			Темта: '83154',
			Тенекаево: '83192',
			Тепелево: '83168',
			Теплово: '83176',
			Теряево: '83170',
			Теша: '83175',
			Тилинино: '83148',
			Титково: '83154',
			Толба: '83191',
			Тонкино: '83153',
			Тоншаево: '83151',
			Трехозерье: '83194',
			Трофимово: '83149',
			Трошково: '83153',
			Тубанаевка: '83165',
			Тулага: '83154',
			Туманино: '83152',
			Тумботино: '83171',
			Турбанка: '83165',
			Туртапка: '83177',
			Уварово: '83172',
			Ужовка: '83197',
			Ужово: '83197',
			Ульяново: '83196',
			Умай: '83140',
			Унор: '83177',
			Уразовка: '83194',
			Урень: '83154',
			Усольцево: '83156',
			Уста: '83154',
			Фанерный: '83162',
			Федоровка: '83194',
			Федурино: '83161',
			Филинское: '83173',
			Филипповское: '83159',
			Филюково: '83174',
			Фокино: '83164',
			Фролищи: '83136',
			Фундриково: '83162',
			Хахалы: '83162',
			Хватовка: '83147',
			Хвойное: '83162',
			Хвощевка: '83170',
			Хмелевицы: '83152',
			Холязино: '83167',
			Хохлома: '83157',
			Хрипуново: '83179',
			Чащиха: '83156',
			Чемашиха: '83156',
			Чембилей: '83194',
			Черемушки: '83158',
			Черновское: '83138',
			Черное: '83152',
			Черномуж: '83155',
			Чернышиха: '83145',
			Чертас: '83138',
			Чибирь: '83156',
			Чиргуши: '83196',
			Чиреси: '83138',
			Чистое: '83160',
			Чкаловск: '83160',
			Чмутово: '83171',
			Чугуны: '83164',
			Чулково: '83173',
			Чупалейка: '83177',
			Шагаево: '83197',
			Шайгино: '83151',
			Шалдеж: '83162',
			Шалдежка: '83162',
			Шандрово: '83196',
			Шапкино: '83170',
			Шаранга: '83155',
			Шарапово: '83142',
			Шатки: '83190',
			Шатовка: '83147',
			Шахунья: '83152',
			Швариха: '83170',
			Шелокша: '83145',
			Шеманиха: '83156',
			Шемарино: '83193',
			Шерстино: '83147',
			Шерстки: '83151',
			Шершово: '83148',
			Шилокша: '83176',
			Шиморское: '83177',
			Шпилево: '83148',
			Шумилово: '83170',
			Шутилово: '83139',
			Щекотово: '83155',
			Щенники: '83155',
			Щепачиха: '83171',
			Юганец: '83136',
			Юморга: '83192',
			Юрасово: '83159',
			Юрьево: '83195',
			Ягодное: '83148',
			Ягубовка: '83172',
			Ядрово: '83156',
			Языково: '83192',
			Яковское: '83174',
			Яковцево: '83173',
			Ямново: '83159',
			Яново: '83191',
			Ярымово: '83171',
			Ясенцы: '83171',
			Ясное: '83193'
		}
	},
	'Новгородская область': {
		regionCode: '816',
		cities: {
			Антоново: '8162',
			'Большая Вишера': '81660',
			'Большая Уторгош': '81656',
			'Большие Боры': '81652',
			'Большое Ельно': '81654',
			'Большое Замошье': '81666',
			'Большое Засово': '81652',
			'Большое Яблоново': '81650',
			'Великий Заход': '81651',
			'Великий Новгород': '8162',
			'Великое Село': '81652',
			'Висленев Остров': '81657',
			Волотово: '8162',
			'Вольная Горка': '81661',
			'Жилой Бор': '81667',
			'Ильина Гора': '81651',
			'Карпина Гора': '81660',
			'Кончанско-Суворовское': '81664',
			'Кончанское-Суворовское': '81664',
			'Красная Гора': '81653',
			'Красные Станки': '8162',
			'Красный Бор': '81654',
			'Красный Двор': '81656',
			'Малая Вишера': '81660',
			'Малые Семирицы': '81664',
			'Мокрый Остров': '81659',
			'Мстинский Мост': '81660',
			'Мшага Ямская': '81656',
			'Новая Русса': '81663',
			'Новое Овсино': '81661',
			'Новое Рахино': '81659',
			'Новый Скребель': '81651',
			'Опеченский Посад': '81664',
			'Пинаевы Горки': '81652',
			'Речные Котцы': '81652',
			'Село Гора': '8162',
			'Спас-Нередицы': '8162',
			'Спасская Полисть': '81665',
			'Старая Русса': '81652',
			'Старое Ракомо': '8162',
			'Старое Рахино': '81659',
			'Сутоко-Рядок': '81664',
			'Сухая Нива': '81666',
			'Тесово-Нетыльский': '8162',
			'Турская Горка': '81656',
			'Усть-Волма': '81659',
			'Черный Ручей': '81651',
			'Чувашева Гора': '81653',
			'д. Ручьи': '81659',
			'деревня Сябреницы': '81665',
			Абросово: '81669',
			Анциферово: '81667',
			Аполец: '81654',
			Астрилово: '81652',
			Афаносово: '81663',
			Барсаниха: '81669',
			Барышево: '81653',
			Батецкий: '81661',
			Беззубцево: '81669',
			Белебелка: '81658',
			Белышево: '81657',
			Березовик: '81657',
			Богослово: '81669',
			Божонка: '8162',
			Борисово: '81652',
			Борки: '8162',
			Боровенка: '81657',
			Боровичи: '81664',
			Боровское: '81667',
			Броди: '81653',
			Бронница: '8162',
			Брякуново: '81669',
			Бугры: '81667',
			Бураково: '81658',
			Бурга: '81660',
			Буреги: '81652',
			Быково: '81669',
			Валдай: '81666',
			Велилы: '81663',
			Веребье: '81660',
			Верехново: '81662',
			Верещино: '81656',
			Взвад: '81652',
			Виджа: '81652',
			Видони: '81655',
			Виленка: '81652',
			Вины: '81659',
			Водогон: '81668',
			Волгино: '81664',
			Волма: '81659',
			Волок: '81664',
			Волот: '81662',
			Волховский: '8162',
			Воронино: '81661',
			Вотолино: '81651',
			Вотроса: '81669',
			Вшели: '81655',
			Выбити: '81655',
			Вычерема: '81668',
			Вяжищи: '8162',
			Вятка: '81669',
			Гора: '81669',
			Горбино: '81664',
			Горицы: '81662',
			Горки: '81655',
			Горнешно: '81657',
			Горное: '81663',
			Горный: '81667',
			Городище: '81656',
			Городня: '81661',
			Городцы: '81662',
			Гостцы: '8162',
			Грузино: '81665',
			Гряды: '81660',
			Давыдово: '81652',
			Дворец: '81666',
			Демянск: '81651',
			Дерглец: '81662',
			Дерняки: '81657',
			Добрости: '81659',
			Добывалово: '81666',
			Долгое: '81653',
			Дрегли: '81668',
			Дубки: '81652',
			Дубовицы: '81652',
			Дуброви: '81651',
			Дубровка: '8162',
			Дуброво: '81655',
			Дубровы: '81650',
			Дунаево: '81654',
			Егла: '81664',
			Едрово: '81666',
			Елкино: '81669',
			Ельничное: '81669',
			Еремино: '81669',
			Ересино: '81659',
			Ермолино: '8162',
			Есипово: '81651',
			Железково: '81664',
			Жирково: '81651',
			Завод: '81657',
			Заделье: '81667',
			Зайцево: '81659',
			Закибье: '81656',
			Залучье: '81652',
			Замостье: '81660',
			Замошье: '81654',
			Заполье: '81668',
			Зарубино: '81668',
			Заручевье: '81657',
			Заря: '81651',
			Захарьино: '8162',
			Зимогорье: '81666',
			Зуево: '81665',
			Ивановское: '81652',
			Ивантеево: '81666',
			Иловенка: '81655',
			Ильмень: '8162',
			Иногоща: '81657',
			Кабожа: '81667',
			Каево: '81657',
			Каменка: '81654',
			Карловка: '81665',
			Карпелово: '81669',
			Кересть: '8162',
			Кипино: '81651',
			Кировский: '81664',
			Клевичи: '81651',
			Климовщина: '81669',
			Кневицы: '81651',
			Кобожа: '81653',
			Ковалево: '8162',
			Коегоща: '81664',
			Комарово: '81668',
			Коровино: '81669',
			Коростынь: '81656',
			Короцко: '81666',
			Косино: '81652',
			Косицкое: '81661',
			Котово: '81657',
			Крапивно: '81655',
			Красилово: '81666',
			Красненка: '81660',
			Краснофарфорный: '81665',
			Кременичи: '81668',
			Крестцы: '81659',
			Кречевицы: '8162',
			Кстечки: '81666',
			Кузнецовка: '81666',
			Кузьминское: '81650',
			Куклино: '81655',
			Кулотино: '81657',
			Кушавера: '81667',
			Лажины: '81650',
			Лазарицы: '81650',
			Ламерье: '81659',
			Лаптево: '81669',
			Леменка: '81655',
			Лесная: '8162',
			Липье: '81663',
			Локотско: '81659',
			Лубенское: '81653',
			Лубино: '81655',
			Луньшино: '81652',
			Лутовенка: '81666',
			Лучки: '81666',
			Лычково: '81651',
			Любница: '81666',
			Люболяды: '81661',
			Любыни: '81656',
			Любытино: '81668',
			Лядчино: '81657',
			Лякова: '81659',
			Мамоновщина: '81663',
			Мануйлово: '81650',
			Марево: '81663',
			Меглецы: '81653',
			Медведь: '81656',
			Медниково: '81652',
			Мелковичи: '81661',
			Мельница: '81657',
			Менюши: '81656',
			Миголощи: '81667',
			Минцы: '81667',
			Мойка: '81661',
			Молвотицы: '81663',
			Морхово: '81654',
			Мошенское: '81653',
			Мытно: '8162',
			Мякишево: '81667',
			Нагово: '81652',
			Наход: '81654',
			Неболчи: '81668',
			Невское: '81655',
			Некрасово: '81661',
			Нивки: '81658',
			Никитино: '81667',
			Новоселицы: '8162',
			Новосельский: '81652',
			Новотроицы: '81666',
			Озерки: '81657',
			Окладнево: '81664',
			Оксочи: '81660',
			Окуловка: '81657',
			Ольховка: '81659',
			Ореховно: '81653',
			Оскуй: '81665',
			Остахново: '81667',
			Осташово: '81653',
			Охона: '81669',
			Панковка: '8162',
			Парфино: '81650',
			Пеньково: '81652',
			Перегино: '81658',
			Передки: '81664',
			Переезд: '81658',
			Перелучи: '81664',
			Переходы: '81658',
			Пески: '81651',
			Пестово: '81669',
			Песь: '81667',
			Петрово: '81653',
			Питилипы: '8162',
			Плавково: '81664',
			Погорелово: '81669',
			Подгорное: '81660',
			Подгощи: '81656',
			Поддорье: '81658',
			Подмолодье: '81654',
			Пола: '81650',
			Полново: '81651',
			Порожки: '81662',
			Почугинское: '81669',
			Прилуки: '8162',
			Прогресс: '81664',
			Прокшино: '81667',
			Пролетарий: '8162',
			Прошково: '81664',
			Псижа: '81652',
			Пузырево: '81657',
			Ракитино: '81667',
			Ракушино: '81659',
			Рамушево: '81652',
			Ратицы: '81662',
			Ретно: '81655',
			Речка: '81664',
			Речки: '81655',
			Родники: '81668',
			Рощино: '81666',
			Ручьи: '81659',
			Савино: '8162',
			Светлицы: '81655',
			Селеево: '81658',
			Селище: '81657',
			Селищи: '81665',
			Семеновщина: '81666',
			Семытино: '81669',
			Сергово: '8162',
			Ситня: '81655',
			Скирино: '81655',
			Славитино: '81662',
			Слобода: '81668',
			Соловьево: '81662',
			Сольцы: '81655',
			Соменка: '81659',
			Сопки: '81654',
			Спасское: '81664',
			Сусолово: '81652',
			Сушилово: '81664',
			Сырково: '8162',
			Сябреницы: '81665',
			Тальцево: '81657',
			Тальцы: '81668',
			Тарасово: '81651',
			Теребутинец: '81668',
			Теремово: '81652',
			Тесовский: '8162',
			Тогодь: '81654',
			Топорок: '81657',
			Торбино: '81657',
			Травково: '81664',
			Трегубово: '81665',
			Трубичино: '8162',
			Тулебля: '81652',
			Тухомичи: '81654',
			Тухун: '81664',
			Угловка: '81657',
			Удино: '81664',
			Улома: '81669',
			Усторонье: '81666',
			Устрека: '81653',
			Устье: '81654',
			Устюцкое: '81669',
			Уторгош: '81656',
			Федорково: '81650',
			Хвойная: '81667',
			Хмелево: '81650',
			Холм: '81654',
			Холынья: '8162',
			Хоромы: '81664',
			Хотоли: '81659',
			Частова: '8162',
			Чекуново: '81654',
			Черенчицы: '81652',
			Чечулино: '8162',
			Чудово: '81665',
			Шереховичи: '81668',
			Шимск: '81656',
			Шишково: '81651',
			Шубино: '81652',
			Шуя: '81666',
			Юбилейный: '81667',
			Юрьево: '81650',
			Яжелбицы: '81666',
			Яковищи: '81653',
			Ямник: '81651',
			Ярцево: '81668'
		}
	},
	'Новосибирская область': {
		regionCode: '383',
		cities: {
			'Александро-Невское': '38366',
			'Аул-Бергуль': '38362',
			'Барабо-Юдино': '38368',
			'Большая Черная': '38349',
			'Большие Кулики': '38360',
			'Большой Изырак': '38347',
			'Верх-Алеус': '38359',
			'Верх-Балта': '38348',
			'Верх-Ики': '38347',
			'Верх-Ирмень': '38359',
			'Верх-Ича': '38362',
			'Верх-Коен': '38343',
			'Верх-Красноярка': '38360',
			'Верх-Майзас': '38371',
			'Верх-Мильтюши': '38345',
			'Верх-Сузун': '38346',
			'Верх-Тарка': '38371',
			'Верх-Тоя': '38352',
			'Верх-Тула': '383',
			'Верх-Урюм': '38363',
			'Верх-Чекино': '38371',
			'Верх-Чик': '38359',
			'Гусиный Брод': '383',
			'Дорогина Заимка': '38345',
			'Земляная Заимка': '38367',
			'Золотая Грива': '38350',
			'Иня-Восточная': '383',
			'Казачий Мыс': '38364',
			'Красная Грива': '38354',
			'Кудельный Ключ': '38340',
			'Лесная Поляна': '38351',
			'Малая Томка': '38347',
			'Мохнатый Лог': '38357',
			'Нижний Урюм': '38363',
			'Нижний Чулым': '38363',
			'Новая Кулында': '38368',
			'Новая Чебула': '38349',
			'Новые Кулики': '38369',
			'Новые Решеты': '38356',
			'Новый Баганенок': '38357',
			'Новый Майзас': '38371',
			'Новый Поросс': '38348',
			'Новый Тартас': '38369',
			'Новый Шарап': '38359',
			'Огнева Заимка': '38345',
			'Озерки-Шестые': '38365',
			'Озеро-Карачи Курорт': '38367',
			'Озеро-Карачи': '38367',
			'Орехов Лог': '38357',
			'Песчаное Озеро': '38367',
			'Петропавловка Вторая': '38369',
			'Петропавловка Первая': '38369',
			'Светлая Поляна': '38349',
			'Сибирцево Второе': '38369',
			'Сибирцево Первое': '38369',
			'Станционно-Ояшинский': '38348',
			'Старые Карачи': '38367',
			'Старый Искитим': '38343',
			'Убинское ': '38366',
			'Усть-Алеус': '38359',
			'Усть-Изес': '38369',
			'Усть-Каменка': '38340',
			'Усть-Ламенка': '38369',
			'Усть-Луковка': '38359',
			'Усть-Сумы': '38365',
			'Усть-Тарка': '38372',
			'Усть-Хмелевка': '38359',
			'Усть-Чем': '38343',
			'Участок Балта': '38348',
			'Форпост-Каргат': '38365',
			'Черный Мыс': '38366',
			'Шилово-Курья': '38355',
			'Широкий Яр': '38348',
			'Юный Пионер': '38361',
			'Юрт-Акбалык': '38352',
			'Яркуль-Матюшкино': '38372',
			'с. Здвинск ': '38363',
			Абрамово: '38362',
			Аксениха: '38357',
			Алабуга: '38365',
			Александровка: '38347',
			Александровский: '38355',
			Андреевка: '38353',
			Аткуль: '38365',
			Ача: '38349',
			Баган: '38353',
			Бадажки: '38361',
			Бажинск: '38347',
			Базово: '38350',
			Байкал: '38349',
			Баклуши: '38354',
			Бакмасиха: '38361',
			Балман: '38362',
			Балта: '38348',
			Барабинск: '38361',
			Барабка: '38343',
			Баратаевка: '38349',
			Барлак: '38348',
			Барышево: '383',
			Безменово: '38345',
			Белое: '38355',
			Белоярка: '38348',
			Бергуль: '38360',
			Бердск: '38341',
			Береговое: '383',
			Березиково: '38340',
			Березово: '38347',
			Биаза: '38360',
			Битки: '38346',
			Благовещенка: '38358',
			Благодатное: '38355',
			Блюдчанское: '38367',
			Бобровка: '38346',
			Болотное: '38349',
			Болтово: '38346',
			Большеникольское: '38350',
			Большеречка: '38349',
			Большеречье: '38371',
			Бор: '38349',
			Борисоглебский: '38366',
			Борково: '38347',
			Боровлянка: '38340',
			Боровое: '383',
			Борцово: '38340',
			Бочкаревка: '38371',
			Бочкарево: '38345',
			Боярка: '38352',
			Буготак: '38340',
			Булатово: '38362',
			Бураново: '38345',
			Бурмистрово: '38343',
			Быстровка: '38343',
			Быструха: '38356',
			Вараксино: '38371',
			Варваровка: '38368',
			Варламово: '38349',
			Вассино: '38340',
			Венгерово: '38369',
			Верхнеомка: '38372',
			Веселовское: '38357',
			Веснянка: '38362',
			Витаминка: '383',
			Вишневка: '38358',
			Владимировское: '38366',
			Воздвиженский: '38350',
			Волчанка: '38354',
			Воробьево: '38369',
			Вороновка: '38358',
			Вьюны: '38352',
			Гербаево: '38357',
			Гжатск: '38362',
			Горбуново: '38362',
			Горный: '38340',
			Городище: '38363',
			Гражданцево: '38360',
			Груздевка: '38365',
			Гусельниково: '38343',
			Дергаусово: '38340',
			Дивинка: '38349',
			Дмитриевка: '38364',
			Довольное: '38354',
			Долгово: '38340',
			Дорогино: '38345',
			Дресвянка: '38347',
			Дружный: '38354',
			Дубровино: '38348',
			Дубровка: '38347',
			Дупленская: '38356',
			Евсино: '38343',
			Егоровка: '38349',
			Егорьевское: '38347',
			Еланка: '38372',
			Елбань: '38347',
			Елизаветинка: '38368',
			Елтышево: '38348',
			Еремино: '38371',
			Ермаковский: '38356',
			Ермолаевка: '38366',
			Железнодорожный: '383',
			Жеребцово: '383',
			Жерновка: '38347',
			Жуланка: '38356',
			Журавка: '38368',
			Заковряжино: '38346',
			Заливино: '38371',
			Заречное: '38340',
			Заречье: '38369',
			Здвинск: '38363',
			Зимовье: '38345',
			Златоуст: '38340',
			Зоново: '38362',
			Зубково: '38357',
			Зубовка: '38364',
			Зудово: '38349',
			Зыково: '38369',
			Зюзя: '38361',
			Зятьковка: '38358',
			Ивановка: '38353',
			Издревая: '383',
			Индерь: '38354',
			Ирбизино: '38355',
			Искитим: '38343',
			Искра: '38345',
			Ишимская: '38368',
			Кабинетное: '38350',
			Кавказское: '38353',
			Казанак: '38357',
			Казанцево: '38361',
			Казаткуль: '38364',
			Кайлы: '38348',
			Калачи: '38355',
			Калиновка: '38355',
			Кама: '38362',
			Каменка: '383',
			Камышево: '38372',
			Камышинка: '38371',
			Камышино: '38358',
			Кандаурово: '38352',
			Карасук: '38355',
			Карган: '38365',
			Каргаполово: '38346',
			Каргат: '38365',
			Кармакла: '38361',
			Катково: '38351',
			Квашнино: '38361',
			Керамкомбинат: '38343',
			Киевка: '38364',
			Киик: '38340',
			Киргинцево: '38358',
			Кирза: '38359',
			Кирзинское: '38361',
			Клубничная: '38366',
			Ключевая: '38369',
			Ключики: '38346',
			Кожевниково: '38361',
			Кожурла: '38366',
			Козино: '38372',
			Козиха: '38359',
			Козловка: '38364',
			Козлово: '38351',
			Кокошино: '38350',
			Колбаса: '38371',
			Колыбелька: '38357',
			Колывань: '38352',
			Кольцовка: '38365',
			Кольцово: '383',
			Комарье: '38354',
			Комсомольский: '38362',
			Кондусла: '38362',
			Конево: '38357',
			Копкуль: '38358',
			Кордон: '38360',
			Корнилово: '38349',
			Королевка: '38352',
			Коурак: '38340',
			Коченево: '38351',
			Коченёво: '38351',
			Кочки: '38356',
			Кочневка: '38364',
			Красноглинное: '38373',
			Красногорский: '38348',
			Красное: '38367',
			Краснозёрское: '38357',
			Краснообск: '383',
			Красноселье: '38367',
			Красноярка: '38364',
			Крещенское: '38366',
			Криводановка: '383',
			Кривояш: '38349',
			Кротово: '38354',
			Кругликово: '38349',
			Круглоозерное: '38366',
			Крутиха: '38371',
			Крутишка: '38345',
			Крутологово: '38351',
			Кубовая: '383',
			Кудрино: '38340',
			Кудряшовский: '383',
			Кузнецовка: '38353',
			Куйбышев: '38362',
			Кукарка: '38355',
			Куликовское: '38350',
			Кульча: '38362',
			Куляба: '38371',
			Кундран: '38366',
			Кунчурук: '38349',
			Купино: '38358',
			Куриловка: '38345',
			Курундус: '38340',
			Курьинский: '38357',
			Кучугур: '38355',
			Кушаги: '38372',
			Кыштовка: '38371',
			Лебедевка: '38343',
			Лебедево: '38340',
			Легостаево: '38343',
			Лекарственное: '38340',
			Ленинский: '383',
			Ленинское: '383',
			Лепокурово: '38353',
			Линёво: '38343',
			Листвянка: '38345',
			Листвянский: '38343',
			Лобино: '38357',
			Лозовское: '38353',
			Локтенок: '38357',
			Лопатино: '38364',
			Лотошное: '38357',
			Луговой: '38357',
			Лукошино: '38358',
			Льниха: '38340',
			Лягушье: '38358',
			Лянино: '38363',
			Майский: '38345',
			Майское: '38357',
			Маландино: '38363',
			Малокрасноярка: '38371',
			Малышево: '38346',
			Мальчиха: '38352',
			Мамоново: '38347',
			Мамонтовое: '38365',
			Марусино: '383',
			Маршанское: '38365',
			Маслянино: '38347',
			Маюрово: '38346',
			Медведское: '38345',
			Медяково: '38358',
			Межовка: '38371',
			Меньшиково: '38369',
			Мереть: '38346',
			Метелево: '38358',
			Минино: '38369',
			Мирный: '38340',
			Мироновка: '38353',
			Михайловский: '38350',
			Мичуринский: '383',
			Мокрушино: '38340',
			Морозовка: '38355',
			Морозово: '38343',
			Мотково: '38348',
			Мочище: '383',
			Мошково: '38348',
			Мусы: '38365',
			Набережное: '38365',
			Нагорное: '38362',
			Неудачино: '38364',
			Нечаевский: '38340',
			Нижнекаменка: '38359',
			Нижнечеремошное: '38357',
			Николаевка: '38364',
			Никоново: '38347',
			Никулино: '38364',
			Новоабышево: '38340',
			Новоалександровка: '38364',
			Новобибеево: '38349',
			Нововоскресенка: '38345',
			Новогандичево: '38366',
			Новогутово: '38361',
			Новодубровское: '38366',
			Новоиткульское: '38350',
			Новоичинское: '38362',
			Новоключи: '38358',
			Новокозловское: '38361',
			Новокрасное: '38368',
			Новокремлевское: '38351',
			Новолокти: '38343',
			Новолуговое: '383',
			Новомошковское: '38348',
			Новоникольск: '38372',
			Новопервомайское: '38364',
			Новопесчаное: '38368',
			Новопичугово: '38359',
			Новопреображенка: '38367',
			Новороссийское: '38363',
			Новоселово: '38366',
			Новоселье: '38358',
			Новосибирск: '383',
			Новосилиш: '38372',
			Новоспасск: '38361',
			Новотырышкино: '38352',
			Новоульяновское: '38361',
			Новофеклино: '38367',
			Новоцелинное: '38356',
			Новочановское: '38361',
			Новочекино: '38371',
			Новошилово: '383',
			Новоярково: '38361',
			Обской: '38348',
			Обь: '38373',
			Овчинниково: '38351',
			Октябрьское: '38355',
			Ольгино: '38368',
			Ольховка: '38368',
			Оравка: '38367',
			Ордынское: '38359',
			Орловское: '38366',
			Осиново: '38362',
			Осиновский: '38350',
			Осинцево: '38367',
			Останинка: '38360',
			Остяцк: '38360',
			Отрадненское: '38362',
			Отреченское: '38367',
			Ояш: '38349',
			Павлово: '38369',
			Пайвино: '38347',
			Палецкое: '38353',
			Пашино: '383',
			Пенек: '38350',
			Пензино: '38361',
			Пеньково: '38347',
			Первомихайловка: '38364',
			Первотроицк: '38365',
			Петраки: '38363',
			Петровка: '38358',
			Петровский: '38359',
			Петропавловка: '38357',
			Пешково: '38366',
			Пихтовка: '38352',
			Плотниково: '383',
			Победа: '38372',
			Поваренка: '38351',
			Погорелка: '38367',
			Пойменное: '38340',
			Половинное: '38357',
			Полойка: '38357',
			Польяново: '38368',
			Помельцево: '38362',
			Пономаревка: '38352',
			Поповка: '38355',
			Посевная: '38345',
			Преображенка: '38343',
			Приобский: '383',
			Прокудское: '38351',
			Пролетарский: '38359',
			Пушной: '38345',
			Пятилетка: '38345',
			Радуга: '38348',
			Раздольное: '383',
			Раисино: '38366',
			Рассказово: '38355',
			Репьево: '38340',
			Республиканский: '38356',
			Речник: '38351',
			Решеты: '38356',
			Рогалево: '38359',
			Рождественка: '38358',
			Рождественский: '38355',
			Романовка: '38368',
			Савкино: '38353',
			Сапожковский: '38365',
			Сарапулка: '38348',
			Сарыбалык: '38363',
			Светлое: '38357',
			Светлый: '38351',
			Северное: '38360',
			Северный: '38352',
			Северотатарское: '38364',
			Селикла: '38369',
			Сенчанка: '383',
			Сергеевка: '38371',
			Сергино: '38362',
			Серебренниково: '38347',
			Серебрянское: '38350',
			Сибирский: '38358',
			Сидоровка: '38352',
			Скала: '38352',
			Смоленский: '38348',
			Советский: '38358',
			Согорное: '38354',
			Соколово: '38352',
			Сокур: '38348',
			Соловьевка: '38353',
			Сорочиха: '38355',
			Спирино: '38359',
			Среднеичинский: '38360',
			Старогорносталево: '38363',
			Старощербаково: '38361',
			Стеклянное: '38358',
			Степногутово: '38340',
			Степной: '38343',
			Студеное: '38355',
			Суенга: '38347',
			Суздалка: '38354',
			Сузун: '38346',
			Сумы: '38365',
			Сурково: '38340',
			Табулга: '38368',
			Таган: '38367',
			Тальменка: '38343',
			Тармакуль: '38367',
			Таскаево: '38361',
			Татарск: '38364',
			Ташара: '38348',
			Тебисское: '38367',
			Теренгуль: '38353',
			Тогучин: '38340',
			Томилово: '38348',
			Травное: '38354',
			Троицкий: '38356',
			Тропино: '38352',
			Тулинский: '383',
			Турнаево: '38349',
			Туруновка: '38369',
			Убинское: '38366',
			Увальское: '38364',
			Ужаниха: '38350',
			Улыбино: '38343',
			Ульяновка: '38357',
			Умрева: '38348',
			Урез: '38369',
			Ускуль: '38364',
			Успенка: '38364',
			Устьянцево: '38361',
			Устюжанино: '38359',
			Утянка: '38354',
			Федоровка: '38360',
			Федосиха: '38351',
			Филиппово: '38359',
			Филошенка: '38369',
			Хапово: '38363',
			Холодное: '38346',
			Хорошее: '38355',
			Цветники: '38363',
			Целинное: '38351',
			Чаинка: '38358',
			Чаны: '38367',
			Чаргары: '38369',
			Чебаки: '38360',
			Чемское: '38340',
			Черепаново: '38345',
			Чернаковка: '38371',
			Чернокурья: '38355',
			Чернореченский: '38343',
			Чик: '38351',
			Чикман: '38350',
			Чингисы: '38359',
			Чистоозерное: '38368',
			Чистополье: '38351',
			Чуваши: '38360',
			Чудиново: '38347',
			Чулым: '38350',
			Чумаково: '38362',
			Чумашки: '38358',
			Чупино: '38347',
			Шагалка: '38354',
			Шагалово: '38351',
			Шаитик: '38358',
			Шайдуровский: '38359',
			Шарчино: '38346',
			Шахта: '38340',
			Шибково: '38343',
			Шипуново: '38346',
			Шубинское: '38361',
			Шурыгино: '38345',
			Щеглово: '38367',
			Щербаки: '38372',
			Южино: '38352',
			Юрты: '38340',
			Янченково: '38340',
			Ярково: '383'
		}
	},
	'Омская область': {
		regionCode: '381',
		cities: {
			'Белый Яр': '38154',
			'Большая Бича': '38150',
			'Большая Роща': '38168',
			'Большая Тава': '38150',
			'Большие Туралы': '38171',
			'Большие Уки': '38162',
			'Большой Атмас': '38153',
			'Веселая Поляна': '38175',
			'Веселый Привал': '38170',
			'Горячий Ключ': '3812',
			'Заря Свободы': '38168',
			'Звонарев Кут': '38141',
			'Золотая Нива': '38166',
			'Иванов Мыс': '38154',
			'Камышино-Курское': '38158',
			'Красная Горка': '3812',
			'Красная Поляна': '38157',
			'Красное Знамя': '38174',
			'Красный Октябрь': '38153',
			'Крутая Горка': '3812',
			'Лорис-Меликово': '38161',
			'Любино-Малороссы': '38175',
			'Малая Бича': '38150',
			'Могильно-Посельское': '38169',
			'Моховой Привал': '38158',
			'Нижняя Омка': '38165',
			'Новая Шараповка': '38168',
			'Новый Кошкуль': '38176',
			'Новый Свет': '38155',
			'Пашенная Роща': '38172',
			'Покрово-Иртышское': '3812',
			'Путь Социализма': '38161',
			'Родная Долина': '38174',
			'Русская Поляна': '38156',
			'Северо-Любинский': '38175',
			'Увало-Ядрино': '38175',
			'Увальная Бития': '38178',
			'Усть-Инцы': '38164',
			'Усть-Ишим': '38150',
			'Усть-Тара': '38171',
			'Усть-Шиш': '38179',
			'Центрально-Любинский': '38175',
			'Черлак-Станция': '38153',
			'Южно-Подольск': '38153',
			'поселок Конезаводский': '38168',
			'село Большие Уки': '38162',
			'село Седельниково': '38164',
			'село Форпост': '38162',
			Авяк: '38179',
			Аев: '38162',
			Азово: '38141',
			Аксеново: '38150',
			Алабота: '38156',
			Алексеевский: '38157',
			Аникино: '38160',
			Антоновка: '38165',
			Аполлоновка: '38173',
			Артын: '38158',
			Астыровка: '38157',
			Атирка: '38171',
			Атрачи: '38176',
			Ачаирский: '3812',
			Бабеж: '38177',
			Баженово: '38178',
			Бакино: '38164',
			Бакшеево: '38154',
			Баррикада: '38173',
			Бекишево: '38176',
			Белоглазово: '38176',
			Белогривка: '38162',
			Белосток: '38159',
			Бергамак: '38158',
			Береговой: '3812',
			Березовка: '38141',
			Благодаровка: '38159',
			Бобринка: '38152',
			Богдановка: '38170',
			Богодуховка: '38172',
			Боголюбовка: '38168',
			Богословка: '3812',
			Боевой: '38173',
			Бологое: '38156',
			Большаковка: '38175',
			Большегривское: '38152',
			Большепесчанка: '38161',
			Большеречье: '38169',
			Борисовское: '38177',
			Борки: '38170',
			Бражниково: '38160',
			Буняковка: '38159',
			Бутаково: '38179',
			Валуевка: '38176',
			Васильевка: '38168',
			Васисс: '38171',
			Великорусское: '38155',
			Верблюжье: '38178',
			Владимировка: '38160',
			Вольное: '38163',
			Воронцовка: '38163',
			Воскресенка: '38155',
			Восточный: '38176',
			Вставское: '38171',
			Входной: '3812',
			Ганновка: '38159',
			Гауф: '38141',
			Гвоздевка: '38174',
			Глуховка: '38155',
			Глухониколаевка: '38165',
			Горьковское: '38157',
			Гостиловка: '38163',
			Гурово: '38158',
			Дачное: '38168',
			Дачный: '3812',
			Девятириковка: '3812',
			Демьяновка: '38157',
			Десподзиновка: '38178',
			Джартаргуль: '38153',
			Добровольск: '38156',
			Дружино: '3812',
			Дурново: '38158',
			Евгащино: '38169',
			Евлантьевка: '38164',
			Егоровка: '38171',
			Екатерининское: '38171',
			Екатериновка: '38154',
			Екатеринославка: '38177',
			Елизаветинка: '38153',
			Елизаветино: '38166',
			Ельничное: '38164',
			Еремеевка: '38163',
			Ермак: '38152',
			Ермаковка: '38171',
			Ермиловка: '38154',
			Желанное: '38159',
			Жирновка: '38161',
			Журавлевка: '38154',
			Завьялово: '38179',
			Загваздино: '38150',
			Заливино: '38171',
			Замелетеновка: '38175',
			Заречное: '38152',
			Звездино: '38174',
			Зимино: '38167',
			Знаменское: '38179',
			Золотухино: '38153',
			Ивановка: '38155',
			Изюмовка: '38177',
			Ильичевка: '38174',
			Имшегал: '38171',
			Ингалы: '38169',
			Индейка: '38155',
			Интенис: '38178',
			Иртыш: '38153',
			Иртышский: '3812',
			Исилькуль: '38173',
			Искра: '38161',
			Кабанье: '38155',
			Кабырдак: '38176',
			Казанка: '38175',
			Кайлы: '38150',
			Кайсы: '38150',
			Калачинск: '38155',
			Камышловский: '38175',
			Карбаиново: '38176',
			Карбыза: '38158',
			Карповка: '38151',
			Каскат: '38173',
			Качуково: '38179',
			Кейзес: '38164',
			Кип: '38154',
			Киселево: '38179',
			Кисляки: '38161',
			Китерма: '38167',
			Ключи: '3812',
			Князево: '38161',
			Ковалево: '38155',
			Колосовка: '38160',
			Кольтюгино: '38171',
			Комиссаровское: '38177',
			Комсомольский: '38173',
			Кондратьево: '38158',
			Кондрашино: '38179',
			Конезаводский: '38168',
			Копейкино: '38151',
			Кормиловка: '38170',
			Корсино: '38160',
			Коршуновка: '38176',
			Костино: '38158',
			Котовщиково: '38179',
			Крайчиково: '38160',
			Красногорка: '38163',
			Красноусово: '38176',
			Красовка: '38166',
			Крестики: '38166',
			Крутинка: '38167',
			Ксеньевка: '38173',
			Кузнецово: '38154',
			Кукарка: '38164',
			Куликово: '38155',
			Куломзино: '38166',
			Курганка: '38158',
			Курносово: '38169',
			Кутузовка: '38177',
			Кутурлы: '38160',
			Кушайлы: '38178',
			Лагушино: '38155',
			Ламаново: '38160',
			Лебединка: '38164',
			Лежанка: '38157',
			Лесной: '38173',
			Лисино: '38158',
			Листвяги: '38162',
			Литковка: '38171',
			Логиновка: '38172',
			Ложниково: '38171',
			Лубянск: '38163',
			Луговое: '38151',
			Лузино: '3812',
			Лукьяновка: '38159',
			Львовка: '38155',
			Любимовка: '38166',
			Любино: '38175',
			Любинский: '38175',
			Любовка: '38152',
			Любомировка: '38151',
			Магистральный: '3812',
			Малиновка: '38176',
			Мангут: '38161',
			Маргенау: '38173',
			Мариновка: '38166',
			Мартюшево: '38171',
			Марьяновка: '38168',
			Марьяновский: '38168',
			Маяк: '38166',
			Медвежье: '38173',
			Медет: '38153',
			Междуречье: '38171',
			Мельничное: '3812',
			Меркутлы: '38160',
			Милоградовка: '38172',
			Морозовка: '3812',
			Москаленки: '38174',
			Москаленский: '38168',
			Муравьевка: '38161',
			Муромцево: '38158',
			Мыс: '38158',
			Нагибино: '38176',
			Нагорное: '38171',
			Надеждино: '3812',
			Назаровка: '38172',
			Называевск: '38161',
			Налимово: '38161',
			Неверовка: '38151',
			Некрасовка: '38170',
			Немировка: '38170',
			Нижнеиртышское: '38178',
			Низовое: '38158',
			Никольск: '38150',
			Никольское: '38176',
			Никоновка: '3812',
			Новоархангелка: '38175',
			Нововаршавка: '38152',
			Новоивановка: '38165',
			Новоильинка: '38163',
			Новокарасук: '38167',
			Новокиевка: '38175',
			Новолосево: '38173',
			Новоомский: '3812',
			Новопокровка: '38157',
			Новорождественка: '38173',
			Новороссийка: '38152',
			Новосанжаровка: '38156',
			Новоселецк: '38151',
			Новоселье: '38170',
			Новосергеевка: '38163',
			Новоскатовка: '38177',
			Новотроицкое: '3812',
			Новоуйка: '38164',
			Новоуральский: '38151',
			Новоуральское: '38172',
			Новоцарицыно: '38174',
			Новоягодное: '38179',
			Ночка: '38173',
			Оглухино: '38167',
			Одесское: '38159',
			Оконешниково: '38166',
			Октябрьский: '38176',
			Октябрьское: '38157',
			Ольгино: '38163',
			Омск: '3812',
			Омский: '3812',
			Орлово: '38171',
			Осокино: '38155',
			Осташково: '3812',
			Отрадное: '38168',
			Охотниково: '38176',
			Павлоградка: '38172',
			Павлодаровка: '38157',
			Паутовка: '38165',
			Первотаровка: '38173',
			Петелино: '38154',
			Петровка: '3812',
			Петрово: '38154',
			Пикетное: '38168',
			Платово: '38163',
			Платоновка: '38152',
			Плотбище: '38158',
			Победа: '38152',
			Победитель: '38170',
			Побочино: '38159',
			Пологрудово: '38171',
			Полтавка: '38163',
			Поречье: '38158',
			Почекуево: '38169',
			Преображеновка: '38178',
			Прииртышье: '38151',
			Пристанское: '38151',
			Протопоповка: '38175',
			Пушкино: '3812',
			Радищево: '38165',
			Раздольное: '38172',
			Ракитинка: '3812',
			Ребровка: '3812',
			Репинка: '38155',
			Речной: '3812',
			Рогозино: '38164',
			Рославка: '38173',
			Ростовка: '3812',
			Рощино: '38157',
			Рощинский: '38170',
			Русановка: '38152',
			Рыжково: '38167',
			Рязаны: '38158',
			Сажино: '38176',
			Салтаим: '38167',
			Самсоново: '38171',
			Саратовка: '38164',
			Саргатское: '38178',
			Седельниково: '38164',
			Сергеевка: '38166',
			Серебряное: '38157',
			Сибирское: '38156',
			Ситниково: '38165',
			Скородум: '38150',
			Славянка: '38152',
			Слобода: '38179',
			Слободчики: '38150',
			Смирновка: '38165',
			Солнцевка: '38173',
			Солнцево: '38177',
			Соловецкое: '38165',
			Соловьевка: '38163',
			Соляное: '38153',
			Сорочино: '38155',
			Сосновка: '38170',
			Сосновское: '38151',
			Соусканово: '38171',
			Становка: '38162',
			Старинка: '38161',
			Старокарасук: '38169',
			Старомалиновка: '38165',
			Степановка: '38156',
			Степное: '38168',
			Степок: '38174',
			Стрела: '38151',
			Строкино: '38160',
			Сухое: '38157',
			Сыропятское: '38170',
			Тавричанка: '38175',
			Таврическое: '38151',
			Такмык: '38169',
			Таловское: '38177',
			Тара: '38171',
			Тармакла: '38158',
			Таскатлы: '38160',
			Татарка: '38153',
			Тевриз: '38154',
			Терпенье: '38163',
			Тихвинка: '38172',
			Тихорецкое: '38151',
			Толбакуль: '38160',
			Толоконцево: '38167',
			Троицк: '38176',
			Троицкое: '3812',
			Трубецкое: '38141',
			Тумановка: '38174',
			Тургеневка: '38155',
			Тюкалинск: '38176',
			Украинка: '38173',
			Уленкуль: '38169',
			Ульяновка: '3812',
			Унара: '38164',
			Уралы: '38162',
			Ураш: '38154',
			Урожайный: '38175',
			Усовка: '38168',
			Утичье: '38161',
			Утьма: '38154',
			Ушаково: '38158',
			Фирстово: '38162',
			Фомиха: '38161',
			Форпост: '38162',
			Харино: '3812',
			Харламово: '38151',
			Хлебодаровка: '38156',
			Хмаровка: '38163',
			Хомутинка: '38165',
			Хорошки: '38172',
			Хортицы: '38165',
			Хохлово: '38178',
			Хутора: '38176',
			Царицыно: '38155',
			Цветнополье: '38141',
			Цветочное: '38156',
			Целинное: '38156',
			Чапаево: '38160',
			Чередово: '38179',
			Черемновка: '38161',
			Черемуховское: '3812',
			Черлак: '38153',
			Черлакский: '38152',
			Чернецовка: '38162',
			Чернолучинский: '3812',
			Черноусовка: '38156',
			Черняево: '38171',
			Черталы: '38158',
			Чистово: '38166',
			Шахово: '38163',
			Шевченко: '38174',
			Шербакуль: '38177',
			Шипицыно: '38169',
			Шипуново: '38167',
			Шухово: '38179',
			Щербаки: '38178',
			Щербакуль: '38177',
			Элита: '38174',
			Южное: '38172',
			Юрьевка: '38172',
			Юрьево: '38170',
			Язово: '38166',
			Яланкуль: '38169',
			Яман: '38167',
			Ярково: '38150',
			Ярославка: '38176'
		}
	},
	'Оренбургская область': {
		regionCode: '353',
		cities: {
			'Боевая Гора': '35336',
			'Большой Зайкин': '35348',
			'Большой Сурмет': '35355',
			'Верхние Чебеньки': '35331',
			'Верхний Гумбет': '35330',
			'Верхняя Вязовка': '35342',
			'Верхняя Платовка': '35339',
			'Веселый Первый': '35335',
			'Голубой Факел': '35367',
			'Елшанка-Вторая': '35342',
			'Елшанка-Первая': '35342',
			'Ефремово-Зыково': '35357',
			'Зеленая Роща': '35359',
			'Ивановка-Вторая': '35346',
			'Изяк-Никитино': '35358',
			'Имангулово-Второе': '35330',
			'Каменная Сарма': '35342',
			'Каменно-Имангулово': '35347',
			'Камыш-Садак': '35355',
			'Карагай-Покровка': '35361',
			'Красная Поляна': '35339',
			'Красная Слободка': '35342',
			'Красный Коммунар': '35331',
			'Красный Яр': '35337',
			'Курская Васильевка': '35354',
			'Ленина поселок': '3532',
			'Лисья Поляна': '35342',
			'Малая Ремизенка': '35349',
			'Малый Зайкин': '35348',
			'Малый Сурмет': '35355',
			'Михайловка-Вторая': '35346',
			'Михайловка-Первая': '35346',
			'Мордово-Добрино': '35354',
			'Мордовский Бугуруслан': '35352',
			'Нижние Кузлы': '35357',
			'Нижний Гумбет': '35330',
			'Нижний Курмей': '35355',
			'Нижняя Вязовка': '35342',
			'Нижняя Кийма': '35365',
			'Новая Белогорка': '35346',
			'Новая Ракитянка': '35361',
			'Новая Тепловка': '35342',
			'Новорск Вокзал': '35363',
			'Новый Сулак': '35333',
			'Новый Тирис': '35355',
			'Павло-Антоновка': '35349',
			'Петро-Херсонец': '35344',
			'Пригородная Покровка': '3532',
			'Родничный Дол': '35338',
			'Русская Бокла': '35352',
			'Русский Кандыз': '35354',
			'Русско-Игнашкино': '35344',
			'Сарай-Гир': '35356',
			'Соль-Илецк': '35336',
			'Старая Белогорка': '35339',
			'Старое Тюрино': '35352',
			'Старые Узели': '35352',
			'Старые Шалты': '35355',
			'Старый Сокулак': '35333',
			'Степной Маяк': '35339',
			'Тамар-Уткуль': '35336',
			'Татарская Каргала': '35331',
			'Тирис-Усманово': '35355',
			'Тоцкое Второе': '35349',
			'Черный Отрог': '35333',
			'Чукари-Ивановка': '35361',
			'Южный Урал': '3532',
			'Ясная Поляна': '35347',
			Абдрахманово: '35355',
			Абдулино: '35355',
			Абрамовка: '35338',
			Авдеевка: '35355',
			Адамовка: '35365',
			Айдырлинский: '35364',
			Акбулак: '35335',
			Акжарское: '35368',
			Аккермановка: '3537',
			Аксаково: '35352',
			Аксенкино: '35354',
			Аксютино: '35351',
			Актюбинский: '35366',
			Алабайтал: '35334',
			Аландское: '35364',
			Алдаркино: '35342',
			Александровка: '35359',
			Аллабердино: '35332',
			Алмала: '35332',
			Андрианополь: '35364',
			Аниховка: '35365',
			Артемьевка: '35355',
			Архангеловка: '3532',
			Архангельское: '35367',
			Архиповка: '35331',
			Асекеево: '35351',
			Байгоровка: '35341',
			Бакаево: '35354',
			Баландино: '35351',
			Балейка: '35339',
			Банное: '35362',
			Барабановка: '35339',
			Бараково: '35358',
			Беловка: '35331',
			Белогорский: '35334',
			Белозерка: '35330',
			Белоусовка: '35331',
			Беляевка: '35334',
			Бердянка: '3532',
			Берестовка: '35339',
			Бестужевка: '35352',
			Биккулово: '35330',
			Благовещенка: '35332',
			Благодаровка: '35352',
			Благословенка: '3532',
			Блявтамак: '35379',
			Бобровка: '35341',
			Богородское: '35358',
			Богоявленка: '35367',
			Болдырево: '35347',
			Большедорожный: '35354',
			Борискино: '35356',
			Борисовка: '35357',
			Бородинск: '35347',
			Брацлавка: '35365',
			Бриент: '35364',
			Бродецкое: '3532',
			Броды: '35330',
			Бугуруслан: '35352',
			Будамша: '35363',
			Бузулук: '35342',
			Буланово: '35330',
			Буранное: '35336',
			Буранчи: '35334',
			Бурдыгино: '35346',
			Буренино: '35347',
			Бурлыкский: '35334',
			Буртинский: '35334',
			Бурунча: '35333',
			Бухарча: '35361',
			Верхнебузулукский: '35349',
			Верхнеигнашкино: '35344',
			Верхнекардаиловка: '35364',
			Верхнеозерное: '35334',
			Верхнепавлушкино: '35352',
			Веселовский: '35368',
			Ветлянка: '35336',
			Вишневое: '35362',
			Вознесенка: '35345',
			Войковский: '35346',
			Волжский: '35341',
			Воскресеновка: '35351',
			Восточный: '35366',
			Высотный: '35356',
			Вязовка: '3532',
			Вязовое: '35347',
			Гай: '35362',
			Гамалеевка: '35346',
			Гаршино: '35341',
			Георгиевка: '35359',
			Герасимовка: '35339',
			Гирьял: '35334',
			Горный: '3532',
			Городище: '3532',
			Городки: '35332',
			Горьковское: '35363',
			Гостеприимный: '35366',
			Гранитный: '35363',
			Грачевка: '35344',
			Гребени: '35331',
			Григорьевка: '35336',
			Губерля: '3537',
			Дедуровка: '3532',
			Державино: '35342',
			Джарлинский: '35365',
			Дивнополье: '35336',
			Димитровский: '35337',
			Днепровка: '35334',
			Добринка: '35359',
			Добровольское: '35363',
			Домбаровка: '35367',
			Домбаровский: '35367',
			Донгузская: '3532',
			Донецкое: '35338',
			Донское: '35334',
			Дружба: '35336',
			Дубенское: '35334',
			Дубиновка: '35361',
			Думино: '35351',
			Дымка: '35354',
			Дюсметьево: '35357',
			Екатеринославка: '35332',
			Елатомка: '35352',
			Еленовка: '35368',
			Елизаветинка: '35365',
			Елховка: '35342',
			Емельяновка: '35356',
			Емонтаево: '35355',
			Ероховка: '35344',
			Ефимовка: '35341',
			Жанаталап: '35334',
			Ждановка: '35359',
			Желтое: '35333',
			Жидиловка: '35349',
			Жилинка: '35342',
			Завьяловка: '35352',
			Заглядино: '35351',
			Задорожный: '35349',
			Залесово: '35345',
			Заречное: '35347',
			Затонное: '35337',
			Зауральный: '3532',
			Зеленодольск: '35364',
			Землянка: '35339',
			Зерикла: '35355',
			Зерикло: '35358',
			Зеркло: '35358',
			Зиянчурино: '35361',
			Злобинка: '35349',
			Зобово: '35358',
			Зубаревка: '3532',
			Ибрагимово: '35361',
			Ибряево: '35354',
			Изобильное: '35336',
			Илек: '35337',
			Илькульган: '35358',
			Ириклинский: '35362',
			Исайкино: '35355',
			Искра: '35342',
			Кабаевка: '35354',
			Кабанкино: '35333',
			Казанка: '35358',
			Каировка: '35333',
			Кайракты: '35335',
			Каликино: '35359',
			Калинин: '35347',
			Камейкино: '35362',
			Каменногорское: '35354',
			Каменное: '35348',
			Каменноозерное: '3532',
			Камышино: '35333',
			Кандауровка: '35341',
			Канчерово: '35361',
			Капитоновка: '35338',
			Караванный: '3532',
			Карагач: '35334',
			Карагузино: '35333',
			Каракудук: '35335',
			Карасай: '35335',
			Каргала: '3532',
			Кардаилово: '35337',
			Кариновка: '35338',
			Кармалка: '35358',
			Карповка: '35335',
			Кваркено: '35364',
			Кинделя: '35347',
			Кинельский: '35356',
			Кинзелька: '35345',
			Кировск: '35364',
			Кирсановка: '35349',
			Кирюшкино: '35352',
			Кисла: '35351',
			Кичкасс: '35338',
			Ковыляевка: '35349',
			Козловка: '35339',
			Кокошеевка: '35352',
			Колпакское: '35362',
			Колтубанка: '35342',
			Колтубановский: '35342',
			Комарово: '35368',
			Комаровский: '35368',
			Коминтерн: '35364',
			Комиссарово: '35330',
			Комсомольский: '35365',
			Кондуровка: '35333',
			Константиновка: '35358',
			Коптяжево: '35352',
			Коровино: '35352',
			Корсунский: '35367',
			Коскуль: '35366',
			Костино: '35341',
			Котансу: '35368',
			Красногвардеец: '35342',
			Красногор: '35333',
			Красногорский: '35351',
			Красное: '35348',
			Краснознаменка: '35361',
			Краснооктябрьский: '35330',
			Краснохолм: '35337',
			Красночабанский: '35367',
			Краснощеково: '35361',
			Красноярский: '35364',
			Кристалка: '35345',
			Крыловка: '3537',
			Крючковка: '35334',
			Кряжлы: '35354',
			Кубанка: '35338',
			Кувай: '35339',
			Кувандык: '35361',
			Кузькино: '35356',
			Кузьминовка: '35330',
			Кулагино: '35339',
			Кульчум: '35356',
			Кульчумово: '35333',
			Кумакский: '35336',
			Курлино: '35348',
			Курманаевка: '35341',
			Курмансай: '35367',
			Куруил: '35361',
			Кутлуево: '35351',
			Кутушево: '35339',
			Кутуши: '35341',
			Лабазы: '35341',
			Лаврентьевка: '35341',
			Лапаз: '35339',
			Лекаревка: '35351',
			Ленинский: '35348',
			Линевка: '35336',
			Липовка: '35342',
			Логачевка: '35349',
			Лукинка: '35352',
			Лылов: '35362',
			Любимовка: '35349',
			Мазово: '35361',
			Майский: '35365',
			Максимовка: '35357',
			Мамалаевка: '35338',
			Мананниково: '35349',
			Марковка: '35349',
			Марксовский: '35359',
			Мартыновка: '35351',
			Матвеевка: '35356',
			Маякский: '35336',
			Маячная: '35336',
			Маячный: '35361',
			Медведка: '35349',
			Медногорск: '35379',
			Междуречье: '35334',
			Михеевка: '35354',
			Могутово: '35342',
			Молодежный: '35349',
			Моторино: '35354',
			Мочегай: '35351',
			Мрясовой: '35339',
			Мустаево: '35339',
			Мустафино: '35358',
			Мухамедьярово: '35361',
			Мухраново: '35337',
			Надеждинка: '35333',
			Назаровка: '35348',
			Наурузово: '35357',
			Невежкино: '35349',
			Нежинка: '3532',
			Нестеровка: '35339',
			Нижнеаскарово: '35333',
			Нижнекристалка: '35345',
			Нижнеозерное: '35337',
			Нижнепавловка: '3532',
			Никитино: '35333',
			Николькино: '35355',
			Никольск: '35361',
			Новоалександровка: '35342',
			Новоархангельское: '35358',
			Новоаширово: '35356',
			Нововасильевка: '35332',
			Нововиницкое: '35365',
			Нововоронежский: '35362',
			Новогеоргиевка: '35358',
			Новогригорьевка: '35335',
			Новодомосейкино: '35354',
			Новожедрино: '35356',
			Новоилецк: '35336',
			Новокаменка: '35347',
			Новокиевка: '35362',
			Новомихайловка: '35359',
			Новомусино: '35358',
			Новониколаевка: '35362',
			Новоникольское: '35344',
			Новооренбург: '35364',
			Новоорск: '35363',
			Новопавловка: '35335',
			Новопетровка: '35345',
			Новопетропавловка: '35362',
			Новопокровка: '35361',
			Новородниковка: '35339',
			Новорудный: '3537',
			Новосаринский: '35361',
			Новоселки: '35333',
			Новосельский: '35368',
			Новосергиевка: '35339',
			Новосимбирка: '35361',
			Новоспасск: '35359',
			Новоспасское: '35356',
			Новосултангулово: '35351',
			Новотроевка: '35355',
			Новотроицк: '3537',
			Новотроицкое: '35330',
			Новоузели: '35356',
			Новоуральск: '35361',
			Новоуспеновка: '35335',
			Новочеркасск: '35333',
			Новоюласка: '35345',
			Новоякупово: '35355',
			Нойкино: '35352',
			Нуштайкино: '35352',
			Обильный: '35365',
			Озерка: '35359',
			Озеркиво: '35337',
			Озерное: '35348',
			Озерный: '35366',
			Октябрьский: '35364',
			Октябрьское: '35330',
			Оноприеновка: '35361',
			Оренбург: '3532',
			Орловка: '35331',
			Орск: '3537',
			Островное: '35333',
			Палимовка: '35342',
			Парадеево: '35358',
			Партизанский: '35342',
			Пашкино: '35354',
			Первокрасное: '35346',
			Первомайск: '35361',
			Первомайский: '35348',
			Первомайское: '35336',
			Переволоцкий: '35338',
			Петровское: '35333',
			Пилюгино: '35352',
			Писаревка: '35362',
			Платовский: '35339',
			Плешаново: '35345',
			Победа: '35344',
			Погромное: '35349',
			Подгорное: '35361',
			Подколки: '35342',
			Подлесное: '35344',
			Подольск: '35345',
			Подстепки: '35337',
			Полевой: '35367',
			Полибино: '35352',
			Поникла: '35352',
			Пономаревка: '35357',
			Портнов: '35330',
			Претория: '35338',
			Пречистенка: '3532',
			Прибрежный: '35367',
			Приветливый: '35358',
			Привольный: '35337',
			Пригородный: '3532',
			Придолинный: '35347',
			Приморск: '35364',
			Приуральский: '3532',
			Приютное: '35349',
			Прогресс: '3537',
			Пролетарка: '35345',
			Проскурино: '35342',
			Просторы: '35364',
			Пруды: '3532',
			Пугачевский: '3532',
			Путятино: '35358',
			Равнинный: '35357',
			Разномойка: '35332',
			Ракитянка: '35379',
			Раннее: '35347',
			Рассыпная: '35337',
			Ратчино: '35358',
			Революционное: '35348',
			Ремчугово: '35354',
			Репьевка: '35332',
			Речной: '35365',
			Ржавка: '35339',
			Родинский: '35346',
			Ромашкино: '35341',
			Российский: '35330',
			Рубежинский: '35348',
			Рудное: '35332',
			Рыбкино: '35339',
			Рысаево: '35379',
			Рычково: '35354',
			Рычовка: '35338',
			Рязановка: '35351',
			Саблино: '35344',
			Сагарчин: '35335',
			Садовый: '35338',
			Саиновка: '35349',
			Сакмара: '35331',
			Саловка: '35352',
			Самаркино: '35351',
			Самородово: '3532',
			Сара: '35361',
			Сарабкино: '35346',
			Саракташ: '35333',
			Саратовка: '35336',
			Сарбай: '35361',
			Сарманай: '35358',
			Свердлово: '35349',
			Свердловский: '35345',
			Светлый: '35366',
			Северное: '35354',
			Северный: '35336',
			Секретарка: '35354',
			Сенное: '35338',
			Сергеевка: '35341',
			Сергушкино: '35354',
			Сладков: '35337',
			Слободка: '35346',
			Слоновка: '35358',
			Соболево: '35348',
			Советский: '35333',
			Совхозный: '35365',
			Соковка: '35354',
			Соловьевка: '3532',
			Сорочинск: '35346',
			Сосновка: '35364',
			Софиевка: '35357',
			Спасское: '35333',
			Спиридоновка: '35341',
			Среднеуранский: '35339',
			Старица: '3532',
			Старицкое: '35334',
			Староалександровка: '35342',
			Староаширово: '35356',
			Старобогдановка: '35345',
			Староборискино: '35354',
			Стародомосейкино: '35354',
			Старокульшарипово: '35351',
			Старокутлумбетьево: '35356',
			Старомукменево: '35351',
			Староникольское: '35345',
			Старояшкино: '35344',
			Степановский: '3532',
			Струково: '3532',
			Студеное: '35337',
			Студенцы: '35333',
			Суворовский: '35349',
			Судьбодаровка: '35339',
			Сузаново: '35339',
			Султакай: '35359',
			Сунарча: '35333',
			Сырт: '35338',
			Таллы: '35344',
			Таналык: '35364',
			Татищево: '35338',
			Ташла: '35347',
			Твердилово: '35342',
			Теплое: '35348',
			Теренсай: '35365',
			Тимашево: '35331',
			Тимошкино: '35356',
			Титовка: '35358',
			Тобольский: '35366',
			Толкаевка: '35346',
			Тоцкое: '35349',
			Трифоновка: '35354',
			Троицк: '35336',
			Тугустемир: '35332',
			Тупиковка: '35342',
			Тюльган: '35332',
			Тюльпан: '35348',
			Угольное: '35336',
			Ударник: '3537',
			Украинка: '35331',
			Урал: '35361',
			Уральск: '35362',
			Уральский: '35348',
			Уральское: '35364',
			Уранбаш: '35330',
			Уртазым: '35364',
			Ушкатты: '35367',
			Фадеевка: '35357',
			Фурманов: '35348',
			Хабарное: '3537',
			Халилово: '35362',
			Херсоновка: '35334',
			Хмелевка: '35362',
			Хортица: '35359',
			Хуторка: '35339',
			Целинный: '35366',
			Чапаевка: '35363',
			Чапаево: '35356',
			Чапаевск: '35348',
			Чапаевский: '35331',
			Чебеньки: '3532',
			Чебоксарово: '35359',
			Чеботарево: '35361',
			Чеганлы: '35355',
			Черепаново: '35339',
			Черкассы: '35333',
			Чернореченское: '3532',
			Черноярово: '35347',
			Чесноковка: '35338',
			Чкалов: '3532',
			Чкаловский: '35351',
			Чулошников: '3532',
			Чураево: '35361',
			Шаповалово: '35335',
			Шапошниково: '35348',
			Шар: '35359',
			Шарлык: '35358',
			Шахматовка: '35342',
			Шестаковка: '35347',
			Шильда: '35365',
			Шкуновка: '35335',
			Шубино: '35361',
			Экспериментальный: '3532',
			Энергетик: '35363',
			Юбилейный: '35365',
			Юдинка: '35351',
			Юзеево: '35358',
			Юный: '3532',
			Ягодное: '35344',
			Яковлевка: '35351',
			Яковлево: '35354',
			Яман: '35337',
			Япрынцево: '35338',
			Ясногорский: '35339',
			Ясный: '35368',
			Яфарово: '35359',
			Яшкино: '35345'
		}
	},
	'Орловская область': {
		regionCode: '486',
		cities: {
			'Белый Колодезь Первый': '48674',
			'Большая Каменка': '48646',
			'Большая Куликовка': '4862',
			'Большая Чернава': '48663',
			'Большая Чернь': '48640',
			'Большие Озерки': '48667',
			'Большие Пруды': '48673',
			'Большое Юрьево': '48642',
			'Верхнее Алябьево': '48646',
			'Верхнее Скворчье': '48648',
			'Верхняя Залегощь': '48676',
			'Верхняя Любовша': '48663',
			'Вышнее Долгое': '48672',
			'Вышнее Ольшаное': '48672',
			'Вышний Туровец': '48664',
			'Вяжи-Заречье': '48673',
			'Вязовая Дубрава': '48677',
			'Гагаринский Хутор': '48667',
			'Гнилая Плота': '48679',
			'Гнилое Болото': '48665',
			'Дмитровск-Орловский': '48649',
			'Дубовая Роща': '4862',
			'Закромский Хутор': '48643',
			'Зверево-Бакулино': '48663',
			'Здоровецкие Выселки': '48677',
			'Ивань Первая': '48679',
			'Козьма-Демьяновка': '48672',
			'Коровье Болото': '48643',
			'Коротеево Первое': '48679',
			'Красная Заря': '48663',
			'Красная Звезда': '4862',
			'Красная Рыбница': '48645',
			'Красная Слободка': '48675',
			'Красно-Армейский': '48666',
			'Красные Рябинки': '48642',
			'Красный Октябрь': '48678',
			'Кривцово-Плота': '48672',
			'Малая Куликовка': '4862',
			'Малое Боброво': '48249',
			'Малое Сотниково': '48647',
			'Нижний Жерновец': '48676',
			'Нижняя Залегощь': '48648',
			'Нижняя Замарайка': '48672',
			'Нижняя Калиновка': '4862',
			'Нижняя Лужна': '4862',
			'Новая Жизнь': '48665',
			'Новая Петровка': '48645',
			'Новая Слободка': '4862',
			'Ново-Гнездилово': '48665',
			'Ново-Дмитровка': '4862',
			'Новый Синец': '48640',
			'Пенно-Удельное': '48666',
			'Полозовские Дворы': '4862',
			'Русский Брод': '48676',
			'Свободная Дубрава': '48677',
			'Спасское-Лутовиново': '48646',
			'Становой Колодезь': '4862',
			'Студеновский Cовхоз': '48672',
			'Тагино Совхоз': '48675',
			'Хутор-Лимовое': '48674',
			'Шаблыкино ': '48644',
			Александровка: '48679',
			Алехино: '48642',
			Алешинка: '48249',
			Алмазово: '48665',
			Аниканово: '48646',
			Аношинка: '48249',
			Арбузово: '48643',
			Архарово: '48679',
			Атяевка: '48643',
			Ахтырка: '48674',
			Бакланово: '4862',
			Бараново: '48677',
			Башкатово: '48646',
			Бегичево: '48663',
			Бельдяжки: '48643',
			Березовец: '48648',
			Березовка: '48664',
			Биофабрика: '4862',
			Благодать: '48678',
			Близна: '48640',
			Богдановка: '48647',
			Богодухово: '48645',
			Богородское: '48675',
			Болотово: '4862',
			Болхов: '48640',
			Борилово: '48640',
			Бородино: '48249',
			Бортное: '48648',
			Борщевка: '48647',
			Бунино: '48647',
			Важжово: '48677',
			Вахново: '48677',
			Введенское: '48677',
			Вепринец: '48664',
			Верховье: '48676',
			Верхососенье: '48664',
			Викторовка: '48677',
			Внуково: '48664',
			Воейково: '48642',
			Волково: '48646',
			Воронец: '48666',
			Вороново: '48674',
			Воротынск: '48677',
			Воротынцево: '48673',
			Высокое: '48646',
			Вязовая: '48640',
			Герасимово: '48644',
			Гладкое: '48646',
			Глазуновка: '48675',
			Глазуново: '48646',
			Глебово: '48678',
			Глотово: '48662',
			Глыбочки: '48644',
			Гнездилово: '48640',
			Гнилец: '48666',
			Гнилуша: '48675',
			Голунь: '48673',
			Горбуновка: '48249',
			Городецкое: '48674',
			Гостиново: '48645',
			Гостомль: '48643',
			Гранкино: '48666',
			Гремячево: '48675',
			Гремячка: '48677',
			Грязцы: '48677',
			Губкино: '48679',
			Давыдово: '48663',
			Даниловка: '48664',
			Девятино: '48249',
			Дементьевка: '48678',
			Демидово: '48677',
			Дмитровск: '48249',
			Долбенкино: '48249',
			Долгое: '48672',
			Домаха: '48249',
			Дровосечное: '48674',
			Дросково: '48664',
			Дружно: '48249',
			Дубки: '48677',
			Дубовик: '48679',
			Дубы: '48678',
			Егорьевка: '48645',
			Екатериновка: '48677',
			Ждимир: '48662',
			Жерино: '48677',
			Жерновец: '48666',
			Жилина: '4862',
			Жилино: '48646',
			Жихаревка: '48665',
			Жудре: '48642',
			Жулино: '48644',
			Задушное: '48673',
			Залегощь: '48648',
			Зареченский: '4862',
			Звезда: '48642',
			Звягинки: '4862',
			Змиёвка: '48645',
			Знаменка: '4862',
			Знаменское: '48662',
			Золотарево: '48648',
			Ивановка: '48664',
			Ивановское: '4862',
			Ильинское: '48642',
			Казанское: '48677',
			Калинино: '4862',
			Калиновка: '48672',
			Каменево: '48677',
			Каменец: '48666',
			Карповка: '48676',
			Кирово: '48665',
			Клевцово: '48674',
			Клейменово: '4862',
			Климово: '48644',
			Ключиковский: '48663',
			Козьминка: '48677',
			Козьминское: '48645',
			Козюлькино: '48640',
			Кологривово: '48678',
			Колпна: '48674',
			Коньшино: '48676',
			Коптево: '48662',
			Короськово: '48643',
			Коротыш: '48677',
			Корсаково: '48667',
			Корсунь: '48676',
			Корытенка: '48676',
			Косарево: '48678',
			Котово: '48647',
			Кривчее: '48640',
			Кривчиково: '48643',
			Кромы: '48643',
			Круглое: '48677',
			Кудиново: '48672',
			Куликовский: '4862',
			Кунач: '48677',
			Кутафино: '48643',
			Кутьма: '48640',
			Лаврово: '4862',
			Лазавка: '48678',
			Лебедка: '48647',
			Ливны: '48677',
			Липовец: '48664',
			Ловчиково: '48675',
			Локно: '48662',
			Ломовец: '48666',
			Ломовое: '48648',
			Лубянки: '48249',
			Луганка: '48672',
			Луковец: '48679',
			Луначары: '48647',
			Льгов: '48642',
			Любаново: '4862',
			Макеево: '48643',
			Малиново: '48663',
			Малоархангельск: '48679',
			Мальцево: '48677',
			Маркино: '48674',
			Маслово: '4862',
			Маховая: '48648',
			Маховица: '4862',
			Маяки: '48642',
			Медвежье: '48663',
			Мисайлово: '48674',
			Михайловка: '48678',
			Молодовое: '48644',
			Мощеное: '48642',
			Мужиково: '48673',
			Муравль: '48666',
			Мураевка: '48665',
			Мценск: '48646',
			Мымрино: '48662',
			Мыцкое: '48665',
			Навесное: '48677',
			Навля: '48644',
			Нарышкино: '48647',
			Некрасовка: '4862',
			Неполодь: '4862',
			Нетрубеж: '48674',
			Нечаево: '48667',
			Нижнеольшаное: '48672',
			Нововолковское: '48646',
			Новомалиново: '48667',
			Новомихайловка: '48667',
			Новополево: '48675',
			Новосиль: '48673',
			Новочеркасский: '48643',
			Норовка: '48677',
			Одинок: '48673',
			Однолуки: '48640',
			Ольховец: '48648',
			Орево: '48663',
			Орел: '4862',
			Орлянка: '48679',
			Орёл: '4862',
			Отрадинский: '48646',
			Пальчикова: '48640',
			Паньково: '48678',
			Пасынки: '48678',
			Паюсово: '4862',
			Пеньшино: '48676',
			Песочное: '48676',
			Петрушково: '48644',
			Петушки: '48673',
			Пешкова: '48662',
			Плещеево: '4862',
			Плоское: '48249',
			Плоты: '48645',
			Победа: '48643',
			Победное: '48648',
			Подбелевец: '48646',
			Подберезово: '48646',
			Подзавалово: '48647',
			Подмаслово: '48648',
			Подолянь: '48675',
			Поздеево: '48645',
			Покровское: '48664',
			Протасово: '48646',
			Прусынок: '48676',
			Путимец: '4862',
			Работьково: '48249',
			Репнино: '48640',
			Ретинка: '48664',
			Ретяжи: '48643',
			Речица: '48677',
			Ржавец: '48648',
			Ржаное: '48648',
			Робье: '48644',
			Ровнец: '48676',
			Рогатик: '48672',
			Росстани: '48677',
			Ртищево: '48676',
			Рыжково: '48665',
			Салтыки: '4862',
			Сахзаводской: '48677',
			Себякино: '48647',
			Селихово: '48662',
			Семеновка: '48644',
			Сеньково: '48675',
			Сергиевка: '48677',
			Середичи: '48640',
			Сетуха: '48648',
			Синковец: '48676',
			Скворцово: '48642',
			Скородное: '48676',
			Скорятино: '48676',
			Смирные: '48664',
			Совхозный: '48677',
			Соломино: '48249',
			Сосково: '48665',
			Сосновка: '48677',
			Спешнево: '48667',
			Среднее: '48676',
			Становое: '48648',
			Старогольское: '48678',
			Старополево: '48675',
			Степановка: '48645',
			Столбецкое: '48664',
			Столбище: '48249',
			Страховка: '48667',
			Стрелецкий: '4862',
			Струково: '48640',
			Студенка: '48642',
			Студенок: '48666',
			Ступишино: '4862',
			Судьбищи: '48678',
			Суры: '48278',
			Сурьянино: '48640',
			Тагино: '48675',
			Теличье: '48677',
			Тельчье: '48646',
			Теляжье: '48676',
			Теляково: '48647',
			Техникумовский: '48675',
			Тим: '48672',
			Титово: '48644',
			Топки: '48664',
			Тросна: '48666',
			Туровка: '48676',
			Узкое: '48662',
			Упорой: '48249',
			Урынок: '48672',
			Успенье: '48663',
			Ушаково: '48674',
			Фатнево: '48640',
			Федоровка: '48664',
			Федотово: '48643',
			Фошня: '48674',
			Хардикова: '4862',
			Хворостянка: '48673',
			Хитрово: '48679',
			Хомутово: '48678',
			Хорошилово: '48647',
			Хотетово: '48645',
			Хотынец: '48642',
			Хотьково: '48644',
			Черемошное: '48666',
			Черемощны: '48646',
			Черногрязка: '48640',
			Чувардино: '48249',
			Чулково: '48673',
			Шаблыкино: '48644',
			Шатилово: '48678',
			Шахово: '48643',
			Шашкино: '48646',
			Щербово: '48640',
			Юшино: '48647',
			Юшково: '48644',
			Яковка: '48674',
			Яковлево: '48645',
			Ярище: '48674'
		}
	},
	'Пензенская область': {
		regionCode: '841',
		cities: {
			'Базарная Кеньша': '84165',
			'Большая Елань': '8412',
			'Большая Ижмора': '84155',
			'Большая Кавендра': '84163',
			'Большая Лука': '84142',
			'Большая Сергеевка': '84169',
			'Большие Хутора': '84154',
			'Большое Кирдяшево': '84163',
			'Большое Пермиево': '84165',
			'Большой Вьяс': '84161',
			'Большой Колояр': '84163',
			'Большой Мичкас': '84154',
			'Большой Труев': '84157',
			'Большой Умыс': '84156',
			'Верхние Поляны': '84153',
			'Верхний Шкафт': '84158',
			'Верхняя Елюзань': '84158',
			'Волхон-Умет': '84147',
			'Волчий Враг': '84169',
			'Замуравские Выселки': '84154',
			'Знаменская Пестровка': '84144',
			'Зубовский Совхоз': '84151',
			'Илим Гора': '84164',
			'Казанская Арчада': '84156',
			'Казачья Пелетьма': '84161',
			'Калинина Совхоз': '84156',
			'Каменный Брод': '84144',
			'Кевдо-Вершина': '84153',
			'Кевдо-Мельситово': '84156',
			'Комсомолец Совхоз': '84148',
			'Красная Горка': '84146',
			'Красная Дубрава': '84155',
			'Кувак-Никольское': '84154',
			'Лермонтово ': '84153',
			'Лесной Вьяс': '84161',
			'Малая Ижмора': '84155',
			'Малая Сергиевка': '84169',
			'Малая Сердоба': '84162',
			'Малый Буртас': '84152',
			'Мача-Родники': '84141',
			'Мичкасские Выселки': '84154',
			'Мокрый Мичкас': '84152',
			'Мордовская Муромка': '84150',
			'Мордовский Ишим': '84158',
			'Нагорная Пелетьма': '84161',
			'Нижний Катмис': '84168',
			'Нижний Ломов': '84154',
			'Нижний Мывал': '84168',
			'Нижняя Липовка': '84168',
			'Николо-Барнуки': '84168',
			'Новая Пятина': '84154',
			'Новая Студеновка': '84167',
			'Новая Толковка': '84152',
			'Новые Забалки': '84158',
			'Новые Пичуры': '84163',
			'Новый Валовай': '84152',
			'Новый Мачим': '84159',
			'Новый Шуструй': '84154',
			'Павло-Куракино': '84158',
			'Покрово-Березовка': '84147',
			'Покровская Арчада': '84156',
			'Покровская Варежка': '84156',
			'Россия Совхоз': '84155',
			'Русская Норка': '84159',
			'Русская Пенделка': '84157',
			'Русский Ишим': '84158',
			'Русский Камешкир': '84145',
			'Русский Качим': '84168',
			'Русский Пимбур': '84151',
			'Русский Шелдаис': '84151',
			'Село Пачелма': '84152',
			'Серп и Молот': '8412',
			'Спасско-Александровка': '84147',
			'Средняя Елюзань': '84158',
			'Старая Андреевка': '84164',
			'Старая Каменка': '8412',
			'Старая Кутля': '84161',
			'Старая Потловка': '84146',
			'Старая Селя': '84165',
			'Старая Степановка': '84161',
			'Старая Толковка': '84152',
			'Старая Яксарка': '84159',
			'Старое Cлавкино': '84162',
			'Старое Демкино': '84159',
			'Старое Захаркино': '84159',
			'Старое Шаткино': '84145',
			'Старые Турдаки': '84158',
			'Старый Вершаут': '84148',
			'Старый Карлыган': '84148',
			'Старый Чирчим': '84145',
			'Степное Полеологово': '84140',
			'Татаро-Никольское': '84152',
			'Татарская Лака': '84142',
			'Усть-Атмис': '84156',
			'Усть-Каремша': '84154',
			'Усть-Уза': '84159',
			'село Абашево': '84151',
			'село Наровчат': '84163',
			'село Поим': '84153',
			Абашево: '84151',
			Алеево: '84164',
			Александровка: '84140',
			Алферьевка: '8412',
			Андреевка: '84156',
			Анненково: '84157',
			Анучино: '84156',
			Аргамаково: '84153',
			Аришка: '84165',
			Армиево: '84159',
			Архангельское: '84158',
			Аршиновка: '84154',
			Асеевская: '84158',
			Атмис: '84154',
			Ахматовка: '84165',
			Байка: '84167',
			Балкашино: '84153',
			Баранчеевка: '84151',
			Батрак: '84156',
			Башмаково: '84143',
			Бегуч: '84156',
			Беднодемьяновск: '84151',
			Бекетовка: '84144',
			Беково: '84141',
			Беликово: '84150',
			Белинский: '84153',
			Белогорка: '84150',
			Белокаменка: '84146',
			Белынь: '84152',
			Бессоновка: '84140',
			Бигеево: '84164',
			Бикмурзино: '84164',
			Блиновка: '84156',
			Блохино: '84140',
			Богородское: '84150',
			Богословка: '8412',
			Болотниково: '84161',
			Болтино: '84156',
			Бузовлево: '84148',
			Булычево: '84144',
			Вадинск: '84142',
			Вазерки: '84140',
			Варварино: '84169',
			Варваровка: '84156',
			Варыпаево: '84147',
			Вачелей: '84168',
			Верешим: '84148',
			Вертуновка: '84141',
			Верхозим: '84157',
			Виляйки: '84163',
			Вирга: '84154',
			Вичкелей: '84165',
			Вишневое: '84169',
			Владимирский: '84148',
			Владыкино: '84156',
			Волхонщино: '84147',
			Волчково: '84153',
			Воробьевка: '84159',
			Ворона: '84152',
			Воскресеновка: '8412',
			Выборное: '84142',
			Высокое: '84143',
			Выша: '84155',
			Вышелей: '84158',
			Вьюнки: '84163',
			Вяземки: '84155',
			Вязовка: '84168',
			Голицыно: '84154',
			Головинщино: '84156',
			Городище: '84158',
			Грабово: '84140',
			Григорьевка: '84169',
			Громок: '84143',
			Гуленовка: '84167',
			Даниловка: '84148',
			Дарьевка: '84161',
			Демино: '84164',
			Дерябкино: '84151',
			Джалилово: '84164',
			Дигилевка: '84158',
			Долгово: '84155',
			Дружаевка: '84162',
			Дуровка: '84169',
			Евлашево: '84157',
			Елизаветино: '84150',
			Елюзань: '84157',
			Ермоловка: '8412',
			Завиваловка: '84156',
			Загоскино: '8412',
			Заречный: '8412',
			Засурское: '84161',
			Затон: '84158',
			Зеленовка: '84167',
			Земетчино: '84155',
			Золотаревка: '8412',
			Зубрилово: '84169',
			Ива: '84154',
			Иванырс: '84161',
			Ильмино: '84165',
			Индерка: '84168',
			Исикеево: '84164',
			Исса: '84144',
			Кадомцево: '84154',
			Казаковка: '84157',
			Казарка: '84165',
			Казеевка: '84163',
			Калдуссы: '84153',
			Калиновка: '84169',
			Камаевка: '84148',
			Каменка: '84156',
			Канеевка: '84158',
			Карамалы: '84165',
			Каргалей: '84142',
			Каргалейка: '84159',
			Кардаво: '84158',
			Каржимант: '84159',
			Карновар: '84164',
			Карповка: '84167',
			Кера: '84154',
			Кижеватово: '84140',
			Кикино: '84156',
			Кирилловка: '84143',
			Кириллово: '84155',
			Кирово: '84167',
			Китунькино: '84148',
			Клейменовка: '84156',
			Князевка: '84147',
			Кобылкино: '84156',
			Колдаис: '84159',
			Колтовское: '84146',
			Колударово: '84155',
			Колышлей: '84146',
			Колышлейка: '84147',
			Комаровка: '84157',
			Кондоль: '84147',
			Константиновка: '8412',
			Коповка: '84142',
			Корсаевка: '84153',
			Котел: '84142',
			Кочелейка: '84156',
			Кочетовка: '84156',
			Кошелевка: '84151',
			Краснополье: '84147',
			Кривошеевка: '84154',
			Кромщино: '84147',
			Крутец: '84146',
			Крыловка: '84156',
			Крюково: '84153',
			Кряжимское: '84168',
			Куземкино: '84143',
			Кузнецк: '84157',
			Кукарки: '84153',
			Куликовка: '84169',
			Куракино: '84167',
			Кургановка: '84156',
			Кутеевка: '84153',
			Кучки: '8412',
			Кянда: '84143',
			Лапшово: '84156',
			Ленино: '8412',
			Леонидовка: '8412',
			Лермонтово: '84153',
			Лесное: '84155',
			Лесозавод: '84158',
			Лещиново: '84154',
			Ломовка: '84161',
			Лопатино: '84148',
			Лопатки: '84140',
			Лунино: '84161',
			Маис: '84165',
			Майское: '84162',
			Марат: '84143',
			Маркино: '84168',
			Матчерка: '84155',
			Махалино: '84157',
			Мача: '84169',
			Мачкасы: '84159',
			Мещерское: '84167',
			Миткирей: '84141',
			Митрофаново: '84143',
			Михайловка: '84161',
			Мичуринский: '8412',
			Можарка: '84158',
			Мокшан: '84150',
			Монастырское: '84151',
			Морсово: '84155',
			Мочалейка: '84156',
			Мошки: '84141',
			Надеждино: '8412',
			Наровчат: '84163',
			Наскафтым: '84159',
			Наумкино: '84159',
			Невежкино: '84153',
			Неверкино: '84164',
			Нечаевка: '84150',
			Никольск: '84165',
			Никольское: '84157',
			Никульевка: '84143',
			Новиковка: '84165',
			Новознаменский: '84143',
			Новотрехсвятск: '84144',
			Ночка: '84165',
			Обвал: '84169',
			Огаревка: '84148',
			Озерки: '84168',
			Октябрьское: '84164',
			Оленевка: '8412',
			Ольшанка: '84143',
			Орловка: '84163',
			Оторма: '84155',
			Отрадный: '84150',
			Павловка: '84165',
			Пазелки: '84140',
			Пановка: '84146',
			Паны: '84163',
			Пачелма: '84152',
			Пашково: '84155',
			Пенза: '8412',
			Пестровка: '84156',
			Пиксанкино: '84159',
			Пионер: '84157',
			Пичилейка: '84168',
			План: '84164',
			Плес: '84150',
			Плесковка: '84163',
			Плещеевка: '84146',
			Плодосовхоз: '84141',
			Пограничное: '84146',
			Поим: '84153',
			Понкратовка: '84150',
			Поперечное: '8412',
			Порзово: '84156',
			Порошино: '84152',
			Поселки: '84157',
			Потодеевка: '84163',
			Потьма: '84150',
			Пригородное: '84167',
			Проказна: '84140',
			Прянзерки: '84154',
			Пустынь: '84156',
			Пушанино: '84153',
			Пылково: '84148',
			Пыркино: '84140',
			Пятницкое: '84143',
			Пяша: '84141',
			Радищево: '84157',
			Раево: '84155',
			Рамзай: '84150',
			Рахмановка: '84142',
			Решетино: '84152',
			Родники: '84161',
			Ростовка: '84156',
			Рощино: '84167',
			Ртищево: '84142',
			Рянза: '84155',
			Салтыково: '84155',
			Саполга: '84162',
			Сахзавод: '84141',
			Свищевка: '84153',
			Секретарка: '84167',
			Сердобск: '84167',
			Серман: '84165',
			Синодское: '84159',
			Сканово: '84163',
			Скачки: '84150',
			Скворечное: '84156',
			Скрябино: '84146',
			Соболевка: '84156',
			Соколка: '84167',
			Соколовка: '84165',
			Соловцово: '84144',
			Соломинка: '84143',
			Сорокино: '84154',
			Соседка: '84143',
			Сосновка: '84140',
			Сосновоборск: '84168',
			Софьевка: '84143',
			Спасск: '84151',
			Стеклозавод: '84158',
			Степановка: '84140',
			Студенец: '84156',
			Сулак: '84153',
			Сулеймановка: '84164',
			Суляевка: '84148',
			Сумароково: '84150',
			Сумы: '84146',
			Сурск: '84158',
			Сытинка: '84161',
			Сюзюм: '84157',
			Сюзюмское: '84168',
			Сядемка: '84155',
			Тамала: '84169',
			Танеевка: '84161',
			Тархово: '84153',
			Телегино: '84146',
			Телешовка: '84163',
			Тешнярь: '84168',
			Тимирязево: '84143',
			Титово: '84152',
			Тихменево: '84157',
			Топлое: '84162',
			Топориха: '84153',
			Троицкое: '84156',
			Тюнярь: '84165',
			Уварово: '84144',
			Уранка: '84158',
			Урлейка: '84147',
			Усердино: '84155',
			Успенское: '84150',
			Устье: '84151',
			Ушинка: '84155',
			Хованщина: '84141',
			Хоненево: '84150',
			Хопер: '84146',
			Царевщино: '84150',
			Чаадаевка: '84158',
			Чемодановка: '84140',
			Черкасское: '84152',
			Чернозерье: '84150',
			Чернояр: '84155',
			Чернышово: '84153',
			Чертково: '84140',
			Чибирлей: '84157',
			Чубаровка: '84146',
			Чумаево: '84145',
			Чунаки: '84162',
			Шарово: '84153',
			Шейно: '84152',
			Шемышейка: '84159',
			Шереметьево: '84143',
			Шингал: '84162',
			Широкоис: '84150',
			Ширяево: '84153',
			Шугурово: '84168',
			Ягановка: '84142',
			Яковлевка: '84141'
		}
	},
	'Пермский край': {
		regionCode: '342',
		cities: {
			'Большая Ослянка': '34255',
			'Большая Соснова': '34257',
			'Большая Сосновая': '34257',
			'Большая Уса': '34262',
			'Большие Кусты': '34262',
			'Большое Савино': '342',
			'Большое Самылово': '34277',
			'Большой Ась': '34259',
			'Большой Букор': '34241',
			'Большой Гондыр': '34262',
			'Большой Каскасал': '34262',
			'Большой Талмаз': '34262',
			'Бор-Ленва': '34265',
			'Верх-Буй': '34262',
			'Верх-Кондас': '34244',
			'Верх-Потка': '34257',
			'Верх-Уса': '34262',
			'Верх-Шуртан': '34266',
			'Верх-Язьва': '34243',
			'Верхнее Калино': '34256',
			'Верхнее Мошево': '34253',
			'Верхнечусовские Городки': '34256',
			'Верхний Кунгур': '34258',
			'Верхний Сып': '34259',
			'Верхняя Давыдовка': '34291',
			'Верхняя Колва': '34240',
			'Верхняя Сава': '34262',
			'Всеволодо-Вильва': '34274',
			'Вторые Ключики': '34258',
			'Дубовая Гора': '34262',
			'Ильича Поселок': '34271',
			'Карьер Известняк': '34274',
			'Комариха Первая': '34276',
			'Краснояр Первый': '34292',
			'Красный Берег': '34253',
			'Красный Восход': '342',
			'Красный Яр': '34257',
			'Красный Ясыл': '34258',
			'Кын-Село': '34249',
			'Липовая Первая': '34249',
			'Малая Уса': '34296',
			'Малый Ашап': '34258',
			'Нижнее Галино': '34254',
			'Нижнее Красное': '34265',
			'Нижнее Мошево': '34253',
			'Нижние Муллы': '342',
			'Нижний Козьмяш': '34261',
			'Нижний Лух': '34265',
			'Нижний Лып': '34257',
			'Нижний Сып': '34259',
			'Нижний Тымбай': '34262',
			'Нижняя Барда': '34296',
			'Нижняя Истекаевка': '34275',
			'Нижняя Сава': '34262',
			'Нижняя Талица': '34278',
			'Новая Залесная': '34291',
			'Новая Каменка': '34276',
			'Новый Ашап': '34292',
			'Обманка Вторая': '34249',
			'Ореховая Гора': '34261',
			'Русские Чикаши': '34262',
			'Русский Сарс': '34266',
			'Северный Колчим': '34243',
			'Северный Коммунар': '34277',
			'Северный Коспашский': '34255',
			'Спасо-Барда': '34252',
			'Старый Бисер': '34269',
			'Старый Шагирт': '34262',
			'Теплая Гора': '34269',
			'Усть-Буб': '34277',
			'Усть-Гаревая': '34265',
			'Усть-Игум': '34274',
			'Усть-Качка': '342',
			'Усть-Кишерть': '34252',
			'Усть-Сурмог': '34253',
			'Усть-Сыны': '34273',
			'Усть-Турка': '34271',
			'Усть-Язьва': '34243',
			'Черный Яр': '34252',
			'Щучье Озеро': '34266',
			'Юго-Камский': '342',
			'поселок Суксун': '34275',
			'село Сива': '34277',
			Агарзя: '34261',
			Агафонково: '34275',
			Аитково: '34249',
			Акбаш: '34292',
			Александровск: '34274',
			Алтынное: '34266',
			Альняш: '34241',
			Ананьино: '34261',
			Андреевка: '34279',
			Антипина: '34243',
			Аряж: '34262',
			Асово: '34251',
			Аспа: '34259',
			Атняшка: '34261',
			Ашап: '34258',
			Бабка: '34268',
			Бажуки: '34271',
			Байболовка: '342',
			Барда: '34292',
			Бартым: '34266',
			Басим: '34253',
			Басино: '34266',
			Бедряж: '34261',
			Безгодово: '34250',
			Беляевка: '34279',
			Бердышево: '34257',
			Березники: '3424',
			Березовка: '34251',
			Бершеть: '342',
			Бикбарда: '34262',
			Бисер: '34269',
			Бичурино: '34292',
			Бияваш: '34266',
			Бобровка: '34256',
			Богомягково: '34291',
			Богородск: '34266',
			Бондюг: '34240',
			Бор: '34275',
			Бородулино: '34254',
			Брехово: '34275',
			Брод: '34240',
			Брюзли: '34292',
			Брюхово: '34296',
			Буб: '34277',
			Булдырья: '34240',
			Буренка: '34241',
			Бым: '34271',
			Бырма: '34271',
			Валай: '34240',
			Валежная: '34256',
			Ваньки: '34241',
			Ванюки: '342',
			Васильевское: '34276',
			Вассята: '34241',
			Вая: '34243',
			Верещагино: '34254',
			Ветляны: '34265',
			Вижай: '34240',
			Вильгорт: '34240',
			Вишерогорск: '34243',
			Вогулка: '34244',
			Вознесенское: '34254',
			Воскресенск: '34297',
			Воскресенское: '34259',
			Гайны: '34245',
			Гамицы: '34291',
			Гамово: '342',
			Гожан: '34262',
			Голубята: '34265',
			Горнозаводск: '34269',
			Городище: '34253',
			Горшки: '342',
			Горы: '34291',
			Гремяча: '34291',
			Гремячинск: '34250',
			Григорьевское: '34272',
			Грызаны: '34258',
			Губаха: '34248',
			Дворец: '34278',
			Деменево: '34261',
			Дивья: '34265',
			Дмитриевское: '34276',
			Добрянка: '34265',
			Дойная: '34262',
			Екатерининское: '34277',
			Елово: '34296',
			Елпачиха: '34292',
			Ельшата: '34268',
			Енапаево: '34266',
			Ерзовка: '34268',
			Ермия: '34261',
			Есаул: '34261',
			Етыш: '34261',
			Жилино: '34271',
			Жуланово: '34253',
			Журавлево: '34258',
			Заборье: '34251',
			Заимка: '34249',
			Зарубино: '34271',
			Засечный: '34241',
			Звездный: '342',
			Звёздный: '342',
			Земплягаш: '34262',
			Зернино: '34251',
			Зипуново: '34241',
			Змеевка: '34268',
			Зуята: '34271',
			Зюкайка: '34254',
			Ивака: '34274',
			Ивановское: '34276',
			Ильинский: '34276',
			Ишимово: '34266',
			Иштеряки: '34259',
			Казанка: '34279',
			Казанцево: '34261',
			Калинино: '34271',
			Калино: '34256',
			Камень: '34274',
			Камский: '34265',
			Канабеки: '34249',
			Карагай: '34297',
			Каргино: '34276',
			Карьево: '34258',
			Касиб: '34253',
			Керчевский: '34240',
			Кизел: '34255',
			Кизьва: '34277',
			Кинделино: '34271',
			Киприно: '34278',
			Кипчак: '34262',
			Кирга: '34262',
			Киселево: '34275',
			Кленовка: '34257',
			Ключи: '34275',
			Кляпово: '34251',
			Козьмодемьянск: '34297',
			Койва: '34269',
			Кольчуг: '34240',
			Комариха: '34276',
			Комарихинский: '34256',
			Комарово: '34291',
			Комары: '34254',
			Комсомольский: '34271',
			Кондратово: '342',
			Константиновка: '34292',
			Копально: '34256',
			Кормовище: '34249',
			Коса: '34298',
			Кочево: '34293',
			Кочешовка: '34259',
			Кояново: '342',
			Красновишерск: '34243',
			Красногорка: '34259',
			Краснокамск: '34273',
			Краснояр: '34262',
			Кривец: '34276',
			Кривчана: '34254',
			Крылово: '34291',
			Крюково: '34296',
			Кува: '34260',
			Кудымкар: '34260',
			Куеда: '34262',
			Кузнечиха: '34291',
			Кукеты: '34254',
			Кукуштан: '342',
			Кулики: '34278',
			Култаево: '342',
			Кумыш: '34249',
			Кунгур: '34271',
			Курашим: '342',
			Курган: '34240',
			Кутамыш: '34256',
			Кучино: '34256',
			Кыласово: '34271',
			Кын: '34249',
			Левино: '34257',
			Лемзер: '34244',
			Ленино: '34254',
			Ленск: '34271',
			Лесной: '34291',
			Леун: '34266',
			Липово: '34265',
			Лисья: '34257',
			Лобаново: '342',
			Ломовка: '34249',
			Ломь: '34259',
			Лысьва: '34249',
			Ляды: '342',
			Лямино: '34256',
			Мазунино: '34271',
			Майский: '34273',
			Марковский: '34241',
			Мартыновцы: '34276',
			Матвеево: '34249',
			Маховляне: '34249',
			Медведево: '34252',
			Медведка: '34269',
			Медянка: '34258',
			Мельничная: '34268',
			Менделеево: '34297',
			Меркуши: '34268',
			Мизево: '34259',
			Михино: '34258',
			Мичура: '34296',
			Мокино: '34272',
			Молебка: '34252',
			Морозово: '34278',
			Мостовая: '342',
			Моховое: '34271',
			Мулянка: '342',
			Мутиха: '34243',
			Мысы: '34273',
			Нагорнский: '34248',
			Насадка: '34271',
			Невидимка: '34249',
			Неволино: '34271',
			Нердва: '34297',
			Никулино: '34265',
			Нововильвенский: '34269',
			Нововознесенск: '34278',
			Новоильинский: '34272',
			Новоильинское: '342',
			Новорождественское: '34249',
			Ножовка: '34268',
			Ныроб: '34240',
			Нытва: '34272',
			Обвинск: '34297',
			Оверята: '34273',
			Октябрьский: '34266',
			Опачевка: '34258',
			Орда: '34258',
			Орел: '34244',
			Оса: '34291',
			Осиновик: '34296',
			Осинцево: '34252',
			Осокино: '34253',
			Острожка: '34279',
			Оханск: '34279',
			Очёр: '34278',
			Ошья: '34262',
			Ощепково: '34244',
			Павловка: '34261',
			Павлово: '34258',
			Павловский: '34278',
			Пакли: '34291',
			Паль: '34291',
			Пальники: '34265',
			Пантелеевка: '34262',
			Парма: '34248',
			Пашия: '34269',
			Пепеляева: '34276',
			Перебор: '34251',
			Перемское: '34265',
			Пермь: '342',
			Петрецово: '34240',
			Печмень: '34292',
			Пильва: '34240',
			Пихтовка: '34268',
			Платошино: '342',
			Плеханово: '34271',
			Плишкари: '34296',
			Плишкино: '34296',
			Подволошино: '34251',
			Поедуги: '34275',
			Покровка: '34251',
			Покча: '34240',
			Полазна: '34265',
			Половодово: '34253',
			Посад: '34252',
			Посер: '34276',
			Притыка: '34279',
			Промысла: '34269',
			Проносное: '34251',
			Путино: '34254',
			Пыскор: '34244',
			Пянтег: '34240',
			Рассоленки: '34249',
			Редькино: '34266',
			Рейд: '34291',
			Родники: '34253',
			Рождественск: '34297',
			Рождественское: '342',
			Романово: '34244',
			Рудничный: '34255',
			Рябинино: '34240',
			Рябки: '34261',
			Сабарка: '34275',
			Савино: '34297',
			Садки: '34276',
			Садоягодное: '34271',
			Сараны: '34269',
			Сараши: '34292',
			Сарс: '34266',
			Сатино: '34277',
			Сая: '34251',
			Села: '34256',
			Селянка: '34256',
			Семеново: '34278',
			Семсовхоз: '34271',
			Сенькино: '34265',
			Сепыч: '34254',
			Серга: '34271',
			Серьгино: '34277',
			Сива: '34277',
			Сим: '34253',
			Скальный: '34256',
			Скобелевка: '342',
			Скопкортная: '34274',
			Советная: '34275',
			Соколово: '34254',
			Соликамск: '34253',
			Сосново: '34241',
			Спешково: '34278',
			Сретенское: '34276',
			Стряпунята: '34273',
			Субботники: '34254',
			Суганка: '34296',
			Суда: '34259',
			Суксун: '34275',
			Сульмаш: '34261',
			Сухая: '34274',
			Сызганка: '34275',
			Сылва: '342',
			Сыра: '34275',
			Тауш: '34261',
			Телес: '34259',
			Теплая: '34271',
			Тетерино: '34253',
			Тис: '34275',
			Тишкова: '34291',
			Тойкино: '34257',
			Токари: '34278',
			Торговище: '34275',
			Тохтуева: '34253',
			Троельга: '34271',
			Троица: '342',
			Трун: '34261',
			Трушники: '34261',
			Тулумбасы: '34251',
			Турлавы: '34244',
			Тюй: '34261',
			Тюлькино: '34253',
			Тюндюк: '34292',
			Тюш: '34266',
			Углеуральский: '34248',
			Узяр: '34262',
			Уинское: '34259',
			Уймуж: '34292',
			Урада: '34262',
			Уразметьево: '34266',
			Уральский: '34272',
			Уральское: '34241',
			Уролка: '34253',
			Урталга: '34262',
			Усовский: '34253',
			Усолье: '3424',
			Успенка: '34256',
			Усьва: '34250',
			Утес: '34256',
			Федоровск: '34262',
			Ферма: '342',
			Филатово: '34276',
			Фоки: '34241',
			Фролово: '34297',
			Фролы: '342',
			Хохловка: '342',
			Цепел: '34243',
			Чайка: '34259',
			Чайковская: '34272',
			Чайковский: '34241',
			Частые: '34268',
			Челва: '34265',
			Чепец: '34240',
			Чердынь: '34240',
			Чермоз: '34276',
			Черная: '34273',
			Черновское: '34257',
			Черное: '34253',
			Чернушка: '34261',
			Чеченино: '34252',
			Чусовой: '34256',
			Чусовской: '34240',
			Шабарка: '34292',
			Шабуры: '34268',
			Шадейка: '34271',
			Шаква: '34249',
			Шахта: '34255',
			Шахтный: '34248',
			Шемейный: '34244',
			Шермейка: '34292',
			Шерья: '34272',
			Широковский: '34248',
			Шиши: '3424',
			Шлыки: '34268',
			Шляпники: '34258',
			Шулынды: '34277',
			Шульдиха: '34296',
			Шумихинский: '34250',
			Шумково: '34252',
			Шушпанка: '34256',
			Щекино: '34244',
			Юбилейный: '34250',
			Юг: '342',
			Юговское: '34271',
			Юрич: '34297',
			Юрла: '34294',
			Юсьва: '34246',
			Яйва: '34274',
			Янычи: '342'
		}
	},
	'Приморский край': {
		regionCode: '423',
		cities: {
			'Алексей-Никольское': '4234',
			'Барабаш-Левада': '42345',
			'Барано-Оренбургское': '42345',
			'Боец Кузнецов': '42363',
			'Большой Камень': '42335',
			'Булыга-Фадеево': '42372',
			'Верхний Перевал': '42357',
			'Верхняя Бреевка': '42372',
			'Веселый Яр': '42376',
			'Владимиро-Александровск': '42363',
			'Владимиро-Александровское': '42365',
			'Владимиро-Петровка': '42349',
			'Вольно-Надеждинское': '42334',
			'Горно-Таежное': '4234',
			'Горные Ключи': '42354',
			'Дальний Кут': '42359',
			'Дубовый Ключ': '4234',
			'Золотая Долина': '42363',
			'Камень-Рыболов': '42349',
			'Красный Кут': '42352',
			'Крутой Яр': '42359',
			'Малая Кема': '42374',
			'Малые Ключи': '42352',
			'Медвежий Кут': '42372',
			'Моряк-Рыболов': '42376',
			'Нижние Лужки': '42372',
			'Павло-Федоровка': '42354',
			'Попова им.': '423',
			'Рудная Пристань': '42373',
			'Синий Гай': '42351',
			'Спасск-Дальний': '42352',
			'Турий Рог': '42349',
			'Усть-Соболевка': '42374',
			'Южная Лифляндия': '42335',
			'Южно-Морской': '4236',
			Абрамовка: '42346',
			Авангард: '42363',
			Агзу: '42374',
			Александровка: '42352',
			Алтыновка: '42351',
			Амгу: '42374',
			Андреевка: '42331',
			Анисимовка: '42335',
			Анна: '4236',
			Анучино: '42362',
			Ариадное: '42356',
			Арсеньев: '42361',
			Артемовский: '42337',
			Артём: '42337',
			Астраханка: '42349',
			Барабаш: '42331',
			Безверхово: '42331',
			Бельцово: '42371',
			Беневское: '42377',
			Береговое: '423',
			Березовка: '42372',
			Благодатное: '42347',
			Боголюбовка: '42356',
			Богополь: '42375',
			Богуславец: '42359',
			Богуславка: '42345',
			Борисовка: '4234',
			Буссевка: '42352',
			Вадимовка: '42351',
			Валентин: '42377',
			Варфоломеевка: '42371',
			Васильевка: '42346',
			Васильковка: '42352',
			Вассиановка: '42351',
			Веденка: '42356',
			Виноградовка: '42362',
			Вишневка: '42352',
			Владивосток: '4232',
			Воздвиженка: '4234',
			Вознесенка: '42347',
			Волчанец: '42363',
			Восток: '42359',
			Вострецово: '42359',
			Врангель: '4236',
			Высокогорск: '42375',
			Гайворон: '42352',
			Галенки: '42344',
			Гвоздево: '42331',
			Глазовка: '42355',
			Глубинное: '42359',
			Гоголевка: '42359',
			Гончаровка: '42359',
			Горбатка: '42346',
			Горное: '42346',
			Горнореченский: '42375',
			Гражданка: '42362',
			Григорьевка: '42346',
			Грушевое: '42356',
			Дальзаводское: '42347',
			Дальнегорск: '42373',
			Дальнегорский: '42356',
			Дальнереченск: '42356',
			Даниловка: '42346',
			Дзержинское: '42344',
			Дмитриевка: '42351',
			Дунай: '42339',
			Единка: '42374',
			Екатериновка: '42363',
			Жариково: '42345',
			Заветное: '42372',
			Заводской: '42337',
			Залесье: '42363',
			Занадворовка: '42331',
			Заречное: '42344',
			Зарубино: '42331',
			Зеркальное: '42375',
			Зимники: '42356',
			Ивановка: '42346',
			Игнатьевка: '42357',
			Измайлиха: '42359',
			Изюбриный: '42372',
			Ильинка: '42349',
			Иннокентьевка: '42355',
			Кавалерово: '42375',
			Каменушка: '4234',
			Киевка: '42377',
			Кипарисово: '42334',
			Кировский: '42354',
			Кневичи: '42337',
			Козьмино: '4236',
			Кокшаровка: '42372',
			Кольцевое: '42356',
			Комаровка: '42354',
			Корсаковка: '4234',
			Корфовка: '4234',
			Краскино: '42331',
			Краснореченский: '42356',
			Кремово: '42346',
			Кронштадтка: '42352',
			Крыловка: '42354',
			Курское: '42355',
			Лазо: '42377',
			Ленино: '42372',
			Ленинское: '42347',
			Лесогорье: '42372',
			Лесозаводск: '42355',
			Ливадия: '4236',
			Липовцы: '42344',
			Луговой: '42347',
			Лукашевка: '42347',
			Лукьяновка: '42359',
			Лучегорск: '42357',
			Лучки: '42347',
			Любитовка: '42356',
			Ляличи: '42346',
			Максимовка: '42374',
			Малиново: '42356',
			Маргаритово: '42376',
			Марково: '42355',
			Марьяновка: '42354',
			Междуречье: '42356',
			Мельгуновка: '42349',
			Мельники: '42363',
			Мельничное: '42359',
			Меркушевка: '42351',
			Милоградово: '42376',
			Михайловка: '42346',
			Молодежное: '42359',
			Монастырище: '42351',
			Мономахово: '42356',
			Муравейка: '42362',
			Мысовой: '42335',
			Нагорное: '42357',
			Находка: '4236',
			Некруглово: '42346',
			Нестеровка: '42345',
			Новицкое: '42363',
			Новобельмановка: '42347',
			Нововладимировка: '42352',
			Новогеоргиевка: '42344',
			Новогордеевка: '42362',
			Новодевица: '42347',
			Новожатково: '42346',
			Новокачалинск: '42349',
			Новокрещенка: '42359',
			Новомихайловка: '42372',
			Новонежино: '42335',
			Новоникольск: '4234',
			Новопокровка: '42359',
			Новорусановка: '42352',
			Новоселище: '42349',
			Новосельское: '42352',
			Новостройка: '42357',
			Новосысоевка: '42371',
			Новочугуевка: '42372',
			Новошахтинский: '42346',
			Озерное: '42371',
			Октябрьское: '42349',
			Оленевод: '42334',
			Олений: '42337',
			Ольга: '42376',
			Орехово: '42356',
			Осиновка: '42346',
			Павловка: '42346',
			Пантелеймоновка: '42355',
			Партизанск: '42363',
			Первомайское: '42346',
			Перевозная: '42331',
			Пермское: '42376',
			Песчаное: '42346',
			Пластун: '42374',
			Пограничный: '42345',
			Подъяпольское: '42335',
			Пожарское: '42357',
			Покровка: '42344',
			Полтавка: '42344',
			Поляны: '42356',
			Поповка: '42347',
			Поречье: '42344',
			Посьет: '42331',
			Преображение: '42377',
			Прилуки: '42347',
			Приморский: '42331',
			Приозерное: '42347',
			Прохладное: '42334',
			Пуциловка: '4234',
			Пшеницыно: '42372',
			Раздольное: '42334',
			Ракитное: '42356',
			Раковка: '4234',
			Ракушка: '42376',
			Рейнеке: '423',
			Реттиховка: '42351',
			Рисовое: '42362',
			Родниковый: '42354',
			Рождественка: '42356',
			Рощино: '42359',
			Рудный: '42375',
			Ружино: '42355',
			Руновка: '42354',
			Сальское: '42356',
			Самарга: '42374',
			Самарка: '42372',
			Саратовка: '42372',
			Светлая: '42374',
			Светлогорье: '42357',
			Свиягино: '42352',
			Серафимовка: '42376',
			Сержантово: '42373',
			Сибирцево: '42351',
			Сиваковка: '42347',
			Синельниково: '42344',
			Славянка: '42331',
			Смоляниново: '42335',
			Снегуровка: '42351',
			Соколовка: '42372',
			Соловьевка: '42356',
			Спасское: '42352',
			Средняя: '4236',
			Сретенка: '42356',
			Струговка: '42344',
			Сунгач: '42352',
			Суражевка: '42337',
			Тавричанка: '42334',
			Таежное: '42359',
			Тайга: '42373',
			Тамга: '42355',
			Тарасовка: '42346',
			Тереховка: '42334',
			Терней: '42374',
			Тигровый: '42363',
			Тимирязевский: '4234',
			Тимофеевка: '42376',
			Тихменево: '42355',
			Тихоречное: '42362',
			Троицкое: '42349',
			Трудовое: '423',
			Уборка: '42372',
			Увальное: '42354',
			Углекаменск: '42363',
			Угловое: '42337',
			Усачевка: '42347',
			Уссурийск: '4234',
			Устиновка: '42375',
			Утесное: '4234',
			Фабричный: '42375',
			Фадеевка: '42344',
			Федосьевка: '42357',
			Филаретовка: '42355',
			Филипповка: '42331',
			Фокино: '42339',
			Фридман: '42363',
			Халкидон: '42351',
			Хасан: '42331',
			Хвалынка: '42352',
			Хороль: '42347',
			Хрустальный: '42375',
			Центральное: '42335',
			Черниговка: '42351',
			Черноручье: '42377',
			Чернышевка: '42362',
			Чернятино: '42344',
			Чкаловское: '42352',
			Чугуевка: '42372',
			Ширяевка: '42346',
			Шкотово: '42335',
			Штыково: '42335',
			Шумный: '42372',
			Яблоновка: '42371',
			Яковлевка: '42371',
			Ярославский: '42347',
			Ясное: '42372'
		}
	},
	'Псковская область': {
		regionCode: '811',
		cities: {
			'Арбузова Щелинка': '81134',
			'Бельское Устье': '81134',
			'Большая Листовка': '8112',
			'Большевичка Совхоз': '8112',
			'Большие Пети': '81134',
			'Большое Загорье': '8112',
			'Большое Захонье': '81133',
			'Большое Приезжево': '81152',
			'Большое Юрково': '81135',
			'Букрово-Второе': '81153',
			'Васьково-Иглино': '81143',
			'Великие Луки': '81153',
			'Верхний Мост': '81134',
			'Высокий Мост': '81148',
			'Гора-Каменка': '8112',
			'Горбунова Гора': '81145',
			'Грызавино-Второе': '81152',
			'Дубрава-Первая': '81153',
			'Иваново Болото': '81148',
			'Красное Сосонье': '81134',
			'Красные Горки': '81136',
			'Красный Луч': '81141',
			'Красный Поселок': '81151',
			'Лютые Болоты': '81134',
			'Малая Губа': '81152',
			'Михайлов Погост': '81139',
			'Неелово-Второе': '8112',
			'Никандрова пустынь': '81134',
			'Новая Уситва': '81145',
			'Новый Изборск': '81148',
			'Осипово Село': '81139',
			'Павлово-Блины': '81148',
			'Подборовье-Первое': '8112',
			'Пушкинские Горы': '81146',
			'Ротный Двор': '81132',
			'Синяя Никола': '81137',
			'Сосновый Бор': '81140',
			'Струги Красные': '81132',
			'Усть-Долыссы': '81151',
			'деревня Березнюк': '81148',
			Адамово: '81150',
			Адворицы: '8112',
			Адорье: '81143',
			Аксеново: '81141',
			Александрово: '81140',
			Алексеевка: '81152',
			Алоль: '81142',
			Алтун: '81143',
			Алушково: '81142',
			Андромер: '81133',
			Аполье: '81141',
			Аристово: '81138',
			Астратово: '81152',
			Ашево: '81141',
			Бардово: '81141',
			Барканы: '81151',
			Барсуки: '81139',
			Барута: '81143',
			Батино: '81134',
			Бежаницы: '81141',
			Белая: '81135',
			Белорусский: '81147',
			Береза: '81134',
			Березка: '81140',
			Березки: '81141',
			Бешкино: '81131',
			Бичи: '81147',
			Блажи: '81146',
			Блясино: '81137',
			Бобьяково: '81145',
			Болгатово: '81138',
			Бологое: '81144',
			Бор: '81144',
			Бори: '81133',
			Борисенки: '81140',
			Борки: '81153',
			Боровик: '8112',
			Боровичи: '81134',
			Бороусы: '81147',
			Боталово: '81149',
			Бояриново: '81140',
			Брагино: '81144',
			Булынино: '81153',
			Быково: '81149',
			Быковщина: '81131',
			Быстрецово: '8112',
			Варыгино: '81138',
			Васильево: '81145',
			Васильевское: '81146',
			Васильки: '81142',
			Ваулино: '8112',
			Ваши: '81153',
			Вейно: '81131',
			Велье: '81146',
			Верхолино: '8112',
			Веска: '81143',
			Вехно: '81143',
			Вишлево: '81143',
			Влазово: '81152',
			Волочек: '81146',
			Волышово: '81134',
			Воронцово: '81152',
			Встеселово: '81149',
			Выбор: '81143',
			Выскодь: '81135',
			Выставка: '8112',
			Вышгородок: '81147',
			Вышегород: '81136',
			Вяз: '81144',
			Вязье: '81136',
			Гаврово: '81135',
			Гаево: '81142',
			Галузино: '81140',
			Гверздонь: '8112',
			Гвоздно: '81131',
			Гдов: '81131',
			Глазуново: '81150',
			Глембочино: '81140',
			Глубокое: '81138',
			Гоголево: '81139',
			Гора: '81141',
			Гораи: '81152',
			Горелик: '81146',
			Городовик: '81136',
			Горожане: '81144',
			Готовино: '81134',
			Грибули: '81145',
			Гривино: '81143',
			Гривы: '81152',
			Груздово: '81149',
			Губаны: '81153',
			Гультяи: '81142',
			Дачное: '81135',
			Дворцы: '81141',
			Дедино: '81140',
			Дедовичи: '81136',
			Деменино: '81134',
			Демидово: '81153',
			Демя: '81144',
			Демянка: '81134',
			Детково: '81133',
			Дно: '81135',
			Добручи: '81131',
			Добрывичи: '81141',
			Долговица: '81149',
			Должицы: '81133',
			Долосцы: '81140',
			Доминиково: '81151',
			Дрени: '81147',
			Дубишно: '81136',
			Дубки: '81152',
			Дубровно: '81134',
			Дуброво: '8112',
			Дубровы: '81143',
			Дуловка: '81152',
			Духново: '81138',
			Евашково: '81136',
			Елизарово: '8112',
			Елины: '81152',
			Еменец: '81151',
			Емилово: '81147',
			Ершово: '8112',
			Есенники: '81138',
			Жадрицы: '81143',
			Жарки: '81139',
			Жгилево: '81134',
			Жигари: '81153',
			Жижица: '81149',
			Забелье: '81142',
			Заболотье: '81153',
			Заборовье: '81152',
			Заборье: '81143',
			Заверняйка: '81138',
			Загорье: '81139',
			Загоска: '81134',
			Задворье: '8112',
			Зайцево: '8112',
			Заклинье: '81135',
			Залесье: '81148',
			Заплюсье: '81133',
			Зародище: '81140',
			Захаркино: '81152',
			Захино: '81146',
			Заянье: '81133',
			Звоны: '81138',
			Зили: '81147',
			Змеино: '81151',
			Золотково: '81153',
			Золотово: '81137',
			Иваново: '81151',
			Иваньково: '81139',
			Игомель: '81133',
			Идрица: '81140',
			Изборск: '81148',
			Ильинское: '81137',
			Исаково: '81140',
			Искра: '81135',
			Исса: '81146',
			Карамышево: '8112',
			Карпово: '81152',
			Картенки: '81140',
			Карцево: '81153',
			Каськово: '81149',
			Кахново: '81152',
			Качаново: '81145',
			Кирово: '8112',
			Киршино: '81148',
			Кисели: '81152',
			Кицково: '81140',
			Колюбаки: '81153',
			Комша: '81153',
			Копылок: '81142',
			Коростели: '81144',
			Костелево: '81132',
			Которск: '81133',
			Котоши: '81133',
			Кошелевицы: '81133',
			Кошелево: '81151',
			Красино: '81145',
			Красногородск: '81137',
			Красное: '81142',
			Крестилово: '81139',
			Криуха: '81142',
			Крупп: '81148',
			Крылово: '81146',
			Крюки: '81152',
			Крюково: '81145',
			Крякуша: '8112',
			Кудеверь: '81141',
			Кунино: '81138',
			Кунья: '81149',
			Купуй: '81153',
			Курея: '81133',
			Лаврово: '81152',
			Лавры: '81148',
			Ладино: '81143',
			Лаптево: '81138',
			Лехово: '81151',
			Лещихино: '81145',
			Линово: '81147',
			Липеты: '8112',
			Липец: '81153',
			Липшани: '81139',
			Лобок: '81151',
			Ловец: '81151',
			Лог: '81144',
			Логовино: '81134',
			Локно: '81145',
			Локня: '81139',
			Лопатово: '8112',
			Лосево: '81153',
			Лосицы: '81133',
			Лудони: '81132',
			Лукино: '81137',
			Лукомо: '81135',
			Любимец: '81131',
			Ляды: '81133',
			Лямцево: '81133',
			Маево: '81144',
			Мазиха: '81131',
			Макарово: '81143',
			Макушино: '81138',
			Малы: '81148',
			Марьино: '81132',
			Матюшкино: '81138',
			Махновка: '81134',
			Махново: '81141',
			Мельницы: '8112',
			Мелётово: '81112',
			Миритиницы: '81139',
			Мирный: '81147',
			Могилево: '81134',
			Молоди: '81132',
			Моложане: '81132',
			Монино: '81144',
			Морино: '81135',
			Мостище: '81140',
			Мочево: '8112',
			Мякишево: '81138',
			Навережье: '81136',
			Насва: '81144',
			Наумово: '81149',
			Невель: '81151',
			Нежадово: '81133',
			Новгородка: '81146',
			Новоржев: '81143',
			Новосокольники: '81144',
			Новохованск: '81151',
			Норкино: '81138',
			Носово: '81147',
			Окни: '81144',
			Опочка: '81138',
			Опухлики: '81151',
			Орел: '81131',
			Ореховно: '81133',
			Остров: '81152',
			Островки: '81144',
			Островцы: '81131',
			Осыно: '81140',
			Отрадное: '81144',
			Павы: '81134',
			Палицы: '81132',
			Палкино: '81145',
			Пальцево: '81152',
			Паниковичи: '81148',
			Панкратово: '81135',
			Партизанская: '81131',
			Первомайская: '81131',
			Переслегино: '81153',
			Першино: '81153',
			Пески: '81134',
			Петровское: '81138',
			Пехово: '81144',
			Печки: '81148',
			Печоры: '81148',
			Писковичи: '8112',
			Плаксино: '81153',
			Платоново: '81153',
			Плесна: '81131',
			Плессы: '81141',
			Плотовец: '81141',
			Плюсса: '81133',
			Погорелка: '81152',
			Подберезье: '81139',
			Поддубье: '81142',
			Подлесье: '81148',
			Подмогилье: '81152',
			Подоклинье: '81134',
			Подсевы: '81134',
			Пожеревицы: '81136',
			Покаты: '81152',
			Покровское: '81137',
			Полибино: '81153',
			Полна: '81131',
			Полоное: '81134',
			Поляне: '81146',
			Поречье: '81153',
			Порхов: '81134',
			Посадниково: '81143',
			Похвальщина: '8112',
			Приозерная: '81152',
			Прихабы: '81149',
			Псков: '8112',
			Пустошка: '81142',
			Пустыньки: '81146',
			Пухново: '81149',
			Пыталово: '81147',
			Пятчино: '81132',
			Раменье: '81144',
			Ремда: '81131',
			Ровное: '81132',
			Родина: '8112',
			Родовое: '81145',
			Ротово: '81148',
			Руново: '81144',
			Русаново: '81153',
			Рыкайлово: '81139',
			Рысцево: '81134',
			Самолва: '81131',
			Самолуково: '81139',
			Самохвалово: '81145',
			Свиново: '81147',
			Себеж: '81140',
			Северики: '81150',
			Сергейцево: '81142',
			Середка: '8112',
			Серово: '81138',
			Сиверст: '81153',
			Сиковицы: '81132',
			Скорды: '81147',
			Скрипово: '81134',
			Скугры: '81135',
			Славковичи: '81134',
			Слепнево: '81149',
			Слопыгино: '81145',
			Соино: '81142',
			Соловьи: '8112',
			Сопрыгино: '81141',
			Сорокино: '81136',
			Сосонка: '81136',
			Спасовщина: '8112',
			Спиры: '81152',
			Спицино: '81131',
			Стайки: '81151',
			Станки: '81136',
			Станьково: '81144',
			Старосокольники: '81144',
			Стеревнево: '81150',
			Стехново: '81143',
			Стехны: '81147',
			Столбово: '81151',
			Стремутка: '8112',
			Сумско: '81134',
			Сутоки: '81140',
			Суханово: '81153',
			Сыроквашино: '81151',
			Творожково: '81132',
			Теребище: '8112',
			Терептино: '81134',
			Тимофеевка: '81151',
			Тинеи: '81134',
			Томсино: '81140',
			Торошино: '8112',
			Торчани: '81152',
			Треньки: '81137',
			Трехалево: '81151',
			Троица: '81153',
			Трубицино: '81145',
			Трутнево: '81131',
			Туготино: '81134',
			Тупицино: '81131',
			Туричино: '81151',
			Тямша: '8112',
			Ублиска: '81141',
			Удвяты: '81150',
			Узкое: '81150',
			Узьмино: '81132',
			Урицкое: '81153',
			Усвяты: '81150',
			Усмынь: '81149',
			Усово: '81151',
			Успенское: '81153',
			Устье: '81131',
			Ушаково: '81151',
			Ушицы: '81149',
			Фенево: '81151',
			Фишнево: '81141',
			Хилово: '81134',
			Хредино: '81132',
			Хряпьево: '81141',
			Цапелька: '81132',
			Цевло: '81141',
			Церковище: '81150',
			Черепягино: '81152',
			Череха: '8112',
			Чернево: '81131',
			Чернецово: '81151',
			Чернея: '81140',
			Черпесса: '81153',
			Черская: '81145',
			Чертовидово: '81152',
			Чихачево: '81141',
			Шалахово: '81142',
			Шевелево: '8112',
			Шелково: '81153',
			Шершни: '81150',
			Шики: '81152',
			Шилово: '81141',
			Шмойлово: '81134',
			Шумилкино: '81148',
			Щербино: '81151',
			Щукино: '81142',
			Эпимахово: '81140',
			Юхово: '81139',
			Якушово: '81137',
			Ямище: '81149',
			Ямм: '81131',
			Ясно: '81134',
			Ясски: '81136'
		}
	},
	'Республика Адыгея': {
		regionCode: '877',
		cities: {
			'Казенно-Кужорский': '87770',
			'Красная Улька': '8772',
			'Нижний Айрюм': '87779',
			'Новый Сад': '87771',
			'Свободный Труд': '87773',
			'Северо-Восточные Сады': '8772',
			'Семено-Макаренский': '87773',
			'Смольчев Малиновский': '87779',
			'Тульский РУПС': '8772',
			'Усть-Сахрай': '8772',
			Абадзехская: '8772',
			Адамий: '87778',
			Адыгейск: '87772',
			Ассоколай: '87772',
			Афипсип: '87771',
			Безводная: '8772',
			Белое: '87778',
			Бжедугхабль: '87778',
			Блечепсин: '87770',
			Большесидоровское: '87778',
			Верхненазаровское: '87778',
			Веселый: '8772',
			Вольное: '87770',
			Вочепший: '87772',
			Габукай: '87772',
			Гавердовский: '8772',
			Гатлукай: '87772',
			Гиагинская: '87779',
			Гончарка: '87779',
			Городской: '87772',
			Грозный: '8772',
			Гузерипль: '8772',
			Дагестанская: '8772',
			Даховская: '8772',
			Джамбичи: '87778',
			Джерокай: '87773',
			Джиджихабль: '87772',
			Дондуковская: '87779',
			Дружба: '87770',
			Дукмасов: '87773',
			Егерухай: '87770',
			Еленовское: '87778',
			Зарево: '87773',
			Игнатьевский: '87770',
			Кабехабль: '87773',
			Каменномостский: '8772',
			Келермесская: '87779',
			Козет: '87771',
			Кошехабль: '87770',
			Красногвардейское: '87778',
			Красное: '87772',
			Краснооктябрьский: '8772',
			Кужорская: '8772',
			Кунчукохабль: '87772',
			Курджипская: '8772',
			Майкоп: '8772',
			Майский: '87770',
			Мамацев: '87773',
			Михайлов: '87773',
			Натырбово: '87770',
			Нешукай: '87772',
			Новопрохладное: '8772',
			Новосвободная: '8772',
			Новосевастопольское: '87778',
			Отрадный: '87771',
			Панахес: '87771',
			Первомайский: '8772',
			Плодопитомник: '87770',
			Победа: '8772',
			Подгорный: '8772',
			Понежукай: '87772',
			Преображенское: '87778',
			Прикубанский: '87771',
			Прогресс: '87779',
			Псейтук: '87771',
			Псекупс: '87772',
			Пчегатлукай: '87772',
			Пшизов: '87773',
			Родниковый: '8772',
			Садовое: '87778',
			Саратовский: '87778',
			Свободный: '87778',
			Севастопольская: '8772',
			Северный: '8772',
			Сергиевское: '87779',
			Совхозный: '8772',
			Старобжегокай: '87771',
			Табачный: '8772',
			Тамбовский: '87779',
			Тахтамукай: '87771',
			Тихонов: '87773',
			Тлюстенхабль: '87772',
			Трехречный: '8772',
			Тульский: '87777',
			Уляп: '87778',
			Хакуринохабль: '87773',
			Хамышки: '8772',
			Ханская: '8772',
			Хапачев: '87773',
			Хатажукай: '87773',
			Хатукай: '87778',
			Хачемзий: '87770',
			Ходзь: '87770',
			Цветочный: '8772',
			Чернышов: '87773',
			Шевченко: '87772',
			Шелковников: '87770',
			Шенджий: '87771',
			Штурбино: '87778',
			Шунтук: '8772',
			Энем: '87771',
			Яблоновский: '87771'
		}
	},
	'Республика Алтай': {
		regionCode: '388',
		cities: {
			'Белый Ануй': '38847',
			'Беш-Озек': '38849',
			'Верх-Апшуяхта': '38849',
			'Верх-Бийск': '38843',
			'Верх-Карагуж': '38844',
			'Веселая Сейка': '38840',
			'Горно-Алтайск': '38822',
			'Горный Алтай': '38822',
			'Кош-Агач': '38842',
			'Курмач-Байгол': '38843',
			'Кызыл-Озёк': '38844',
			'Малая-Черга': '38849',
			'Мендур-Саккон': '38847',
			'Мухор-Тархата': '38842',
			'Озеро-Куреево': '38843',
			'Турочак РУПС': '38843',
			'Улус-Черга': '38849',
			'Урлу-Аспак': '38844',
			'Усть-Кан': '38847',
			'Усть-Кокса': '38848',
			'Усть-Кумир': '38847',
			'Усть-Муны': '38844',
			'Усть-Мута': '38847',
			'Усть-Пыжа': '38843',
			'Усть-Сема': '38841',
			'Чаган-Узун': '38842',
			'Черный Ануй': '38847',
			'село Анос': '38841',
			'село Верх-Уймон': '38848',
			'село Усть-Кокса': '38848',
			'село Чемал': '38841',
			Абай: '38848',
			Актал: '38842',
			Акташ: '38846',
			Александровка: '38844',
			Алтайский: '38537',
			Алтайское: '38537',
			Амур: '38848',
			Анос: '38841',
			Балыктуюль: '38846',
			Балыкча: '38846',
			Барагаш: '38849',
			Бельтир: '38842',
			Беляши: '38842',
			Бешпельтир: '38841',
			Бийка: '38843',
			Бирюля: '38844',
			Горбуново: '38848',
			Дмитриевка: '38843',
			Дьектиек: '38849',
			Ело: '38845',
			Иогач: '38843',
			Кайтанак: '38848',
			Камлак: '38849',
			Карагай: '38848',
			Каракокша: '38840',
			Карасук: '38844',
			Каргон: '38847',
			Катанда: '38848',
			Каяшкан: '38843',
			Кебезень: '38843',
			Киска: '38840',
			Козуль: '38847',
			Кокоря: '38842',
			Кулада: '38845',
			Купчегень: '38845',
			Курай: '38842',
			Курунда: '38848',
			Куюс: '38841',
			Кырлык: '38847',
			Майма: '38844',
			Майский: '38843',
			Манжерок: '38844',
			Мульта: '38848',
			Мыюта: '38849',
			Огневка: '38848',
			Онгудай: '38845',
			Ороктой: '38841',
			Ортолык: '38842',
			Паспаул: '38840',
			Саратан: '38846',
			Сибирский: '38532',
			Соузга: '38844',
			Сростки: '3854',
			Сугаш: '38848',
			Суранаш: '38843',
			Талда: '38848',
			Талон: '38843',
			Ташанта: '38842',
			Тебелер: '38842',
			Теньга: '38845',
			Тондошка: '38843',
			Туньжа: '38840',
			Турочак: '38843',
			Туэкта: '38845',
			Тюдрала: '38847',
			Тюнгур: '38848',
			Удаловка: '38843',
			Узнезя: '38841',
			Уймень: '38840',
			Улаган: '38846',
			Ускуч: '38840',
			Хабаровка: '38845',
			Чемал: '38841',
			Чендек: '38848',
			Чепош: '38841',
			Черга: '38849',
			Чибиля: '38846',
			Чибит: '38846',
			Чоя: '38840',
			Чуйка: '38843',
			Шашикман: '38845',
			Шебалино: '38849',
			Ынырга: '38840',
			Эдиган: '38841',
			Элекмонар: '38841',
			Ябоган: '38847',
			Яконур: '38847',
			Яровое: '38568'
		}
	},
	'Республика Башкортостан': {
		regionCode: '347',
		cities: {
			'1-е Мая Совхоз': '34782',
			'8 марта им.': '34741',
			'Аксеново Сельхозтехникум': '34754',
			'Бадряш Разъезд': '34760',
			'Байки-Юнусово': '34744',
			'Бала-Четырман': '34746',
			'Батырша-Кубово': '34773',
			'Башкирская Ургинка': '34785',
			'Бедеева Поляна': '34766',
			'Белое Озеро': '34740',
			'Бик-Кармалы': '34768',
			'Большая Ока': '34770',
			'Большие Каркалы': '34788',
			'Большие Шады': '34749',
			'Большой Келтей': '34779',
			'Большой Куганак': '3473',
			'Буль-Кайпаново': '34778',
			'Ваныш-Алпаутово': '34756',
			'Верхние Бишинды': '34782',
			'Верхние Каргалы': '34747',
			'Верхние Киги': '34748',
			'Верхние Татышлы': '34778',
			'Верхние Услы': '3473',
			'Верхний Авзян': '34792',
			'Верхний Альштан': '34746',
			'Верхний Аташ': '34796',
			'Верхний Изяк': '34766',
			'Верхний Муйнак': '34785',
			'Верхний Сардык': '34782',
			'Верхний Тыхтем': '34779',
			'Второе Иткулово': '34751',
			'Глуховской Санаторий': '34786',
			'Давлеканово ': '34768',
			'Демский Совхоз': '34743',
			'Дружба Совхоз': '34775',
			'Дуван-Мечетлино': '34770',
			'Енебей-Урсаево': '34788',
			'Зая-Ишметово': '34757',
			'Зилаирский Совхоз': '34751',
			'Зилим-Караново': '34740',
			'Ивано-Казанка': '34795',
			'Ивано-Кувалат': '34752',
			'Ильино-Поляна': '34766',
			'Имай-Кармалы': '34768',
			'Камчалы-Тамак': '34768',
			'Канлы-Туркеево': '34773',
			'Кара-Якупово': '34797',
			'Карамалы-Губеево': '34782',
			'Каран-Кункас': '34788',
			'Карача-Елга': '34780',
			'Карламан Совхоз': '34765',
			'Кенгер-Менеуз': '34743',
			'Кипчак-Аскарово': '34754',
			'Кир-Тлявли': '34769',
			'Киргиз-Мияки': '34788',
			'Кистенли-Богданово': '34743',
			'Кистенли-Ивановка': '34743',
			'Кожай-Cеменовка': '34788',
			'Кожай-Икские Вершины': '34743',
			'Конезавод 119': '347',
			'Копей-Кубово': '34773',
			'Кош-Елга': '34743',
			'Красная Башкирия Совхоз': '34772',
			'Красная Горка': '34776',
			'Красноусольский Санаторий': '34740',
			'Красный Восход': '34795',
			'Красный Зилим': '34774',
			'Красный Ключ': '34776',
			'Красный Урюш': '34744',
			'Красный Яр': '347',
			'Кривле-Илюшкино': '34757',
			'Кусимовский Рудник': '34772',
			'Кшлау-Елга': '34771',
			'Лемез-Тамак': '34770',
			'Лесозавод 2': '34751',
			'Максим Горький': '34774',
			'Максима Горького Совхоз': '34786',
			'Малая Александровка': '34786',
			'Малое Ибраево': '34745',
			'Малый Седяк': '34743',
			'Митро-Аюповское': '34796',
			'Миякинский Совхоз': '34788',
			'Нижнее Аврюзово': '34754',
			'Нижнее Бобино': '34770',
			'Нижнеулу-Елга': '34741',
			'Нижние Бишинды': '34782',
			'Нижние Киги': '34748',
			'Нижние Лемезы': '34795',
			'Нижние Ташлы': '34769',
			'Нижний Авзян': '34792',
			'Нижний Искуш': '34750',
			'Нижний Качмаш': '34779',
			'Нижний Ташбукан': '34740',
			'Николо-Березовка': '34759',
			'Новая Бура': '34759',
			'Новая Васильевка': '34743',
			'Новая Отрадовка': '3473',
			'Новое Барятино': '3473',
			'Новые Ишлы': '34788',
			'Новые Карамалы': '34788',
			'Новые Карьявды': '34796',
			'Новые Киешки': '34765',
			'Новые Сулли': '34741',
			'Новые Татышлы': '34778',
			'Новые Чебенки': '34785',
			'Новый Артаул': '34760',
			'Новый Бердяш': '34744',
			'Новый Зирган': '34758',
			'Новый Каинлык': '34759',
			'Новый Краснояр': '3473',
			'Новый Субай': '34776',
			'Первое Иткулово': '34751',
			'Русский Юрмаш': '347',
			'Семено-Макарово': '34741',
			'Семено-Петровское': '34789',
			'Семеновский Рудник': '34751',
			'Смычка Совхоз': '34797',
			'Средние Карамалы': '34741',
			'Старая Мушта': '34759',
			'Старая Отрада': '34757',
			'Старое Азмеево': '34742',
			'Старые Багазы': '34744',
			'Старые Богады': '34773',
			'Старые Казанчи': '34771',
			'Старые Камышлы': '34780',
			'Старые Маты': '34742',
			'Старые Санны': '34747',
			'Старые Туймазы': '34782',
			'Старые Тукмаклы': '34780',
			'Старые Турбаслы': '34766',
			'Старые Шарашли': '34742',
			'Старый Акбуляк': '34744',
			'Старый Калкаш': '34739',
			'Старый Курдым': '34778',
			'Старый Кызыл-Яр': '34778',
			'Старый Мутабаш': '34771',
			'Старый Сибай': '34751',
			'Стерлитамакский Совхоз': '3473',
			'Суук-Чишма': '34765',
			'Тамьян-Таймас': '34788',
			'Татар-Улканово': '34782',
			'Татыр-Узяк': '34758',
			'Троицкий 2-ой': '34747',
			'Туркменево 1-е': '34751',
			'Тятер-Арасланово': '34739',
			'Удельно-Дуваней': '34766',
			'Улу-Елга': '34792',
			'Улу-Теляк': '34795',
			'Урман-Бишкадак': '34794',
			'Усень-Ивановское': '34786',
			'Усман-Ташлы': '34741',
			'Усть-Табаска': '34798',
			'Учалы-Село': '34791',
			'Чехова им.Санаторий': '34754',
			'Чуваш-Кубово': '34795',
			'Чувашский Нагадак': '34745',
			'Шингак-Куль': '34797',
			'Шульган-Таш': '34755',
			'Южный Совхоз': '34743',
			'Юматово Санаторий': '347',
			'Якты-Куль': '34772',
			'Ялгыз-Нарат': '34778',
			'Янгантау Санаторий': '34763',
			'Янгильский Совхоз': '34772',
			'деревня Туркменево': '34751',
			'с. Усень-Ивановское': '34786',
			Абдрашитово: '34754',
			Абдулкаримово: '34751',
			Абдуллино: '34770',
			Абдулмамбетово: '34772',
			Абдулово: '34757',
			Абзаево: '34748',
			Абзаково: '34792',
			Аблаево: '34796',
			Авдон: '347',
			Агидель: '34731',
			Адзитарово: '34765',
			Азикеево: '34770',
			Азово: '34774',
			Азяково: '34756',
			Аитово: '34743',
			Айбуляк: '34760',
			Айгулево: '3473',
			Айдарали: '34739',
			Айсуак: '34757',
			Акбарисово: '34769',
			Аккузево: '34762',
			Акмурун: '34751',
			Аксаитово: '34778',
			Аксаково: '34786',
			Аксеново: '34754',
			Акъяр: '34758',
			Алайгирово: '34765',
			Алатана: '3473',
			Алаторка: '34795',
			Алга: '34768',
			Алегазово: '34770',
			Александровка: '34764',
			Алексеевка: '347',
			Алкино: '34797',
			Алькино: '34763',
			Амангильдино: '34772',
			Амзибаш: '34779',
			Амзя: '34783',
			Амирово: '34773',
			Ангасяк: '34787',
			Андреевка: '34762',
			Анновка: '34752',
			Антинган: '34758',
			Антоновка: '34764',
			Аптраково: '34764',
			Арасланово: '34764',
			Арбашево: '34771',
			Арибашево: '34778',
			Ариево: '34798',
			Аркаулово: '34763',
			Арлан: '34759',
			Арняшево: '34756',
			Арово: '34797',
			Арсеново: '34785',
			Арсланово: '34748',
			Артакуль: '34744',
			Архангельское: '34774',
			Асавдыбаш: '34760',
			Аскарово: '34772',
			Аскино: '34771',
			Ассы: '34792',
			Асяново: '34787',
			Атарша: '34750',
			Атиково: '34755',
			Атлегач: '34760',
			Атняш: '34776',
			Ауструн: '34795',
			Ахлыстино: '34766',
			Ахманово: '34742',
			Ахмерово: '34751',
			Ахметово: '34780',
			Ахуново: '34791',
			Ашаево: '34750',
			Бадряшево: '34778',
			Баженово: '34784',
			Базанчатово: '34771',
			Базгиево: '34769',
			Базитамак: '34762',
			Базлык: '34743',
			Баимово: '34772',
			Баишево: '34785',
			Байгильдино: '34776',
			Байгузино: '34760',
			Байгускарово: '34758',
			Байки: '34744',
			Байкибашево: '34744',
			Баймак: '34751',
			Баймурзино: '34749',
			Байназарово: '34755',
			Байталлы: '34780',
			Байтурово: '34749',
			Бакаево: '34780',
			Бакалдинское: '34774',
			Бакалы: '34742',
			Бакеево: '34739',
			Балтика: '34795',
			Балыклы: '34746',
			Балыклыкуль: '34745',
			Балышлы: '34747',
			Бартым: '34744',
			Бахмут: '34757',
			Бахтыбаево: '34784',
			Баязитово: '34788',
			Бекетово: '34765',
			Бекешево: '34751',
			Белебей: '34786',
			Белорецк: '34792',
			Белянка: '34750',
			Бердяш: '34744',
			Бижбуляк: '34743',
			Биккулово: '34743',
			Билялово: '34751',
			Бирск: '34784',
			Бишкаин: '34745',
			Бишкураево: '34782',
			Благовар: '34747',
			Благовещенка: '34774',
			Благовещенск: '34766',
			Богданово: '34788',
			Богородское: '34764',
			Большеабишево: '34758',
			Большебадраково: '34756',
			Большекачаково: '34779',
			Большеустьикинское: '34770',
			Большешукшаново: '34756',
			Буганак: '34792',
			Бугульчан: '34757',
			Бузат: '34739',
			Буздяк: '34773',
			Бузовьязы: '34765',
			Бузюрово: '34742',
			Булгаково: '347',
			Бураево: '34756',
			Бурангулово: '34772',
			Бурибай: '34758',
			Буриказганово: '3473',
			Бурлы: '34740',
			Буруновка: '34740',
			Валентиновка: '34774',
			Васильевка: '3473',
			Веровка: '34786',
			Верхнеарметово: '34794',
			Верхнеаршинский: '34792',
			Верхнегалеево: '34752',
			Верхнеиткулово: '34794',
			Верхнекудашево: '34778',
			Верхнелачентау: '34784',
			Верхнеманчарово: '34762',
			Верхнетавлыкаево: '34751',
			Верхнетроицкое: '34782',
			Верхнеяркеево: '34762',
			Верхотор: '34794',
			Воздвиженка: '34754',
			Вознесенка: '34791',
			Волостновка: '34789',
			Воскресенское: '34789',
			Вострецово: '34756',
			Вояда: '34760',
			Вперед: '34768',
			Гадельгареево: '34755',
			Гайниямак: '34754',
			Галиакберово: '34755',
			Галиахметово: '34758',
			Гафури: '34773',
			Гафурово: '34782',
			Гончаровка: '34746',
			Гусево: '34772',
			Давлеканово: '34768',
			Давлетово: '34772',
			Дарьино: '34764',
			Дедово: '34746',
			Денискино: '34746',
			Дергачевка: '3473',
			Дияшево: '34742',
			Дмитриевка: '34747',
			Дубровка: '34744',
			Дуван: '34798',
			Дурасово: '34797',
			Дуслык: '34782',
			Душанбеково: '34748',
			Дюртюли: '34787',
			Евбуляк: '34771',
			Еланлино: '34748',
			Елбулактамак: '34743',
			Елимбетово: '34739',
			Емашево: '34784',
			Емаши: '34750',
			Енгалышево: '34797',
			Ермекеево: '34741',
			Ермолаево: '34757',
			Ермолкино: '34743',
			Ефремкино: '34765',
			Жуково: '347',
			Заимка: '34798',
			Зайцево: '34760',
			Зигаза: '34792',
			Зилаир: '34752',
			Зильдярово: '34788',
			Зилязекулово: '34753',
			Зирган: '34764',
			Зириклы: '34769',
			Знаменка: '34786',
			Золотоношка: '3473',
			Зуяково: '34792',
			Ибрагимово: '34797',
			Ибраево: '34748',
			Иванаево: '34787',
			Ивангород: '34768',
			Ивановка: '34758',
			Иглино: '34795',
			Игнатовка: '34797',
			Идельбаково: '34785',
			Ижбердино: '34789',
			Иликово: '34780',
			Илькино: '34786',
			Ильтеряково: '34765',
			Ильчигулово: '34788',
			Ильчимбетово: '34782',
			Ильчино: '34791',
			Имангулово: '34791',
			Имянликулово: '34796',
			Инзелга: '34740',
			Инзер: '34792',
			Ира: '34761',
			Иргизлы: '34755',
			Ирныкши: '34774',
			Ирсаево: '34749',
			Исаметово: '34762',
			Исанбаево: '34762',
			Исимово: '34789',
			Искушта: '34792',
			Исламбахты: '34741',
			Исмагилово: '34745',
			Исмаилово: '34787',
			Исмакаево: '34792',
			Истяк: '34760',
			Исянгулово: '34785',
			Итеево: '34762',
			Иткинеево: '34760',
			Ишберда: '34751',
			Ишеево: '34794',
			Ишей: '34751',
			Ишемгулово: '34785',
			Ишимбаево: '34763',
			Ишимбай: '34794',
			Ишкарово: '34762',
			Ишкулово: '34772',
			Ишлы: '34745',
			Ишля: '34792',
			Ишмурзино: '34751',
			Ишмухаметово: '34751',
			Иштуганово: '34764',
			Иштыбаево: '34749',
			Кабаково: '34765',
			Кабакуш: '34739',
			Кага: '34792',
			Кагарманово: '34792',
			Кадыргулово: '34768',
			Кадырово: '34798',
			Казангулово: '34768',
			Казанка: '34754',
			Казанчи: '34742',
			Казарма: '34780',
			Казаяк: '34795',
			Каинлыково: '34756',
			Кайраково: '34749',
			Какрыбашево: '34782',
			Калегино: '34779',
			Калинники: '34784',
			Калмаш: '34798',
			Калмашбашево: '34796',
			Калмашево: '34797',
			Калтаево: '34780',
			Калтасы: '34779',
			Калтыманово: '34795',
			Кальтовка: '34795',
			Кальтяево: '34778',
			Кальшали: '34782',
			Камеево: '34749',
			Каменка: '34743',
			Камышлинка: '34765',
			Камышлытамак: '34742',
			Кананикольское: '34752',
			Кандаковка: '34748',
			Кандры: '34782',
			Кандрыкуль: '34782',
			Карабашево: '34762',
			Карагаево: '34740',
			Карагуш: '34739',
			Каразириково: '34796',
			Караидель: '34744',
			Караидельский: '34744',
			Каралачик: '34746',
			Каран: '34773',
			Карантрав: '34750',
			Каратово: '34782',
			Караяр: '34744',
			Кариево: '34759',
			Карламан: '34765',
			Карлыханово: '34750',
			Карманово: '34760',
			Кармасан: '347',
			Кармаскалы: '34765',
			Кармышево: '34754',
			Карташевка: '34774',
			Карякино: '34759',
			Качеганово: '34788',
			Кашкалаши: '34747',
			Кашкалево: '34756',
			Кашкарово: '34752',
			Кашкино: '34771',
			Кигазы: '34771',
			Кидрячево: '34768',
			Киебак: '34779',
			Килеево: '34742',
			Килимово: '34773',
			Кинзикеево: '34794',
			Кирдасово: '34772',
			Кирзя: '34744',
			Кирябинское: '34791',
			Ключи: '34771',
			Кляшево: '34797',
			Коварды: '34740',
			Комсомольск: '34791',
			Комсомольский: '34744',
			Константиноградовка: '3473',
			Корнеевка: '34764',
			Красноусольский: '34740',
			Краснохолмский: '34779',
			Крымский: '34754',
			Кубагушево: '34791',
			Кубиязы: '34771',
			Кувыкино: '34780',
			Куганакбаш: '34739',
			Кугарчи: '34789',
			Кудеевский: '34795',
			Куезбашево: '34745',
			Кужанак: '34785',
			Кузбаево: '34756',
			Кузеево: '34773',
			Кузьминовка: '34746',
			Кузяново: '34794',
			Куккуяново: '34787',
			Кулгунино: '34794',
			Кульчурово: '34751',
			Кумертау: '34761',
			Кунакбаево: '34791',
			Кунакулово: '34743',
			Кундашлы: '34753',
			Кундряк: '34739',
			Кунтугушево: '34753',
			Курамино: '34791',
			Кургатово: '34770',
			Кургашла: '34740',
			Курманаево: '34749',
			Куртлыкуль: '34744',
			Кусеево: '34751',
			Кусекеево: '34784',
			Кутерем: '34779',
			Кутушево: '34764',
			Кучаш: '34779',
			Кушманаково: '34756',
			Кушнаренково: '34780',
			Куштеряково: '34742',
			Куянтаево: '34751',
			Куяштыр: '34771',
			Кшанны: '34745',
			Лагерево: '34763',
			Лаклы: '34763',
			Левали: '34750',
			Лемазы: '34798',
			Ленинское: '34749',
			Леуза: '34748',
			Ломовка: '34792',
			Магинск: '34744',
			Майгаза: '34750',
			Майский: '34795',
			Макан: '34758',
			Макарово: '34794',
			Максимовка: '3473',
			Максимово: '34760',
			Максютово: '34789',
			Малиновка: '34786',
			Малоказаккулово: '34791',
			Малонакаряково: '34749',
			Малояз: '34777',
			Мансурово: '34791',
			Манышта: '34792',
			Матраево: '34752',
			Маядык: '34787',
			Маядыково: '34784',
			Межгорье: '34792',
			Мелеуз: '34764',
			Мендим: '34740',
			Мендяново: '34754',
			Менеузтамак: '34788',
			Мерясово: '34751',
			Месели: '34745',
			Месягутово: '34798',
			Метевбаш: '34786',
			Метели: '34798',
			Мечетлино: '34763',
			Мещегарово: '34763',
			Микяшево: '34768',
			Миловка: '347',
			Миндяк: '34791',
			Минзитарово: '34795',
			Миништы: '34787',
			Мирный: '34747',
			Митрофановка: '34798',
			Михайловка: '34772',
			Мичуринск: '34769',
			Мишкино: '34749',
			Миякибашево: '34788',
			Миякинская: '34788',
			Миякитамак: '34718',
			Молоканово: '34757',
			Москово: '34787',
			Мраково: '34789',
			Музяк: '34759',
			Мулдакаево: '34791',
			Мурапталово: '34757',
			Мурсалимкино: '34763',
			Мустафино: '34739',
			Нагайбаково: '34742',
			Нагретдиново: '34744',
			Надеждино: '34779',
			Насибаш: '34763',
			Наумкино: '34745',
			Наумовка: '3473',
			Наурузово: '34791',
			Нефтекамск: '34783',
			Нигаматово: '34751',
			Нигматулино: '34754',
			Нижегородка: '347',
			Нижнеаташево: '34787',
			Нижнебалтачево: '34778',
			Нижнебиккузино: '34789',
			Нижнезавитово: '34769',
			Нижнекарышево: '34753',
			Нижнеманчарово: '34787',
			Нижнесикиязово: '34753',
			Нижнетроицкий: '34782',
			Нижнеутяшево: '34750',
			Нижнечерекулево: '34762',
			Никифарово: '34754',
			Николаевка: '34792',
			Никольское: '34773',
			Нимислярово: '34776',
			Новая: '34797',
			Новоакбулатово: '34749',
			Новоаптиково: '34794',
			Новобайрамгулово: '34791',
			Новобалтачево: '34796',
			Новобелокатай: '34750',
			Новобикметово: '34756',
			Новобиктово: '34787',
			Новобирючево: '34776',
			Новокабаново: '34759',
			Новокангышево: '34787',
			Новокатаево: '34742',
			Новокизганово: '34756',
			Новокильбахтино: '34779',
			Новокулево: '34776',
			Новокурмашево: '34780',
			Новокутово: '34796',
			Новомедведево: '34762',
			Новомещерово: '34770',
			Новомихайловский: '34743',
			Новомуллакаево: '34744',
			Новомунасипово: '34755',
			Новомусино: '34757',
			Новомуслюмово: '34770',
			Новонагаево: '34759',
			Новонадеждино: '34766',
			Новопетровское: '34789',
			Новоселка: '34746',
			Новосепяшево: '34754',
			Новософиевка: '34746',
			Новотазларово: '34756',
			Новотроицкое: '34797',
			Новоурсаево: '34742',
			Новофедоровское: '3473',
			Новохвалынский: '34789',
			Новошахово: '34741',
			Новоянмурзино: '34753',
			Новоянсаитово: '34744',
			Новояушево: '34770',
			Ногуши: '34750',
			Нордовка: '34764',
			Норкино: '34753',
			Нугуш: '34764',
			Нуреево: '34769',
			Нурлино: '347',
			Озерки: '34744',
			Озерный: '34791',
			Озеро: '34798',
			Октябрьск: '34770',
			Октябрьский: '34767',
			Орловка: '34760',
			Осиновка: '34784',
			Осиповка: '34766',
			Охлебинино: '34795',
			Павловка: '34740',
			Пахарь: '34786',
			Первомайск: '34776',
			Первомайский: '3473',
			Первушино: '34780',
			Петровка: '34752',
			Петровское: '34794',
			Печенкино: '34784',
			Писарево: '34769',
			Питяково: '34784',
			Побоище: '34789',
			Подгорное: '34789',
			Подлесное: '3473',
			Подлубово: '34765',
			Подольск: '34758',
			Подымалово: '347',
			Покровка: '34746',
			Поляковка: '34791',
			Преображеновка: '3473',
			Прибельский: '34765',
			Приуралье: '34774',
			Пришиб: '34747',
			Приютово: '34786',
			Пятилетка: '34795',
			Раево: '34768',
			Раевский: '34754',
			Рапатово: '34796',
			Рассвет: '34768',
			Редькино: '34759',
			Резяпово: '34796',
			Рефанды: '34749',
			Родина: '34740',
			Рощинский: '3473',
			Рсаево: '34762',
			Рухтино: '34798',
			Рысаево: '34791',
			Рязановка: '3473',
			Рятамак: '34741',
			Сабаево: '34773',
			Сабирово: '34752',
			Савалеево: '34765',
			Савкияз: '34778',
			Саитбаба: '34740',
			Сайраново: '34797',
			Сакты: '34769',
			Салават: '34763',
			Салихово: '34794',
			Сальевка: '34798',
			Самарское: '34758',
			Сандугач: '34760',
			Сараево: '34754',
			Сарва: '34776',
			Саргая: '34755',
			Сарышево: '34764',
			Сатыево: '34788',
			Саузбаш: '34759',
			Сафарово: '34797',
			Сахаево: '34765',
			Свобода: '34757',
			Севадыбашево: '34773',
			Седяш: '34744',
			Сейтяково: '34753',
			Семенкино: '34745',
			Семилетка: '34787',
			Серафимовский: '34782',
			Сергеевка: '34773',
			Серегулово: '34785',
			Серменево: '34792',
			Сибай: '34775',
			Сикияз: '34798',
			Силантьево: '34784',
			Симский: '34765',
			Сихонкино: '34765',
			Скворчиха: '34794',
			Слак: '34754',
			Слакбаш: '34786',
			Смаково: '34764',
			Сосновка: '34792',
			Спартак: '34741',
			Староабсалямово: '34745',
			Староакбулатово: '34778',
			Старобабичево: '34765',
			Старобазаново: '34784',
			Старобалтачево: '34753',
			Старобаскаково: '34780',
			Старобаширово: '34796',
			Старобелокатай: '34750',
			Старобикметово: '34756',
			Старобурново: '34784',
			Старогумерово: '34780',
			Старогусево: '34742',
			Стародюмеево: '34762',
			Староиликово: '34766',
			Старокалмашево: '34796',
			Старокостеево: '34742',
			Старокудашево: '34760',
			Старокуктово: '34762',
			Старокулево: '34776',
			Старокурмашево: '34780',
			Старокуручево: '34742',
			Старокучербаево: '34747',
			Старомусино: '34797',
			Старонадеждино: '34766',
			Старосеменкино: '34786',
			Старосубхангулово: '34755',
			Старотавларово: '34773',
			Старотимкино: '34753',
			Старотумбагушево: '34769',
			Старотураево: '34741',
			Старочукурово: '34778',
			Староянбаево: '34753',
			Староянзигитово: '34759',
			Староянтузово: '34787',
			Старояшево: '34779',
			Степановка: '34745',
			Степной: '34758',
			Стерлибашево: '34739',
			Стерлитамак: '3473',
			Субханкулово: '34782',
			Суккулово: '34741',
			Султанаево: '34780',
			Султанбеково: '34771',
			Султанмуратово: '34745',
			Суслово: '34784',
			Сухоречка: '34743',
			Сюльтино: '34762',
			Табынское: '34740',
			Тавричанка: '34754',
			Тавтиманово: '34795',
			Тазеево: '34762',
			Тазларово: '34785',
			Таймасово: '34757',
			Таймеево: '34763',
			Таймурзино: '34787',
			Тайняшево: '34796',
			Тактагулово: '34742',
			Талалаевка: '3473',
			Талачево: '3473',
			Талог: '34771',
			Тан: '34747',
			Тангатарово: '34756',
			Таптыково: '347',
			Тарказы: '34741',
			Тастуба: '34798',
			Татарбаево: '34749',
			Татлыбаево: '34751',
			Ташбулатово: '34772',
			Ташкиново: '34783',
			Ташла: '34740',
			Ташлы: '34754',
			Ташлыкуль: '34745',
			Таштамак: '34745',
			Таштимерово: '34772',
			Теляшево: '34770',
			Темясово: '34751',
			Теняево: '34746',
			Тепляки: '34756',
			Терменево: '34763',
			Тимашевка: '34794',
			Тирлянский: '34792',
			Тляумбетово: '34789',
			Толбазы: '34745',
			Толпарово: '34740',
			Тошкурово: '34753',
			Троицкое: '34764',
			Трунтаишево: '34754',
			Тряпино: '34745',
			Тубинский: '34751',
			Тугаево: '34740',
			Тугузлы: '34748',
			Тузлукуш: '34786',
			Тузлукушево: '34796',
			Туймазы: '34782',
			Тукаево: '34782',
			Тукан: '34792',
			Туктагулово: '34782',
			Тульгузбаш: '34771',
			Турбаслы: '34795',
			Турмаево: '34739',
			Турналы: '34763',
			Турсагали: '34745',
			Турумбет: '34745',
			Турушла: '34766',
			Тучубаево: '34753',
			Тынбаево: '34749',
			Тюльди: '34779',
			Тюменяк: '34782',
			Тюрюшево: '34773',
			Тюрюшля: '3473',
			Угузево: '34784',
			Удрякбаш: '34747',
			Узбяково: '34740',
			Узунларово: '34774',
			Узя: '34764',
			Узян: '34792',
			Узянбаш: '34792',
			Улькунды: '34798',
			Уразбахты: '34797',
			Уразово: '34791',
			Урал: '34765',
			Уральск: '34791',
			Ургала: '34750',
			Ургуш: '34744',
			Урзайбаш: '34773',
			Урман: '34795',
			Урманаево: '34742',
			Урмантау: '34763',
			Урметово: '34762',
			Урмиязы: '34771',
			Урняк: '34796',
			Уртакуль: '34773',
			Уршак: '34788',
			Уршакбашкарамалы: '34788',
			Уръяды: '34749',
			Утягулово: '34785',
			Утяково: '34740',
			Уфа: '347',
			Уфимский: '34758',
			Учалы: '34791',
			Учпили: '34787',
			Уязыбашево: '34788',
			Уязытамак: '34782',
			Федоровка: '34746',
			Халикеево: '34739',
			Халилово: '34772',
			Хамитово: '34772',
			Хлебодаровка: '34764',
			Целинное: '34758',
			Целинный: '34772',
			Чалмалы: '34769',
			Чандар: '34776',
			Чебенли: '34754',
			Чебыково: '34749',
			Чекмагуш: '34796',
			Челканово: '34756',
			Черкассы: '347',
			Чернолесовский: '347',
			Чесноковка: '347',
			Чишма: '34787',
			Чишмы: '34797',
			Чубукаран: '34786',
			Чувалкипово: '34797',
			Чукадыбашево: '34782',
			Чумара: '34779',
			Чураево: '34749',
			Чуракаево: '34754',
			Чуюнчи: '34768',
			Шабагиш: '34757',
			Шавьяды: '34753',
			Шаймуратово: '34765',
			Шакарла: '34750',
			Шакировка: '34774',
			Шаран: '34769',
			Шарипово: '34780',
			Шарлык: '34747',
			Шаровка: '34786',
			Шатмантамак: '34788',
			Шафраново: '34754',
			Шигаево: '34792',
			Штанды: '34753',
			Шудек: '34760',
			Шулганово: '34778',
			Шушнур: '34759',
			Юзимяново: '34740',
			Юкаликулево: '34748',
			Юлдыбаево: '34752',
			Юлук: '34751',
			Юлуково: '34740',
			Юмагужино: '34752',
			Юмагузино: '34789',
			Юмадыбаш: '34769',
			Юмашево: '34796',
			Юность: '34769',
			Юнусово: '34770',
			Юрматы: '34746',
			Юсупово: '34787',
			Ябалаково: '34762',
			Явгильдино: '34744',
			Языково: '34747',
			Якупово: '34773',
			Якшимбетово: '34757',
			Ялангачево: '34753',
			Ялчино: '34789',
			Ямады: '34760',
			Ямакай: '34747',
			Ямансаз: '34752',
			Янагушево: '34749',
			Янаул: '34760',
			Янгискаин: '34740',
			Янгурча: '34739',
			Янтышево: '34758',
			Яныбаево: '34785',
			Ярославка: '34798',
			Яшерганово: '34739'
		}
	},
	'Республика Бурятия': {
		regionCode: '301',
		cities: {
			'Ара-Киреть': '30133',
			'Большая Речка': '30138',
			'Большое Колесово': '30138',
			'Большой Куналей': '30146',
			'Большой Луг': '30142',
			'Верхние Тальцы': '30148',
			'Верхний Жирин': '30146',
			'Верхний Мангиртуй': '30133',
			'Верхняя Заимка': '30130',
			'Верхняя Иволга ': '30140',
			'Выдрино 1': '30138',
			'Гусиное Озеро': '30145',
			'Додо-Ичётуй': '30134',
			'Дэдэ-Cутэй': '30145',
			'Дэдэ-Ичетуй': '30134',
			'Ехэ-Цакир': '30137',
			'Золотой Ключ': '30144',
			'Зун-Мурино': '30147',
			'Зун-Хурай': '30148',
			'Зурган-Дэбэ': '30145',
			'Киран Курорт': '30142',
			'Красный Яр': '30138',
			'Кудара-Сомон': '30142',
			'Малая Курба': '30148',
			'Малый Куналей': '30133',
			'Нижние Тальцы': '30136',
			'Нижний Бургултай': '30134',
			'Нижний Жирим': '30146',
			'Нижний Саянтуй': '30146',
			'Нижний Торей': '30134',
			'Новая Брянь': '30136',
			'Новый Заган': '30143',
			'Новый Уоян': '30130',
			'Нур-Тухум': '30145',
			'Окино-Ключи': '30133',
			'Саган-Нур': '30143',
			'Сахарный Завод': '30133',
			'Сосново-Озёрское': '30135',
			'Средний Убукум': '30145',
			'Средний Харлун': '30133',
			'Старая Брянь': '30136',
			'Старая Курба': '30136',
			'Старое Татаурово': '30144',
			'Степной Дворец': '30138',
			'Татарский Ключ': '30136',
			'Улан-Удэ': '3012',
			'Усть-Баргузин': '30131',
			'Усть-Брянка': '30136',
			'Усть-Джилинда': '30153',
			'Усть-Дунгуй': '30142',
			'Усть-Киран': '30142',
			'Усть-Кяхта': '30142',
			'Усть-Муя': '30132',
			'Усть-Орот': '30141',
			'Усть-Урма': '30145',
			'Усть-Эгита': '30135',
			'Хара-Шибирь': '30136',
			'Хойто-Гол': '30147',
			'Хошун-Узур': '30143',
			'Хурай-Хобок': '30147',
			'Шара-Азарга': '30137',
			Адамово: '30131',
			Алан: '30148',
			Алла: '30149',
			Алтачей: '30133',
			Алцак: '30134',
			Ангоя: '30130',
			Аргада: '30149',
			Ардасан: '30145',
			Арзгун: '30149',
			Армак: '30134',
			Аршан: '30147',
			Ацагат: '30136',
			Бабушкин: '30138',
			Багдарин: '30153',
			Байкальское: '30130',
			Бар: '30143',
			Барагхан: '30149',
			Бараты: '30145',
			Баргузин: '30131',
			Баянгол: '30137',
			Белоозерск: '30134',
			Билютай: '30133',
			Бичура: '30133',
			Боргой: '30134',
			Боций: '30134',
			Брянск: '30138',
			Буй: '30133',
			Варваринский: '30153',
			Ганзурино: '3012',
			Гашей: '30143',
			Георгиевское: '30148',
			Горхон: '30136',
			Горячинск: '30144',
			Гремячинск: '30144',
			Гунда: '30135',
			Гурульба: '3012',
			Гусиноозёрск: '30145',
			Гусиха: '30131',
			Гэгэтуй: '30134',
			Давша: '30130',
			Далахай: '30147',
			Десятниково: '30146',
			Джида: '30134',
			Дутулур: '30137',
			Дырестуй: '30134',
			Елань: '30133',
			Енхор: '30134',
			Жаргаланта: '30145',
			Желтура: '30134',
			Жемчуг: '30147',
			Забайкальский: '3012',
			Загустай: '30141',
			Заиграево: '30136',
			Закаменск: '30137',
			Заречный: '3012',
			Зырянск: '30144',
			Иволгинск: '30140',
			Ильинка: '30144',
			Илька: '30136',
			Ина: '30131',
			Инзагатуй: '30134',
			Иракинда: '30132',
			Исинга: '30135',
			Итанца: '30144',
			Кабанск: '30138',
			Каленово: '3012',
			Калиновка: '30143',
			Каменск: '30138',
			Карафтит: '30153',
			Кижинга: '30141',
			Кика: '30144',
			Кичера: '30130',
			Клюевка: '30138',
			Комсомольское: '30135',
			Котокель: '30144',
			Кудара: '30138',
			Куйтун: '30146',
			Кумора: '30130',
			Курумкан: '30149',
			Кусоты: '30143',
			Кырен: '30147',
			Кяхта: '30142',
			Майла: '30148',
			Майский: '30149',
			Максимиха: '30131',
			Маловский: '30153',
			Михайловка: '30137',
			Могойто: '30149',
			Могсохон: '30141',
			Можайка: '30135',
			Монгой: '30153',
			Монды: '30147',
			Мостовка: '30144',
			Мурочи: '30142',
			Мухоршибирь: '30143',
			Мыла: '30137',
			Нарын: '30148',
			Наушки: '30142',
			Нестерово: '30144',
			Нижнеангарск: '30130',
			Николаевский: '30146',
			Никольск: '30143',
			Ниловка: '30147',
			Новоильинск: '30136',
			Новокижингинск: '30141',
			Новоселенгинск: '30145',
			Новосретинка: '30133',
			Оер: '30134',
			Озерный: '30135',
			Оймур: '30138',
			Октябрьский: '30142',
			Онохой: '30136',
			Орлик: '30140',
			Оронгой: '3012',
			Оёр: '30134',
			Первомаевка: '30136',
			Петропавловка: '30134',
			Поворот: '30145',
			Подлопатки: '30143',
			Поперечное: '30135',
			Поселье: '30133',
			Посольское: '30138',
			Романовка: '30153',
			Россошино: '30153',
			Санага: '30137',
			Санномыск: '30148',
			Сахули: '30149',
			Саяны: '30140',
			Северный: '30153',
			Северобайкальск: '30130',
			Северомуйск: '30132',
			Селенгинск: '30138',
			Селендума: '30145',
			Солнечный: '30130',
			Сорок: '30140',
			Сотниково: '3012',
			Суво: '30131',
			Сулхара: '30141',
			Сухая: '30138',
			Таежный: '30145',
			Таксимо: '30132',
			Таловка: '30144',
			Тамир: '30142',
			Танхой: '30138',
			Тарбагатай: '30146',
			Татаурово: '30144',
			Ташелан: '30136',
			Ташир: '30145',
			Телемба: '30135',
			Темник: '30145',
			Тимлюй: '30138',
			Тоннельный: '30132',
			Топка: '30133',
			Торы: '30147',
			Тохой: '30145',
			Тугнуй: '30143',
			Тужинка: '30135',
			Тулдун: '30135',
			Тунка: '30147',
			Туран: '30147',
			Турка: '30144',
			Турунтаево: '30144',
			Тэгда: '30148',
			Уакит: '30153',
			Удинск: '30148',
			Уладый: '30142',
			Улекчин: '30137',
			Ульдурга: '30135',
			Улюн: '30131',
			Улюнхан: '30149',
			Унгуркуй: '30142',
			Унэгэтэй: '30136',
			Уоян: '30130',
			Уро: '30131',
			Утата: '30137',
			Хамней: '30137',
			Хандагай: '30148',
			Харацай: '30137',
			Харашибирь: '30143',
			Харгана: '30145',
			Хасурта: '30148',
			Хилгана: '30131',
			Холодная: '30130',
			Холтосон: '30137',
			Хонхолой: '30143',
			Хоринск: '30148',
			Хоронхой: '30142',
			Хужиры: '30147',
			Хурамша: '3012',
			Хуртага: '30137',
			Хуртэй: '30141',
			Цакир: '30137',
			Целинный: '30135',
			Ципикан: '30153',
			Цолга: '30143',
			Челутай: '30136',
			Чесан: '30141',
			Чикой: '30142',
			Читкан: '30131',
			Шабур: '30136',
			Шанага: '30133',
			Шарагол: '30142',
			Шаралдай: '30143',
			Шергино: '30138',
			Шибертуй: '30133',
			Шигаево: '30138',
			Эгита: '30135',
			Эдэрмэг: '30141',
			Эрхирик: '30136',
			Юбилейный: '30131',
			Ягодное: '30145',
			Янчукан: '30130'
		}
	},
	'Республика Дагестан': {
		regionCode: '872',
		cities: {
			'Адиль-Янгиюрт': '87247',
			'Аймау-Махи': '87230',
			'Аметерк-Махи': '87260',
			'Арадерих-Cредний': '87272',
			'Ашага Архит': '87244',
			'Ашага-Cтал-Казмаляр': '87236',
			'Ашага-Стал': '87236',
			'Ашага-Ярак': '87244',
			'Большая Арешевка': '87239',
			'Ванаши-Махи': '87230',
			'Верхнее Инхело': '87250',
			'Верхнее Казанище': '87237',
			'Верхний Гуниб': '87258',
			'Верхний Дженгутай': '87237',
			'Верхний Каранай': '87237',
			'Восточно-Сухокумск': '87276',
			'Гоцатль-Большой': '87233',
			'Дагестанские Огни': '87275',
			'Даркуш Казмаляр': '87236',
			'Зубутли Миатли': '87234',
			'Инхо-Нижнее': '87272',
			'Кабир-Казмаляр': '87235',
			'Кака-Шура': '87232',
			'Каланюрт Станция': '87231',
			'Кара-Кюре': '87269',
			'Карла Маркса им.': '87239',
			'Картас-Казмаляр': '87235',
			'Кизлярский Совхоз': '87239',
			'Кичи-Гамри': '87230',
			'Львовское 1': '87247',
			'Малая Арешевка': '87239',
			'Мичурина им.': '87240',
			'Нижнее Инхело': '87271',
			'Нижнее Казанище': '87237',
			'Нижние Гаквари': '87273',
			'Нижние Мулебки': '87230',
			'Нижние Хваршини': '87273',
			'Нижний Батлух': '87259',
			'Нижний Дженгутай': '87237',
			'Нижний Каранай': '87237',
			'Нижний Катрух': '87264',
			'Новый Аул': '87235',
			'Новый Бирюзяк': '87239',
			'Новый Викри': '87248',
			'Новый Костек': '87231',
			'Новый Кумух': '87237',
			'Новый Кяхулай': '8722',
			'Новый Хушет': '8722',
			'Новый Чиркей': '87234',
			'Орта-Стал': '87236',
			'Остров Чечень': '8722',
			'Султан-Янги-Юрт': '87234',
			'Тагиркент-Казмаляр': '87235',
			'Тад-Магитль': '87250',
			'Талги-Курорт': '8722',
			'Тамаза-Тюбе': '87247',
			'Усух-Чай': '87269',
			'Хели-Пенджи': '87249',
			'Цияб-Ичичали': '87231',
			'Шамхал-Термен': '8722',
			'Шамхал-Янги-Юрт': '87234',
			'Южно-Сухокумск': '87276',
			'Юхари-Стал': '87236',
			Авадан: '87269',
			Аверьяновка: '87239',
			Агвали: '87273',
			Аданак: '87232',
			Аджидада: '87234',
			Адильотар: '87231',
			Аймаки: '87255',
			Акнада: '87234',
			Акуша: '87260',
			Алак: '87271',
			Аламише: '87236',
			Александрийская: '87239',
			Александроневское: '87261',
			Алкадар: '87236',
			Алмак: '87279',
			Алмало: '87234',
			Алхаджикент: '87248',
			Альбурикент: '8722',
			Амишта: '87233',
			Амух: '87243',
			Анди: '87271',
			Андых: '87259',
			Ансалта: '87271',
			Анцух: '87265',
			Анчик: '87250',
			Апши: '87237',
			Араблинское: '87240',
			Аракани: '87257',
			Арани: '87233',
			Аргвани: '87272',
			Аркит: '87249',
			Артлух: '87279',
			Арчиб: '87266',
			Ассаб: '87259',
			Атланаул: '87237',
			Ахалчи: '87233',
			Ахар: '87242',
			Ахты: '87263',
			Ачису: '87245',
			Ашар: '87262',
			Ашильта: '87257',
			Ашты: '87254',
			Аялакаб: '87252',
			Бабаюрт: '87247',
			Бавтугай: '87234',
			Байрамаул: '87231',
			Балахани: '87257',
			Балхар: '87260',
			Бамматюрт: '87231',
			Баташюрт: '87231',
			Батаюрт: '87231',
			Батлаич: '87233',
			Бацада: '87258',
			Башлакент: '87248',
			Бежта: '87274',
			Белиджи: '87240',
			Берикей: '87240',
			Богатыревка: '8722',
			Большебредихинское: '87239',
			Большезадоевское: '87239',
			Бондаренковское: '87239',
			Ботлих: '87271',
			Брянск: '87239',
			Буглен: '87237',
			Буйнакск: '87237',
			Бургимакмахи: '87260',
			Бурдеки: '87230',
			Буртунай: '87279',
			Бухты: '87258',
			Варсит: '87238',
			Вачи: '87268',
			Великент: '87240',
			Вихли: '87268',
			Вицхи: '87267',
			Вперед: '87239',
			Гагатль: '87271',
			Гадири: '87273',
			Гамиях: '87242',
			Гапцах: '87235',
			Гапшима: '87260',
			Геджук: '87240',
			Гелли: '87232',
			Гельхен: '87262',
			Геметюбе: '87247',
			Герга: '87248',
			Гергебиль: '87255',
			Герейхановское: '87236',
			Герель: '87265',
			Герменчик: '87247',
			Гертма: '87279',
			Гигатль: '87273',
			Гилиб: '87266',
			Гильяр: '87235',
			Гимры: '87257',
			Гинта: '87260',
			Гоа: '87243',
			Гогаз: '87263',
			Годобери: '87271',
			Голотль: '87259',
			Гонода: '87258',
			Гочада: '87266',
			Гочоб: '87266',
			Губден: '87232',
			Гуми: '87249',
			Гуни: '87279',
			Гуниб: '87258',
			Гурбуки: '87232',
			Гюхряг: '87249',
			Дарваг: '87249',
			Дегва: '87230',
			Дербент: '87240',
			Джаба: '87263',
			Джавгат: '87238',
			Джанга: '87232',
			Джиных: '87264',
			Джульджаг: '87249',
			Дзержинское: '87231',
			Дибгаши: '87254',
			Дружба: '87248',
			Дуакар: '87254',
			Дубки: '87234',
			Дубримахи: '87260',
			Дургели: '87232',
			Дусрах: '87266',
			Дылым: '87279',
			Дюбек: '87249',
			Ерси: '87249',
			Зидьян: '87240',
			Зизик: '87236',
			Зило: '87271',
			Зильбачи: '87254',
			Зрых: '87263',
			Игали: '87272',
			Избербаш: '87245',
			Икра: '87262',
			Инчха: '87279',
			Ирганай: '87257',
			Ириб: '87266',
			Ихрек: '87264',
			Кабир: '87262',
			Кадар: '87237',
			Казьмааул: '87231',
			Кака: '87263',
			Каладжух: '87269',
			Калининаул: '87279',
			Калиновка: '87261',
			Карабаглы: '87261',
			Карабудахкент: '87232',
			Карагас: '87256',
			Карадах: '87258',
			Карамахи: '87237',
			Каранайаул: '87248',
			Карата: '87250',
			Карацан: '87238',
			Кардоновка: '87239',
			Карлабко: '87252',
			Карланюрт: '87231',
			Карчаг: '87236',
			Каспийск: '87246',
			Касумкент: '87236',
			Ках: '87233',
			Кахиб: '87259',
			Каякент: '87248',
			Кванада: '87273',
			Кегер: '87258',
			Кидеро: '87274',
			Кизилюрт: '87234',
			Кизляр: '87239',
			Кикуни: '87255',
			Килятль: '87272',
			Кирка: '87235',
			Кироваул: '87234',
			Кища: '87254',
			Коктюбей: '87261',
			Коммуна: '87258',
			Кондик: '87244',
			Конциль: '87244',
			Коркмаскала: '8722',
			Кособ: '87265',
			Костек: '87231',
			Кочубей: '87261',
			Кошкент: '87244',
			Крайновка: '87239',
			Красноармейское: '8722',
			Кубачи: '87254',
			Куг: '87244',
			Кудали: '87258',
			Кудиябросо: '87250',
			Кудутль: '87255',
			Кули: '87268',
			Куллар: '87240',
			Кулушац: '87267',
			Кульзеб: '87234',
			Кумли: '87256',
			Кумух: '87267',
			Кунбатар: '87256',
			Кунды: '87267',
			Куппа: '87252',
			Кураг: '87243',
			Курах: '87262',
			Куркак: '87249',
			Куркент: '87236',
			Курми: '87255',
			Куруш: '87231',
			Кутиша: '87252',
			Куштиль: '87244',
			Леваши: '87252',
			Ленинкент: '87232',
			Луткун: '87263',
			Лучек: '87264',
			Люксембург: '87247',
			Маали: '87255',
			Магар: '87266',
			Магарамкент: '87235',
			Маджалис: '87238',
			Майданское: '87257',
			Мамедкала: '87240',
			Манасаул: '87237',
			Манаскент: '87232',
			Марага: '87249',
			Махачкала: '8722',
			Мегеб: '87258',
			Межгюль: '87244',
			Мекеги: '87252',
			Местерух: '87250',
			Мехельта: '87272',
			Мискинджи: '87269',
			Мишлеш: '87264',
			Могох: '87255',
			Мокок: '87274',
			Моллакент: '87240',
			Мугарта: '87240',
			Мугерган: '87235',
			Муги: '87260',
			Мужукай: '87247',
			Муни: '87271',
			Мурада: '87255',
			Мургук: '87230',
			Мусультемахи: '87252',
			Муцалаул: '87231',
			Мушули: '87233',
			Мюрего: '87230',
			Нариман: '87256',
			Наци: '87260',
			Некрасовка: '87239',
			Нечаевка: '87234',
			Новогагатли: '87231',
			Новогеоргиевка: '87261',
			Новодмитриевка: '87261',
			Новокаре: '87247',
			Новокахановское: '87239',
			Новокаякент: '87248',
			Новокули: '87242',
			Новолак: '87242',
			Новомехельта: '87242',
			Новомонастырское: '87239',
			Новоромановка: '87261',
			Новосельское: '87231',
			Новочуртах: '87242',
			Нурадилово: '87231',
			Огузер: '87239',
			Октябрьское: '87231',
			Ортатюбе: '87256',
			Оружба: '87235',
			Османюрт: '87231',
			Охли: '87252',
			Параул: '87232',
			Покровское: '87231',
			Раздолье: '87261',
			Рассвет: '87261',
			Ратлуб: '87259',
			Рахата: '87271',
			Риквани: '87271',
			Рича: '87243',
			Рубас: '87240',
			Ругельда: '87259',
			Ругуджа: '87258',
			Рукель: '87240',
			Рутул: '87264',
			Салта: '87258',
			Самур: '87235',
			Семендер: '8722',
			Сергокала: '87230',
			Сиртич: '87249',
			Согратль: '87258',
			Солнечное: '87231',
			Стальское: '87234',
			Старотеречное: '87239',
			Сулак: '8722',
			Сулевкент: '87231',
			Сумета: '87266',
			Суюткино: '87239',
			Танты: '87260',
			Тарки: '8722',
			Тарумовка: '87261',
			Татляр: '87240',
			Тебекмахи: '87260',
			Телетль: '87259',
			Темираул: '87231',
			Теречное: '87231',
			Тинди: '87273',
			Тинит: '87249',
			Тлогоб: '87258',
			Тлондода: '87273',
			Тлох: '87271',
			Тлядаль: '87274',
			Тлярата: '87265',
			Трисанчи: '87254',
			Тукита: '87231',
			Тураг: '87249',
			Туршунай: '87247',
			Тухчар: '87242',
			Тушиловка: '87239',
			Узунотар: '87231',
			Уллуая: '87252',
			Уллубийаул: '87232',
			Уллугатаг: '87236',
			Унцукуль: '87257',
			Унчукатль: '87267',
			Урада: '87259',
			Урари: '87254',
			Урахи: '87230',
			Урга: '87244',
			Ури: '87267',
			Уриб: '87259',
			Уркарах: '87254',
			Усемикент: '87248',
			Уцмиюрт: '87247',
			Учкент: '87234',
			Филя: '87235',
			Хаджалмахи: '87252',
			Хадиял: '87265',
			Хазар: '87240',
			Халимбекаул: '87237',
			Хамавьюрт: '87231',
			Хамаматюрт: '87247',
			Ханаг: '87249',
			Хараг: '87249',
			Харахи: '87233',
			Харбук: '87254',
			Хасавюрт: '87231',
			Хахита: '87252',
			Хвартикуни: '87255',
			Хебда: '87259',
			Хелетури: '87271',
			Хив: '87244',
			Хиндах: '87233',
			Хлют: '87264',
			Хнов: '87263',
			Хосрех: '87268',
			Хоточ: '87258',
			Хрюг: '87263',
			Хубар: '87279',
			Хулисма: '87267',
			Хунзах: '87233',
			Хуни: '87267',
			Хурик: '87249',
			Хучни: '87249',
			Хуштада: '87273',
			Цада: '87233',
			Цатаних: '87257',
			Цахур: '87264',
			Цветковка: '87239',
			Цекоб: '87259',
			Целягюн: '87235',
			Цилитль: '87272',
			Цмур: '87236',
			Цнал: '87244',
			Цугни: '87260',
			Цудахар: '87252',
			Цуриб: '87266',
			Чагаротар: '87231',
			Чанко: '87271',
			Чанкурбе: '87237',
			Чарода: '87266',
			Черняевка: '87239',
			Чинар: '87240',
			Чирката: '87272',
			Чиркей: '87237',
			Чонтаул: '87234',
			Чох: '87258',
			Чулат: '87249',
			Шава: '87247',
			Шамилькала: '87257',
			Шамхал: '8722',
			Шапих: '87274',
			Шара: '87267',
			Шаури: '87274',
			Шиляги: '87238',
			Шимихюр: '87262',
			Шиназ: '87264',
			Шихикент: '87236',
			Шодрода: '87271',
			Штул: '87262',
			Шулани: '87258',
			Эбдалая: '87252',
			Эндирей: '87231',
			Эрпели: '87237',
			Эчеда: '87273',
			Юбилейный: '87239',
			Южное: '87239',
			Юрковка: '87261',
			Янгикент: '87238'
		}
	},
	'Республика Ингушетия': {
		regionCode: '873',
		cities: {
			'Али-Юрт': '8732',
			'Арамхи Санаторий': '87343',
			'Вежарий-Юрт': '8734',
			'Верхние Ачалуки': '8734',
			'Гази-Юрт': '8732',
			'Зязиков-Юрт': '8734',
			'Насыр-Корт': '8732',
			'Нижние Ачалуки': '8734',
			'Новый Редант': '8734',
			'Средние Ачалуки': '8734',
			'село Мужичи': '8734',
			Алхасты: '8734',
			Альтиево: '8732',
			Аршты: '8734',
			Ассиновская: '8734',
			Барсуки: '8732',
			Вознесенская: '8734',
			Галашки: '8734',
			Гамурзиево: '8732',
			Долаково: '8732',
			Инарки: '8734',
			Кантышево: '8732',
			Карабулак: '8734',
			Магас: '87345',
			Малгобек: '8734',
			Мужичи: '8734',
			Назрань: '8732',
			Нестеравская: '8734',
			Нестеровская: '87341',
			Орджоникидзевская: '8734',
			Плиево: '8732',
			Пседах: '8734',
			Сагопши: '8734',
			Серноводск: '8734',
			Согобши: '8734',
			Сурхаки: '8732',
			Сурхахи: '8732',
			Троицкая: '8734',
			Экажево: '8732',
			Южное: '8734',
			Яндаре: '8732'
		}
	},
	'Республика Калмыкия': {
		regionCode: '847',
		cities: {
			'Аршань-Зельмень': '84741',
			'Бага-Бурул': '84732',
			'Бага-Тугтун': '84745',
			'Бага-Чонос': '84742',
			'Большой Царын': '84747',
			'Верхний Яшкуль': '84742',
			'Зунда-Толга': '84732',
			'Ики Бурул': '84732',
			'Ики-Бурул': '84732',
			'Ики-Бухус': '84734',
			'Ики-Чонос': '84742',
			'Красный Маныч': '84745',
			'Красный Партизан': '84745',
			'Малые Дербеты': '84734',
			'Манцын Кец': '84732',
			'Нарын-Худук': '84743',
			'Салын Тугтун': '84741',
			'Тавн-Гашун': '84746',
			'Улан-Хол': '84733',
			'Улан-Эрге': '84746',
			'Ут-Сала': '84732',
			'Хар Толга': '84746',
			'Хар-Булук': '84742',
			'Хонч-Нур': '84734',
			'Цаган Аман ': '84744',
			'Цаган Аман': '84744',
			'Цаган-Аман': '84744',
			'Цаган-Нур': '84747',
			'Цаган-Усн': '84746',
			'Чолун-Хамур': '84732',
			'Эсто-Алтай': '84745',
			Адык: '84743',
			Артезиан: '84743',
			Ачинеры: '84743',
			Барун: '84744',
			Бергин: '84744',
			Березовское: '84745',
			Буранное: '84733',
			Бурата: '84736',
			Буровой: '84743',
			Виноградное: '8473',
			Вознесеновка: '84742',
			Воробьевка: '84736',
			Восход: '84747',
			Гашун: '84746',
			Годжур: '84735',
			Городовиково: '84734',
			Городовиковск: '84731',
			Джалыково: '84733',
			Джангар: '84747',
			Ергенинский: '84735',
			Заливной: '84735',
			Иджил: '84747',
			Кануково: '84741',
			Кевюды: '84732',
			Кегульта: '84735',
			Кетченеры: '84735',
			Кировский: '84741',
			Комсомольский: '84743',
			Коробкин: '84741',
			Красинское: '84733',
			Красномихайловское: '84745',
			Кумской: '84743',
			Лагань: '84733',
			Лола: '84722',
			Маныч: '84732',
			Манычский: '84745',
			Мирный: '84747',
			Молодежный: '84746',
			Найнтахн: '84742',
			Нарта: '84736',
			Нарын: '84736',
			Новый: '84741',
			Обильное: '84741',
			Овата: '84742',
			Оргакин: '84732',
			Партизанский: '84735',
			Первомайский: '84736',
			Песчаный: '84736',
			Плодовитое: '84734',
			Привольный: '84746',
			Прикумский: '84743',
			Приманыч: '84732',
			Приютное: '84736',
			Пушкинское: '8473',
			Розенталь: '8473',
			Садовое: '84741',
			Сарпа: '84735',
			Сарул: '84743',
			Светлый: '84732',
			Северное: '84733',
			Соленое: '84745',
			Солнечный: '84722',
			Татал: '84744',
			Троицкое: '84742',
			Тугтун: '84735',
			Ульдючины: '84736',
			Ульяновское: '84745',
			Уманцево: '84741',
			Утта: '84746',
			Ханата: '84734',
			Харба: '84744',
			Хомутников: '84732',
			Хошеут: '84747',
			Хулхута: '84746',
			Целинный: '84742',
			Чагорта: '84742',
			Чилгир: '84746',
			Чкаловский: '84735',
			Шарнут: '84741',
			Шатта: '84735',
			Элвг: '84746',
			Элиста: '84722',
			Эрдниевский: '84744',
			Эрмели: '84746',
			Юста: '84744',
			Ялмта: '84742',
			Яшалта: '84745',
			Яшкуль: '84746'
		}
	},
	'Республика Карелия': {
		regionCode: '814',
		cities: {
			Вирма: '81437',
			'Великая Губа': '81434',
			'Великая Нива': '81434',
			'Верхнее Волозеро': '81434',
			'Верхние Важины': '81456',
			'Верхний Олонец': '81436',
			'Вилла Гора': '81456',
			'Каменный Бор': '81431',
			'Кривой Порог': '81458',
			'Ладва-Ветка': '8142',
			'Ляскеля лесозавод N 14': '81433',
			'Малиновая Варакка': '81439',
			'Марциальные Воды': '8142',
			'Марциальные воды': '8142',
			'Новая Вилга': '8142',
			'Новое Машозеро': '81437',
			'Полярный Круг': '81439',
			'Попов Порог': '81431',
			'Речная Сельга': '81436',
			'Сенная Губа': '81434',
			'Спасская Губа': '8145',
			'Улитина Новинка': '8145',
			'Усть-Река': '81452',
			'Черный Порог': '81431',
			'ур. Муромский монастырь': '81452',
			Авдеево: '81452',
			Авнепорог: '81458',
			Алхо: '81450',
			Амбарный: '81439',
			Ахвенламби: '81434',
			Беломорск: '81437',
			Березовка: '8145',
			Боровой: '81454',
			Бочилово: '81452',
			Валаам: '81430',
			Валдай: '81431',
			Вача: '81431',
			Вегарус: '81457',
			Ведлозеро: '81456',
			Верхручей: '8142',
			Вешкелица: '81457',
			Вещкелица: '81457',
			Видлица: '81436',
			Вилга: '8142',
			Вирандозеро: '81437',
			Водла: '81452',
			Возрицы: '81434',
			Вокнаволок: '81459',
			Волома: '81455',
			Вяртсиля: '81430',
			Габсельга: '81434',
			Гимолы: '81455',
			Гирвас: '8145',
			Гридино: '81458',
			Гумарино: '81457',
			Деревянка: '8142',
			Деревянное: '8142',
			Евгора: '81434',
			Еглово: '81434',
			Заозерный: '81430',
			Заозерье: '8142',
			Зашеек: '81439',
			Идель: '81431',
			Ильинский: '81436',
			Импилахти: '81433',
			Интерпоселок: '81436',
			Ихала: '81450',
			Кааламо: '81430',
			Кажма: '81434',
			Калгалакша: '81458',
			Калевала: '81454',
			Карельский: '81439',
			Каршево: '81452',
			Кварцитный: '8142',
			Кедрозеро: '8145',
			Кемь: '81458',
			Кепа: '81454',
			Кестеньга: '81439',
			Кижи: '8142',
			Кимоваара: '81455',
			Кинелахта: '81456',
			Ковера: '81436',
			Койвусельга: '81456',
			Колатсельга: '81456',
			Колежма: '81437',
			Колово: '81452',
			Кондопога: '81451',
			Кончезером: '8145',
			Космозеро: '81434',
			Костомукша: '81459',
			Коткозеро: '81436',
			Кочкома: '81431',
			Красноборский: '81452',
			Крошнозеро: '81456',
			Кубово: '81452',
			Куганаволок: '81452',
			Кудома: '81456',
			Кузаранда: '81434',
			Кузема: '81458',
			Куйтежа: '81436',
			Куликово: '81450',
			Кумса: '81434',
			Куокканиеми: '81430',
			Куркиеки: '81450',
			Куусиниеми: '81454',
			Кяппесельга: '8145',
			Ладва: '8142',
			Ламбасручей: '81434',
			Лахденпохья: '81450',
			Лахколампи: '81457',
			Ледмозеро: '81455',
			Лендеры: '81455',
			Леппясюрья: '81457',
			Летнереченский: '81437',
			Лоймола: '81457',
			Лоухи: '81439',
			Лумиваара: '81450',
			Луусалми: '81454',
			Ляскеля: '81433',
			Маленьга: '81437',
			Маслозеро: '81434',
			Маткаселька: '81430',
			Матросы: '81456',
			Мегрега: '81436',
			Медвежьегорск: '81434',
			Мелиоративный: '8142',
			Мийнола: '81450',
			Михайловское: '81436',
			Мотко: '81455',
			Муезерский: '81455',
			Надвоицы: '81431',
			Найстенъярви: '81457',
			Нелгомозеро: '8145',
			Немино: '81434',
			Новостеклянное: '81452',
			Нурмолица: '81436',
			Нюхча: '81437',
			Огорелыши: '81434',
			Олений: '81431',
			Олонец: '81436',
			Ондозеро: '81455',
			Онежский: '81452',
			Паданы: '81434',
			Падун: '81434',
			Пай: '8142',
			Панозеро: '81458',
			Партала: '81430',
			Патрово: '81434',
			Педасельга: '8142',
			Пенинга: '81455',
			Пергуба: '81434',
			Пертозеро: '81431',
			Песчаное: '81452',
			Петрозаводск: '8142',
			Пийтсиоки: '81457',
			Пиндуши: '81434',
			Питкяранта: '81433',
			Плотина: '81439',
			Повенец: '81434',
			Подпорожье: '81452',
			Полга: '81431',
			Поросозеро: '81457',
			Приречный: '81452',
			Пряжа: '81456',
			Пудож: '81452',
			Пудожгорский: '81452',
			Пуйккала: '81430',
			Пухта: '8142',
			Пушной: '81437',
			Пяльма: '81452',
			Пяозерский: '81439',
			Рабочеостровск: '81458',
			Рагнукса: '81452',
			Райконкоски: '81457',
			Рауталахти: '81433',
			Реболы: '81455',
			Ринтола: '81450',
			Ругозеро: '81455',
			Рускеала: '81430',
			Рыбрека: '8142',
			Рыпушкалица: '81436',
			Ряймеля: '81433',
			Савиново: '81456',
			Салми: '81433',
			Святозеро: '81456',
			Сегежа: '81431',
			Сельги: '81434',
			Семеново: '81452',
			Сергиево: '81434',
			Соддер: '81456',
			Сортавала: '81430',
			Сосновец: '81437',
			Сосновка: '81434',
			Сосновый: '81439',
			Суйстамо: '81457',
			Суккозеро: '81455',
			Сумпосад: '81437',
			Суоеки: '81457',
			Суоярви: '81457',
			Сяпся: '81456',
			Тамбицы: '81452',
			Тамбичозеро: '81452',
			Таунан: '81450',
			Тивдия: '8145',
			Тикша: '81455',
			Типиницы: '81434',
			Тойвола: '81457',
			Толвуя: '81434',
			Тукса: '81436',
			Тулокса: '81436',
			Тумба: '81455',
			Тунгозеро: '81439',
			Тэдино: '81439',
			Уница: '8145',
			Уукса: '81433',
			Хаапалампи: '81430',
			Харлу: '81433',
			Хелюля: '81430',
			Хетоламбино: '81439',
			Хийтола: '81450',
			Хуухканмяки: '81450',
			Хюмпеля: '81430',
			Чална: '81456',
			Чебино: '81434',
			Челмужи: '81434',
			Чкаловский: '81439',
			Чупа: '81439',
			Шалговаары: '81434',
			Шальский: '81452',
			Шелтозеро: '8142',
			Шижня: '81437',
			Шуерецкое: '81437',
			Шуйская: '8142',
			Шуньга: '81434',
			Шуя: '8142',
			Элисенваара: '81450',
			Энгозеро: '81439',
			Эссойла: '81456',
			Юркостров: '8145',
			Юшкозеро: '81454',
			Ялгуба: '8142',
			Яндомозеро: '81434',
			Янишполе: '8145'
		}
	},
	'Республика Коми': {
		regionCode: '821',
		cities: {
			'Белый Бор': '82138',
			'Белый Ю': '82142',
			'Большая Пучкома': '82135',
			'Большая Пысса': '82135',
			'Верхняя Инта': '82145',
			'Верхняя Максаковка': '8212',
			'Верхняя Омра': '82149',
			'Иван-Ель': '82149',
			'Илья-Шор': '82134',
			'Кедровый Шор': '82142',
			'Комсомольск-на-Печоре': '82138',
			'Коровий Ручей': '82141',
			'Красный Яг': '82142',
			'Малая Пера': '82149',
			'Митрофан-Дикост': '82138',
			'Мишкин-Ель': '82138',
			'Мутный Материк': '82144',
			'Нижний Воч': '82137',
			'Нижний Одес': '82149',
			'Нижний Турунъю': '82132',
			'Нижняя Омра': '82138',
			'Новый Бор': '82141',
			'Окунев Нос': '82141',
			'Среднее Бугаево': '82141',
			'с. Ижма': '82140',
			'Троицко-Печорск': '82138',
			'Усть-Вымь': '82134',
			'Усть-Ижма': '82140',
			'Усть-Илыч': '82138',
			'Усть-Кулом': '82137',
			'Усть-Лопъю': '82133',
			'Усть-Лыжа': '82144',
			'Усть-Лэкчим': '82136',
			'Усть-Нем': '82137',
			'Усть-Пожег': '8212',
			'Усть-Соплеск': '82146',
			'Усть-Унья': '82138',
			'Усть-Уса': '82144',
			'Усть-Ухта': '82149',
			'Усть-Цильма': '82141',
			'Черный Яр': '82134',
			Абезь: '82145',
			Аджером: '82136',
			Адзьвавом: '82145',
			Айкино: '82134',
			Акись: '82144',
			Аныб: '82137',
			Бакур: '82140',
			Березовка: '82142',
			Благоево: '82135',
			Богородск: '82136',
			Большелуг: '82136',
			Боровой: '8216',
			Бортэм: '82131',
			Брыкаланск: '82140',
			Буткан: '82135',
			Важгорт: '82135',
			Важкуръя: '82136',
			Ваймес: '82133',
			Вежайка: '82134',
			Вежъю: '82132',
			Вездино: '82134',
			Велдоръя: '82133',
			Вендинга: '82135',
			Верхнеижемский: '82149',
			Верхолузье: '82133',
			Веселовка: '82136',
			Весляна: '82139',
			Ветью: '82139',
			Визинга: '82131',
			Визиндор: '82131',
			Визябож: '82136',
			Вогваздино: '82134',
			Водный: '8216',
			Вожаель: '82139',
			Вожский: '82135',
			Войвож: '82149',
			Вольдино: '82137',
			Вомын: '82136',
			Воргашор: '82151',
			Воркута: '82151',
			Вотча: '82131',
			Вуктыл: '82146',
			Вухтым: '82133',
			Выльгорт: '82130',
			Гагшор: '82131',
			Гам: '82134',
			Глотово: '82135',
			Горьковская: '82131',
			Гостиногорка: '82133',
			Грива: '82132',
			Гуляшор: '82133',
			Гурьевка: '82133',
			Денисовка: '82144',
			Деревянск: '82137',
			Диасеръя: '82137',
			Диюр: '82140',
			Додзь: '82136',
			Дон: '82137',
			Донаель: '82134',
			Дутово: '82146',
			Едва: '82135',
			Елецкий: '82151',
			Ельбаза: '82131',
			Емва: '82139',
			Еремеево: '82138',
			Ермица: '82141',
			Ертом: '82135',
			Жешарт: '82134',
			Замежная: '82141',
			Занулье: '82133',
			Заозерье: '82131',
			Заполярный: '82151',
			Заречное: '82131',
			Захарвань: '82144',
			Зеленец: '8212',
			Зеленоборск: '82142',
			Зимовка: '82132',
			Зимстан: '82137',
			Знаменка: '82138',
			Ижма: '82140',
			Изъяю: '82142',
			Инта: '82145',
			Иоссер: '82139',
			Ираель: '82149',
			Исанево: '82131',
			Каджером: '82142',
			Кажым: '82132',
			Казлук: '82134',
			Канава: '82137',
			Кебанъель: '82137',
			Кедвавом: '8216',
			Кельчиюр: '82140',
			Кемъяр: '8212',
			Керес: '82136',
			Керки: '82149',
			Керчомъя: '82137',
			Кипиево: '82140',
			Княжпогост: '82139',
			Кожва: '82142',
			Кожмудор: '82134',
			Кожым: '82145',
			Койгородок: '82132',
			Койдин: '82132',
			Койю: '82140',
			Коквицы: '82134',
			Ком: '82132',
			Комсомольский: '82151',
			Конашъель: '82149',
			Конецбор: '82142',
			Копса: '82131',
			Коржинский: '82133',
			Корткерос: '82136',
			Кослан: '82135',
			Косью: '82142',
			Косьювом: '82145',
			Краснобор: '82140',
			Краснозатонский: '8212',
			Крутоборка: '82137',
			Кужба: '82137',
			Кузьель: '82132',
			Куратово: '82131',
			Куръя: '82138',
			Кыддзявидз: '82133',
			Кырта: '82146',
			Кэмдин: '8216',
			Лемты: '82146',
			Лемтыбож: '82146',
			Летка: '82133',
			Лойма: '82133',
			Лопъювад: '82137',
			Лэзым: '8212',
			Ляли: '82139',
			Маджа: '82136',
			Мадмас: '82134',
			Мандач: '8212',
			Мартиты: '82136',
			Медвежка: '82141',
			Межадор: '82131',
			Междуреченск: '82135',
			Межег: '82134',
			Мескашор: '82151',
			Мещура: '82139',
			Микунь: '82134',
			Мирный: '82138',
			Мозындор: '82135',
			Мордино: '82136',
			Мохча: '82140',
			Мошъюга: '82140',
			Мутница: '82133',
			Муфтюга: '82135',
			Мыелдино: '82137',
			Мылва: '82138',
			Намск: '82136',
			Небдино: '82136',
			Нерица: '82141',
			Нившера: '82136',
			Новикбож: '82144',
			Ношуль: '82133',
			Нювчим: '8212',
			Нюмыд: '82137',
			Нючпас: '82132',
			Няшабож: '82140',
			Объячево: '82133',
			Озел: '8212',
			Озерный: '82142',
			Озъяг: '82137',
			Октябрьский: '82151',
			Оньмесь: '82133',
			Пажга: '8212',
			Палауз: '82131',
			Палевицы: '8212',
			Палью: '82138',
			Парма: '82144',
			Парч: '82137',
			Первомайский: '82131',
			Петрунь: '82145',
			Печора: '82142',
			Подзь: '82132',
			Подтыбок: '82136',
			Подчерье: '82146',
			Подъельск: '82136',
			Пожег: '82137',
			Пожемаяг: '82133',
			Позтыкерес: '82136',
			Поинга: '8212',
			Покча: '82138',
			Поляна: '82149',
			Помоздино: '82137',
			Приозерный: '82136',
			Приуральский: '82138',
			Приуральское: '82142',
			Прокопьевка: '82133',
			Промышленный: '82151',
			Пузла: '82137',
			Путеец: '82142',
			Пыелдино: '82131',
			Ракпас: '82139',
			Ропча: '82139',
			Русаново: '82138',
			Руч: '82137',
			Рыбница: '82142',
			Северный: '82151',
			Седкыркещ: '8212',
			Седтыдор: '82132',
			Седъю: '8216',
			Седъюдор: '82139',
			Сельыб: '82135',
			Селэгвож: '82135',
			Семуково: '82134',
			Серегово: '82139',
			Сивомаскинский: '82151',
			Сизябск: '82140',
			Синдор: '82139',
			Синегорье: '82141',
			Скородум: '82137',
			Смолянка: '82137',
			Собино: '82136',
			Советский: '82151',
			Соколово: '82142',
			Сосногорск: '82149',
			Спаспоруб: '82133',
			Сторожевск: '82136',
			Студенец: '82134',
			Сыктывкар: '8212',
			Сыня: '82142',
			Талый: '82142',
			Тимушбор: '82138',
			Тимшер: '82137',
			Тобысь: '8216',
			Том: '82140',
			Тракт: '82139',
			Троицк: '82136',
			Трусово: '82141',
			Туискерес: '82134',
			Туръя: '82139',
			Уег: '82141',
			Ульяново: '82137',
			Уръель: '82136',
			Усадор: '82144',
			Усинск: '82144',
			Усогорск: '82135',
			Ухта: '82147',
			Хабариха: '82141',
			Харъяга: '82141',
			Цементнозаводский: '82151',
			Часово: '8212',
			Чернореченский: '82139',
			Чернутьево: '82135',
			Черныш: '82133',
			Чикшино: '82142',
			Чим: '82135',
			Чиньяворык: '82139',
			Читаево: '82133',
			Чукаиб: '82131',
			Чупрово: '82135',
			Чухлэм: '82131',
			Шердино: '82146',
			Шерляга: '82138',
			Шугрэм: '82131',
			Шудаяг: '8216',
			Шэръяг: '82137',
			Щельябож: '82144',
			Щельяюр: '82140',
			Ыб: '8212',
			Югыдъяг: '82137',
			Юршор: '82151',
			Ягкедж: '82137',
			Якуньель: '82133',
			Якша: '82138',
			Ярашъю: '82137',
			Ярега: '82147',
			Яренга: '82134',
			Яснэг: '8212'
		}
	},
	'Республика Крым': {
		regionCode: '365',
		cities: {
			'Красная Зорька': '3652',
			'Старый Крым': '3655',
			Аграрное: '3652',
			Алупка: '3654',
			Алушта: '36560',
			Армянск: '36567',
			Аэрофлотский: '3652',
			Бахчисарай: '36554',
			Белоглинка: '3652',
			Белогорск: '36559',
			Гаспра: '3654',
			Гвардейское: '3652',
			Грэсовский: '3652',
			Джанкой: '36564',
			Доброе: '3652',
			Евпатория: '36569',
			Инкерман: '8692',
			Каменское: '3652',
			Керчь: '36561',
			Кировское: '36555',
			Коктебель: '36562',
			Кольчугино: '3652',
			Комсомольское: '3652',
			Красногвардейское: '36556',
			Красноперекопск: '36565',
			Лекарственное: '3652',
			Ливадия: '3654',
			Мазанка: '3652',
			Мирное: '3652',
			Молодежное: '3652',
			Мраморное: '3652',
			Нижнегорский: '36550',
			Николаевка: '3652',
			Перевальное: '3652',
			Перово: '3652',
			Пионерское: '3652',
			Пожарское: '3652',
			Приморский: '36562',
			Родниковое: '3652',
			Саки: '36563',
			Севастополь: '8692',
			Симферополь: '3652',
			Синекаменка: '36559',
			Скворцово: '3652',
			Советский: '36551',
			Судак: '36566',
			Топольное: '3652',
			Трудовое: '3652',
			Укромное: '3652',
			Феодосия: '36562',
			Фонтаны: '3652',
			Форос: '3654',
			Чайкино: '3652',
			Черноморское: '36558',
			Чистенькое: '3652',
			Щёлкино: '36557',
			Ялта: '3654'
		}
	},
	'Республика Марий Эл': {
		regionCode: '836',
		cities: {
			'Большая Коклала': '83633',
			'Большая Лумарь': '83636',
			'Большие Ключи': '83633',
			'Большое Кибеево': '83643',
			'Большое Опарино': '83634',
			'Большой Ашламаш': '83638',
			'Большой Карлыган': '83634',
			'Большой Кугланур': '83641',
			'Большой Ляждур': '83637',
			'Большой Сердеж': '83633',
			'Верх-Ушнур': '83638',
			'Верхнее Азяково': '8362',
			'Верхний Кугенер': '83633',
			'Горный Шумец': '83644',
			'Изи-Кугунур': '83635',
			'Изи-Шурга': '83635',
			'Йошкар-Ола ': '8362',
			'Йошкар-Ола': '8362',
			'Кленовая Гора': '83631',
			'Красный Мост': '83643',
			'Красный Стекловар': '83635',
			'Красный Яр': '83645',
			'Кутюк-Кинер': '83635',
			'Кучко-Памаш': '83635',
			'Малая Турша': '8362',
			'Мари-Билямор': '83634',
			'Мари-Купта': '83634',
			'Мари-Турек': '83634',
			'Нижний Рушенер': '83633',
			'Новая Слобода': '83632',
			'Новые Параты': '83631',
			'Новый Торъял': '83636',
			'Русская Ляжмарь': '83639',
			'Русские Шои': '83637',
			'Русский Кукмор': '8362',
			'Средний Кадам': '83638',
			'Старое Крещено': '83641',
			'Старый Торъял': '83636',
			'Тат Китня': '83634',
			'Три Рутки': '83632',
			'Троицкий Посад': '83632',
			'Тыгыде Морко': '83635',
			'Черное Озеро': '83645',
			'Шой-Шудумарь': '83637',
			Азаново: '8362',
			Азъял: '83635',
			Алашайка: '83639',
			Алексеевский: '83638',
			Анчутино: '83644',
			Арда: '83643',
			Арино: '83635',
			Березово: '83632',
			Васильевское: '83644',
			Великополье: '83641',
			Весьшурга: '83635',
			Визимьяры: '83643',
			Виловатово: '83632',
			Волжск: '83631',
			Вятское: '83638',
			Головино: '83641',
			Дружино: '83634',
			Ежово: '8362',
			Еласы: '83632',
			Елеево: '83639',
			Елембаево: '83636',
			Емелево: '83632',
			Емешево: '83632',
			Зашижемье: '83633',
			Звенигово: '83645',
			Зеленогорск: '83635',
			Знаменский: '8362',
			Ильпанур: '83639',
			Ирнур: '83639',
			Исменцы: '83645',
			Иштымбал: '83637',
			Казанское: '83633',
			Калеево: '83633',
			Карай: '83631',
			Картуково: '83632',
			Кельмаксола: '83638',
			Керебеляк: '83645',
			Килемары: '83643',
			Кичиер: '83631',
			Козиково: '83644',
			Козьмодемьянск: '83632',
			Кокшайск: '8362',
			Кокшамары: '83645',
			Коркатово: '83635',
			Косолапово: '83634',
			Красногорский: '83645',
			Краснооктябрьский: '8362',
			Круглово: '83644',
			Крупино: '83634',
			Куанпамаш: '83636',
			Куженер: '83637',
			Кужмара: '83638',
			Кузнецово: '8362',
			Кузнецы: '83636',
			Кузьмино: '83644',
			Кукмарь: '83638',
			Кукнур: '83633',
			Кулаково: '83632',
			Кульбаш: '83635',
			Кумья: '83643',
			Куракино: '83639',
			Куяр: '8362',
			Лажъял: '83633',
			Ленинский: '83644',
			Липша: '83645',
			Лоскутово: '83633',
			Лужбеляк: '83641',
			Люльпаны: '8362',
			Майский: '83643',
			Макаркино: '83632',
			Манылово: '83634',
			Мариец: '83634',
			Марисола: '83633',
			Маркелово: '83636',
			Марково: '83641',
			Марьино: '83644',
			Масканур: '83636',
			Медведево: '8362',
			Микряково: '83632',
			Михайловка: '83638',
			Морки: '83635',
			Моркиялы: '83631',
			Мочалище: '83645',
			Мумариха: '83632',
			Мустаево: '83633',
			Нартас: '83634',
			Нежнур: '83643',
			Нежнурский: '83643',
			Новопавловский: '83634',
			Новый: '8362',
			Нужьялы: '8362',
			Нурма: '8362',
			Озерки: '83632',
			Октябрьский: '83635',
			Олоры: '83639',
			Орша: '83638',
			Оршанка: '83641',
			Осипсола: '83635',
			Отары: '83641',
			Ошканер: '83636',
			Пайгусово: '83632',
			Параньга: '83639',
			Пектубаево: '83636',
			Пемба: '8362',
			Пертнуры: '83632',
			Пертылга: '83635',
			Петровское: '83635',
			Петьялы: '83631',
			Пижма: '8362',
			Покровское: '83644',
			Полевая: '83631',
			Помары: '83631',
			Портянур: '83639',
			Приволжский: '83631',
			Ронга: '83638',
			Ружбеляк: '83637',
			Руэм: '8362',
			Салтакъял: '83637',
			Сардаял: '83634',
			Себеусад: '83635',
			Семисола: '83635',
			Семёновка: '8362',
			Сенда: '83634',
			Сенькино: '8362',
			Сернур: '83633',
			Сидельниково: '83645',
			Силикатный: '8362',
			Советский: '83638',
			Солнечный: '83638',
			Сотнур: '83631',
			Сурок: '8362',
			Суслонгер: '83645',
			Суходол: '83644',
			Сысоево: '83634',
			Табашино: '83641',
			Токтайбеляк: '83637',
			Токтарсола: '83636',
			Тумьюмучаш: '83637',
			Упша: '83641',
			Учейкино: '83631',
			Хлебниково: '83634',
			Цибикнур: '8362',
			Чавайнур: '83635',
			Чаломкино: '83632',
			Часовенная: '83631',
			Чекеево: '83632',
			Чирки: '83641',
			Чкарино: '83638',
			Чобыково: '83636',
			Чодраял: '83631',
			Шелангер: '83645',
			Шереганово: '83635',
			Шимшурга: '83645',
			Шиндырьялы: '83632',
			Шиньша: '83635',
			Шойбулак: '8362',
			Шордур: '83635',
			Шоруньжа: '83635',
			Шуарсола: '83638',
			Шулка: '83641',
			Шура: '83636',
			Эмеково: '83631',
			Эшполдино: '83633',
			Юбилейный: '8362',
			Юксары: '83643',
			Юледур: '83637',
			Юрдур: '83635',
			Юрино: '83644',
			Юркино: '83644',
			Яльчик: '83631',
			Яштуга: '83632'
		}
	},
	'Республика Мордовия': {
		regionCode: '834',
		cities: {
			'Архангельское Голицыно': '83451',
			'Базарная Дубровка': '83454',
			'Береговые Сыреси': '83433',
			'Большая Елховка': '83441',
			'Большая Пестровка': '83433',
			'Большая Поляна': '83448',
			'Большие Березники': '83436',
			'Большие Манадыши': '83434',
			'Большие Мордовские Пошаты': '83444',
			'Большие Поляны': '83431',
			'Большие Ремезенки': '83437',
			'Большое Игнатово': '83442',
			'Большое Маресево': '83437',
			'Большой Азясь': '83453',
			'Большой Уркат': '83444',
			'Большой Шуструй': '83454',
			'Вадовские Селищи': '83458',
			'Верхний Урледим': '83451',
			'Верхняя Лухма': '83449',
			'Восход Совхоз': '83432',
			'Дмитриев Усад': '83454',
			'Зубова Поляна': '83458',
			'Ингенер-Пятина': '83432',
			'Инсар Поселок': '83448',
			'Инсар-Акшино': '83451',
			'Казенный Майдан': '83453',
			'Каменный Брод': '83444',
			'Коммунар Совхоз': '83441',
			'Красная Пресня Совхоз': '83453',
			'Красноармеец Совхоз': '83456',
			'Красное Сельцо Совхоз': '83451',
			'Красный Шадым': '83453',
			'Красный Яр': '83446',
			'Лесное Цибаево': '83445',
			'Луньгинский Майдан': '83431',
			'Лухменский Майдан': '83449',
			'Малое Игнатово': '83431',
			'Малые Березники': '83438',
			'Манадыши Вторые': '83431',
			'Манадыши Первые': '83431',
			'Мордовская Козловка': '83454',
			'Мордовская Паевка': '83449',
			'Мордовская Пишля': '83451',
			'Мордовская Поляна': '83458',
			'Мордовские Сыреси': '83434',
			'Мордовские Юнки': '83456',
			'Мордовский Пимбур': '83458',
			'Мордовско-Маскин Выселки': '83444',
			'Мордовское Давыдово': '83439',
			'Мордовское Коломасово': '83453',
			'Наборные Сыреси': '83434',
			'Напольная Тавла': '8342',
			'Нижняя Вязера': '83449',
			'Новая Александровка': '83432',
			'Новая Карьга': '83443',
			'Новая Муравьевка': '83451',
			'Новая Потьма': '83458',
			'Новая Пырма': '83439',
			'Новая Толковка': '83453',
			'Новая Федоровка': '83432',
			'Новое Акшино': '83432',
			'Новое Бадиково': '83458',
			'Новое Баево': '83442',
			'Новое Качаево': '83442',
			'Новое Мамангино': '83453',
			'Новое Пшенево': '83453',
			'Новоусадские Выселки': '83444',
			'Новоямская Слобода': '83444',
			'Новые Выселки': '83458',
			'Новые Ичалки': '83433',
			'Новые Пичингуши': '83444',
			'Новые Турдаки': '83439',
			'Новый Ковыляй': '83444',
			'Новый Усад': '83443',
			'Подгорное Канаково': '83445',
			'Подлесная Тавла': '83439',
			'Польское Цибаево': '83445',
			'Русская Паевка': '83449',
			'Русские Дубровки': '83434',
			'Русские Найманы': '83436',
			'Русский Лундан': '83458',
			'Русское Баймаково': '83451',
			'Русское Караево': '83445',
			'Русское Маскино': '83443',
			'Русское Тювеево': '83445',
			'Сабур-Мачкассы': '83437',
			'Сараст Птицесовхоз': '83434',
			'Сиалеевская Пятина': '83449',
			'Слободские Дубровки': '83443',
			'Спасские Мурзы': '83431',
			'Старая Авгура': '83443',
			'Старая Качеевка': '83446',
			'Старая Михайловка': '83438',
			'Старая Рябка': '83443',
			'Старая Самаевка': '83453',
			'Старая Теризморга': '83432',
			'Старая Федоровка': '83432',
			'Старое Аллагулово': '83453',
			'Старое Ардатово': '83431',
			'Старое Бадиково': '83458',
			'Старое Дракино': '83453',
			'Старое Синдрово': '83443',
			'Старое Чамзино': '83442',
			'Старое Шайгово': '83432',
			'Старотештелимские Выселки': '83444',
			'Старые Верхиссы': '83449',
			'Старые Найманы': '83436',
			'Старые Пичуры': '83456',
			'Старые Селищи': '83442',
			'Старые Турдаки': '83439',
			'Старый Город': '83445',
			'Стрелецкая Слобода': '83451',
			'Тарханская Потьма': '83458',
			'Татарская Пишля': '83451',
			'Татарская Свербейка': '83441',
			'Татарская Тавла': '83441',
			'Татарские Юнки': '83456',
			'Татарский Шебдас': '83451',
			'Унуевский Майдан': '83453',
			'Урей Третий': '83445',
			'Чекашевы Поляны': '83453',
			'Челмодеевский Майдан': '83449',
			'Черная Промза': '83436',
			'Шадымо-Рыскино': '83449',
			'Языкова Пятина': '83449',
			'Янгуженский Майдан': '83453',
			Адашево: '83448',
			Аксел: '83445',
			Аксеново: '83441',
			Акчеево: '83444',
			Александровка: '83441',
			Алово: '83434',
			Алтары: '83438',
			Алькино: '83453',
			Анаево: '83458',
			Андреевка: '83445',
			Анненково: '83438',
			Апраксино: '83437',
			Аргамаково: '83451',
			Ардатов: '83431',
			Ардатово: '83447',
			Атемар: '83441',
			Атюрьево: '83454',
			Атяшево: '83434',
			Ачадово: '83458',
			Бабеево: '83445',
			Баево: '83431',
			Барашево: '83446',
			Батушево: '83434',
			Безводное: '83431',
			Белозерье: '83438',
			Берсеневка: '83441',
			Богдановка: '83432',
			Болдасево: '83433',
			Болдово: '83451',
			Болотниково: '83441',
			Бузаево: '83436',
			Булгаково: '83439',
			Булдыгино: '83458',
			Варжеляй: '83456',
			Васильевка: '83453',
			Ведянцы: '83433',
			Вертелим: '83432',
			Верякуши: '83432',
			Вечерлей: '83434',
			Вечкусы: '83433',
			Виндрей: '83456',
			Воеводское: '83439',
			Волгапино: '83453',
			Вольноникольское: '83454',
			Выша: '83458',
			Гарт: '83436',
			Говорово: '83432',
			Горки: '83442',
			Горяйновка: '8342',
			Гузынцы: '83436',
			Гуляево: '83433',
			Дальний: '83441',
			Дачный: '83446',
			Дегилевка: '83436',
			Долговерясы: '83443',
			Дракино: '83456',
			Дубенки: '83447',
			Дубитель: '83458',
			Дубровское: '83433',
			Дюрки: '83434',
			Ежовка: '83453',
			Елизаветинка: '83436',
			Ельники: '83444',
			Енгалычево: '83447',
			Ефаево: '83443',
			Жегалово: '83445',
			Жуковка: '83458',
			Жуково: '83456',
			Журавкино: '83458',
			Зайцево: '83443',
			Заречное: '83443',
			Зыково: '8342',
			Известь: '83458',
			Изосимовка: '83453',
			Инсар: '83449',
			Ичалки: '83433',
			Ишейки: '83445',
			Кабаево: '83447',
			Кадошкино: '83448',
			Кажлодка: '83456',
			Казеевка: '83449',
			Кайбичево: '83447',
			Каймар: '83443',
			Каласево: '83431',
			Калыша: '83433',
			Камаево: '83433',
			Каменка: '83434',
			Каньгуши: '83444',
			Капасово: '83434',
			Каргашино: '83458',
			Качелай: '83439',
			Кельвядни: '83431',
			Кемля: '83433',
			Кендя: '83433',
			Кечушево: '83431',
			Кимляй: '83453',
			Кишалы: '83454',
			Ключарево: '83451',
			Ковылкино: '83453',
			Козловка: '83434',
			Колопино: '83443',
			Комсомольский: '83437',
			Кондровка: '83445',
			Конопать: '83432',
			Константиновка: '83438',
			Косогоры: '83436',
			Кочелаево: '83453',
			Кочетовка: '83449',
			Кочкурово: '83439',
			Кочуново: '83438',
			Красино: '83447',
			Красномайский: '83439',
			Краснослободск: '83443',
			Красный: '83432',
			Кривозерье: '83441',
			Кулдым: '83432',
			Кураево: '83446',
			Куракино: '83431',
			Курилово: '83438',
			Курмачкасы: '83438',
			Курнино: '83453',
			Курташки: '83454',
			Кученяево: '83431',
			Кучкаево: '83442',
			Кушки: '83445',
			Лаврентьево: '83445',
			Лада: '83433',
			Латышовка: '83448',
			Левжа: '83451',
			Лемдяй: '83432',
			Леплей: '83458',
			Лесной: '83458',
			Лесозавод: '83431',
			Летки: '83432',
			Липки: '83438',
			Ломаты: '83447',
			Луньга: '83431',
			Луховка: '8342',
			Лямбирь: '83441',
			Маколово: '83437',
			Мальцево: '83456',
			Мамолаево: '83453',
			Марьяновка: '83436',
			Матвеево: '83445',
			Медаево: '83437',
			Мельсетьево: '83446',
			Мельцаны: '83432',
			Митрялы: '83445',
			Михайловское: '83453',
			Мичурино: '83437',
			Мокшалей: '83437',
			Молочница: '83458',
			Морга: '83447',
			Мурань: '83439',
			Нагаево: '83448',
			Надеждино: '83444',
			Нароватово: '83446',
			Низовка: '83434',
			Николаевка: '83447',
			Никольское: '83456',
			Новодевичье: '83444',
			Новоникольское: '83444',
			Новотроицкое: '83432',
			Новочадово: '83454',
			Носакино: '83456',
			Озерный: '83458',
			Октябрьский: '83431',
			Олевка: '83431',
			Отрадное: '83437',
			Паево: '83448',
			Пайгарма: '83451',
			Палаевка: '83451',
			Паньжа: '83453',
			Парадеево: '83433',
			Паракино: '83436',
			Парапино: '83453',
			Парца: '83458',
			Пензятка: '83441',
			Первомайск: '83441',
			Первомайский: '83453',
			Перевесье: '83454',
			Пермеево: '83433',
			Пермиси: '83436',
			Перхляй: '83451',
			Петровка: '83447',
			Пиксяси: '83431',
			Пичеуры: '83437',
			Пичпанда: '83458',
			Плодопитомнический: '83451',
			Поводимово: '83447',
			Подлясово: '83458',
			Покровск: '83453',
			Покровское: '83434',
			Полое: '83431',
			Польцо: '83453',
			Полянки: '83445',
			Потьма: '83458',
			Починки: '83436',
			Пурдошки: '83445',
			Пуркаево: '83447',
			Пятина: '83438',
			Редкодубье: '83431',
			Резоватово: '83433',
			Репьевка: '83437',
			Рождествено: '83433',
			Ромоданово: '83438',
			Рузаевка: '83451',
			Рыбкино: '83453',
			Рыскино: '83453',
			Рязановка: '83432',
			Сабаево: '83439',
			Сабанчеево: '83434',
			Савва: '83456',
			Салазгорь: '83456',
			Салма: '83438',
			Самаевка: '83453',
			Саранск: '8342',
			Свеженькая: '83458',
			Свиносовхоз: '83447',
			Семилей: '83439',
			Сивинь: '83443',
			Силикатный: '83453',
			Силино: '83431',
			Симкино: '83436',
			Скрябино: '83441',
			Смольный: '83433',
			Солдатское: '83431',
			Сосновка: '83458',
			Сосуновка: '83434',
			Софьино: '83444',
			Спасское: '83442',
			Стандрово: '83446',
			Стародевичье: '83444',
			Стрельниково: '83454',
			Студенец: '83458',
			Судосево: '83436',
			Сузгарье: '83451',
			Сургодь: '83456',
			Тазино: '83436',
			Такушево: '83446',
			Тарасово: '83434',
			Тарханово: '83433',
			Тарханы: '83445',
			Темников: '83445',
			Теньгушево: '83446',
			Токмово: '83453',
			Торбеево: '83456',
			Троицк: '83453',
			Трофимовщина: '83438',
			Трускляй: '83451',
			Тургенево: '83431',
			Турдаково: '83431',
			Уголок: '83458',
			Ударный: '83458',
			Ульянка: '83433',
			Умет: '83458',
			Уришка: '83438',
			Урусово: '83431',
			Ушаковка: '83434',
			Хилково: '83456',
			Хлебино: '83446',
			Хованщина: '83451',
			Хухорево: '83442',
			Центральный: '83456',
			Чамзинка: '83437',
			Чеберчино: '83447',
			Челпаново: '83434',
			Черемишево: '83441',
			Чиндяново: '83447',
			Чудинка: '83454',
			Шаверки: '83443',
			Шигонь: '83432',
			Ширингуши: '83458',
			Шишкеево: '83451',
			Шокша: '83446',
			Шувары: '83432',
			Шугурово: '83436',
			Явас: '83458',
			Ялга: '8342',
			Ямщина: '83449',
			Яндовище: '83449'
		}
	},
	'Республика Северная Осетия — Алания': {
		regionCode: '867',
		cities: {
			'Верхний Згид': '86731',
			'Верхний Фиагдон': '86731',
			'Дарг-Кох': '86735',
			'Дур-Дур': '86733',
			'Карман-Синдзикау': '86733',
			'Нижний Зарамаг': '86731',
			'Нижний Ларс': '8672',
			'Нижний Унал': '86731',
			'Новая Саниба': '86738',
			'Новый Батако': '86737',
			'Новый Урух': '86734',
			'Средний Урух': '86734',
			'Ставд-Дурта': '86735',
			'Стур-Дигора': '86734',
			'Сурх-Дигора': '86734',
			Алагир: '86731',
			Алханчурт: '86738',
			Ардон: '86732',
			Арсарисар: '86734',
			Архонская: '86739',
			Балта: '8672',
			Батако: '86737',
			Бекан: '86732',
			Беслан: '86737',
			Бирагзанг: '86731',
			Брут: '86737',
			Бурон: '86731',
			Веселовское: '86736',
			Виноградное: '86736',
			Владикавказ: '8672',
			Галиат: '86734',
			Гизель: '86738',
			Даргавс: '86738',
			Дачное: '86738',
			Дзинага: '86734',
			Дзуарикау: '86731',
			Дигора: '86733',
			Заводской: '8672',
			Заманкул: '86737',
			Зилга: '86737',
			Змейская: '86735',
			Иран: '86735',
			Кадгарон: '86732',
			Калининский: '86736',
			Камбилеевское: '86738',
			Карджин: '86735',
			Кармадон: '86738',
			Киевское: '86736',
			Кизляр: '86736',
			Кирово: '86732',
			Кобан: '86738',
			Комарово: '86736',
			Комгарон: '86738',
			Комсомольское: '86735',
			Коста: '86732',
			Красногор: '86732',
			Лескен: '86734',
			Луковская: '86736',
			Майрамадаг: '86731',
			Майский: '86738',
			Майское: '86738',
			Малгобек: '86736',
			Махческ: '86734',
			Мацута: '86734',
			Мизур: '86731',
			Михайловское: '86738',
			Мичурино: '86732',
			Моздок: '86736',
			Мостиздах: '86733',
			Нарт: '86732',
			Николаевская: '86733',
			Новогеоргиевское: '86736',
			Новоосетинская: '86736',
			Ногир: '86738',
			Ногкау: '86731',
			Нузал: '86731',
			Октябрьское: '86738',
			Ольгинское: '86737',
			Павлодольская: '86736',
			Первомайский: '8672',
			Предгорное: '86736',
			Притеречный: '86736',
			Раздзог: '86737',
			Раздольное: '86736',
			Рамоново: '86731',
			Рассвет: '86732',
			Садовый: '86736',
			Садон: '86731',
			Советский: '86734',
			Суадаг: '86731',
			Сунжа: '86738',
			Сухотское: '86736',
			Тамиск: '86731',
			Тарское: '86738',
			Тельман: '86736',
			Терская: '86736',
			Толдзгун: '86734',
			Троицкое: '86736',
			Урсдон: '86733',
			Фарн: '86737',
			Фаснал: '86734',
			Фиагдон: '86732',
			Хазнидон: '86734',
			Хаталдон: '86731',
			Холст: '86731',
			Хумалаг: '86737',
			Хурикау: '86736',
			Цалык: '86737',
			Цей: '86731',
			Црау: '86731',
			Чермен: '86738',
			Чернореченское: '8672',
			Черноярская: '86736',
			Чикола: '86734',
			Чми: '8672',
			Эльхотово: '86735'
		}
	},
	'Республика Татарстан': {
		regionCode: ['843', '855'],
		cities: {
			'Адав-Тулумбаево': '84374',
			'Алан-Бексер': '84365',
			'Алан-Полян': '84361',
			'Алекина Поляна': '84373',
			'Александровская Слобода': '85558',
			'Алешкин Саплык': '84375',
			'Арбузов Баран': '84341',
			'Бавлинский Совхоз': '85569',
			'Багряж-Никольское': '8553',
			'Базарные Матаки': '84346',
			'Байряка-Тамак': '85593',
			'Балыклы-Чукаево': '84361',
			'Беркет Ключ': '84396',
			'Бик-Утеево': '84374',
			'Биляр-Озеро': '84345',
			'Бирюлинский Зверосовхоз': '84365',
			'Биш-Мунча': '8553',
			'Богатые Сабы': '84362',
			'Большая Акса': '84375',
			'Большая Атня': '84369',
			'Большая Елга': '84361',
			'Большая Карланга': '84374',
			'Большая Качка': '85557',
			'Большая Кульга': '84361',
			'Большая Меша': '84360',
			'Большая Турма': '84373',
			'Большая Цильна': '84375',
			'Большая Янгасала': '84377',
			'Большие Армалы': '85557',
			'Большие Атряси': '84373',
			'Большие Ачасыры': '84371',
			'Большие Берези': '84369',
			'Большие Буртасы': '84377',
			'Большие Кабаны': '84378',
			'Большие Кайбицы': '84370',
			'Большие Кармалы': '84377',
			'Большие Кибячи': '84362',
			'Большие Ключи': '84371',
			'Большие Кляри': '84377',
			'Большие Кокузы': '84376',
			'Большие Кургузи': '84371',
			'Большие Меми': '84379',
			'Большие Метески': '84360',
			'Большие Нырсы': '84360',
			'Большие Нырты': '84362',
			'Большие Полянки': '84341',
			'Большие Салтыки': '84377',
			'Большие Тарханы': '84373',
			'Большие Тиганы': '84341',
			'Большие Ширданы': '84371',
			'Большое Афанасово': '8555',
			'Большое Елово': '85557',
			'Большое Нуркеево': '85559',
			'Большое Подберезье': '84370',
			'Большое Русаково': '84370',
			'Большое Фролово': '84374',
			'Большое Ходяшево': '84371',
			'Большое Шемякино': '84373',
			'Большой Битаман': '84365',
			'Большой Менгер': '84369',
			'Большой Ошняк': '84361',
			'Большой Салтан': '84361',
			'Большой Сухояш': '85592',
			'Большой Толкиш': '84342',
			'Большой Чекмак': '85556',
			'Большой Шинар': '84362',
			'Большой Шурняк': '85557',
			'Булым-Булыхчи': '84376',
			'Варяш-Баш': '85556',
			'Введенская Слобода': '84379',
			'Верхнее Аткозино': '84376',
			'Верхнее Колчурино': '84341',
			'Верхнее Стярле': '85592',
			'Верхнее Яхшеево': '85552',
			'Верхние Кибя-Кози': '84360',
			'Верхние Лащи': '84374',
			'Верхние Челны': '8555',
			'Верхние Чершилы': '85559',
			'Верхние Шипки': '85558',
			'Верхний Акташ': '8553',
			'Верхний Индырчи': '84376',
			'Верхний Налим': '85558',
			'Верхний Субаш': '84368',
			'Верхний Такермен': '85555',
			'Верхний Тимерлек': '84361',
			'Верхний Услон': '84379',
			'Верхний Шубан': '84368',
			'Верхняя Баланда': '84344',
			'Верхняя Каменка': '84396',
			'Верхняя Ошма': '85563',
			'Верхняя Серда': '84369',
			'Верхняя Сунь': '85563',
			'Верхняя Татарская Майна': '84341',
			'Верхняя Уратьма': '8555',
			'Верхняя Фоминовка': '85569',
			'Вишневая Поляна': '84345',
			'Вольный Стан': '84374',
			'Высокая Гора': '84365',
			'Галактионова им.Совхоз': '84342',
			'Дурт-Мунча': '85558',
			'Дым-Дюм': '85557',
			'Дым-Тамак': '85593',
			'Зай-Каратай': '85595',
			'Иж Борискино': '84347',
			'Иж-Бобья': '85551',
			'Иске-Рязап': '84347',
			'Иске-Юрт': '84367',
			'Казан-Баш': '84366',
			'Какре-Елга': '85592',
			'Кама-Исмагилово': '8553',
			'Камские Поляны': '8555',
			'Камское Устье': '84377',
			'Караульная Гора': '84345',
			'Карашай Саклово': '85559',
			'Кемеш-Куль': '85563',
			'Кзыл-Тау': '84376',
			'Кзыл-Яр': '85569',
			'Ким Совхоз': '84347',
			'Кирова им.Совхоз': '85552',
			'Коминтерн Совхоз': '84347',
			'Кошки-Новотимбаево': '84373',
			'Красная Горка': '85563',
			'Красная Кадка': '8555',
			'Красная Слобода': '84347',
			'Красный Бор': '85551',
			'Красный Вал': '84347',
			'Красный Ключ': '8555',
			'Красный Яр': '84342',
			'Крутая Гора': '84342',
			'Крым-Сарай': '85569',
			'Кряш-Серда': '84367',
			'Кряш-Шуран': '85556',
			'Куйбышевский Затон': '84377',
			'Кулле-Киме': '84369',
			'Кульбаево-Мараса': '84345',
			'Кутлу-Букаш': '84361',
			'Ленино-Кокушкино': '84367',
			'Лешев-Тамак': '85559',
			'Малая Бугульма': '85594',
			'Малая Елга': '84378',
			'Малая Сунь': '85563',
			'Малая Цильна': '84375',
			'Малая Шильна': '8552',
			'Малые Болгояры': '84376',
			'Малые Кирмени': '85563',
			'Малые Лызи': '84368',
			'Малые Меми': '84370',
			'Малые Салтыки': '84377',
			'Малые Уруссу': '85593',
			'Малый Красный Яр': '84341',
			'Малый Толкиш': '84342',
			'Мари-Булярово': '85556',
			'Мелля-Тамак': '85556',
			'Мичурина им.': '85595',
			'Мокрая Савалеевка': '84374',
			'Мокрые Курнали': '84341',
			'Мордовская Кармалка': '85595',
			'Мордовское Афонькино': '84396',
			'Муртыш-Тамак': '85559',
			'Мусабай-Завод': '8552',
			'Набережные Моркваши': '84379',
			'Набережные Челны': '8552',
			'Наратлы-Кичу': '85555',
			'Нижнее Алькеево': '84341',
			'Нижнее Бишево': '85558',
			'Нижнее Качеево': '84341',
			'Нижнее Кучуково': '85551',
			'Нижнее Чекурское': '84375',
			'Нижние Вязовые': '84371',
			'Нижние Ураспуги': '84371',
			'Нижние Челны': '84345',
			'Нижние Чершилы': '85595',
			'Нижние Шитцы': '84362',
			'Нижние Яки': '85563',
			'Нижний Искубаш': '84364',
			'Нижний Каракитан': '84375',
			'Нижний Наратбаш': '84374',
			'Нижний Табын': '85556',
			'Нижний Таканыш': '85563',
			'Нижний Услон': '84379',
			'Нижняя Береске': '84369',
			'Нижняя Каменка': '84396',
			'Нижняя Кармалка': '84396',
			'Нижняя Кня': '84368',
			'Нижняя Кондрата': '84342',
			'Нижняя Мактама': '8553',
			'Нижняя Ошма': '85563',
			'Нижняя Русь': '84364',
			'Нижняя Сосна': '84368',
			'Нижняя Сунь': '85563',
			'Нижняя Уратьма': '8555',
			'Нижняя Чегодайка': '84396',
			'Новая Александровка': '85594',
			'Новая Амзя': '84345',
			'Новая Мурзиха': '85557',
			'Новая Тумба': '84345',
			'Новое Аксубаево': '84344',
			'Новое Алимово': '85552',
			'Новое Демкино': '84344',
			'Новое Ибрайкино': '84344',
			'Новое Иглайкино': '84345',
			'Новое Ильмово': '84396',
			'Новое Кадеево': '84396',
			'Новое Каширово': '8553',
			'Новое Курмашево': '85552',
			'Новое Мазино': '85555',
			'Новое Надырово': '8553',
			'Новое Русское Маматкозино': '84379',
			'Новое Сумароково': '85594',
			'Новое Тимошкино': '84344',
			'Новое Узеево': '84344',
			'Новые Ишли': '84375',
			'Новые Тинчали': '84374',
			'Новые Усы': '85556',
			'Новые Чечкабы': '84374',
			'Новые Чути': '84371',
			'Новые Шалты': '84371',
			'Новые Шаши': '84369',
			'Новый Арыш': '84361',
			'Новый Баран': '84347',
			'Новый Иштеряк': '85595',
			'Новый Кинерь': '84366',
			'Новый Кишит': '84366',
			'Новый Кумазан': '85563',
			'Новый Яваш': '84366',
			'Ныртинский Совхоз': '84364',
			'Отар-Дубровка': '84367',
			'Песчаные Ковали': '84378',
			'Петровский Завод': '85559',
			'Подгорный Байлар': '85555',
			'Подлесная Шентала': '84341',
			'Покровский Урустамак': '85569',
			'Потапово-Тумбарла': '85569',
			'Починок-Cутер': '84364',
			'Починок-Кучук': '84364',
			'Пролей-Каши': '84373',
			'Пустые Моркваши': '84379',
			'Пятилетка Совхоз': '85563',
			'Русская Киреметь': '84344',
			'Русские Шибаши': '84341',
			'Русский Акташ': '8553',
			'Русский Ошняк': '84361',
			'Русский Шуган': '85556',
			'Русское Азелеево': '84371',
			'Русское Богдашкино': '84345',
			'Русское Макулово': '84379',
			'Рыбная Слобода': '84361',
			'Сабы-Лесхоз': '84362',
			'Саклов-Баш': '85559',
			'Салауз-Мухан': '85556',
			'Сардек-Баш': '84364',
			'Сармаш-Баш': '85558',
			'Сарсак-Омга': '85551',
			'Светлое Озеро': '85558',
			'Слобода-Архангельская': '84348',
			'Слобода-Волчья': '84348',
			'Слобода-Екатерининская': '84348',
			'Слобода-Петропавловская': '84348',
			'Слобода-Черемуховая': '84348',
			'Совхоз-Техникум': '85555',
			'Солдатская Письмянка': '85594',
			'Сорок-Сайдак': '84374',
			'Среднее Балтаево': '84376',
			'Среднее Девятово': '84378',
			'Средние Аты': '84366',
			'Средние Кирмени': '85563',
			'Средние Пинячи': '85558',
			'Средние Тиганы': '84341',
			'Средний Багряж': '85558',
			'Средний Кукмор': '84364',
			'Средний Кушкет': '84368',
			'Средний Юрткуль': '84347',
			'Средняя Камышла': '84345',
			'Средняя Корса': '84366',
			'Средняя Серда': '84366',
			'Старая Александровка': '85555',
			'Старая Икшурма': '84362',
			'Старая Киреметь': '84344',
			'Старая Масра': '84366',
			'Старая Матвеевка': '85555',
			'Старая Михайловка': '8553',
			'Старая Письмянка': '85595',
			'Старая Пристань': '84378',
			'Старая Салаусь': '84368',
			'Старая Хурада': '84341',
			'Старая Чекалда': '85551',
			'Старая Юмья': '84364',
			'Старое Абдулово': '8552',
			'Старое Алпарово': '84341',
			'Старое Барышево': '84377',
			'Старое Бейсарово': '85552',
			'Старое Гришкино': '85549',
			'Старое Дрожжаное': '84375',
			'Старое Иванаево': '84342',
			'Старое Ильмово': '84396',
			'Старое Исаково': '85594',
			'Старое Кадеево': '84396',
			'Старое Калейкино': '8553',
			'Старое Камкино': '84341',
			'Старое Курмашево': '85552',
			'Старое Мазино': '85555',
			'Старое Мокшино': '84344',
			'Старое Ромашкино': '84342',
			'Старое Сляково': '85551',
			'Старое Суркино': '8553',
			'Старое Тимошкино': '84344',
			'Старое Тлякеево': '85552',
			'Старое Тябердино': '84370',
			'Старое Узеево': '84344',
			'Старое Чурилино': '84366',
			'Старое Шаймурзино': '84375',
			'Старое Шигалеево': '84367',
			'Старорусское Альметьево': '84345',
			'Старые Бугады': '85552',
			'Старые Зюри': '84360',
			'Старые Какерли': '84375',
			'Старые Карамалы': '85556',
			'Старые Кутуши': '84396',
			'Старые Матаки': '84341',
			'Старые Салманы': '84341',
			'Старые Тинчали': '84374',
			'Старые Уруссы': '85593',
			'Старые Урьяды': '85552',
			'Старые Челны': '84345',
			'Старые Чукалы': '84375',
			'Старый Ашит': '84366',
			'Старый Багряж-Елхово': '8553',
			'Старый Дрюш': '8552',
			'Старый Иркеняш': '85555',
			'Старый Иштеряк': '85595',
			'Старый Кашир': '85559',
			'Старый Куак': '85595',
			'Старый Куклюк': '85557',
			'Старый Кырлай': '84366',
			'Старый Мелькен': '85555',
			'Старый Мензелябаш': '85559',
			'Старый Мичань': '84362',
			'Старый Студенец': '84374',
			'Старый Татарский Адам': '84344',
			'Старый Токмак': '85558',
			'Старый Утямыш': '84396',
			'Старый Юмралы': '84376',
			'Старый Юраш': '85557',
			'Степное Озеро': '84345',
			'Сухие Курнали': '84341',
			'Табар-Черки': '84376',
			'Татарская Багана': '84342',
			'Татарская Беденьга': '84373',
			'Татарская Бездна': '84375',
			'Татарская Дымская': '85594',
			'Татарская Суксы': '85552',
			'Татарская Тумбарла': '85569',
			'Татарские Саралы': '84378',
			'Татарские Челны': '85549',
			'Татарские Шатрашаны': '84375',
			'Татарские Ямалы': '85552',
			'Татарский Елтан': '84342',
			'Татарский Кандыз': '85569',
			'Татарский Толкиш': '84342',
			'Татарский Шуган': '85592',
			'Татарский Янтык': '84378',
			'Татарское Адельшино': '84342',
			'Татарское Ахметьево': '84341',
			'Татарское Булярово': '85556',
			'Татарское Бурнашево': '84379',
			'Татарское Танаево': '84371',
			'Татарское Утяшкино': '84348',
			'Татарское Ходяшево': '84367',
			'Татарстан Совхоз': '8552',
			'Ташлы-Ковали': '84365',
			'Тлянче-Тамак': '8552',
			'Три Озера': '84347',
			'Троицкий Урай': '84361',
			'Туктарово Урдала': '85595',
			'Тюрясевский Совхоз': '84345',
			'Удельное Нечасово': '84373',
			'Уреево-Челны': '84361',
			'Утар-Аты': '84366',
			'Хорновар Шигали': '84375',
			'Черки-Гришино': '84374',
			'Черки-Кульдуразы': '84374',
			'Чистопольские Выселки': '84342',
			'Чистопольский Зверосовхоз': '84342',
			'Чубар-Абдуллово': '85592',
			'Чувашская Майна': '84341',
			'Чувашская Чебоксарка': '84348',
			'Чувашские Кищаки': '84374',
			'Чувашский Елтан': '84342',
			'Чувашский Тимерлек': '84345',
			'Чувашское Бурнаево': '84341',
			'Чувашское Дрожжаное': '84375',
			'Чувашское Шапкино': '84341',
			'Чура-Село': '84364',
			'Чуру-Барышево': '84376',
			'Шешминская Крепость': '84396',
			'Янга-Аул': '85551',
			'Янга-Буляк': '8552',
			'Ятмас-Дусай': '84364',
			'деревня Камаево': '84365',
			'село Кутлушкино': '84342',
			'село Черемшан': '84396',
			'село Шамбулыхчи': '84376',
			Абалачи: '85549',
			Абди: '84360',
			Абдрахманово: '8553',
			Абсалямово: '85593',
			Агерзе: '85592',
			Аграмаковка: '84347',
			Агрыз: '85551',
			Азалаково: '85559',
			Азеево: '84348',
			Азнакаево: '85592',
			Аишево: '85552',
			Айбаш: '84365',
			Айдарово: '84360',
			Айша: '84371',
			Акзигитово: '84371',
			Аккузово: '85552',
			Аксарино: '85558',
			Аксу: '84374',
			Аксубаево: '84344',
			Актаныш: '85552',
			Актюбинский: '85592',
			Алабердино: '84373',
			Алан: '84360',
			Алаты: '84365',
			Албаево: '85563',
			Александровка: '85559',
			Алексеевка: '85569',
			Алексеевское: '84341',
			Альдермыш: '84365',
			Альметьевск: '8553',
			Альшеево: '84374',
			Альшихово: '84374',
			Амикеево: '85556',
			Анатыш: '84361',
			Андреевка: '84345',
			Антоновка: '84347',
			Апазово: '84366',
			Апастово: '84376',
			Арбор: '84368',
			Арск: '84366',
			Асеево: '85592',
			Атабаево: '84378',
			Атрякле: '85555',
			Атясево: '85552',
			Аю: '85555',
			Бавлы: '85569',
			Багаево: '84370',
			Базяково: '84341',
			Байрашево: '84373',
			Байряка: '85593',
			Бакирово: '85595',
			Бакрче: '84376',
			Бакрчи: '84373',
			Баландыш: '84360',
			Баланны: '85556',
			Балтаси: '84368',
			Балтачево: '84377',
			Баюково: '85556',
			Бегишево: '85558',
			Белкино: '84367',
			Березки: '84365',
			Берлибаш: '84370',
			Берсут: '85563',
			Бетьки: '8552',
			Бехтерево: '85557',
			Бизяки: '85549',
			Бикасаз: '8553',
			Бикбулово: '85555',
			Биклян: '8552',
			Биляр: '84341',
			Билярск: '84341',
			Бима: '85551',
			Бишня: '84371',
			Биюрган: '8552',
			Благодатная: '8555',
			Богородское: '84367',
			Болгар: '84347',
			Болгары: '84347',
			Борискино: '8553',
			Бугульма: '85594',
			Буинск: '84374',
			Булгары: '84347',
			Булдырь: '84342',
			Буралы: '85592',
			Бурбаш: '84368',
			Бурды: '8552',
			Бурметьево: '84345',
			Бурнак: '84368',
			Бурнашево: '84376',
			Бурундуки: '84370',
			Бутаиха: '84345',
			Бутлеровка: '84341',
			Бухарай: '85558',
			Бюрганы: '84374',
			Варварино: '84377',
			Васильевка: '8553',
			Васильево: '84371',
			Вахитово: '85563',
			Венета: '84366',
			Владимирово: '85563',
			Водников: '84342',
			Вожи: '84347',
			Володарский: '8555',
			Габишево: '84378',
			Гайтанкино: '84345',
			Гари: '84371',
			Гарь: '84365',
			Глазово: '85595',
			Городище: '84375',
			Девликеево: '84376',
			Девятерня: '85551',
			Державино: '84378',
			Деуково: '85555',
			Деушево: '84376',
			Джалиль: '85559',
			Дигитли: '85563',
			Дружба: '85563',
			Дубъязы: '84365',
			Дурга: '84368',
			Дюсметьево: '85563',
			Егоркино: '84345',
			Елабуга: '85557',
			Елантово: '8555',
			Елаур: '84345',
			Емелькино: '84344',
			Емельяново: '84378',
			Ерепкино: '84345',
			Ерыкла: '84341',
			Ерыклы: '84348',
			Жуково: '84373',
			Заинск: '85558',
			Заречный: '84345',
			Зверосовхоз: '85563',
			Зеленодольск: '84371',
			Зирекле: '84348',
			Зубаирово: '85552',
			Зюри: '85563',
			Ивановка: '85595',
			Ивашкино: '84396',
			Ижевка: '85549',
			Изгары: '84342',
			Изма: '84362',
			Измери: '84347',
			Ильбухтино: '8552',
			Илюткино: '84345',
			Иляксаз: '85559',
			Именьково: '84378',
			Ирекле: '85592',
			Исенбаево: '85551',
			Исергапово: '85569',
			Исляйкино: '84342',
			Ишкеево: '85563',
			Иштеряково: '8552',
			Кавзияково: '85559',
			Кадряково: '85555',
			Кадыбаш: '85551',
			Кадырово: '85558',
			Кадышево: '84365',
			Каенлы: '8555',
			Казаклар: '84365',
			Казанка: '84396',
			Казань: '843',
			Казкеево: '85552',
			Каинки: '84379',
			Каипы: '84378',
			Калейкино: '8553',
			Камаево: '85549',
			Канаш: '84379',
			Карабаш: '85594',
			Карадуван: '84368',
			Каразирек: '85593',
			Каракашлы: '85593',
			Карамалы: '85592',
			Караталга: '84377',
			Каратун: '84376',
			Каргали: '84342',
			Каргаполь: '84341',
			Каркали: '85595',
			Кармалка: '85558',
			Кармалы: '8555',
			Катмыш: '85563',
			Качелино: '84366',
			Качкиново: '85552',
			Кашка: '84373',
			Керлигач: '85595',
			Кибячи: '84367',
			Кильдебяк: '84362',
			Кильдеево: '84379',
			Кильдешево: '84373',
			Кильдуразы: '84376',
			Кирби: '84378',
			Кирельское: '84377',
			Киртели: '84373',
			Кительга: '8553',
			Кичкальня: '84345',
			Кичкетан: '85551',
			Кичуй: '8553',
			Кият: '84374',
			Климентейкино: '8553',
			Ключи: '85594',
			Клянчеево: '84377',
			Клянчино: '84379',
			Кляуш: '85563',
			Кляшево: '84373',
			Ковали: '84367',
			Кожаевка: '84347',
			Комсомолец: '8552',
			Комургузя: '84369',
			Коноваловка: '85555',
			Коногоровка: '85594',
			Константиновка: '84365',
			Конь: '84367',
			Коргуза: '84379',
			Корноухово: '84361',
			Корсабаш: '84362',
			Костенеево: '85557',
			Кощаково: '84367',
			Красновидово: '84377',
			Кривоозерки: '84344',
			Крынды: '85551',
			Куакбаш: '85595',
			Кубассы: '84342',
			Кубян: '84369',
			Кугарчино: '84361',
			Кугеево: '84371',
			Кугунур: '84368',
			Кугушево: '84371',
			Кудашево: '85594',
			Кузайкино: '8553',
			Кузембетьево: '85555',
			Кузкеево: '8552',
			Кузнечиха: '84347',
			Кузякино: '85552',
			Кукмор: '84364',
			Кулаево: '84367',
			Куланга: '84370',
			Кулегаш: '85551',
			Кульшарипово: '8553',
			Кунгер: '84369',
			Куралово: '84347',
			Куркачи: '84365',
			Куркуль: '84341',
			Курманаево: '84345',
			Курмыш: '84345',
			Кутема: '84396',
			Кутемели: '85559',
			Кутлушкино: '84342',
			Кушманы: '84370',
			Кшклово: '84369',
			Лаишево: '84378',
			Лашманка: '84396',
			Лебедино: '84341',
			Левашово: '84341',
			Лекарево: '85557',
			Ленино: '84348',
			Лениногорск: '85595',
			Лощи: '84374',
			Лубяны: '84364',
			Льяшево: '84373',
			Ляки: '85559',
			Майдан: '84379',
			Макаровка: '84378',
			Малмыжка: '85563',
			Мальгабушево: '85592',
			Малькеево: '84370',
			Мамадыш: '85563',
			Мамашир: '84364',
			Маметьево: '8553',
			Мамыково: '84345',
			Маскара: '84364',
			Масловка: '84361',
			Масягутово: '85592',
			Матаки: '84375',
			Матюшино: '84379',
			Мелекес: '8552',
			Мемдель: '84365',
			Менделеевск: '85549',
			Мендюш: '84366',
			Мензелинск: '85555',
			Мизиново: '84371',
			Микулино: '85592',
			Миннибаево: '8553',
			Михайловка: '85556',
			Молвино: '84371',
			Монастырское: '84373',
			Монашево: '85549',
			Морты: '85557',
			Мульма: '84365',
			Муртаза: '85569',
			Муслюмкино: '84342',
			Муслюмово: '85556',
			Надеждино: '84367',
			Наласа: '84366',
			Наратлы: '85594',
			Нармонка: '84378',
			Нижнекамск: '8555',
			Никифорово: '85563',
			Николаевка: '85555',
			Никольское: '84347',
			Новоникольск: '8553',
			Новоспасск: '85558',
			Новочершилинский: '85595',
			Новошешминск: '84348',
			Новый: '8552',
			Нуринер: '84368',
			Нурлат: '84345',
			Нурма: '84368',
			Нуса: '84366',
			Нырья: '84364',
			Обсерватория: '84371',
			Октябрь: '85556',
			Октябрьский: '84379',
			Омары: '85563',
			Орел: '84378',
			Отрада: '84347',
			Пановка: '84367',
			Пелево: '84378',
			Пермяки: '84365',
			Пестрецы: '84367',
			Петровка: '85594',
			Петровский: '84378',
			Печищи: '84379',
			Пижмар: '84368',
			Пимери: '84367',
			Подгорный: '85594',
			Поисево: '85552',
			Покровка: '85557',
			Полянки: '84347',
			Поповка: '85569',
			Поспелово: '85557',
			Приволжский: '84347',
			Прости: '8555',
			Псеево: '85549',
			Псяк: '84364',
			Раифа: '84371',
			Рангазар: '85559',
			Речное: '84341',
			Родники: '84341',
			Рождественно: '84378',
			Ромодан: '84341',
			Ростовка: '85594',
			Рунга: '84374',
			Савалеево: '85558',
			Салауши: '85551',
			Салмачи: '84367',
			Сапеево: '85592',
			Сарабикулово: '85595',
			Сарлы: '85592',
			Сарманово: '85559',
			Сатламышево: '84376',
			Сатышево: '84362',
			Сафарово: '85552',
			Сахаровка: '84341',
			Свияжск: '84379',
			Секинесь: '85563',
			Селенгуши: '84345',
			Семекеево: '8552',
			Семиозерка: '84365',
			Семяково: '85556',
			Сиза: '84366',
			Сикертан: '84366',
			Сихтерма: '84341',
			Смаиль: '84368',
			Соболевское: '84379',
			Соколка: '85563',
			Сокуры: '84378',
			Спасское: '85594',
			Старошешминск: '8555',
			Столбище: '84378',
			Сугушла: '85595',
			Суксу: '84365',
			Сулеево: '8553',
			Сунчелеево: '84344',
			Сухарево: '8555',
			Сюкеево: 'м',
			Сюндюково: '84373',
			Сюрда: '84366',
			Табарли: '85551',
			Тавели: '85563',
			Такталачук: '85552',
			Танайка: '85557',
			Ташкичу: '84366',
			Теньки: '84377',
			Терси: '85551',
			Тетюши: '84373',
			Тимбаево: '84374',
			Тимершик: '84362',
			Тимяшево: '85595',
			Тихоново: '85549',
			Тогашево: '84367',
			Тойгильдино: '85556',
			Трудовой: '8555',
			Трудолюбово: '84344',
			Туембаш: '84364',
			Тумутук: '85592',
			Тюгеевка: '85558',
			Тюлячи: '84360',
			Тюнтер: '84368',
			Убей: '84375',
			Узяк: '84360',
			Улиманово: '85552',
			Ульянково: '84370',
			Ульяновка: '84396',
			Уразбахтино: '85563',
			Уразлино: '84377',
			Уразметьево: '85556',
			Уракча: '84342',
			Урахча: '84361',
			Урманаево: '85592',
			Урмандеево: '84344',
			Урмышла: '85595',
			Урняк: '84366',
			Урсаево: '85592',
			Урсала: '8553',
			Урусово: '85555',
			Уруссу: '85593',
			Урюм: '84373',
			Усады: '84365',
			Усали: '85563',
			Утяково: '84371',
			Учалле: '85592',
			Учили: '84366',
			Федоровское: '84370',
			Федотовка: '85595',
			Фомкино: '84345',
			Хасаншаих: '84366',
			Хозесаново: '84370',
			Ципья: '84368',
			Чалманарат: '85552',
			Чалпы: '85592',
			Чапшар: '84368',
			Чарлы: '84364',
			Чекан: '85592',
			Чемодурово: '85592',
			Чепчуги: '84365',
			Черемшан: '84396',
			Чернышев: '84365',
			Четырчи: '84342',
			Чинчурино: '84373',
			Чистополь: '84342',
			Чита: '84367',
			Чубуклы: '85558',
			Чувашли: '84365',
			Чукмарлы: '85559',
			Чулпаново: '84345',
			Чупаево: '8553',
			Чуракаево: '85552',
			Чутеево: '84370',
			Шадки: '84360',
			Шадчи: '85563',
			Шали: '84367',
			Шама: '84341',
			Шапши: '84365',
			Шармаши: '84360',
			Шаршада: '85551',
			Шахмайкино: '84348',
			Шеланга: '84379',
			Шемордан: '84362',
			Шереметьевка: '8555',
			Шикша: '84362',
			Шилькебаш: '8552',
			Шингальчи: '8555',
			Шишинер: '84368',
			Шланга: '84375',
			Шуганка: '85556',
			Шугурово: '85595',
			Шукрали: '8552',
			Шуман: '84365',
			Шумбут: '84361',
			Шумково: '84361',
			Шурабаш: '84366',
			Шуран: '84378',
			Шушмабаш: '84366',
			Щербень: '84344',
			Эбалаково: '84376',
			Энтуганы: '84374',
			Юлбат: '84362',
			Юлдуз: '84342',
			Юлсубино: '84361',
			Ютаза: '85593',
			Юхмачи: '84341',
			Ядыгерь: '84364',
			Яковлево: '85557',
			Якушкино: '84345',
			Ялкын: '84341',
			Ямаши: '8553',
			Ямашурма: '84365',
			Ямбухтино: '84347',
			Ямурзино: '85551',
			Янасала: '84366',
			Янгулово: '84368',
			Янурусово: '85559',
			Янцевары: '84367',
			Яныль: '84364',
			Яшевка: '84374'
		}
	},
	'Республика Тыва': {
		regionCode: '394',
		cities: {
			'Адыр-Кежиг': '39450',
			'Ак-Довурак': '39433',
			'Ак-Туруг': '39436',
			'Аксы-Барлык': '39433',
			'Алдан-Маадыр': '39445',
			'Арыг-Бажи': '39436',
			'Арыг-Узуу': '39436',
			'Бажин-Алаак': '39434',
			'Бай-Даг': '39439',
			'Бай-Тал': '39442',
			'Бай-Хаак': '39437',
			'Баян-Кол': '39422',
			'Баян-Тала': '39434',
			'Бора-Тайга': '39445',
			'Булун-Бажи': '39439',
			'Булун-Терек': '39436',
			'Дон-Терезин': '39433',
			'Каа-Хем': '39422',
			'Кара-Хаак': '39422',
			'Кара-Холь': '39442',
			'Кызыл-Даг': '39442',
			'Кызыл-Мажалык': '39441',
			'Кызыл-Мажалыкский': '39433',
			'Мугур-Аксы': '39451',
			'Сарыг-Сеп': '39432',
			'Суг-Аксы': '39445',
			'Сут-Холь': '39445',
			'Сыстыг-Хем': '39450',
			'Теве-Хая': '39434',
			'Терлиг-Хая': '39422',
			'Тоора-Хем': '39450',
			'Усть-Элегест': '39422',
			'Хову-Аксы': '39452',
			'Чаа-Холь': '39443',
			'Чаа-холь': '39436',
			'Чыра-Бажи': '39434',
			'Эрги-Барлик': '39433',
			Аржаан: '39435',
			Арыскан: '39436',
			Аянгаты: '39433',
			Балгазын: '39437',
			Барлык: '39433',
			Дурген: '39437',
			Ий: '39450',
			Ийме: '39434',
			Ишкин: '39445',
			Кочетово: '39437',
			Kочетово: '39437',
			Кызыл: '39422',
			Межегей: '39437',
			Морен: '39439',
			Нарын: '39439',
			Самагалтай: '39438',
			Севи: '39435',
			Сосновка: '39437',
			Сукпак: '39422',
			Суш: '39435',
			Торгалыг: '39436',
			Туран: '39435',
			Тээли: '39442',
			Успенка: '39437',
			Уюк: '39435',
			Хадын: '39435',
			Хайыракан: '39436',
			Хамсара: '39450',
			Хандагайты: '39444',
			Хондергей: '39434',
			Целинное: '39422',
			Чадан: '39434',
			Черби: '39422',
			Чодураа: '39436',
			Шагонар: '39436',
			Шамбалык: '39422',
			Шекспээр: '39433',
			Шеми: '39434',
			Шивилиг: '39435',
			Шуй: '39442',
			Эрзин: '39439'
		}
	},
	'Удмуртская Республика': {
		regionCode: '341',
		cities: {
			'Асановский с/х техникум': '34150',
			'Баграш-Бигра': '34138',
			'Бобья-Уча': '34138',
			'Большая Кибья': '34139',
			'Большая Кивара': '34145',
			'Большая Можга': '34155',
			'Большая Пудга': '34139',
			'Большая Сюга': '34139',
			'Большая Уча': '34139',
			'Большие Ошворцы': '34162',
			'Большое Волково': '34155',
			'Большой Жужгес': '34130',
			'Большой Зетым': '34151',
			'Большой Олып': '34158',
			'Большой Селег': '34164',
			'Вавож ': '34155',
			'Варзи-Ятчи': '34150',
			'Верх-Люкино': '34166',
			'Верх-Уни': '34161',
			'Верхне Позимь': '34145',
			'Верхние Юри': '34139',
			'Верхний Бемыж': '34154',
			'Верхний Четкер': '34151',
			'Верхняя Богатырка': '34141',
			'Верхняя Игра': '34163',
			'Верхняя Слудка': '34141',
			'Верхняя Талица': '34145',
			'Верхняя Тыжма': '34154',
			'Головизнин Язок': '34159',
			'Заречная Медла': '34151',
			'Заречный Вишур': '34136',
			'Зяглуд-Какся': '34155',
			'Каменное Заделье': '34166',
			'Карамас-Пельга': '34133',
			'Кипрята,Сергино': '34166',
			'Крымская Слудка': '34154',
			'Лолошур-Возжи': '34163',
			'Лонки Ворцы': '34134',
			'Малая Воложикья': '34139',
			'Малая Пурга': '34138',
			'Малая Сюга': '34139',
			'Малые Калмаши': '34132',
			'Малый Вениж': '34161',
			'Мари-Возжай': '34163',
			'Можга Село': '34139',
			'Муркозь-Омга': '34154',
			'Нижнее Котнырево': '34150',
			'Нижние Кивары': '34136',
			'Нижние Юри': '34138',
			'Нижний Армязь': '34153',
			'Нижняя Пыхта': '34151',
			'Новая Бия': '34155',
			'Новая Казмаска': '3412',
			'Новая Монья': '34159',
			'Новые Зятцы': '34134',
			'Новый Мултан': '34130',
			'Новый Унтем': '34158',
			'Ныши-Какси': '34139',
			'Нюрдор-Котья': '34155',
			'Поршур-Тукля': '34130',
			'Русская Коса': '34154',
			'Русская Лоза': '34134',
			'Русский Пычас': '34139',
			'Средний Постол': '3412',
			'Старая Бодья': '34154',
			'Старая Гыя': '34158',
			'Старая Монья': '34138',
			'Старая Салья': '34133',
			'Старые Быги': '34136',
			'Старые Зятцы': '34162',
			'Старые Какси': '34139',
			'Старые Ятчи': '34163',
			'Старый Березняк': '34139',
			'Старый Кармыж': '34154',
			'Старый Утчан': '34150',
			'Сям-Можга': '34130',
			'Тыловыл-Пельга': '34155',
			'Ува-Тукля': '34130',
			'Удмурт-Зязьгор': '34158',
			'Удмуртские Ключи': '34141',
			'Удмуртский Сарамак': '34154',
			'Удмуртский Тоймобаш': '34150',
			'Удмуртское Гондырево': '34150',
			'Усть-Сюмси': '34159',
			'Чемошур-Куюк': '34150',
			'Яган-Докья': '34138',
			'Якшур-Бодья': '34162',
			'деревня Гурезь-Пудга': '34155',
			'село Грахово': '34163',
			'село Якшур-Бодья': '34162',
			Адам: '34141',
			Азаматово: '34150',
			Азино: '3412',
			Аксакшур: '34138',
			Алнаши: '34150',
			Андреевцы: '34166',
			Андрейшур: '34166',
			Арзамасцево: '34132',
			Арлеть: '34134',
			Архангельское: '34164',
			Атабаево: '34133',
			Бабино: '3412',
			Байтеряково: '34150',
			Балаки: '34153',
			Балдейка: '34154',
			Балезино: '34166',
			Бачкеево: '34134',
			Бачумово: '34157',
			Баяран: '34157',
			Безменшур: '34154',
			Беляевское: '34134',
			Бемыж: '34154',
			Беркуты: '34145',
			Болгуры: '34145',
			Бородули: '34136',
			Борок: '34153',
			Боярка: '34132',
			Брызгалово: '34155',
			Булай: '34130',
			Быргында: '34132',
			Вавож: '34155',
			Варавай: '34162',
			Вараксино: '3412',
			Васильево: '34154',
			Васильевское: '34164',
			Васькино: '34152',
			Вичурка: '34154',
			Вишур: '34130',
			Водзимонье: '34155',
			Воегурт: '34166',
			Волипельга: '34155',
			Вортчино: '34136',
			Ворца: '34157',
			Воткинск: '34145',
			Вятское: '34132',
			Гавриловка: '34145',
			Галаново: '34132',
			Глазов: '34141',
			Гобгурт: '34159',
			Гольяны: '3412',
			Горняк: '34139',
			Грахово: '34163',
			Гулеково: '34141',
			Гура: '34152',
			Гуртлуд: '34152',
			Гыбдан: '34154',
			Дебы: '34164',
			Дебёсы: '34151',
			Дзякино: '34141',
			Дизьмино: '34157',
			Дмитрошур: '34152',
			Дондыкар: '34141',
			Дулесово: '34147',
			Дырпа: '34158',
			Ежево: '34161',
			Елово: '34157',
			Ермолаево: '34133',
			Ершовка: '34153',
			Жувам: '34161',
			Завьялово: '3412',
			Заречный: '34163',
			Засеково: '34161',
			Золотарево: '34141',
			Зон: '34152',
			Зура: '34134',
			Зюзино: '34136',
			Зюино: '34157',
			Зямбайгурт: '34155',
			Игра: '34134',
			Ижевск: '3412',
			Ильдибаево: '34133',
			Ильинское: '34138',
			Исаково: '34166',
			Италмас: '3412',
			Июльское: '34145',
			Кабалуд: '34158',
			Кабачигурт: '34134',
			Какмож: '34155',
			Кама: '34153',
			Камбарка: '34153',
			Камское: '34145',
			Каракулино: '34132',
			Каркалай: '34130',
			Карсашур: '34136',
			Карсовай: '34166',
			Качкашур: '34141',
			Кварса: '34145',
			Кватчи: '34139',
			Кез: '34158',
			Кекоран: '34162',
			Кельчино: '34145',
			Кестым: '34166',
			Кечево: '34138',
			Кибья: '34154',
			Кигбаево: '34147',
			Кизнер: '34154',
			Кильмезь: '34152',
			Киршонки: '34166',
			Кияик: '3412',
			Киясово: '34133',
			Ключевка: '34152',
			Кожиль: '34141',
			Кокман: '34164',
			Колесниково: '34132',
			Колесур: '34159',
			Копки: '34159',
			Короленко: '34154',
			Котегурт: '34151',
			Котловка: '34163',
			Кочишево: '34141',
			Красногорское: '34164',
			Красное: '34130',
			Кузебаево: '34150',
			Кузьма: '34158',
			Кузьмино: '34157',
			Кукуи: '34145',
			Кулига: '34158',
			Кулюшево: '34132',
			Кулябино: '34130',
			Курегово: '34141',
			Курья: '34164',
			Кучеряново: '34150',
			Кушья: '34134',
			Кыйлуд: '34130',
			Кыква: '34136',
			Лекшур: '34152',
			Ломеслуд: '34139',
			Лудорвай: '3412',
			Лутоха: '34133',
			Лынга: '34162',
			Льнозаводский: '34159',
			Люга: '34139',
			Люкшудья: '3412',
			Люм: '34141',
			Ляльшур: '34136',
			Мазунино: '34147',
			Макарово: '34163',
			Малягурт: '34134',
			Мельниково: '34139',
			Менил: '34134',
			Мещеряково: '34163',
			Михайловка: '34153',
			Мишкино: '34136',
			Можга: '34139',
			Мосеево: '34157',
			Мостовое: '34147',
			Муважи: '34150',
			Мувыр: '34136',
			Мужбер: '34134',
			Мукши: '34162',
			Мушак: '34133',
			Мушковай: '34130',
			Мысы: '34158',
			Нечкино: '34147',
			Никольское: '34157',
			Нововолково: '34166',
			Новогорское: '34163',
			Новоелово: '34161',
			Новый: '34145',
			Норья: '34138',
			Нылга: '34130',
			Нынек: '34139',
			Ныргында: '34132',
			Ныша: '34139',
			Областная: '34130',
			Ожги: '34155',
			Ольхово: '34145',
			Орлово: '34152',
			Пажман: '34158',
			Пазял: '34139',
			Палагай: '34161',
			Парзи: '34141',
			Перевозное: '34145',
			Петропавлово: '34130',
			Пижил: '34152',
			Пионерский: '34134',
			Пирогово: '3412',
			Писеево: '34150',
			Подгорное: '34133',
			Подмой: '34130',
			Подшивалово: '3412',
			Полом: '34158',
			Поломское: '34158',
			Понино: '34141',
			Порозово: '34136',
			Поршур: '34139',
			Порым: '34163',
			Постол: '3412',
			Починки: '34161',
			Прохорово: '34164',
			Пугачево: '34138',
			Пудем: '34157',
			Пужмезь: '34158',
			Пушкари: '34162',
			Пычас: '34139',
			Пышкет: '34161',
			Рябово: '34130',
			Сарапул: '34147',
			Сардан: '34139',
			Саркуз: '34154',
			Светлое: '34145',
			Селты: '34159',
			Селычка: '34162',
			Селянур: '34163',
			Сеп: '34134',
			Сигаево: '34147',
			Совхозный: '3412',
			Сокол: '3412',
			Соколовка: '34147',
			Сосновка: '34136',
			Стеньгурт: '34158',
			Степаненки: '34158',
			Степаново: '34145',
			Сюгаил: '34139',
			Сюмси: '34152',
			Сюрек: '34152',
			Сюрногурт: '34151',
			Сюромошур: '34159',
			Сюрсовай: '34136',
			Такагурт: '34151',
			Тарасово: '34147',
			Тольен: '34151',
			Тортым: '34158',
			Трактор: '34139',
			Турецкое: '34166',
			Турнес: '34151',
			Тыловай: '34151',
			Ува: '34130',
			Удугучин: '34130',
			Узи: '34159',
			Уйвай: '34151',
			Укан: '34157',
			Ураково: '34141',
			Уральский: '34147',
			Уром: '34138',
			Факел: '34134',
			Халды: '34159',
			Хохряки: '3412',
			Чажай: '34141',
			Чеганда: '34132',
			Чекан: '34130',
			Чепца: '34158',
			Черемушки: '34139',
			Черная: '34145',
			Черновское: '34145',
			Чернушка: '34162',
			Чистотем: '34130',
			Чур: '34162',
			Чутырь: '34134',
			Шабердино: '3412',
			Шадрино: '34147',
			Шамардан: '34161',
			Шаркан: '34136',
			Шевырялово: '34147',
			Шолья: '34153',
			Эркешево: '34166',
			Югдон: '34159',
			Юкаменское: '34161',
			Юнда: '34166',
			Юр: '34157',
			Юрино: '34147',
			Юски: '34158',
			Юськи: '3412',
			Яжбахтино: '34133',
			Якшур: '3412',
			Яр: '34157'
		}
	},
	'Республика Хакасия': {
		regionCode: '390',
		cities: {
			'Белый Яр': '39041',
			'Большая Ерба': '39034',
			'Большой Монок': '39044',
			'Верх-Таштып': '39046',
			'Вершина Тёи': '39045',
			'Вершино-Биджа': '39032',
			'Изыхские Копи': '39041',
			'Малые Арбаты': '39046',
			'Советская Хакасия': '39034',
			'Усть Абакан': '39032',
			'Усть-Абакан': '39032',
			'Усть-Бюрь': '39032',
			'Усть-Ерба': '39034',
			'Усть-Есь': '39045',
			'Усть-Камышта': '39045',
			'Усть-Чуль': '39045',
			'Черное Озеро': '39035',
			Абаза: '39047',
			Абакан: '3902',
			Арбаты: '39046',
			Аршанов: '39041',
			Аскиз: '39045',
			Балыкса: '39045',
			Бельтирское: '39045',
			Бельтырский: '39045',
			Беренжак: '39035',
			Бея: '39044',
			Бирикчуль: '39045',
			Бискамжа: '39045',
			Боград: '39034',
			Бондарево: '39044',
			Борец: '39035',
			Бородино: '39034',
			Буденновка: '39044',
			Весеннее: '39032',
			Ворота: '39035',
			Гайдаровск: '39036',
			Джирим: '39035',
			Доможаков: '39032',
			Ербинская: '39032',
			Ефремкино: '39035',
			Жемчужный: '39035',
			Зеленое: '39032',
			Знаменка: '39034',
			Имек: '39046',
			Июс: '39036',
			Кайбалы: '39041',
			Калинино: '39032',
			Калы: '39044',
			Кирба: '39044',
			Кирово: '39041',
			Кобяково: '39036',
			Когунек: '39036',
			Коммунар: '39035',
			Копьёво: '39036',
			Краснополье: '39041',
			Куйбышево: '39044',
			Кызлас: '39045',
			Летник: '39041',
			Майна: '39042',
			Матур: '39046',
			Московское: '39032',
			Неожиданный: '39045',
			Новоенисейка: '39044',
			Новокурск: '39044',
			Новомарьясово: '39036',
			Новомихайловка: '39041',
			Новониколаевка: '39044',
			Новороссийское: '39041',
			Новотроицкое: '39044',
			Орджоникидзевское: '39036',
			Очуры: '39041',
			Первомайское: '39034',
			Подсинее: '39041',
			Полтаков: '39045',
			Приисковый: '39036',
			Пуланколь: '39045',
			Пушное: '39034',
			Райков: '39032',
			Расцвет: '39032',
			Сабинка: '39044',
			Сапогово: '39032',
			Сарагаш: '39034',
			Сарала: '39036',
			Саяногорск: '39042',
			Соленоозерное: '39035',
			Солнечное: '39032',
			Сон: '39035',
			Сонское: '39034',
			Сорск: '39033',
			Табат: '39044',
			Ташеба: '39032',
			Таштып: '39046',
			Троицкое: '39034',
			Туим: '39035',
			Устинкино: '39036',
			Фыркал: '39035',
			Целинное: '39035',
			Чарков: '39032',
			Черногорск: '39031',
			Черёмушки: '39042',
			Шира: '39035'
		}
	},
	'Чувашская Республика': {
		regionCode: '835',
		cities: {
			'Азим-Сирма': '83537',
			'Альбусь-Сюрбеево': '83539',
			'Анастасово-Первое': '83543',
			'Андреево-Базары': '83534',
			'Балабаш-Баишево': '83532',
			'Бичурга-Баишево': '83536',
			'Большая Выла': '83535',
			'Большая Таяба': '83549',
			'Большая Шатьма': '83530',
			'Большие Абакасы': '83538',
			'Большие Алгаши': '83536',
			'Большие Атмени': '83535',
			'Большие Чаки': '83544',
			'Большие Яльчики': '83549',
			'Большие Яуши': '83537',
			'Большое Карачкино': '83541',
			'Большое Чеменево': '83532',
			'Большое Чурашево': '83547',
			'Большое Шигаево': '83542',
			'Большое Яниково': '83544',
			'Большой Сундырь': '83547',
			'Верхние Ачаки': '83547',
			'Верхние Карачуры': '83535',
			'Вурманкас-Туруново': '8352',
			'Долгая Поляна': '83543',
			'Долгий Остров': '83532',
			'Задние Яндоуши': '8353',
			'Иваньково-Ленино': '83531',
			'Ильина Гора': '83547',
			'Ишмурзино-Суринск': '83549',
			'Карабай-Шемурша': '83536',
			'Кзыл-Чишма': '83532',
			'Кожар Ядоба': '83537',
			'Корак-Чурачики': '8352',
			'Красные Четаи': '83551',
			'Красный Октябрь': '83536',
			'Лащ-Таяба': '83549',
			'Малая Таяба': '83549',
			'Малое Буяново': '83536',
			'Малое Карачкино': '83547',
			'Малое Тугаево': '8353',
			'Малые Бикшихи': '8353',
			'Малые Кармалы': '83538',
			'Малые Кибечи': '8353',
			'Малые Туваны': '83535',
			'Малые Яуши': '83537',
			'Мариинский Посад': '83542',
			'Напольные Котяки': '8353',
			'Нижнее Тимерчеево': '83539',
			'Нижние Абакасы': '83538',
			'Нижние Мочары': '83547',
			'Нижняя Кумашка': '83536',
			'Новое Атлашево': '83540',
			'Новое Ахпердино': '83532',
			'Новое Байбатырево': '83549',
			'Новое Буяново': '83548',
			'Новое Урюмово': '8353',
			'Новое Чурашево': '83538',
			'Новочелны-Сюрбеево': '83539',
			'Новые Айбеси': '83531',
			'Новые Лапсары': '8352',
			'Новые Мураты': '83539',
			'Новые Чукалы': '83536',
			'Новые Шальтямы': '8353',
			'Новые Шимкусы': '83549',
			'Норваш Шигали': '83532',
			'Ойкас-Асламасы': '83547',
			'Первое Степаново': '83545',
			'Первое Чурашево': '83542',
			'Полевой Сундырь': '83539',
			'Полевые Бикшики': '83532',
			'Полевые Пинеры': '83549',
			'Починок-Быбыть': '83539',
			'Русская Cорма': '83535',
			'Русские Алгаши': '83536',
			'Средние Кибечи': '8353',
			'Средние Татмыши': '8353',
			'Старое Котяково': '83532',
			'Старые Айбеси': '83531',
			'Старые Атаи': '83551',
			'Старые Теньгеши': '83547',
			'Старые Тойси': '83532',
			'Старые Урмары': '83544',
			'Старые Чукалы': '83536',
			'Сурский Майдан': '83531',
			'Сюрбей-Токаево': '83539',
			'Татарские Сугуты': '83532',
			'Чепкас Никольское': '83536',
			'Чириш-Шинеры': '83537',
			'Чирш-Хирлепы': '83537',
			'Чувашская Сорма': '83535',
			'Чувашские Тимяши': '83538',
			'д. Сеспель': '83533',
			Абашево: '8352',
			Абызово: '83537',
			Айбечи: '83538',
			Акрамово: '83541',
			Аксарино: '83542',
			Акулево: '8352',
			Акчикасы: '83551',
			Алатырь: '83531',
			Албахтино: '83530',
			Алгазино: '83537',
			Алдиарово: '83548',
			Александровка: '83539',
			Аликово: '83535',
			Алманчиково: '83532',
			Алманчино: '83530',
			Алтышево: '83531',
			Анаткасы: '83541',
			Андреевка: '83538',
			Антипинка: '83543',
			Анютино: '83531',
			Арабоси: '83544',
			Артеменькино: '83537',
			Асаново: '83539',
			Астакасы: '83542',
			Асхва: '8353',
			Атлашево: '8352',
			Атнары: '83551',
			Ахматово: '83531',
			Ачаксы: '8353',
			Байгильдино: '8353',
			Байгулово: '83534',
			Батырево: '83532',
			Бахтигильдино: '83532',
			Березовка: '83538',
			Бичурино: '83542',
			Богатырево: '83545',
			Бугуян: '83538',
			Буинск: '83538',
			Булдеево: '83545',
			Буртасы: '83537',
			Василькасы: '8352',
			Васькино: '83541',
			Вознесенское: '83544',
			Восход: '83531',
			Вотланы: '83535',
			Вурманкасы: '83537',
			Вурнары: '83537',
			Вурумсют: '83545',
			Вутабоси: '8353',
			Гарт: '83543',
			Егоркино: '83536',
			Еметкино: '83534',
			Ермошкино: '83537',
			Ершипоси: '83537',
			Ефремкасы: '83535',
			Засурье: '83547',
			Ибреси: '83538',
			Игорвары: '83545',
			Избахтино: '83549',
			Икково: '8352',
			Именево: '83551',
			Индырчи: '83548',
			Исаково: '83551',
			Ичиксы: '83531',
			Ишаки: '8352',
			Ишлеи: '8352',
			Кабаново: '83536',
			Калайкасы: '83541',
			Калинино: '83537',
			Канаш: '83533',
			Карабаши: '83542',
			Караево: '83551',
			Караклы: '8353',
			Карамышево: '83534',
			Карачево: '83534',
			Кармалы: '83548',
			Кильдюшево: '83549',
			Киря: '83531',
			Ковали: '83544',
			Козловка: '83534',
			Кольцовка: '83537',
			Комсомольское: '83539',
			Конар: '83545',
			Кошноруй: '8353',
			Красноармейское: '83530',
			Кувакино: '83531',
			Кугеево: '83542',
			Кугеси: '83540',
			Кудеиха: '83543',
			Кудеснеры: '83544',
			Кукшумы: '83547',
			Кульгеши: '83544',
			Курочкино: '83534',
			Лагери: '8352',
			Липовка: '83538',
			Мартынкино: '83535',
			Медикасы: '83545',
			Междуречье: '83531',
			Миренки: '83531',
			Михайловка: '83545',
			Мишуково: '83543',
			Можарки: '83548',
			Моргауши: '83541',
			Москакасы: '83541',
			Мочей: '83551',
			Мусирмы: '83544',
			Мыслец: '83536',
			Напольное: '83543',
			Нижарово: '83548',
			Николаевское: '83547',
			Никулино: '83543',
			Новочебоксарск: '8352',
			Одаркино: '83541',
			Ойкасы: '83545',
			Октябрьское: '83542',
			Опытный: '83545',
			Орауши: '83537',
			Орбаши: '83535',
			Оринино: '83541',
			Орнары: '83544',
			Ослаба: '83537',
			Пандиково: '83551',
			Первомайский: '83531',
			Первомайское: '83532',
			Персирланы: '83547',
			Пикшики: '83530',
			Пинеры: '83536',
			Питеркино: '83551',
			Питишево: '83551',
			Поваркасы: '83545',
			Порецкое: '83543',
			Раскильдино: '83535',
			Речной: '83536',
			Рындино: '83543',
			Сабанчино: '83549',
			Саланчик: '83536',
			Семеновское: '83543',
			Сеспель: '8353',
			Синьялы: '8352',
			Сиява: '83543',
			Советское: '83547',
			Сойгино: '83531',
			Солдыбаево: '83534',
			Соловьевский: '83531',
			Сосновка: '8352',
			Сотниково: '83542',
			Стемасы: '83531',
			Сугуты: '83532',
			Сутчево: '83542',
			Сыбайкасы: '83541',
			Сыреси: '83543',
			Сявалкасы: '83537',
			Тарханы: '83532',
			Таутово: '83535',
			Таушкасы: '83545',
			Тегешево: '83544',
			Тенеево: '83535',
			Тобурданово: '8353',
			Тоганашево: '83534',
			Тойси: '83532',
			Толиково: '8352',
			Тораево: '83541',
			Торханы: '83536',
			Тренькино: '83541',
			Трехбалтаево: '83536',
			Туваны: '83536',
			Тувси: '83545',
			Турмыши: '83548',
			Тюмерево: '83548',
			Тюрлема: '83534',
			Убеево: '83530',
			Урмаево: '83539',
			Урмары: '83544',
			Ухманы: '8353',
			Хирпоси: '83537',
			Ходары: '83536',
			Хозанкино: '83551',
			Хормалы: '83538',
			Хочашево: '83547',
			Хыркасы: '8352',
			Цивильск: '83545',
			Чагаси: '8353',
			Чадукасы: '83530',
			Чебаково: '83547',
			Чебоксары: '8352',
			Челкасы: '83544',
			Чемурша: '8352',
			Чиричкасы: '83545',
			Чичканы: '83539',
			Чубаево: '83544',
			Чуварлеи: '83531',
			Чурачики: '83545',
			Чутеево: '83548',
			Шаймурзино: '83532',
			Шакулово: '8353',
			Шатракасы: '83541',
			Шатьмапоси: '83541',
			Шемалаково: '83549',
			Шемурша: '83546',
			Шерауты: '83539',
			Шибылги: '8353',
			Шивбоси: '83530',
			Шигали: '83544',
			Шимкуссы: '83548',
			Шинерпоси: '8352',
			Шихазаны: '8353',
			Шоркасы: '8353',
			Шоркистры: '83544',
			Шоршелы: '83542',
			Штанаши: '83551',
			Шульгино: '83542',
			Шумерля: '83536',
			Шумшеваши: '83551',
			Шыгырдан: '83532',
			Эренары: '83535',
			Юваново: '83547',
			Юманай: '83536',
			Юнга: '83541',
			Юськасы: '83541',
			Явлеи: '83531',
			Ядрин: '83547',
			Ядрино: '83547',
			Яльчики: '83549',
			Яманаки: '83530',
			Ямашево: '8353',
			Янгильдино: '83534',
			Янгличи: '8353',
			Янгорчино: '83537',
			Яндоба: '83535',
			Янзакасы: '83545',
			Янишево: '83537',
			Янтиково: '83548',
			Янымово: '83547',
			Яныши: '8352',
			Ярабайкасы: '83541',
			Яргунькино: '83535',
			Ярославка: '83541',
			Ятманкино: '83541'
		}
	},
	'Республика Саха (Якутия)': {
		regionCode: '411',
		cities: {
			'Батагай-Алыта': '41160',
			'Мегино-Алдан': '41153',
			'Теплый Ключ': '41153',
			'Усть-Мая': '41141',
			'Усть-Нера': '41154',
			'Ытык-Кель': '41152',
			'Ытык-Кюель': '41152',
			'Ытык-Кюёль ': '41152',
			'пос. Тиски': '41167',
			'поселок Тикси': '41167',
			'с. Колымское': '41157',
			'с. Саскылах': '41168',
			'с. Томтор': '41154',
			'село Бердигестях': '41131',
			'село Бютейдях': '41143',
			Айхал: '41136',
			Алдан: '41145',
			Амга: '41142',
			Багатай: '41165',
			Батагай: '41165',
			Бердигестях: '41131',
			Борогонцы: '41161',
			Верхневилюйск: '41133',
			Верхоянск: '41165',
			Вилюйск: '41132',
			Депутатский: '41166',
			Жатай: '4112',
			Жиганск: '41164',
			Зырянка: '41155',
			Кобяй: '41163',
			Кюпцы: '41141',
			Ленск: '41137',
			Майя: '41143',
			Мирный: '41136',
			Намцы: '41162',
			Нерюнгри: '41147',
			Нюрба: '41134',
			Олёкминск: '41138',
			Покровск: '41144',
			Сангар: '41163',
			Саскылах: '41168',
			Солнечный: '41140',
			Среднеколымск: '41156',
			Сунтар: '41135',
			Суола: '41143',
			Тикси: '41167',
			Томмот: '41145',
			Удачный: '41136',
			Хандыга: '41153',
			Харыйалах: '41162',
			Хонуу: '41150',
			Черкех: '41152',
			Черский: '41157',
			Чульман: '41147',
			Чурапча: '41151',
			Ыгыатта: '41135',
			Якутск: '4112'
		}
	},
	'Ростовская область': {
		regionCode: '863',
		cities: {
			'Авило-Успенка': '86341',
			'Александровка-Вторая': '86349',
			'Алексеево-Лозовское': '86387',
			'Алексеево-Тузловка': '86340',
			'Андреево-Мелентьево': '86347',
			'Анно-Ребриковская': '86387',
			'Балко-Грузский': '86370',
			'Барило-Крепинская': '86340',
			'Белая Калитва': '86383',
			'Большая Кирсановка': '86341',
			'Большая Мартыновка': '86395',
			'Большая Неклиновка': '86347',
			'Большая Орловка': '86395',
			'Большая Таловая': '86359',
			'Большая Федоровка': '86367',
			'Большие Салы': '86349',
			'Большое Ремонтное': '86379',
			'Большой Лог': '86350',
			'Большой Мишкин': '86350',
			'Бунако-Соколовец': '86340',
			'Васильево-Петровское': '86342',
			'Васильево-Ханженовка': '86347',
			'Вербовый Лог': '86377',
			'Верхние Грачики': '86365',
			'Верхний Митякин': '86386',
			'Верхний Пиховкин': '86365',
			'Весело-Вознесенка': '86347',
			'Вольно-Донская': '86384',
			'Второй Киевский': '86388',
			'Грай-Воронец': '86385',
			'Греково-Станичный': '86385',
			'Греково-Степановка': '86387',
			'Греково-Тимофеевка': '86341',
			'Греково-Ульяновка': '86340',
			'Гуляй-Борисовка': '86359',
			'Гусарева Балка': '86342',
			'Дальнее Поле': '86373',
			'Донская Нива': '86386',
			'Егоро-Калитвенский': '86386',
			'Ефремово-Степановка': '86386',
			'Задоно-Кагальницкая': '86356',
			'Займо-Обрыв': '86342',
			'Зеленая Горка': '86356',
			'Золотая Коса': '86347',
			'Золотое Руно': '86378',
			'Иваново-Шамшево': '86345',
			'Казанская Лопатина': '86364',
			'Казачьи Лагери': '86360',
			'Калач-Куртлак': '86363',
			'Каменная Балка': '86375',
			'Каменно-Андрианово': '86341',
			'Каменный Брод': '86340',
			'Каменск-Шахтинск': '86365',
			'Каменск-Шахтинский': '86365',
			'Керчик-Савров': '86360',
			'Костино-Быстрянский': '86384',
			'Красная Поляна': '86373',
			'Красное Знамя': '86358',
			'Красный Бумажник': '86341',
			'Красный Колос': '86388',
			'Красный Крым': '86349',
			'Красный Кут': '86360',
			'Красный Луч': '86360',
			'Красный Маныч': '86358',
			'Красный Октябрь': '86358',
			'Красный Сад': '86342',
			'Красный Сулин': '86367',
			'Кривой Лиман': '86395',
			'Кринично-Лугский': '86348',
			'Крученая Балка': '86372',
			'Курно-Липовка': '86386',
			'Малая Западенка': '86358',
			'Малая Каменка': '86365',
			'Малая Лозовка': '86387',
			'Малая Лучка': '86377',
			'Мальчевско-Полненское': '86385',
			'Маныч-Балабинка': '86358',
			'Маньково-Березовская': '86389',
			'Маньково-Калитвенское': '86387',
			'Матвеев-Курган': '86341',
			'Михайлово-Александровка': '86387',
			'Мокрая Ельмута': '86374',
			'Мокрый Батай': '86345',
			'Мокрый Гашун': '86376',
			'Мокрый Лог': '86360',
			'Морской Чулек': '86347',
			'Недвиговка ': '86349',
			'Нижний Саловск': '86356',
			'Новая Надежда': '86348',
			'Новоселый-Первый': '86372',
			'Новый Егорлык': '86372',
			'Новый Маныч': '86372',
			'Обливская ': '86396',
			'Ольховый Рог': '86385',
			'Первый Россошинский': '86359',
			'Песковатская-Лопатина': '86364',
			'Плато-Ивановка': '86340',
			'Полтава-первая': '86342',
			'Порт-Катон': '86342',
			'Раково-Таврический': '86345',
			'Родионово-Несветайская': '86340',
			'Ростов-на-Дону': '863',
			'Русский Колодец': '86347',
			'Семено-Камышенская': '86387',
			'Сеятель-Северный': '86372',
			'Сидорово-Кадамовский': '8636',
			'Синий Курган': '86391',
			'Сладкая Балка': '86371',
			'Соколово-Кундрюченский': '86369',
			'Средние Хороли': '86359',
			'Средний Егорлык': '86371',
			'Средний Маныч': '86358',
			'Средний Чир': '86396',
			'Степано-Савченский': '86389',
			'Степной Курган': '86372',
			'Сысоево-Александровское': '86372',
			'Тарасово-Меловское': '86387',
			'Теплые Ключи': '86388',
			'Тихая Журавка': '86387',
			'Тихий Лиман': '86379',
			'Упраздно-Кагальницкий': '86393',
			'Усть Донецк': '86351',
			'Усть-Быстрый': '86383',
			'Усть-Быстрянская': '86351',
			'Усть-Грязновский': '86363',
			'Усть-Донецкий': '86351',
			'Усть-Мечетка': '86388',
			'Холодный Плес': '86355',
			'Чистый Ручей': '86345',
			'Шахта 3-бис': '86383',
			'Широко-Атамановский': '86384',
			'Широко-Бахолдинский': '86389',
			'ст. Боковская': '86312',
			'станица Раздорская': '86351',
			'станица Старочеркасская': '86350',
			Абрикосовый: '86395',
			Авилов: '86340',
			Аграрный: '86389',
			Аграфеновка: '86340',
			Ажинов: '86357',
			Азов: '86342',
			Аксай: '86350',
			Александров: '86384',
			Александровский: '86396',
			Алмазный: '86361',
			Анастасиевка: '86341',
			Андреевская: '86377',
			Андроповский: '86353',
			Антиповский: '86353',
			Антонов: '86391',
			Апанасовка: '86383',
			Апаринский: '86351',
			Араканцев: '86397',
			Арпачин: '86357',
			Артамошкин: '86387',
			Аютинский: '8636',
			Багаевская: '86357',
			Багаевский: '86357',
			Базковская: '86353',
			Базковский: '86364',
			Байков: '86376',
			Бакай: '86387',
			Бакланики: '86356',
			Баклановская: '86377',
			Балабанов: '86370',
			Бараники: '86372',
			Батайск: '86354',
			Батальщиковский: '86364',
			Беглица: '86347',
			Белавин: '86382',
			Белозерный: '86372',
			Белянский: '86393',
			Березовка: '86372',
			Березовый: '86365',
			Бессергеневская: '86360',
			Бессергеновка: '86347',
			Богатов: '86383',
			Богородицкое: '86373',
			Богородское: '86379',
			Богоявленская: '86393',
			Богуны: '86387',
			Богураев: '86383',
			Божковка: '86367',
			Боковская: '86382',
			Болдыревка: '86340',
			Большекрепинская: '86340',
			Большемечетный: '86356',
			Большенаполовский: '86382',
			Большинка: '86386',
			Большовская: '86392',
			Буденновская: '86374',
			Буденовская: '86374',
			Бургуста: '86361',
			Быковский: '86364',
			Быстрогорский: '86397',
			Быстрянский: '86375',
			Валуевка: '86379',
			Вареновка: '86347',
			Васильевка: '86386',
			Васильевский: '86365',
			Ведерников: '86393',
			Вербочки: '86384',
			Верхнегреково: '86388',
			Верхнегрушевский: '86360',
			Верхнекольцов: '86397',
			Верхнекундрюченская: '86351',
			Верхнемакеевка: '86388',
			Верхнеобливский: '86397',
			Верхнеподпольный: '86350',
			Верхнепотапов: '86393',
			Верхнесвечниково: '86388',
			Верхнесеребряковка: '86376',
			Верхнесоленый: '86358',
			Верхнеталовка: '86385',
			Верхнетарасовский: '86386',
			Верхнечирский: '86382',
			Верхнеясиновский: '86365',
			Верхняковский: '86364',
			Вершинный: '86356',
			Веселый: '86358',
			Вислый: '86356',
			Вишневецкий: '86365',
			Владимиров: '86384',
			Владимировская: '86367',
			Водопадный: '86350',
			Вознесенский: '86384',
			Возрожденный: '86350',
			Войково: '86386',
			Войнов: '86370',
			Волгодонск: '8639',
			Волочаевский: '86375',
			Волошино: '86340',
			Волченский: '86365',
			Вороново: '86371',
			Воронцовка: '86345',
			Восточногорняцкий: '86383',
			Выдел: '86340',
			Высочино: '86342',
			Вяжа: '86388',
			Вёшенская: '86353',
			Гаевка: '8636',
			Галдин: '86387',
			Ганчуков: '86374',
			Гапкин: '86393',
			Гашун: '86376',
			Генеральское: '86340',
			Гигант: '86372',
			Головка: '86383',
			Голубинка: '86383',
			Горный: '86367',
			Горняцкий: '86383',
			Гороховский: '86353',
			Грачи: '86383',
			Греково: '86385',
			Григорьевка: '86341',
			Грузинов: '86384',
			Груцинов: '86365',
			Грушевка: '86383',
			Грушевская: '86350',
			Гуково: '86361',
			Гуреев: '86377',
			Дальний: '86374',
			Данилов: '86365',
			Дарагановка: '8636',
			Дарьевка: '86340',
			Двуречье: '86345',
			Дегтево: '86385',
			Денисов: '86395',
			Денисовский: '86379',
			Деркул: '86386',
			Дибровый: '86388',
			Дивный: '86350',
			Дмитриадовка: '8636',
			Доброполье: '86389',
			Донецк: '86368',
			Дорожный: '86350',
			Дубенцовская: '86392',
			Дубовское: '86377',
			Дубравный: '86391',
			Дубровский: '86353',
			Дугино: '86342',
			Дударевский: '86353',
			Дудкино: '86367',
			Дячкино: '86386',
			Евсеевский: '86351',
			Егорлыкская: '86370',
			Еланская: '86311',
			Елизаветинская: '86342',
			Елизаветовка: '86342',
			Елкин: '86357',
			Ериковский: '86377',
			Ермаковская: '86397',
			Ермилов: '86393',
			Ефремовка: '8636',
			Железнодорожный: '86391',
			Жирнов: '86397',
			Жуков: '86356',
			Жуковская: '86377',
			Жуковское: '86373',
			Журавлевка: '86371',
			Заветное: '86378',
			Заводской: '86365',
			Задонский: '86342',
			Зазерский: '86397',
			Зайцевка: '86367',
			Залужный: '86360',
			Заплавская: '86360',
			Заполосный: '86359',
			Зверево: '86355',
			Зеленовка: '86386',
			Зеленолугский: '86395',
			Зерноград: '86359',
			Зимовники: '86376',
			Знаменка: '86384',
			Золотаревка: '86356',
			Изобильный: '86370',
			Изумрудный: '86386',
			Ильинка: '86383',
			Ильинов: '86395',
			Ильинский: '86370',
			Индустриальный: '86388',
			Интернациональный: '86360',
			Исаев: '86397',
			Кавалерский: '86370',
			Кагальник: '86342',
			Кагальницкая: '86345',
			Кадамовский: '86360',
			Казанская: '86364',
			Казачий: '86358',
			Какичев: '86383',
			Калашников: '86388',
			Калининская: '86391',
			Калининский: '86353',
			Калиновский: '86353',
			Калитвенская: '86365',
			Каменоломни: '86360',
			Камышев: '86376',
			Камышевка: '86375',
			Камышевская: '86391',
			Камышный: '86393',
			Караичев: '86396',
			Каргинская: '86382',
			Качалин: '86397',
			Кашары: '86388',
			Каштановский: '86396',
			Каяльский: '86342',
			Керчикский: '86351',
			Киевка: '86379',
			Киреев: '86396',
			Киреевка: '86360',
			Кировская: '86345',
			Киселевка: '86378',
			Киселево: '86367',
			Кичкино: '86378',
			Клевцов: '86367',
			Клюев: '86359',
			Ковалевка: '86350',
			Коврино: '86374',
			Ковыленский: '86396',
			Ковылкин: '86397',
			Коксовый: '86383',
			Колодези: '86385',
			Колундаевский: '86353',
			Колушкино: '86386',
			Комаров: '86395',
			Комиссаровка: '86367',
			Комсомольский: '86384',
			Кононов: '86383',
			Константиновск: '86393',
			Коныгин: '86351',
			Кормовое: '86379',
			Кочетковская: '86356',
			Кочетовка: '86365',
			Кочетовская: '86356',
			Красногорняцкий: '86360',
			Краснодонецкая: '86383',
			Краснодонский: '86392',
			Краснозоринский: '86382',
			Краснокутская: '86382',
			Краснопартизанский: '86379',
			Красноярская: '86391',
			Красюковская: '86360',
			Кривов: '86396',
			Криворожье: '86385',
			Кривянская: '86360',
			Кринички: '86385',
			Круглое: '86342',
			Кружилинский: '86353',
			Крутинский: '86383',
			Крутобережный: '86395',
			Крутой: '86391',
			Крылов: '86397',
			Крым: '86349',
			Крынка: '86341',
			Крюково: '86348',
			Кугей: '86342',
			Кугейский: '86370',
			Кудинов: '86357',
			Кудиновка: '86385',
			Кузнецовка: '86356',
			Куйбышево: '86348',
			Кулешовка: '86342',
			Кульбаково: '86341',
			Курганный: '86375',
			Кутейников: '86389',
			Кутейниковская: '86376',
			Лагутники: '86392',
			Лакедемоновка: '86347',
			Латоново: '86341',
			Ленинаван: '86349',
			Леонов: '86396',
			Летник: '86373',
			Литвиновка: '86383',
			Лиховской: '86365',
			Лихой: '86367',
			Лобачев: '86396',
			Лозновская: '86391',
			Лозной: '86391',
			Лопанка: '86391',
			Майорский: '86375',
			Майский: '8636',
			Малахов: '86385',
			Малаховский: '86382',
			Малоекатериновка: '86341',
			Малокирсановка: '86341',
			Малоорловский: '86395',
			Малотокмацкий: '86385',
			Мальчевская: '86385',
			Манычская: '86357',
			Манычстрой: '86372',
			Маргаритово: '86342',
			Мариинская: '86393',
			Маркин: '86360',
			Маркинская: '86391',
			Марфинка: '86341',
			Масаловка: '86365',
			Маслов: '86397',
			Машлыкино: '86385',
			Маяк: '86372',
			Мелиховская: '86351',
			Меркуловский: '86353',
			Мечетинская: '86359',
			Мешковская: '86364',
			Мещеряковский: '86364',
			Мигулинская: '86364',
			Миллерово: '86385',
			Милютинская: '86389',
			Митякинская: '86386',
			Михайлов: '86397',
			Михайловский: '86364',
			Мичуринский: '86392',
			Можаевка: '86386',
			Молодежный: '86365',
			Морозов: '86392',
			Морозовск: '86384',
			Моховской: '86353',
			Мрыховский: '86364',
			Нагибин: '86387',
			Надежда: '86341',
			Надежевка: '86397',
			Назаровский: '86364',
			Насонтов: '86383',
			Натальевка: '86347',
			Наумовский: '86374',
			Недвиговка: '86349',
			Некрасовка: '8636',
			Нестеркин: '86396',
			Нижнеговейный: '86365',
			Нижнедонской: '86360',
			Нижнежуравский: '86393',
			Нижнекалинов: '86393',
			Нижнекамышинка: '86315',
			Нижнекривской: '86353',
			Нижнекугоейский: '86359',
			Нижнекудрюченская: '86351',
			Нижнемитякин: '86386',
			Нижненагольная: '86315',
			Нижнепопов: '86383',
			Нижнесеребряковский: '86383',
			Нижнетиховский: '86364',
			Николаев: '86384',
			Николаевская: '86393',
			Николовка: '86389',
			Никольская: '86315',
			Никольский: '86378',
			Никольское: '8636',
			Новиковка: '86348',
			Новоалександровка: '86342',
			Новоандриановка: '86341',
			Новобатайск: '86345',
			Новоберезовка: '86395',
			Новобессергеневка: '8636',
			Новогашунский: '86377',
			Новодмитриевский: '86389',
			Новозарянский: '86360',
			Новозолотовская: '86356',
			Новоивановка: '86359',
			Новокузнецовка: '86359',
			Новомаргаритово: '86342',
			Новомартыновский: '86395',
			Новомирский: '86342',
			Новомоисеевский: '86374',
			Новониколаевский: '86364',
			Новоперсиановка: '86360',
			Новополеевский: '86396',
			Новополтавский: '86342',
			Новопривольный: '86379',
			Новоприморский: '86347',
			Новоровенецкий: '86361',
			Новороговская: '86370',
			Новороссошанский: '86397',
			Новосадковский: '86395',
			Новоселовка: '86395',
			Новостепановский: '86387',
			Новосуховый: '86397',
			Новотроицкое: '86342',
			Новоцимлянская: '86391',
			Новочеркасск: '86352',
			Новошахтинск: '86369',
			Новый: '86358',
			Носово: '86347',
			Обливская: '86396',
			Обуховка: '86342',
			Общий: '86384',
			Объединенный: '86370',
			Овощной: '86342',
			Октябрьский: '86350',
			Ольгинская: '86350',
			Ольховский: '86351',
			Ольховчик: '86387',
			Ольшанка: '86371',
			Опенки: '86374',
			Орлов: '86389',
			Орловка: '86342',
			Орловский: '86375',
			Осиково: '86387',
			Осиновский: '86363',
			Островянский: '86375',
			Отрадное: '86347',
			Отрадный: '86357',
			Отрадовка: '86342',
			Парамонов: '86384',
			Паршиков: '86391',
			Персиановский: '86360',
			Песчанокопское: '86373',
			Петровка: '86349',
			Петрово: '86363',
			Петровский: '86389',
			Пешково: '86342',
			Пирожок: '86392',
			Пишванов: '86359',
			Платово: '86367',
			Плешаков: '86365',
			Плодородное: '86371',
			Плотников: '86376',
			Победа: '86392',
			Погорелов: '86383',
			Подгорное: '86379',
			Подгоры: '86392',
			Позднеевка: '86315',
			Покровское: '86347',
			Поливянка: '86373',
			Политотдельское: '86341',
			Пономарев: '86388',
			Попов: '86382',
			Поповский: '86311',
			Потапов: '86392',
			Поцелуев: '86383',
			Почтовый: '86393',
			Приазовский: '86347',
			Пригородный: '86367',
			Приморка: '86347',
			Приовражный: '86361',
			Присальский: '86377',
			Приют: '86347',
			Прогной: '86386',
			Пролетарка: '86367',
			Пролетарск: '86374',
			Пролетарский: '86375',
			Прохоровка: '86367',
			Пухляковский: '86351',
			Равнинный: '86360',
			Развильное: '86373',
			Раздольный: '86379',
			Раздорская: '86351',
			Рассвет: '86350',
			Рассыпное: '86373',
			Революционный: '86359',
			Реконструктор: '86350',
			Ремонтное: '86379',
			Рогалик: '86385',
			Роговский: '86370',
			Рогожкино: '86342',
			Родники: '86345',
			Рожок: '8636',
			Романов: '86377',
			Романовка: '86372',
			Романовская: '86394',
			Рудаков: '86383',
			Русичи: '86383',
			Русское: '86348',
			Рыбасово: '86372',
			Рябичев: '86392',
			Ряженое: '86341',
			Рясное: '86341',
			Савдя: '86378',
			Савельевский: '86392',
			Савоськин: '86376',
			Садки: '86367',
			Садковский: '86358',
			Садовый: '86357',
			Сальск: '86372',
			Самарское: '86342',
			Самбуров: '86365',
			Сандата: '86372',
			Сариновка: '86388',
			Саркел: '86391',
			Светоч: '86389',
			Свобода: '86358',
			Свободный: '86348',
			Севостьянов: '86389',
			Селивановская: '86389',
			Семенкин: '86392',
			Семибалки: '86342',
			Семикаракорск: '86356',
			Семичный: '86377',
			Сетраки: '86387',
			Сиволобов: '86396',
			Синегорский: '86383',
			Синявское: '86347',
			Сиротский: '86377',
			Скельновский: '86364',
			Скосырская: '86397',
			Слободской: '86356',
			Советка: '86347',
			Советская: '86363',
			Солонецкий: '86396',
			Сорговый: '86359',
			Сосенки: '86391',
			Сосновый: '86396',
			Сосны: '86383',
			Сохрановка: '86387',
			Старокузнецовский: '86356',
			Старопетровский: '86384',
			Староротовка: '86341',
			Старочеркасская: '86350',
			Степное: '86371',
			Степной: '86395',
			Стефанидинодар: '86342',
			Страхов: '86356',
			Стычновский: '86393',
			Суворов: '86393',
			Сулин: '86385',
			Сулинский: '86389',
			Супрун: '86372',
			Сусат: '86356',
			Суходольный: '86364',
			Суходольск: '86342',
			Сухой: '86374',
			Табунщиково: '86367',
			Таганрог: '8634',
			Талловеров: '86388',
			Таловый: '8636',
			Тарасовский: '86386',
			Татников: '86374',
			Тацинская: '86397',
			Тацинский: '86397',
			Терновая: '86385',
			Терновой: '86389',
			Терновская: '86391',
			Терновый: '86373',
			Тимирязевский: '86342',
			Титов: '86356',
			Титовка: '86385',
			Топилин: '86356',
			Тополевый: '86367',
			Троицкое: '86347',
			Трудовой: '86355',
			Тубянский: '86364',
			Туриловка: '86385',
			Углегорский: '86397',
			Углекаменный: '86383',
			Углеродовский: '86361',
			Украинский: '86370',
			Урывский: '86365',
			Усьман: '86357',
			Уютный: '86374',
			Федоровка: '86347',
			Федосеевка: '86378',
			Федулов: '86357',
			Фомин: '86378',
			Фоминка: '86385',
			Хапры: '86349',
			Хлебодарное: '86371',
			Хлеборобное: '86371',
			Хмызов: '86385',
			Хомутовская: '86345',
			Хорошевская: '86391',
			Христичево: '86342',
			Хрящевский: '86393',
			Хуторской: '86376',
			Целина: '86371',
			Центральный: '86395',
			Цимлянск: '86391',
			Чалтырь: '86349',
			Чапаев: '86383',
			Чебачий: '86356',
			Чекалов: '86384',
			Чеканиха: '86358',
			Черемухи: '86395',
			Чернецов: '86367',
			Черников: '86367',
			Чернышевка: '86359',
			Чертково: '86387',
			Черюмкин: '86350',
			Чирский: '86363',
			Чистоозерный: '86365',
			Чистяково: '86363',
			Чичерино: '86367',
			Чукаринский: '86353',
			Шаблиевка: '86372',
			Шарпаевка: '86386',
			Шаумяновский: '86370',
			Шахтенки: '86367',
			Шахты: '8636',
			Шебалин: '86378',
			Шептуховка: '86387',
			Широкий: '86375',
			Шолоховский: '86383',
			Шумилинская: '86364',
			Щеглов: '86377',
			Щедровка: '86387',
			Щепкин: '86350',
			Юбилейный: '86369',
			Яблоновский: '86382',
			Ягодинка: '86360',
			Ярский: '86385',
			Ясногорка: '86383'
		}
	},
	'Рязанская область': {
		regionCode: '491',
		cities: {
			'Агро-Пустынь': '4912',
			'Балушевы-Починки': '49131',
			'Боковой Майдан': '49133',
			'Большая Алешня': '49132',
			'Большая Екатериновка': '49146',
			'Большая Журавинка': '49132',
			'Большевик Совхоз': '49157',
			'Большое Агишево': '49147',
			'Большое Жоково': '49137',
			'Большое Коровино': '49153',
			'Большое Самарино': '49132',
			'Большое Село': '49155',
			'Высокие Поляны': '49145',
			'Гремячий Ключ': '49144',
			'Гусь-Железный': '49131',
			'Дашки-Вторые': '4912',
			'Дегтяные Борки': '49154',
			'Ермо-Николаевка': '49145',
			'Желобова Слобода': '49135',
			'Задне-Пилево': '49142',
			'Занино-Починки': '49136',
			'Заря Совхоз': '49130',
			'Ильича Совхоз': '49130',
			'Институт коневодства': '49137',
			'Казачий Дюк': '49147',
			'Казачья Слобода': '49147',
			'Красная Вершина': '49148',
			'Красное Знамя': '49158',
			'Красный Угол': '49152',
			'Красный Холм': '49136',
			'Кривая Лука': '49147',
			'Лесная Поляна': '49147',
			'Лесное Конобеево': '49147',
			'Малый Сапожок': '49152',
			'Малый Студенец': '49133',
			'Марчуки-Вторые': '49132',
			'Марчуки-Первые': '49132',
			'Маяк Совхоз': '49131',
			'Морозовы Борки': '49152',
			'Наумово-Первое': '4912',
			'Нижнее Мальцево': '49133',
			'Новое Батурино': '49137',
			'Новое Еголдаево': '49132',
			'Новый Киструс': '49135',
			'Новый Ункор': '49145',
			'Огарево-Почково': '49133',
			'Остро-Пластиково': '49138',
			'Пет-Завод': '49145',
			'Печерниковские Выселки': '49130',
			'Покровское Первое': '49130',
			'Польное Ялтуново': '49147',
			'Поляковский Майдан': '49133',
			'Поселок Газопровода': '49143',
			'Просяные Поляны': '49139',
			'Рано-Верхи': '49157',
			'Ремизово Первое': '49148',
			'Роман-Дарки': '49146',
			'Рязанские Сады': '49151',
			'Рязанский Совхоз': '4912',
			'Сергиевский Боровок': '49158',
			'Смена Совхоз': '49153',
			'Сново-Здорово': '49147',
			'Спас-Клепики': '49142',
			'Спасск-Рязанский': '49135',
			'Спасско-Раменье': '49144',
			'Старая Рязань': '49135',
			'Старое Березово': '49133',
			'Старое Бокино': '49148',
			'Старое Зимино': '49153',
			'Стенькино Учхоз': '4912',
			'Стрелецкие Выселки': '49130',
			'Терновая Погореловка': '49155',
			'Троице-Орловка': '49156',
			'Черная Речка': '49152',
			'Черная Слобода': '49147',
			'Шевалеевский Майдан': '49133',
			'Шелемишевские Хутора': '49156',
			'р.п. Сапожок': '49152',
			Агломазово: '49133',
			Аделино: '49136',
			Азеево: '49144',
			Акаево: '49144',
			Акулово: '49132',
			Аладьино: '49138',
			Александровка: '49154',
			Александрово: '4912',
			Алексеевка: '49148',
			Алексеево: '49142',
			Алешино: '49133',
			Алешня: '49137',
			Альютово: '49155',
			Аманово: '49143',
			Анемнясево: '49131',
			Апушка: '49147',
			Ардабьево: '49131',
			Аристово: '49151',
			Артемово: '49142',
			Арцыбашево: '49157',
			Ахматово: '49131',
			Баграмово: '49137',
			Байдики: '49153',
			Бастаново: '49133',
			Безлычное: '49153',
			Белоречье: '49148',
			Бельское: '49135',
			Береговое: '49146',
			Березники: '49152',
			Березняги: '49156',
			Берестянки: '49133',
			Бетино: '49131',
			Биркино: '49143',
			Благие: '49158',
			Богослово: '49156',
			Болонь: '49142',
			Болошнево: '4912',
			Борец: '49148',
			Борисково: '4912',
			Борисовка: '49158',
			Боровое: '49136',
			Боршевое: '49157',
			Борщевка: '49157',
			Бурминка: '49158',
			Бусаево: '49142',
			Варские: '4912',
			Верда: '49148',
			Вердерево: '49156',
			Веретье: '49135',
			Веряево: '49145',
			Виленка: '49130',
			Виленки: '49130',
			Витуша: '49148',
			Власово: '49144',
			Волынщино: '49154',
			Вороново: '49151',
			Воронцово: '49142',
			Воршево: '49146',
			Вослебово: '49156',
			Восход: '49139',
			Выжелес: '49135',
			Выкуши: '49131',
			Выползово: '49135',
			Выша: '49147',
			Вышгород: '4912',
			Вышетравино: '4912',
			Вялсы: '49133',
			Гавердово: '4912',
			Гавриловское: '49135',
			Гаи: '49157',
			Гиблицы: '49131',
			Глядково: '49133',
			Голдино: '49130',
			Голованово: '49142',
			Горенка: '49130',
			Горлово: '49156',
			Горняк: '49157',
			Городное: '49135',
			Гребнево: '49151',
			Гремячка: '49156',
			Гришино: '49142',
			Грязное: '49130',
			Гулынки: '49151',
			Гуреево: '49142',
			Давыдово: '49142',
			Данилово: '49157',
			Дарьино: '49139',
			Дегтярка: '49157',
			Деревенское: '49135',
			Дмитриево: '49131',
			Долгинино: '4912',
			Дубровичи: '4912',
			Дубровка: '49136',
			Дудкино: '49138',
			Дунино: '49142',
			Дядьково: '4912',
			Егорово: '49142',
			Екатериновка: '49146',
			Екимовка: '4912',
			Екшур: '49142',
			Елатьма: '49131',
			Елино: '49153',
			Енкаево: '49139',
			Ерахтур: '49136',
			Ерлино: '49143',
			Ермишь: '49144',
			Ермолово: '49131',
			Желанное: '49147',
			Желобово: '49148',
			Желтухино: '49156',
			Желудево: '49136',
			Житово: '49137',
			Жокино: '49153',
			Заборово: '49158',
			Заборье: '4912',
			Завидное: '49147',
			Завидовка: '49130',
			Задубровье: '49136',
			Заокское: '4912',
			Заполье: '49136',
			Заречный: '49156',
			Затворное: '49156',
			Захарово: '49153',
			Зимарово: '49158',
			Змеевка: '49157',
			Змеинка: '49130',
			Ибердский: '49143',
			Ибердус: '49131',
			Ибредь: '49136',
			Иванково: '49135',
			Ивкино: '49142',
			Игошино: '49144',
			Ижевское: '49135',
			Ижеславль: '49130',
			Илебники: '49136',
			Ильинка: '49156',
			Инякино: '49136',
			Ирицы: '49136',
			Исады: '49135',
			Искра: '4912',
			Истье: '49151',
			Каверино: '49147',
			Кадом: '49139',
			Казинка: '49156',
			Калинин: '49154',
			Калинино: '49158',
			Канино: '49152',
			Карабухино: '49146',
			Каргашино: '49133',
			Карнаухово: '49147',
			Картаносово: '4912',
			Касимов: '49131',
			Катино: '49156',
			Кафтейка: '49144',
			Кермись: '49147',
			Кипчаково: '49143',
			Кирицы: '49135',
			Киселево: '49151',
			Кисьва: '49155',
			Китово: '49131',
			Клекотки: '49156',
			Клетино: '49131',
			Ключ: '49143',
			Князево: '49156',
			Кобылино: '49154',
			Ковалинка: '49143',
			Коготково: '49156',
			Колесниково: '49142',
			Кольдюки: '49131',
			Комсомольский: '49156',
			Коноплино: '49154',
			Константиново: '49136',
			Копнино: '49138',
			Кораблино: '49143',
			Коровка: '49152',
			Костино: '49137',
			Котелино: '49139',
			Которово: '49131',
			Кочемирово: '49139',
			Кочуры: '49157',
			Красное: '49152',
			Кремлево: '49156',
			Криуша: '49142',
			Кузьминское: '49137',
			Култуки: '49142',
			Кустаревка: '49133',
			Кутуково: '49135',
			Кучасьево: '49147',
			Кучуково: '49132',
			Кущапино: '49139',
			Ладышкино: '49136',
			Лашма: '49131',
			Ленино: '49158',
			Лесной: '49136',
			Липяги: '49157',
			Листвянка: '4912',
			Лихунино: '49142',
			Лопатино: '49156',
			Лопухи: '4912',
			Лубоное: '49136',
			Лубяники: '49131',
			Лужки: '49130',
			Лукмос: '49152',
			Льгово: '4912',
			Маклаково: '49155',
			Маково: '49130',
			Максы: '49148',
			Малахово: '49142',
			Малинищи: '49155',
			Малинки: '49130',
			Мамоново: '49155',
			Марково: '49137',
			Матвеевское: '49133',
			Машково: '49130',
			Мелехово: '49138',
			Мердушь: '49144',
			Милославское: '49157',
			Мимишкино: '49131',
			Михайлов: '49130',
			Михеи: '49152',
			Можары: '49148',
			Моловка: '49143',
			Мосолово: '49136',
			Мураевня: '49157',
			Мурмино: '4912',
			Мышинка: '49157',
			Мягково: '49142',
			Нагиши: '49156',
			Нагорное: '49132',
			Назаровка: '49138',
			Напольное: '49148',
			Нарма: '49144',
			Нармушадь: '49136',
			Насурово: '4912',
			Неверово: '49142',
			Незнаново: '49143',
			Ненашкино: '49142',
			Нестерово: '49145',
			Новики: '49135',
			Новобараково: '49156',
			Новобокино: '49148',
			Новокрасное: '49152',
			Новомичуринск: '49155',
			Новопанское: '49130',
			Огородниково: '49135',
			Озерки: '49148',
			Октябрьский: '49130',
			Октябрьское: '49155',
			Орехово: '49135',
			Орловка: '49155',
			Островки: '49135',
			Остроухово: '49153',
			Оськино: '49142',
			Павелец: '49156',
			Пальные: '49137',
			Панино: '49135',
			Парышка: '49152',
			Пахомовка: '49143',
			Пеньки: '49145',
			Перво: '49131',
			Перкино: '49135',
			Пертово: '49138',
			Песочня: '49146',
			Петрово: '49132',
			Петрушино: '49156',
			Пехлец: '49143',
			Печерники: '49130',
			Пионерский: '49137',
			Пителино: '49145',
			Пичкиряево: '49133',
			Плахино: '49153',
			Побединка: '49156',
			Подвязье: '4912',
			Покровское: '49154',
			Поливаново: '49153',
			Полково: '4912',
			Половское: '49135',
			Поляны: '49145',
			Помозово: '49130',
			Поплевино: '49132',
			Поповка: '49131',
			Потапьево: '49145',
			Пощупово: '49137',
			Поярково: '49130',
			Преображенка: '49139',
			Прибрежный: '49136',
			Придорожный: '49133',
			Пронск: '49155',
			Проня: '49135',
			Просечье: '49158',
			Пустополье: '49136',
			Пустотино: '49143',
			Путятино: '49146',
			Пушкари: '49130',
			Разбердеево: '49135',
			Раздольное: '49130',
			Рачатники: '49130',
			Рожково: '49133',
			Рыбное: '49137',
			Ряжск: '49132',
			Рязань: '4912',
			Ряссы: '49136',
			Савватьма: '49144',
			Савостьяново: '49131',
			Салтыки: '49132',
			Салтыково: '49133',
			Самодуровка: '49145',
			Сановка: '49136',
			Санское: '49136',
			Сапожок: '49152',
			Сараи: '49148',
			Сасово: '49133',
			Сасыкино: '49136',
			Свестур: '49144',
			Свинчус: '49136',
			Секиотово: '4912',
			Секирино: '49156',
			Сельцы: '49137',
			Семенск: '49155',
			Семион: '49143',
			Сиверка: '49131',
			Симушка: '49139',
			Скопин: '49156',
			Слободка: '49130',
			Смолеевка: '49154',
			Собчаково: '49135',
			Соловьяновка: '49139',
			Солотча: '49134',
			Сосновка: '49131',
			Сотницыно: '49133',
			Соха: '49151',
			Спасское: '49157',
			Спешнево: '49158',
			Спирино: '49142',
			Старожилово: '49151',
			Старолетово: '49137',
			Старочернеево: '49147',
			Стенькино: '4912',
			Столпцы: '49151',
			Строевское: '49146',
			Студенки: '49158',
			Суйск: '49151',
			Сумерки: '49139',
			Сынтул: '49131',
			Сысои: '49148',
			Тарадеи: '49147',
			Татаркино: '49151',
			Ташенка: '49131',
			Телебукино: '49131',
			Телятники: '49148',
			Темгенево: '49133',
			Терехово: '49136',
			Тимошкино: '49136',
			Токарево: '49131',
			Топилы: '49157',
			Торбаево: '49131',
			Торопово: '49144',
			Треполье: '49130',
			Троицкое: '49148',
			Тума: '49142',
			Тупик: '49144',
			Турлатово: '4912',
			Турмадеево: '49144',
			Турово: '49132',
			Тюково: '49142',
			Тюрвищи: '49142',
			Унгор: '49146',
			Ункосово: '49138',
			Устье: '49133',
			Ухолово: '49154',
			Ухорское: '49135',
			Федоровское: '49153',
			Федосово: '49147',
			Федотьево: '49135',
			Федяево: '49147',
			Федякино: '49137',
			Ходынино: '49137',
			Хрущево: '49151',
			Царево: '49144',
			Центральный: '49157',
			Чаур: '49131',
			Чемодановка: '49143',
			Чермные: '49139',
			Чернава: '49157',
			Чубарово: '49133',
			Чулково: '49156',
			Чурики: '49130',
			Чуриловка: '49154',
			Чучково: '49138',
			Шарик: '49147',
			Шацк: '49147',
			Шевцово: '4912',
			Шевырляй: '49147',
			Шелемишево: '49156',
			Шелковая: '49151',
			Шереметьево: '49132',
			Шилово: '49136',
			Шостье: '49131',
			Шумашь: '4912',
			Щербатовка: '49131',
			Юраково: '49143',
			Юшта: '49136',
			Яблонево: '49143',
			Ягодное: '49148',
			Ямбирно: '49147',
			Ясенок: '49154'
		}
	},
	'Самарская область': {
		regionCode: ['846', '848'],
		cities: {
			'Абдул-Завод': '84656',
			'Большая Глушица': '84673',
			'Большая Дергуновка': '84673',
			'Большая Ега': '84656',
			'Большая Каменка': '84657',
			'Большая Константиновка': '84650',
			'Большая Малышевка': '84663',
			'Большая Раковка': '84657',
			'Большая Романовка': '84650',
			'Большая Рязань': '84862',
			'Большая Черениговка': '84672',
			'Большая Черниговка': '84672',
			'Большая Чесноковка': '84655',
			'Большое Алдаркино': '84667',
			'Большое Ермаково': '84650',
			'Большое Микушкино': '84654',
			'Большой Толкай': '84656',
			'Борискино-Игар': '84653',
			'Верхнее Санчелеево': '84862',
			'Верхние Белозерки': '84862',
			'Верхние Росташи': '84672',
			'Верхний Сускан': '84862',
			'Верхняя Домашка': '84670',
			'Верхняя Орлянка': '84655',
			'Волжский Утес': '84648',
			'Вольная Солянка': '84660',
			'Два Ключа': '84654',
			'Дубовый Умет': '846',
			'Кармала-Аделяково': '84655',
			'Кинель-Черкассы': '84660',
			'Кинель-Черкасы': '84660',
			'Красная Багана': '84651',
			'Красная Горка': '84660',
			'Красная Поляна': '84674',
			'Красное Поселение': '84658',
			'Красные Дома': '84658',
			'Красные Ключи': '84656',
			'Красный Городок': '84655',
			'Красный Строитель': '84651',
			'Красный Яр': '84657',
			'Крепость Кондурча': '84652',
			'Криволучье-Ивановка': '84675',
			'Малая Глушица': '84673',
			'Малая Каменка': '84657',
			'Малая Малышевка': '84663',
			'Малая Царевщина': '84657',
			'Малое Девлезеркино': '84651',
			'Малое Ибряйкино': '84656',
			'Малое Микушкино': '84654',
			'Малый Толкай': '84656',
			'Михайло-Лебяжье': '84677',
			'Михайло-Овсянка': '84674',
			'Мордово-Аделяково': '84654',
			'Мордово-Ишуткино': '84654',
			'Мордовская Селитьба': '84655',
			'Нижнее Санчелеево': '84862',
			'Нижняя Быковка': '84650',
			'Новая Бинарадка': '84862',
			'Новая Кармала': '84650',
			'Новая Рачейка': '8464',
			'Новая Таяба': '84651',
			'Новая Чесноковка': '84654',
			'Новое Аделяково': '84651',
			'Новое Ганькино': '84654',
			'Новое Мансуркино': '84656',
			'Новое Тенеево': '84650',
			'Новое Усманово': '84664',
			'Новое Якушкино': '84654',
			'Новые Ключи': '84660',
			'Новые Сосны': '84653',
			'Новый Буян': '84657',
			'Новый Камелик': '84672',
			'Новый Кувак': '84652',
			'Новый Кутулук': '84667',
			'Новый Маклауш': '84653',
			'Новый Ризадей': '8464',
			'Новый Сарбай': '84663',
			'Новый Тукшум': '84648',
			'Петра-Дубрава': '846',
			'Печерские Выселки': '8464',
			'Подгорный Дол': '84653',
			'Подъем-Михайловка': '846',
			'Ровно-Владимировка': '846',
			'Русская Борковка': '84862',
			'Русская Васильевка': '84650',
			'Русская Селитьба': '84657',
			'Русский Байтуган': '84664',
			'Русско-Добрино': '84653',
			'Самовольно-Ивановка': '84671',
			'Светлое Поле': '84657',
			'Северный Ключ': '84656',
			'Семеново-Шарла': '84652',
			'Солнечная Поляна': '84862',
			'Сосновый Солонец': '84862',
			'Среднее Аверкино': '84656',
			'Старая Балыкла': '84664',
			'Старая Бинарадка': '84657',
			'Старая Дмитриевка': '84655',
			'Старая Ивановка': '84650',
			'Старая Рачейка': '8464',
			'Старая Таволжанка': '84667',
			'Старая Чесноковка': '84654',
			'Старая Шентала': '84652',
			'Старое Аделяково': '84651',
			'Старое Афонькино': '84652',
			'Старое Вечканово': '84654',
			'Старое Ермаково': '84664',
			'Старое Максимкино': '84650',
			'Старое Резяпкино': '84653',
			'Старое Семенкино': '84653',
			'Старое Суркино': '84652',
			'Старое Усманово': '84664',
			'Старое Эштебенькино': '84651',
			'Старое Якушкино': '84655',
			'Старые Сосны': '84653',
			'Старый Аманак': '84656',
			'Старый Байтермиш': '84653',
			'Старый Буян': '84657',
			'Старый Маклауш': '84653',
			'Старый Тукшум': '84648',
			'Старый Шунгут': '84654',
			'Степная Шантала': '84650',
			'Сухарь-Матак': '84654',
			'Сухая Вязовка': '846',
			'Сухие Аврали': '84658',
			'Татарское Абдикеево': '84652',
			'Таш-Кустьяново': '84673',
			'Теплый Стан': '84658',
			'Тяглое Озеро': '84674',
			'Усть-Кинельский': '84663',
			'Челно-Вершины': '84651',
			'Черный Ключ': '84653',
			'Чувашское Урметьево': '84651',
			'село Калиновка': '84655',
			Абашево: '84677',
			Авангард: '84671',
			Августовка: '84672',
			Аверьяновка: '84666',
			Аверьяновский: '84672',
			Аксаково: '84652',
			Алакаевка: '84663',
			Алексеевка: '84671',
			Алексеевский: '84675',
			Алькино: '84656',
			Андреевка: '84666',
			Андросовка: '84675',
			Антоновка: '84655',
			Апальково: '84650',
			Арзамасцевка: '84666',
			Арсентьевка: '84675',
			Артюшкино: '84652',
			Ахрат: '84656',
			Багана: '84652',
			Багряш: '84654',
			Байдеряково: '84648',
			Баландаево: '84652',
			Балахоновка: '84653',
			Балашейка: '8464',
			Бариновка: '84670',
			Бахилово: '84862',
			Безенчук: '84676',
			Беловка: '84666',
			Белозерка: '84657',
			Береговой: '84648',
			Березки: '846',
			Березняки: '84660',
			Березовка: '84658',
			Бестужевка: '84647',
			Бичевной: '84648',
			Благодаровка: '84667',
			Благодатовка: '84672',
			Бобровка: '84663',
			Богатое: '84666',
			Богатырь: '84862',
			Богородское: '84660',
			Борма: '84658',
			Боровка: '84655',
			Борское: '84667',
			Братский: '84675',
			Брусяны: '84862',
			Бузаевка: '84663',
			Валы: '84862',
			Варламово: '8464',
			Верхнесъезжее: '84670',
			Виловатое: '84666',
			Владимировка: '84677',
			Водино: '84657',
			Волжский: '84657',
			Волчанка: '84675',
			Воротнее: '84655',
			Воскресенка: '846',
			Восточный: '84672',
			Выползово: '846',
			Выселки: '84862',
			Высокое: '84674',
			Вязовка: '84658',
			Гавриловка: '84671',
			Гвардейцы: '84667',
			Георгиевка: '84663',
			Герасимовка: '84671',
			Глушицкий: '84672',
			Гостевка: '84667',
			Гражданский: '84675',
			Грачевка: '84663',
			Давыдовка: '84647',
			Девлезеркино: '84651',
			Демидовка: '8464',
			Денискино: '84652',
			Дмитриевка: '84670',
			Долматовка: '84667',
			Домашка: '84663',
			Дудачный: '846',
			Елань: '84677',
			Елховка: '84658',
			Елшанка: '84655',
			Емелькино: '84652',
			Ерзовка: '84660',
			Ерилкино: '84653',
			Жемковка: '8464',
			Жигули: '84862',
			Жигулёвск: '84862',
			Заборовка: '8464',
			Заволжье: '84647',
			Залесье: '84650',
			Заливное: '84666',
			Заплавное: '84667',
			Захаркино: '84655',
			Звезда: '84676',
			Зеленовка: '84862',
			Зеленовский: '84654',
			Землянки: '84667',
			Зольное: '84862',
			Зубовка: '84651',
			Зубчаниновка: '846',
			Зуевка: '84670',
			Ивашевка: '8464',
			Идакра: '84674',
			Ильмень: '84647',
			Иргизский: '84672',
			Исаклы: '84654',
			Исаково: '84656',
			Кабановка: '84660',
			Калашиновка: '84671',
			Каменка: '84652',
			Камышинка: '84648',
			Камышла: '84664',
			Кандабулак: '84655',
			Кануевка: '84676',
			Кашпир: '84647',
			Киндяково: '84657',
			Кинель: '84663',
			Кинельский: '84663',
			Кирилловка: '84862',
			Кировский: '84675',
			Климовка: '84648',
			Ключи: '84654',
			Клявлино: '84653',
			Кобзевка: '84673',
			Колодинка: '84657',
			Колокольцовка: '84675',
			Колывань: '84675',
			Комаровка: '84648',
			Коммунарский: '84657',
			Кондурча: '84652',
			Конезавод: '84657',
			Коноваловка: '84667',
			Константиновка: '84673',
			Корнеевка: '84671',
			Костино: '84672',
			Коханы: '84660',
			Кошелевка: '8464',
			Кошки: '84650',
			Красноармейское: '84675',
			Краснооктябрьский: '84672',
			Красносамарское: '84663',
			Красноселки: '84676',
			Красносельское: '84655',
			Краснояриха: '84651',
			Кротково: '84656',
			Кротовка: '84660',
			Кузькино: '84648',
			Куйбышевский: '84675',
			Кулешовка: '84670',
			Купино: '84676',
			Кураповка: '84666',
			Курумоч: '846',
			Кутузовский: '84655',
			Кяхта: '84648',
			Ленинский: '84675',
			Летниково: '84671',
			Лозовка: '84660',
			Ломовка: '84674',
			Луначарский: '84862',
			Львовка: '84648',
			Любицкий: '84675',
			Маза: '84648',
			Майское: '84674',
			Максимовка: '84666',
			Малоархангельское: '84674',
			Малячкино: '84648',
			Мамыково: '84650',
			Масленниково: '84677',
			Маяк: '84635',
			Междуреченск: '84646',
			Михайловка: '84657',
			Михеевка: '84674',
			Мокша: '84673',
			Молгачи: '84657',
			Морша: '84673',
			Мосты: '84674',
			Мочалеевка: '84656',
			Мулловка: '84658',
			Муранка: '84648',
			Мусорка: '84862',
			Муханово: '84660',
			Мыльная: '84676',
			Надеждино: '84650',
			Назаровка: '84653',
			Натальино: '84676',
			Неклюдово: '84664',
			Неприк: '84667',
			Нероновка: '84655',
			Несмеяновка: '84671',
			Нефтегорск: '84670',
			Нижнеаверкино: '84656',
			Нижнеозерецкий: '84647',
			Нижнепечерское: '84647',
			Никитинка: '84658',
			Никиткино: '84664',
			Николаевка: '846',
			Никольское: '84676',
			Новинки: '846',
			Новоборский: '84667',
			Новогеранькино: '84667',
			Новодевичье: '84648',
			Новокашпирский: '8464',
			Новокуйбышевск: '84635',
			Новокуровка: '84677',
			Новомихайловка: '84676',
			Новопавловка: '84673',
			Новосемейкино: '84657',
			Новоспасский: '84647',
			Новотулка: '84677',
			Образцовое: '8464',
			Обшаровка: '84647',
			Озерецкое: '84647',
			Озерки: '84651',
			Октябрьск: '84646',
			Октябрьский: '84656',
			Ольгино: '84676',
			Орловка: '84650',
			Осинки: '84676',
			Осиновка: '84862',
			Островка: '84650',
			Отрадный: '84661',
			Павловка: '84675',
			Падовка: '84674',
			Парфеновка: '84663',
			Патровка: '84671',
			Пензено: '84672',
			Первокоммунарский: '84671',
			Первомайский: '84660',
			Первомайское: '84656',
			Переволоки: '84676',
			Песочное: '84676',
			Пестравка: '84674',
			Петровка: '84653',
			Петровский: '84672',
			Печерское: '8464',
			Печинино: '84666',
			Пионерский: '84648',
			Пискалы: '84862',
			Платоновка: '84648',
			Погрузная: '84650',
			Подбельск: '84656',
			Подвалье: '84648',
			Подгорное: '84667',
			Подсолнечное: '84667',
			Подстепки: '84862',
			Полудни: '84660',
			Поляков: '84672',
			Похвистнево: '84656',
			Преображенка: '846',
			Преполовенка: '84676',
			Прибой: '84676',
			Прибрежный: '846',
			Приволжье: '84647',
			Привольный: '84676',
			Придорожный: '846',
			Приморский: '84862',
			Прогресс: '84677',
			Пролейка: '84658',
			Пронино: '84653',
			Просвет: '846',
			Пустовалово: '84660',
			Рамено: '8464',
			Рахмановка: '84650',
			Репьевка: '84660',
			Рождествено: '846',
			Рощинский: '846',
			Рысайкино: '84656',
			Савруха: '84656',
			Садгород: '84660',
			Салейкино: '84652',
			Самара: '846',
			Самарский: '846',
			Самсоновка: '84654',
			Саперкино: '84654',
			Сарбай: '84660',
			Сборный: '8464',
			Светлодольск: '84655',
			Севрюкаево: '84862',
			Сенькино: '84652',
			Сергиевск: '84655',
			Серноводск: '84655',
			Сиделькино: '84651',
			Сидоровка: '84655',
			Сколково: '84663',
			Славкино: '84655',
			Смагино: '84652',
			Смолькино: '8464',
			Смольково: '84654',
			Смышляевка: '846',
			Соковнинка: '84667',
			Сокский: '84654',
			Сосновка: '84656',
			Софьино: '84647',
			Спиридоновка: '846',
			Старомансуркино: '84656',
			Старопохвистнево: '84656',
			Степановка: '84664',
			Степняки: '84647',
			Строганькино: '84656',
			Стройкерамика: '846',
			Студенцы: '84677',
			Стюхино: '84656',
			Субботинский: '84671',
			Султангулово: '84656',
			Сургут: '84655',
			Суринск: '84648',
			Суходол: '84655',
			Съезжее: '84666',
			Сызрань: '8464',
			Сырейка: '84663',
			Таволжанка: '84667',
			Тайдаково: '84648',
			Тамбовка: '84673',
			Ташелка: '84862',
			Ташла: '84862',
			Тепловка: '84674',
			Тимашево: '84660',
			Тимофеевка: '84862',
			Тимяшево: '84652',
			Токмакла: '84651',
			Толстовка: '84676',
			Тольятти: '8482',
			Томанский: '84647',
			Торновое: '846',
			Торшиловский: '84672',
			Тоузаково: '84660',
			Тридцатый: '846',
			Тростянь: '84674',
			Трофимовка: '84670',
			Трубетчино: '8464',
			Туарма: '84652',
			Убейкино: '84654',
			Угловой: '84657',
			Узюково: '84862',
			Украинка: '84672',
			Усакла: '84653',
			Усинское: '8464',
			Усманка: '84667',
			Усолье: '84648',
			Успенка: '84655',
			Утевка: '84670',
			Федоровка: '84647',
			Фрунзенский: '84673',
			Хворостянка: '84677',
			Хилково: '84657',
			Хорошенькое: '84657',
			Хрящевка: '84862',
			Центральный: '84666',
			Чагра: '84677',
			Чапаево: '84657',
			Чапаевск: '84639',
			Чапаевский: '84675',
			Чекалино: '8464',
			Черновка: '84655',
			Черновский: '846',
			Черноречье: '846',
			Четырла: '84652',
			Четыровка: '84650',
			Чистовка: '84651',
			Чубовка: '84663',
			Чувичи: '84677',
			Шариповка: '84671',
			Шелашниково: '84652',
			Шентала: '84652',
			Шигоны: '84648',
			Шилан: '84657',
			Широченка: '84667',
			Ширяево: '84862',
			Шламка: '84651',
			Шпановка: '84650',
			Шумовский: '84672',
			Южный: '84673',
			Ягодное: '84862',
			Языково: '84667'
		}
	},
	'Санкт-Петербург': {
		regionCode: '812',
		cities: {
			'Красное Село': '812',
			'Лисий Нос': '812',
			'Петропавловская крепость': '812',
			'посёлок Тярлево': '812',
			'Санкт-Петербург': '812',
			'Усть-Ижора': '812',
			'Усть-Славянка': '812',
			Горелово: '812',
			Зеленогорск: '812',
			Колпино: '812',
			Кронштадт: '812',
			Ломоносов: '812',
			Металлострой: '812',
			Павловск: '812',
			Парголово: '812',
			Песочный: '812',
			Петергоф: '812',
			Понтонный: '812',
			Пушкин: '812',
			Репино: '812',
			Сестрорецк: '812',
			Стрельна: '812',
			Шушары: '812'
		}
	},
	'Саратовская область': {
		regionCode: '845',
		cities: {
			'Акатная Маза': '84595',
			'Александров Гай': '84578',
			'Базарный Карабулак': '84591',
			'Березина Речка': '8452',
			'Березовая Лука': '84573',
			'Большая Гусиха': '84591',
			'Большая Дмитриевка': '84551',
			'Большая Екатериновка': '84552',
			'Большая Журавка': '84542',
			'Большая Ивановка': '84558',
			'Большая Каменка': '84558',
			'Большая Ольшанка': '84549',
			'Большая Осиновка': '84552',
			'Большая Рельня': '84551',
			'Большая Сакма': '84577',
			'Большая Таволожка': '84574',
			'Большая Федоровка': '84558',
			'Большая Чечуйка': '84591',
			'Большие Копены': '84551',
			'Большие Озерки': '84592',
			'Большой Карай': '84544',
			'Большой Кушум': '8453',
			'Большой Мелик': '84545',
			'Бороно-Михайловка': '84543',
			'Быков Отрог': '8453',
			'Верхний Еруслан': '84560',
			'Верхний Кушум': '84564',
			'Верхняя Чернавка': '84593',
			'Грачев Куст': '84575',
			'Дубовый Гай': '84595',
			'Заветы Ильича': '8453',
			'Зеленый Дол': '8453',
			'Земляные Хутора': '84552',
			'Карамыш-Станция': '84550',
			'Красная Звезда': '84540',
			'Красная Кудрявка': '84545',
			'Красная Речка': '84574',
			'Красное Знамя': '84542',
			'Красный Боец': '84564',
			'Красный Кут': '84560',
			'Красный Октябрь': '8452',
			'Красный Текстильщик': '8452',
			'Криволучье-Сура': '8453',
			'Курган Первый': '84540',
			'Куриловка Станция': '84593',
			'Лобки Вторые': '84564',
			'Луков Кордон': '84578',
			'Лысые Горы': '84551',
			'Малая Быковка': '8453',
			'Малая Екатериновка': '84549',
			'Малая Семеновка': '84545',
			'Малое Щербедино': '84544',
			'Малые Копены': '84552',
			'Малый Мелик': '84545',
			'Малый Узень': '84561',
			'Марьино-Лашмино': '84557',
			'Мизино-Лапшиновка': '84558',
			'Мордовский Карай': '84544',
			'Натальин Яр': '84575',
			'Нижняя Банновка': '84550',
			'Нижняя Покровка': '84575',
			'Нижняя Чернавка': '84593',
			'Никольское-Казаково': '8453',
			'Новая Алексеевка': '84568',
			'Новая Елюзань': '8453',
			'Новая Ивановка': '84549',
			'Новая Красавка': '84551',
			'Новая Краснянка': '84564',
			'Новая Лопастейка': '84592',
			'Новая Порубежка': '84574',
			'Новые Бурасы': '84557',
			'Новые Выселки': '84549',
			'Орлов Гай': '84564',
			'Осинов Гай': '84564',
			'Перевесино-Михайловка': '84543',
			'Репная Вершина': '84545',
			'Римско-Корсаковка': '84577',
			'Семено-Полтавка': '84564',
			'Сланцевый Рудник': '84576',
			'Сосновая Маза': '84595',
			'Станция Курдюм': '84558',
			'Старая Жуковка': '84591',
			'Старая Лебежайка': '84595',
			'Старая Порубежка': '84574',
			'Старая Топовка': '84550',
			'Старая Яблонка': '84595',
			'Старые Бурасы': '84591',
			'Старые Озинки': '84576',
			'Старый Хопер': '84545',
			'Сухая Елань': '84545',
			'Сухой Карабулак': '84591',
			'Сухой Отрог': '8453',
			'Труевая Маза': '84593',
			'Усть-Золиха': '84550',
			'Усть-Курдюм': '8452',
			'Усть-Шербедино': '84544',
			'Ханеневка Первая': '84591',
			'Черная Падина': '84564',
			'Черный Затон': '84595',
			'Шило-Голицыно': '84540',
			'Широкий Уступ': '84549',
			'Юловая Маза': '84593',
			'Яблоновый Гай': '84579',
			'Ягодная Поляна': '84558',
			Агафоновка: '84561',
			Алгайский: '84562',
			Александровский: '84545',
			Алексашино: '84561',
			Алексеевский: '84544',
			Алмазово: '84545',
			Алтала: '84563',
			Альшанка: '84554',
			Анастасьино: '84549',
			Андреевка: '84568',
			Анисовский: '8453',
			Антоновка: '84563',
			Апалиха: '84595',
			Арбузовка: '84579',
			Аркадак: '84542',
			Аряш: '84557',
			Асметовка: '84555',
			Атаевка: '84551',
			Аткарск: '84552',
			Афанасьевка: '84568',
			Ахмат: '84560',
			Ахтуба: '84549',
			Багаевка: '8452',
			Баклуши: '84542',
			Бакуры: '84554',
			Балаково: '8453',
			Балаши: '84576',
			Балашов: '84545',
			Балтай: '84592',
			Барки: '84545',
			Барнуковка: '84592',
			Бартеневка: '84579',
			Баскатовка: '84567',
			Безымянное: '8453',
			Белоглинный: '84576',
			Белогорное: '84593',
			Белоярский: '84557',
			Березняки: '84568',
			Березово: '84574',
			Благовещенка: '84548',
			Благодатное: '84595',
			Бобылевка: '84544',
			Богатое: '84593',
			Богородское: '84573',
			Борисоглебовка: '84565',
			Бородаевка: '84567',
			Боцманово: '84543',
			Брыковка: '84573',
			Букатовка: '84568',
			Булгаковка: '84568',
			Бурасы: '84557',
			Бутурлинка: '84554',
			Бык: '84544',
			Варфоломеевка: '84578',
			Варыпаевка: '84552',
			Васильевка: '84564',
			Ваулино: '84550',
			Верхазовка: '84563',
			Взлетный: '8453',
			Владимирский: '84596',
			Владыкино: '84540',
			Водопьяновка: '84567',
			Вознесенка: '84567',
			Возрождение: '84595',
			Вольск: '84593',
			Воронино: '84548',
			Воронцовка: '84554',
			Воскресенское: '84568',
			Восточный: '84563',
			Выдвиженец: '84540',
			Высокое: '84550',
			Вяжля: '84552',
			Вязьмино: '84555',
			Галахово: '84554',
			Генеральское: '8453',
			Георгиевка: '84567',
			Головановский: '8453',
			Головинщено: '84577',
			Горный: '84577',
			Горюши: '84595',
			Горяиновка: '84573',
			Грачи: '8453',
			Гремячий: '84551',
			Гремячка: '84557',
			Гривки: '84554',
			Григорьевка: '84573',
			Гусевка: '84545',
			Гусево: '84550',
			Давыдовка: '84574',
			Данилкино: '84545',
			Даниловка: '84552',
			Двоенка: '84551',
			Демьяс: '84563',
			Дергачи: '84563',
			Динамовский: '84557',
			Долина: '84565',
			Донгуз: '84592',
			Дубки: '8452',
			Дубовка: '84550',
			Дубравный: '84549',
			Дуплятка: '84545',
			Духовницкое: '84573',
			Дьяковка: '84560',
			Дюрский: '84562',
			Екатериновка: '84554',
			Еланка: '8453',
			Елань: '84540',
			Елизаветино: '84552',
			Еловатка: '84548',
			Елховка: '84595',
			Еремеевка: '84564',
			Еруслан: '84565',
			Ершов: '84564',
			Ерышевка: '84540',
			Жадовка: '84563',
			Жасминный: '8452',
			Ждановка: '84560',
			Жестянка: '84574',
			Жулидово: '84564',
			Журавлевка: '84560',
			Журавлиха: '84592',
			Заволжский: '84574',
			Загородный: '84560',
			Залесянка: '84548',
			Запрудное: '84561',
			Заречное: '84545',
			Заречный: '84574',
			Заря: '84567',
			Звонаревка: '84567',
			Зерновой: '84563',
			Знаменский: '84579',
			Золотое: '84550',
			Зоринский: '8452',
			Зоркино: '84567',
			Иваниха: '84575',
			Ивановский: '8452',
			Ивантеевка: '84579',
			Идолга: '84558',
			Индустриальный: '84554',
			Интернациональное: '84560',
			Инясево: '84544',
			Ириновка: '84557',
			Казанла: '84591',
			Казачка: '84549',
			Калдино: '84565',
			Калинин: '84575',
			Калининск: '84549',
			Калининское: '84567',
			Калмантай: '84593',
			Камелик: '84574',
			Каменский: '84550',
			Камышево: '84563',
			Камышки: '84578',
			Канавка: '84578',
			Канаевка: '84579',
			Караман: '84567',
			Карамышевка: '84550',
			Карамышка: '84558',
			Кардаил: '84545',
			Карловка: '84574',
			Карпенка: '84560',
			Квасниковка: '8453',
			Кипцы: '84554',
			Кировское: '84567',
			Кистендей: '84542',
			Клевенка: '84579',
			Клещевка: '8452',
			Клинцовка: '84574',
			Кожевино: '84555',
			Козловка: '84561',
			Колено: '84554',
			Колки: '84555',
			Колокольцовка: '84549',
			Колос: '84567',
			Колояр: '84593',
			Колычево: '84543',
			Комаровка: '84554',
			Коминтерн: '8453',
			Конный: '84545',
			Кормежка: '8453',
			Корнеевка: '84577',
			Котоврас: '84545',
			Кочетное: '84596',
			Кочетовка: '84552',
			Красавка: '84548',
			Красноармейск: '84550',
			Красноармейский: '84544',
			Красноармейское: '84549',
			Краснознаменский: '84548',
			Красноозерный: '84563',
			Краснянка: '84564',
			Кривояр: '84596',
			Крутояр: '84554',
			Кручи: '84554',
			Кряжим: '84593',
			Курдюм: '84558',
			Кутьино: '84557',
			Кучумбетово: '84575',
			Кушумский: '84564',
			Лавровка: '84560',
			Лебедевка: '84560',
			Лебедево: '8453',
			Левенка: '84573',
			Леляевка: '84557',
			Ленинское: '8453',
			Лепехинка: '84560',
			Лесное: '84545',
			Летяжевка: '84542',
			Липовский: '84576',
			Логиновка: '84560',
			Лопатино: '84540',
			Лох: '84557',
			Луганское: '84550',
			Луговское: '84596',
			Лунино: '84543',
			Луч: '84540',
			Любимово: '84566',
			Любицкое: '84574',
			Макарово: '84540',
			Максимовка: '84591',
			Малоперекопное: '8453',
			Маркс: '84567',
			Марфино: '84552',
			Марьевка: '84564',
			Марьино: '84543',
			Матвеевка: '8453',
			Маянга: '8453',
			Междуречье: '84593',
			Меловое: '84550',
			Мечетное: '84566',
			Мещеряковка: '84542',
			Милорадовка: '84577',
			Мирный: '84563',
			Мироновка: '84561',
			Миусс: '84564',
			Модин: '84576',
			Мокроус: '84565',
			Молодежный: '84575',
			Монастырское: '84549',
			Мордово: '84550',
			Моховое: '84564',
			Муммовка: '84552',
			Надеждинка: '84574',
			Наливная: '84566',
			Натальино: '8453',
			Наумовка: '8453',
			Невежкино: '84551',
			Нееловка: '84558',
			Некрасово: '84550',
			Непряхин: '84576',
			Нива: '84561',
			Нижегороды: '84549',
			Николевка: '8453',
			Никольское: '84573',
			Новодубровка: '84555',
			Новозаволжский: '84576',
			Новокривовка: '84566',
			Новониколаевский: '8453',
			Новопокровское: '84545',
			Новополеводино: '8453',
			Новопушкинское: '8453',
			Новорепное: '84564',
			Новореченский: '84561',
			Новоросляевка: '84563',
			Новоселовка: '84554',
			Новосельский: '84564',
			Новосельское: '84542',
			Новотулка: '84561',
			Новоузенск: '84562',
			Новочерниговка: '84576',
			Новояблонка: '84595',
			Ножкино: '84555',
			Озерное: '84552',
			Озинки: '84576',
			Олоновка: '84562',
			Оркино: '84555',
			Орловское: '84567',
			Орошаемый: '84563',
			Осиновка: '84544',
			Осиновский: '84567',
			Основной: '84562',
			Павловка: '84567',
			Пады: '84545',
			Паницкая: '84550',
			Первоцелинный: '84576',
			Перевесинка: '84543',
			Переезд: '84554',
			Перекопное: '84564',
			Перелюб: '84575',
			Песчаный: '84549',
			Петрово: '84552',
			Петровск: '84555',
			Пигари: '84576',
			Пилюгино: '84592',
			Пинеровка: '84545',
			Питерка: '84561',
			Плес: '84565',
			Плеханы: '8453',
			Пограничное: '84562',
			Подлесное: '84567',
			Подснежный: '84557',
			Подсосенки: '8453',
			Подстепное: '8453',
			Покровка: '84593',
			Покурлей: '84593',
			Полеводинский: '84573',
			Полековское: '84567',
			Полоцкое: '84548',
			Полтавка: '84548',
			Полчаниновка: '84558',
			Потьма: '84540',
			Преображенка: '84574',
			Привольное: '84596',
			Пригорки: '84575',
			Пригородный: '84555',
			Придорожный: '8453',
			Приречное: '84552',
			Пристанное: '8452',
			Приузенский: '84578',
			Пробуждение: '8453',
			Прокудино: '84552',
			Прудовой: '84554',
			Пугачёв: '84574',
			Пушкино: '84566',
			Пылковка: '8453',
			Радищево: '84562',
			Раевка: '84579',
			Раскатово: '84567',
			Расково: '8452',
			Рассказань: '84545',
			Рахмановка: '84574',
			Ревино: '84550',
			Рекорд: '84560',
			Репьевка: '84540',
			Рефлектор: '84564',
			Ровное: '84596',
			Рогаткино: '84550',
			Родионовка: '84577',
			Родничек: '84545',
			Розовое: '84566',
			Романовка: '84544',
			Ромашевка: '84543',
			Росташи: '84542',
			Ртищево: '84540',
			Ртищевский: '84540',
			Рукополь: '84577',
			Рыбушка: '8452',
			Рязанка: '84543',
			Сабуровка: '8452',
			Савкино: '84555',
			Садовка: '84592',
			Садовое: '84550',
			Сазоново: '84552',
			Салтыковка: '84540',
			Салтыково: '84549',
			Самойловка: '84548',
			Сапожок: '84540',
			Саратов: '8452',
			Сафаровка: '84563',
			Свердлово: '84549',
			Светлый: '84558',
			Свободный: '84591',
			Святославка: '84548',
			Северка: '84540',
			Северный: '84595',
			Селитьба: '84595',
			Семенной: '84560',
			Сенной: '84593',
			Сергиевка: '84549',
			Сергиевский: '8452',
			Симоновка: '84549',
			Синегорский: '84576',
			Синодское: '84568',
			Сиротка: '84543',
			Скатовка: '84596',
			Славновка: '84549',
			Сланцы: '84540',
			Сластуха: '84554',
			Слепцовка: '84558',
			Смородинка: '84575',
			Советский: '84563',
			Советское: '84566',
			Содом: '84591',
			Соколовый: '8452',
			Сокур: '84558',
			Солнечный: '84565',
			Солянка: '84576',
			Солянский: '84574',
			Софьинка: '84573',
			Софьино: '84542',
			Соцземледельский: '84545',
			Спартак: '84565',
			Спасское: '84593',
			Сплавнуха: '84550',
			Степное: '84566',
			Степной: '84549',
			Столыпино: '84592',
			Сторожевка: '84558',
			Стригай: '84591',
			Студенка: '84543',
			Студеновка: '84568',
			Студеный: '84555',
			Сулак: '84577',
			Таволжанка: '84544',
			Таволожка: '84555',
			Талалихино: '84593',
			Таловка: '84549',
			Тамбовка: '84565',
			Тарлыковка: '84596',
			Тарханым: '8452',
			Татищево: '84558',
			Телековка: '84573',
			Темп: '84540',
			Тепличный: '8452',
			Тепловский: '84575',
			Тепляковка: '84591',
			Терса: '84593',
			Тимонин: '84563',
			Титоренко: '8453',
			Толстовка: '84577',
			Тополевый: '84593',
			Тракторный: '84555',
			Тростянка: '84545',
			Трубетчино: '84543',
			Трудовик: '84561',
			Тургенево: '84552',
			Тургеневский: '84574',
			Турки: '84543',
			Узморье: '8453',
			Ульянино: '84595',
			Умет: '84552',
			Упоровка: '84554',
			Урицкое: '84551',
			Урусово: '84540',
			Усатово: '84560',
			Усовка: '84568',
			Успенка: '84574',
			Устиновка: '84545',
			Учебный: '84564',
			Федоровка: '84565',
			Фурманово: '84567',
			Харитоновка: '84575',
			Хвалынск: '84595',
			Хватовка: '84591',
			Хлебновка: '8453',
			Хмелевский: '8452',
			Холманка: '84575',
			Хоперское: '84545',
			Хрущевка: '84548',
			Царевщина: '84592',
			Чадаевка: '84551',
			Чапаевка: '84564',
			Чапаевский: '84574',
			Чапушка: '84542',
			Чардым: '84568',
			Черкасское: '84593',
			Чернава: '84579',
			Чернавка: '84543',
			Чиганак: '84542',
			Чистопольский: '84577',
			Чугунка: '84564',
			Шебалов: '84542',
			Шепелевка: '84543',
			Шереметьевка: '84551',
			Шиловка: '84554',
			Широкое: '84558',
			Широкополье: '8453',
			Шиханы: '84593',
			Шклово: '84549',
			Шняево: '84591',
			Шумейка: '8453',
			Энгельс: '8453',
			Юбилейный: '84554',
			Южный: '84564',
			Яблоновка: '84596',
			Яблочный: '84551',
			Языковка: '84552',
			Яковлевка: '84591',
			Ямское: '84560',
			Ястребовка: '84567'
		}
	},
	'Сахалинская область': {
		regionCode: '424',
		cities: {
			'Адо-Тымово': '42447',
			'Александровск-Сахалин.': '42434',
			'Александровск-Сахалинский': '42434',
			'Арги-Паги': '42447',
			'Горячие Ключи': '42454',
			'Горячий Пляж': '42455',
			'Красная Тымь': '42447',
			'Новые Лангры': '42437',
			'Северо-Курильск': '42453',
			'Третья Падь': '42435',
			'Южно-Курильск': '42455',
			'Южно-Сахалинск': '4242',
			Айнское: '42446',
			Анива: '42441',
			Арково: '42434',
			Березняки: '4242',
			Бошняково: '42432',
			Буюклы: '42452',
			Быков: '42442',
			Вал: '42444',
			Вахрушев: '42431',
			Взморье: '42442',
			Виахту: '42434',
			Владимировка: '42434',
			Воскресеновка: '42447',
			Восток: '42431',
			Восход: '42447',
			Гастелло: '42431',
			Головнино: '42455',
			Горнозаводск: '42436',
			Дальнее: '4242',
			Дачное: '42435',
			Долинск: '42442',
			Дуэ: '42434',
			Зональное: '42447',
			Ильинский: '42446',
			Иркир: '42447',
			Катангли: '42444',
			Кировское: '42447',
			Колендо: '42437',
			Колхозное: '42436',
			Корсаков: '42435',
			Костромское: '42433',
			Крабозаводское: '42455',
			Красногорск: '42446',
			Краснополье: '42432',
			Курильск: '42454',
			Леонидово: '42431',
			Лесное: '42435',
			Лесогорск: '42432',
			Лопатино: '42446',
			Макаров: '42443',
			Малиновка: '42431',
			Малокурильское: '42455',
			Мгачи: '42434',
			Михайловка: '42434',
			Молодежное: '42447',
			Москальво: '42437',
			Невельск: '42436',
			Некрасовка: '42437',
			Никольское: '42432',
			Новиково: '42435',
			Новое: '42443',
			Новоселово: '42446',
			Новосибирское: '42433',
			Новотроицкое: '42441',
			Ноглики: '42444',
			Ныш: '42444',
			Огоньки: '42441',
			Озерский: '42435',
			Ольховка: '42432',
			Ольшанка: '42432',
			Онор: '42452',
			Оха: '42437',
			Охотское: '42435',
			Парусное: '42446',
			Пензенское: '42446',
			Первомайск: '42452',
			Петропавловское: '42441',
			Пильво: '42452',
			Пильтун: '42437',
			Пионеры: '42433',
			Пихтовый: '42435',
			Победино: '42452',
			Покровка: '42442',
			Поречье: '42432',
			Поронайск: '42431',
			Правда: '42433',
			Приозерный: '42432',
			Пятиречье: '42433',
			Раздольное: '42435',
			Рейдово: '42454',
			Рощино: '42452',
			Рыбновск: '42437',
			Сабо: '42437',
			Санаторный: '4242',
			Синегорск: '4242',
			Слава: '42447',
			Смирных: '42452',
			Советское: '42442',
			Сокол: '42442',
			Соловьевка: '42435',
			Стародубское: '42442',
			Танги: '42434',
			Таранай: '42441',
			Тельновский: '42432',
			Тихменево: '42431',
			Томари: '42446',
			Троицкое: '42441',
			Трудовое: '42431',
			Тунгор: '42437',
			Тымовское: '42447',
			Углегорск: '42432',
			Углезаводск: '42442',
			Ударный: '42432',
			Успенское: '42441',
			Холмск: '42433',
			Хоэ: '42434',
			Чапаево: '42435',
			Чапланово: '42433',
			Черемшанка: '42446',
			Чехов: '42433',
			Шахтёрск: '42432',
			Шебунино: '42436',
			Яблочный: '42433',
			Ясное: '42447',
			Ясноморский: '42436'
		}
	},
	'Свердловская область': {
		regionCode: '343',
		cities: {
			'Большая Выя': '34342',
			'Большая Кочевка': '34355',
			'Большое Пульниково': '34375',
			'Большой Исток': '34374',
			'Большой Рамыл': '34367',
			'Большой Турыш': '34394',
			'Большой Ут': '34391',
			'Буткинское Озеро': '34371',
			'Верх-Нейвинский': '34356',
			'Верх-Тиса': '34391',
			'Верхнее Дуброво': '34377',
			'Верхние Серги': '34398',
			'Верхний Потам': '34391',
			'Верхний Тагил': '34357',
			'Верхний Талман': '34371',
			'Верхняя Пышма': '34368',
			'Верхняя Салда': '34345',
			'Верхняя Синячиха': '34346',
			'Верхняя Тура': '34344',
			'Висимо-Уткинск': '3435',
			'Вновь-Юрмытское': '34371',
			'Вогулка-Станция': '34358',
			'Всеволодо-Благодатское': '34380',
			'Горный Щит': '343',
			'Каквинские Печи': '34383',
			'Каменск-Уральский': '3439',
			'Косой Брод': '34350',
			'Красный Яр': '34388',
			'Курорт Самоцвет': '34346',
			'Малая Тавра': '34391',
			'Малые Карзи': '34391',
			'Марийские Карши': '34391',
			'Нейво-Рудянка': '34357',
			'Нейво-Шайтанский': '34346',
			'Нижние Серги': '34398',
			'Нижние Таволги': '34356',
			'Нижний Арий': '34391',
			'Нижний Бардым': '34391',
			'Нижний Катарач': '34371',
			'Нижний Тагил': '3435',
			'Нижняя Иленка': '34362',
			'Нижняя Салда': '34345',
			'Нижняя Синячиха': '34346',
			'Нижняя Тура': '34342',
			'Николо-Павловское': '3435',
			'Новая Ляля': '34388',
			'Новое Село': '34394',
			'Новый Бугалыш': '34375',
			'Новый Быт': '3439',
			'Новый Златоуст': '34391',
			'Покровск-Уральский': '34380',
			'Прокопьевская Салда': '34389',
			'Пушкарево Первое': '34361',
			'Русская Тавра': '34394',
			'Русские Карши': '34391',
			'Русский Потам': '34391',
			'Русский Усть-Маш': '34394',
			'Сарсы Вторые': '34394',
			'Сосновый Бор': '34363',
			'Средний Баяк': '34394',
			'Средний Бугалыш': '34394',
			'Станционный-Полевской': '34350',
			'Старая Ляля': '34388',
			'Старая Сама': '34386',
			'Старые Арти': '34391',
			'Сухой Лог': '34373',
			'Татарская Еманзельга': '34394',
			'Третий Северный': '34380',
			'Туринская Слобода': '34361',
			'Унже-Павинская': '34347',
			'Усть-Баяк': '34394',
			'Усть-Манчаж': '34391',
			'Усть-Ницинское': '34361',
			'Усть-Салда': '34389',
			'Усть-Утка': '3435',
			'Усть-Югуш': '34391',
			'Черный Яр': '34388',
			'Широкая Речка': '343',
			'поселок Верх-Нейвинский': '34370',
			'поселок Верхняя Синячиха': '34346',
			'село Мугай': '34346',
			Азанка: '34360',
			Азиатская: '34344',
			Азигулово: '34391',
			Акбаш: '34398',
			Акинфиево: '34345',
			Алапаевск: '34346',
			Александровское: '34394',
			Алтынай: '34373',
			Андриановичи: '34385',
			Андрюшино: '34387',
			Аракаево: '34398',
			Арамашка: '34364',
			Арамиль: '34374',
			Аромашево: '34346',
			Артемовский: '34363',
			Арти: '34391',
			Артёмовский: '34363',
			Асбест: '34365',
			Асбестовский: '34346',
			Атиг: '34398',
			Атымья: '34386',
			Афанасьевский: '34391',
			Афанасьевское: '34391',
			Ачит: '34391',
			Аятское: '34356',
			Аять: '34356',
			Багышково: '34391',
			Баженовское: '34362',
			Байкалово: '34362',
			Байны: '34376',
			Бакряж: '34391',
			Балаир: '34371',
			Балтым: '34368',
			Бараба: '34376',
			Баранчинский: '34344',
			Басмановское: '34371',
			Басьяновский: '34345',
			Башкарка: '3435',
			Баяновка: '34380',
			Белокаменный: '34365',
			Белореченский: '34377',
			Белоречка: '34357',
			Белослудское: '34355',
			Белоярский: '34377',
			Беляковское: '34371',
			Бердюгина: '34355',
			Березовка: '34391',
			Березовский: '34369',
			Билимбай: '3439',
			Бисерть: '34398',
			Битимка: '3439',
			Благовещенское: '34349',
			Бобровка: '34346',
			Бобровский: '34374',
			Бобровское: '34361',
			Богданович: '34376',
			Большебрусянское: '34377',
			Боровлянское: '34372',
			Боровской: '34371',
			Бродово: '3435',
			Бруснятское: '34377',
			Бубчиково: '34346',
			Буланаш: '34363',
			Бурмантово: '34386',
			Бутка: '34371',
			Быково: '34391',
			Быньги: '34356',
			Валериановск: '34341',
			Васькино: '34398',
			Вересовка: '3439',
			Верховино: '34367',
			Верхотурье: '34389',
			Веселовка: '34383',
			Вижай: '34386',
			Висим: '3435',
			Вихляева: '34371',
			Волково: '34391',
			Волковское: '34376',
			Володинское: '34375',
			Волчанск: '34383',
			Воронцовка: '34384',
			Вязовка: '34362',
			Гагарка: '34377',
			Гагарский: '34377',
			Гаева: '34355',
			Галкинское: '34375',
			Гаранинка: '34346',
			Гарашкинское: '34376',
			Гари: '34387',
			Герасимовка: '34360',
			Глазуновка: '34389',
			Глинское: '34364',
			Голендухино: '34364',
			Голубковское: '34346',
			Голякова: '34361',
			Гора: '34358',
			Горбуновское: '34371',
			Горки: '34355',
			Горноуральский: '3435',
			Грязновское: '34376',
			Гуни: '34355',
			Дачный: '34343',
			Двуреченск: '34374',
			Дегтярск: '34397',
			Деево: '34346',
			Демино: '34367',
			Денежкино: '34386',
			Дерябино: '34389',
			Добрино: '34347',
			Дружинино: '34398',
			Дубская: '34355',
			Дымковское: '34349',
			Ежевичный: '34345',
			Екатеринбург: '343',
			Екатерининка: '34386',
			Елкино: '34342',
			Ельничная: '34346',
			Еремино: '34387',
			Ертарский: '34367',
			Заводоуспенское: '34367',
			Завьяловское: '34371',
			Зайково: '34355',
			Западный: '34346',
			Заречный: '34377',
			Зарубина: '34371',
			Захаровское: '34375',
			Зубково: '34367',
			Зыкова: '34387',
			Зыряновский: '34346',
			Зюзельский: '34350',
			Ивдель: '34386',
			Измоденово: '34346',
			Изумруд: '34365',
			Илим: '34358',
			Ильинское: '34376',
			Ирбит: '34355',
			Ис: '34342',
			Исеть: '34372',
			Истоур: '34371',
			Казаковское: '34371',
			Калач: '34346',
			Калиново: '34356',
			Калиновское: '34375',
			Калья: '34380',
			Каменнозерское: '34376',
			Камышево: '34369',
			Камышлов: '34375',
			Карабашка: '34360',
			Карги: '34391',
			Карелино: '34389',
			Карпинск: '34383',
			Карпунинский: '34389',
			Карпушиха: '34357',
			Катарач: '34371',
			Катырева: '34391',
			Качканар: '34341',
			Квашнинское: '34375',
			Кедровка: '34369',
			Кедровое: '34368',
			Килачевское: '34355',
			Киприно: '34356',
			Кирга: '34355',
			Киргишаны: '34398',
			Кириллова: '34355',
			Кировград: '34357',
			Кировоград: '34357',
			Кировское: '34346',
			Киселева: '34360',
			Киселевка: '34398',
			Кисловское: '3439',
			Кишкинское: '34346',
			Кленовское: '34398',
			Ключ: '34391',
			Ключевая: '34398',
			Ключевск: '34369',
			Ключи: '34355',
			Кокуй: '34371',
			Кокшарова: '34375',
			Колпаковка: '34358',
			Колчедан: '3439',
			Кольцово: '343',
			Коменки: '34376',
			Комсомольский: '34371',
			Конево: '34356',
			Коптелово: '34346',
			Коптяки: '34388',
			Кордюково: '34389',
			Корзуновка: '34391',
			Коркинское: '34349',
			Косолманка: '34389',
			Костино: '34346',
			Костоусово: '34364',
			Косулино: '34377',
			Косья: '34342',
			Кошай: '34385',
			Кошуки: '34360',
			Красноармеец: '34398',
			Красногвардейский: '34363',
			Красноглинный: '34385',
			Красногорское: '34389',
			Краснополье: '3435',
			Краснополянское: '34362',
			Краснослободское: '34361',
			Краснотурьинск: '34384',
			Красноуральск: '34343',
			Красноуфимск: '34394',
			Красноярка: '34385',
			Красный: '34368',
			Криулино: '34394',
			Крутиха: '34364',
			Крутихинское: '34355',
			Крутое: '34360',
			Круторечка: '34387',
			Крылатовский: '34397',
			Крылово: '34394',
			Крылосово: '3439',
			Куваева: '34375',
			Кузнецова: '34387',
			Кузнецово: '34347',
			Кузнецовский: '34371',
			Куминовское: '34361',
			Кунарское: '34376',
			Кунгурка: '34397',
			Курганово: '34350',
			Курки: '34391',
			Куровское: '34375',
			Курьи: '34373',
			Кушва: '34344',
			Куяровское: '34371',
			Кытлым: '34383',
			Лапоткова: '34387',
			Лая: '3435',
			Левиха: '34357',
			Леневское: '34364',
			Ленское: '34349',
			Леонтьевское: '34349',
			Лесной: '34342',
			Ликино: '34387',
			Липовка: '34362',
			Липчинское: '34361',
			Лобва: '34388',
			Логиново: '34377',
			Лозьвинский: '34386',
			Лопаево: '34388',
			Лопатково: '34355',
			Лосиный: '34369',
			Лубяной: '34369',
			Луговая: '3435',
			Луговской: '34367',
			Лучинкино: '34367',
			Лямпа: '34391',
			Ляпуново: '34362',
			Мака: '34371',
			Малобрусянское: '34377',
			Малыгино: '34345',
			Малышева: '34365',
			Мальцево: '34367',
			Маминское: '3439',
			Манчаж: '34391',
			Мариинск: '34397',
			Маркова: '34371',
			Марсяты: '34385',
			Мартюш: '3439',
			Маслово: '34386',
			Махнево: '34346',
			Медведево: '34345',
			Мезенское: '34377',
			Меркушино: '34389',
			Михайловск: '34398',
			Монетный: '34369',
			Москвинское: '34371',
			Мостовка: '34360',
			Мостовское: '34368',
			Мохирева: '34371',
			Мраморское: '34350',
			Мугай: '34346',
			Муратково: '34346',
			Мурзинка: '3435',
			Назарово: '34349',
			Накоряково: '34398',
			Натальинск: '34394',
			Невьянск: '34356',
			Невьянское: '34346',
			Некрасово: '34377',
			Нелоба: '34345',
			Нижнеиргинское: '34394',
			Никитино: '34345',
			Нихвор: '34387',
			Новгородова: '34355',
			Новоалексеевское: '3439',
			Новоасбест: '3435',
			Новопаньшино: '3435',
			Новопышминское: '34373',
			Новоселово: '34347',
			Новоуральск: '34370',
			Новоуткинск: '3439',
			Обуховское: '34375',
			Оверино: '34347',
			Озерки: '34347',
			Озерный: '34364',
			Октябрьское: '34364',
			Ольховка: '34368',
			Осинцевское: '34355',
			Оус: '34386',
			Ошкуково: '34367',
			Павда: '34388',
			Пальмино: '34347',
			Панова: '34371',
			Патруши: '34374',
			Пелевина: '34362',
			Пелым: '34386',
			Пеньки: '34371',
			Первоуральск: '3439',
			Первухина: '34371',
			Першино: '34364',
			Песчаный: '34360',
			Петрокаменское: '3435',
			Печеркино: '34372',
			Пионерский: '34371',
			Пия: '34389',
			Платина: '34342',
			Платоново: '34358',
			Поварня: '34377',
			Подгорная: '34394',
			Позариха: '3439',
			Полдневая: '34350',
			Полдневой: '34376',
			Полевской: '34350',
			Половинный: '34357',
			Полуночное: '34386',
			Понил: '34386',
			Порошина: '34375',
			Поташка: '34391',
			Починок: '34370',
			Привокзальный: '34389',
			Приданниково: '34394',
			Пристань: '34391',
			Прогресс: '3439',
			Пуксинка: '34387',
			Пульниково: '34372',
			Пылаева: '34372',
			Пышма: '34372',
			Пьянково: '34355',
			Раздольное: '34375',
			Рахмангулово: '34394',
			Ребристый: '34356',
			Ревда: '34397',
			Реж: '34364',
			Ретнева: '34355',
			Рефтинский: '34365',
			Речелга: '34372',
			Речкалова: '34355',
			Решетникова: '34361',
			Решеты: '3439',
			Романово: '34385',
			Роща: '34358',
			Рудничный: '34384',
			Рудное: '34355',
			Рудянское: '34373',
			Рыбниковское: '3439',
			Рынта: '34387',
			Сабик: '34358',
			Савинова: '34388',
			Садовый: '343',
			Сажино: '34391',
			Салтаново: '34388',
			Санкино: '34346',
			Сарана: '34394',
			Сарапулка: '34369',
			Сарга: '34358',
			Саргая: '34394',
			Сарьянка: '34347',
			Свердловское: '34391',
			Светлое: '34373',
			Свободный: '34345',
			Северка: '343',
			Северная: '34345',
			Северный: '34386',
			Североуральск: '34380',
			Серебрянка: '3435',
			Серов: '34385',
			Сигнальный: '34342',
			Симинчи: '34391',
			Синегорский: '3435',
			Сипавское: '3439',
			Скатинское: '34375',
			Скородумское: '34355',
			Сладковское: '34361',
			Слобода: '3439',
			Смолинское: '34371',
			Смычка: '34349',
			Совхозный: '34377',
			Сосновка: '34383',
			Среднеуральск: '34368',
			Становая: '34369',
			Старобухарово: '34398',
			Старопышминск: '34369',
			Староуткинск: '34358',
			Стриганское: '34355',
			Студенческий: '34377',
			Сухановка: '34391',
			Сызги: '34394',
			Сылва: '34358',
			Сысерть: '34374',
			Таборы: '34347',
			Таватуй: '34356',
			Тавда: '34360',
			Тагильский: '34345',
			Тагильцы: '34360',
			Талица: '34371',
			Тарасково: '34370',
			Тимофеево: '34361',
			Тимохинское: '34372',
			Толмачево: '34346',
			Томский: '34347',
			Травянское: '3439',
			Трехозерная: '34371',
			Трифоново: '34372',
			Троицкий: '34371',
			Троицкое: '34376',
			Трошково: '34367',
			Тугулым: '34367',
			Тупицыно: '34372',
			Туринск: '34349',
			Тыгиш: '34376',
			Тюльгаш: '34398',
			Тюш: '34391',
			Увал: '34360',
			Уецкое: '34371',
			Упорова: '34371',
			Уралец: '3435',
			Уральский: '34377',
			Усениново: '34349',
			Уфимский: '34391',
			Фабричное: '34349',
			Федюшина: '34375',
			Филатовское: '34373',
			Филькино: '34385',
			Фирсово: '34364',
			Фомина: '34355',
			Фоминское: '34346',
			Хабарчиха: '34346',
			Харловское: '34355',
			Хмелевка: '34360',
			Холкина: '34372',
			Храмцово: '34361',
			Цементный: '34356',
			Цепошниково: '34367',
			Чатлык: '34394',
			Черемисское: '34364',
			Черемухово: '34380',
			Черемыш: '34372',
			Черкасовка: '34391',
			Черновское: '34355',
			Черноисточинск: '3435',
			Чернокоровское: '34376',
			Чернореченск: '34384',
			Чернорицкое: '34355',
			Черноусово: '34377',
			Чернышово: '34372',
			Четкарино: '34372',
			Чикунова: '34375',
			Чубаровское: '34355',
			Чувашково: '34394',
			Чукреевское: '34349',
			Чупина: '34349',
			Чупино: '34372',
			Чурманское: '34362',
			Чусовое: '34358',
			Шабровский: '343',
			Шабурово: '34387',
			Шадринка: '34362',
			Шайдуриха: '34356',
			Шайтанка: '34388',
			Шаля: '34358',
			Шамары: '34358',
			Шантальская: '34387',
			Шилкинское: '34375',
			Шипичный: '34386',
			Шокурово: '34398',
			Шувакиш: '343',
			Шумиха: '3435',
			Шурала: '34356',
			Шухруповское: '34349',
			Щелконогова: '34367',
			Щелкун: '34374',
			Юва: '34394',
			Южаково: '3435',
			Юрмытское: '34372',
			Юрты: '34388',
			Юшала: '34367',
			Яборково: '34388',
			Ядрышникова: '34367',
			Якшина: '34355',
			Якшино: '34347',
			Ялунинское: '34346',
			Ялым: '34391',
			Яр: '34367',
			Ярославское: '34346',
			Ясашная: '34346'
		}
	},
	Севастополь: {
		regionCode: '869',
		cities: {
			Севастополь: '8692'
		}
	},
	'Смоленская область': {
		regionCode: '481',
		cities: {
			'Белый Холм': '48165',
			'Блинные Кучи': '48155',
			'Большая Моховатка': '48130',
			'Большие Хутора': '48140',
			'Большое Береснево': '48166',
			'Большое Павлово': '48146',
			'Верешковичи-Первые': '48166',
			'Верхние Моховичи': '48147',
			'Владимирский Тупик': '48139',
			'Волоста-Пятница': '48137',
			'Высокий Холм': '4812',
			'Вязьма-Брянская': '48131',
			'Долгие Нивы': '48148',
			'Епишево-Первое': '48134',
			'Ивано-Гудино': '48146',
			'Каспля-Вторая': '4812',
			'Крапивенский-Второй': '48134',
			'Красное Знамя': '48149',
			'Красный Холм': '48138',
			'Лесные Дали': '48130',
			'Малая Калпита': '48131',
			'Малые Кириллы': '48134',
			'Николо-Погорелое': '48142',
			'Новая Рудня': '48140',
			'Ново-Милятино': '48137',
			'Новое Село': '48131',
			'Новое Ханино': '48165',
			'Новые Головачи': '48149',
			'Новый Батеки': '4812',
			'Носково-Первое': '48148',
			'Рибшево-Первое': '48166',
			'Серго-Ивановская': '48135',
			'Спас-Углы': '48166',
			'Сырокоренские Липки': '4812',
			'Хватов Завод': '48131',
			'Хмелита ': '48131',
			'Холм Жирки': '48139',
			'Холм-Жирковский': '48139',
			'Царево-Займище': '48131',
			'Чижовка-Вторая': '48134',
			'п. Темкино': '48149',
			'хутор Загорье': '48149',
			Агибалово: '48139',
			Акатово: '48135',
			Александрино: '48138',
			Александровка: '48137',
			Алексино: '48144',
			Алушково: '48145',
			Алферово: '48142',
			Андрейково: '48131',
			Аполье: '4812',
			Арнишинцы: '48137',
			Архиповка: '4812',
			Астапковичи: '48134',
			Астахово: '48135',
			Афанасьево: '48166',
			Ашково: '48135',
			Бабино: '48166',
			Бабны: '4812',
			Бабыново: '48149',
			Бакланово: '48147',
			Балахоновка: '48133',
			Балтутино: '48165',
			Бараново: '48142',
			Баскаковка: '48137',
			Баскаково: '48135',
			Батурино: '48139',
			Батюшково: '48135',
			Беззаботы: '48165',
			Бекрино: '48136',
			Беленино: '48142',
			Белик: '48149',
			Беляево: '48132',
			Беляи: '48145',
			Бережняны: '48167',
			Березино: '48141',
			Березкино: '48165',
			Бехтеево: '48130',
			Богданово: '48134',
			Богдановщина: '48142',
			Боголюбово: '48139',
			Болшево: '48138',
			Болышево: '48139',
			Борки: '48141',
			Борода: '48147',
			Братышки: '48141',
			Бубново: '4812',
			Будница: '48132',
			Буризи: '48166',
			Буяново: '48143',
			Быково: '48144',
			Вадино: '48142',
			Вараксино: '48130',
			Варваровщина: '48167',
			Васино: '48144',
			Васьково: '48149',
			Вачково: '48167',
			Велиж: '48132',
			Великополье: '48137',
			Велисто: '48166',
			Величково: '48135',
			Верхнеднепровский: '48144',
			Викторово: '48145',
			Волконщина: '48134',
			Волоковая: '4812',
			Ворга: '48155',
			Воронцово: '48166',
			Ворошилово: '48149',
			Всходы: '48137',
			Вышегор: '48142',
			Вязьма: '48131',
			Гагарин: '48135',
			Гаристово: '48146',
			Глинка: '48165',
			Гневково: '48133',
			Гнездово: '48112',
			Гоголевка: '48148',
			Годуново: '48131',
			Голынки: '48141',
			Горки: '48136',
			Городище: '48140',
			Гранки: '48141',
			Гребени: '48145',
			Грязенять: '48134',
			Гусино: '48145',
			Гутка: '48140',
			Даньково: '48149',
			Двуполяны: '48145',
			Демидов: '48147',
			Демшино: '48146',
			Деребуж: '48149',
			Десногорск: '48153',
			Дивасы: '4812',
			Дивинка: '48149',
			Диво: '48147',
			Дмитровка: '48131',
			Дмитрово: '48130',
			Днепровское: '48138',
			Добрино: '48166',
			Добромино: '48165',
			Доброселье: '48148',
			Дорогобуж: '48144',
			Досугово: '48148',
			Дроздово: '48142',
			Дубосище: '48165',
			Дубровка: '48147',
			Дугино: '48130',
			Дурово: '48142',
			Духовщина: '48166',
			Егоровка: '48155',
			Екимовичи: '48134',
			Ельня: '48146',
			Ершичи: '48155',
			Ерыши: '48166',
			Ефремово: '48131',
			Жанвиль: '48140',
			Жарынь: '48134',
			Желанья: '48137',
			Заболотье: '48134',
			Заборье: '48147',
			Загорье: '48149',
			Задорожье: '48135',
			Зайцево: '48143',
			Закрутье: '48147',
			Замошье: '4812',
			Замыцкое: '48136',
			Заозерье: '48132',
			Засецкое: '48136',
			Засижье: '48143',
			Захарино: '48140',
			Зимец: '48166',
			Зимницы: '48142',
			Зимонино: '48133',
			Знаменка: '48137',
			Ивановское: '48134',
			Игнатково: '48142',
			Игоревская: '48139',
			Извеково: '48138',
			Издешково: '48142',
			Иозефовка: '48140',
			Исаково: '48131',
			Кадино: '48148',
			Казимирово: '48141',
			Казулино: '48142',
			Кайдаково: '48131',
			Каменка: '48167',
			Канютино: '48139',
			Капустино: '48138',
			Капыревщина: '48143',
			Карды: '48155',
			Кардымово: '48167',
			Карманово: '48135',
			Карповка: '48155',
			Карташевичи: '48141',
			Касня: '48131',
			Каськово: '48144',
			Катынь: '4812',
			Кашкурино: '48147',
			Кикино: '48136',
			Клемятино: '48149',
			Климщина: '48149',
			Клушино: '48135',
			Клюкино: '48140',
			Кляриново: '48141',
			Княжино: '48138',
			Княшино: '48144',
			Кожино: '48135',
			Кожуховичи: '48140',
			Корево: '48147',
			Корзово: '48140',
			Коробец: '48146',
			Корсики: '48155',
			Коситчено: '48146',
			Коски: '48134',
			Коханы: '48134',
			Кошевичи: '48141',
			Кошелево: '48149',
			Кощино: '4812',
			Крапивна: '48134',
			Краснополье: '48133',
			Красный: '48145',
			Криволес: '48133',
			Кротово: '48143',
			Крутое: '48132',
			Крюково: '48145',
			Кузино: '48144',
			Кузьмичи: '48155',
			Куприно: '4812',
			Ладенка: '48135',
			Ламоново: '48149',
			Лапино: '48146',
			Лахи: '48134',
			Лебедки: '48135',
			Леоново: '48146',
			Лесное: '48142',
			Лехмино: '48139',
			Лешно: '48141',
			Липецы: '48138',
			Липки: '48149',
			Липовка: '48134',
			Липцы: '48135',
			Литвиновка: '48155',
			Логово: '48132',
			Лоино: '4812',
			Лонница: '48145',
			Лосня: '48149',
			Лосьмино: '48131',
			Лубня: '4812',
			Лужная: '48155',
			Лукино: '48130',
			Лучеса: '48149',
			Лысовка: '48149',
			Львово: '48143',
			Мазальцево: '4812',
			Мазово: '48146',
			Макшеево: '48149',
			Малеево: '48145',
			Маньково: '48145',
			Марково: '48145',
			Мархоткино: '48144',
			Марьино: '48149',
			Мачулы: '48149',
			Мерлино: '48145',
			Микулино: '48141',
			Микшино: '48140',
			Мирополье: '48143',
			Митино: '4812',
			Митяево: '48166',
			Михайловка: '48148',
			Михайловское: '48147',
			Михали: '48137',
			Михейково: '48143',
			Михновка: '4812',
			Мишино: '48135',
			Могильно: '48141',
			Моготово: '4812',
			Молоченево: '48135',
			Мольгино: '48138',
			Мольково: '48167',
			Монастырщина: '48148',
			Мощинки: '4812',
			Мурыгино: '48149',
			Мутище: '48146',
			Мушковичи: '48143',
			Мытишино: '48137',
			Мякуры: '48147',
			Надва: '48141',
			Надейковичи: '48133',
			Нарытка: '48136',
			Нахимовское: '48139',
			Нетризово: '48167',
			Никитинка: '48139',
			Никитье: '48130',
			Николаевка: '48145',
			Никонцы: '48141',
			Новодугино: '48138',
			Новое: '48131',
			Озерище: '48144',
			Озерный: '48166',
			Озёрный: '48166',
			Октябрьский: '48131',
			Ольхово: '48143',
			Ольша: '4812',
			Осетище: '48133',
			Остер: '48134',
			Относово: '48131',
			Павлово: '48145',
			Первомайский: '48133',
			Перенка: '48134',
			Пересна: '48149',
			Петрищево: '48166',
			Петровичи: '48133',
			Петрово: '48143',
			Петровское: '48147',
			Петрополье: '48140',
			Петушки: '48135',
			Печатники: '48139',
			Печеничено: '48143',
			Печенки: '48132',
			Печерск: '4812',
			Пигулино: '48139',
			Плоское: '48141',
			Пнево: '48167',
			Погорелье: '48132',
			Подосинки: '48147',
			Подроща: '48143',
			Подсосонки: '48137',
			Подъямное: '48130',
			Полднево: '48137',
			Полуяново: '48147',
			Поляново: '48131',
			Понизовье: '48141',
			Понятовка: '48133',
			Поселки: '48155',
			Потапово: '48135',
			Починичи: '48133',
			Починок: '48149',
			Пржевальское: '48147',
			Приволье: '48141',
			Пригорское: '4812',
			Пригорье: '48134',
			Прилепово: '48149',
			Пронино: '48146',
			Путьково: '48131',
			Пушкино: '48142',
			Раевка: '48148',
			Репино: '48143',
			Рогайлово: '48145',
			Родоманово: '48135',
			Родьковка: '48148',
			Рождество: '48146',
			Ромоданово: '48165',
			Рославль: '48134',
			Рудня: '48141',
			Русаново: '48137',
			Русилово: '4812',
			Русское: '48133',
			Рухань: '48155',
			Рыбки: '48142',
			Рябцево: '48149',
			Савеево: '48134',
			Савино: '48166',
			Садовая: '48144',
			Самуйлово: '48135',
			Сапрыкино: '48143',
			Сафоново: '48142',
			Селезни: '48132',
			Сельцо: '48149',
			Семлево: '48131',
			Сергеевское: '48135',
			Середа: '48130',
			Синьково: '4812',
			Ситьково: '48132',
			Слобода: '48148',
			Слободка: '48137',
			Слойково: '48144',
			Сметанино: '4812',
			Смоленск: '4812',
			Снегиревка: '48133',
			Соболево: '48148',
			Соино: '48140',
			Соколино: '48130',
			Соловьево: '48167',
			Стаи: '48141',
			Старинки: '48149',
			Староселье: '48143',
			Стегримово: '48148',
			Стешино: '48139',
			Стодолище: '48149',
			Стригино: '48149',
			Студенец: '48133',
			Субботники: '48130',
			Суетово: '48143',
			Сукромля: '48155',
			Сутормино: '48130',
			Сычёвка: '48130',
			Талашкино: '4812',
			Татарка: '48138',
			Татарск: '48148',
			Телепнево: '48131',
			Темкино: '48136',
			Теренино: '48146',
			Тесово: '48138',
			Тетерино: '48166',
			Титково: '48167',
			Токарево: '48135',
			Торбеево: '48138',
			Третьяково: '48166',
			Троицкое: '48166',
			Туманово: '48131',
			Тюшино: '48167',
			Уварово: '48146',
			Угра: '48137',
			Узгорки: '48141',
			Упино: '48140',
			Усвятье: '48144',
			Успенское: '48131',
			Ушаково: '48144',
			Фленово: '4812',
			Фролово: '48140',
			Хвощеватое: '48138',
			Хиславичи: '48140',
			Хмелита: '48131',
			Холмы: '48137',
			Хорошово: '48134',
			Хохлово: '4812',
			Чекулино: '4812',
			Черепово: '48140',
			Черногубцево: '48135',
			Чистик: '48141',
			Шанталово: '48149',
			Шапы: '48147',
			Шаталово: '48149',
			Шестаково: '48167',
			Шиловичи: '48166',
			Шилы: '4812',
			Шмаково: '48149',
			Шмыри: '48141',
			Шокино: '48167',
			Шуйское: '48131',
			Шумячи: '48133',
			Шутовка: '48167',
			Язвище: '4812',
			Язовка: '48155',
			Ярцево: '48143'
		}
	},
	'Ставропольский край': {
		regionCode: ['865', '879'],
		cities: {
			'Ага-Батыр': '87964',
			'Андрей-Курган': '86558',
			'Белые Копани': '86555',
			'Благодар-ный': '86549',
			'Большая Джалга': '86542',
			'Бургун-Маджары': '86543',
			'Верхняя Кугульта': '86540',
			'Горькая Балка': '86552',
			'Донская Балка': '86547',
			'Дубовая Роща': '86557',
			'Железноводск ': '87932',
			'Зеленая Роща': '86563',
			'Зимняя Ставка': '86558',
			'Кара-Тюбе': '86558',
			'Кендже-Кулак': '86565',
			'Красная Поляна': '86542',
			'Красный Ключ': '86549',
			'Красный Кундуль': '86542',
			'Красный Маныч': '86565',
			'Красный Октябрь': '86559',
			'Крупско-Ульяновский': '87938',
			'Куликовы Копани': '86565',
			'Кумская Долина': '86543',
			'Ладовская Балка': '86541',
			'Лесная Дача': '86542',
			'Летняя Ставка': '86565',
			'Малая Джалга': '86555',
			'Малые Ягуры': '86565',
			'Малый Барханчак': '86542',
			'Марьины Колодцы': '87922',
			'Махмуд-Мектеб': '86558',
			'Минеральные Воды': '87922',
			'Нижняя Александровка': '87922',
			'Николина Балка': '86547',
			'Николо-Александровское': '86543',
			'Новая Деревня': '86550',
			'Новая Жизнь': '86559',
			'Новая Кугульта': '86546',
			'Новкус-Артезиан': '86558',
			'Новый Бешпагир': '86554',
			'Новый Маяк': '86548',
			'Новый Янкуль': '86554',
			'Озек-Суат': '86558',
			'Посёлок Свободы': '8793',
			'Рогатая Балка': '86547',
			'Свободы Поселок': '8793',
			'Советское Руно': '86542',
			'Солдато-Александровское': '86552',
			'Соленое Озеро': '86547',
			'Солуно-Дмитриевское': '86554',
			'Средний Лес': '86552',
			'Сухая Буйвола': '86547',
			'Сухая Падина': '87922',
			'Толстово-Васюковское': '86559',
			'Тукуй-Мектеб': '86558',
			'Уч-Тюбе': '86558',
			'Ясная Поляна': '87961',
			'с. Верхняя Татарка': '86553',
			'с. Донское': '86546',
			'с.Труновское': '86546',
			'село Дмитриевское': '86541',
			'село Новоселицкое': '86548',
			Айгурский: '86555',
			Александрийская: '87951',
			Александрия: '86549',
			Александровское: '86557',
			Анджиевский: '87922',
			Андреевский: '86552',
			Апанасенковское: '86555',
			Арзгир: '86560',
			Артезианский: '86548',
			Архангельское: '86559',
			Архиповское: '86559',
			Ачикулак: '86558',
			Базовый: '86540',
			Баклановская: '86545',
			Балахоновское: '86550',
			Балковский: '87951',
			Балтийский: '87964',
			Барсуковская: '86550',
			Безопасное: '86546',
			Бекешевская: '87961',
			Беломечетская: '86550',
			Беляев: '86545',
			Березовский: '86565',
			Бешпагир: '86540',
			Благодарный: '86549',
			Благодатное: '86547',
			Богдановка: '86563',
			Боргустанская: '87961',
			Бородыновка: '87922',
			Будённовск: '86559',
			Бурлацкое: '86549',
			Бурукшун: '86542',
			Вавилон: '86542',
			Варениковское: '86563',
			Васильевский: '86550',
			Величаевское: '86543',
			Верхнеегорлыкский: '86554',
			Верхнерусское: '86554',
			Верхнестепной: '86563',
			Веселое: '86550',
			Виноградный: '86559',
			Винодельненский: '86542',
			Винсады: '87961',
			Водный: '86542',
			Водораздел: '86554',
			Воздвиженское: '86555',
			Вознесеновское: '86555',
			Воровский: '86544',
			Воровсколесская: '86554',
			Воскресенская: '86544',
			Восточный: '86552',
			Вревское: '86550',
			Всадник: '86557',
			Высоцкое: '86547',
			Гаевская: '86545',
			Галюгаевская: '87964',
			Георгиевск: '87951',
			Горнозаводское: '87938',
			Горьковский: '86544',
			Горячеводский: '8793',
			Гофицкое: '86547',
			Гражданское: '87922',
			Грачевка: '86540',
			Греческое: '87922',
			Григорополисская: '86544',
			Грушевское: '86557',
			Дворцовское: '86550',
			Дегтяревский: '86550',
			Демино: '86553',
			Дербетовка: '86555',
			Дивное: '86555',
			Дмитриевское: '86541',
			Доброжеланный: '86559',
			Долиновка: '86548',
			Донское: '86546',
			Дубовка: '86554',
			Дунаевка: '87922',
			Дыдымкин: '87964',
			Елизаветинское: '86549',
			Ессентуки: '87934',
			Ессентукская: '87961',
			Железноводск: '87932',
			Железноводский: '87961',
			Жуковский: '86548',
			Журавское: '86548',
			Заветное: '86550',
			Загорский: '87922',
			Зайцев: '87964',
			Залесный: '86542',
			Заря: '86543',
			Затеречный: '86558',
			Зеленокумск: '86552',
			Золотаревка: '86542',
			Зольская: '87938',
			Зункарь: '86558',
			Ивановское: '86550',
			Изобильный: '86545',
			Иноземцево: '87932',
			Ипатово: '86542',
			Иргаклы: '86563',
			Искра: '86559',
			Казгулак: '86565',
			Казьминское: '86550',
			Калиновское: '86557',
			Камбулат: '86565',
			Каменнобродская: '86545',
			Канглы: '87922',
			Каново: '87964',
			Карамурзинский: '86550',
			Кармалиновская: '86544',
			Каскадный: '86554',
			Каясула: '86558',
			Кевсала: '86542',
			Киан: '86554',
			Кианкиз: '86554',
			Киевка: '86555',
			Кизилов: '86540',
			Кисловодск: '87937',
			Китаевское: '86548',
			Ключевское: '86546',
			Коммаяк: '87938',
			Коммунар: '86541',
			Комсомолец: '87938',
			Константиновская: '8793',
			Константиновское: '86547',
			Кочубеевское: '86550',
			Кочубей: '86543',
			Красногвардейское: '86541',
			Красное: '86540',
			Краснозоринский: '86544',
			Краснокумское: '87951',
			Красночервонный: '86544',
			Красноярское: '86554',
			Красочный: '86542',
			Крестьянское: '86542',
			Круглолесское: '86557',
			Крутоярский: '87951',
			Крымгиреевское: '86554',
			Кугульта: '86540',
			Кугуты: '86547',
			Кумагорск: '87922',
			Курсавка: '86556',
			Курская: '87964',
			Куршава: '86554',
			Кучерла: '86565',
			Левобережный: '86559',
			Левокумка: '87922',
			Левокумское: '86543',
			Лермонтов: '87935',
			Лиман: '86542',
			Лысогорская: '87951',
			Лысогорский: '87922',
			Манычское: '86555',
			Мартыновка: '86547',
			Марьинская: '87938',
			Медвеженский: '86541',
			Мирное: '86549',
			Михайловка: '86552',
			Михайловск: '865534',
			Мищенский: '86550',
			Московское: '86545',
			Нагутское: '87922',
			Надежда: '86554',
			Надзорное: '86550',
			Найденовка: '86545',
			Невдахин: '86546',
			Невинномысск: '86554',
			Нежинский: '87961',
			Незлобная: '87951',
			Нефтекумск: '86558',
			Нижнезольский: '87951',
			Нижнеподкумский: '8793',
			Нижнерусский: '86554',
			Никольское: '86563',
			Новоалександровск: '86544',
			Новоандреевское: '86542',
			Новоблагодарное: '87961',
			Новоекатериновская: '86550',
			Новозаведенное: '87951',
			Новоизобильный: '86545',
			Новокавказский: '86557',
			Новокумский: '86543',
			Новомарьевская: '86554',
			Новомихайловский: '87951',
			Новомихайловское: '86541',
			Новопавловск: '87938',
			Новоромановское: '86560',
			Новоселицкое: '86548',
			Новоспицевский: '86540',
			Новосредненское: '87938',
			Новотерский: '87922',
			Новотроицкая: '86545',
			Новоульяновский: '87951',
			Новый: '87951',
			Носачев: '86547',
			Обильное: '87951',
			Овощи: '86565',
			Озерное: '86563',
			Октябрь: '86540',
			Октябрьское: '86542',
			Ольгино: '86563',
			Орбельяновка: '87922',
			Ореховка: '86547',
			Острогорка: '87935',
			Отказное: '86552',
			Падинское: '86548',
			Пелагиада: '86554',
			Первомайский: '87922',
			Первомайское: '86542',
			Перевальный: '87922',
			Передовой: '86545',
			Петропавловка: '86554',
			Петропавловское: '86560',
			Побегайловка: '87922',
			Подгорная: '87951',
			Подгорное: '86554',
			Подкумок: '87961',
			Подлесное: '86546',
			Подлужное: '86545',
			Покойное: '86559',
			Покровское: '86541',
			Полтавское: '87964',
			Польский: '86554',
			Прасковея: '86559',
			Преградное: '86541',
			Преображенское: '86559',
			Прикалаусский: '86547',
			Прикумское: '87922',
			Приозерный: '86554',
			Приозерское: '86543',
			Приэтокский: '87951',
			Пролетарский: '87964',
			Просянка: '86547',
			Птичье: '86545',
			Пятигорск: '8793',
			Пятигорский: '87961',
			Равнинный: '86544',
			Рагули: '86555',
			Радуга: '86544',
			Раздольное: '86544',
			Расшеватская: '86544',
			Родники: '86542',
			Родниковский: '86550',
			Родниковское: '86560',
			Родыки: '86541',
			Рождественская: '86545',
			Розовка: '87922',
			Ростовановское: '87964',
			Рощино: '87964',
			Русское: '87964',
			Рыздвяный: '86545',
			Саблинское: '86557',
			Санамер: '87961',
			Светлоград: '86547',
			Светлый: '86544',
			Свобода: '87961',
			Северное: '86557',
			Селивановка: '86552',
			Сенгилеевское: '86554',
			Серафимовское: '86560',
			Сергиевское: '86540',
			Серноводское: '87964',
			Советская: '87938',
			Солнечнодольск: '86545',
			Соломенское: '86563',
			Сотниковское: '86549',
			Софиевка: '86542',
			Спасское: '86549',
			Спицевка: '86540',
			Спорный: '86545',
			Средний: '86557',
			Ставрополь: '8652',
			Ставропольский: '86549',
			Стародворцовский: '86550',
			Стародубское: '86559',
			Староизобильная: '86545',
			Старомарьевка: '86540',
			Старопавловская: '87938',
			Степное: '86563',
			Степной: '86550',
			Стодеревская: '87964',
			Суворовская: '87961',
			Султан: '86554',
			Сунжа: '87922',
			Тамбукан: '87961',
			Татарка: '86554',
			Тахта: '86542',
			Темижбекский: '86544',
			Темнолесская: '86554',
			Терек: '86559',
			Терский: '87951',
			Тищенское: '86545',
			Томузловское: '86559',
			Тоннельный: '86550',
			Труновское: '86546',
			Тугулук: '86540',
			Турксад: '86543',
			Уваровское: '87964',
			Ульяновка: '87922',
			Урожайное: '86543',
			Урожайный: '87961',
			Урухская: '87951',
			Фазанный: '87938',
			Фельдмаршальский: '86544',
			Филимоновская: '86545',
			Херсонский: '86559',
			Холодногорский: '86554',
			Цимлянский: '86554',
			Чернолесское: '86548',
			Чограйский: '86560',
			Шангала: '86547',
			Шарахалсун: '86565',
			Шаумянский: '87951',
			Шведино: '86547',
			Широбоков: '86545',
			Шишкино: '86549',
			Штурм: '86541',
			Щелкан: '86548',
			Эдельбай: '86549',
			Эдиссия: '87964',
			Этока: '87961',
			Юца: '87961',
			Янкуль: '86554',
			Ясный: '86565'
		}
	},
	'Тамбовская область': {
		regionCode: '475',
		cities: {
			'Алкужинские Борки': '47533',
			'Атманов Угол': '47532',
			'Бадин Угол': '47554',
			'Беломестная Двойня': '4752',
			'Беломестная Криуша': '4752',
			'Большая Алексеевка': '47544',
			'Большая Верда': '47543',
			'Большая Даниловка': '47542',
			'Большая Дорога': '47543',
			'Большая Лазовка': '47557',
			'Большая Липовица': '4752',
			'Большая Ржакса': '47555',
			'Большая Сосновка': '47545',
			'Большая Талинка': '4752',
			'Большое Лаврово': '47545',
			'Большое Шереметьево': '47554',
			'Большой Избердей': '47544',
			'Большой Ломовис': '47554',
			'Верхнее Чуево': '47558',
			'Верхний Шибряй': '47558',
			'Верхняя Мазовка': '4752',
			'Верхняя Ярославка': '47532',
			'Вольная Вершина': '47558',
			'Второй Пятилетки им.': '47531',
			'Вторые Левые Ламки': '47532',
			'Гавриловка Вторая': '47551',
			'Гавриловка Первая': '47551',
			'Гавриловка-2Я': '47551',
			'Гагарино 1-е': '47551',
			'Горельский Лесхоз': '4752',
			'Григорьевка Вторая': '47558',
			'Дельная Дубрава': '47532',
			'Демьян Бедный': '47535',
			'Дуплято-Маслово': '47552',
			'Западная Старинка': '47536',
			'Зеленый Бор': '47533',
			'Зеленый Гай': '47545',
			'Иловай-Бригадирское': '47548',
			'Иловай-Дмитриевское': '47548',
			'Иловай-Рождественское': '47548',
			'Иноземная Духовка': '4752',
			'Иноковка Вторая': '47537',
			'Иноковка Первая': '47537',
			'Карай-Пущино': '47553',
			'Карай-Салтыково': '47553',
			'Кершинские Борки': '47533',
			'Комсомолец Совхоз': '4752',
			'Красная Криуша': '4752',
			'Красный Куст': '47546',
			'Кузьмина-Гать': '4752',
			'Ленина им.Совхоз': '47542',
			'Лысые Горы': '4752',
			'Максим Горький': '47535',
			'Малая Зверяевка': '47557',
			'Мало-Моршевка': '47533',
			'Малое Гагарино': '47534',
			'Малые Кулики': '47533',
			'Малый Cнежеток': '47548',
			'Малый Самовец': '47544',
			'Машково-Сурена': '47536',
			'Меховая Фабрика': '47531',
			'Моисеево-Алабушка': '47558',
			'Нижнее-Чуево': '47546',
			'Нижние Пески': '47559',
			'Нижний Шибряй': '47558',
			'Нижняя Ярославка': '47532',
			'Новая Жизнь': '4752',
			'Новая Ляда': '4752',
			'Новая Павловка': '47532',
			'Новое Гаритово': '47544',
			'Новое Грязное': '47532',
			'Новое Козьмодемьяновское': '47548',
			'Новое Тарбеево': '47545',
			'Овсяновская дорога': '47537',
			'Осино-Гай': '47551',
			'Осино-Лазовка': '47556',
			'Пановы Кусты': '47556',
			'Парижская Коммуна': '47548',
			'Парский Угол': '47533',
			'Пахотный Угол': '47534',
			'Пересыпкино Второе': '47551',
			'Пересыпкино Первое': '47551',
			'Плоская Дубрава': '47533',
			'Покрово-Васильевка': '47532',
			'Покрово-Васильево': '47554',
			'Покрово-Марфино': '47552',
			'Покрово-Пригородное': '4752',
			'Покрово-Чичерино': '47544',
			'Польное Лапино': '47545',
			'Правые Ламки': '47532',
			'Сабуро-Покровское': '47536',
			'Савинские Карпели': '47532',
			'Синие Кусты': '47555',
			'Синявка Первая': '47551',
			'Солдатская Духовка': '4752',
			'Старая Казинка': '47545',
			'Старое Грязное': '47532',
			'Старое Сабурово': '47536',
			'Старое Тарбеево': '47545',
			'Старое Хмелевое': '47545',
			'Третьи Левые Ламки': '47532',
			'Тринадцатый Октябрь': '47533',
			'Троицкая Вихляйка': '47532',
			'Троицкая Дубрава': '4752',
			'Троицкие Росляи': '47532',
			'Троицкий Росляй': '47557',
			'Хобот-Богоявленское': '47548',
			'Хоботец-Васильевское': '47548',
			'Чащинские Дворики': '47558',
			'Челнаво-Покровское': '47532',
			'Челнаво-Рождественское': '47532',
			'Чуево-Алабушка': '47558',
			'Шушпан-Ольшанка': '47543',
			Абакумовка: '47557',
			Авангард: '4752',
			Авдеевка: '4752',
			Алгасово: '47533',
			Алкужи: '47533',
			Андриановка: '47546',
			Анненка: '47551',
			Арбеньевка: '47546',
			Афанасьевка: '47555',
			Ахматово: '47542',
			Ахтырка: '47531',
			Базево: '47533',
			Байловка: '47554',
			Балыклей: '47553',
			Бахарево: '47556',
			Безукладовка: '47557',
			Беляевка: '47556',
			Березка: '4752',
			Благодатка: '47533',
			Богданово: '47555',
			Богородицкое: '47536',
			Богоявленск: '47548',
			Бокино: '4752',
			Бондари: '47534',
			Борисовка: '47542',
			Борозда: '47552',
			Борщевка: '4752',
			Борщевое: '47545',
			Булгаково: '47551',
			Булыгино: '47551',
			Бурнак: '47535',
			Быковка: '47533',
			Ваново: '47533',
			Варварино: '47546',
			Вельможка: '47551',
			Вердеревщино: '47534',
			Вернадовка: '47554',
			Верхнеспасское: '47531',
			Верхоценье: '47556',
			Веселое: '47533',
			Вирятино: '47532',
			Вишневое: '47543',
			Владимировка: '47546',
			Волхонщина: '47554',
			Волхонщино: '47555',
			Волчки: '47544',
			Воронцовка: '47552',
			Вырубово: '47536',
			Вышенка: '47554',
			Вязовое: '47535',
			Вячка: '47537',
			Гагарино: '47554',
			Гладышево: '4752',
			Глазок: '47545',
			Голицыно: '47536',
			Гололобовка: '47545',
			Голынщина: '47537',
			Гомзяки: '47536',
			Горелое: '4752',
			Городище: '47534',
			Граждановка: '47534',
			Грачевка: '47542',
			Григорьевка: '47535',
			Грушевка: '47553',
			Гусевка: '47551',
			Давыдово: '47533',
			Дегтянка: '47532',
			Дмитриевка: '47536',
			Дмитриевщина: '47531',
			Донское: '4752',
			Дубовое: '47544',
			Дубровка: '4752',
			Дьячи: '47533',
			Екатериновка: '47533',
			Екатеринополье: '47553',
			Ереминка: '47542',
			Желановка: '47545',
			Жердевка: '47535',
			Жидиловка: '47545',
			Заворонежское: '47545',
			Заречный: '47533',
			Зеленое: '47532',
			Зеленый: '47531',
			Землянский: '47553',
			Змеевка: '47548',
			Знаменка: '47552',
			Золотовка: '47555',
			Иванково: '4752',
			Измайловка: '47552',
			Изосимово: '47545',
			Ильинка: '47559',
			Инжавино: '47553',
			Искра: '47535',
			Кадыковка: '47533',
			Казывань: '47534',
			Калаис: '47537',
			Калугино: '47553',
			Каменка: '47555',
			Канино: '47558',
			Караваино: '47553',
			Карандеевка: '47553',
			Караул: '47553',
			Карели: '47533',
			Кариан: '47552',
			Карпели: '47542',
			Керша: '47531',
			Кирсанов: '47537',
			Княжево: '47552',
			Кобяки: '47537',
			Ковылка: '47537',
			Козьмодемьяновка: '47551',
			Кондаурово: '47551',
			Коптево: '47531',
			Коровино: '47534',
			Коршуновка: '47554',
			Космачевка: '47532',
			Котовск: '47541',
			Котовское: '47531',
			Кочетовка: '47557',
			Красивое: '47545',
			Красиловка: '47544',
			Красненькая: '4752',
			Красносвободное: '4752',
			Краснояровка: '47546',
			Красный: '47537',
			Кривополянье: '47534',
			Круглое: '47545',
			Крутое: '47544',
			Крюковка: '47545',
			Крюково: '47533',
			Кужное: '47542',
			Кузьминский: '47552',
			Кулеватово: '47532',
			Кулябовка: '47546',
			Куньи: '4752',
			Курдюки: '47553',
			Куровщина: '47534',
			Лавровка: '47542',
			Лаврово: '47542',
			Лебедевка: '47553',
			Лебедево: '47536',
			Лебяжье: '47558',
			Левино: '47533',
			Ленинское: '47537',
			Леонтьевка: '47553',
			Лесной: '4752',
			Ломовка: '47553',
			Лопатино: '47553',
			Лукино: '47555',
			Луч: '47558',
			Лычное: '47548',
			Львово: '47557',
			Максимовка: '47534',
			Малиновка: '4752',
			Мановицы: '47545',
			Марусино: '47533',
			Марьевка: '47556',
			Марьинка: '47537',
			Масловка: '47559',
			Мезинец: '47543',
			Мельгуны: '47542',
			Митрополье: '47534',
			Мичуринск: '47545',
			Моисеево: '47558',
			Молодежный: '47533',
			Мордвиновка: '47555',
			Мордовка: '47544',
			Мордово: '47542',
			Моршанск: '47533',
			Мосоловка: '47555',
			Мучкапский: '47546',
			Найденовка: '47544',
			Нащекино: '47534',
			Нижнеспасское: '47531',
			Никитино: '47553',
			Николаевка: '47533',
			Николино: '47553',
			Новгородовка: '47531',
			Новиково: '47543',
			Новоалександровка: '47533',
			Новоархангельское: '47548',
			Нововоздвиженка: '47559',
			Новознаменка: '47552',
			Новокленское: '47548',
			Новопокровка: '47542',
			Новорусаново: '47535',
			Новосельцево: '4752',
			Новосельцы: '47546',
			Новосеславино: '47548',
			Новоситовка: '47544',
			Новоспасское: '47548',
			Новотомниково: '47533',
			Новоюрьево: '47543',
			Новоямское: '47532',
			Озерный: '47534',
			Октябрьский: '47554',
			Ольгино: '47555',
			Ольхи: '47532',
			Ольшанка: '47558',
			Оржевка: '47559',
			Орловка: '4752',
			Осиновка: '47531',
			Отрада: '47542',
			Отхожее: '47555',
			Отъяссы: '47532',
			Панское: '47545',
			Паревка: '47553',
			Пеньки: '47533',
			Первомайский: '47548',
			Перевоз: '47555',
			Перикса: '4752',
			Перкино: '47532',
			Песковатка: '47544',
			Песчаное: '47544',
			Петровка: '47556',
			Петровское: '47544',
			Питерское: '47533',
			Питим: '47554',
			Пичаево: '47554',
			Пичер: '47531',
			Платоновка: '47531',
			Плодопитомник: '47553',
			Плоское: '47542',
			Подвигаловка: '47537',
			Подлесное: '47532',
			Подоскляй: '47531',
			Подъем: '47554',
			Покровка: '47546',
			Покровское: '47544',
			Полетаево: '47557',
			Понзари: '47556',
			Прибытки: '47534',
			Пригородный: '47533',
			Протасово: '47555',
			Прудки: '47546',
			Раево: '47533',
			Ракша: '47533',
			Рамза: '47537',
			Ранино: '47545',
			Рассказово: '47531',
			Рахманино: '47544',
			Ржакса: '47555',
			Рождественское: '47531',
			Розановка: '47557',
			Рудовка: '47554',
			Рыбное: '47533',
			Рымарево: '47535',
			Рысли: '47533',
			Савелово: '47543',
			Сампур: '47556',
			Сарымовка: '47533',
			Сатинка: '47556',
			Сатино: '47553',
			Саюкино: '47531',
			Свинино: '47544',
			Свищевка: '47537',
			Селезни: '4752',
			Семикино: '47532',
			Серединовка: '47556',
			Серповое: '47533',
			Сестренка: '47544',
			Скачиха: '47559',
			Скобелевка: '47543',
			Советское: '47532',
			Соколово: '47537',
			Сосновка: '47532',
			Софьинка: '47559',
			Софьино: '47551',
			Спасское: '47543',
			Стаево: '47545',
			Староалександровка: '47543',
			Старокленское: '47548',
			Старосеславино: '47548',
			Старотомниково: '47533',
			Староюрьево: '47543',
			Стежки: '47532',
			Стеньшино: '47544',
			Степановка: '47555',
			Степной: '47542',
			Столовое: '4752',
			Строитель: '4752',
			Сукмановка: '47535',
			Сулак: '47559',
			Сурава: '4752',
			Сурки: '47537',
			Сухотинка: '47552',
			Сычевка: '47536',
			Тамбов: '4752',
			Таракса: '47554',
			Татаново: '4752',
			Татарщина: '47531',
			Текино: '47556',
			Телешовка: '47531',
			Терновое: '47545',
			Терское: '47545',
			Токарёвка: '47557',
			Трегуляй: '4752',
			Трескино: '47553',
			Троицкое: '47546',
			Туголуково: '47535',
			Тулиновка: '4752',
			Турмасово: '47545',
			Туровка: '47536',
			Тынково: '47544',
			Уварово: '47558',
			Уваровщина: '47537',
			Умет: '47559',
			Успеновка: '47544',
			Филатовский: '47553',
			Хитрово: '47531',
			Хлудово: '47533',
			Хлыстовский: '47533',
			Хмелинка: '47537',
			Хоботово: '47548',
			Хоперка: '47542',
			Хорошавка: '47553',
			Христофоровка: '47532',
			Царевка: '47559',
			Цветовка: '47535',
			Чакино: '47555',
			Чащино: '47546',
			Чегловка: '47544',
			Чекмари: '47532',
			Черемушка: '47548',
			Чернавка: '47553',
			Чернышевка: '47548',
			Черняевка: '47542',
			Черняное: '4752',
			Чикаревка: '47535',
			Чичерино: '47557',
			Чуповка: '47551',
			Чутановка: '47537',
			Шапкино: '47546',
			Шача: '47534',
			Шехмань: '47544',
			Шиновка: '47537',
			Шмаровка: '47542',
			Шпикулово: '47535',
			Шульгино: '47542',
			Эксталь: '4752',
			Энгуразово: '47558',
			Юбилейный: '47553',
			Юрловка: '47536',
			Яблоновец: '47544',
			Ярок: '47545'
		}
	},
	'Тверская область': {
		regionCode: '482',
		cities: {
			'Беле-Кушальское': '48223',
			'Белое Село': '48231',
			'Белый Городок': '48236',
			'Белый Омут': '48233',
			'Березовский Рядок': '48238',
			'Большая Каденка': '48258',
			'Большая Коша': '48269',
			'Большие Борки': '48223',
			'Большие Горки': '48223',
			'Большое Вишенье': '48251',
			'Большое Кашино': '48269',
			'Большое Кузнечково': '48257',
			'Большое Малинское': '48272',
			'Большое Овсяниково': '48264',
			'Большое Петрово': '48251',
			'Большое Рагозино': '48237',
			'Большое Святцево': '48251',
			'Большой Борок': '48257',
			'Бор-Пруды': '48271',
			'Борок Сулежский': '48231',
			'Васильевский Мох': '48223',
			'Верхнее Заборье': '48266',
			'Верхняя Троица': '48234',
			'Ворошилово ': '48249',
			'Ворошилово Малица ': '48249',
			'Второе Моховое': '48242',
			'Вышний Волочёк': '48233',
			'Гладкий Лог': '48267',
			'Голубые Озера': '48255',
			'Городня-на-Волге': '48242',
			'Дмитрова Гора': '48242',
			'Дмитрово-Черкасское': '48223',
			'Дружная Горка': '48269',
			'Завидовская Горка': '48274',
			'Западная Двина': '48265',
			'Кесова Гора': '48274',
			'Княжьи Горы': '48262',
			'Кожина Гора': '48271',
			'Косковская Горка': '48244',
			'Красная Гора': '48223',
			'Красная Заря': '48233',
			'Красное Знамя': '48276',
			'Красный Городок': '48257',
			'Красный Торфяник': '48251',
			'Красный Холм': '48237',
			'Кривая Лука': '48273',
			'Лисицкий Бор': '48223',
			'Малое Ананкино': '48269',
			'Малое Василево': '48236',
			'Малое Вишенье': '48251',
			'Малое Коробино': '48262',
			'Малые Ручьи': '48242',
			'Малые Сетки': '48234',
			'Михайлова Гора': '48261',
			'Молодой Туд': '48258',
			'Моркины Горы': '48231',
			'Николо-Высокое': '48264',
			'Николо-Малица': '4822',
			'Николо-Пустынь': '48262',
			'Николо-Ям': '48236',
			'Новое Ободово': '48276',
			'Новые Ельцы': '48235',
			'Озерская Горка': '48255',
			'Осиновая Гряда': '48261',
			'Острые Луки': '48253',
			'Первое Мая': '48242',
			'Погорелое Городище': '48262',
			'Пречисто-Каменка': '48257',
			'Рыбинское Заручье': '48253',
			'Старая Торопа': '48265',
			'Старое Гвоздино': '48237',
			'Старое Домкино': '48242',
			'Старое Мелково': '48242',
			'Старое Сандово': '48272',
			'Старое Устиново': '48262',
			'Старые Горки': '48262',
			'Старый Погост': '48223',
			'Черный Дор': '48235',
			'Чистая Дуброва': '48264',
			'Шишково-Дуброво': '48231',
			Аболешево: '48262',
			Аввакумово: '48223',
			Академический: '48233',
			Аксеново: '48267',
			Аксентьево: '48265',
			Алабузино: '48231',
			Алферово: '48249',
			Альфимово: '48251',
			Андреаполь: '48267',
			Андрейково: '48223',
			Антипино: '48250',
			Антоновское: '48275',
			Анцифарово: '48261',
			Апарниково: '48234',
			Апухтино: '48249',
			Архангельское: '48263',
			Афанасово: '48237',
			Ахматово: '48275',
			Бабино: '48263',
			Бабынино: '48263',
			Баево: '48265',
			Барановка: '48261',
			Баринцево: '48249',
			Барсуки: '48273',
			Батуриха: '48253',
			Бахмутово: '48232',
			Бежецк: '48231',
			Беклемишево: '48246',
			Бекрень: '48237',
			Белавино: '48233',
			Белый: '48250',
			Бельский: '48233',
			Беляницы: '48246',
			Бенцы: '48265',
			Бережки: '48246',
			Березайка: '48238',
			Березино: '48223',
			Березовка: '48261',
			Березуг: '48269',
			Берново: '48263',
			Бибирево: '48265',
			Биколово: '48275',
			Бирючево: '48276',
			Бителево: '48249',
			Благинино: '48262',
			Бобровец: '48267',
			Бобровка: '48258',
			Богатьково: '48251',
			Бойково: '48263',
			Бологово: '48267',
			Бологое: '48238',
			Болотово: '48267',
			Борзыни: '48257',
			Борисовский: '48233',
			Борихино: '48234',
			Борки: '48262',
			Боровно: '48233',
			Бохтово: '48271',
			Братково: '48263',
			Братское: '48237',
			Броды: '48263',
			Брусово: '48255',
			Брылево: '48257',
			Брылино: '48274',
			Брычево: '48262',
			Буденовка: '48253',
			Будино: '48250',
			Будово: '48251',
			Бузыково: '48234',
			Буйлово: '48244',
			Бурашево: '48223',
			Бухолово: '48233',
			Бушевец: '48238',
			Быково: '48236',
			Быльцыно: '48251',
			Валентиновка: '48233',
			Васильевское: '48263',
			Васильки: '48237',
			Васьково: '48274',
			Васюково: '48231',
			Васюнино: '48237',
			Вахонино: '48242',
			Введенье: '48275',
			Ведное: '48244',
			Велеса: '48265',
			Великооктябрьский: '48239',
			Венецианово: '48255',
			Верескуново: '48255',
			Верхневолжская: '48242',
			Верховье: '48250',
			Вески: '48261',
			Весьегонск: '48264',
			Власово: '48246',
			Воздвиженка: '48253',
			Вокшино: '48272',
			Волговерховье: '48235',
			Волково: '48244',
			Волок: '48267',
			Волосково: '48244',
			Воронино: '48258',
			Воронцово: '48249',
			Вороны: '48273',
			Воропуни: '48251',
			Воротьково: '48258',
			Ворошилово: '48230',
			Восход: '48251',
			Выдропужск: '48276',
			Выдры: '48268',
			Выползово: '48238',
			Выскодня: '48255',
			Высокое: '48251',
			Высокуша: '48237',
			Вышково: '48261',
			Вязьмицы: '48257',
			Гайново: '48236',
			Глазомичи: '48265',
			Глухово: '48251',
			Гнездово: '48261',
			Голибицы: '48268',
			Горбачево: '48236',
			Горка: '48275',
			Горки: '48266',
			Горняк: '48233',
			Гороватка: '48273',
			Городищи: '48231',
			Гостенево: '48263',
			Гостиница: '48253',
			Градницы: '48231',
			Гриблянка: '48255',
			Григорково: '48246',
			Гришино: '48258',
			Грузины: '48251',
			Грядцы: '48268',
			Грязновец: '48276',
			Гузятино: '48238',
			Гурьево: '48263',
			Гусево: '48258',
			Давыдово: '48234',
			Даниловское: '48223',
			Дарьино: '48263',
			Дворищи: '48271',
			Деледино: '48275',
			Демяхи: '48250',
			Денежное: '48263',
			Дербужье: '48276',
			Дерягино: '48255',
			Диево: '48244',
			Дмитрово: '48269',
			Дмитровское: '48223',
			Домославль: '48233',
			Дорожаево: '48262',
			Дрыгомо: '48269',
			Дубищи: '48253',
			Дуброва: '48231',
			Дубровка: '48239',
			Дубровки: '48269',
			Дуброво: '48265',
			Дудорово: '48251',
			Дымово: '48249',
			Дымцево: '48253',
			Дятлово: '48233',
			Егна: '48264',
			Егорье: '48250',
			Езвино: '48223',
			Ельцы: '48269',
			Емельяново: '48263',
			Еремеевка: '48276',
			Еремково: '48255',
			Есемово: '48232',
			Есеновичи: '48233',
			Есинка: '48232',
			Еськи: '48231',
			Жарковский: '48273',
			Жданово: '48235',
			Жедулино: '48268',
			Жилино: '48236',
			Жилотково: '48233',
			Житищи: '48231',
			Забелино: '48230',
			Заборье: '48230',
			Заволжский: '48223',
			Задово: '48234',
			Задубье: '48235',
			Заево: '48230',
			Зайцево: '48232',
			Заклинье: '48244',
			Залазино: '48261',
			Залучье: '48235',
			Замытье: '48244',
			Занепречье: '48235',
			Заовражье: '48257',
			Засека: '48253',
			Застолбье: '48244',
			Застровье: '48271',
			Захарово: '48269',
			Зеленогорский: '48233',
			Зеленцово: '48234',
			Зеленцыно: '48234',
			Зеленый: '48251',
			Зеленьково: '48273',
			Земцы: '48266',
			Зехново: '48235',
			Знаменское: '48258',
			Зобнино: '48234',
			Зобы: '48231',
			Зубцов: '48262',
			Иваново: '48264',
			Ивановское: '48244',
			Игуменка: '48242',
			Изоплит: '48242',
			Ильгощи: '48244',
			Ильенки: '48258',
			Ильятино: '48238',
			Исаково: '48249',
			Итомля: '48232',
			Каблуково: '48223',
			Кава: '48261',
			Кавельщино: '48250',
			Калашниково: '48261',
			Калязин: '48249',
			Каменка: '48253',
			Капшино: '48249',
			Карамзино: '48262',
			Карачарово: '48242',
			Касково: '48255',
			Кафтино: '48238',
			Кашин: '48234',
			Кащенки: '48273',
			Каюрово: '48236',
			Квакшино: '48223',
			Кемцы: '48238',
			Кесьма: '48264',
			Киверичи: '48244',
			Кимры: '48236',
			Киселево: '48269',
			Кистутово: '48253',
			Клыпино: '48268',
			Ключевая: '48253',
			Ключевое: '48267',
			Княжиха: '48231',
			Князево: '4822',
			Княщины: '48233',
			Козино: '48265',
			Козьмодемьяновское: '48234',
			Кой: '48246',
			Коломно: '48233',
			Колталово: '48223',
			Комары: '48250',
			Комсомольский: '48239',
			Конаково: '48242',
			Копейки: '48266',
			Коптево: '48263',
			Кореничено: '48263',
			Коробово: '48234',
			Королевщина: '48273',
			Корыхново: '48238',
			Кострецы: '48253',
			Костюшино: '48267',
			Котлован: '48255',
			Котово: '48250',
			Кочевино: '48231',
			Кочута: '48268',
			Краски: '48269',
			Красномайский: '48233',
			Краснополец: '48268',
			Красноселье: '48268',
			Красуха: '48253',
			Кривцово: '48266',
			Крюково: '48249',
			Кувшиново: '48257',
			Куженкино: '48238',
			Кузнецково: '48275',
			Кузнецово: '48233',
			Кузовино: '48261',
			Кулицкая: '48223',
			Кумордино: '48223',
			Куракино: '48250',
			Курово: '48255',
			Курьяново: '48232',
			Куряево: '48235',
			Кучино: '48236',
			Кушалино: '48244',
			Лаврово: '48246',
			Ладожское: '48272',
			Ладьино: '48251',
			Лаптиха: '48231',
			Леонтьево: '48232',
			Леонтьевское: '48249',
			Лесниково: '48258',
			Лесное: '48271',
			Леушино: '48234',
			Липига: '48251',
			Липны: '48255',
			Липовка: '48249',
			Лисково: '48274',
			Лихославль: '48261',
			Лобково: '48234',
			Лопатиха: '48271',
			Лосево: '48236',
			Лощемля: '48253',
			Лубеньковский: '48255',
			Луги: '48267',
			Лужане: '48268',
			Лужково: '48251',
			Лужниково: '48233',
			Лукино: '48272',
			Луковниково: '48263',
			Лухново: '48276',
			Лыкошино: '48238',
			Любегощи: '48264',
			Любино: '48267',
			Любитово: '48238',
			Лядины: '48244',
			Ляды: '48231',
			Ляхово: '48251',
			Макеево: '48265',
			Максатиха: '48253',
			Максимково: '48269',
			Малышево: '48253',
			Мануйлово: '48251',
			Мартисово: '48268',
			Мартыново: '48237',
			Мартьяново: '48263',
			Марьино: '48251',
			Матино: '48234',
			Медведиха: '48244',
			Медведково: '48271',
			Мелентьево: '48269',
			Мермерино: '48223',
			Мигуново: '48232',
			Микшино: '48261',
			Минькино: '48230',
			Мирный: '48251',
			Митенево: '48223',
			Митино: '48251',
			Митьково: '48232',
			Михайлики: '48232',
			Могилевка: '48257',
			Мокшино: '48242',
			Молдино: '48255',
			Молоково: '48275',
			Монаково: '48271',
			Мончалово: '48232',
			Морозово: '48231',
			Мосеевцы: '48235',
			Мостовая: '48258',
			Мошары: '48230',
			Мошенка: '48235',
			Мошки: '48251',
			Мста: '48255',
			Муравьево: '48232',
			Мухино: '48223',
			Мушино: '48255',
			Мылохово: '48267',
			Мякишево: '48267',
			Назарово: '48261',
			Неклюдово: '48236',
			Некрашово: '48268',
			Неледино: '48237',
			Нелидово: '48266',
			Нерль: '48249',
			Нивы: '48237',
			Нишевицы: '48268',
			Новозавидовский: '48242',
			Новокотово: '48275',
			Новоникольское: '48266',
			Новопхово: '48253',
			Новоселки: '48266',
			Овинище: '48264',
			Овинищи: '48237',
			Овсище: '48233',
			Овчинники: '48232',
			Озерец: '48268',
			Озерки: '48242',
			Озерный: '48238',
			Оковцы: '48269',
			Октябрьское: '48268',
			Оленино: '48258',
			Олехново: '48276',
			Ольхово: '48269',
			Орехово: '48232',
			Орешки: '48263',
			Орлинка: '48230',
			Орловка: '48262',
			Орлово: '48263',
			Орша: '48223',
			Осечно: '48233',
			Ососье: '48276',
			Осташков: '48235',
			Осташково: '48251',
			Остолопово: '48264',
			Островно: '48255',
			Осуга: '48232',
			Отрадное: '48258',
			Охват: '48230',
			Павлюки: '48232',
			Пальцево: '48238',
			Пальчиха: '48253',
			Паникля: '48266',
			Панино: '48232',
			Паньково: '48263',
			Парихино: '48232',
			Паскино: '48236',
			Пено: '48230',
			Пень: '48257',
			Пенье: '48249',
			Первитино: '48261',
			Первомайский: '48265',
			Переварово: '48232',
			Передово: '48275',
			Пестряково: '48268',
			Петуново: '48232',
			Печетово: '48236',
			Пирогово: '48251',
			Пищалино: '48262',
			Пищалкино: '48246',
			Плоскошь: '48268',
			Плотники: '48231',
			Пнево: '48272',
			Победа: '48232',
			Подвязье: '48267',
			Подгороднее: '48268',
			Подобино: '48246',
			Пожитово: '48251',
			Пожня: '48268',
			Покров: '48275',
			Покровское: '48263',
			Полубратово: '48223',
			Понизовье: '48268',
			Поповка: '48237',
			Поповский: '48250',
			Поречье: '48249',
			Порожки: '48255',
			Потесы: '48231',
			Приволжский: '48236',
			Пригорки: '48246',
			Пригородный: '48233',
			Присеки: '48231',
			Прудово: '48261',
			Прямухино: '48257',
			Пустораменка: '48244',
			Пустошка: '48269',
			Пушкино: '48223',
			Пышково: '48250',
			Пятиусово: '48265',
			Пятницкое: '48268',
			Радченко: '48242',
			Раевское: '48253',
			Раково: '48262',
			Раменье: '48276',
			Рамешки: '48244',
			Редкино: '48242',
			Ременники: '48237',
			Речане: '48268',
			Ржев: '48232',
			Ривицкий: '48253',
			Рогалево: '48258',
			Рогожа: '48235',
			Родня: '48263',
			Рождествено: '48223',
			Рождество: '48239',
			Романово: '48263',
			Рунский: '48230',
			Русино: '48251',
			Ручки: '48253',
			Рютино: '48238',
			Ряд: '48255',
			Рязаново: '48223',
			Рясня: '48263',
			Савватьево: '48223',
			Савцыно: '48234',
			Салино: '48262',
			Сандово: '48272',
			Сахарово: '4822',
			Свапуще: '48235',
			Светлица: '48235',
			Севостьяново: '48265',
			Сеглино: '48238',
			Селижарово: '48269',
			Селище: '48269',
			Селы: '48266',
			Сельцы: '48253',
			Семендяево: '48249',
			Серебряники: '48233',
			Середка: '48230',
			Сиговка: '48235',
			Сидорково: '48253',
			Сидорово: '48263',
			Синцово: '48242',
			Скворцово: '48268',
			Скнятино: '48249',
			Скоросово: '48237',
			Славково: '48234',
			Славное: '48223',
			Славный: '48251',
			Слаутино: '48230',
			Смутиха: '48274',
			Снопово: '48268',
			Соблаго: '48230',
			Соболины: '48272',
			Сокольники: '48257',
			Солнечный: '48233',
			Сонково: '48246',
			Сорога: '48235',
			Сорогожское: '48271',
			Сосница: '48235',
			Сосновицы: '48261',
			Сосновка: '48239',
			Спасское: '48249',
			Спиридово: '48267',
			Спирово: '48276',
			Стан: '48261',
			Старица: '48263',
			Старобислово: '48249',
			Степурино: '48263',
			Столбищи: '48264',
			Столбово: '48274',
			Столыпино: '48262',
			Стоянцы: '48236',
			Страшевичи: '48251',
			Стрелиха: '48274',
			Стружня: '48251',
			Студеница: '48267',
			Стулово: '48234',
			Суборь: '48275',
			Сукромля: '48251',
			Сукромны: '48231',
			Суровцово: '48263',
			Сутоки: '48244',
			Суховерково: '48223',
			Сухуша: '48232',
			Сушигорицы: '48272',
			Сырцевка: '48231',
			Сытьково: '48232',
			Талица: '48268',
			Таложня: '48251',
			Тальцы: '48269',
			Тарасково: '48257',
			Тархово: '48258',
			Татево: '48258',
			Тверецкий: '48251',
			Тверь: '4822',
			Теблеши: '48231',
			Телятники: '48271',
			Телятово: '48264',
			Терелесовский: '48233',
			Терешкино: '48251',
			Тетьково: '48234',
			Тиволино: '48234',
			Тимирязево: '48249',
			Тимково: '48238',
			Тимошкино: '48264',
			Титово: '48236',
			Толмачи: '48261',
			Толокново: '48258',
			Топалки: '48272',
			Топорово: '48272',
			Торжок: '48251',
			Торопаца: '48267',
			Торопец: '48268',
			Требески: '48258',
			Тредубье: '48251',
			Трестино: '48239',
			Трестна: '48253',
			Троицкое: '48273',
			Трубино: '48232',
			Труд: '48239',
			Трудовой: '48233',
			Труженик: '48253',
			Тупиково: '48251',
			Тургиново: '48223',
			Турчаниново: '48246',
			Турынино: '48274',
			Тухани: '48272',
			Тысяцкое: '48257',
			Удомля: '48255',
			Улейки: '48258',
			Улин: '48265',
			Ульянино: '48237',
			Ульяново: '48262',
			Уницы: '48234',
			Успенское: '48232',
			Устиново: '48236',
			Фалево: '48234',
			Федоровка: '48236',
			Федоровское: '48242',
			Федцово: '48274',
			Филиппково: '48231',
			Филистово: '48269',
			Фирово: '48239',
			Фофаново: '48265',
			Фролово: '48234',
			Хабоцкое: '48237',
			Хитино: '48235',
			Хлебники: '48258',
			Ходуново: '48239',
			Хозницы: '48231',
			Холмец: '48258',
			Холмина: '48258',
			Холохоленка: '48233',
			Хотилицы: '48267',
			Хотилово: '48238',
			Хотошино: '48269',
			Чайка: '48269',
			Чамерово: '48264',
			Чернецкое: '48264',
			Черногубово: '48223',
			Чертолино: '48232',
			Чичаты: '48250',
			Чуприяновка: '48223',
			Чупрово: '48234',
			Шайтровщина: '48250',
			Шарапово: '48265',
			Шепели: '48234',
			Шешурино: '48268',
			Шуваево: '48269',
			Шульгино: '48231',
			Щеколдино: '48262',
			Эммаусс: '48223',
			Энергетик: '48242',
			Эскино: '48234',
			Южный: '48235',
			Юрино: '48234',
			Юркино: '48231',
			Юрьевское: '48263',
			Юсино: '48257',
			Яблонька: '48239',
			Язвиха: '48261',
			Языковщина: '48268',
			Яковлевское: '48236',
			Яконово: '48251',
			Ямок: '4822',
			Яринское: '48249'
		}
	},
	'Томская область': {
		regionCode: '382',
		cities: {
			'Белый Яр': '38258',
			'Большая Галка': '38249',
			'Большая Грива': '38253',
			'Большая Саровка': '38254',
			'Верхняя Чигара': '38252',
			'Высокий Яр': '38249',
			'Зональная Станция': '3822',
			'Киевский Еган': '38253',
			'Коломинские Гривы': '38257',
			'Красная Горка': '38246',
			'Красный Яр': '38251',
			'Лукашкин Яр': '38255',
			'Могильный Мыс': '38254',
			'Моряковский Затон': '3822',
			'Новая Бурка': '38249',
			'Новый Васюган': '38253',
			'Новый Тевриз': '38253',
			'Светлая Протока': '38255',
			'Средний Васюган': '38253',
			'Старая Березовка': '38253',
			'Старая Ювала': '38244',
			'Усть-Бакчар': '38257',
			'Усть-Тым': '38253',
			'Усть-Чая': '38254',
			'Черный Яр': '38246',
			'Четь Конторка': '38246',
			'п. Максимкин Яр': '38258',
			Алатаево: '38252',
			Александровское: '38255',
			Альмяково: '38245',
			Анастасьевка: '38247',
			Аргатюл: '38245',
			Асино: '38241',
			Бабарыкино: '38247',
			Базой: '38244',
			Бакчар: '38249',
			Басандайка: '3822',
			Баткат: '38247',
			Беловодовка: '38243',
			Белосток: '38251',
			Белояровка: '38254',
			Беляй: '38245',
			Берегаево: '38246',
			Берлинка: '38243',
			Богатыревка: '38249',
			Богашево: '3822',
			Богословка: '38243',
			Большедорохово: '38241',
			Бондарка: '38253',
			Борзуновка: '38244',
			Борики: '3822',
			Бундюр: '38257',
			Вавиловка: '38249',
			Варгатер: '38257',
			Вертикос: '38253',
			Вершинино: '3822',
			Вознесенка: '38247',
			Володино: '38251',
			Воронино: '3822',
			Вороново: '38244',
			Гарь: '38241',
			Гореловка: '38257',
			Гришкино: '38257',
			Громышевка: '38243',
			Гусево: '38247',
			Дальнее: '38254',
			Десятово: '38244',
			Дзержинский: '3822',
			Дружный: '38258',
			Дубровка: '38243',
			Ежи: '38245',
			Елгай: '38244',
			Еловка: '38244',
			Жуково: '38251',
			Заводской: '38252',
			Золотушка: '38256',
			Зоркальцево: '3822',
			Зырянское: '38243',
			Игреково: '38256',
			Иловка: '38243',
			Инкино: '38254',
			Итатка: '3822',
			Иштан: '38251',
			Казанка: '38241',
			Калтай: '3822',
			Кандинка: '3822',
			Каргала: '38247',
			Каргасок: '38253',
			Катайга: '38258',
			Кафтанчиково: '3822',
			Кедровый: '38250',
			Кенга: '38249',
			Киндал: '38253',
			Киреевск: '38244',
			Кисловка: '3822',
			Клюквинка: '38258',
			Кожевниково: '38244',
			Колбинка: '38256',
			Колпашево: '38254',
			Комсомольск: '38245',
			Копылово: '3822',
			Корнилово: '3822',
			Кривошеино: '38251',
			Крыловка: '38249',
			Куржино: '38254',
			Курлек: '3822',
			Куролино: '38258',
			Куяново: '38245',
			Леботер: '38257',
			Лисица: '38258',
			Лоскутово: '3822',
			Лучаново: '3822',
			Макзыр: '38258',
			Малобрагино: '38247',
			Маложирово: '38241',
			Маркелово: '38247',
			Межениновка: '3822',
			Мельниково: '38247',
			Минаевка: '38241',
			Мирный: '3822',
			Михайловка: '38243',
			Могочин: '38256',
			Молчаново: '38256',
			Монастырка: '38247',
			Мыльджино: '38253',
			Назино: '38255',
			Напас: '38253',
			Нарга: '38256',
			Нарым: '38252',
			Наумовка: '3822',
			Неготка: '38253',
			Нельмач: '38252',
			Нелюбино: '3822',
			Нибегинский: '38258',
			Никольское: '38251',
			Новиковка: '38241',
			Новоархангельское: '3822',
			Новогорное: '38254',
			Новодубровка: '38244',
			Новоильика: '38254',
			Новоильинка: '38247',
			Новокривошеино: '38251',
			Новокусково: '38241',
			Новомариинка: '38245',
			Новониколаевка: '38241',
			Новоникольское: '38255',
			Новопокровка: '38244',
			Новорождественское: '3822',
			Новоселово: '38254',
			Новосельцево: '38252',
			Новосергеевка: '38244',
			Новоюгино: '38253',
			Новый: '38245',
			Обское: '38257',
			Озерное: '38254',
			Октябрьский: '3822',
			Окунеево: '38243',
			Орехово: '38245',
			Орловка: '3822',
			Осиновка: '38244',
			Осипово: '38252',
			Оськино: '38247',
			Павлово: '38253',
			Палочка: '38258',
			Панычево: '38249',
			Парабель: '38252',
			Парбиг: '38249',
			Первомайское: '38245',
			Петровка: '38251',
			Плотниково: '38249',
			Победа: '38247',
			Подгорное: '38257',
			Полынянка: '38249',
			Поротниково: '38249',
			Прокоп: '38252',
			Прохоркино: '38255',
			Пудино: '38252',
			Пудовка: '38251',
			Рассвет: '3822',
			Рогалево: '38252',
			Рыбалово: '3822',
			Сайга: '38258',
			Самусь: '3822',
			Сарафановка: '38256',
			Светлый: '3822',
			Север: '38254',
			Северск: '3823',
			Семеновка: '38243',
			Семилужки: '3822',
			Сенькино: '38252',
			Сергеево: '38245',
			Соколовка: '38256',
			Сосновка: '38253',
			Старица: '38252',
			Старокороткино: '38254',
			Староюгино: '38253',
			Степановка: '38258',
			Стрежевой: '38259',
			Суйга: '38256',
			Сулзат: '38256',
			Тавлы: '38243',
			Тарбеево: '38245',
			Тарск: '38252',
			Татьяновка: '38247',
			Тегульдет: '38246',
			Тека: '38244',
			Тимирязевский: '3822',
			Тимирязевское: '3822',
			Тискино: '38254',
			Тогур: '38254',
			Томск: '3822',
			Трубачево: '38247',
			Тунгусово: '38256',
			Турунтаево: '3822',
			Тымск: '38253',
			Узень: '38245',
			Улуюл: '38245',
			Уртам: '38244',
			Филимоновка: '38241',
			Халдеево: '3822',
			Центральный: '38258',
			Центрополигон: '38246',
			Чажемто: '38254',
			Чаинск: '38257',
			Чердаты: '38243',
			Чернышевка: '38249',
			Чилино: '38244',
			Шпалозавод: '38252'
		}
	},
	'Тульская область': {
		regionCode: '487',
		cities: {
			'Бежин Луг': '48756',
			'Большая Тросна': '48751',
			'Большие Глубочки': '48733',
			'Большие Медведки': '48741',
			'Большие Озерки': '48752',
			'Большие Плоты': '48741',
			'Большое Огарево': '48755',
			'Большое Шелепино': '48753',
			'Бредихино Первое': '48756',
			'Венев-Монастырь': '48745',
			'Верхнее Касимово': '48736',
			'Верхнее Красино': '48766',
			'Дедиловские Выселки': '48745',
			'Долгие Лески': '48744',
			'Захарьинские Выселки': '48766',
			'Косая Гора': '4872',
			'Красная Дубровка': '48768',
			'Красное Михайлово': '48763',
			'Красные Буйцы': '48761',
			'Красный Богатырь': '48762',
			'Крюковка Первая': '48755',
			'Кузьмино-Доможирово': '48751',
			'Малая Огаревка': '48755',
			'Молочные Дворы': '48752',
			'Молчаново Правое': '48756',
			'Николо-Вяземское': '48756',
			'Николо-Гастунь': '48742',
			'Новая Велична': '48742',
			'Новая Покровка': '48756',
			'Новое Павшино': '48732',
			'Новые Выселки': '48751',
			'Новые Дольцы': '48742',
			'Павлов Хутор': '48741',
			'Пирогово Первое': '48751',
			'Покровское Первое': '48755',
			'Северо-Агеевский': '48763',
			'Северо-Задонск': '48746',
			'Серебряные Ключи': '48754',
			'Синегубово Первое': '48756',
			'Спас-Конино': '48753',
			'Страхово ': '48734',
			'Сухие Плоты': '48768',
			'Теряево Первое': '48734',
			'Товарково Вокзал': '48761',
			'Троицкое-Бачурино': '48756',
			'Хороше-Полево': '48752',
			'Ченцовы Дворы': '48736',
			'Черная Грязь': '48754',
			'Ясная Поляна ': '48751',
			'Ясная Поляна': '48751',
			'деревня Пирогово': '48745',
			'п. Чернь': '48756',
			'поселок Епифан': '48735',
			'поселок Скуратовский': '48756',
			'село Песковатское': '48763',
			Авангард: '48753',
			Агеево: '48763',
			Аксиньино: '48745',
			Александринский: '48761',
			Алексин: '48753',
			Алешня: '4876',
			Андреевка: '48743',
			Анишино: '48745',
			Апухтино: '48736',
			Араны: '48733',
			Арсеньево: '48733',
			Архангельское: '48744',
			Бабошино: '48732',
			Барановка: '48735',
			Барсуки: '4876',
			Баскаково: '48768',
			Бахметьево: '48761',
			Бегичевский: '48761',
			Бельково: '48745',
			Белёв: '48742',
			Берники: '4876',
			Бестужево: '48731',
			Бобрики: '48742',
			Богдановка: '48762',
			Богородицк: '48761',
			Богословское: '48766',
			Болохово: '48754',
			Борисово: '48753',
			Боровковский: '48766',
			Бородинский: '48754',
			Борятино: '48768',
			Ботвиньево: '48736',
			Брусянский: '48731',
			Бураково: '48766',
			Буреломы: '48741',
			Бутиково: '48734',
			Бутырки: '48731',
			Бучалки: '48735',
			Быковка: '48754',
			Варварино: '48733',
			Варфоломеево: '4876',
			Васильевское: '48745',
			Велегож: '48734',
			Вельмино: '48731',
			Венёв: '48745',
			Верхоупье: '48768',
			Волово: '48768',
			Володьково: '48742',
			Воскресенское: '48732',
			Восход: '4876',
			Гагарино: '48761',
			Галица: '48744',
			Гамово: '48754',
			Гати: '48745',
			Глубоковский: '48763',
			Говоренки: '48736',
			Головеньки: '48751',
			Головлинский: '48754',
			Горбачево: '48752',
			Горелки: '4872',
			Горшково: '48766',
			Горьковский: '48755',
			Гремячее: '48762',
			Грецовка: '48751',
			Григорьевское: '48766',
			Грицовский: '48745',
			Гурьево: '48745',
			Дворики: '48768',
			Дедилово: '48754',
			Демидовка: '4876',
			Денисово: '48766',
			Диктатура: '48752',
			Дмитриевское: '48734',
			Долматово: '48756',
			Донской: '48746',
			Доробино: '48755',
			Дубики: '48741',
			Дубки: '48756',
			Дубна: '48732',
			Дубовка: '48731',
			Дьяконово: '48745',
			Егнышевка: '48753',
			Епифань: '48735',
			Ержино: '48756',
			Есуковский: '48766',
			Ефремов: '48741',
			Жданковский: '48761',
			Железница: '48742',
			Железня: '48734',
			Жемчужниково: '48736',
			Жердево: '48751',
			Жизнь: '48756',
			Житово: '48751',
			Задонье: '48746',
			Заокский: '48734',
			Захаровка: '48751',
			Зеленино: '48763',
			Зубовский: '48735',
			Ивановка: '48743',
			Иваново: '48742',
			Ивицы: '48736',
			Иевлево: '48761',
			Иноземка: '48741',
			Иншинский: '4876',
			Иста: '48733',
			Истленьево: '48768',
			Истьино: '48733',
			Кадное: '48744',
			Казановка: '48735',
			Казначеевский: '48751',
			Каменецкий: '48731',
			Каменское: '48744',
			Камынино: '48752',
			Карамышево: '48751',
			Караси: '48768',
			Квашино: '48766',
			Кимовск: '48735',
			Кипеть: '48763',
			Киреевск: '48754',
			Климовское: '48766',
			Клин: '48745',
			Кожинка: '48756',
			Козловка: '48745',
			Козье: '48741',
			Козьминский: '48741',
			Колосово: '48753',
			Коммунаров: '48762',
			Кондуки: '48731',
			Кочерово: '48742',
			Кочкино: '48741',
			Краинка: '48763',
			Крапивна: '48751',
			Красницкий: '48761',
			Красногвардеец: '48755',
			Красногвардейский: '48754',
			Красногорье: '48752',
			Красное: '48752',
			Краснополье: '48735',
			Круглянский: '48754',
			Кудашево: '48735',
			Кузнецово: '48754',
			Кузовка: '48761',
			Кузьменки: '48733',
			Кукуй: '48745',
			Кулешово: '48763',
			Куликовка: '48735',
			Куракино: '48754',
			Кураково: '4876',
			Куркино: '48743',
			Кытино: '48741',
			Лазарево: '48751',
			Ланьшинский: '48734',
			Лапотково: '48751',
			Ленинский: '4876',
			Липицы: '48756',
			Липки: '48754',
			Липово: '48751',
			Литвиново: '48733',
			Лобаново: '48741',
			Лобжа: '48732',
			Ломинцево: '48751',
			Ломинцевский: '48751',
			Ломовка: '48761',
			Лужное: '48732',
			Лужны: '48756',
			Лукино: '48751',
			Лутово: '48768',
			Львово: '48735',
			Любимовка: '48768',
			Люторичи: '48731',
			Майское: '48743',
			Маклец: '48762',
			Малевка: '48761',
			Малынь: '48751',
			Манаенки: '48733',
			Маслово: '48743',
			Машковичи: '48763',
			Машково: '48766',
			Медвенский: '4876',
			Менделеевский: '4872',
			Меркулово: '48733',
			Мечнянка: '48741',
			Мещерино: '48752',
			Милославщина: '48735',
			Мирный: '48735',
			Миротинский: '48734',
			Михайловский: '48743',
			Мичуринский: '48755',
			Мишенское: '48742',
			Молодежный: '4876',
			Молоденки: '48735',
			Молчаново: '48744',
			Мордвес: '48745',
			Мордовка: '48741',
			Моховое: '48743',
			Муравлянка: '48735',
			Надеждино: '48732',
			Нарышкино: '48755',
			Ненашево: '48734',
			Непрядва: '48768',
			Николаевка: '48741',
			Никольское: '48751',
			Новогуровский: '48753',
			Новокрасивое: '48741',
			Новольвовск: '48735',
			Новомосковск: '48762',
			Новоникольское: '48752',
			Новоогаревский: '48751',
			Новопетровский: '48744',
			Новопокровское: '48761',
			Новоселебное: '48754',
			Новоугольный: '48746',
			Огаревка: '48751',
			Одоев: '48736',
			Окороково: '48736',
			Оленьково: '48745',
			Ольхи: '48752',
			Опочня: '48732',
			Орловка: '48743',
			Островки: '48745',
			Павловка: '48761',
			Панарино: '48768',
			Папоротка: '48761',
			Партизан: '48731',
			Пахомово: '48734',
			Пашково: '48731',
			Першино: '48753',
			Песковатское: '48763',
			Песоченский: '48763',
			Плавск: '48752',
			Пластово: '48753',
			Плеханово: '4876',
			Поветкино: '48745',
			Подгорный: '48756',
			Подлесный: '48746',
			Пожилино: '48741',
			Полтево: '48756',
			Поречье: '48732',
			Правда: '48762',
			Прилепы: '4876',
			Прилесье: '48731',
			Присады: '4876',
			Приупский: '48754',
			Пришня: '48751',
			Прогресс: '48754',
			Пронь: '48735',
			Протасово: '48732',
			Прохоровка: '48762',
			Прудищи: '48745',
			Птань: '48743',
			Пчельна: '48736',
			Ракитино: '48731',
			Рахманово: '48752',
			Ревякино: '48766',
			Ржаво: '48751',
			Ровно: '48742',
			Рождественский: '4876',
			Романцевский: '48761',
			Руднев: '48746',
			Румянцево: '48735',
			Русятино: '48734',
			Рылево: '48736',
			Савино: '48762',
			Самарский: '48743',
			Санталовский: '48766',
			Свойно: '48763',
			Северный: '48755',
			Селиваново: '48751',
			Селюково: '48763',
			Сенево: '48753',
			Сергиевка: '48741',
			Сетка: '48745',
			Сеченский: '48754',
			Сизенево: '48732',
			Силино: '48743',
			Симоново: '48734',
			Ситово: '48744',
			Скоморошки: '48732',
			Скуратовский: '48756',
			Слобода: '48732',
			Смородино: '48731',
			Советск: '48751',
			Советский: '48754',
			Соклаково: '48744',
			Сокольники: '48762',
			Соловьевка: '48756',
			Солопенки: '48753',
			Сомово: '48736',
			Сорочинка: '48752',
			Социалистический: '48751',
			Спасское: '48762',
			Спицыно: '48766',
			Стахановский: '48754',
			Сторожа: '48741',
			Страхово: '48734',
			Стрелецкий: '48736',
			Стрикино: '48733',
			Студенец: '48745',
			Ступино: '48741',
			Суворов: '48763',
			Суханово: '48735',
			Суходол: '48753',
			Суходольский: '48761',
			Таболо: '48735',
			Тайдаково: '48766',
			Теплое: '48755',
			Товарковский: '48761',
			Торхово: '4876',
			Троекурово: '48755',
			Тула: '4872',
			Тулубьево: '48745',
			Тургенево: '48756',
			Турдей: '48768',
			Узловая: '48731',
			Успенское: '48755',
			Ханино: '48763',
			Хатманово: '48753',
			Хитровщина: '48735',
			Хомяково: '4872',
			Хотушь: '48766',
			Хрущево: '4876',
			Чекалин: '48763',
			Черепеть: '48763',
			Чернь: '48756',
			Черняевка: '48761',
			Шатово: '48732',
			Шатск: '4876',
			Шахтерский: '48746',
			Шахтинский: '48735',
			Шварцевский: '48754',
			Шилово: '48741',
			Ширинский: '48762',
			Шкилевка: '48741',
			Щёкино: '48751',
			Яблонево: '48744',
			Языково: '48744',
			Яковлево: '48734',
			Ямны: '4876',
			Яндовка: '48741',
			Ярославка: '48741',
			Ярцево: '48751',
			Ясенки: '48733',
			Ясногорск: '48766'
		}
	},
	'Тюменская область': {
		regionCode: '345',
		cities: {
			'Большая Заморозовка': '34533',
			'Большая Ченчерь': '34553',
			'Большие Ярки': '34553',
			'Большое Сорокино': '34550',
			'Большое Тихвино': '34535',
			'Большой Карагай': '34539',
			'Большой Краснояр': '34544',
			'Верхние Аремзяны': '3456',
			'Малая Зоркальцева': '3456',
			'Нижние Аремзяны': '3456',
			'Нижняя Тавда': '34533',
			'Новая Заимка': '34542',
			'Новый Тап': '34543',
			'Северо-Плетнево': '34543',
			'Сингуль-Татарский': '34535',
			'Слобода-Бешкиль': '34537',
			'Средние Тарманы': '34533',
			'Средние Чирки': '34546',
			'Старая Заимка': '34542',
			'Старая Маслянка': '34556',
			'Старый Кавдык': '34535',
			'Усть-Ламенка': '34546',
			'Челюскинцев им.': '34553',
			'Южно-Дубровное': '34547',
			'Южно-Плетнево': '34544',
			'с. Исетское': '34537',
			'село Викулово': '34557',
			Абалак: '3456',
			Абатский: '34556',
			Агарак: '34543',
			Аксурка: '34539',
			Александровка: '34555',
			Алымка: '34561',
			Андреевский: '3452',
			Андрюшино: '34533',
			Антипино: '34533',
			Армизонское: '34547',
			Аромашево: '34545',
			Архангельское: '34537',
			Аслана: '34535',
			Афонькино: '34553',
			Ахманский: '34533',
			Ачиры: '3456',
			Байкалово: '3456',
			Балаганы: '34557',
			Банниково: '34556',
			Бархатово: '34537',
			Бачелино: '34531',
			Бегишево: '34539',
			Бельховка: '34543',
			Бердюгино: '34535',
			Бердюжье: '34554',
			Березовка: '34533',
			Беркут: '34535',
			Бескозобово: '34546',
			Бигила: '34542',
			Бизино: '3456',
			Бития: '34556',
			Бобылево: '34537',
			Богандинский: '3452',
			Боково: '34557',
			Болдырево: '34556',
			Борки: '3452',
			Боровинка: '34542',
			Боровлянка: '34546',
			Боровое: '34551',
			Боровский: '3452',
			Булашево: '3456',
			Буньково: '34541',
			Бурлаки: '34547',
			Бутусово: '34551',
			Бухтал: '34533',
			Бушуево: '34543',
			Бызово: '34541',
			Быструха: '34556',
			Вагай: '34539',
			Варвара: '34531',
			Велижаны: '34533',
			Верхнебешкиль: '34537',
			Викулово: '34557',
			Винзили: '3452',
			Водолазово: '34556',
			Володино: '34543',
			Ворсиха: '34550',
			Восток: '34556',
			Второвагайское: '34539',
			Второпесьяново: '34551',
			Гагарино: '34551',
			Гагарье: '34553',
			Гладилово: '34546',
			Голдобино: '34551',
			Голышманово: '34546',
			Горнослинкино: '34561',
			Горьковка: '3452',
			Горюново: '34542',
			Готопутово: '34550',
			Грачи: '34553',
			Дегтярево: '3456',
			Демьянское: '34561',
			Денисово: '34537',
			Дронова: '34542',
			Дубынка: '34553',
			Евсино: '34546',
			Ембаево: '3452',
			Емуртла: '34541',
			Емуртлинский: '34541',
			Ермаки: '34557',
			Ермаково: '3456',
			Ершово: '34551',
			Жидоусово: '34550',
			Журавлевское: '34544',
			Заводопетровский: '34535',
			Заводоуковск: '34542',
			Загваздина: '3456',
			Задонка: '34555',
			Заречный: '34539',
			Зарослое: '34554',
			Земляная: '34546',
			Зиново: '34535',
			Знаменщиково: '34550',
			Зоново: '34543',
			Иваново: '34547',
			Иевлево: '34531',
			Ильинка: '34553',
			Ингалинское: '34541',
			Инжура: '34539',
			Иртыш: '34539',
			Иртышский: '3456',
			Исетское: '34537',
			Иска: '34533',
			Истошино: '34554',
			Ишим: '34551',
			Казанское: '34553',
			Калинино: '34557',
			Калиновка: '34550',
			Калмакское: '34547',
			Каменка: '3452',
			Камышинская: '34556',
			Канаш: '34533',
			Капралиха: '34547',
			Карабаш: '34535',
			Каравай: '34555',
			Карасуль: '34551',
			Караульнояр: '34531',
			Карачино: '3456',
			Карбаны: '34531',
			Каргалы: '34557',
			Кармацкая: '34545',
			Картымский: '34533',
			Каскара: '3452',
			Касьяново: '34539',
			Киева: '34535',
			Киндер: '34533',
			Кировский: '34537',
			Кирсарай: '34561',
			Киселево: '34541',
			Клепиково: '34551',
			Ключи: '34533',
			Княжево: '3452',
			Коктюль: '34535',
			Колесниково: '34542',
			Коммунар: '34537',
			Комсомольский: '34539',
			Конево: '34556',
			Коркино: '34541',
			Королево: '34546',
			Коточиги: '34557',
			Красивое: '34555',
			Красново: '34537',
			Красноорловское: '34547',
			Крашенинино: '34541',
			Кротово: '34545',
			Кукушки: '34537',
			Кулаково: '3452',
			Куларово: '34539',
			Кулики: '34535',
			Курья: '34539',
			Кутарбитка: '3456',
			Лабино: '34543',
			Лайтамак: '3456',
			Ламенский: '34546',
			Лариха: '34551',
			Лебедевка: '34542',
			Ленинка: '34556',
			Лесное: '34543',
			Лесозаводский: '34533',
			Липиха: '34541',
			Лопазное: '34555',
			Луговое: '3452',
			Майка: '34555',
			Майский: '34556',
			Малахово: '34557',
			Малиновка: '34545',
			Малоскаредное: '34545',
			Малышенка: '34546',
			Мальково: '3452',
			Маранка: '34531',
			Масали: '34541',
			Маслянский: '34555',
			Медведево: '34546',
			Мелехино: '34554',
			Менделеево: '3456',
			Менжинское: '34555',
			Мизоново: '34551',
			Минино: '34537',
			Мияссы: '34533',
			Московский: '3452',
			Муллаши: '3452',
			Надцы: '3456',
			Назарово: '34556',
			Неволина: '34551',
			Нерпино: '34551',
			Нижнеманай: '34541',
			Нижнепинигино: '34550',
			Николаевка: '34545',
			Никулино: '34555',
			Новикова: '34537',
			Новоалександровка: '34531',
			Новоандреевка: '34555',
			Новоаптула: '34545',
			Новоатъялово: '34535',
			Новоберезовка: '34545',
			Нововяткино: '34557',
			Новоказанка: '34555',
			Новокаишкуль: '34531',
			Новолокти: '34551',
			Новолыбаево: '34542',
			Новоникольское: '34533',
			Новопетрово: '34545',
			Новопокровка: '34533',
			Новотарманский: '3452',
			Новотравное: '34551',
			Новотроицкое: '34533',
			Овсово: '34545',
			Овсянникова: '3456',
			Огнево: '34553',
			Одино: '34541',
			Ожогино: '34551',
			Озерное: '34557',
			Окунево: '34554',
			Окуневское: '34544',
			Омутинский: '34544',
			Омутинское: '34544',
			Онохино: '3452',
			Орлово: '34547',
			Осинник: '34561',
			Осиновка: '34550',
			Осиновская: '34539',
			Оськина: '34546',
			Ощепково: '34556',
			Падун: '34542',
			Памятное: '34535',
			Партизан: '34556',
			Паченка: '34533',
			Пеганово: '34554',
			Первомайский: '34539',
			Первопесьяново: '34551',
			Перевалово: '3452',
			Першино: '34561',
			Петелино: '34535',
			Петрунькино: '34533',
			Пешнево: '34553',
			Плеханово: '34531',
			Плешково: '34551',
			Погорелка: '34556',
			Поддубровное: '34557',
			Покровское: '34531',
			Полозаозерье: '34554',
			Полуянова: '3456',
			Преображенка: '34545',
			Прииртышский: '3456',
			Прокуткино: '34551',
			Прохорово: '34547',
			Птицкое: '34539',
			Пятково: '34541',
			Равнец: '34551',
			Ражево: '34546',
			Раздолье: '34547',
			Рассвет: '34537',
			Рафайлова: '34537',
			Ревда: '34535',
			Речкунова: '34556',
			Рождественка: '34555',
			Русаково: '34545',
			Рябово: '34557',
			Салаирка: '3452',
			Санниково: '3456',
			Сартам: '34557',
			Сетово: '3456',
			Сибиряк: '3456',
			Синицына: '34551',
			Ситниково: '34544',
			Скородум: '34541',
			Скрипкино: '34557',
			Сладково: '34555',
			Слободчики: '34545',
			Смирное: '34553',
			Созоново: '3452',
			Соколова: '34543',
			Солобоево: '34537',
			Солянка: '34561',
			Сор: '34561',
			Сорокино: '34531',
			Сорочкино: '34545',
			Сосновка: '34542',
			Сосновое: '3452',
			Староалександровка: '34531',
			Старорямово: '34554',
			Степное: '34555',
			Стрехнино: '34551',
			Суерка: '34541',
			Сумкино: '3456',
			Супра: '34539',
			Сычево: '34539',
			Тоболово: '34551',
			Тобольск: '3456',
			Торгили: '34533',
			Тугалово: '34561',
			Тукман: '34533',
			Тукуз: '34539',
			Тумашово: '34542',
			Туринский: '3452',
			Туртас: '34561',
			Тушнолобово: '34556',
			Тюмень: '3452',
			Тюнево: '34533',
			Уват: '34561',
			Уктуз: '34554',
			Упорово: '34541',
			Усалка: '34531',
			Усово: '34555',
			Успенка: '3452',
			Ушаково: '34539',
			Ушарова: '3456',
			Фатеево: '34539',
			Хмелева: '3456',
			Хмелевка: '34546',
			Хохлово: '34535',
			Чебурга: '3456',
			Червишево: '3452',
			Черемшанка: '34551',
			Черепаново: '34533',
			Черная: '34541',
			Черное: '34539',
			Чикча: '3452',
			Чирки: '34553',
			Чугунаево: '34533',
			Чуртан: '34557',
			Шабаново: '34544',
			Шаблыкино: '34551',
			Шевырино: '34556',
			Шестаково: '34542',
			Шестовое: '34539',
			Шипаково: '34543',
			Шишкина: '34539',
			Шорохово: '34537',
			Щетково: '34531',
			Южное: '34535',
			Юргинское: '34543',
			Юрминка: '34545',
			Юрмы: '34539',
			Ялуторовск: '34535',
			Ярково: '34531',
			Яровое: '34547',
			Яровское: '34553'
		}
	},
	'Ульяновская область': {
		regionCode: '842',
		cities: {
			'Базарный Сызган': '84240',
			'Базарный Урень': '84246',
			'Барышская Слобода': '84242',
			'Белый Яр': '84231',
			'Большая Борисовка': '84241',
			'Большая Борла': '84234',
			'Большая Кандала': '84230',
			'Большая Кандарать': '84246',
			'Большие Ключищи': '8422',
			'Большие Озимки': '84241',
			'Большие Поселки': '84246',
			'Большое Жеребятниково': '84244',
			'Большое Нагаткино': '84245',
			'Большое Шуватово': '84241',
			'Большой Кувай': '84242',
			'Большой Чирклей': '84247',
			'Верхние Тимерсяны': '84245',
			'Верхний Мелекесс': '84235',
			'Верхняя Маза': '84239',
			'Верхняя Терешка': '84249',
			'Верхняя Якушка': '84232',
			'Высокий Колок': '84232',
			'Вязовый Гай': '84249',
			'Гимова им.Совхоз': '84244',
			'Дмитриево-Помряскино': '84230',
			'Елховое Озеро': '84245',
			'Елховый Куст': '84232',
			'Зеленая Роща': '8422',
			'Красная Балтия': '84237',
			'Красная Поляна': '84253',
			'Красная Река': '84230',
			'Красная Сосна': '84240',
			'Красный Бор': '84243',
			'Красный Гуляй': '84233',
			'Лесная Дача': '84253',
			'Лесная Хмелевка': '84235',
			'Малая Борла': '84237',
			'Малая Кандала': '84230',
			'Малая Хомутерь': '84253',
			'Малое Нагаткино': '84245',
			'Малое Станичное': '84246',
			'Мокрая Бугурна': '84245',
			'Мордовская Карагужа': '84239',
			'Мордовский Белый Ключ': '84243',
			'Нижние Тимерсяны': '84245',
			'Нижняя Туарма': '84243',
			'Нижняя Якушка': '84232',
			'Никольское-на-Черемшане': '84235',
			'Новая Алексеевка': '84248',
			'Новая Беденьга': '8422',
			'Новая Бекшанка': '84253',
			'Новая Бесовка': '84232',
			'Новая Бирючевка': '8422',
			'Новая Дмитриевка': '84239',
			'Новая Камаевка': '84248',
			'Новая Кулатка': '84249',
			'Новая Лава': '84238',
			'Новая Майна': '84235',
			'Новая Малыкла': '84232',
			'Новая Слобода': '84233',
			'Новое Никулино': '84245',
			'Новое Погорелово': '84246',
			'Новое Томышево': '84238',
			'Новые Алгаши': '84245',
			'Новые Зимницы': '84249',
			'Новые Маклауши': '84244',
			'Новые Тимерсяны': '84245',
			'Новый Белый Яр': '84231',
			'Новый Дол': '84253',
			'Новый Урень': '8422',
			'Панская Слобода': '8422',
			'Радищево ': '84239',
			'Репьевка Колхозная': '84244',
			'Репьевка-Космынка': '84244',
			'Родниковые Пруды': '84244',
			'Русская Бектяшка': '84233',
			'Русская Хомутерь': '84240',
			'Русская Цильна': '84245',
			'Русские Горенки': '84246',
			'Русский Мелекесс': '84235',
			'Русский Юрткуль': '84230',
			'Солдатская Ташла': '84234',
			'Средние Тимерсяны': '84245',
			'Средний Сантимир': '84232',
			'Средняя Терешка': '84249',
			'Средняя Якушка': '84232',
			'Старая Бесовка': '84232',
			'Старая Ерыкла': '84234',
			'Старая Кулатка': '84249',
			'Старая Майна': '84230',
			'Старая Малыкла': '84232',
			'Старая Тюгальбуга': '84232',
			'Старая Яндовка': '84249',
			'Старое Еремкино': '84231',
			'Старое Зеленое': '84249',
			'Старое Матюшкино': '84231',
			'Старое Погорелово': '84243',
			'Старое Томышево': '84238',
			'Старое Чирково': '84248',
			'Старые Алгаши': '84245',
			'Старые Маклауши': '84244',
			'Старый Атлаш': '84249',
			'Старый Белый Яр': '84231',
			'Старый Мостяк': '84249',
			'Старый Пичеур': '84248',
			'Степная Васильевка': '84235',
			'Степная Репьевка': '84245',
			'Степное Анненково': '84245',
			'Степное Матюнино': '84244',
			'Сухая Терешка': '84247',
			'Сухой Карсун': '84246',
			'Татарский Калмаюр': '84231',
			'Татарский Сайман': '84247',
			'Татарский Шмалак': '84248',
			'Татарское Урайкино': '84230',
			'Троицкий Сунгур': '84238',
			'Урено-Карлинское': '84246',
			'Усть-Кулатка': '84249',
			'Усть-Урень': '84246',
			'Фабричные Выселки': '84238',
			'Чувашская Кулатка': '84249',
			'Чувашский Сускан': '84235',
			'Ясачный Сызган': '84240',
			'Ясашная Ташла': '84234',
			Абдреево: '84232',
			Абдулово: '84231',
			Абрамовка: '84244',
			Адоевщина: '84239',
			Аксаур: '84241',
			Акшуат: '84253',
			Алакаевка: '84238',
			Аллагулово: '84235',
			Андреевка: '84231',
			Анненково: '84244',
			Араповка: '84242',
			Арбузовка: '84245',
			Аргаш: '84241',
			Аристовка: '84241',
			Артюшкино: '84233',
			Астрадамовка: '84242',
			Ахметлей: '84247',
			Баевка: '84247',
			Байдулино: '84234',
			Баклуши: '84248',
			Барановка: '84247',
			Баратаевка: '8422',
			Барыш: '84253',
			Безводовка: '84237',
			Безречный: '84244',
			Бекетовка: '84233',
			Беклемишево: '84243',
			Беловодье: '84246',
			Белогорское: '84234',
			Белозерье: '84246',
			Бестужево: '84238',
			Бирля: '84235',
			Богдашкино: '84245',
			Боровка: '84235',
			Бригадировка: '84235',
			Бряндино: '84231',
			Бугры: '84240',
			Валгуссы: '84241',
			Вальдиватское: '84246',
			Вешкайма: '84243',
			Водорацк: '84253',
			Воецкое: '84253',
			Волостниковка: '84230',
			Волчанка: '84239',
			Волынщина: '84237',
			Выползово: '84242',
			Выры: '84244',
			Вышки: '8422',
			Гавриловка: '84234',
			Гладчиха: '84234',
			Глотовка: '84241',
			Годяйкино: '84240',
			Головино: '84247',
			Головцево: '84253',
			Грибовка: '84230',
			Гулюшево: '84242',
			Давыдовка: '84247',
			Димитровград: '84235',
			Дмитриевка: '84239',
			Должниково: '84240',
			Дракино: '84241',
			Дубровка: '84247',
			Евлейка: '84248',
			Еделево: '84237',
			Екатериновка: '84233',
			Елаур: '84233',
			Елховка: '84242',
			Елшанка: '84247',
			Енганаево: '84231',
			Ермоловка: '84243',
			Ерыклинск: '84235',
			Жадовка: '84253',
			Ждамирово: '84242',
			Жедяевка: '84230',
			Живайкино: '84253',
			Забалуйка: '84241',
			Загарино: '84253',
			Загоскино: '84244',
			Залесный: '84243',
			Заречное: '84253',
			Зарыклей: '84249',
			Зеленец: '84234',
			Земляничный: '84253',
			Игнатовка: '84244',
			Измайлово: '84253',
			Илюшкино: '84248',
			Инза: '84241',
			Ишеевка: '84254',
			Кадышевка: '84248',
			Кадышево: '84246',
			Калда: '84253',
			Калиновка: '84239',
			Канадей: '84247',
			Канасаево: '84247',
			Карабаевка: '84245',
			Каргино: '84243',
			Кармалей: '84249',
			Карсун: '84246',
			Кезьмино: '84242',
			Кивать: '84237',
			Кирзять: '84242',
			Кирюшкино: '84249',
			Ключики: '84247',
			Княжуха: '84242',
			Колхозный: '84231',
			Конновка: '84253',
			Коптевка: '84238',
			Копышовка: '84244',
			Коржевка: '84241',
			Коромысловка: '84237',
			Коченяевка: '84243',
			Кравково: '84247',
			Красноармейский: '8422',
			Красноборск: '84234',
			Краснополка: '84246',
			Красносельск: '84238',
			Красный: '84238',
			Кременки: '84230',
			Крестниково: '84245',
			Криуши: '8422',
			Кротково: '84233',
			Кротовка: '8422',
			Кубра: '84239',
			Кузоватово: '84237',
			Кундюковка: '84245',
			Куроедово: '84247',
			Кучуры: '84233',
			Лава: '84242',
			Лаишевка: '8422',
			Лапшаур: '84240',
			Лебяжье: '84235',
			Липки: '8422',
			Луговое: '8422',
			Ляховка: '84253',
			Майна: '84244',
			Малаевка: '84231',
			Матвеевка: '84230',
			Меловой: '8422',
			Мирный: '84231',
			Молвино: '84234',
			Мосеевка: '84249',
			Мочилки: '84234',
			Мулловка: '84235',
			Муратовка: '84248',
			Нагаево: '84246',
			Назайкино: '84234',
			Налейка: '84237',
			Неклюдово: '84241',
			Никитино: '84242',
			Николаевка: '84247',
			Никольское: '84237',
			Никулино: '84247',
			Новиковка: '84230',
			Новоанненковский: '84244',
			Новоселки: '84235',
			Новоспасское: '84238',
			Новосурское: '84241',
			Новоульяновск: '84255',
			Новочеремшанск: '84232',
			Озерки: '84231',
			Октябрьское: '84248',
			Оськино: '84241',
			Отрада: '8422',
			Охотничья: '8422',
			Павловка: '84248',
			Панциревка: '84241',
			Паньшино: '84239',
			Папузы: '84240',
			Первомайский: '84231',
			Первомайское: '84241',
			Петровское: '84231',
			Пилюгино: '84245',
			Плетьма: '84248',
			Плодовый: '8422',
			Подлесное: '84244',
			Покровское: '84245',
			Полбино: '84244',
			Поливаново: '84253',
			Помаево: '84242',
			Поника: '84247',
			Поспеловка: '84247',
			Потьма: '84246',
			Прасковьино: '84247',
			Прибрежное: '84230',
			Приволье: '84237',
			Приморское: '84235',
			Прислониха: '84246',
			Радищево: '84239',
			Румянцево: '84253',
			Рызлей: '84247',
			Рябина: '84239',
			Рязаново: '84235',
			Сабакаево: '84235',
			Садовое: '84238',
			Салмановка: '8422',
			Самайкино: '84238',
			Сара: '84242',
			Свирино: '84238',
			Сенгилей: '84233',
			Силикатный: '84233',
			Сиуч: '84244',
			Скугареевка: '84234',
			Славкино: '84247',
			Смышляевка: '84237',
			Соловчиха: '84239',
			Софьино: '84239',
			Спешневка: '84237',
			Старотимошкино: '84253',
			Стемасс: '84243',
			Стоговка: '84237',
			Студенец: '84237',
			Сурское: '84242',
			Суруловка: '84238',
			Суходол: '84231',
			Сущевка: '84244',
			Сюксюм: '84241',
			Таволжанка: '84246',
			Тагай: '84244',
			Телешовка: '84245',
			Телятниково: '84247',
			Теньковка: '84246',
			Тепловка: '84247',
			Тереньга: '84234',
			Тетюшское: '8422',
			Тиинск: '84235',
			Тимирязевский: '8422',
			Тинарка: '84235',
			Тияпино: '84241',
			Томылово: '84237',
			Топорнино: '84247',
			Труслейка: '84241',
			Тумкино: '84234',
			Тушна: '84233',
			Ульяновск: '8422',
			Ундоры: '8422',
			Уразгильдино: '84231',
			Уржумское: '84244',
			Федькино: '84234',
			Филипповка: '84235',
			Хвостиха: '84237',
			Хмелевка: '84242',
			Ховрино: '84243',
			Холстовка: '84248',
			Цильна: '84245',
			Чамзинка: '84241',
			Чауши: '84239',
			Чеботаевка: '84242',
			Чердаклы: '84231',
			Черемушки: '84241',
			Чертановка: '84237',
			Чириково: '84237',
			Чуфарово: '84243',
			Шалкино: '84248',
			Шарлово: '84243',
			Шатрашаны: '84242',
			Шаховское: '84248',
			Шемурша: '84237',
			Шиковка: '84248',
			Шиловка: '84233',
			Шумовка: '8422',
			Эчкаюн: '84232',
			Юлово: '84241',
			Юрловка: '84240',
			Языково: '84246',
			Якушка: '84232'
		}
	},
	'Хабаровский край': {
		regionCode: '421',
		cities: {
			'Анненские Воды': '42151',
			'База Дрофа': '42154',
			'Верхний Нерген': '42156',
			'Верхняя Манома': '42156',
			'Верхняя Эконь': '4217',
			'Веселая Горка': '42144',
			'Главный Стан': '42144',
			'Де-Кастри': '42151',
			'Дубовый Мыс': '42156',
			'Заветы Ильича': '42138',
			'Князе-Волконское': '4212',
			'Комсомольск-на-Амуре': '4217',
			'Малая Сидима': '42154',
			'Мариинский Рейд': '42151',
			'Нижнее Пронге': '42135',
			'Нижние Халбы': '4217',
			'Нижняя Манома': '42156',
			'Николаевск-на-Амуре': '42135',
			'Новая Иня': '42141',
			'Новое Устье': '42141',
			'Новый Мир': '4217',
			'Новый Ургал': '42149',
			'Осиновая Речка': '4212',
			'Полины Осипенко им.': '42144',
			'село им. Полины Осипенко': '42144',
			'Советская Гавань': '42138',
			'Средний Ургал': '42149',
			'Усть Ургал': '42149',
			'Хабаровск ': '4212',
			'Черная Речка': '4212',
			Аим: '42147',
			Аланап: '42149',
			Алонка: '42149',
			Амгунь: '42146',
			Амурск: '42142',
			Анастасьевка: '4212',
			Арка: '42141',
			Арсеньево: '42156',
			Ачан: '42142',
			Аян: '42147',
			Бельго: '4217',
			Берёзовый: '42146',
			Бикин: '42155',
			Бичевая: '42154',
			Богородское: '42151',
			Болонь: '42142',
			Бриакан: '42144',
			Булава: '42151',
			Булгин: '42141',
			Быстринск: '42151',
			Бычиха: '4212',
			Бяудэ: '42138',
			Ванино: '42137',
			Венюково: '42153',
			Виноградовка: '42153',
			Владимировка: '42144',
			Вознесенское: '42142',
			Восточное: '4212',
			Вострецово: '42141',
			Высокогорный: '42137',
			Вяземский: '42153',
			Вятское: '4212',
			Гайтер: '4217',
			Галечный: '4217',
			Галкино: '4212',
			Гатка: '42138',
			Георгиевка: '42154',
			Герби: '42149',
			Горин: '42146',
			Горный: '42146',
			Гродеково: '42154',
			Гурское: '4217',
			Дада: '42156',
			Даппы: '4217',
			Датта: '42137',
			Джамку: '42146',
			Джонка: '42156',
			Джуен: '42142',
			Долми: '42154',
			Дормидонтовка: '42153',
			Дружба: '4212',
			Дурмин: '42154',
			Елабуга: '4212',
			Забайкальский: '42153',
			Заозерное: '4212',
			Золотой: '42154',
			Известковый: '42142',
			Ильинка: '4212',
			Калинка: '4212',
			Капитоновка: '42153',
			Кедрово: '42153',
			Кенада: '42137',
			Кенай: '4217',
			Киинск: '42154',
			Киселевка: '42151',
			Константиновка: '42135',
			Корфовский: '4212',
			Котиково: '42153',
			Красицкое: '42153',
			Красное: '42135',
			Краснореченское: '4212',
			Кругликово: '42154',
			Кукан: '4212',
			Кукелево: '42153',
			Лазарев: '42135',
			Лермонтовка: '42155',
			Лесопильное: '42155',
			Лиан: '42146',
			Лидога: '42156',
			Литовко: '42142',
			Лончаково: '42155',
			Лососина: '42138',
			Мавринск: '42146',
			Маго: '42135',
			Майский: '42138',
			Малмыж: '42156',
			Малышево: '4212',
			Мариинское: '42151',
			Марусино: '42154',
			Матвеевка: '4212',
			Маяк: '42156',
			Мирный: '4212',
			Мичуринское: '4212',
			Многовершинный: '42135',
			Могилевка: '42154',
			Молодежный: '4217',
			Монгохто: '42137',
			Морской: '42141',
			Мухен: '42154',
			Найхин: '42156',
			Некрасовка: '4212',
			Нелькан: '42147',
			Нигирь: '42135',
			Нижнетамбовское: '4217',
			Новоильиновка: '4217',
			Новокуровка: '4212',
			Обор: '42154',
			Оглонги: '42144',
			Озерпах: '42135',
			Омми: '42142',
			Оремиф: '42135',
			Оренбургское: '42155',
			Отрадное: '42153',
			Охотск: '42141',
			Переяславка: '42154',
			Пивань: '4217',
			Победа: '4212',
			Полетное: '42154',
			Пуир: '42135',
			Пушкино: '42155',
			Ракитное: '4212',
			Савинское: '42151',
			Санболи: '42142',
			Санники: '42151',
			Святогорье: '42154',
			Селихино: '4217',
			Сергеевка: '4212',
			Синда: '42156',
			Сита: '42154',
			Славянка: '42156',
			Снежный: '4217',
			Согда: '42149',
			Солнечный: '42146',
			Солони: '42149',
			Солонцовый: '42154',
			Солонцы: '42151',
			Сосновка: '4212',
			Софийск: '42149',
			Софийское: '42151',
			Среднехорский: '42154',
			Сукпай: '42154',
			Сулук: '42149',
			Сусанино: '42151',
			Таланджа: '42149',
			Тахта: '42151',
			Токи: '42137',
			Тополево: '4212',
			Троицкое: '42156',
			Тугур: '42143',
			Тулучи: '42137',
			Тумнин: '42137',
			Тыр: '42151',
			Тырма: '42149',
			Удинск: '42144',
			Удское: '42143',
			Уктур: '4217',
			Ургал: '42149',
			Ушман: '42149',
			Хабаровск: '4212',
			Хальгассо: '42146',
			Харпичан: '42146',
			Херпучи: '42144',
			Хор: '42154',
			Хурба: '4217',
			Хурмули: '42146',
			Циммермановка: '42151',
			Чегдомын: '42149',
			Чекунда: '42149',
			Черняево: '42154',
			Чля: '42135',
			Чумикан: '42143',
			Шереметьево: '42153',
			Шумный: '42153',
			Эворон: '42146',
			Эльбан: '42142',
			Эльга: '42149',
			Этыркен: '42149',
			Ягодный: '4217'
		}
	},
	'Ханты-Мансийский автономный округ — Югра': {
		regionCode: '346',
		cities: {
			'Пыть-Ях': '3463',
			'Ханты-Мансийск': '34671',
			'поселок Березово': '34674',
			Белоярский: '34377',
			Березово: '34674',
			Варьёган: '3466',
			Излучинск: '3466',
			Когалым: '34667',
			Кондинское: '34677',
			Лангепас: '34669',
			Лянтор: '34638',
			Мегион: '34663',
			Междуреченский: '34677',
			Нефтеюганск: '3463',
			Нижневартовск: '3466',
			Нижнесортымский: '34638',
			Новоаганск: '34668',
			Нягань: '34672',
			Октябрьское: '34678',
			Пойковский: '83463',
			Покачи: '34669',
			Приобье: '34678',
			Радужный: '34668',
			Салым: '3463',
			Саранпауль: '34674',
			Сентябрьский: '3463',
			Советский: '34675',
			Сосьва: '34674',
			Сургут: '3462',
			Урай: '34676',
			Федоровский: '3462',
			Шеркалы: '34678',
			Югорск: '34675'
		}
	},
	'Челябинская область': {
		regionCode: '351',
		cities: {
			' с. Париж': '35157',
			'Александро-Невский': '35157',
			'Аракуль Дом Отдыха': '35149',
			'Арчаглы-Аят': '35142',
			'Большие Егусты': '35151',
			'Большие Харлуши': '35144',
			'Большое Баландино': '35144',
			'Большой Куяш': '35148',
			'Буранная Станция': '35140',
			'Верх-Катав': '35147',
			'Верхний Айск': '35161',
			'Верхний Уфалей': '35164',
			'Верхняя Кабанка': '35160',
			'Верхняя Санарка': '35160',
			'Гумбейка Станция': '35140',
			'Каменная Речка': '35163',
			'Карагайский Бор Д/о': '35143',
			'Катав-Ивановск': '35147',
			'Красное Поле': '35144',
			'Красный Камень': '35153',
			'Красный Октябрь': '35142',
			'Малое Шумаково': '35166',
			'Минка Разъезд': '35167',
			'Нижний Атлян': '3513',
			'Нижний Уфалей': '35164',
			'Нижняя Санарка': '35163',
			'Новая Cоболева': '35131',
			'Новое Курманово': '35148',
			'Новый Урал': '35142',
			'Путь Октября': '35155',
			'Русская Теча': '35139',
			'Синий Бор': '35166',
			'Субутак Станция': '35140',
			'Сухая Атя': '35159',
			'Татарская Караболка': '35148',
			'Уйско-Чебаркульское': '35158',
			'Усть-Багаряк': '35148',
			'Усть-Караболка': '35154',
			'Усть-Катав': '35167',
			'Усть-Курышка': '35159',
			'Южно-Степной': '35133',
			'Ясные Поляны': '35163',
			'п. Кассельский': '35157',
			'п. Остроленский': '35157',
			'село Беспаловка (Кузнецкое)': '35131',
			'село Губернское': '35132',
			Агаповка: '35140',
			Айлино: '35161',
			Акбашево: '35131',
			Алабуга: '35139',
			Алишево: '35144',
			Аллаки: '35149',
			Алтынташ: '35168',
			Аминево: '35165',
			Амурский: '35141',
			Андреевский: '35141',
			Анненское: '35133',
			Аптряково: '35156',
			Арасланово: '35156',
			Аргаяш: '35131',
			Арсинский: '35157',
			Астафьевский: '35157',
			Атамановский: '35141',
			Аша: '35159',
			Аширово: '35148',
			Аязгулово: '35131',
			Бабарикинский: '35143',
			Багаряк: '35149',
			Бажово: '35139',
			Байрамгулово: '35131',
			Бакал: '35161',
			Балканы: '35157',
			Баязитово: '35148',
			Бедярыш: '35147',
			Беловка: '35169',
			Белово: '35165',
			Белозеры: '35163',
			Белоносово: '35145',
			Белоусово: '35145',
			Бердяуш: '35161',
			Береговой: '35149',
			Березинский: '35169',
			Березово: '35139',
			Березовский: '35158',
			Берлин: '35163',
			Бижеляк: '35130',
			Бишкиль: '35168',
			Биянка: '35159',
			Бобровка: '35163',
			Богдановское: '35155',
			Болотово: '35168',
			Большеникольское: '35158',
			Борисовка: '35160',
			Бородиновка: '35142',
			Браиловский: '35155',
			Бреды: '35141',
			Бродокалмак: '35139',
			Булзи: '35149',
			Буранный: '35140',
			Бускульский: '35169',
			Бутаки: '35144',
			Ваганово: '35158',
			Вандышевка: '35165',
			Варламово: '35168',
			Варна: '35142',
			Варшавка: '35133',
			Вахрушево: '35139',
			Великопетровка: '35133',
			Верхнекизильское: '35140',
			Верхнеуральск: '35143',
			Веселовка: '3513',
			Вишневогорск: '35149',
			Водопойка: '35166',
			Воздвиженка: '35154',
			Воронино: '35165',
			Воскресенское: '35154',
			Выдрино: '35165',
			Вязовая: '35167',
			Гогино: '35141',
			Горелое: '35158',
			Горный: '35140',
			Горняк: '35139',
			Гранитный: '35155',
			Гривенка: '35156',
			Григорьевка: '35149',
			Грязнушенский: '35155',
			Губернское: '35131',
			Демарино: '35160',
			Дербишево: '35131',
			Джабык: '35133',
			Долгодеревенское: '35144',
			Дробышево: '35163',
			Дубровка: '35139',
			Еленинка: '35133',
			Елизаветопольское: '35133',
			Ельничный: '35161',
			Еманжелинка: '35145',
			Еманжелинск: '35138',
			Ерал: '35159',
			Ершовский: '35155',
			Есаульский: '35144',
			Еткуль: '35145',
			Железнодорожный: '35139',
			Желтинский: '35140',
			Жукатау: '35161',
			Запасное: '35133',
			Зауральский: '35138',
			Звягино: '35168',
			Зингейский: '35155',
			Златоуст: '3513',
			Злоказово: '35154',
			Знаменка: '35149',
			Ибрагимово: '35148',
			Измайловский: '35155',
			Илек: '35159',
			Иткуль: '35164',
			Ишалино: '35131',
			Калачево: '35139',
			Калининский: '35141',
			Калиновка: '35156',
			Калиновский: '35169',
			Каменский: '35166',
			Камышевка: '35131',
			Канашево: '35139',
			Карабаш: '35153',
			Карабулак: '35155',
			Карагайский: '35143',
			Каракульское: '35158',
			Каратабан: '35145',
			Карсы: '35163',
			Карталы: '35133',
			Касли: '35149',
			Кассельский: '35157',
			Катенино: '35142',
			Кацбахский: '35155',
			Кварцитный: '35163',
			Кидыш: '35165',
			Кизильское: '35155',
			Кирды: '35139',
			Кирса: '35143',
			Кичигино: '35166',
			Клубовка: '35169',
			Ключевка: '35163',
			Ключи: '35138',
			Клястицкое: '35163',
			Коелга: '35145',
			Комсомольский: '35141',
			Копейск: '35139',
			Коркино: '35152',
			Котово: '35156',
			Кочердык: '35158',
			Кочкарь: '35160',
			Краснинский: '35143',
			Красногорский: '35138',
			Краснокаменка: '35165',
			Красносельское: '35166',
			Кременкуль: '35144',
			Кропачево: '35159',
			Крутоярский: '35158',
			Куваши: '3513',
			Кузнецкое: '35131',
			Кулевчи: '35142',
			Кулуево: '35131',
			Кумляк: '35165',
			Кунашак: '35148',
			Кундравы: '35168',
			Курга: '35156',
			Куса: '35154',
			Кыштым: '35151',
			Лазурный: '35139',
			Лебедевка: '35145',
			Лебедки: '35158',
			Лейпциг: '35142',
			Ленинск: '3513',
			Локомотивный: '35133',
			Луговой: '35139',
			Лысково: '35158',
			Магнитка: '35154',
			Магнитный: '35140',
			Магнитогорск: '3519',
			Мариинский: '35141',
			Маскайка: '35168',
			Маслово: '35165',
			Маук: '35149',
			Маяк: '35141',
			Маячное: '35158',
			Медведевка: '35154',
			Межевой: '35161',
			Межозерный: '35143',
			Меседа: '35147',
			Метлино: '35130',
			Миасс: '3513',
			Миасское: '35150',
			Минка: '35167',
			Миньяр: '35159',
			Мирное: '35141',
			Могутовский: '35141',
			Мордвиновка: '35166',
			Муслюмово: '35148',
			Мухаметово: '35153',
			Мяконьки: '35158',
			Наваринка: '35140',
			Нагайбакский: '35157',
			Нагорный: '35166',
			Наровчатка: '35140',
			Наследницкий: '35141',
			Неплюевка: '35133',
			Непряхино: '35168',
			Нестерово: '35156',
			Нижнепетропавловское: '35139',
			Нижнеусцелемово: '35165',
			Николаевка: '35142',
			Новоандреевка: '3513',
			Новобатурино: '35145',
			Новобурановка: '35140',
			Новогорный: '35130',
			Новоеткульский: '35169',
			Новозаречный: '35159',
			Новокаолиновый: '35133',
			Новомосковское: '35158',
			Новопокровка: '35142',
			Новопокровский: '35155',
			Новотагилка: '3513',
			Новоукраинский: '35169',
			Новоянгелька: '35140',
			Нязепетровск: '35156',
			Обручевка: '35155',
			Огневское: '35154',
			Озерск: '35130',
			Октябрьское: '35158',
			Орловка: '35147',
			Остроленский: '35157',
			Петровское: '35166',
			Петропавловский: '35143',
			Печенкино: '35145',
			Писклово: '35145',
			Пласт: '35160',
			Подовинное: '35158',
			Полднево: '35149',
			Полевой: '35144',
			Полетаево: '35144',
			Половинка: '35166',
			Полоцкое: '35155',
			Потанино: '35139',
			Приморский: '35140',
			Приуральский: '35140',
			Пустозерово: '35168',
			Редутово: '35169',
			Родники: '35163',
			Рождественка: '35166',
			Роза: '35152',
			Романовка: '35161',
			Рощино: '35144',
			Рудничное: '35161',
			Рымникский: '35141',
			Садовый: '35144',
			Саккулово: '35144',
			Сарафаново: '35168',
			Саргазы: '35144',
			Сары: '35148',
			Сатка: '35161',
			Светлое: '35169',
			Светлый: '35160',
			Свободный: '35158',
			Селезян: '35145',
			Серпиевка: '35147',
			Силач: '35164',
			Сим: '35159',
			Ситцево: '35156',
			Сказ: '35156',
			Скалистый: '35163',
			Слюдорудник: '35151',
			Смеловский: '35143',
			Смородинка: '3513',
			Снежинск: '35146',
			Снежный: '35133',
			Солнечный: '35144',
			Сосновка: '351',
			Спасский: '35143',
			Старокамышинск: '35139',
			Сугояк: '35139',
			Сулея: '35161',
			Султаново: '35148',
			Сурменевский: '35143',
			Сухореченский: '35133',
			Сухтелинский: '35143',
			Сыростан: '3513',
			Сыртинский: '35155',
			Тавранкуль: '35139',
			Тайгинка: '35151',
			Тарасовка: '35169',
			Тарутино: '35169',
			Ташкинова: '35156',
			Телюк: '35147',
			Теченский: '35144',
			Тимино: '35149',
			Тимирязевский: '35168',
			Тогузак: '35163',
			Толсты: '35142',
			Томинский: '35144',
			Точильный: '35159',
			Травники: '35168',
			Троицк: '35163',
			Трубный: '35144',
			Трёхгорный: '35191',
			Туктубаево: '35144',
			Тундуш: '3513',
			Тургояк: '3513',
			Тюбеляс: '35167',
			Тюбук: '35149',
			Увельский: '35166',
			Углицкий: '35169',
			Уйский: '35165',
			Уйское: '35165',
			Ук: '35159',
			Ункурда: '35156',
			Урал: '35155',
			Урлядинский: '35143',
			Урукуль: '35148',
			Усольцево: '35139',
			Устиново: '3513',
			Федоровка: '35139',
			Фершампенуаз: '35157',
			Филимоново: '35168',
			Форштадт: '35143',
			Халитово: '35148',
			Ханжино: '35139',
			Хомутинино: '35166',
			Хребет: '3513',
			Худайбердынский: '35131',
			Хуторка: '35166',
			Целинный: '35163',
			Центральный: '35133',
			Чебаркуль: '35168',
			Челябинск: '351',
			Черемшанка: '35164',
			Черниговский: '35140',
			Черноборский: '35169',
			Черновское: '3513',
			Черноречье: '35163',
			Чесма: '35169',
			Чудиново: '35158',
			Шабурово: '35149',
			Шантарино: '35163',
			Шахматово: '35168',
			Шеломенцево: '35145',
			Шемаха: '35156',
			Шершни: '351',
			Шишминка: '35158',
			Шумово: '35139',
			Щербаковка: '35149',
			Южноуральск: '35134',
			Южный: '35157',
			Юрюзань: '35147',
			Юшково: '35149',
			Янгельский: '35140',
			Яраткулово: '35131'
		}
	},
	'Чеченская Республика': {
		regionCode: '871',
		cities: {
			'Алхан-Кала': '8712',
			'Алхан-Юрт': '87145',
			'Ачхой-Мартан': '87142',
			'Бачи-Юрт': '87155',
			'Итум- Кали': '87164',
			'Итум-Кале': '87135',
			'Итум-Кали': '87164',
			'Катыр-Юрт': '87142',
			'Мескер-Юрт': '87146',
			'Новые Атаги': '87146',
			'Новый Хутор': '87145',
			'Ножай-Юрт': '87148',
			'Рагун-Кажи': '87148',
			'Сары-Су': '87136',
			'Старые Атаги': '8712',
			'Улус-Керт': '87135',
			'Урус-Мартан': '87145',
			'Хал-Килой': '87135',
			'Цоци-Юрт': '87155',
			'Чири-Юрт': '87146',
			'Энгель-Юрт': '87152',
			'село Махкеты': '87134',
			'село Шатой': '87135',
			Автуры: '87146',
			Аллерой: '87155',
			Алпатово: '87143',
			Аргун: '87146',
			Ассиновская: '87154',
			Бамут: '87142',
			Ведено: '87131',
			Гелдагана: '87155',
			Герменчук: '87146',
			Гехи: '87145',
			Гойты: '87145',
			Горагорский: '87132',
			Грозный: '8712',
			Гудермес: '87152',
			Знаменское: '87132',
			Каргалинская: '87136',
			Курчалой: '87155',
			Майртуп: '87155',
			Надтеречная: '87132',
			Наурская: '87143',
			Новогрозненский: '87152',
			Новощедринская: '87136',
			Ойсхара: '87137',
			Октябрьское: '87146',
			Парабоч: '87136',
			Правобережное: '8712',
			Самашки: '87147',
			Саясан: '87148',
			Серноводская: '87154',
			Советское: '87135',
			Старогладковская: '87136',
			Старощедринская: '87136',
			Хатуни: '87131',
			Червленная: '87136',
			Шалажи: '87145',
			Шали: '87146',
			Шатой: '87135',
			Шелковская: '87136',
			Шелкозаводская: '87136',
			Шуани: '87148',
			Энгеной: '87148'
		}
	},
	'Чукотский автономный округ': {
		regionCode: '427',
		cities: {
			'Мыс Шмидта': '427392',
			'Новое Чаплино': '4273527',
			'Угольные Копи': '42732',
			'Усть-Белая': '4273293',
			Анадырь: '42722',
			Анюйск: '4273881',
			Беринговский: '42733',
			Билибино: '42738',
			Биллингс: '4273992',
			Ваеги: '4273298',
			Ванкарем: '4273461',
			Илирней: '4273882',
			Инчоун: '4273691',
			Канчалан: '4273294',
			Кепервеем: '4273827',
			Конергино: '4273452',
			Краснено: '4273295',
			Лаврентия: '427362',
			Ламутское: '4273297',
			Лорино: '4273693',
			Марково: '4273291',
			Мейныпильгыно: '4273335',
			Нешкан: '4273694',
			Нунлигран: '4273526',
			Нутэпэльмен: '4273451',
			Омолон: '4273884',
			Островное: '4273883',
			Певек: '42737',
			Провидения: '42735',
			Рыркайпий: '4273991',
			Рыткучи: '4273795',
			Сиреники: '4273525',
			Снежное: '4273292',
			Уэлен: '4273695',
			Уэлькаль: '4273453',
			Хатырка: '4273338',
			Чуванское: '4273296',
			Эгвекинот: '427342',
			Энмелен: '4273529',
			Энурмино: '4273692',
			Янракыннот: '4273528',
			Янранай: '4273797'
		}
	},
	'Ямало-Ненецкий автономный округ': {
		regionCode: '349',
		cities: {
			'Вершина-Войкары': '34994',
			'Газ-Сале': '34940',
			'Зеленый Яр': '34993',
			'Казым-Мыс': '34994',
			'Матюй-Сале': '34940',
			'Мыс Каменный': '34996',
			'Новый Киеват': '34994',
			'Новый Порт': '34996',
			'Новый Уренгой': '3494',
			'Порц-Яха': '34996',
			'Сюнай-Сале': '34996',
			'Тадебя-Яха': '34940',
			'Тарко-Сале': '34997',
			'Усть-Войкары': '34994',
			'Ханты-Мужи': '34994',
			'Яптик-Сале': '34996',
			'Яр-Сале': '34996',
			Азовы: '34994',
			Аксарка: '34993',
			Анжигорт: '34994',
			Антипаюта: '34940',
			Белоярск: '34993',
			Восяхово: '34994',
			Вылпосл: '34993',
			Горки: '34994',
			Горнокнязевск: '34993',
			Губкинский: '34936',
			Гыда: '34940',
			Евригорт: '34994',
			Заполярный: '34995',
			Ильягорт: '34994',
			Ишвары: '34994',
			Карвожгорт: '34994',
			Катравож: '34993',
			Киккиакки: '34932',
			Красноселькуп: '34932',
			Кутопьюган: '3499',
			Кушеват: '34994',
			Лаборовая: '34993',
			Лабытнанги: '34992',
			Лонгъюган: '3499',
			Лопхари: '34994',
			Лохпотгорт: '34994',
			Мужи: '34994',
			Муравленко: '34938',
			Надым: '3499',
			Напалково: '34940',
			Находка: '34940',
			Нори: '3499',
			Ноябрьск: '3496',
			Ныда: '3499',
			Нымвожгорт: '34994',
			Овгорт: '34994',
			Оволынгорт: '34994',
			Панаевск: '34996',
			Пангоды: '3499',
			Пельвож: '34922',
			Питляр: '34994',
			Пословы: '34994',
			Правохеттинский: '3499',
			Приозерный: '34995',
			Пуровск: '34997',
			Пурпе: '34936',
			Ратта: '34932',
			Салемал: '34996',
			Салехард: '34922',
			Самбург: '34997',
			Сангымгорт: '34994',
			Сывдарма: '34997',
			Сёяха: '34996',
			Тазовский: '34940',
			Тамбей: '34996',
			Тильтим: '34994',
			Товопогол: '34993',
			Толька: '34997',
			Унсельгорт: '34994',
			Уренгой: '34934',
			Халасьпугор: '34993',
			Халясавэй: '34997',
			Ханымей: '34997',
			Харампур: '34997',
			Харп: '34948',
			Харсаим: '34993',
			Хашгорт: '34994',
			Чапаевск: '34993',
			Шурышкары: '34994',
			Щучье: '34993',
			Юрибей: '34940',
			Ягельный: '3499',
			Ямбура: '34993',
			Ямбург: '34995',
			Ямгорт: '34994'
		}
	},
	'Ярославская область': {
		regionCode: '485',
		cities: {
			'Андрианова слобода': '48546',
			'Большая Брембола': '48535',
			'Большое Ескино': '48549',
			'Большое Село': '48542',
			'Великое Село': '48533',
			'Воровского им.Санаторий': '4855',
			'Гаврилов-Ям': '48534',
			'Дивная Гора': '48532',
			'Диево Городище': '48531',
			'Заячий Холм': '48534',
			'Золотой Колос': '48531',
			'Илинское-Урусово': '48534',
			'Искра Октября': '4855',
			'Красные Ткачи': '4852',
			'Красный Бор': '4852',
			'Красный Октябрь': '48539',
			'Красный Профинтерн': '48531',
			'Лесная Поляна': '4852',
			'Некоуз Село': '48547',
			'Никитская слобода': '48535',
			'Николо-Гора': '48549',
			'Николо-Ухтома': '48549',
			'Новое Гостилово': '48542',
			'Новый Некоуз': '48547',
			'Пансионат Углич': '48532',
			'Переславль-Залесский': '48535',
			'Покров-Рогули': '48546',
			'Поречье-Рыбное': '48536',
			'Поселок Судоверфь': '4855',
			'Починок-Болотово': '4855',
			'Профилакторий Строитель': '48531',
			'Спас-Ильд': '48547',
			'Татищев Погост': '48536',
			'Троицкая Слобода': '48535',
			'Туношна-городок': '4852',
			'Черная Заводь': '48531',
			'село Вятское': '48531',
			'село Новый Некоуз': '48547',
			'село Рыбницы': '48531',
			Ананьино: '4852',
			Андреевское: '48539',
			Андрианово: '48535',
			Андроники: '4852',
			Андрюшино: '48546',
			Арефино: '4855',
			Архангельское: '48544',
			Бабаево: '48538',
			Байково: '48542',
			Беклемишево: '48536',
			Бекренево: '4852',
			Бектышево: '48535',
			Белогостицы: '48536',
			Белое: '48546',
			Белоусово: '48532',
			Березники: '48539',
			Берендеево: '48535',
			Благодать: '48546',
			Богдановка: '48533',
			Богородское: '48544',
			Бор: '48531',
			Борисовское: '48542',
			Борисоглеб: '48533',
			Борисоглебский: '48539',
			Борок: '48547',
			Брейтово: '48545',
			Бурмакино: '48531',
			Бурмасово: '48532',
			Вараково: '48549',
			Варегово: '48542',
			Василево: '48532',
			Васильевское: '48546',
			Васильки: '48532',
			Васильково: '48536',
			Ваулово: '48533',
			Вахромейка: '48543',
			Вахрушево: '48536',
			Великое: '48534',
			Веретея: '48547',
			Верещагино: '48533',
			Веськово: '48535',
			Владычное: '48546',
			Воздвиженское: '48532',
			Волга: '48547',
			Волково: '4855',
			Вощажниково: '48539',
			Вощиково: '48546',
			Всехсвятское: '48549',
			Выползово: '48533',
			Вятское: '48531',
			Галицино: '48547',
			Гари: '48542',
			Гаютино: '48546',
			Глебово: '4855',
			Глебовское: '4852',
			Головино: '48532',
			Горелово: '48545',
			Горинское: '48538',
			Горки: '48535',
			Горный: '48536',
			Грешнево: '48531',
			Григорьевское: '4852',
			Давыдово: '48539',
			Данилов: '48538',
			Девницы: '48542',
			Дмитриановское: '48536',
			Дмитриевское: '48546',
			Дорожаево: '4852',
			Дубровицы: '48535',
			Дуденево: '48545',
			Дунилово: '48542',
			Дюдьково: '4855',
			Емишево: '48533',
			Ераково: '4855',
			Жоглово: '48536',
			Заболотье: '48531',
			Загорье: '48535',
			Закобякино: '48543',
			Заозерье: '48532',
			Захарово: '48536',
			Зачатье: '48539',
			Здоровцево: '48533',
			Зубарево: '48546',
			Иванищево: '4852',
			Иваново: '48532',
			Ивановское: '48535',
			Иванцево: '48542',
			Ивняки: '4852',
			Ильинское: '48532',
			Инальцино: '48539',
			Итларь: '48536',
			Ишня: '48536',
			Каблуково: '48532',
			Каменники: '4855',
			Карабиха: '4852',
			Караш: '48536',
			Кинтаново: '48543',
			Кириллово: '48543',
			Кичибухино: '48535',
			Кладово: '48546',
			Клементьево: '48532',
			Климатино: '48532',
			Кобостово: '4855',
			Коза: '48549',
			Козино: '48539',
			Козлово: '48538',
			Козьмодемьянск: '4852',
			Колодино: '48546',
			Колокарево: '48535',
			Константиновский: '48533',
			Копнино: '48535',
			Коптево: '48544',
			Кормилицино: '4852',
			Костюшино: '48538',
			Кременево: '48546',
			Крюково: '48544',
			Кубринск: '48535',
			Кузнечиха: '4852',
			Кукобой: '48549',
			Купанское: '48549',
			Курба: '4852',
			Лазарцево: '48536',
			Лахость: '48534',
			Лацкое: '48547',
			Левашово: '48531',
			Левцово: '4852',
			Лехоть: '48539',
			Лом: '4855',
			Лыкошино: '48538',
			Лыченцы: '48535',
			Любилки: '48536',
			Любим: '48543',
			Маймеры: '48532',
			Макарово: '48531',
			Макеевское: '48547',
			Малино: '48549',
			Манжаково: '48538',
			Марково: '48536',
			Мартыново: '48544',
			Масальское: '48532',
			Маслово: '48547',
			Машаково: '48533',
			Медягино: '4852',
			Меленки: '4852',
			Меньково: '48546',
			Миглино: '48539',
			Микляиха: '48533',
			Милково: '48549',
			Милюшино: '4855',
			Митино: '48534',
			Михайловское: '4852',
			Мишутино: '48538',
			Мокеевское: '4852',
			Мордвиново: '4852',
			Мосейцево: '48536',
			Мышкин: '48544',
			Нагорье: '48535',
			Назарово: '4855',
			Наумиха: '48531',
			Неверково: '48539',
			Некрасовское: '48531',
			Нефедьево: '48532',
			Никульское: '48533',
			Нинорово: '48532',
			Новинское: '48547',
			Ново: '48532',
			Новоалексеевка: '48535',
			Новоникольское: '48536',
			Новоселье: '48535',
			Норское: '48543',
			Обнорское: '48543',
			Октябрь: '48547',
			Октябрьский: '4855',
			Омелино: '48538',
			Ордино: '48532',
			Осенево: '48534',
			Остров: '48534',
			Охотино: '48544',
			Парфеньево: '48547',
			Паршино: '48549',
			Перелески: '48535',
			Переславский: '48535',
			Перово: '48536',
			Першино: '48533',
			Песочное: '4855',
			Пестрецово: '4852',
			Петровское: '48536',
			Платуново: '48532',
			Плещеево: '48534',
			Плоски: '48532',
			Погорелка: '4855',
			Починок: '48538',
			Пошехонье: '48546',
			Правдино: '48547',
			Пречистое: '48549',
			Прилуки: '48532',
			Прозорово: '48545',
			Прошенино: '48534',
			Пружинино: '48534',
			Прусово: '4852',
			Путчино: '48532',
			Пшеничище: '48533',
			Ракоболь: '48546',
			Раменье: '48539',
			Раслово: '48543',
			Рахманово: '48535',
			Редкошово: '48539',
			Рожалово: '48547',
			Рождествено: '48531',
			Ростов: '48536',
			Рузбугино: '48543',
			Рыбинск: '4855',
			Рыжиково: '48538',
			Рязанцево: '48535',
			Савино: '48532',
			Савинское: '48533',
			Сарафоново: '4852',
			Севастьянцево: '48545',
			Седельницы: '4852',
			Семендяево: '48543',
			Семенники: '4855',
			Семеновское: '48549',
			Семибратово: '48536',
			Семлово: '48538',
			Сера: '48544',
			Середа: '48538',
			Сеславино: '4852',
			Сигарь: '48539',
			Скалино: '48549',
			Скнятиново: '48536',
			Скоморохово: '48535',
			Слобода: '48538',
			Смоленское: '48535',
			Сольба: '48535',
			Софряково: '4852',
			Спас: '48538',
			Сретенье: '4855',
			Ставотино: '48534',
			Станилово: '48547',
			Стогинское: '48534',
			Столбищи: '48533',
			Судино: '48536',
			Сулость: '48536',
			Сутка: '48545',
			Сущево: '48539',
			Терехово: '48549',
			Терютино: '48532',
			Титово: '48539',
			Тихменево: '4855',
			Толбухино: '4852',
			Толстоухово: '48546',
			Торопово: '48538',
			Троица: '48543',
			Туношна: '4852',
			Тутаев: '48533',
			Туфаново: '48538',
			Углич: '48532',
			Угодичи: '48536',
			Улейма: '48532',
			Ульяниха: '48545',
			Ульянкино: '48532',
			Урдома: '48533',
			Уткино: '4852',
			Фатьяново: '48536',
			Федорково: '48546',
			Федурино: '48538',
			Филиппово: '48543',
			Флоровское: '48544',
			Фоминское: '48533',
			Хабарово: '48538',
			Харитоново: '4855',
			Хмельники: '48536',
			Холм: '48546',
			Чебоково: '48533',
			Чепорово: '48536',
			Черново: '48543',
			Чудиново: '48542',
			Чурьяково: '48538',
			Шаготь: '48538',
			Шалаево: '48534',
			Шамары: '48547',
			Шашково: '4855',
			Шестихино: '48547',
			Шильпухово: '48549',
			Шипилово: '48544',
			Ширинье: '4852',
			Шопша: '48534',
			Шпаново: '48533',
			Шулец: '48536',
			Шурскол: '48536',
			Шёлдомеж: '48547',
			Щедрино: '4852',
			Щурово: '48539',
			Юдино: '48546',
			Юркино: '48539',
			Якимовское: '48536',
			Яковцево: '48539',
			Ярославка: '4852',
			Ярославль: '4852'
		}
	}
};
